// ── DATA ───────────────────────────────────────────────────────────────────────

// Admin accounts — separate from advisers, have access to Admin Panel
// ── COMMISSION TIERS ──────────────────────────────────────────────────────────
// Wealth Planner tiers (based on YTD personal revenue)
const WP_TIERS = [
  { minRevenue: 100000, rate: 0.70, rank: "Associate Partner" },
  { minRevenue:  50000, rate: 0.60, rank: "Elite Wealth Planner" },
  { minRevenue:      0, rate: 0.50, rank: "Wealth Planner" },
];

// Manager direct overriding tiers (based on YTD direct team revenue)
const MGR_TIERS = [
  { minRevenue: 300000, rate: 0.12, rank: "Partner" },
  { minRevenue: 200000, rate: 0.10, rank: "Senior Manager" },
  { minRevenue:      0, rate: 0.06, rank: "Manager" },
];

// Vice President indirect overriding tiers (based on YTD district group revenue)
const VP_TIERS = [
  { minRevenue: 600000, rate: 0.06, rank: "Senior Partner" },
  { minRevenue: 400000, rate: 0.04, rank: "Senior Vice President" },
  { minRevenue:      0, rate: 0.02, rank: "Vice President" },
];

// EXCOMM: fixed 80% personal, remaining 20% retained by LIFA (no overriding)
// Helper: get WP tier rate from YTD revenue
function getWPTier(ytdRevenue) {
  return WP_TIERS.find(t => ytdRevenue >= t.minRevenue) || WP_TIERS[WP_TIERS.length-1];
}
function getMgrTier(ytdDirectRevenue) {
  return MGR_TIERS.find(t => ytdDirectRevenue >= t.minRevenue) || MGR_TIERS[MGR_TIERS.length-1];
}
function getVPTier(ytdDistrictRevenue) {
  return VP_TIERS.find(t => ytdDistrictRevenue >= t.minRevenue) || VP_TIERS[VP_TIERS.length-1];
}

const ADMINS = {
  "admin@lifa.com.my":   { name:"Lifa Admin",   isAdmin:true  },
  "checker@lifa.com.my": { name:"Lifa Checker", isChecker:true },
};

// ── iFAST ZIP password (applied automatically to all iFAST ZIPs) ──────────────
// Admin can change this if iFAST rotates the password
var IFAST_ZIP_PASS = "LFA888";

// ── CLOUDFLARE D1 API ─────────────────────────────────────────────────────────
const API = "https://lifaportal-api.lifa-gan.workers.dev";
// "Stay signed in" persists the token in localStorage (survives tab close, 30-day
// token); otherwise sessionStorage (clears on tab close, 8-hour token).
// Prefer THIS TAB's sessionStorage over the shared localStorage: a per-tab login
// must never be shadowed on reload by a "Stay signed in" token left in localStorage
// by a different account/tab. A fresh tab has empty sessionStorage, so remember-me
// still restores correctly via the localStorage fallback.
var SESSION_TOKEN = (function(){ try { return sessionStorage.getItem("lifa_admin_token") || localStorage.getItem("lifa_admin_token"); } catch { return null; } })();
// SSO hand-off from admin.lifa.com.my launcher: ?sso=<jwt> signs straight in.
(function(){ try {
  var q = new URLSearchParams(location.search), t = q.get("sso");
  // ?view=applications — the admin.lifa.com.my "Recruitment" link lands on the candidate list.
  if (q.get("view") === "applications") window._SSO_VIEW = "applications";
  if (t) { SESSION_TOKEN = t; sessionStorage.setItem("lifa_admin_token", t); history.replaceState(null, "", location.pathname); }
} catch {} })();
var _loginAttempts = 0;
var _loginLockoutTime = null;
var MAX_LOGIN_ATTEMPTS = 5;
function _setSessionToken(t, remember) {
  SESSION_TOKEN = t || null;
  try {
    if (t) {
      if (remember) { localStorage.setItem("lifa_admin_token", t); sessionStorage.removeItem("lifa_admin_token"); }
      else { sessionStorage.setItem("lifa_admin_token", t); localStorage.removeItem("lifa_admin_token"); }
    } else { sessionStorage.removeItem("lifa_admin_token"); localStorage.removeItem("lifa_admin_token"); }
  } catch {}
}
function _apiHeaders(extra){
  const h = {"Content-Type":"application/json"};
  if(SESSION_TOKEN) h["Authorization"] = "Bearer "+SESSION_TOKEN;
  return Object.assign(h, extra||{});
}

async function apiGet(path) {
  const r = await fetch(API + path, {headers:_apiHeaders()}); return r.json();
}
async function apiPost(path, body) {
  const r = await fetch(API + path, {method:"POST",headers:_apiHeaders({"Content-Type":"application/json"}),body:JSON.stringify(body)}); return r.json();
}
async function apiPut(path, body) {
  const r = await fetch(API + path, {method:"PUT",headers:_apiHeaders({"Content-Type":"application/json"}),body:JSON.stringify(body)}); return r.json();
}
async function apiDelete(path) {
  const r = await fetch(API + path, {method:"DELETE",headers:_apiHeaders()}); return r.json();
}
async function api(path, opts = {}) {
  const method = (opts.method || 'GET').toUpperCase();
  const hasBody = !!opts.body;
  const r = await fetch(API + path, {method, headers: _apiHeaders(hasBody ? {'Content-Type':'application/json'} : {}), body: opts.body || undefined});
  return r.json();
}
async function apiLogin(email, pass, remember) {
  const r = await fetch(API+"/api/login", {method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({email,pass,remember:!!remember})});
  const d = await r.json();
  if(d.error) throw new Error(d.error);
  if(d.token){ _setSessionToken(d.token, !!remember); }
  return d;
}
async function _validateExistingSession() {
  // Called on page load. If token exists, ping a protected endpoint; if it fails, clear and force re-login.
  if (!SESSION_TOKEN) return false;
  try {
    const r = await fetch(API + "/api/advisers", { headers: _apiHeaders() });
    if (r.status === 401 || r.status === 403) { _setSessionToken(null); return false; }
    return r.ok;
  } catch { return false; }
}

// ── DATA (loaded from D1 on startup) ─────────────────────────────────────────
let ADVISERS_LOADED = false;
let STATEMENTS_LOADED = false;

async function loadAllData() {
  try {
    const [advisers, statements, ytdRows] = await Promise.all([
      apiGet("/api/advisers"),
      apiGet("/api/statements"),
      apiGet("/api/ytd")
    ]);
    // Populate ADVISERS
    advisers.forEach(function(a) {
      ADVISERS[a.id] = {
        name: a.name, initials: a.initials, rank: a.rank, category: a.category,
        ifast: a.ifast, cmsrl: a.cmsrl, email: a.email, personalEmail: a.personal_email,
        displayName: a.display_name || '', canInvoice: !!a.can_invoice, willCommTier: a.will_comm_tier || '', perms: a.perms || '', role: a.role || '',
        pass: a.pass, mustChangePass: !!a.must_change_pass,
        lastLoginAt: a.last_login_at || null, firstLoginAt: a.first_login_at || null, loginCount: a.login_count || 0,
        terminated: !!a.terminated, terminatedAt: a.terminated_at || null,
        uplineManager: a.upline_manager, uplineVP: a.upline_vp,
        phone: a.phone || '', bankName: a.bank_name || '', bankAccount: a.bank_account || '', mailingAddress: a.mailing_address || ''
      };
    });
    // Populate STATEMENTS — deduplicate by adviser+period, keep highest _dbId (latest)
    Object.keys(ADVISERS).forEach(function(id){ STATEMENTS[id] = []; });
    var stmtMap = {}; // key: advId+"|"+period -> best record
    statements.forEach(function(s) {
      var key = s.adviser_id + "|" + s.period;
      if (!stmtMap[key] || s.id > stmtMap[key].id) stmtMap[key] = s;
    });
    Object.values(stmtMap).forEach(function(s) {
      if (!STATEMENTS[s.adviser_id]) STATEMENTS[s.adviser_id] = [];
      STATEMENTS[s.adviser_id].push({
        _dbId: s.id, period: s.period, date: s.date, status: s.status,
        ifast_comm: s.ifast_comm, personal_rate: s.personal_rate, rank: s.rank,
        personal_payout: s.personal_payout, overridings: s.overridings,
        total_payout: s.total_payout, lifa_retention: s.lifa_retention,
        carried_in: s.carried_in || 0, paid_amount: s.paid_amount || 0, carried_out: s.carried_out || 0,
        settled_amount: s.settled_amount || 0, phillip_comm: s.phillip_comm || 0, fp_base: s.fp_base || 0, fp_personal: s.fp_personal || 0, fp_overriding: s.fp_overriding || 0,
        adjustment_amount: s.adjustment_amount || 0, reconciled_in: s.reconciled_in || '',
        transactions: s.transactions || []
      });
    });
    // Populate YTD
    ytdRows.forEach(function(y) {
      YTD[y.adviser_id] = {
        ytd_personal: y.ytd_personal, mtd_personal: y.mtd_personal,
        ytd_direct: y.ytd_direct, ytd_district: y.ytd_district
      };
    });
    ADVISERS_LOADED = true;
    STATEMENTS_LOADED = true;
  } catch(e) {
    console.error("Failed to load data from API", e);
    showToast("error", "⚠️ Failed to connect to database. Using local data.");
  }
}

// All adviser, statement and YTD data is loaded from Cloudflare D1 via the Worker API.
// Do NOT add hardcoded data here — it will be overwritten on login anyway and causes stale data bugs.
const ADVISERS   = {}; // populated by loadAllData()
const STATEMENTS = {}; // populated by loadAllData()
const YTD        = {}; // populated by loadAllData()

// ── UPLOADED SOURCE STATEMENTS ────────────────────────────────────────────────
// Stores raw uploaded files indexed by partner → month → { files, parsed }
// Structure: UPLOADS["iFAST"]["Jan 2026"] = [ { name, type, date, rows:[], invoiceNo } ]
//            UPLOADS["Phillip"]["Jan 2026"] = [ { name, rows:[] } ]
const UPLOADS = { "iFAST": {}, "Phillip": {} };

// ── STATE ──────────────────────────────────────────────────────────────────────
let currentUser = null;
let currentView = "dashboard";
let currentStatement = null;
let isAdmin = false;
let isChecker = false;
let isAdminPreview = false;
let selectedYear = new Date().getFullYear(); // year filter for both agent and admin
let adminSelectedYear = new Date().getFullYear(); // year filter for admin folder view

// ── AUTH ───────────────────────────────────────────────────────────────────────

function generateTempPassword() {
  const up="ABCDEFGHJKLMNPQRSTUVWXYZ", dg="23456789", sp="!@#$%",
        al="ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789!@#$%";
  let p = up[Math.floor(Math.random()*up.length)]
        + dg[Math.floor(Math.random()*dg.length)]
        + sp[Math.floor(Math.random()*sp.length)];
  for(let i=3;i<10;i++) p+=al[Math.floor(Math.random()*al.length)];
  return p.split("").sort(()=>Math.random()-.5).join("");
}

function validatePassword(p) {
  if(p.length<8)             return "Password must be at least 8 characters.";
  if(!/[A-Z]/.test(p))      return "Must contain at least one uppercase letter.";
  if(!/[0-9]/.test(p))      return "Must contain at least one number.";
  if(!/[^A-Za-z0-9]/.test(p)) return "Must contain at least one special character.";
  return null;
}

// Email is now sent server-side via Resend (worker endpoints). EmailJS removed.

// Toast helper — success / error / sending states
function showToast(type, message) {
  // ⚠️ AN UNKNOWN TYPE FALLS BACK TO BLUE "IN PROGRESS" — which is why a
  // failure could look like work underway and fade out after six seconds. Two
  // types were being passed that did not exist here, so ~30 call sites rendered
  // blue regardless of what they meant:
  //   warn — the action did NOT happen and the user needs to know why
  //   info — genuinely in progress (same blue as sending; named so a caller
  //          saying "info" gets what it asked for rather than a lucky default)
  // ADDING A TYPE HERE IS THE FIX. Rewriting call sites to dodge a missing
  // colour would leave the next 'warn' silently blue all over again.
  const colours = {
    sending: { bg:"#1D4ED8", icon:"📤" },
    info:    { bg:"#1D4ED8", icon:"📤" },
    success: { bg:"#166534", icon:"✅" },
    warn:    { bg:"#B45309", icon:"⚠️" },
    error:   { bg:"#991B1B", icon:"⚠️" },
  };
  const c = colours[type] || colours.sending;

  const old = document.getElementById("email-toast");
  if(old) old.remove();

  const t = document.createElement("div");
  t.id = "email-toast"; t.className = "email-toast";
  t.style.background = c.bg;
  t.innerHTML = `
    <span class="toast-close" onclick="this.parentElement.remove()">✕</span>
    <div style="font-weight:700;margin-bottom:4px;">${c.icon} Lifa Planners Portal</div>
    <div style="font-size:12px;color:#CBD5E1;">${escapeHtml(message)}</div>`;
  document.body.appendChild(t);

  if(type !== "error") setTimeout(()=>t?.remove(), 6000);
}

function doLogin() {
  const email = document.getElementById("login-email").value.trim().toLowerCase();
  const pass  = document.getElementById("login-pass").value.trim();
  const remEl = document.getElementById("login-remember");
  const remember = remEl ? remEl.checked : false;
  const err   = document.getElementById("login-error");
  if(!email){ err.textContent="Please enter your corporate email."; return; }
  if(!pass) { err.textContent="Please enter your password."; return; }
  err.textContent="Signing in...";
  apiLogin(email, pass, remember)
    .then(result=>{ _doLoginContinue(result); })
    .catch((e)=>{
    _loginAttempts++;
    const msg = (e&&e.message)||"";
    if(msg.toLowerCase().includes("too many")){
      _loginLockoutTime = Date.now();
      const retryMatch = msg.match(/(\d+)\s*minute/);
      const mins = retryMatch ? parseInt(retryMatch[1]) : 15;
      err.textContent = "Too many failed attempts. Please wait "+mins+" minute(s) before trying again.";
      setTimeout(()=>{ _loginAttempts=0; _loginLockoutTime=null; err.textContent=""; }, mins*60*1000);
    } else {
      if(_loginLockoutTime && Date.now()-_loginLockoutTime < 15*60*1000){
        err.textContent = "Too many failed attempts. Please wait before trying again.";
        return;
      }
      const remaining = MAX_LOGIN_ATTEMPTS - _loginAttempts;
      if(remaining <= 0){
        err.textContent = "Too many failed attempts. Please wait 15 minutes before trying again.";
      } else {
        err.textContent = "Incorrect password. " + remaining + " attempt" + (remaining===1?"":"s") + " remaining before lockout.";
      }
    }
  });
}

function _doLoginContinue(adviserObj) {
  const err = document.getElementById("login-error");
  const a = adviserObj;
  const role = a.role || 'adviser';
  isAdmin = role === 'admin';
  isChecker = role === 'checker';
  // ── ADMIN PORTAL LINK ──────────────────────────────────────────────────
  // Owner 2026-09-29: *"add the link onlu for admin. advisor login no need
  // admin link"* · *"me, vinnie and pavithra has lifa portal login so they
  // can chanmge view between admin and lifa portal"*.
  //
  // THE TEST IS "NOT AN ADVISER", NOT "IS ADMIN" — and that distinction is
  // the whole point. Measured on the live roster: Vinnie is role 'admin' but
  // PAVITHRA IS role 'licensing', so gating on isAdmin would have hidden the
  // link from one of the three people he named. Checker is staff too and
  // sees it on the same reading of his words.
  //
  // Set HERE, where the role is known, because the two init paths diverge on
  // isAdmin/isChecker and 'licensing' falls through to the ADVISER one — a
  // gate inside either function would miss her.
  try {
    var _staff = role && role !== 'adviser';
    var _ws = document.getElementById("nav-workspace");
    if (_ws) _ws.style.display = _staff ? "" : "none";
  } catch (_e) {}
  const adv = {
    name: a.name, initials: a.initials, rank: a.rank, category: a.category,
    ifast: a.ifast, cmsrl: a.cmsrl, email: a.email, personalEmail: a.personal_email,
    displayName: a.display_name || '',
    mustChangePass: !!a.must_change_pass,
    uplineManager: a.upline_manager, uplineVP: a.upline_vp, role: role, perms: a.perms || '',
    phone: a.phone || '', bankName: a.bank_name || '', bankAccount: a.bank_account || '', mailingAddress: a.mailing_address || ''
  };
  ADVISERS[a.id] = adv;
  currentUser = a.id;
  err.textContent="";
  if(adv.mustChangePass){
    document.getElementById("login-screen").style.display="none";
    document.getElementById("change-pass-overlay").classList.add("open"); return;
  }
  document.getElementById("login-screen").style.display="none";
  const appEl=document.getElementById("app");
  appEl.style.display="flex";
  appEl.style.visibility="visible";
  appEl.style.opacity="1";
  if(isAdmin || isChecker){
    loadAllData().then(()=>setTimeout(()=>initAdminApp(),200));
  } else {
    loadAllData().then(()=>{ initApp(); });
  }
}

function submitNewPassword() {
  const p1=document.getElementById("new-pass1").value.trim();
  const p2=document.getElementById("new-pass2").value.trim();
  const err=document.getElementById("change-pass-error");
  const msg=validatePassword(p1);
  if(msg){err.textContent=msg;return;}
  if(p1!==p2){err.textContent="Passwords do not match.";return;}
  ADVISERS[currentUser].pass=p1; ADVISERS[currentUser].mustChangePass=false;
  apiPut("/api/advisers/"+currentUser+"/password", {pass:p1, must_change_pass:false});
  err.textContent="";
  document.getElementById("change-pass-overlay").classList.remove("open");
  document.getElementById("login-screen").style.display="none";
  const appEl=document.getElementById("app");
  appEl.style.display="flex";
  appEl.style.visibility="visible";
  appEl.style.opacity="1";
  setTimeout(()=>initApp(),50);
}

// ── FORGOT PASSWORD ───────────────────────────────────────────────────────────
let _forgotId=null, _forgotTemp=null, _forgotEmail=null, _forgotSendEmail=true;

function openForgotPassword() {
  document.getElementById("forgot-overlay").style.display="flex";
  if(Object.keys(ADVISERS).length===0){
    const btn=document.querySelector("#forgot-form .modal-btn");
    if(btn){btn.disabled=true;btn.textContent="Loading...";}
    apiGet("/api/advisers").then(list=>{
      list.forEach(a=>{ADVISERS[a.id]=a;});
      if(btn){btn.disabled=false;btn.textContent="Send Reset Password";}
    }).catch(()=>{if(btn){btn.disabled=false;btn.textContent="Send Reset Password";}});
  }
  const btn=document.querySelector("#forgot-form .modal-btn"); if(btn){btn.disabled=false;btn.textContent="Send Reset Password";}
  _forgotId=null; _forgotTemp=null;
  document.getElementById("forgot-email").value="";
  document.getElementById("forgot-err").textContent="";
  document.getElementById("forgot-form").style.display="block";
  document.getElementById("forgot-sent").style.display="none";
  document.getElementById("forgot-overlay").classList.add("open");
}
function closeForgotPassword() {
  document.getElementById("forgot-overlay").style.display="none";
  document.getElementById("forgot-form").style.display="block";
  document.getElementById("forgot-sent").style.display="none";
  document.getElementById("forgot-email").value="";
  document.getElementById("forgot-err").textContent="";
  _forgotId=null; _forgotTemp=null; _forgotEmail=null;
}
function doForgotPassword() {
  const email=document.getElementById("forgot-email").value.trim().toLowerCase();
  const err=document.getElementById("forgot-err");
  if(!email){err.textContent="Please enter your corporate email.";return;}
  const btn=document.querySelector("#forgot-form .modal-btn");
  if(btn){btn.disabled=true;btn.textContent="Searching...";}
  err.textContent="";
  fetch(API+"/api/forgot-check",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({email})})
    .then(r=>r.json())
    .then(d=>{
      if(d.error||!d.id){
        err.textContent="Email not found. Please use your corporate @lifa.com.my email.";
        if(btn){btn.disabled=false;btn.textContent="Send Reset Password";}
        return;
      }
      ADVISERS[d.id]=ADVISERS[d.id]||{name:d.name,email:d.email,initials:d.initials};
      _forgotId=d.id; _forgotTemp=generateTempPassword(); _forgotEmail=email;
      const adv=ADVISERS[d.id];
      if(btn){btn.disabled=true;btn.textContent="Sending...";}
      // Server generates the temp password, persists it, and emails it via Resend.
      fetch(API+"/api/forgot-send",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({email:adv.email})})
        .then(r=>r.json())
        .then(rd=>{
          if(rd.error){err.textContent="Failed to send reset email. Please try again.";if(btn){btn.disabled=false;btn.textContent="Send Reset Password";}return;}
          document.getElementById("forgot-form").style.display="none";
          document.getElementById("forgot-sent").style.display="block";
          if(btn){btn.disabled=false;btn.textContent="Send Reset Password";}
        })
        .catch(()=>{
          err.textContent="Failed to reset password. Please try again.";
          if(btn){btn.disabled=false;btn.textContent="Send Reset Password";}
        });
    })
    .catch(()=>{
      err.textContent="Failed to reset password. Please try again.";
      if(btn){btn.disabled=false;btn.textContent="Send Reset Password";}
    });
}

function submitForgotNewPassword() {
  const tempEntered = (document.getElementById("forgot-temp-input").value||"").trim();
  const newPass1 = (document.getElementById("forgot-new-pass1").value||"").trim();
  const newPass2 = (document.getElementById("forgot-new-pass2").value||"").trim();
  const errEl = document.getElementById("forgot-temp-err");
  const btn = document.getElementById("forgot-submit-btn");
  if(!tempEntered){errEl.textContent="Please enter the temporary password from your email.";return;}
  if(!newPass1){errEl.textContent="Please enter a new password.";return;}
  const msg=validatePassword(newPass1);
  if(msg){errEl.textContent=msg;return;}
  if(newPass1!==newPass2){errEl.textContent="Passwords do not match. Please re-enter.";return;}
  errEl.textContent="";
  btn.disabled=true; btn.textContent="Saving...";
  const id=_forgotId, email=_forgotEmail;
  fetch(API+"/api/forgot-reset",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:id,temp:tempEntered,pass:newPass1,must_change_pass:0})})
    .then(r=>r.json())
    .then(d=>{
      if(d.error){errEl.textContent=(d.error.indexOf("Temporary")>=0)?"Temporary password is incorrect. Check the email and re-enter it.":"Failed to save new password. Please try the reset process again.";btn.disabled=false;btn.textContent="Set New Password & Sign In";return;}
      // Update must_change_pass to 0 in reset endpoint already handles this
      // Now login with new password
      return apiLogin(email, newPass1);
    })
    .then(result=>{
      if(!result) return;
      closeForgotPassword();
      _doLoginContinue(result);
    })
    .catch(()=>{
      errEl.textContent="Login failed after password reset. Please sign in manually with your new password.";
      btn.disabled=false; btn.textContent="Set New Password & Sign In";
    });
}

function openAdminPassModal(lid, action) {
  _adminTargetId=lid; _adminAction=action;
  const adv=ADVISERS[lid];
  document.getElementById("admin-new-pass").value="";
  document.getElementById("admin-pass-err").textContent="";
  document.getElementById("admin-pass-form").style.display="block";
  document.getElementById("admin-pass-done").style.display="none";
  if(action==="reset"){
    document.getElementById("admin-pass-title").textContent="Reset Password";
    document.getElementById("admin-pass-sub").textContent=
      `Reset password for ${adv.name}. A temporary password will be auto-generated and emailed to both addresses. They must change it on next login.`;
    document.getElementById("admin-new-pass-field").style.display="none";
    document.getElementById("admin-pass-submit-btn").textContent="Reset & Send Email";
  } else {
    document.getElementById("admin-pass-title").textContent="Update Password";
    document.getElementById("admin-pass-sub").textContent=
      `Set a specific password for ${adv.name}. They will receive it by email and can log in immediately without a forced change.`;
    document.getElementById("admin-new-pass-field").style.display="block";
    document.getElementById("admin-pass-submit-btn").textContent="Set Password & Send Email";
  }
  document.getElementById("admin-pass-overlay").classList.add("open");
}
function closeAdminPassModal() {
  document.getElementById("admin-pass-overlay").classList.remove("open");
  _adminTargetId=null; _adminAction=null;
  if(currentUser) renderAdminPanel();
}
function submitAdminPassword() {
  const adv=ADVISERS[_adminTargetId];
  const err=document.getElementById("admin-pass-err");
  err.textContent="";
  var reqBody={};
  if(_adminAction!=="reset"){
    var np=document.getElementById("admin-new-pass").value.trim();
    if(np){ var vmsg=validatePassword(np); if(vmsg){err.textContent=vmsg;return;} reqBody.password=np; }
    // blank → server generates a temp password (behaves like a reset)
  }
  var btn=document.getElementById("admin-pass-submit-btn");
  var btnLabel=btn?btn.textContent:"";
  if(btn){ btn.disabled=true; btn.textContent="Sending…"; }
  // Persist + email server-side via the worker (Resend), not EmailJS.
  apiPost("/api/advisers/"+_adminTargetId+"/reset-password", reqBody).then(function(r){
    if(btn){ btn.disabled=false; btn.textContent=btnLabel; }
    if(r && r.ok){
      document.getElementById("admin-pass-form").style.display="none";
      document.getElementById("admin-pass-done-title").textContent=
        r.mustChange ? "Password Reset Successfully" : "Password Updated Successfully";
      document.getElementById("admin-pass-done-msg").textContent=
        adv.name+" has been emailed at "+r.email+(r.personalSent?" and their personal email":"")+"."+
        (r.mustChange ? " They must change their password on next login." : " They can log in immediately.");
      document.getElementById("admin-pass-done").style.display="block";
      if(typeof loadAllData==="function") loadAllData(); // refresh state from DB
    } else {
      err.textContent="✗ "+((r&&r.error)||"Could not send the email. Check the email service.");
    }
  }).catch(function(e){ if(btn){ btn.disabled=false; btn.textContent=btnLabel; } err.textContent="✗ "+e; });
}

document.addEventListener("DOMContentLoaded", function() {
  document.getElementById("login-btn").addEventListener("click", doLogin);
  document.getElementById("login-pass").addEventListener("keydown", e=>{ if(e.key==="Enter") doLogin(); });
  document.getElementById("login-email").addEventListener("keydown", e=>{ if(e.key==="Enter") document.getElementById("login-pass").focus(); });
  document.getElementById("forgot-email").addEventListener("keydown", e=>{ if(e.key==="Enter") doForgotPassword(); });
  // Show/hide password toggle (eye icon)
  var pTog = document.getElementById("login-pass-toggle");
  var pInp = document.getElementById("login-pass");
  if (pTog && pInp) {
    pTog.addEventListener("click", function() {
      var hidden = pInp.type === "password";
      pInp.type = hidden ? "text" : "password";
      pTog.textContent = hidden ? "🙈" : "👁";
      pTog.setAttribute("aria-label", hidden ? "Hide password" : "Show password");
    });
  }
  // If we already have a session token, restore the session by fetching /api/me
  if (SESSION_TOKEN) {
    apiGet("/api/me").then(me => {
      if (!me || me.error || !me.id) return;   // invalid token → fall through to login screen
      _doLoginContinue(me);
    }).catch(()=>{});
  }
});

function doLogout() {
  _setSessionToken(null);
  currentUser=null;
  isAdmin=false;
  isChecker=false;
  document.getElementById("app").style.display="none";
  document.getElementById("login-screen").style.display="flex";
  document.getElementById("login-pass").value="";
  document.getElementById("login-email").value="";
  document.getElementById("change-pass-overlay").classList.remove("open");
  document.getElementById("forgot-overlay").classList.remove("open");
  document.getElementById("admin-pass-overlay").classList.remove("open");
}

// ── ADMIN APP INIT ─────────────────────────────────────────────────────────────
function initAdminApp() {
  // Hide adviser-only sidebar items
  document.getElementById("nav-dashboard").style.display = "none";
  document.getElementById("nav-statements").style.display = "none";
  var _mycpe=document.getElementById("nav-mycpe"); if(_mycpe) _mycpe.style.display = "none";
  document.getElementById("sec-recent").style.display = "none";
  document.getElementById("grp-recent").style.display = "none";
  document.getElementById("sidebar-badge").style.display = "none";

  // Show admin nav
  document.getElementById("admin-nav-section").style.display = "block";
  document.getElementById("admin-nav-section-2").style.display = "block";
  { var _inv=document.getElementById("nav-invoicing"); if(_inv) _inv.style.display=""; }
  initSidebarSections();

  // Staff (checker) sidebar is permission-driven — each staff member sees only
  // the sections their perms allow. Owner-only areas (Admin Panel, System) are
  // never shown to staff regardless of perms.
  if (isChecker) {
    var _me = ADVISERS[currentUser] || {};
    var _p = String(_me.perms || 'all').toLowerCase(); // legacy checker with no perms = all
    var can = function(a){ return _p.indexOf('all') >= 0 || _p.split(',').map(function(s){return s.trim();}).indexOf(a) >= 0; };
    // Commission group (Upload Statements / Monthly Close / bank tally)
    if (!can('commission')) {
      document.getElementById("nav-upload").style.display = "none";
      ["nav-close","nav-bankstmts"].forEach(function(id){ var el=document.getElementById(id); if(el) el.style.display="none"; });
    } else {
      document.getElementById("nav-upload").style.display = "";
    }
    // Owner-only: Admin Panel + System section
    document.getElementById("nav-admin").style.display = "none";
    ["sec-system","grp-system"].forEach(function(id){ var el=document.getElementById(id); if(el) el.style.display="none"; });
    // Licensing + recruit sections
    if (!can('licensing')) ["sec-licensing","grp-licensing","sec-ai","grp-ai"].forEach(function(id){ var el=document.getElementById(id); if(el) el.style.display="none"; });
    // Compliance section (incl. CPE registers)
    if (!can('compliance') && !can('cpe')) ["sec-compliance","grp-compliance"].forEach(function(id){ var el=document.getElementById(id); if(el) el.style.display="none"; });
    // Adviser folders need at least one client-data area
    if (!can('commission') && !can('kyc') && !can('compliance')) ["sec-advisers","grp-advisers","nav-advisers"].forEach(function(id){ var el=document.getElementById(id); if(el) el.style.display="none"; });
  }

  // Topbar identity
  const adminEmail = Object.keys(ADMINS).find(e => ADMINS[e].isChecker === isChecker && (isAdmin ? ADMINS[e].isAdmin : ADMINS[e].isChecker));
  const adminInfo = ADMINS[adminEmail || Object.keys(ADMINS)[0]];
  document.getElementById("nav-avatar").textContent = isChecker ? "CK" : "AD";
  document.getElementById("nav-name").textContent = adminInfo ? adminInfo.name : "Lifa Admin";
  document.getElementById("nav-rank").textContent = isChecker ? "Checker" : "Administrator";

  // Build adviser folder sidebar items
  var sidebarAdvisers = document.getElementById("sidebar-adviser-list");
  if (sidebarAdvisers) {
    sidebarAdvisers.innerHTML = Object.keys(ADVISERS).filter(function(id){ return !ADVISERS[id].terminated; }).map(function(id) {
      var adv = ADVISERS[id];
      var pendingCount = getAdviserPendingCount(id);
      var badge = pendingCount > 0
        ? '<span style="background:#DC2626;color:#fff;font-size:9px;font-weight:700;padding:1px 6px;border-radius:10px;margin-left:auto;">' + pendingCount + ' to approve</span>'
        : '';
      return '<div class="sidebar-item" id="nav-adviser-'+id+'" onclick="adminViewAdviserFolder(\''+id+'\')" style="padding:8px 22px;display:flex;align-items:center;gap:8px;">'
        + '<span style="width:26px;height:26px;background:#E2E8F0;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;font-size:9px;font-weight:700;color:#0B2545;flex-shrink:0;">' + adv.initials + '</span>'
        + '<span style="font-size:12px;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + adv.name + '</span>'
        + badge
        + '</div>';
    }).join("");
  }

  // Red badge on Register Attempts nav: count of failed registrations in last 24h.
  const since24h = Math.floor(Date.now() / 1000) - 86400;
  applyGet("/api/apply/admin/register-attempts?since=" + since24h + "&limit=500").then(function(res) {
    var failures = (res.attempts || []).filter(function(a) { return a.status_code >= 400; }).length;
    var badge = document.getElementById("reg-fail-badge");
    if (badge && failures > 0) { badge.textContent = failures; badge.style.display = "inline"; }
  }).catch(function() {});

  // Default view: admin → Admin Panel, checker → first adviser folder.
  // Arrived from the Recruitment link → the candidate list, if this login can see it.
  // (sec-ai is hidden only for lacking the licensing tick; a collapsed section hides grp-ai, not sec-ai.)
  var _secAi = document.getElementById("sec-ai");
  if (window._SSO_VIEW === "applications" && _secAi && _secAi.style.display !== "none") {
    window._SSO_VIEW = null;
    showView("applications");
  } else if (isChecker) {
    var firstId = Object.keys(ADVISERS)[0];
    adminViewAdviserFolder(firstId);
  } else {
    document.getElementById("nav-advisers").classList.add("active");
    currentView = "advisers";
    _adminMode = "advisers";
    renderAdminPanel();
  }
  // §AUTOPILOT — after everything is loaded, close any completed month by itself.
  setTimeout(function(){ upAutoPilot(); }, 1500);
}

// ── APP INIT ───────────────────────────────────────────────────────────────────
function initApp() {
  try {
  const adv = ADVISERS[currentUser];
  const stmts = STATEMENTS[currentUser] || [];

  // Hide admin nav for regular advisers
  document.getElementById("admin-nav-section").style.display = "none";
  document.getElementById("admin-nav-section-2").style.display = "none";
  { var _inv=document.getElementById("nav-invoicing"); if(_inv) _inv.style.display = "none"; }

  // Topbar
  document.getElementById("nav-avatar").textContent = adv.initials;
  document.getElementById("nav-name").textContent = adv.name;
  document.getElementById("nav-rank").textContent = adv.rank;
  document.getElementById("sidebar-badge").textContent = stmts.length;

  // Sidebar: group statements by year, show months in chronological order
  const recentEl = document.getElementById('sidebar-recent');
  const sidebarYears = {};
  stmts.forEach(function(s, i) {
    var yr = parseInt((s.period||'').split(' ')[1]||'0');
    if (!sidebarYears[yr]) sidebarYears[yr] = [];
    sidebarYears[yr].push({s, i});
  });
  var yearsDesc = Object.keys(sidebarYears).map(Number).sort((a,b)=>b-a);
  var sidebarHTML = '';
  yearsDesc.forEach(function(yr) {
    var months = sidebarYears[yr].sort((a,b) => new Date('01 '+a.s.period) - new Date('01 '+b.s.period));
    sidebarHTML += '<div style="padding:4px 16px 2px;font-size:10px;font-weight:700;color:#9CA3AF;text-transform:uppercase;letter-spacing:.06em;cursor:pointer;" onclick="changeAgentYear('+yr+')">' + yr + '</div>';
    months.forEach(function(item) {
      sidebarHTML += '<div class="sidebar-item" onclick="viewStatement('+item.i+')" style="font-size:12px;padding:5px 22px;">'
        + '<span class="dot" style="background:' + (item.s.status==='Paid'?'#166534':'#92400E') + '"></span>'
        + item.s.period
        + '</div>';
    });
  });
  recentEl.innerHTML = sidebarHTML || '<div style="padding:8px 22px;font-size:12px;color:var(--mgray)">No statements yet</div>';

  // Licensing-role staff (Pavithra) with the Licensing tick also get AI Interview
  // (Applications) and Licensing — owner 29 Oct 2026: "Fix in code". Their account
  // stays a "licensing" one: only those two sections of the admin menu are shown.
  var _p = String(adv.perms || '').toLowerCase().split(',').map(function(x){ return x.trim(); });
  if (adv.role === 'licensing' && !isAdminPreview && (_p.indexOf('licensing') >= 0 || _p.indexOf('all') >= 0)) {
    document.getElementById("admin-nav-section").style.display = "block";
    ["nav-advisers","sec-comp","grp-comp","sec-compliance","grp-compliance"].forEach(function(id){
      var el = document.getElementById(id); if (el) el.style.display = "none";
    });
    if (window._SSO_VIEW === "applications") { window._SSO_VIEW = null; showView("applications"); return; }
  }

  showView("dashboard");
  } catch(e) {
    console.error("initApp error:", e);
    alert("Portal error: " + e.message + "\nPlease refresh and try again.");
  }
}

// ── VIEWS ──────────────────────────────────────────────────────────────────────
// ── Mobile drawer sidebar ────────────────────────────────────────────────
function toggleSidebar(){
  var sb=document.getElementById('sidebar'), bd=document.getElementById('sidebar-backdrop');
  if(!sb) return;
  var open=!sb.classList.contains('open');
  sb.classList.toggle('open',open);
  if(bd) bd.classList.toggle('open',open);
}
function closeSidebar(){
  var sb=document.getElementById('sidebar'), bd=document.getElementById('sidebar-backdrop');
  if(sb) sb.classList.remove('open');
  if(bd) bd.classList.remove('open');
}

// Open the KYC app (kyc.lifa.com.my) with single-sign-on: the portal JWT is passed in the
// URL fragment (never sent to any server) and adopted by the KYC app — no second login.
function openKyc() {
  var t = SESSION_TOKEN;
  window.open("https://kyc.lifa.com.my/" + (t ? "#tok=" + encodeURIComponent(t) : ""), "_blank");
}
// ----- Collapsible sidebar sections -----
var _navSection = {dashboard:'nav',statements:'nav',kyc:'nav',invoicing:'nav', applications:'ai',regattempts:'ai', admin:'system',upload:'comp',close:'comp',bankstmts:'comp',
  comphub:'compliance',compliance:'compliance',regreports:'compliance',aml:'compliance',compads:'compliance',policies:'compliance',commslog:'compliance', errorlog:'system',emailtemplates:'system',signingroster:'system',
  licensing:'licensing', intakes:'licensing'};
var _sectionKeys = ['nav','ai','comp','compliance','system','licensing'];
function toggleSection(key, force){
  var grp=document.getElementById('grp-'+key), sec=document.getElementById('sec-'+key);
  if(!grp||!sec) return;
  var collapse = (force!==undefined) ? force : (grp.style.display!=='none');
  grp.style.display = collapse ? 'none' : '';
  sec.classList.toggle('collapsed', collapse);
  if(force===undefined){
    try{ var st=JSON.parse(localStorage.getItem('lifaNavCollapsed')||'{}'); st[key]=collapse; localStorage.setItem('lifaNavCollapsed', JSON.stringify(st)); }catch(e){}
  }
}
function initSidebarSections(){
  var def={nav:false, ai:false, comp:false, compliance:false, system:false, licensing:false}; // open by default (walkthrough 29 Oct 2026); a section the person folds stays folded
  var saved={}; try{ saved=JSON.parse(localStorage.getItem('lifaNavCollapsed')||'{}')||{}; }catch(e){}
  _sectionKeys.forEach(function(k){ toggleSection(k, (saved[k]!==undefined)?saved[k]:def[k]); });
}
// Reveal a section (without persisting) so a programmatically-selected item is visible.
function _expandSectionFor(view){
  var key=_navSection[view]; if(!key) return;
  var grp=document.getElementById('grp-'+key), sec=document.getElementById('sec-'+key);
  if(grp){ grp.style.display=''; } if(sec){ sec.classList.remove('collapsed'); }
}

// Compliance Hub tabs (walkthrough board B5, owner 29 Oct 2026 "Flow is right"):
// the 8 compliance pages sit behind one menu item, switched by a tab strip.
var _COMP_TABS = [["comphub","Compliance Hub"],["compliance","SC Compliance"],["regreports","Reporting Checklist"],
  ["aml","AML/CFT"],["compads","Complaints & Ads"],["policies","Policies & Suitability"],["registers","Registers"],["commslog","Comms Log"]];
function _compTabStrip(view){
  var main = document.getElementById("main-content"); if (!main) return;
  var html = '<div id="comp-tabs" style="display:flex;gap:2px;flex-wrap:wrap;border-bottom:1px solid #E2E8F0;padding:14px 24px 0;background:#fff;">'
    + _COMP_TABS.map(function(t){
        var on = t[0] === view;
        return '<button onclick="showView(\'' + t[0] + '\')" style="background:none;border:0;border-bottom:2px solid ' + (on ? '#0B2545' : 'transparent')
          + ';color:' + (on ? '#0B2545' : '#64748B') + ';font-weight:' + (on ? '700' : '500') + ';font-size:13px;padding:8px 12px;cursor:pointer;">' + t[1] + '</button>';
      }).join('') + '</div>';
  main.insertAdjacentHTML('afterbegin', html);
  var hub = document.getElementById("nav-comphub"); if (hub) hub.classList.add("active");
}
function showView(view) {
  currentView = view;
  closeSidebar();   // collapse the mobile drawer after picking a destination
  _expandSectionFor(view);
  ["dashboard","statements","advisers","admin","upload","close","bankstmts","applications","errorlog","regattempts","compliance","commslog","regreports","aml","compads","comphub","policies","registers","protection","licensing","intakes","emailtemplates","signingroster","invoicing","circulars","academy","simulator"].forEach(v => {
    var el = document.getElementById("nav-"+v);
    if (el) el.classList.toggle("active", v===view);
  });
  // Clear adviser folder sidebar active states when navigating to main views
  Object.keys(ADVISERS).forEach(function(id) {
    var el = document.getElementById("nav-adviser-"+id);
    if (el) el.classList.remove("active");
  });

  if (view === "dashboard") renderDashboard();
  else if (view === "statements") renderStatements();
  else if (view === "advisers") { _adminMode = "advisers"; renderAdminPanel(); }
  else if (view === "admin")  { _adminMode = "settings"; renderAdminPanel(); bankSuggLoad(); }
  else if (view === "upload") renderUploadPanel();
  else if (view === "close")  renderCloseView();
  else if (view === "bankstmts") renderBankStatements();
  else if (view === "applications") renderApplicationsList();
  else if (view === "errorlog")     renderErrorLog();
  else if (view === "regattempts")  renderRegisterAttempts();
  else if (view === "compliance")   renderCompliance();
  else if (view === "commslog")     renderCommsLog();
  else if (view === "regreports")   renderRegReports();
  else if (view === "aml")          renderAML();
  else if (view === "compads")      renderComplaintsAds();
  else if (view === "comphub")      renderComplianceHub();
  else if (view === "policies")     renderPolicies();
  else if (view === "registers")    renderRegisters();
  else if (view === "protection")   renderProtectionGuide();
  else if (view === "licensing")    renderLicensing();
  else if (view === "intakes")      renderIntakes();
  else if (view === "emailtemplates") renderEmailTemplates();
  else if (view === "signingroster")  renderSigningRoster();
  else if (view === "invoicing")       renderInvoicing();
  else if (view === "circulars")       renderCircularsView();
  else if (view === "academy")         renderAcademyView();
  else if (view === "simulator")       renderSimulatorView();
  if (_COMP_TABS.some(function(t){ return t[0] === view; })) _compTabStrip(view);
}

function changeAgentYear(y) {
  selectedYear = parseInt(y);
  renderDashboard();
}

// Populate the adviser's CPE/CMSRL status cards (hours, shortfall, payment, view own cert/slip).
async function loadSelfCpeStatus(){
  try{
    const r = await apiGet("/api/cpe/self?as="+encodeURIComponent(currentUser||""));
    if(!r || !r.years || !r.years.length) return;
    const cur = r.years.find(function(y){return (y.hours_completed>0)||(y.certs&&y.certs.length);}) || r.years[0];
    const hdr=document.getElementById("cpe-self-hdr"), status=document.getElementById("cpe-self-status"), certsEl=document.getElementById("cpe-self-certs");
    var _period = _fmtDate(cur.anniversary_start)+' &rarr; '+_fmtDate(cur.anniversary_end);
    if(hdr) hdr.innerHTML='<span style="font-size:12px;font-weight:600;color:'+(cur.shortfall>0?'#B45309':'#15803D')+'">· '+cur.hours_completed+'/'+cur.required_hours+' hrs</span>';
    if(status) status.innerHTML = (cur.shortfall>0
      ? '<b>'+cur.hours_completed+' hours completed</b> &middot; <span style="color:#B45309">shortfall '+cur.shortfall+' hours</span>'
        + '<div style="font-size:11px;color:#6B7280;margin-top:3px">For <b>renewal '+cur.year+'</b> &mdash; CPE must be attended during <b>'+_period+'</b>.</div>'
      : '✅ <b>CPE done — renewal '+cur.year+'</b>');
    if(certsEl){
      const all=[]; r.years.forEach(function(y){ (y.certs||[]).forEach(function(c){ all.push(Object.assign({year:y.year},c)); }); });
      certsEl.innerHTML = all.map(function(c){ var icon=c.verified?'✅':(c.rejection_reason?'⚠️':'⏳'); return '<div style="font-size:11.5px;display:flex;align-items:center;gap:6px;padding:2px 0;color:#374151" title="'+String(c.rejection_reason||'').replace(/"/g,"&quot;")+'">'+icon+' '+String(c.title||'').slice(0,24)+' <span style="color:#9CA3AF">('+c.hours+'h·'+c.year+')</span> <button onclick="_cpeCertView('+c.id+')" style="background:#fff;border:1px solid #0B2545;color:#0B2545;border-radius:5px;font-size:10px;padding:1px 6px;cursor:pointer">📄 view</button></div>'; }).join("");
    }
    const ch=document.getElementById("cmsrl-self-hdr"), cs=document.getElementById("cmsrl-self-status");
    const exempt=(cur.cmsrl_exempt||r.is_excomm||cur.payment_status==="Exempt");
    const paid=(cur.payment_status==="Verified"||cur.payment_status==="Paid");
    if(ch) ch.innerHTML='<span style="font-size:12px;font-weight:600;color:'+(exempt?'#15803D':paid?'#15803D':'#B45309')+'">· '+(exempt?'Exempt (firm pays)':paid?'Paid':'Outstanding RM 500')+'</span>';
    if(cs) cs.innerHTML = exempt
      ? '✅ CMSRL renewal '+cur.year+' is <b>paid by the firm</b> for EXCOMM — no payment or slip needed.'
      : paid
      ? '✅ CMSRL renewal <b>Paid</b> for '+cur.year+'.'
      : '<span style="color:#B45309"><b>Outstanding RM 500</b></span> — after paying, upload your transfer slip below.'+(cur.has_slip?' <span style="color:#6B7280">(Slip uploaded — awaiting finance.)</span> <button onclick="_cpeViewSlip('+cur.record_id+')" style="background:#fff;border:1px solid #0B2545;color:#0B2545;border-radius:5px;font-size:10px;padding:1px 6px;cursor:pointer">🧾 view</button>':'');
    // EXCOMM: firm pays CMSRL renewal — no slip upload needed.
    var slipBtn=document.getElementById("cmsrl-self-upload"); if(slipBtn) slipBtn.style.display = exempt ? "none" : "";
  }catch(e){}
}
// Adviser self-upload of CPE certificate / CMSRL renewal receipt → Claude verifies.
function openSelfUpload(kind){
  const isCpe = kind==='cpe';
  const m=document.createElement('div'); m.id='self-upload-modal';
  m.style.cssText='position:fixed;inset:0;z-index:99999;background:rgba(11,37,69,.45);display:flex;align-items:center;justify-content:center;padding:16px';
  m.innerHTML=`<div style="background:#fff;border-radius:16px;max-width:440px;width:100%;padding:22px;box-sizing:border-box">
    <div style="font-size:17px;font-weight:700;color:#0B2545;margin-bottom:4px">${isCpe?'⬆️ Upload CPE Certificate':'🧾 Upload CMSRL Transfer Slip'}</div>
    <div style="font-size:12px;color:#6B7280;margin-bottom:16px">${isCpe?'Just pick your certificate — we&rsquo;ll read the title, date &amp; SIDC CPE hours automatically. Review, then submit.':'Upload your bank transfer slip for the CMSRL renewal payment. Finance will verify it and issue your receipt.'}</div>
    <label style="font-size:12px;font-weight:600;color:#374151">${isCpe?'Certificate file (PDF or image)':'File (PDF or image)'}</label>
    <input type="file" id="su-file" accept="application/pdf,image/*" ${isCpe?'onchange="selfExtractCpe()"':''} style="width:100%;margin:6px 0 12px;font-size:13px">
    ${isCpe?`<div id="su-autonote" style="font-size:11px;color:#6B7280;margin:-4px 0 10px;display:flex;align-items:center;gap:6px"><span>📎 Pick your cert above and the fields below fill in automatically.</span></div>
    <label style="font-size:12px;font-weight:600;color:#374151">Training title</label>
    <input id="su-title" placeholder="auto-fills from your certificate" style="width:100%;padding:9px;border:1px solid #D1D5DB;border-radius:8px;margin:6px 0 10px;box-sizing:border-box;font-size:13px">
    <div style="display:flex;gap:10px">
      <div style="flex:1"><label style="font-size:12px;font-weight:600;color:#374151">Training date</label><input id="su-date" type="date" style="width:100%;padding:9px;border:1px solid #D1D5DB;border-radius:8px;margin:6px 0;box-sizing:border-box;font-size:13px"></div>
      <div style="width:90px"><label style="font-size:12px;font-weight:600;color:#374151">CPE hours</label><input id="su-hours" type="number" step="0.5" min="0" placeholder="auto" style="width:100%;padding:9px;border:1px solid #D1D5DB;border-radius:8px;margin:6px 0;box-sizing:border-box;font-size:13px"></div>
    </div>`:''}
    <div id="su-status" style="font-size:12px;min-height:18px;margin:6px 0;line-height:1.5"></div>
    <div style="display:flex;gap:10px;margin-top:8px">
      <button onclick="document.getElementById('self-upload-modal').remove()" style="flex:1;padding:11px;background:#F1F5F9;color:#374151;border:none;border-radius:10px;font-weight:700;cursor:pointer">Cancel</button>
      <button id="su-go" onclick="submitSelfUpload('${kind}')" style="flex:1;padding:11px;background:#0B2545;color:#fff;border:none;border-radius:10px;font-weight:700;cursor:pointer">Upload &amp; Verify</button>
    </div></div>`;
  document.body.appendChild(m);
}
async function submitSelfUpload(kind){
  const st=document.getElementById('su-status');
  const file=(document.getElementById('su-file')||{}).files && document.getElementById('su-file').files[0];
  if(!file){ st.innerHTML='<span style="color:#B91C1C">Please choose a file.</span>'; return; }
  if(kind!=='cpe'){
    const fd=new FormData(); fd.append('slip',file);
    const go=document.getElementById('su-go'); go.disabled=true; go.textContent='⏳ Uploading…';
    st.innerHTML='<span style="color:#6B7280">Uploading transfer slip…</span>';
    try{
      const r=await fetch(API+`/api/cpe/${currentUser}/payment-slip`,{method:'POST',headers:{Authorization:'Bearer '+SESSION_TOKEN},body:fd});
      const j=await r.json(); if(!r.ok) throw new Error(j.error||('HTTP '+r.status));
      st.innerHTML='<span style="color:#166534">✅ Transfer slip uploaded. Finance has been notified to verify your payment and issue your receipt.</span>';
      go.textContent='Done'; setTimeout(()=>{document.getElementById('self-upload-modal')&&document.getElementById('self-upload-modal').remove();},3000);
    }catch(e){ st.innerHTML='<span style="color:#B91C1C">'+e.message+'</span>'; go.disabled=false; go.textContent='Upload & Verify'; }
    return;
  }
  const title=(document.getElementById('su-title').value||'').trim();
  const date=(document.getElementById('su-date').value||'').trim();
  const hours=parseFloat(document.getElementById('su-hours').value||'0');
  if(!title||!date||!(hours>0)){ st.innerHTML='<span style="color:#B91C1C">Fill in title, training date and hours.</span>'; return; }
  const fd=new FormData(); fd.append('file',file); fd.append('title',title); fd.append('training_date',date); fd.append('hours',String(hours));
  const go=document.getElementById('su-go'); go.disabled=true; go.textContent='⏳ Verifying…';
  st.innerHTML='<span style="color:#6B7280">Uploading and running AI verification…</span>';
  try{
    const r=await fetch(API+`/api/cpe/${currentUser}/cert`,{method:'POST',headers:{Authorization:'Bearer '+SESSION_TOKEN},body:fd});
    const j=await r.json();
    if(!r.ok) throw new Error(j.error||('HTTP '+r.status));
    const ai=j.ai||{}; const ok=ai.auto_verified||ai.qualifies;
    st.innerHTML='<span style="color:'+(ok?'#166534':'#92400E')+'">'+(ok?'✅ Uploaded &amp; auto-verified by AI.':'⚠️ Uploaded — '+(ai.reject_reason||ai.notes||'pending compliance review.'))+(j.in_window?'':' (Outside current anniversary window.)')+'</span>';
    go.textContent='Done'; setTimeout(()=>{document.getElementById('self-upload-modal')&&document.getElementById('self-upload-modal').remove();},2800);
  }catch(e){ st.innerHTML='<span style="color:#B91C1C">'+e.message+'</span>'; go.disabled=false; go.textContent='Upload & Verify'; }
}

// Auto-read the chosen CPE cert with Claude and populate title / date / hours so the
// adviser doesn't have to type anything — they just review and submit.
async function selfExtractCpe(){
  const fileInput=document.getElementById('su-file');
  const file=fileInput && fileInput.files && fileInput.files[0];
  if(!file) return;
  const st=document.getElementById('su-status');
  const go=document.getElementById('su-go');
  const tIn=document.getElementById('su-title'), dIn=document.getElementById('su-date'), hIn=document.getElementById('su-hours');
  if(go){ go.disabled=true; }
  if(st) st.innerHTML='<span style="color:#6B7280">🤖 Reading your certificate…</span>';
  try{
    const fd=new FormData(); fd.append('file',file); fd.append('adviser_id',currentUser);
    const r=await fetch(API+'/api/cpe/extract',{method:'POST',headers:{Authorization:'Bearer '+SESSION_TOKEN},body:fd});
    const data=await r.json();
    if(!r.ok || data.error) throw new Error(data.error||'Could not read the certificate');
    const ai=data.extraction||{};
    if(ai.title && tIn) tIn.value=ai.title;
    if(ai.date  && dIn) dIn.value=ai.date;
    if(ai.hours && hIn) hIn.value=ai.hours;
    const haveHours=(parseFloat(hIn&&hIn.value)||0)>0;
    // Flag SIDC-CPE hours if Claude couldn't find them (adviser fills manually)
    if(hIn){
      if(!haveHours){ hIn.style.border='2px solid #F59E0B'; hIn.style.background='#FFFBEB'; hIn.placeholder='⚠️ enter hours'; }
      else { hIn.style.border='1px solid #D1D5DB'; hIn.style.background='#fff'; }
    }
    if(st){
      if(ai.title||ai.date||haveHours){
        st.innerHTML='<span style="color:#166534">✅ Read your certificate — '
          +(ai.title?('“'+String(ai.title).slice(0,40)+'”'):'')
          +(haveHours?(' · <b>'+ai.hours+' SIDC CPE hrs</b>'):' · <span style="color:#B45309">hours not found, please enter</span>')
          +'.</span> <span style="color:#6B7280;font-size:11px">Check the details, then Upload &amp; Verify.</span>';
      } else {
        st.innerHTML='<span style="color:#B45309">⚠️ Couldn&rsquo;t auto-read this file — please fill the fields in manually.</span>';
      }
    }
  }catch(e){
    if(st) st.innerHTML='<span style="color:#B45309">⚠️ Auto-read failed ('+e.message+'). Please fill the fields manually.</span>';
  } finally {
    if(go) go.disabled=false;
  }
}

// Sidebar shortcut: jump to the dashboard's CPE compliance card.
function gotoCPE(){
  showView('dashboard');
  setTimeout(function(){ var el=document.getElementById('cpe-card'); if(el) el.scrollIntoView({behavior:'smooth', block:'start'}); }, 80);
}
async function loadFitProper(){
  var card=document.getElementById('fitproper-card'); if(!card) return;
  var d; try{ d=await apiGet('/api/me/fit-proper'); }catch(e){ card.innerHTML=''; return; }
  if(!d || d.error){ card.innerHTML=''; return; }
  var yr=d.year, dec=d.declaration;
  if(dec){
    card.innerHTML='<div style="background:#ECFDF5;border:1px solid #A7F3D0;border-radius:14px;padding:16px 18px"><div style="font-weight:700;color:#065F46;font-size:15px">&#10003; Fit-and-proper declaration — '+yr+' completed</div><div style="font-size:12px;color:#047857;margin-top:4px">Signed '+_amlEsc(dec.signed_name||'')+' &middot; '+_amlEsc((dec.signed_at||'').slice(0,10))+'. Thank you.</div></div>';
    return;
  }
  var qs=[['fp-bk','Have you been declared bankrupt, or are you subject to bankruptcy proceedings?'],['fp-cr','Have you been convicted of any offence involving fraud, dishonesty or financial misconduct?'],['fp-di','Have you been subject to disciplinary action by the SC, FIMM, BNM or any regulator / professional body?'],['fp-cv','Are you a defendant in civil proceedings relating to your professional conduct?'],['fp-in','Are you currently under investigation by any regulator or law-enforcement agency?']];
  var rl='margin-left:10px';
  card.innerHTML='<div style="background:#fff;border:1px solid #FDE68A;border-radius:14px;padding:16px 18px">'
    +'<div style="font-weight:700;color:#92400E;font-size:15px">&#128203; Annual fit-and-proper declaration — '+yr+' (required)</div>'
    +'<div style="font-size:12px;color:#92400E;margin:4px 0 12px">Required before the firm&rsquo;s ARAA licence renewal. Answer honestly; if you answer &ldquo;Yes&rdquo; to anything, add details below.</div>'
    +qs.map(function(q){return '<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:14px;padding:8px 0;border-bottom:1px solid #F3F4F6;font-size:13px"><span style="flex:1;color:#334155">'+q[1]+'</span><span style="white-space:nowrap"><label style="'+rl+'"><input type="radio" name="'+q[0]+'" value="0" checked onchange="_fpToggle()"> No</label><label style="'+rl+'"><input type="radio" name="'+q[0]+'" value="1" onchange="_fpToggle()"> Yes</label></span></div>';}).join('')
    +'<div id="fp-disc-wrap" style="display:none;margin-top:10px"><div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;font-weight:600">Please give details of any &ldquo;Yes&rdquo; answer</div><textarea id="fp-disc" rows="2" style="width:100%;margin-top:3px;padding:8px 10px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px;box-sizing:border-box;resize:vertical"></textarea></div>'
    +'<label style="display:flex;gap:8px;align-items:flex-start;font-size:13px;margin-top:12px;cursor:pointer"><input type="checkbox" id="fp-true"> I confirm the above answers are true and complete, and I will notify the firm immediately of any change.</label>'
    +'<div style="display:flex;gap:8px;align-items:center;margin-top:10px;flex-wrap:wrap"><input id="fp-sign" placeholder="Type your name to sign" style="flex:1;max-width:280px;padding:8px 10px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px"><button onclick="submitFitProper()" style="background:#0B2545;color:#fff;border:0;padding:9px 18px;border-radius:9px;font-size:13px;font-weight:700;cursor:pointer">Submit declaration</button></div>'
    +'<div id="fp-msg" style="font-size:12px;margin-top:6px"></div></div>';
}
function _fpToggle(){
  var anyYes=['fp-bk','fp-cr','fp-di','fp-cv','fp-in'].some(function(n){var el=document.querySelector('input[name="'+n+'"]:checked'); return el&&el.value==='1';});
  var w=document.getElementById('fp-disc-wrap'); if(w) w.style.display=anyYes?'block':'none';
}
async function submitFitProper(){
  var val=function(n){var el=document.querySelector('input[name="'+n+'"]:checked'); return el&&el.value==='1'?1:0;};
  var msg=document.getElementById('fp-msg');
  if(!document.getElementById('fp-true').checked){ msg.innerHTML='<span style="color:#B91C1C">Please tick the confirmation box.</span>'; return; }
  var sign=((document.getElementById('fp-sign')||{}).value||'').trim(); if(!sign){ msg.innerHTML='<span style="color:#B91C1C">Type your name to sign.</span>'; return; }
  var anyYes=['fp-bk','fp-cr','fp-di','fp-cv','fp-in'].some(function(n){return val(n)===1;});
  var disc=((document.getElementById('fp-disc')||{}).value||'').trim();
  if(anyYes && !disc){ msg.innerHTML='<span style="color:#B91C1C">You answered &ldquo;Yes&rdquo; — please give details.</span>'; return; }
  var payload={q_bankruptcy:val('fp-bk'),q_criminal:val('fp-cr'),q_disciplinary:val('fp-di'),q_civil:val('fp-cv'),q_investigation:val('fp-in'),disclosures:disc,declared_true:true,signed_name:sign};
  try{ var r=await apiPost('/api/me/fit-proper',payload); if(r&&r.error){ msg.innerHTML='<span style="color:#B91C1C">'+_amlEsc(r.error)+'</span>'; return; } loadFitProper(); }
  catch(e){ msg.innerHTML='<span style="color:#B91C1C">'+_amlEsc(e.message)+'</span>'; }
}
async function saveMyDetails(){
  var btn=document.getElementById('md-save-btn'), msg=document.getElementById('md-msg');
  if(btn){ btn.disabled=true; btn.textContent='Saving…'; }
  var body={
    personal_email:((document.getElementById('md-pemail')||{}).value||'').trim(),
    phone:((document.getElementById('md-phone')||{}).value||'').trim(),
    bank_name:((document.getElementById('md-bankname')||{}).value||'').trim(),
    bank_account:((document.getElementById('md-bankacc')||{}).value||'').trim(),
    mailing_address:((document.getElementById('md-addr')||{}).value||'').trim()
  };
  try{
    var r=await apiPost('/api/me/update', body);
    if(r&&r.error){ if(msg){ msg.style.color='#B91C1C'; msg.textContent=r.error; } }
    else {
      var a=ADVISERS[currentUser];
      if(a){ a.personalEmail=body.personal_email; a.phone=body.phone; a.bankName=body.bank_name; a.bankAccount=body.bank_account; a.mailingAddress=body.mailing_address; }
      if(msg){ msg.style.color='#15803D'; msg.textContent='✓ Saved — synced to LIFA admin'; }
    }
  }catch(e){ if(msg){ msg.style.color='#B91C1C'; msg.textContent=String(e.message||e); } }
  if(btn){ btn.disabled=false; btn.textContent='💾 Save my details'; }
}

function changeMyPassword(){
  var existing = document.getElementById('chpw-modal');
  if(existing){ existing.remove(); }
  var modal = document.createElement('div');
  modal.id = 'chpw-modal';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9999;display:flex;align-items:center;justify-content:center';
  modal.innerHTML = `
    <div style="background:#fff;border-radius:16px;padding:28px 28px 20px;width:340px;max-width:94vw;box-shadow:0 8px 40px rgba(0,0,0,.18)">
      <div style="font-weight:700;color:#0B2545;font-size:16px;margin-bottom:18px">🔑 Change Password</div>
      <div style="font-size:13px;color:#374151;margin-bottom:6px">Current password</div>
      <input id="chpw-cur" type="password" style="width:100%;box-sizing:border-box;padding:9px 11px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;margin-bottom:12px">
      <div style="font-size:13px;color:#374151;margin-bottom:6px">New password <span style="color:#9CA3AF;font-size:11px">(min 8 characters)</span></div>
      <input id="chpw-new" type="password" style="width:100%;box-sizing:border-box;padding:9px 11px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;margin-bottom:12px">
      <div style="font-size:13px;color:#374151;margin-bottom:6px">Confirm new password</div>
      <input id="chpw-con" type="password" style="width:100%;box-sizing:border-box;padding:9px 11px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;margin-bottom:16px">
      <div id="chpw-msg" style="font-size:12px;min-height:18px;margin-bottom:10px"></div>
      <div style="display:flex;gap:10px;justify-content:flex-end">
        <button onclick="document.getElementById('chpw-modal').remove()" style="background:#F3F4F6;color:#374151;border:none;border-radius:8px;padding:9px 16px;font-size:13px;cursor:pointer">Cancel</button>
        <button onclick="submitChangeMyPassword()" id="chpw-btn" style="background:#0B2545;color:#fff;border:none;border-radius:8px;padding:9px 18px;font-size:13px;font-weight:700;cursor:pointer">Update</button>
      </div>
    </div>`;
  document.body.appendChild(modal);
  modal.addEventListener('click', function(e){ if(e.target===modal) modal.remove(); });
  setTimeout(function(){ var f=document.getElementById('chpw-cur'); if(f) f.focus(); }, 50);
}

async function submitChangeMyPassword(){
  var cur=document.getElementById('chpw-cur'), n1=document.getElementById('chpw-new'), n2=document.getElementById('chpw-con');
  var msg=document.getElementById('chpw-msg'), btn=document.getElementById('chpw-btn');
  if(!cur||!n1||!n2) return;
  if(n1.value !== n2.value){ msg.style.color='#B91C1C'; msg.textContent='New passwords do not match.'; return; }
  if(n1.value.length < 8){ msg.style.color='#B91C1C'; msg.textContent='New password must be at least 8 characters.'; return; }
  btn.disabled=true; btn.textContent='Updating…';
  try{
    var r=await apiPost('/api/me/change-password', {current:cur.value, new:n1.value});
    if(r&&r.error){ msg.style.color='#B91C1C'; msg.textContent=r.error; }
    else{ msg.style.color='#15803D'; msg.textContent='✓ Password updated successfully.'; setTimeout(function(){ var m=document.getElementById('chpw-modal'); if(m) m.remove(); },1200); }
  }catch(e){ msg.style.color='#B91C1C'; msg.textContent=String(e.message||e); }
  btn.disabled=false; btn.textContent='Update';
}

function renderDashboard() {
  const adv   = ADVISERS[currentUser];
  const stmts = STATEMENTS[currentUser] || [];

  const now = new Date();
  const thisYear = now.getFullYear();

  // Determine available years from joining year onwards
  const allYears = [...new Set(stmts.map(s => parseInt((s.period||"").split(" ")[1]||"0")).filter(y=>y>2000))];
  allYears.sort((a,b)=>a-b);
  if (!allYears.includes(thisYear)) allYears.push(thisYear);
  const joinYear = allYears[0] || thisYear;
  if (selectedYear < joinYear) selectedYear = joinYear;
  if (selectedYear > thisYear) selectedYear = thisYear;

  const dispYear = selectedYear;
  const prevYear = dispYear - 1;
  const thisMonth = now.toLocaleString('en-MY', {month:'short', year:'numeric'});
  const lastMonth = new Date(now.getFullYear(), now.getMonth()-1, 1).toLocaleString('en-MY', {month:'short', year:'numeric'});

  function stmtYear(s) { return parseInt((s.period||"").split(" ")[1]||"0"); }
  function stmtMonthYear(s) { return s.period; }

  // Find latest uploaded month in dispYear for this adviser
  const dispYearStmts = stmts.filter(s => stmtYear(s) === dispYear);
  dispYearStmts.sort((a,b) => new Date("01 "+b.period) - new Date("01 "+a.period));
  const mtdStmt = dispYearStmts[0] || null;
  const mtdLabel = mtdStmt ? mtdStmt.period : "No data";

  // LMTD = same month name, prevYear
  const lmtdPeriod = mtdStmt ? (mtdStmt.period.split(" ")[0] + " " + prevYear) : null;
  const lmtdStmt = lmtdPeriod ? stmts.find(s => s.period === lmtdPeriod) : null;
  const lmtdLabel = lmtdStmt ? lmtdStmt.period : (mtdStmt ? mtdStmt.period.split(" ")[0] + " " + prevYear : "—");

  // YTD = Jan to mtdMonth of dispYear (only months that exist/uploaded)
  const mtdMonthIdx = mtdStmt ? new Date("01 " + mtdStmt.period).getMonth() : -1;
  const ytdStmts = stmts.filter(s => stmtYear(s) === dispYear && new Date("01 "+s.period).getMonth() <= mtdMonthIdx);
  // LYTD = Jan to same month of prevYear (apples-to-apples)
  const lytdStmts = stmts.filter(s => stmtYear(s) === prevYear && new Date("01 "+s.period).getMonth() <= mtdMonthIdx);

  const ytdRevenue  = ytdStmts.reduce((s,x) => s + (x.ifast_comm||0), 0);
  const lytdRevenue = lytdStmts.reduce((s,x) => s + (x.ifast_comm||0), 0);
  const mtdRevenue  = mtdStmt ? (mtdStmt.ifast_comm||0) : 0;
  const lmtdRevenue = lmtdStmt ? (lmtdStmt.ifast_comm||0) : 0;

  // Show all years with statements + current year, newest first
  const allYearsSorted = [...allYears].sort((a,b)=>b-a);
  const yearSelector = '<select onchange="changeAgentYear(this.value)" style="padding:6px 12px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;font-family:inherit;color:#0B2545;background:#fff;cursor:pointer;">'
    + allYearsSorted.map(y => '<option value="'+y+'"'+(y===dispYear?' selected':'')+'>'+y+'</option>').join('')
    + '</select>';

  const ytdPayout  = ytdStmts.reduce((s,x) => s + (x.personal_payout||0), 0);
  const lytdPayout = lytdStmts.reduce((s,x) => s + (x.personal_payout||0), 0);
  const mtdPayout  = mtdStmt ? (mtdStmt.personal_payout||0) : 0;
  const lmtdPayout = lmtdStmt ? (lmtdStmt.personal_payout||0) : 0;

  const latestStmt   = stmts[0];
  const latestPayout = latestStmt ? latestStmt.personal_payout : 0;

  function fmt(n) { return 'MYR ' + n.toLocaleString('en-MY',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  function chg(curr, prev) {
    if(!prev) return '';
    const pct = ((curr-prev)/prev*100).toFixed(1);
    const col = pct>=0?'#166534':'#991B1B';
    const arrow = pct>=0?'▲':'▼';
    return `<div style="font-size:11px;color:${col};margin-top:2px;">${arrow} ${Math.abs(pct)}% vs ${prevYear}</div>`;
  }
  function chgM(curr, prev) {
    if(!prev) return '';
    const pct = ((curr-prev)/prev*100).toFixed(1);
    const col = pct>=0?'#166534':'#991B1B';
    const arrow = pct>=0?'▲':'▼';
    return `<div style="font-size:11px;color:${col};margin-top:2px;">${arrow} ${Math.abs(pct)}% vs ${lmtdLabel}</div>`;
  }

  document.getElementById("main-content").innerHTML = `
    <div class="fade-in">
      <div class="welcome-banner">
        <div class="welcome-text">
          <h2>Welcome back, ${escapeHtml(adv.displayName || adv.name.split(" ")[0])}.</h2>
          <p>${escapeHtml(adv.ifast)} · ${stmts.length} statement${stmts.length!==1?'s':''} available · Last updated 10 Feb 2026</p>
        </div>
        <div class="welcome-badge">
          <div class="rank">${escapeHtml(adv.rank)}</div>
          <div class="rank-label">Current Rank</div>
        </div>
      </div>

      <div id="cpe-card" style="display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:18px">
        <div style="background:#fff;border:1px solid #E5E7EB;border-radius:14px;padding:16px 18px">
          <div style="font-weight:700;color:#0B2545;font-size:15px">📋 CPE Certificate <span id="cpe-self-hdr"></span></div>
          <div id="cpe-self-status" style="font-size:12px;color:#6B7280;margin:3px 0 10px;line-height:1.5">Upload your SIDC CPE cert — auto-checked against your anniversary window &amp; 20-hour requirement.</div>
          <div id="cpe-self-certs" style="margin-bottom:10px"></div>
          <button onclick="openSelfUpload('cpe')" style="background:#0B2545;color:#fff;border:none;border-radius:9px;padding:10px 16px;font-size:13px;font-weight:700;cursor:pointer;width:100%">⬆️ Upload CPE Certificate</button>
        </div>
        <div style="background:#fff;border:1px solid #E5E7EB;border-radius:14px;padding:16px 18px">
          <div style="font-weight:700;color:#0B2545;font-size:15px">🪪 CMSRL Renewal <span id="cmsrl-self-hdr"></span></div>
          <div id="cmsrl-self-status" style="font-size:12px;color:#6B7280;margin:3px 0 12px;line-height:1.5">After paying your CMSRL renewal, upload the bank transfer slip — finance verifies the payment &amp; issues your receipt.</div>
          <button id="cmsrl-self-upload" onclick="openSelfUpload('slip')" style="background:#fff;color:#0B2545;border:1.5px solid #0B2545;border-radius:9px;padding:10px 16px;font-size:13px;font-weight:700;cursor:pointer;width:100%">🧾 Upload Transfer Slip</button>
        </div>
        <img src="x" onerror="this.remove();window.loadSelfCpeStatus&&loadSelfCpeStatus()" style="display:none">
      </div>

      ${(!isAdmin && !isChecker) ? `
      <div style="background:#fff;border:1px solid #E5E7EB;border-radius:14px;padding:16px 18px;margin-bottom:18px">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px">
          <div style="font-weight:700;color:#0B2545;font-size:15px">👤 My Details</div>
          <div style="font-size:11px;color:#9CA3AF">Updates sync to LIFA admin</div>
        </div>
        <div style="background:#F8FAFC;border:1px solid #E2E8F0;border-radius:9px;padding:10px 12px;margin-bottom:10px;display:flex;gap:20px;flex-wrap:wrap;font-size:12px">
          <div><span style="color:#9CA3AF;font-size:10px;text-transform:uppercase;letter-spacing:.04em;font-weight:600">User ID</span><div style="font-weight:700;color:#0B2545;font-size:14px;margin-top:1px">${escapeHtml(currentUser)}</div></div>
          <div><span style="color:#9CA3AF;font-size:10px;text-transform:uppercase;letter-spacing:.04em;font-weight:600">Login email</span><div style="color:#0B2545;margin-top:1px">${escapeHtml(adv.email)||'—'}</div></div>
          <div><span style="color:#9CA3AF;font-size:10px;text-transform:uppercase;letter-spacing:.04em;font-weight:600">Commission structure</span><div style="color:#0B2545;margin-top:2px;display:flex;gap:5px;flex-wrap:wrap;align-items:center">
            <span style="background:#DBEAFE;color:#1D4ED8;font-size:11px;font-weight:700;padding:2px 8px;border-radius:10px">${adv.category==='EXCOMM'?'80%':'50%'} · ${escapeHtml(adv.rank||adv.category||'WP')}</span>
            ${adv.category==='EXCOMM'?'<span style="background:#FEF3C7;color:#92400E;font-size:11px;font-weight:700;padding:2px 8px;border-radius:10px">+ 20% overriding</span>':''}
          </div></div>
          <div style="margin-left:auto;display:flex;align-items:center"><button onclick="changeMyPassword()" style="background:#fff;color:#0B2545;border:1.5px solid #0B2545;border-radius:7px;padding:6px 13px;font-size:12px;font-weight:600;cursor:pointer">🔑 Change password</button></div>
        </div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px 16px;font-size:13px">
          <div><div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;font-weight:600">iFAST · CMSRL</div><div style="color:#6B7280;padding:7px 0">${escapeHtml(adv.ifast)||'—'} · ${escapeHtml(adv.cmsrl)||'—'}</div></div>
          <div><div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;font-weight:600">Notification email <span style="font-weight:400;font-size:9px">(receives alerts &amp; password resets)</span></div><input id="md-pemail" value="${escapeHtml(adv.personalEmail)}" style="width:100%;margin-top:3px;padding:8px 10px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px;box-sizing:border-box"></div>
          <div><div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;font-weight:600">Contact number</div><input id="md-phone" value="${escapeHtml(adv.phone)}" placeholder="+60…" style="width:100%;margin-top:3px;padding:8px 10px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px;box-sizing:border-box"></div>
          <div><div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;font-weight:600">Bank name</div><input id="md-bankname" value="${escapeHtml(adv.bankName)}" placeholder="e.g. Maybank" style="width:100%;margin-top:3px;padding:8px 10px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px;box-sizing:border-box"></div>
          <div><div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;font-weight:600">Bank account no.</div><input id="md-bankacc" value="${escapeHtml(adv.bankAccount)}" style="width:100%;margin-top:3px;padding:8px 10px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px;box-sizing:border-box"></div>
          <div style="grid-column:1/-1"><div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;font-weight:600">Mailing address</div><textarea id="md-addr" rows="2" style="width:100%;margin-top:3px;padding:8px 10px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px;box-sizing:border-box;resize:vertical">${escapeHtml(adv.mailingAddress)}</textarea></div>
        </div>
        <div style="margin-top:12px;display:flex;align-items:center;gap:12px">
          <button onclick="saveMyDetails()" id="md-save-btn" style="background:#0B2545;color:#fff;border:none;border-radius:9px;padding:9px 18px;font-size:13px;font-weight:700;cursor:pointer">💾 Save my details</button>
          <span id="md-msg" style="font-size:12px"></span>
        </div>
      </div>` : ''}

      ${(!isAdmin && !isChecker) ? `<div id="onboarding-card" style="margin-bottom:18px"></div><img src="x" onerror="this.remove();window.loadOnboarding&&loadOnboarding()" style="display:none">` : ''}

      <div class="stats-grid" style="grid-template-columns:repeat(4,1fr);">
        <div class="stat-card">
          <span class="icon">📈</span>
          <div class="label">YTD ${dispYear} (Jan–${mtdLabel})</div>
          <div class="value">${fmt(ytdPayout)}</div>
          ${chg(ytdPayout, lytdPayout)}
          <div style="font-size:10px;color:#9CA3AF;">${dispYear}</div>
          <div class="sub">Revenue: ${fmt(ytdRevenue)}</div>
        </div>
        <div class="stat-card">
          <span class="icon">📅</span>
          <div class="label">MTD — ${mtdLabel}</div>
          <div class="value">${fmt(mtdPayout)}</div>
          ${chgM(mtdPayout, lmtdPayout)}
          <div class="sub">Revenue: ${fmt(mtdRevenue)}</div>
        </div>
        <div class="stat-card">
          <span class="icon">📊</span>
          <div class="label">LYTD ${prevYear} (Jan–${lmtdLabel})</div>
          <div class="value">${fmt(lytdPayout)}</div>
          <div class="sub">Revenue: ${fmt(lytdRevenue)}</div>
        </div>
        <div class="stat-card">
          <span class="icon">🗓️</span>
          <div class="label">LMTD — ${lmtdLabel}</div>
          <div class="value">${fmt(lmtdPayout)}</div>
          <div class="sub">Revenue: ${fmt(lmtdRevenue)}</div>
        </div>
      </div>
      </div>

      <!-- Display Name Setting -->
      <div style="background:#fff;border-radius:12px;box-shadow:0 2px 12px rgba(0,0,0,0.07);padding:18px 24px;margin:0 0 24px 0;">
        <div style="font-size:14px;font-weight:700;color:#0B2545;margin-bottom:4px;">👤 Display Name</div>
        <div style="font-size:12px;color:#6B7280;margin-bottom:12px;">Customise the name shown in your welcome greeting.</div>
        <div style="display:flex;gap:10px;align-items:center;">
          <input id="display-name-input" type="text" value="${escapeHtml(adv.displayName || adv.name.split(' ')[0])}"
            placeholder="Enter preferred name"
            style="flex:1;max-width:280px;padding:8px 12px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;font-family:'DM Sans',sans-serif;outline:none;color:#0B2545;"/>
          <button onclick="saveDisplayName()"
            style="padding:8px 18px;background:#0B2545;color:#fff;border:none;border-radius:8px;font-size:13px;font-weight:600;cursor:pointer;">
            Save
          </button>
          <span id="display-name-msg" style="font-size:12px;color:#166534;"></span>
        </div>
      </div>

      <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:16px;"><div class="section-title" style="margin:0;">Statement History</div>${yearSelector}</div>
      ${buildStmtTable(stmts, dispYear)}
    </div>`;
}

// Normalize a statement's overriding field → {total, lines[]}. Accepts the new array form
// (line items with from_name/type/rate/amount), a JSON string of it (API GET returns a string),
// or the legacy number form. lines[] drives the per-source breakdown display.
function _ovrLines(s){
  var o = s && s.overridings;
  if (typeof o === 'string') { try { o = JSON.parse(o); } catch(e) { o = []; } }
  if (Array.isArray(o)) return { total: o.reduce(function(a,x){ return a + (x.amount||0); }, 0), lines: o };
  if (typeof o === 'number' && o > 0) return { total: o, lines: [{ type:'Overriding', amount:o }] };
  return { total: 0, lines: [] };
}
function buildStmtTable(stmts, dispYear) {
  // §MIN_PAYOUT — advisers see a statement only once it is PUBLISHED (after
  // finance pays, or at month approval for an all-carried month). 'Pending'
  // months are still in the admin pipeline and stay invisible here.
  if (typeof isAdmin === "undefined" || !isAdmin) stmts = stmts.filter(function(s){ return s.status === "Paid" || s.status === "Carried" || s.status === "Accrued"; });
  var filteredStmts = stmts.filter(function(s){ return parseInt((s.period||"").split(" ")[1]||"0") === dispYear; });
  filteredStmts.sort(function(a,b){ return new Date("01 "+b.period) - new Date("01 "+a.period); });
  if (filteredStmts.length === 0) return '<div class="empty-state"><div class="icon">&#128237;</div><p>No statements for ' + dispYear + ' yet.</p></div>';
  var rows = filteredStmts.map(function(s) {
    var idx = stmts.indexOf(s);
    // §ACCRUED — OWNER RULING 18 September 2026, verbatim "yes" / "chaneg to accrued".
    // The owner earns commission and does not draw it; it accrues to his director's
    // account instead. Without its own branch an 'Accrued' statement fell through to
    // "Pending", which reads as money still due to go OUT — the opposite of the truth.
    var badge = s.status === 'Paid' ? '<span class="status-badge paid">&#10003; Paid</span>'
      : s.status === 'Accrued' ? '<span class="status-badge pending" style="background:#FAF3DC;color:#8A6D1F;">&#9878; Accrued &mdash; not drawn</span>'
      : s.status === 'Carried' ? '<span class="status-badge pending" style="background:#FEF3C7;color:#92400E;">&#8635; Carried forward</span>'
      : '<span class="status-badge pending">&#9203; Pending</span>';
    if (s.status === 'Carried') badge += '<div style="font-size:10px;color:#92400E;margin-top:3px;">Below RM50 &mdash; pays with next month</div>';
    var personalPayout = s.personal_payout || 0;
    var ovr            = _ovrLines(s);
    var totalPayout    = (s.total_payout != null) ? s.total_payout : (personalPayout + ovr.total);
    var commBreakdown = '<div style="font-size:13px;font-weight:700;color:#166534;">MYR ' + totalPayout.toLocaleString('en-MY',{minimumFractionDigits:2}) + '</div>';
    commBreakdown += '<div style="font-size:10px;color:#374151;margin-top:3px;line-height:1.7;">';
    commBreakdown += '&#8627; Personal: <b>MYR ' + personalPayout.toLocaleString('en-MY',{minimumFractionDigits:2}) + '</b> <span style="color:#9CA3AF;">(' + (s.personal_rate*100).toFixed(0) + '% &middot; ' + s.rank + ')</span>';
    ovr.lines.forEach(function(l){
      var lbl = (l.type || 'Overriding') + (l.from_name ? ' &larr; ' + l.from_name : '');
      var rt  = l.rate ? ' <span style="color:#9CA3AF;">(' + (l.rate*100).toFixed(0) + '%)</span>' : '';
      commBreakdown += '<br>&#8627; ' + lbl + ': <b>MYR ' + (l.amount||0).toLocaleString('en-MY',{minimumFractionDigits:2}) + '</b>' + rt;
    });
    // §MIN_PAYOUT — show the carry maths: balance brought in from earlier months,
    // and either the total actually paid (this month + carried-in) or the amount rolling on.
    if ((s.carried_in||0) > 0) commBreakdown += '<br>&#8627; Carried in from previous month: <b>MYR ' + s.carried_in.toLocaleString('en-MY',{minimumFractionDigits:2}) + '</b>';
    // §ADJUST — a correction to earlier months is its OWN line, never folded
    // silently into the total: the adviser must be able to see why the figure moved.
    if (Math.abs(s.adjustment_amount||0) > 0.005) {
      var _adjUp = (s.adjustment_amount||0) > 0;
      commBreakdown += '<br><span style="color:' + (_adjUp ? '#166534' : '#92400E') + ';font-weight:700;">&#8627; '
        + (_adjUp ? 'Adjustment for earlier months (underpaid)' : 'Adjustment for earlier months (overpaid)')
        + ': MYR ' + (s.adjustment_amount||0).toLocaleString('en-MY',{minimumFractionDigits:2}) + '</span>';
    }
    if (s.reconciled_in) commBreakdown += '<br><span style="color:#64748B;">&#8627; This month was re-checked; the difference was settled in a later month.</span>';
    if (s.status === 'Paid' && (s.carried_in||0) > 0 && (s.paid_amount||0) > 0) commBreakdown += '<br><span style="color:#166534;font-weight:700;">&#8627; Total paid: MYR ' + s.paid_amount.toLocaleString('en-MY',{minimumFractionDigits:2}) + '</span>';
    if (s.status === 'Carried') commBreakdown += '<br><span style="color:#92400E;font-weight:700;">&#8627; Carried to next month: MYR ' + (s.carried_out||0).toLocaleString('en-MY',{minimumFractionDigits:2}) + '</span>';
    // §ROUNDS — paid once, regenerated with more: say what is paid and what is still coming.
    var _owed = ((s.total_payout||0)+(s.carried_in||0)+(s.adjustment_amount||0)) - (s.settled_amount||0);
    if (s.status === 'Paid' && !s.reconciled_in && (s.settled_amount||0) > 0 && _owed > 0.005) {
      commBreakdown += '<br><span style="color:#166534;font-weight:700;">&#8627; Paid so far: MYR ' + (s.settled_amount||0).toLocaleString('en-MY',{minimumFractionDigits:2}) + '</span>'
        + '<br><span style="color:#92400E;font-weight:700;">&#8627; Pending payment: MYR ' + _owed.toLocaleString('en-MY',{minimumFractionDigits:2}) + '</span>';
    }
    commBreakdown += '</div>';
    var revenueCell = '<div style="font-size:12px;color:#6B7280;">MYR ' + s.ifast_comm.toLocaleString('en-MY',{minimumFractionDigits:2}) + '</div>'
      + '<div style="font-size:10px;color:#9CA3AF;margin-top:2px;">Production points</div>';
    return '<tr>'
      + '<td class="period-cell">' + s.period + '</td>'
      + '<td style="font-size:12px;color:#6B7280;">' + s.date + '</td>'
      + '<td>' + commBreakdown + '</td>'
      + '<td>' + revenueCell + '</td>'
      + '<td>' + badge + '</td>'
      + '<td><button class="view-btn" onclick="viewStatement(' + idx + ')">View &#8594;</button></td>'
      + '</tr>';
  }).join('');
  return '<table class="statements-table"><thead><tr><th>Period</th><th>Statement Date</th><th>Commission Income</th><th>Revenue (Production)</th><th>Status</th><th></th></tr></thead><tbody>'+rows+'</tbody></table>';
}
function renderStatements() {
  var stmts = STATEMENTS[currentUser] || [];
  var mc = document.getElementById("main-content");
  if (stmts.length === 0) {
    mc.innerHTML = '<div class="fade-in"><div class="section-title">Commission Statements</div><div class="empty-state"><div class="icon">📭</div><p>No statements available yet.</p></div></div>';
    return;
  }
  var years = [];
  stmts.forEach(function(s){ var y=parseInt((s.period||'').split(' ')[1]||'0'); if(y&&years.indexOf(y)===-1) years.push(y); });
  years.sort(function(a,b){ return b-a; });
  var selYear = years[0];
  mc.innerHTML = '<div class="fade-in"><div class="section-title">Commission Statements</div><div id="stmts-year-tabs" style="display:flex;gap:8px;margin-bottom:20px;flex-wrap:wrap"></div><div id="stmts-table-wrap"></div></div>';
  var monthOrd = {Jan:1,Feb:2,Mar:3,Apr:4,May:5,Jun:6,Jul:7,Aug:8,Sep:9,Oct:10,Nov:11,Dec:12};
  function renderTabs(active){
    document.getElementById('stmts-year-tabs').innerHTML = years.map(function(y){
      var on=y===active;
      return '<button onclick="_stmtsYear('+y+')" style="padding:8px 22px;border-radius:8px;border:1.5px solid '+(on?'#0B2545':'#E2E8F0')+';background:'+(on?'#0B2545':'#fff')+';color:'+(on?'#fff':'#64748B')+';font-size:14px;font-weight:'+(on?'700':'500')+';cursor:pointer">'+y+'</button>';
    }).join('');
  }
  function renderTable(year){
    var f=stmts.filter(function(s){ return (s.status==='Paid'||s.status==='Carried'||s.status==='Accrued') && parseInt((s.period||'').split(' ')[1]||'0')===year; });
    f.sort(function(a,b){ return (monthOrd[(a.period||'').split(' ')[0]]||0)-(monthOrd[(b.period||'').split(' ')[0]]||0); });
    if(!f.length){ document.getElementById('stmts-table-wrap').innerHTML='<div class="empty-state"><div class="icon">📭</div><p>No statements for '+year+' yet.</p></div>'; return; }
    var rows=f.map(function(s){
      var i=stmts.indexOf(s);
      // §ACCRUED — the yearly table's own badge. Four sites render this badge and a
      // status with no branch falls through to "Pending" at every one of them.
      var badge=s.status==='Paid'?'<span class="status-badge paid">✓ Paid</span>'
        :s.status==='Accrued'?'<span class="status-badge pending" style="background:#FAF3DC;color:#8A6D1F;">⚖ Accrued — not drawn</span>'
        :s.status==='Carried'?'<span class="status-badge pending" style="background:#FEF3C7;color:#92400E;">↻ Carried forward</span><div style="font-size:10px;color:#92400E;margin-top:2px;">Below RM50 — pays with next month</div>'
        :'<span class="status-badge pending">⏳ Pending</span>';
      return '<tr>'
        +'<td class="period-cell">'+s.period+'</td>'
        +'<td style="font-size:12px;color:#6B7280">'+s.date+'</td>'
        +'<td><span class="amount navy">MYR '+s.ifast_comm.toLocaleString('en-MY',{minimumFractionDigits:2})+'</span></td>'
        +'<td style="text-align:center;font-size:12px;color:#6B7280">'+(s.personal_rate*100).toFixed(0)+'%</td>'
        +'<td><span class="amount green">MYR '+s.personal_payout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</span></td>'
        +'<td>'+badge+'</td>'
        +'<td><button class="view-btn" onclick="viewStatement('+i+')">View &#8594;</button></td>'
        +'</tr>';
    }).join('');
    document.getElementById('stmts-table-wrap').innerHTML='<table class="statements-table"><thead><tr><th>Period</th><th>Statement Date</th><th>Revenue Earned</th><th>Rate</th><th>Commission Paid</th><th>Status</th><th></th></tr></thead><tbody>'+rows+'</tbody></table>';
  }
  window._stmtsYear=function(y){ selYear=y; renderTabs(y); renderTable(y); };
  renderTabs(selYear);
  renderTable(selYear);
}

function viewStatement(idx, advIdOverride) {
  const uid = advIdOverride || currentUser;
  const s   = STATEMENTS[uid][idx];
  const adv = ADVISERS[uid];
  const _backView = (typeof isAdmin !== "undefined" && isAdmin) ? "upload" : "dashboard";

  // ── Calculate commission breakdown ─────────────────────────────────────────
  const revenue = s.ifast_comm;
  const isEXCOMM = s.rank === "EXCOMM";

  // Personal rate
  const personalRate = s.personal_rate;
  // §NEG-100 / §I2 — READ the stored figure, never re-derive it. The generator is the
  // single source of truth; a screen that recomputes `revenue * rate` disagrees with the
  // statement it is displaying the moment any rule is not a flat multiplication — which
  // is exactly the case on a NEGATIVE month, where the adviser carries 100% and this
  // line would otherwise show half of it. Falls back only for a legacy row that has no
  // stored payout.
  const personalPayout = (s && s.personal_payout !== undefined && s.personal_payout !== null)
    ? +(+s.personal_payout).toFixed(2)
    : +(revenue * personalRate).toFixed(2);

  // Overriding this adviser EARNS from their downlines — stored on the statement by the
  // generator (single source of truth). EXCOMM earns it too, same as VP.
  const ovr = _ovrLines(s);
  const earnedOvr = +ovr.total.toFixed(2);
  const totalPaidOut = (s.total_payout != null) ? s.total_payout : +(personalPayout + earnedOvr).toFixed(2);
  // (The firm's share is not rendered on the agent's statement — see below.)

  // Tier badge info
  let tierBadge = "";
  if (isEXCOMM) {
    tierBadge = `<span style="background:#F5EDD4;color:#92400E;padding:2px 10px;border-radius:20px;font-size:11px;font-weight:700;">EXCOMM — Fixed 80%</span>`;
  } else {
    const tier = getWPTier(s.ytd_revenue || revenue);
    tierBadge = `<span style="background:#DCFCE7;color:#166534;padding:2px 10px;border-radius:20px;font-size:11px;font-weight:700;">${tier.rank} — ${(tier.rate*100).toFixed(0)}% tier</span>`;
  }

  // Group transactions by type
  const byType = {};
  s.transactions.forEach(t => {
    byType[t.type] = byType[t.type] || [];
    byType[t.type].push(t);
  });

  const txnSection = Object.entries(byType).map(([type, txns]) => {
    const typeRevenue = txns.reduce((a,t) => a + t.ifast_comm, 0);
    const typeComm    = txns.reduce((a,t) => a + t.payout, 0);
    return `
      <div class="detail-section">
        <div class="detail-section-header">
          <span class="title">${type}</span>
          <span class="total">Payout: MYR ${typeComm.toLocaleString('en-MY',{minimumFractionDigits:2})}</span>
        </div>
        <table class="detail-table">
          <thead>
            <tr>
              <th>Date</th><th>Client</th><th>Product / Fund</th>
              <th class="right">iFAST Comm (MYR)</th>
              <th class="right">Commission Paid (MYR)</th>
            </tr>
          </thead>
          <tbody>
            ${txns.map(t => `<tr>
              <td>${t.date}</td>
              <td>${t.client}</td>
              <td>${t.product}</td>
              <td class="right">${t.ifast_comm.toLocaleString('en-MY',{minimumFractionDigits:2})}</td>
              <td class="right green-bold">${t.payout.toLocaleString('en-MY',{minimumFractionDigits:2})}</td>
            </tr>`).join("")}
            <tr style="background:var(--lgold)">
              <td colspan="3"><strong>Subtotal</strong></td>
              <td class="right"><strong>${typeRevenue.toLocaleString('en-MY',{minimumFractionDigits:2})}</strong></td>
              <td class="right green-bold"><strong>${typeComm.toLocaleString('en-MY',{minimumFractionDigits:2})}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>`;
  }).join("") || `<div class="empty-state"><div class="icon">📭</div><p>No transactions with commission this period.</p></div>`;

  // §MIN_PAYOUT — the carry banner sits at the VERY TOP, impossible to miss.
  // Carried month: no payment, whole balance rolls on. Paid month with a carry-in:
  // show that this payment = this month + the brought-forward balance.
  let carryBanner = "";
  if (s.status === "Carried") {
    carryBanner = `<div style="background:#FEF3C7;border:1.5px solid #F59E0B;border-radius:12px;padding:16px 20px;margin-bottom:20px;">
      <div style="font-size:15px;font-weight:800;color:#92400E;">&#8635; No payment this month — carried forward</div>
      <div style="font-size:12.5px;color:#92400E;margin-top:5px;line-height:1.6;">Your ${escapeHtml(s.period)} commission${(s.carried_in||0)>0?` (incl. MYR ${(s.carried_in).toLocaleString('en-MY',{minimumFractionDigits:2})} brought forward)`:``} totals <b>MYR ${(((s.total_payout||0)+(s.carried_in||0))).toLocaleString('en-MY',{minimumFractionDigits:2})}</b> — below the RM50 minimum payout. It is carried forward and will be paid together with your next month's commission once the total reaches RM50.</div>
      <div style="font-size:12px;color:#92400E;margin-top:6px;">Carried to next month: <b>MYR ${(s.carried_out||0).toLocaleString('en-MY',{minimumFractionDigits:2})}</b></div>
    </div>`;
  } else if (s.status === "Paid" && (s.carried_in||0) > 0) {
    carryBanner = `<div style="background:#DCFCE7;border:1.5px solid #16A34A;border-radius:12px;padding:14px 20px;margin-bottom:20px;">
      <div style="font-size:14px;font-weight:800;color:#166534;">&#10003; This payment includes your carried-forward balance</div>
      <div style="font-size:12.5px;color:#166534;margin-top:4px;line-height:1.6;">${escapeHtml(s.period)} commission MYR ${(s.total_payout||0).toLocaleString('en-MY',{minimumFractionDigits:2})} + carried in from previous month MYR ${(s.carried_in).toLocaleString('en-MY',{minimumFractionDigits:2})} = <b>Total paid MYR ${(s.paid_amount||0).toLocaleString('en-MY',{minimumFractionDigits:2})}</b></div>
    </div>`;
  }
  document.getElementById("main-content").innerHTML = `
    <div class="fade-in" style="padding:28px 32px;max-width:1000px;">
      <button class="back-btn" onclick="showView('${_backView}')">← Back</button>
      ${carryBanner}
      <!-- Statement Header -->
      <div class="statement-header" style="margin-bottom:24px;">
        <div>
          <h2>${escapeHtml(adv.name)}</h2>
          <div style="font-size:12px;color:rgba(255,255,255,0.45);margin-top:4px">
            ${uid} · ${escapeHtml(adv.ifast)} · Generated ${s.date}
          </div>
        </div>
        <span class="period-tag">${s.period}</span>
      </div>

      <!-- Summary Cards Row -->
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:16px;margin-bottom:24px;">
        <div style="background:#fff;border-radius:12px;padding:20px;box-shadow:0 2px 12px rgba(0,0,0,0.07);">
          <div style="font-size:11px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:6px;">Revenue Earned</div>
          <div style="font-size:24px;font-weight:700;color:#0B2545;">MYR ${revenue.toLocaleString('en-MY',{minimumFractionDigits:2})}</div>
          <div style="margin-top:8px;">${tierBadge}</div>
        </div>
        <div style="background:#fff;border-radius:12px;padding:20px;box-shadow:0 2px 12px rgba(0,0,0,0.07);">
          <div style="font-size:11px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:6px;">Personal Rate</div>
          <div style="font-size:24px;font-weight:700;color:#0B2545;">${(personalRate*100).toFixed(0)}%</div>
          <div style="font-size:11px;color:#9CA3AF;margin-top:4px;">${escapeHtml(s.rank)}</div>
        </div>
        <div style="background:linear-gradient(135deg,#0B2545,#1a3a6b);border-radius:12px;padding:20px;box-shadow:0 2px 12px rgba(0,0,0,0.12);">
          <div style="font-size:11px;color:rgba(255,255,255,0.5);text-transform:uppercase;letter-spacing:.05em;margin-bottom:6px;">Your Commission</div>
          <div style="font-size:24px;font-weight:700;color:#B8962E;">MYR ${totalPaidOut.toLocaleString('en-MY',{minimumFractionDigits:2})}</div>
          <div style="font-size:11px;color:rgba(255,255,255,0.4);margin-top:4px;">${earnedOvr > 0 ? 'Personal MYR ' + personalPayout.toLocaleString('en-MY',{minimumFractionDigits:2}) + ' + overriding MYR ' + earnedOvr.toLocaleString('en-MY',{minimumFractionDigits:2}) : 'Statement date: ' + s.date}</div>
        </div>
      </div>

      <!-- Full Commission Breakdown -->
      <div style="background:#fff;border-radius:12px;padding:20px 24px;box-shadow:0 2px 12px rgba(0,0,0,0.07);margin-bottom:24px;">
        <div style="font-size:14px;font-weight:700;color:#0B2545;margin-bottom:16px;">💰 Full Commission Breakdown</div>
        <table style="width:100%;font-size:13px;border-collapse:collapse;">

          <!-- Revenue row -->
          <tr style="border-bottom:1px solid #F1F5F9;">
            <td style="padding:10px 0;color:#374151;font-weight:600;">Revenue from iFAST</td>
            <td style="text-align:center;color:#9CA3AF;font-size:11px;"></td>
            <td style="text-align:right;font-weight:700;color:#0B2545;">MYR ${revenue.toLocaleString('en-MY',{minimumFractionDigits:2})}</td>
          </tr>

          <!-- Personal payout row -->
          <tr style="border-bottom:1px solid #F1F5F9;background:#F8FFF8;">
            <td style="padding:10px 0 10px 12px;color:#166534;">
              <b>Your Personal Sales Commission</b>
              <div style="font-size:11px;color:#9CA3AF;margin-top:2px;">${s.rank} — ${(personalRate*100).toFixed(0)}% personal rate</div>
            </td>
            <td style="text-align:center;color:#166534;font-weight:700;">× ${(personalRate*100).toFixed(0)}%</td>
            <td style="text-align:right;font-weight:700;color:#166534;font-size:15px;">MYR ${personalPayout.toLocaleString('en-MY',{minimumFractionDigits:2})}</td>
          </tr>

          <!-- Overriding earned from downlines (one row per source) -->
          ${ovr.lines.map(function(l){ return `
          <tr style="border-bottom:1px solid #F1F5F9;background:#F5F3FF;">
            <td style="padding:10px 0 10px 12px;color:#7C3AED;">
              <b>${l.type || 'Overriding'}${l.from_name ? ' &larr; ' + l.from_name : ''}</b>
              <div style="font-size:11px;color:#9CA3AF;margin-top:2px;">Overriding earned on downline revenue${l.base ? ' (MYR ' + (l.base).toLocaleString('en-MY',{minimumFractionDigits:2}) + ')' : ''}</div>
            </td>
            <td style="text-align:center;color:#7C3AED;font-weight:700;">${l.rate ? '× ' + (l.rate*100).toFixed(0) + '%' : ''}</td>
            <td style="text-align:right;font-weight:700;color:#7C3AED;">MYR ${(l.amount||0).toLocaleString('en-MY',{minimumFractionDigits:2})}</td>
          </tr>`; }).join("")}

          <!-- The firm's share is deliberately NOT shown here. Owner: "no need
               to show firm share in agent statement." The agent's statement
               shows what they EARN; the revenue they GENERATED drives their
               rank elsewhere. The firm's cut is neither, and belongs on
               neither. Still computed, and still shown to admin in
               adminViewStmtDetail. -->

          <!-- Total -->
          <tr>
            <td style="padding:12px 0 4px;font-weight:700;color:#0B2545;">Total Commission Paid Out</td>
            <td></td>
            <td style="text-align:right;font-weight:700;color:#0B2545;font-size:15px;">MYR ${totalPaidOut.toLocaleString('en-MY',{minimumFractionDigits:2})}</td>
          </tr>
        </table>

        ${earnedOvr > 0 ? `
        <div style="margin-top:14px;padding:10px 14px;background:#F8FAFC;border-radius:8px;font-size:11px;color:#6B7280;line-height:1.8;border-left:3px solid #B8962E;">
          <b style="color:#0B2545;">Overriding earned this period:</b> MYR ${earnedOvr.toLocaleString('en-MY',{minimumFractionDigits:2})} on ${ovr.lines.length} downline${ovr.lines.length>1?'s':''} (${ovr.lines.map(function(l){return l.from_name;}).filter(Boolean).join(', ')}).
        </div>` : ""}
      </div>

      <!-- Transaction Detail -->
      <div style="font-size:16px;font-weight:700;color:#0B2545;margin-bottom:14px;">Transaction Detail</div>
      ${txnSection}
    </div>`;
}


// ── COMMISSION PROFILE — one clean source for Tier / Downline / Comm / OR ─────
// iFAST OR: upline EXCOMM/VP earns 20% of downline gross; a Manager in between
// takes 8% and the EXCOMM 12% (total still 20%).
// Will OR (advisor tier): Manager 12% + VP 8%; VP takes both 20% when no
// manager (§10x.2420). Full-pool will tier pays no OR up.
function commProfile(id){
  var adv = ADVISERS[id] || {};
  var cat = adv.category || (adv.rank === 'EXCOMM' ? 'EXCOMM' : 'WP');
  var ytdP = (YTD[id] && YTD[id].ytd_personal) || 0;
  var ifastRate = (cat === 'EXCOMM') ? 80 : Math.round(getWPTier(ytdP).rate * 100);
  var wtier = String(adv.willCommTier || '').toLowerCase();
  var willFull = wtier === 'full' || wtier === 'exco' || wtier === 'vp' || wtier === 'excomm' || (wtier === '' && cat === 'EXCOMM');
  var mgrId = (adv.uplineManager && adv.uplineManager !== 'COMPANY') ? adv.uplineManager : null;
  var vpId  = (adv.uplineVP && adv.uplineVP !== 'COMPANY') ? adv.uplineVP : null;
  if (mgrId && mgrId === vpId) mgrId = null; // same person → single upline
  function nm(x){ return ADVISERS[x] ? ADVISERS[x].name : x; }
  var downs = Object.keys(ADVISERS).filter(function(d){
    var a = ADVISERS[d];
    return a && !a.terminated && d !== id && /^LIFA/.test(d)
      && ((a.uplineManager === id && a.uplineManager !== 'COMPANY') || (a.uplineVP === id && a.uplineVP !== 'COMPANY'));
  });
  var orPayIfast = '', orPayWill = '';
  if (mgrId && vpId)      orPayIfast = '8% → ' + nm(mgrId) + ' · 12% → ' + nm(vpId);
  else if (vpId || mgrId) orPayIfast = '20% → ' + nm(vpId || mgrId);
  if (!willFull) {
    if (mgrId && vpId)      orPayWill = '12% → ' + nm(mgrId) + ' · 8% → ' + nm(vpId);
    else if (vpId || mgrId) orPayWill = '20% → ' + nm(vpId || mgrId);
  }
  return { cat: cat, ifastRate: ifastRate, willFull: willFull, downs: downs,
           mgrId: mgrId, vpId: vpId, orPayIfast: orPayIfast, orPayWill: orPayWill, nm: nm };
}

// Chips used by the profile rows and the hierarchy tree.
function _profChips(prof){
  var chipI = '<span style="background:#DCFCE7;color:#166534;padding:1px 7px;border-radius:9px;font-size:11px;font-weight:700;">iFAST ' + prof.ifastRate + '%</span>';
  var chipW = '<span style="background:#EDE9FE;color:#7C3AED;padding:1px 7px;border-radius:9px;font-size:11px;font-weight:700;">' + (prof.willFull ? 'Will 70% full' : 'Will 50%') + '</span>';
  return chipI + ' ' + chipW;
}

// The 4 clean rows shown in the adviser list "details" expansion.
function commProfileRows(id){
  var prof = commProfile(id);
  function row(l, v){
    return '<div style="display:flex;gap:8px;margin-top:6px;">'
      + '<div style="width:70px;flex-shrink:0;font-size:9px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;padding-top:2px;">' + l + '</div>'
      + '<div style="font-size:12px;color:#0B2545;line-height:1.5;">' + v + '</div></div>';
  }
  var downNames = prof.downs.map(prof.nm).join(', ') || '<span style="color:#9CA3AF;">None</span>';
  var comm = 'Keeps <b>' + prof.ifastRate + '%</b> of own iFAST · <b>' + (prof.willFull ? '70%' : '50%') + '</b> of own will fees';
  var earns = prof.downs.length
    ? '<b style="color:#166534;">Earns:</b> 20% OR on ' + prof.downs.map(prof.nm).join(', ')
    : '<b style="color:#9CA3AF;">Earns:</b> <span style="color:#9CA3AF;">nothing</span>';
  var pays = prof.orPayIfast
    ? '<b style="color:#92400E;">Pays up:</b> iFAST ' + prof.orPayIfast + (prof.orPayWill ? ' &nbsp;·&nbsp; Will ' + prof.orPayWill : '')
    : '<b style="color:#9CA3AF;">Pays up:</b> <span style="color:#9CA3AF;">nobody — LIFA keeps the balance</span>';
  return row('Tier', _profChips(prof))
       + row('Downline', downNames)
       + row('Comm', comm)
       + row('OR', earns + '<br>' + pays);
}

// ── TEAM HIERARCHY TREE — whole structure at a glance ────────────────────────
function renderHierarchyMatrix(){
  var ids = Object.keys(ADVISERS).filter(function(id){
    var a = ADVISERS[id]; return a && !a.terminated && /^LIFA/.test(id);
  }).sort();
  var placed = {};
  function childrenOf(pid){
    return ids.filter(function(d){
      var a = ADVISERS[d];
      var mgr = (a.uplineManager && a.uplineManager !== 'COMPANY') ? a.uplineManager : null;
      var vp  = (a.uplineVP && a.uplineVP !== 'COMPANY') ? a.uplineVP : null;
      return (mgr || vp) === pid; // immediate upline: manager if present, else VP
    });
  }
  function node(id, depth){
    placed[id] = true;
    var a = ADVISERS[id], prof = commProfile(id);
    var rankChip = (prof.cat === 'EXCOMM')
      ? '<span style="background:#F5EDD4;color:#92400E;padding:1px 7px;border-radius:9px;font-size:11px;font-weight:700;">EXCOMM</span>'
      : '<span style="background:#F1F5F9;color:#374151;padding:1px 7px;border-radius:9px;font-size:11px;font-weight:700;">' + escapeHtml(a.rank || 'WP') + '</span>';
    var orLine = prof.orPayIfast
      ? '<div style="font-size:11px;color:#6B7280;margin-top:2px;">OR on their sales: <b style="color:#92400E;">iFAST ' + prof.orPayIfast + '</b>' + (prof.orPayWill ? ' &nbsp;·&nbsp; <b style="color:#7C3AED;">Will ' + prof.orPayWill + '</b>' : '') + '</div>'
      : '';
    var guide = depth > 0 ? '<span style="color:#CBD5E1;font-weight:400;">' + Array(depth).join('&nbsp;&nbsp;&nbsp;&nbsp;') + '└─ </span>' : '';
    var h = '<div style="padding:8px 12px;border-bottom:1px solid #F1F5F9;">'
      + '<div style="font-size:13px;">' + guide + '<b style="color:#0B2545;">' + escapeHtml(a.name) + '</b> &nbsp;' + rankChip + ' ' + _profChips(prof) + '</div>'
      + (orLine ? '<div style="padding-left:' + (depth * 30 + (depth ? 22 : 0)) + 'px;">' + orLine + '</div>' : '')
      + '</div>';
    childrenOf(id).forEach(function(c){ if (!placed[c]) h += node(c, depth + 1); });
    return h;
  }
  // Roots: EXCOMM advisers (top of structure)
  var html = '';
  ids.forEach(function(id){
    var a = ADVISERS[id];
    if ((a.category === 'EXCOMM' || a.rank === 'EXCOMM') && !placed[id]) html += node(id, 0);
  });
  // Independents: everyone left without an upline in the tree
  var indep = ids.filter(function(id){ return !placed[id]; });
  if (indep.length) {
    html += '<div style="padding:10px 12px 4px;font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;font-weight:700;">Independent — no upline, LIFA keeps the OR share</div>';
    indep.forEach(function(id){ html += node(id, 0); });
  }
  return '<div style="background:#fff;border:1px solid #E2E8F0;border-radius:10px;overflow:hidden;">' + html + '</div>';
}

// ── STAFF ACCESS — owner sets which areas each staff login can use ────────────
var STAFF_AREAS = [
  {k:'all',        l:'ALL — everything below'},
  {k:'commission', l:'💸 Commission / Monthly Close'},
  {k:'kyc',        l:'🪪 Client KYC (CSD)'},
  {k:'licensing',  l:'🎓 Licensing'},
  {k:'compliance', l:'🛡️ Compliance'},
  {k:'cpe',        l:'📚 CPE hours'},
  {k:'leave',      l:'🏖️ Leave & Benefits'},
  {k:'csd',        l:'🗂️ CSD (AIA)'},
  {k:'academy',    l:'📚 Academy'},
];
function renderStaffAccess(){
  var staff = Object.keys(ADVISERS).filter(function(id){
    var a=ADVISERS[id]; return a && !a.terminated && (a.role==='checker'||a.role==='licensing');
  });
  if(!staff.length) return '<div style="font-size:12px;color:#94A3B8">No staff accounts yet.</div>';
  return '<div style="font-size:12px;color:#6B7280;margin-bottom:12px">Tick what each staff member can use — it controls their sidebar here AND their tiles on admin.lifa.com.my. A new staff account sees nothing until you tick it.</div>'
    + staff.map(function(id){
      var a=ADVISERS[id]; var p=String(a.perms||'').toLowerCase();
      var hasP=function(k){ return p==='all' ? k==='all' : p.split(',').map(function(s){return s.trim();}).indexOf(k)>=0; };
      return '<div style="background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:12px 16px;margin-bottom:10px">'
        + '<div style="font-weight:700;color:#0B2545;margin-bottom:8px">'+escapeHtml(a.name||id)+' <span style="font-size:11px;color:#9CA3AF;font-weight:400">'+escapeHtml(a.email||'')+'</span></div>'
        + '<div style="display:flex;gap:14px;flex-wrap:wrap">'
        + STAFF_AREAS.map(function(ar){
            return '<label style="font-size:12px;display:flex;align-items:center;gap:5px;cursor:pointer'+(ar.k==='all'?';font-weight:700':'')+'">'
              + '<input type="checkbox" data-staff="'+id+'" data-area="'+ar.k+'" '+(hasP(ar.k)||(p==='all'&&ar.k!=='all'&&false)?'checked':'')+(p==='all'&&ar.k!=='all'?' disabled':'')
              + ' onchange="staffPermChanged(\''+id+'\')">'+ar.l+'</label>';
          }).join('')
        + '</div></div>';
    }).join('');
}
async function staffPermChanged(id){
  var boxes=[].slice.call(document.querySelectorAll('input[data-staff="'+id+'"]'));
  var ticked=boxes.filter(function(b){return b.checked;}).map(function(b){return b.dataset.area;});
  var perms = ticked.indexOf('all')>=0 ? 'all' : ticked.join(',');
  try{
    var r=await apiPost('/api/advisers/'+id+'/perms',{perms:perms});
    if(r&&r.error) throw new Error(r.error);
    if(ADVISERS[id]) ADVISERS[id].perms=r.perms||perms;
    showToast('success','Access updated — '+(ADVISERS[id]?ADVISERS[id].name:id)+': '+((r.perms||perms)||'nothing'));
    renderAdminPanel();
  }catch(e){ showToast('error', e.message||'Could not save access'); }
}

// ── ADMIN PANEL ────────────────────────────────────────────────────────────────
// Format the login status for an adviser row (real tracking from last_login_at).
function fmtLoginCell(adv) {
  function fmtD(ts){ return new Date(ts*1000).toLocaleString('en-MY',{timeZone:'Asia/Kuala_Lumpur',day:'2-digit',month:'short',year:'numeric'}); }
  if (adv && adv.lastLoginAt) {
    var d = new Date(adv.lastLoginAt * 1000);
    var when = d.toLocaleString('en-MY', {timeZone:'Asia/Kuala_Lumpur', day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit'});
    var times = (adv.loginCount && adv.loginCount > 1) ? ' · ' + adv.loginCount + '× logins' : '';
    return '<div style="color:#166534;font-weight:700;">&#9989; Registered' + (adv.firstLoginAt ? ' ' + fmtD(adv.firstLoginAt) : '') + '</div>'
         + '<div style="color:#166534;">&#128994; Last login: ' + when + times + '</div>';
  }
  return '<span style="color:#B45309;font-weight:600;">&#9888;&#65039; Not registered &mdash; never logged in</span>';
}

// Expand/collapse one adviser's full commission breakdown in the Admin Panel.
function toggleCommDetail(id){
  var d = document.getElementById('commdetail-' + id);
  var t = document.getElementById('commtog-' + id);
  if(!d) return;
  var open = d.style.display === 'none';
  d.style.display = open ? 'block' : 'none';
  if(t) t.innerHTML = open ? '&#9662; hide details' : '&#9656; details';
}

// One ⋯ menu per adviser row (replaces the old 6-button strip). Click-away closes it.
// The menu is re-homed to <body> with position:fixed — inside the table it gets CLIPPED
// by the wrapper's overflow:hidden (bottom rows' menus were invisible = "not responding").
// ✉️ ONE ADVISER, ONE MESSAGE. The only adviser email that existed sent a
// PASSWORD RESET TO EVERY ADVISER — using it to ask one person for their bank
// details would have reset ten passwords and mailed nine uninvolved people.
// Sends from the firm address (support@lifa.com.my); replies come back to the
// firm inbox. Every send is logged like any automated one.
// 🏦 BANK DETAILS AN ADVISER SENT IN — read from their reply, saved by you.
// Shows the number they TYPED beside the number read from their statement
// header. Agreement between two independent sources is the corroboration that
// makes this safe to accept; disagreement is the single most useful thing the
// scan can tell you, so it is shown loudly and never resolved automatically.
async function bankSuggLoad(){
  var box=document.getElementById('bank-sugg'); if(!box) return;
  var rows; try{ rows=await apiGet('/api/bank-suggestions'); }catch(e){ return; }
  if(!Array.isArray(rows) || !rows.length){ box.innerHTML=''; return; }
  window._bankSugg=rows;
  box.innerHTML='<div style="background:#FFFBEB;border:1px solid #FCD34D;border-radius:12px;padding:16px;margin-bottom:20px">'
    +'<div style="font-weight:700;color:#92400E">&#127974; '+rows.length+' adviser'+(rows.length===1?'':'s')+' sent bank details &mdash; check and save</div>'
    +'<div style="color:#92400E;font-size:12px;margin:4px 0 10px">Nothing is saved until you press Save. Correct anything that looks wrong first.</div>'
    +rows.map(function(r,i){
      var agree = r.agrees===1 ? '<span style="color:#166534;font-weight:700">&#10003; typed number matches the statement</span>'
                : r.agrees===0 ? '<span style="color:#B91C1C;font-weight:700">&#9888; TYPED '+escapeHtml(r.typed_account||'')+' does NOT match the statement</span>'
                : '<span style="color:#92400E">no typed number to compare</span>';
      var nm = r.name_matches ? '<span style="color:#166534">name matches</span>'
                              : '<span style="color:#B45309">account name '+escapeHtml(r.account_holder||'not read')+'</span>';
      return '<div style="background:#fff;border-radius:8px;padding:12px 14px;margin-top:8px">'
        +'<div style="font-weight:700;color:#0B2545">'+escapeHtml(r.adviser_name||r.adviser_id)+'</div>'
        +'<div style="font-size:12px;color:#6B7280;margin:2px 0 8px">'+agree+' &middot; '+nm
          +' &middot; read confidence '+escapeHtml(r.confidence||'?')+'</div>'
        +'<div style="display:flex;gap:8px;flex-wrap:wrap">'
          +'<input id="_bsBank'+i+'" value="'+escapeHtml(r.bank_name||r.typed_bank||'')+'" placeholder="Bank" style="flex:1;min-width:130px;padding:8px;border:1px solid #D1D5DB;border-radius:7px;font-size:13px">'
          +'<input id="_bsAcct'+i+'" value="'+escapeHtml(r.account_number||r.typed_account||'')+'" placeholder="Account number" style="flex:1;min-width:150px;padding:8px;border:1px solid #D1D5DB;border-radius:7px;font-size:13px;font-family:ui-monospace,monospace">'
        +'</div>'
        +(r.notes?'<div style="font-size:11.5px;color:#B45309;margin-top:6px">'+escapeHtml(r.notes)+'</div>':'')
        +'<div style="margin-top:9px;display:flex;gap:8px">'
          +'<button onclick="bankSuggSave('+r.id+','+i+')" class="mini-btn" style="background:#0B2545;color:#fff">Save to '+escapeHtml((r.adviser_name||'').split(' ')[0]||'adviser')+'</button>'
          +'<button onclick="bankSuggDismiss('+r.id+')" class="mini-btn">Not this</button>'
        +'</div></div>';
    }).join('')+'</div>';
}
async function bankSuggSave(id, i){
  var bank=document.getElementById('_bsBank'+i).value.trim();
  var acct=document.getElementById('_bsAcct'+i).value.replace(/[\s-]/g,'').trim();
  if(!bank){ showToast('warn','Bank name is needed.'); return; }
  if(!/^\d{8,20}$/.test(acct)){ showToast('warn','Account number must be 8-20 digits.'); return; }
  if(!confirm('Save this account for payment?\n\n'+bank+'  '+acct+'\n\nCommission will be paid to it.')) return;
  var r=await apiPost('/api/bank-suggestions/'+id+'/save',{bank_name:bank, account_number:acct});
  if(r&&r.error){ showToast('error',r.error); return; }
  showToast('success','Saved.'); bankSuggLoad(); loadAllData && loadAllData();
}
async function bankSuggDismiss(id){
  var r=await apiPost('/api/bank-suggestions/'+id+'/dismiss',{});
  if(r&&r.error){ showToast('error',r.error); return; }
  bankSuggLoad();
}

function emailAdviser(id){
  // ADVISERS is keyed by id, and camelCases its fields — not the raw API shape.
  var adv=(typeof ADVISERS!=='undefined' && ADVISERS[id]) || {};
  var to=String(adv.email||adv.personalEmail||'').trim();
  var name=adv.displayName||adv.name||id;
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(11,37,69,.45);z-index:9500;display:flex;align-items:center;justify-content:center;padding:20px';
  ov.innerHTML='<div style="background:#fff;border-radius:14px;max-width:520px;width:100%;padding:22px;box-shadow:0 18px 50px rgba(11,37,69,.28)">'
    +'<div style="font-weight:700;font-size:17px;color:#0B2545">Email '+escapeHtml(name)+'</div>'
    +'<div style="color:#6B7280;font-size:13px;margin-top:2px">To '+escapeHtml(to||'(no email on file)')
      +' &middot; from support@lifa.com.my &middot; replies come to the firm inbox</div>'
    +'<label style="display:block;font-size:12px;font-weight:600;color:#374151;margin:14px 0 4px">Subject</label>'
    +'<input id="_eaSubj" type="text" placeholder="What the email is about" style="width:100%;padding:9px;border:1px solid #D1D5DB;border-radius:8px;font-size:14px">'
    +'<label style="display:block;font-size:12px;font-weight:600;color:#374151;margin:12px 0 4px">Message</label>'
    +'<textarea id="_eaBody" rows="9" placeholder="Write the message as you would type it." style="width:100%;padding:9px;border:1px solid #D1D5DB;border-radius:8px;font-size:14px;font-family:inherit;line-height:1.55;resize:vertical"></textarea>'
    +'<div id="_eaMsg" style="font-size:12.5px;margin-top:8px;min-height:16px"></div>'
    +'<button id="_eaGo" class="mini-btn" style="background:#0B2545;color:#fff;width:100%;margin-top:8px;padding:11px;font-size:15px;font-weight:600">Send</button>'
    +'<button id="_eaX" style="background:none;border:0;color:#6B7280;font-size:13px;cursor:pointer;padding:8px 0 0;width:100%">Cancel</button>'
    +'</div>';
  document.body.appendChild(ov);
  var close=function(){ try{ ov.remove(); }catch(e){} };
  ov.querySelector('#_eaX').onclick=close;
  ov.onclick=function(e){ if(e.target===ov) close(); };
  if(!to){ ov.querySelector('#_eaGo').disabled=true;
    ov.querySelector('#_eaMsg').innerHTML='<span style="color:#B91C1C">No email address on file for this adviser.</span>'; return; }
  ov.querySelector('#_eaGo').onclick=async function(){
    var subj=ov.querySelector('#_eaSubj').value.trim();
    var body=ov.querySelector('#_eaBody').value.trim();
    var msg=ov.querySelector('#_eaMsg');
    if(!subj){ msg.innerHTML='<span style="color:#B91C1C">Give the email a subject.</span>'; return; }
    if(body.length<5){ msg.innerHTML='<span style="color:#B91C1C">Write a message.</span>'; return; }
    this.disabled=true; this.textContent='Sending…';
    var r=await apiPost('/api/advisers/'+id+'/email',{subject:subj, message:body});
    if(r&&r.error){ msg.innerHTML='<span style="color:#B91C1C">'+escapeHtml(r.error)+'</span>';
      this.disabled=false; this.textContent='Send'; return; }
    close(); showToast('success','Sent to '+to);
  };
}

function toggleAdvMenu(ev, id){
  ev.stopPropagation();
  var menu=document.getElementById('advmenu-'+id);
  var open=menu && menu.style.display==='none';
  document.querySelectorAll('[id^="advmenu-"]').forEach(function(m){ m.style.display='none'; });
  if(menu && open){
    var btn=ev.currentTarget||ev.target;
    var r=btn.getBoundingClientRect();
    if(menu.parentNode!==document.body) document.body.appendChild(menu);
    menu.style.position='fixed';
    menu.style.zIndex='9000';
    menu.style.left='auto';
    menu.style.right=(window.innerWidth-r.right)+'px';
    menu.style.display='block';
    var h=menu.offsetHeight||220;
    // open downward, or flip upward when too close to the bottom of the screen
    menu.style.top=(r.bottom+h+8>window.innerHeight ? Math.max(8,r.top-h-6) : r.bottom+6)+'px';
  }
}
document.addEventListener('click', function(){ document.querySelectorAll('[id^="advmenu-"]').forEach(function(m){ m.style.display='none'; }); });

// ─── SC Annual Fee reminder (company compliance) ────────────────────────────
// Lifa Planners is licensed solely for financial planning → a FIXED annual fee
// of RM10,000 (Capital Markets & Services (Fees) Regulations 2025, Sch 3 item 7(g)).
// Two touchpoints a year, shown at the top of the Admin Panel:
//   • July    — submit the 1H Submission Pack (Calculator + signed Declaration)
//               by 30 Jun, then PAY via e-PATH by 31 July.
//   • January — submit the 2H pack by 30 Nov (if required) and PAY the new-year
//               annual fee via e-PATH by 31 January (fixed-fee firms, 2027 onward).
// The banner counts down to the nearest deadline and escalates colour as it nears.
function scAnnualFeeReminder() {
  var EPATH = "https://path.sc.com.my/index.php";
  var now = new Date();
  var MS = 86400000;
  function nextOccur(monthIdx, d) {
    var t = new Date(now.getFullYear(), monthIdx, d, 23, 59, 59);
    if (t < now) t = new Date(now.getFullYear() + 1, monthIdx, d, 23, 59, 59);
    return t;
  }
  var items = [
    { tag: "July",    due: nextOccur(6, 31),
      title: "1H — submit pack &amp; pay annual fee",
      detail: "Submit the 1H Annual Fee Submission Pack (Calculator + signed Declaration) to SCFeeSubmission@seccom.com.my by 30 June, then pay the RM10,000 fee via e-PATH by 31 July." },
    { tag: "January", due: nextOccur(0, 31),
      title: "2H / new-year — submit &amp; pay annual fee",
      detail: "Submit the 2H pack by 30 November (if required) and pay the annual SC fee via e-PATH by 31 January." }
  ];
  items.sort(function(a, b){ return a.due - b.due; });
  var next = items[0], other = items[1];
  var days = Math.ceil((next.due - now) / MS);
  function fmtD(dt){ return dt.toLocaleDateString("en-MY", { timeZone:"Asia/Kuala_Lumpur", day:"2-digit", month:"short", year:"numeric" }); }

  // Escalate colour as the deadline approaches
  var bg = "#EFF6FF", bd = "#BFDBFE", ac = "#1D4ED8", icon = "&#128276;"; // 🔔 calm/info
  if (days <= 30) { bg = "#FEF3C7"; bd = "#F59E0B"; ac = "#92400E"; icon = "&#9200;"; }   // ⏰ due soon
  if (days <= 7)  { bg = "#FEE2E2"; bd = "#EF4444"; ac = "#991B1B"; icon = "&#128680;"; }  // 🚨 urgent

  return '<div style="background:' + bg + ';border:1.5px solid ' + bd + ';border-radius:12px;padding:14px 18px;margin-bottom:20px;">'
    + '<div style="display:flex;align-items:flex-start;gap:12px;">'
    +   '<div style="font-size:20px;line-height:1.2;">' + icon + '</div>'
    +   '<div style="flex:1;min-width:0;">'
    +     '<div style="font-size:14px;font-weight:700;color:' + ac + ';">SC Annual Fee &mdash; ' + next.title
    +       ' <span title="' + escapeHtml(next.detail).replace(/"/g,'&quot;') + '&#10;&#10;Then: ' + other.tag + ' &mdash; due ' + fmtD(other.due) + '.&#10;Lifa Planners is licensed solely for financial planning, so the fee is a fixed RM10,000/year." style="cursor:help;font-weight:400">&#8505;&#65039;</span></div>'
    +     '<div style="font-size:12px;color:' + ac + ';font-weight:700;margin-top:6px;">Due ' + fmtD(next.due) + ' &middot; ' + days + ' day' + (days !== 1 ? 's' : '') + ' left</div>'
    +   '</div>'
    +   '<a href="' + EPATH + '" target="_blank" rel="noopener" style="flex-shrink:0;background:#0B2545;color:#fff;text-decoration:none;border-radius:8px;padding:8px 14px;font-size:12px;font-weight:700;white-space:nowrap;">Pay via e-PATH &rarr;</a>'
    + '</div>'
    + '</div>';
}

// Advisers (one list) and Admin Panel (settings) share this renderer — walkthrough
// approved 29 Oct 2026. _adminMode is set by showView; Active/Terminated is a filter.
var _adminMode = "advisers";
var _advShowTerm = false;
function advRowClick(ev, id){
  if (ev.target.closest('button,a,input,select,.advmenu-item,[id^="advmenu-"],[id^="commdetail-"]')) return;
  adminViewAdviserFolder(id);
}
function renderAdminPanel() {
  var _ro = isChecker;   // staff see the list; adviser actions stay with admins
  var _nActive = 0, _nTerm = 0;
  // Remove any ⋯ menus previously re-homed to <body> — the rebuild creates fresh ones
  // and stale orphans would duplicate IDs.
  document.querySelectorAll('body > [id^="advmenu-"]').forEach(function(m){ m.remove(); });
  var catLabel = {WP:"Wealth Planner", MGR:"Manager", VP:"Vice President", EXCOMM:"EXCOMM"};
  var rows = "";
  var termRows = "";

  // Compute per-adviser YTD/MTD from STATEMENTS (current year, latest uploaded month)
  var currentYr = new Date().getFullYear();
  function calcAdviserStats(advId) {
    var advStmts = (STATEMENTS[advId] || []).filter(function(s){
      return parseInt((s.period||"").split(" ")[1]||"0") === currentYr;
    });
    advStmts.sort(function(a,b){ return new Date("01 "+b.period) - new Date("01 "+a.period); });
    var mtdStmt = advStmts[0] || null;
    var ytdRevenue = advStmts.reduce(function(acc,s){ return acc + (s.ifast_comm||0); }, 0);
    var mtdRevenue = mtdStmt ? (mtdStmt.ifast_comm||0) : 0;
    var mtdLabel  = mtdStmt ? mtdStmt.period.split(" ")[0] : "—";
    return { ytdRevenue: ytdRevenue, mtdRevenue: mtdRevenue, mtdLabel: mtdLabel };
  }

  Object.keys(ADVISERS).forEach(function(id) {
    var adv = ADVISERS[id];
    var cat = adv.category || (adv.rank === "EXCOMM" ? "EXCOMM" : "WP");
    var ytd = YTD[id] || {ytd_personal:0, mtd_personal:0, ytd_direct:0, ytd_district:0};
    var stats = calcAdviserStats(id);
    // Direct-team / district-group YTD computed live from downlines (stored YTD fields aren't maintained).
    var _dir = 0, _dist = 0;
    Object.keys(ADVISERS).forEach(function(did){
      var da = ADVISERS[did]; if (!da || da.terminated || did === id) return;
      var dyp = (YTD[did] && YTD[did].ytd_personal) || 0;
      if (da.uplineManager === id) { _dir += dyp; _dist += dyp; }
      else if (da.uplineVP === id) { _dist += dyp; }
    });
    ytd = Object.assign({}, ytd, {ytd_direct:_dir, ytd_district:_dist});
    // EXCOMM earns overriding like a VP (Gan's rule). Show earning badges only when they actually have a team.

    function rm(n) {
      return "RM" + Number(n).toLocaleString("en-MY", {minimumFractionDigits:2, maximumFractionDigits:2});
    }

    // ── Personal tier badge ──────────────────────────────────────────────────
    var pH;
    if (cat === "EXCOMM") {
      pH = '<span style="background:#F5EDD4;color:#92400E;padding:2px 8px;border-radius:10px;font-size:11px;font-weight:700;">80% — EXCOMM</span>';
    } else {
      var t  = getWPTier(ytd.ytd_personal);
      var nt = null;
      for (var wi = WP_TIERS.length - 1; wi >= 0; wi--) {
        if (WP_TIERS[wi].minRevenue > ytd.ytd_personal) { nt = WP_TIERS[wi]; break; }
      }
      var wgap = nt
        ? ' <span style="font-size:10px;color:#9CA3AF;">RM' + Math.ceil(nt.minRevenue - ytd.ytd_personal).toLocaleString("en-MY") + ' to ' + nt.rank + '</span>'
        : ' <span style="font-size:10px;color:#B8962E;">Max tier</span>';
      pH = '<span style="background:#DCFCE7;color:#166534;padding:2px 8px;border-radius:10px;font-size:11px;font-weight:700;">'
         + Math.round(t.rate * 100) + '% — ' + t.rank + '</span>' + wgap;
    }

    // ── EXCOMM overriding badge ──────────────────────────────────────────────
    var exH = "";
    if (cat === "EXCOMM") {
      exH = '<div style="margin-top:6px;">'
          + '<div style="font-size:9px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;margin-bottom:2px;">Company Overriding (Fixed)</div>'
          + '<span style="background:#FEF3C7;color:#92400E;padding:2px 8px;border-radius:10px;font-size:11px;font-weight:700;">20% — Company Fixed</span>'
          + '</div>';
    }

    // ── Direct overriding badge (MGR + VP only) ──────────────────────────────
    var dH = "";
    if ((cat === "MGR" || cat === "VP" || cat === "EXCOMM") && _dir > 0) {
      var mt  = getMgrTier(ytd.ytd_direct);
      var nmt = null;
      for (var mi = MGR_TIERS.length - 1; mi >= 0; mi--) {
        if (MGR_TIERS[mi].minRevenue > ytd.ytd_direct) { nmt = MGR_TIERS[mi]; break; }
      }
      var mgap = nmt
        ? ' <span style="font-size:10px;color:#9CA3AF;">RM' + Math.ceil(nmt.minRevenue - ytd.ytd_direct).toLocaleString("en-MY") + ' to ' + nmt.rank + '</span>'
        : ' <span style="font-size:10px;color:#B8962E;">Max tier</span>';
      dH = '<div style="margin-top:6px;">'
         + '<div style="font-size:9px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;margin-bottom:2px;">Direct Overriding &middot; Direct Team YTD: <b style="color:#1D4ED8;">' + rm(ytd.ytd_direct) + '</b></div>'
         + '<span style="background:#DBEAFE;color:#1D4ED8;padding:2px 8px;border-radius:10px;font-size:11px;font-weight:700;">'
         + Math.round(mt.rate * 100) + '% — ' + mt.rank + '</span>' + mgap + '</div>';
    }

    // ── Indirect overriding badge (VP only) ──────────────────────────────────
    var iH = "";
    if ((cat === "VP" || cat === "EXCOMM") && _dist > 0) {
      var vt  = getVPTier(ytd.ytd_district);
      var nvt = null;
      for (var vi = VP_TIERS.length - 1; vi >= 0; vi--) {
        if (VP_TIERS[vi].minRevenue > ytd.ytd_district) { nvt = VP_TIERS[vi]; break; }
      }
      var vgap = nvt
        ? ' <span style="font-size:10px;color:#9CA3AF;">RM' + Math.ceil(nvt.minRevenue - ytd.ytd_district).toLocaleString("en-MY") + ' to ' + nvt.rank + '</span>'
        : ' <span style="font-size:10px;color:#B8962E;">Max tier</span>';
      iH = '<div style="margin-top:6px;">'
         + '<div style="font-size:9px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;margin-bottom:2px;">Indirect Overriding &middot; District Group YTD: <b style="color:#7C3AED;">' + rm(ytd.ytd_district) + '</b></div>'
         + '<span style="background:#EDE9FE;color:#7C3AED;padding:2px 8px;border-radius:10px;font-size:11px;font-weight:700;">'
         + Math.round(vt.rate * 100) + '% — ' + vt.rank + '</span>' + vgap + '</div>';
    }

    // ── Overriding earned BY this adviser's revenue (who benefits upline) ──────
    var uplineH = '';
    if (cat === 'EXCOMM') {
      uplineH = '<div style="margin-top:7px;padding:6px 8px;background:#FEF9EC;border-radius:6px;border-left:3px solid #B8962E;">'
        + '<div style="font-size:9px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;margin-bottom:3px;">Overriding Paid Out</div>'
        + '<span style="font-size:11px;color:#92400E;font-weight:600;">' + (_dist > 0 ? 'NIL upward (top of structure) — earns overriding on downlines above' : 'NIL — top of structure') + '</span>'
        + '</div>';
    } else {
      // Upline manager
      var mgrId  = adv.uplineManager;
      var mgrAdv = mgrId && mgrId !== 'COMPANY' ? ADVISERS[mgrId] : null;
      var mgrIsEXCOMM = mgrAdv && (mgrAdv.category === 'EXCOMM' || mgrAdv.rank === 'EXCOMM');

      var mgrLine;
      if (!mgrId || mgrId === 'COMPANY') {
        mgrLine = '<div style="font-size:11px;color:#6B7280;font-weight:600;">Direct Overriding → <span style="background:#F1F5F9;padding:1px 6px;border-radius:8px;color:#374151;">NIL — Company Direct</span></div>';
      } else if (mgrIsEXCOMM) {
        mgrLine = '<div style="font-size:11px;color:#92400E;font-weight:600;">Direct Overriding → ' + mgrAdv.name + ' (EXCOMM — NIL, 20% retained by company)</div>';
      } else {
        var mgrCat = mgrAdv ? (mgrAdv.category || 'MGR') : 'MGR';
        var mgrYtd = YTD[mgrId] || {ytd_direct:0};
        var mgrT   = getMgrTier(mgrYtd.ytd_direct);
        mgrLine = '<div style="font-size:11px;color:#1D4ED8;font-weight:700;">'
          + 'Direct Overriding → ' + (mgrAdv ? mgrAdv.name : mgrId)
          + ' <span style="background:#DBEAFE;padding:1px 6px;border-radius:8px;">'
          + Math.round(mgrT.rate * 100) + '% (' + mgrT.rank + ')</span></div>';
      }

      // Upline VP
      var vpId  = adv.uplineVP;
      var vpAdv = vpId && vpId !== 'COMPANY' ? ADVISERS[vpId] : null;
      var vpIsEXCOMM = vpAdv && (vpAdv.category === 'EXCOMM' || vpAdv.rank === 'EXCOMM');

      var vpLine;
      if (!vpId || vpId === 'COMPANY') {
        vpLine = '<div style="font-size:11px;color:#6B7280;font-weight:600;margin-top:2px;">Indirect Overriding → <span style="background:#F1F5F9;padding:1px 6px;border-radius:8px;color:#374151;">NIL — Company Direct</span></div>';
      } else if (vpIsEXCOMM) {
        vpLine = '<div style="font-size:11px;color:#92400E;font-weight:600;margin-top:2px;">Indirect Overriding → ' + vpAdv.name + ' (EXCOMM — NIL, absorbed into 20%)</div>';
      } else {
        var vpYtd = YTD[vpId] || {ytd_district:0};
        var vpT   = getVPTier(vpYtd.ytd_district);
        vpLine = '<div style="font-size:11px;color:#7C3AED;font-weight:700;margin-top:2px;">'
          + 'Indirect Overriding → ' + (vpAdv ? vpAdv.name : vpId)
          + ' <span style="background:#EDE9FE;padding:1px 6px;border-radius:8px;">'
          + Math.round(vpT.rate * 100) + '% (' + vpT.rank + ')</span></div>';
      }

      uplineH = '<div style="margin-top:7px;padding:6px 8px;background:#F8FAFF;border-radius:6px;border-left:3px solid #6366F1;">'
        + '<div style="font-size:9px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;margin-bottom:4px;">Overriding Paid To Upline</div>'
        + mgrLine + vpLine
        + '</div>';
    }

    // ── Revenue cards ────────────────────────────────────────────────────────
    var cards = ''
      + '<div style="background:#F8FAFC;border-radius:6px;padding:4px 8px;">'
      + '<div style="font-size:9px;color:#9CA3AF;text-transform:uppercase;">YTD ' + currentYr + '</div>'
      + '<div style="font-size:12px;font-weight:700;color:#0B2545;">' + rm(stats.ytdRevenue) + '</div></div>'
      + '<div style="background:#F8FAFC;border-radius:6px;padding:4px 8px;">'
      + '<div style="font-size:9px;color:#9CA3AF;text-transform:uppercase;">MTD ' + stats.mtdLabel + '</div>'
      + '<div style="font-size:12px;font-weight:700;color:#0B2545;">' + rm(stats.mtdRevenue) + '</div></div>';
    if (_dir > 0) {
      cards += '<div style="background:#EFF6FF;border-radius:6px;padding:4px 8px;">'
             + '<div style="font-size:9px;color:#9CA3AF;text-transform:uppercase;">YTD Direct Team</div>'
             + '<div style="font-size:12px;font-weight:700;color:#1D4ED8;">' + rm(ytd.ytd_direct) + '</div></div>';
    }
    if (_dist > 0 && (cat === "VP" || cat === "EXCOMM")) {
      cards += '<div style="background:#F5F3FF;border-radius:6px;padding:4px 8px;">'
             + '<div style="font-size:9px;color:#9CA3AF;text-transform:uppercase;">YTD District Group</div>'
             + '<div style="font-size:12px;font-weight:700;color:#7C3AED;">' + rm(ytd.ytd_district) + '</div></div>';
    }

    // ── Compact commission summary (full detail collapsed behind a toggle) ────
    var sumBg, sumColor, sumLabel;
    if (cat === "EXCOMM") { sumBg = "#F5EDD4"; sumColor = "#92400E"; sumLabel = "80% · EXCOMM"; }
    else { var sumT = getWPTier(ytd.ytd_personal); sumBg = "#DCFCE7"; sumColor = "#166534"; sumLabel = Math.round(sumT.rate * 100) + "% · " + sumT.rank; }
    var roleTag = (cat === "VP")  ? ' <span style="font-size:10px;color:#7C3AED;font-weight:600;">+ VP overriding</span>'
                : (cat === "MGR") ? ' <span style="font-size:10px;color:#1D4ED8;font-weight:600;">+ Mgr overriding</span>'
                : (cat === "EXCOMM" && _dist > 0) ? ' <span style="font-size:10px;color:#7C3AED;font-weight:600;">+ overriding</span>' : '';

    var tr = '<tr style="cursor:pointer;" onclick="advRowClick(event,\'' + id + '\')">'
      + '<td><b style="color:#0B2545;">' + id + '</b></td>'
      + '<td>'
      +   '<div style="font-weight:600;">' + adv.name + '</div>'
      +   '<div style="font-size:11px;color:#9CA3AF;">' + (catLabel[cat] || cat) + '</div>'
      +   (adv.displayName ? '<div style="font-size:11px;color:#B8962E;">' + adv.displayName + '</div>' : '')
      + '</td>'
      + '<td style="font-size:12px;">'
      +   '<div style="color:#1D4ED8;">' + adv.email + '</div>'
      +   '<div style="color:#6B7280;margin-top:2px;">' + (adv.personalEmail || '—') + '</div>'
      +   (adv.contact ? '<div style="color:#6B7280;margin-top:2px;">&#128222; ' + adv.contact + '</div>' : '')
      + '</td>'
      + '<td style="font-size:12px;min-width:180px;">'
      +   '<span style="background:' + sumBg + ';color:' + sumColor + ';padding:2px 8px;border-radius:10px;font-size:11px;font-weight:700;">' + sumLabel + '</span>' + roleTag
      +   '<div style="font-size:11px;color:#6B7280;margin-top:5px;">YTD <b style="color:#0B2545;">' + rm(stats.ytdRevenue) + '</b> &middot; MTD ' + stats.mtdLabel + ' ' + rm(stats.mtdRevenue) + '</div>'
      +   '<button id="commtog-' + id + '" onclick="toggleCommDetail(\'' + id + '\')" style="margin-top:6px;background:none;border:0;color:#1D4ED8;font-size:11px;font-weight:600;cursor:pointer;padding:0;">&#9656; details</button>'
      +   '<div id="commdetail-' + id + '" style="display:none;margin-top:8px;">'
      +     '<div style="display:grid;grid-template-columns:1fr 1fr;gap:4px;margin-bottom:4px;padding-bottom:7px;border-bottom:1px solid #F1F5F9;">' + cards + '</div>'
      +     commProfileRows(id)
      +   '</div>'
      + '</td>'
      + '<td><div style="font-size:10px;line-height:1.5;">' + fmtLoginCell(adv)
      +   (adv.mustChangePass ? '<div style="color:#92400E;margin-top:3px;">🔑 Temp password issued — they set their own at first login</div>' : '')
      + '</div></td>'
      + '<td style="white-space:nowrap;position:relative;text-align:right;">'
      + (_ro ? '<span style="color:#9CA3AF;">&rsaquo;</span>' :
          '<button class="admin-action-btn" style="background:#fff;border:1.5px solid #E2E8F0;color:#374151;padding:7px 12px;font-size:14px;line-height:1;" onclick="toggleAdvMenu(event,\'' + id + '\')" title="More actions">&#8943;</button>'
        + '<div id="advmenu-' + id + '" style="display:none;position:absolute;right:8px;top:100%;z-index:500;background:#fff;border:1px solid #E2E8F0;border-radius:10px;box-shadow:0 8px 28px rgba(0,0,0,.14);min-width:170px;padding:6px;text-align:left;">'
        +   '<div class="advmenu-item" onclick="openDetailsModal(\'' + id + '\')">Personal details</div>'
        +   (adv.terminated
              ? '<div class="advmenu-item" style="color:#166534;" onclick="reinstateAdviser(\'' + id + '\')">Reinstate</div>'
              + '<div class="advmenu-item" style="color:#991B1B;border-top:1px solid #F1F5F9;" onclick="confirmRemoveAdviser(\'' + id + '\')">Remove</div>'
              : '<div class="advmenu-item" onclick="emailAdviser(\'' + id + '\')">Email this adviser</div>'
              + '<div class="advmenu-item" onclick="openTierModal(\'' + id + '\')">Set rank / category</div>'
              + '<div class="advmenu-item" onclick="openAdminPassModal(\'' + id + '\',\'reset\')">Reset password</div>'
              + '<div class="advmenu-item" style="color:#92400E;border-top:1px solid #F1F5F9;" onclick="terminateAdviser(\'' + id + '\')">Terminate</div>')
        + '</div>')
      + '</td>'
      + '</tr>';
    if (adv.terminated) { termRows += tr; _nTerm++; } else { rows += tr; _nActive++; }
  });

  var _tab = function(on){ return 'padding:7px 16px;border-radius:16px;font-size:13px;cursor:pointer;font-weight:600;'
    + (on ? 'background:#0B2545;color:#fff;border:1px solid #0B2545;' : 'background:#fff;color:#374151;border:1px solid #E2E8F0;'); };
  if (_adminMode === "advisers") {
    var _list = _advShowTerm ? termRows : rows;
    document.getElementById("main-content").innerHTML =
      '<div style="padding:28px 32px;max-width:1280px;">'
      + '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:16px;">'
      +   '<div style="font-size:22px;font-weight:700;color:#0B2545;">Advisers</div>'
      +   (_ro ? '' : '<button onclick="openAddAdviserModal()" style="padding:10px 20px;background:#0B2545;color:#fff;border:none;border-radius:10px;font-size:13px;font-weight:700;cursor:pointer;">+ Add Adviser</button>')
      + '</div>'
      + (_ro ? '' : scAnnualFeeReminder())
      + '<div style="display:flex;gap:8px;margin-bottom:14px;">'
      +   '<button onclick="_advShowTerm=false;renderAdminPanel()" style="' + _tab(!_advShowTerm) + '">Active &middot; ' + _nActive + '</button>'
      +   '<button onclick="_advShowTerm=true;renderAdminPanel()" style="' + _tab(_advShowTerm) + '">Terminated &middot; ' + _nTerm + '</button>'
      + '</div>'
      + (_list
          ? '<div style="background:#fff;border-radius:12px;box-shadow:0 2px 12px rgba(0,0,0,.07);margin-bottom:24px;">'
            + '<table class="admin-table"><thead><tr>'
            + '<th>LIFA ID</th><th>Name / Rank</th><th>Corporate Email / Personal Email</th><th>Commission Structure</th><th>Status / Login</th><th></th>'
            + '</tr></thead><tbody>' + _list + '</tbody></table></div>'
          : '<div style="color:#6B7280;font-size:13px;">' + (_advShowTerm ? 'No terminated advisers.' : 'No advisers yet.') + '</div>')
      + '</div>';
    return;
  }

  var _link = function(label, view){ return '<div onclick="showView(\'' + view + '\')" style="display:flex;align-items:center;padding:11px 16px;border-top:1px solid #F1F5F9;cursor:pointer;font-size:13px;color:#0B2545;"><span style="flex:1">' + label + '</span><span style="color:#9CA3AF;">&rsaquo;</span></div>'; };
  document.getElementById("main-content").innerHTML =
    '<div style="padding:28px 32px;max-width:1280px;">'
    + '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:20px;">'
    +   '<div style="font-size:22px;font-weight:700;color:#0B2545;">Admin Panel</div>'
    +   '<button onclick="reqParticularsAll()" style="padding:10px 16px;background:#fff;color:#0B2545;border:1.5px solid #0B2545;border-radius:10px;font-size:13px;font-weight:700;cursor:pointer;" title="Email every active adviser a private link to complete their details">Request details from all</button>'
    + '</div>'

    // Pages taken off the menu (walkthrough 29 Oct 2026) — one click from here
    + '<div style="background:#fff;border-radius:12px;box-shadow:0 2px 12px rgba(0,0,0,.07);overflow:hidden;margin-bottom:20px;max-width:520px;">'
    +   '<div style="padding:11px 16px;font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6B7280;font-weight:700;">System</div>'
    +   _link('Error Log', 'errorlog') + _link('Register Attempts', 'regattempts') + _link('Templates', 'emailtemplates') + _link('Contract Signing', 'signingroster')
    + '</div>'

    // Team hierarchy — whole structure + OR flows at a glance
    + '<details class="admin-sec" open><summary>Team Hierarchy &amp; Overriding</summary><div class="sec-body">'
    + renderHierarchyMatrix()
    + '</div></details>'

    // Tier reference table (collapsed by default)
    + '<details class="admin-sec"><summary>Commission Tier Reference</summary><div class="sec-body">'
    + '<div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:16px;font-size:12px;">'

    + '<div><div style="font-weight:700;color:#0B2545;margin-bottom:8px;padding-bottom:6px;border-bottom:2px solid #B8962E;">Wealth Planner (Personal Sales)</div>'
    + '<table style="width:100%;border-collapse:collapse;">'
    + '<tr style="background:#F8FAFC;"><th style="padding:4px 6px;text-align:left;font-size:10px;color:#6B7280;">YTD Personal</th><th style="padding:4px 6px;text-align:center;font-size:10px;color:#6B7280;">Rate</th><th style="padding:4px 6px;font-size:10px;color:#6B7280;">Rank</th></tr>'
    + '<tr><td style="padding:4px 6px;border-bottom:1px solid #F1F5F9;">&ge; RM100,000</td><td style="text-align:center;color:#166534;font-weight:700;border-bottom:1px solid #F1F5F9;">70%</td><td style="padding:4px 6px;border-bottom:1px solid #F1F5F9;">Associate Partner</td></tr>'
    + '<tr><td style="padding:4px 6px;border-bottom:1px solid #F1F5F9;">RM50k – RM100k</td><td style="text-align:center;color:#166534;font-weight:700;border-bottom:1px solid #F1F5F9;">60%</td><td style="padding:4px 6px;border-bottom:1px solid #F1F5F9;">Elite Wealth Planner</td></tr>'
    + '<tr><td style="padding:4px 6px;">Below RM50,000</td><td style="text-align:center;color:#166534;font-weight:700;">50%</td><td style="padding:4px 6px;">Wealth Planner</td></tr>'
    + '</table><div style="margin-top:8px;padding:5px 8px;background:#F5EDD4;border-radius:6px;font-size:10px;color:#92400E;"><b>EXCOMM:</b> Fixed 80% personal &middot; earns 20% OR on downline gross (8% Mgr / 12% EXCOMM when a manager is in between)</div></div>'

    + '<div><div style="font-weight:700;color:#0B2545;margin-bottom:8px;padding-bottom:6px;border-bottom:2px solid #1D4ED8;">Manager Direct Overriding</div>'
    + '<table style="width:100%;border-collapse:collapse;">'
    + '<tr style="background:#F8FAFC;"><th style="padding:4px 6px;text-align:left;font-size:10px;color:#6B7280;">Direct Team YTD</th><th style="padding:4px 6px;text-align:center;font-size:10px;color:#6B7280;">Rate</th><th style="padding:4px 6px;font-size:10px;color:#6B7280;">Rank</th></tr>'
    + '<tr><td style="padding:4px 6px;border-bottom:1px solid #F1F5F9;">Above RM300,000</td><td style="text-align:center;color:#1D4ED8;font-weight:700;border-bottom:1px solid #F1F5F9;">12%</td><td style="padding:4px 6px;border-bottom:1px solid #F1F5F9;">Partner</td></tr>'
    + '<tr><td style="padding:4px 6px;border-bottom:1px solid #F1F5F9;">RM200k – RM300k</td><td style="text-align:center;color:#1D4ED8;font-weight:700;border-bottom:1px solid #F1F5F9;">10%</td><td style="padding:4px 6px;border-bottom:1px solid #F1F5F9;">Senior Manager</td></tr>'
    + '<tr><td style="padding:4px 6px;">Below RM200,000</td><td style="text-align:center;color:#1D4ED8;font-weight:700;">6%</td><td style="padding:4px 6px;">Manager</td></tr>'
    + '</table></div>'

    + '<div><div style="font-weight:700;color:#0B2545;margin-bottom:8px;padding-bottom:6px;border-bottom:2px solid #7C3AED;">VP Indirect Overriding</div>'
    + '<table style="width:100%;border-collapse:collapse;">'
    + '<tr style="background:#F8FAFC;"><th style="padding:4px 6px;text-align:left;font-size:10px;color:#6B7280;">District Group YTD</th><th style="padding:4px 6px;text-align:center;font-size:10px;color:#6B7280;">Rate</th><th style="padding:4px 6px;font-size:10px;color:#6B7280;">Rank</th></tr>'
    + '<tr><td style="padding:4px 6px;border-bottom:1px solid #F1F5F9;">Above RM600,000</td><td style="text-align:center;color:#7C3AED;font-weight:700;border-bottom:1px solid #F1F5F9;">6%</td><td style="padding:4px 6px;border-bottom:1px solid #F1F5F9;">Senior Partner</td></tr>'
    + '<tr><td style="padding:4px 6px;border-bottom:1px solid #F1F5F9;">RM400k – RM600k</td><td style="text-align:center;color:#7C3AED;font-weight:700;border-bottom:1px solid #F1F5F9;">4%</td><td style="padding:4px 6px;border-bottom:1px solid #F1F5F9;">Senior Vice President</td></tr>'
    + '<tr><td style="padding:4px 6px;">Below RM400,000</td><td style="text-align:center;color:#7C3AED;font-weight:700;">2%</td><td style="padding:4px 6px;">Vice President</td></tr>'
    + '</table></div>'

    + '</div></div></details>' // end tier reference

    // Staff access — owner ticks which areas each staff login can use
    + '<details class="admin-sec"><summary>Staff Access</summary><div class="sec-body">'
    + renderStaffAccess()
    + '</div></details>'

    // Admin account settings (collapsed by default)
    + '<details class="admin-sec"><summary>Admin Account Settings</summary><div class="sec-body">'
    + '<div style="font-size:12px;color:#6B7280;margin-bottom:16px;">Update your admin display name, login email and password.</div>'
    + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;">'
    + '<div>'
    + '<div class="modal-field"><label>Admin Display Name</label>'
    + '<input id="admin-display-name" value="Lifa Admin" style="width:100%;padding:9px 12px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;box-sizing:border-box;"/>'
    + '<button onclick="saveAdminDisplayName()" class="modal-btn primary" style="margin-top:6px;padding:6px 16px;font-size:12px;">Save Name</button>'
    + '<div id="admin-name-msg" style="font-size:11px;margin-top:4px;min-height:14px;"></div></div>'
    + '<div class="modal-field" style="margin-top:12px;"><label>Admin Email</label>'
    + '<input id="admin-email-input" value="' + Object.keys(ADMINS)[0] + '" style="width:100%;padding:9px 12px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;box-sizing:border-box;"/>'
    + '<button onclick="saveAdminEmail()" class="modal-btn primary" style="margin-top:6px;padding:6px 16px;font-size:12px;">Save Email</button>'
    + '<div id="admin-email-msg" style="font-size:11px;margin-top:4px;min-height:14px;"></div></div></div>'
    + '<div>'
    + '<div class="modal-field"><label>Current Password</label>'
    + '<input id="admin-cur-pass" type="password" placeholder="••••••••" style="width:100%;padding:9px 12px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;box-sizing:border-box;"/></div>'
    + '<div class="modal-field" style="margin-top:10px;"><label>New Password</label>'
    + '<input id="admin-new-pass1" type="password" style="width:100%;padding:9px 12px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;box-sizing:border-box;"/></div>'
    + '<div class="modal-field" style="margin-top:10px;"><label>Confirm New Password</label>'
    + '<input id="admin-new-pass2" type="password" style="width:100%;padding:9px 12px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;box-sizing:border-box;"/></div>'
    + '<button onclick="updateAdminPassword()" class="modal-btn primary" style="margin-top:10px;padding:8px 20px;font-size:12px;">Update Password</button>'
    + '<div id="admin-pass-msg" style="font-size:12px;margin-top:8px;min-height:16px;"></div></div>'
    + '</div></div></details>'

    + '<details class="admin-sec"><summary>iFAST ZIP Password</summary><div class="sec-body">'
    + '<div style="font-size:11px;color:#78350F;margin-bottom:8px;">iFAST sends commission ZIPs encrypted with this password. Applied automatically on upload.</div>'
    + '<div style="display:flex;gap:8px;align-items:center;">'
    + '<input id="zip-pass-input" value="' + IFAST_ZIP_PASS + '" style="flex:1;padding:8px 12px;border:1.5px solid #FED7AA;border-radius:7px;font-size:13px;font-family:monospace;font-weight:700;letter-spacing:.05em;background:#FFFBEB;"/>'
    + '<button onclick="saveZipPassword()" style="padding:8px 16px;background:#92400E;color:#fff;border:none;border-radius:7px;font-size:12px;font-weight:700;cursor:pointer;white-space:nowrap;">Save Password</button>'
    + '</div>'
    + '<div id="zip-pass-msg" style="font-size:11px;margin-top:6px;min-height:14px;color:#166534;"></div></div></details>'

    // Commission payout summary email recipient (admin-configurable)
    + '<details class="admin-sec"><summary>Commission Payout Summary Email</summary><div class="sec-body">'
    + '<div style="font-size:12px;color:#6B7280;margin-bottom:14px;">Where the &ldquo;Email Summary&rdquo; button (on each month&rsquo;s Statement Review) sends the payout summary so finance can issue payment.</div>'
    + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;">'
    + '<div class="modal-field"><label>Send to (finance)</label><input id="payout-to-input" placeholder="finance@&hellip;" style="width:100%;padding:9px 12px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;box-sizing:border-box;"/></div>'
    + '<div class="modal-field"><label>BCC</label><input id="payout-bcc-input" placeholder="optional bcc" style="width:100%;padding:9px 12px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;box-sizing:border-box;"/></div>'
    + '</div>'
    + '<button onclick="savePayoutEmails()" class="modal-btn primary" style="margin-top:10px;padding:7px 18px;font-size:12px;">Save</button>'
    + '<div id="payout-email-msg" style="font-size:11px;margin-top:6px;min-height:14px;"></div></div></details>'

    // Email advisers their login + commission reminder
    + '<details class="admin-sec"><summary>Email Advisers &mdash; Portal Login &amp; Reminder</summary><div class="sec-body">'
    + '<div style="font-size:12px;color:#6B7280;margin-bottom:6px;">Emails every adviser their login email + a new one-time temporary password and reminds them to log in to <b>portal.lifa.com.my</b> to check their commission statement. Notes that commission is issued on the 25th of every month. <b>This resets each adviser&rsquo;s password</b> &mdash; they set a new one on first login.</div>'
    + '<div style="font-size:11px;color:#92400E;background:#FFF7ED;border:1px solid #FED7AA;border-radius:8px;padding:8px 12px;margin-bottom:12px;">Test first &mdash; &ldquo;Send test&rdquo; only emails Gan (ganchinsoon@lifa.com.my, LIFA001).</div>'
    + '<div style="display:flex;gap:10px;flex-wrap:wrap;">'
    + '<button onclick="sendCommissionReminder(true)" style="padding:8px 18px;background:#fff;color:#0B2545;border:1.5px solid #B8962E;border-radius:8px;font-size:13px;font-weight:700;cursor:pointer;">Send test (ganchinsoon)</button>'
    + '<button onclick="sendCommissionReminder(false)" style="padding:8px 18px;background:#0B2545;color:#fff;border:none;border-radius:8px;font-size:13px;font-weight:700;cursor:pointer;">Send to all advisers</button>'
    + '</div>'
    + '<div id="comm-reminder-msg" style="font-size:12px;margin-top:10px;min-height:16px;line-height:1.6;"></div></div></details>'

    // Admin activity log (collapsed by default)
    + '<details class="admin-sec"><summary>Admin Activity Log</summary><div class="sec-body">'
    + '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:10px;">'
    + '<div style="font-size:12px;color:#6B7280;">Password resets, statement publishing, emails sent, settings &amp; adviser changes &mdash; who did what, when.</div>'
    + '<button onclick="loadAdminAudit()" style="padding:5px 12px;background:#F1F5F9;border:1px solid #E2E8F0;border-radius:7px;font-size:11px;font-weight:600;cursor:pointer;">&#8635; Refresh</button>'
    + '</div>'
    + '<div id="admin-audit-list" style="font-size:12px;color:#9CA3AF;">Loading…</div></div></details>'

    + '</div>'; // end outer padding div

  setTimeout(function(){ loadCompSettings(); loadAdminAudit(); }, 0);
}

// Load + render the admin activity log.
function loadAdminAudit(){
  var box=document.getElementById("admin-audit-list");
  if(box) box.innerHTML="Loading…";
  apiGet("/api/admin/audit?limit=100").then(function(rows){
    if(!box) return;
    if(!rows || !rows.length){ box.innerHTML='<div style="color:#9CA3AF;">No admin actions logged yet.</div>'; return; }
    var labels={password_reset:"🔑 Password reset",password_update:"🔑 Password set",password_changed:"🔑 Password changed",commission_reminder_sent:"📧 Commission reminder sent",payout_summary_emailed:"💸 Payout summary emailed",settings_updated:"⚙️ Settings updated",adviser_created:"➕ Adviser created",adviser_updated:"✏️ Adviser updated",adviser_deleted:"🗑️ Adviser deleted",statement_published:"✅ Statement published"};
    var html='<div style="max-height:340px;overflow:auto;"><table style="width:100%;border-collapse:collapse;font-size:12px;">'
      +'<thead><tr style="text-align:left;color:#9CA3AF;font-size:11px;position:sticky;top:0;background:#fff;"><th style="padding:6px 8px;">When (MYT)</th><th style="padding:6px 8px;">Action</th><th style="padding:6px 8px;">Target</th><th style="padding:6px 8px;">By</th></tr></thead><tbody>';
    rows.forEach(function(r){
      var when=new Date(r.ts*1000).toLocaleString('en-MY',{timeZone:'Asia/Kuala_Lumpur',day:'2-digit',month:'short',hour:'2-digit',minute:'2-digit'});
      var act=labels[r.action]||r.action;
      html+='<tr style="border-top:1px solid #F1F5F9;"><td style="padding:6px 8px;color:#374151;white-space:nowrap;">'+when+'</td><td style="padding:6px 8px;">'+act+'</td><td style="padding:6px 8px;color:#0B2545;">'+(r.target||'—')+'</td><td style="padding:6px 8px;color:#6B7280;">'+(r.actor_id||'—')+'</td></tr>';
    });
    html+='</tbody></table></div>';
    box.innerHTML=html;
  }).catch(function(e){ if(box) box.innerHTML='<div style="color:#DC2626;">Failed to load log: '+e+'</div>'; });
}

// Load + save the admin-configurable payout summary recipient/BCC.
function loadCompSettings(){
  apiGet("/api/settings").then(function(s){
    if(!s) return;
    var to=document.getElementById("payout-to-input"); if(to) to.value=s.payout_summary_to||"";
    var bcc=document.getElementById("payout-bcc-input"); if(bcc) bcc.value=s.payout_summary_bcc||"";
  }).catch(function(){});
}
// ── Adviser: save own display name (welcome-greeting customisation) ──────────
async function saveDisplayName(){
  var inp=document.getElementById('display-name-input'); if(!inp) return;
  var name=(inp.value||'').trim();
  try{
    var r=await apiPost('/api/me/update',{display_name:name});
    if(r&&r.error) throw new Error(r.error);
    if(ADVISERS[currentUser]) ADVISERS[currentUser].displayName=name;
    showToast('success','Display name saved');
    renderDashboard();
  }catch(e){ showToast('error', e.message||'Could not save'); }
}
// ── Admin: own display name / login email / password ─────────────────────────
async function saveAdminDisplayName(){
  var inp=document.getElementById('admin-display-name'), msg=document.getElementById('admin-name-msg');
  try{
    var r=await apiPost('/api/me/update',{display_name:(inp.value||'').trim()});
    if(r&&r.error) throw new Error(r.error);
    if(msg){ msg.style.color='#166534'; msg.textContent='Saved ✓'; }
  }catch(e){ if(msg){ msg.style.color='#B91C1C'; msg.textContent=e.message||'Could not save'; } }
}
async function saveAdminEmail(){
  var inp=document.getElementById('admin-email-input'), msg=document.getElementById('admin-email-msg');
  try{
    var r=await apiPost('/api/me/update',{email:(inp.value||'').trim()});
    if(r&&r.error) throw new Error(r.error);
    if(msg){ msg.style.color='#166534'; msg.textContent='Saved ✓ — use this email at next login'; }
  }catch(e){ if(msg){ msg.style.color='#B91C1C'; msg.textContent=e.message||'Could not save'; } }
}
async function updateAdminPassword(){
  var cur=document.getElementById('admin-cur-pass'), n1=document.getElementById('admin-new-pass1'), n2=document.getElementById('admin-new-pass2');
  var msg=document.getElementById('admin-pass-msg');
  function show(c,t){ if(msg){ msg.style.color=c; msg.textContent=t; } }
  if(!n1.value || n1.value.length<6){ show('#B91C1C','New password must be at least 6 characters'); return; }
  if(n1.value!==n2.value){ show('#B91C1C','New passwords do not match'); return; }
  try{
    var r=await apiPost('/api/me/change-password',{current:cur.value,new:n1.value});
    if(r&&r.error) throw new Error(r.error);
    show('#166534','Password updated ✓');
    cur.value=''; n1.value=''; n2.value='';
  }catch(e){ show('#B91C1C', e.message||'Could not update'); }
}

function openTopbarProfileModal(){
  var existing=document.getElementById('tppm-modal'); if(existing) existing.remove();
  var adv=ADVISERS[currentUser]||{};
  var currentDisplayName = isAdmin
    ? (document.getElementById('nav-name')||{}).textContent||'Lifa Admin'
    : (adv.displayName || adv.name||'');
  var currentEmail = isAdmin
    ? (Object.keys(ADMINS)[0]||'')
    : (adv.email||'');
  var currentNotifEmail = (!isAdmin && !isChecker) ? (adv.personalEmail||'') : '';

  var notifRow = (!isAdmin && !isChecker) ? `
    <div style="margin-bottom:14px;">
      <label style="font-size:11px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;font-weight:600;display:block;margin-bottom:5px;">Notification email <span style="font-weight:400;font-size:10px;">(receives alerts &amp; password resets)</span></label>
      <input id="tppm-notif" type="email" value="${escapeHtml(currentNotifEmail)}" style="width:100%;box-sizing:border-box;padding:9px 11px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;">
    </div>` : '';

  var emailRow = isAdmin ? `
    <div style="margin-bottom:14px;">
      <label style="font-size:11px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;font-weight:600;display:block;margin-bottom:5px;">Login email</label>
      <input id="tppm-email" type="email" value="${escapeHtml(currentEmail)}" style="width:100%;box-sizing:border-box;padding:9px 11px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;">
    </div>` : `
    <div style="margin-bottom:14px;">
      <label style="font-size:11px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;font-weight:600;display:block;margin-bottom:5px;">Login email</label>
      <div style="padding:9px 11px;background:#F8FAFC;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;color:#6B7280;">${escapeHtml(currentEmail)}</div>
    </div>`;

  var modal=document.createElement('div');
  modal.id='tppm-modal';
  modal.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9999;display:flex;align-items:center;justify-content:center';
  modal.innerHTML=`
    <div style="background:#fff;border-radius:16px;padding:28px 28px 20px;width:400px;max-width:94vw;box-shadow:0 8px 40px rgba(0,0,0,.18);">
      <div style="font-weight:700;color:#0B2545;font-size:16px;margin-bottom:4px;">My Profile</div>
      <div style="font-size:12px;color:#9CA3AF;margin-bottom:20px;">${escapeHtml(currentUser||'')} &nbsp;·&nbsp; ${isAdmin?'Administrator':((ADVISERS[currentUser]||{}).rank||'')}</div>

      <div style="margin-bottom:14px;">
        <label style="font-size:11px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;font-weight:600;display:block;margin-bottom:5px;">Display name</label>
        <input id="tppm-name" type="text" value="${escapeHtml(currentDisplayName)}" style="width:100%;box-sizing:border-box;padding:9px 11px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;">
      </div>

      ${emailRow}
      ${notifRow}

      <div style="border-top:1px solid #F1F5F9;margin:16px 0 14px;padding-top:14px;">
        <div style="font-size:11px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;font-weight:600;margin-bottom:10px;">Change password <span style="font-weight:400;font-size:10px;">(leave blank to keep current)</span></div>
        <input id="tppm-cur" type="password" placeholder="Current password" style="width:100%;box-sizing:border-box;padding:9px 11px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;margin-bottom:8px;">
        <input id="tppm-new" type="password" placeholder="New password (min 8 chars)" style="width:100%;box-sizing:border-box;padding:9px 11px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;margin-bottom:8px;">
        <input id="tppm-con" type="password" placeholder="Confirm new password" style="width:100%;box-sizing:border-box;padding:9px 11px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;">
      </div>

      <div id="tppm-msg" style="font-size:12px;min-height:18px;margin-bottom:10px;"></div>
      <div style="display:flex;gap:10px;justify-content:flex-end;">
        <button onclick="document.getElementById('tppm-modal').remove()" style="background:#F3F4F6;color:#374151;border:none;border-radius:8px;padding:9px 16px;font-size:13px;cursor:pointer;">Cancel</button>
        <button onclick="saveTopbarProfile()" id="tppm-btn" style="background:#0B2545;color:#fff;border:none;border-radius:8px;padding:9px 20px;font-size:13px;font-weight:700;cursor:pointer;">Save changes</button>
      </div>
    </div>`;
  document.body.appendChild(modal);
  modal.addEventListener('click',function(e){ if(e.target===modal) modal.remove(); });
  setTimeout(function(){ var f=document.getElementById('tppm-name'); if(f) f.focus(); },50);
}

async function saveTopbarProfile(){
  var btn=document.getElementById('tppm-btn'), msg=document.getElementById('tppm-msg');
  var nameEl=document.getElementById('tppm-name');
  var emailEl=document.getElementById('tppm-email');
  var notifEl=document.getElementById('tppm-notif');
  var curEl=document.getElementById('tppm-cur');
  var newEl=document.getElementById('tppm-new');
  var conEl=document.getElementById('tppm-con');
  function showMsg(color,text){ if(msg){ msg.style.color=color; msg.textContent=text; } }

  var newPw=(newEl&&newEl.value)||'';
  var curPw=(curEl&&curEl.value)||'';
  if(newPw){
    if(newPw.length<8){ showMsg('#B91C1C','New password must be at least 8 characters.'); return; }
    if(newPw!==(conEl&&conEl.value)){ showMsg('#B91C1C','New passwords do not match.'); return; }
    if(!curPw){ showMsg('#B91C1C','Enter your current password to change it.'); return; }
  }

  btn.disabled=true; btn.textContent='Saving…';
  try{
    var updateBody={display_name:(nameEl&&nameEl.value.trim())||''};
    if(isAdmin && emailEl) updateBody.email=emailEl.value.trim();
    if(!isAdmin && !isChecker && notifEl) updateBody.personal_email=notifEl.value.trim();
    var r=await apiPost('/api/me/update',updateBody);
    if(r&&r.error) throw new Error(r.error);

    if(newPw){
      var pr=await apiPost('/api/me/change-password',{current:curPw,new:newPw});
      if(pr&&pr.error) throw new Error(pr.error);
    }

    // Update UI
    var navName=document.getElementById('nav-name');
    if(navName && updateBody.display_name) navName.textContent=updateBody.display_name;
    var navAvatar=document.getElementById('nav-avatar');
    if(navAvatar && updateBody.display_name) navAvatar.textContent=(updateBody.display_name||'?')[0].toUpperCase();
    if(ADVISERS[currentUser]){
      if(updateBody.display_name) ADVISERS[currentUser].displayName=updateBody.display_name;
      if(updateBody.personal_email) ADVISERS[currentUser].personalEmail=updateBody.personal_email;
    }

    showMsg('#15803D','✓ Saved successfully.');
    setTimeout(function(){ var m=document.getElementById('tppm-modal'); if(m) m.remove(); },1000);
  }catch(e){ showMsg('#B91C1C',e.message||'Could not save'); }
  btn.disabled=false; btn.textContent='Save changes';
}

function savePayoutEmails(){
  var to=(document.getElementById("payout-to-input").value||"").trim();
  var bcc=(document.getElementById("payout-bcc-input").value||"").trim();
  var msg=document.getElementById("payout-email-msg");
  if(!to){ msg.textContent="⚠ Recipient cannot be empty"; msg.style.color="#DC2626"; return; }
  msg.textContent="Saving…"; msg.style.color="#6B7280";
  apiPut("/api/settings", {payout_summary_to:to, payout_summary_bcc:bcc}).then(function(r){
    if(r&&r.ok){ msg.textContent="✓ Saved — payout summaries go to "+to+(bcc?(" (bcc "+bcc+")"):""); msg.style.color="#166534"; }
    else { msg.textContent="✗ "+((r&&r.error)||"Save failed"); msg.style.color="#DC2626"; }
  }).catch(function(e){ msg.textContent="✗ "+e; msg.style.color="#DC2626"; });
}
function sendCommissionReminder(testMode){
  var msg=document.getElementById("comm-reminder-msg");
  var who = testMode ? "Gan only (ganchinsoon@lifa.com.my)" : "ALL advisers";
  var warn = testMode ? "" : "\n\nThis RESETS every adviser's password and emails them a new temporary one.";
  if(!confirm("Send the portal login + commission reminder email to "+who+"?"+warn)) return;
  msg.textContent="Sending…"; msg.style.color="#6B7280";
  apiPost("/api/advisers/send-commission-reminder", {test:!!testMode}).then(function(r){
    if(r&&r.ok){
      msg.textContent="✓ Sent "+r.sent+", failed "+r.failed+" "+(r.test?"(test mode — ganchinsoon only)":"(all advisers)")+".";
      msg.style.color = r.failed? "#B45309" : "#166534";
    } else { msg.textContent="✗ "+((r&&r.error)||"Send failed"); msg.style.color="#DC2626"; }
  }).catch(function(e){ msg.textContent="✗ "+e; msg.style.color="#DC2626"; });
}

function saveZipPassword() {
  var v = (document.getElementById("zip-pass-input").value||"").trim();
  var msg = document.getElementById("zip-pass-msg");
  if(!v){ msg.textContent="⚠ Password cannot be empty"; msg.style.color="#DC2626"; return; }
  IFAST_ZIP_PASS = v;
  // Update the badge display if visible
  var allBadges = document.querySelectorAll("[data-zip-pass-badge]");
  allBadges.forEach(function(el){ el.textContent = "📦 ZIP password: "+v; });
  msg.textContent="✓ Password updated to \""+v+"\" — applies to all future ZIP uploads this session";
  msg.style.color="#166534";
  // Re-render upload panel to update the hint text
  if(typeof renderUploadPanel==="function") renderUploadPanel();
}

// ── Rank / Commission Modal ───────────────────────────────────────────────────
// Admin: view / edit an adviser's personal details (contact, bank account, address).
// Values are set via .value after build to avoid HTML-attribute escaping issues.
function openDetailsModal(advId) {
  document.querySelectorAll('[id^="advmenu-"]').forEach(function(m){ m.style.display='none'; });
  var ex = document.getElementById("pd-overlay"); if (ex) ex.remove();
  var a = ADVISERS[advId]; if (!a) return;
  var fld = function(id,label,ph){ return '<div style="margin-bottom:12px;">'
    + '<label style="font-size:11px;color:#6B7280;text-transform:uppercase;letter-spacing:.04em;font-weight:600;">' + label + '</label>'
    + '<input id="' + id + '" placeholder="' + (ph||'') + '" style="width:100%;margin-top:4px;padding:9px 12px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px;box-sizing:border-box;"></div>'; };
  var ov = document.createElement("div");
  ov.id = "pd-overlay";
  ov.style.cssText = "position:fixed;inset:0;background:rgba(11,37,69,0.45);z-index:9000;display:flex;align-items:center;justify-content:center;padding:20px;";
  ov.innerHTML = '<div style="background:#fff;border-radius:16px;max-width:440px;width:100%;max-height:90vh;overflow:auto;padding:26px 28px;box-shadow:0 20px 60px rgba(0,0,0,.3);">'
    + '<div style="font-size:16px;font-weight:700;color:#0B2545;">Personal details</div>'
    + '<div style="font-size:12px;color:#9CA3AF;margin-bottom:18px;">' + a.name + ' &middot; ' + advId + '</div>'
    + fld('pd-email','Contact email','name@lifa.com.my')
    + fld('pd-pemail','Personal email','')
    + fld('pd-phone','Contact number','+60…')
    + '<div style="border-top:1px solid #F1F5F9;margin:6px 0 14px;"></div>'
    + fld('pd-bankname','Bank name','e.g. Maybank')
    + fld('pd-bankacc','Bank account number','')
    + '<div style="margin-bottom:12px;"><label style="font-size:11px;color:#6B7280;text-transform:uppercase;letter-spacing:.04em;font-weight:600;">Mailing address</label>'
    +   '<textarea id="pd-addr" rows="2" style="width:100%;margin-top:4px;padding:9px 12px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px;box-sizing:border-box;resize:vertical;"></textarea></div>'
    + '<div style="display:flex;gap:10px;margin-top:8px;">'
    +   '<button onclick="detailsSave(\'' + advId + '\')" style="flex:1;padding:11px;background:#0B2545;color:#fff;border:none;border-radius:9px;font-size:13px;font-weight:700;cursor:pointer;">&#128190; Save</button>'
    +   '<button onclick="document.getElementById(\'pd-overlay\').remove()" style="padding:11px 18px;background:#F1F5F9;color:#374151;border:none;border-radius:9px;font-size:13px;font-weight:600;cursor:pointer;">Cancel</button>'
    + '</div></div>';
  ov.addEventListener("click", function(e){ if (e.target === ov) ov.remove(); });
  document.body.appendChild(ov);
  document.getElementById("pd-email").value    = a.email || '';
  document.getElementById("pd-pemail").value   = a.personalEmail || '';
  document.getElementById("pd-phone").value    = a.phone || '';
  document.getElementById("pd-bankname").value = a.bankName || '';
  document.getElementById("pd-bankacc").value  = a.bankAccount || '';
  document.getElementById("pd-addr").value     = a.mailingAddress || '';
}
function detailsSave(advId) {
  var a = ADVISERS[advId]; if (!a) return;
  var v = function(id){ var el=document.getElementById(id); return el ? el.value.trim() : ''; };
  a.email          = v('pd-email');
  a.personalEmail  = v('pd-pemail');
  a.phone          = v('pd-phone');
  a.bankName       = v('pd-bankname');
  a.bankAccount    = v('pd-bankacc');
  a.mailingAddress = v('pd-addr');
  apiPut("/api/advisers/" + advId, {
    name:a.name, initials:a.initials, rank:a.rank, category:a.category,
    ifast:a.ifast||"", cmsrl:a.cmsrl||"", email:a.email, personal_email:a.personalEmail,
    phone:a.phone, must_change_pass:a.mustChangePass?1:0,
    upline_manager:a.uplineManager||null, upline_vp:a.uplineVP||null,
    bank_name:a.bankName, bank_account:a.bankAccount, mailing_address:a.mailingAddress
  }).then(function(){ showToast("success","Saved personal details: " + a.name); });
  var ov = document.getElementById("pd-overlay"); if (ov) ov.remove();
  renderAdminPanel();
}
// Email an adviser a private self-service link to review / complete their details. Preview, then send.
async function reqParticulars(advId){
  document.querySelectorAll('[id^="advmenu-"]').forEach(function(m){ m.style.display='none'; });
  try{
    var p = await apiPost("/api/advisers/"+advId+"/request-particulars", {dry_run:true});
    if(p.error) throw new Error(p.error);
    var miss = (p.missing&&p.missing.length) ? p.missing.join(", ") : "nothing missing — asks them to confirm";
    if(!confirm("Send a 'complete your details' email?\n\nTo: "+p.to+"  (cc lifa.gan@gmail.com)\nStill needed: "+miss+"\n\nThey get a private link to fill in their details, which save straight into the system.")) return;
    var r = await apiPost("/api/advisers/"+advId+"/request-particulars", {});
    if(r.error||r.ok===false) throw new Error(r.error||"Send failed");
    showToast("success","Sent to "+r.to);
  }catch(e){ showToast("error", e.message||"Failed"); }
}
// Send the details-request email to every active adviser missing information.
async function reqParticularsAll(){
  var ids = Object.keys(ADVISERS).filter(function(id){ var a=ADVISERS[id]; return a && !a.terminated && /^LIFA/.test(id); });
  if(!confirm("Email a 'complete your details' link to all "+ids.length+" active advisers (cc lifa.gan@gmail.com)? Each gets a private link that saves straight into the system.")) return;
  var sent=0, failed=0;
  for(const id of ids){
    try{ var r=await apiPost("/api/advisers/"+id+"/request-particulars", {}); if(r.ok) sent++; else failed++; }
    catch(e){ failed++; }
  }
  showToast(failed?"error":"success", "Details-request sent: "+sent+(failed?(" · "+failed+" failed"):""));
}
function openTierModal(advId) {
  var ex = document.getElementById("tm-overlay");
  if (ex) ex.remove();

  var adv = ADVISERS[advId];
  if (!adv) return;
  var cat = adv.category || (adv.rank === "EXCOMM" ? "EXCOMM" : "WP");
  var ytd = YTD[advId] || {ytd_personal:0, mtd_personal:0, ytd_direct:0, ytd_district:0};

  // Build filtered upline options
  // Manager: only MGR, VP, EXCOMM eligible. VP: only VP, EXCOMM eligible.
  function advCat(k) { return ADVISERS[k] ? (ADVISERS[k].category || (ADVISERS[k].rank === 'EXCOMM' ? 'EXCOMM' : 'WP')) : 'WP'; }
  function uOptsMgr(cur) {
    var s = '<option value=""' + (!cur ? " selected" : "") + '>— None —</option>'
          + '<option value="COMPANY"' + (cur === "COMPANY" ? " selected" : "") + '>Company Direct</option>';
    Object.keys(ADVISERS).forEach(function(k) {
      if (k === advId) return;
      var ac = advCat(k);
      if (ac === 'MGR' || ac === 'VP' || ac === 'EXCOMM') {
        s += '<option value="' + k + '"' + (cur === k ? " selected" : "") + '>'
           + ADVISERS[k].name + ' (' + k + ') — ' + ac + '</option>';
      }
    });
    return s;
  }
  function uOptsVP(cur) {
    var s = '<option value=""' + (!cur ? " selected" : "") + '>— None —</option>'
          + '<option value="COMPANY"' + (cur === "COMPANY" ? " selected" : "") + '>Company Direct</option>';
    Object.keys(ADVISERS).forEach(function(k) {
      if (k === advId) return;
      var ac = advCat(k);
      if (ac === 'VP' || ac === 'EXCOMM') {
        s += '<option value="' + k + '"' + (cur === k ? " selected" : "") + '>'
           + ADVISERS[k].name + ' (' + k + ') — ' + ac + '</option>';
      }
    });
    return s;
  }
  // If manager is EXCOMM, VP auto-locks to same (20% fixed, no further indirect)
  var mgrIsEXCOMM_cur = adv.uplineManager && adv.uplineManager !== 'COMPANY' && (advCat(adv.uplineManager) === 'EXCOMM');

  var wt = getWPTier(ytd.ytd_personal);
  var mt = getMgrTier(ytd.ytd_direct);
  var vt = getVPTier(ytd.ytd_district);

  var isDirect   = (cat === "MGR" || cat === "VP");
  var isDistrict = (cat === "VP");
  var hasUpline  = (cat !== "EXCOMM");

  var ov = document.createElement("div");
  ov.id = "tm-overlay";
  ov.style.cssText = "display:flex;position:fixed;inset:0;background:rgba(11,37,69,0.72);z-index:9999;align-items:center;justify-content:center;";

  var box = document.createElement("div");
  box.style.cssText = "background:#fff;border-radius:16px;padding:30px 28px;width:520px;max-width:94vw;max-height:88vh;overflow-y:auto;box-shadow:0 24px 64px rgba(0,0,0,0.28);";

  box.innerHTML =
    // Title
    '<div style="font-size:17px;font-weight:700;color:#0B2545;margin-bottom:2px;">&#9881; Commission Settings</div>'
  + '<div style="font-size:12px;color:#9CA3AF;margin-bottom:18px;">' + adv.name + ' &nbsp;·&nbsp; ' + advId + '</div>'

  // ── Rank dropdown ──
  + '<div style="margin-bottom:14px;">'
  + '<label style="display:block;font-size:11px;font-weight:700;color:#6B7280;text-transform:uppercase;letter-spacing:.05em;margin-bottom:5px;">Rank / Category</label>'
  + '<select id="tm-cat" onchange="tmCC()" style="width:100%;padding:10px 14px;border:2px solid #0B2545;border-radius:8px;font-size:13px;font-weight:600;cursor:pointer;background:#fff;">'
  + '<option value="WP"'     + (cat==="WP"     ? " selected":"") + '>&#127775; Wealth Planner — Personal Sales only</option>'
  + '<option value="MGR"'    + (cat==="MGR"    ? " selected":"") + '>&#128084; Manager — Personal Sales + Direct Overriding</option>'
  + '<option value="VP"'     + (cat==="VP"     ? " selected":"") + '>&#127963; Vice President — Personal + Direct + Indirect Overriding</option>'
  + '<option value="EXCOMM"' + (cat==="EXCOMM" ? " selected":"") + '>&#127775; EXCOMM — Fixed 80% personal, 20% LIFA retention</option>'
  + '</select>'
  + '<div id="tm-cat-hint" style="font-size:11px;margin-top:5px;padding:6px 10px;border-radius:6px;background:#F0FDF4;color:#166534;">'
  + tmCatHint(cat) + '</div></div>'

  // ── YTD Revenue ──
  + '<div style="background:#F8FAFC;border-radius:10px;padding:14px;margin-bottom:14px;">'
  + '<div style="font-size:11px;font-weight:700;color:#0B2545;text-transform:uppercase;letter-spacing:.05em;margin-bottom:10px;">&#128202; Revenue Figures</div>'
  + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">'

  + '<div><label style="font-size:11px;color:#6B7280;font-weight:600;">YTD Personal Sales (RM)</label>'
  + '<input id="tm-yp" type="number" min="0" step="0.01" value="' + ytd.ytd_personal + '" style="width:100%;margin-top:3px;padding:8px 10px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px;box-sizing:border-box;">'
  + '<div style="font-size:10px;color:#166534;margin-top:2px;">&#9679; ' + (cat === "EXCOMM" ? "EXCOMM — 80%" : wt.rank + ' — ' + Math.round(wt.rate*100) + '%') + '</div></div>'

  + '<div><label style="font-size:11px;color:#6B7280;font-weight:600;">MTD Personal Sales (RM)</label>'
  + '<input id="tm-mp" type="number" min="0" step="0.01" value="' + ytd.mtd_personal + '" style="width:100%;margin-top:3px;padding:8px 10px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px;box-sizing:border-box;"></div>'

  + '<div id="tm-df" style="' + (isDirect ? "" : "display:none;") + '">'
  + '<label style="font-size:11px;color:#6B7280;font-weight:600;">YTD Direct Team Revenue (RM)</label>'
  + '<input id="tm-yd" type="number" min="0" step="0.01" value="' + ytd.ytd_direct + '" style="width:100%;margin-top:3px;padding:8px 10px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px;box-sizing:border-box;">'
  + '<div style="font-size:10px;color:#1D4ED8;margin-top:2px;">&#9679; ' + mt.rank + ' — ' + Math.round(mt.rate*100) + '%</div></div>'

  + '<div id="tm-vf" style="' + (isDistrict ? "" : "display:none;") + '">'
  + '<label style="font-size:11px;color:#6B7280;font-weight:600;">YTD District Group Revenue (RM)</label>'
  + '<input id="tm-yv" type="number" min="0" step="0.01" value="' + ytd.ytd_district + '" style="width:100%;margin-top:3px;padding:8px 10px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px;box-sizing:border-box;">'
  + '<div style="font-size:10px;color:#7C3AED;margin-top:2px;">&#9679; ' + vt.rank + ' — ' + Math.round(vt.rate*100) + '%</div></div>'

  + '</div></div>'

  // ── Upline (WP / MGR / VP only) ──
  + '<div id="tm-upline" style="' + (hasUpline ? "" : "display:none;") + '">'
  + '<div style="font-size:11px;font-weight:700;color:#0B2545;text-transform:uppercase;letter-spacing:.05em;margin-bottom:4px;">Upline Assignment</div>'
  + '<div style="font-size:11px;color:#6B7280;margin-bottom:10px;padding:6px 10px;background:#FFF7ED;border-radius:6px;border-left:3px solid #F59E0B;">&#8505; <b>Manager</b>: MGR / VP / EXCOMM only &nbsp;|&nbsp; <b>VP</b>: VP / EXCOMM only. If Manager is EXCOMM, VP auto-locks to same — 20% fixed, no further indirect overriding.</div>'
  + '<div style="margin-bottom:10px;"><label style="font-size:11px;color:#6B7280;font-weight:600;">Upline Manager — MGR / VP / EXCOMM only (earns direct overriding)</label>'
  + '<select id="tm-mgr" onchange="tmMgrChanged()" style="width:100%;margin-top:3px;padding:9px 12px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px;">' + uOptsMgr(adv.uplineManager) + '</select></div>'
  + '<div id="tm-vp-wrap"><label style="font-size:11px;color:#6B7280;font-weight:600;">Upline Vice President — VP / EXCOMM only (earns indirect overriding)</label>'
  + '<select id="tm-vp" style="width:100%;margin-top:3px;padding:9px 12px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px;' + (mgrIsEXCOMM_cur ? 'background:#F3F4F6;pointer-events:none;opacity:0.6;' : '') + '">' + uOptsVP(mgrIsEXCOMM_cur ? adv.uplineManager : adv.uplineVP) + '</select>'
  + (mgrIsEXCOMM_cur ? '<div style="font-size:10px;color:#92400E;margin-top:3px;">&#128274; Auto-set to same as Manager — EXCOMM absorbs full 20%, no separate VP overriding.</div>' : '')
  + '</div>'
  + '</div>'

  // ── Buttons ──
  + '<div style="display:flex;gap:10px;margin-top:20px;">'
  + '<button onclick="tmSave(\'' + advId + '\')" style="flex:1;padding:11px;background:#0B2545;color:#fff;border:none;border-radius:9px;font-size:13px;font-weight:700;cursor:pointer;">&#128190; Save Settings</button>'
  + '<button onclick="document.getElementById(\'tm-overlay\').remove()" style="padding:11px 20px;background:#F3F4F6;color:#374151;border:none;border-radius:9px;font-size:13px;cursor:pointer;">Cancel</button>'
  + '</div>';

  ov.appendChild(box);
  // Close on backdrop click
  ov.addEventListener("click", function(e) { if (e.target === ov) ov.remove(); });
  document.body.appendChild(ov);
}

function tmCatHint(c) {
  if (c === "WP")     return "Shows personal sales tier only (50% / 60% / 70% based on YTD personal revenue)";
  if (c === "MGR")    return "Shows personal sales tier + direct overriding tier (6% / 10% / 12% based on direct team YTD)";
  if (c === "VP")     return "Shows all 3 tiers: personal sales, direct overriding + indirect overriding (2% / 4% / 6% based on district group YTD)";
  if (c === "EXCOMM") return "Fixed 80% personal commission (LIFA retains 20% of personal). Earns 20% overriding on direct downlines' gross — 12% when a Manager is in between (Manager gets 8%, total still 20%).";
  return "";
}

function tmMgrChanged() {
  var mgrSel = document.getElementById("tm-mgr");
  var vpSel  = document.getElementById("tm-vp");
  var vpWrap = document.getElementById("tm-vp-wrap");
  if (!mgrSel || !vpSel) return;
  var mgrVal = mgrSel.value;
  // Check if selected manager is EXCOMM
  var isExcomm = mgrVal && mgrVal !== "COMPANY" && ADVISERS[mgrVal]
    && (ADVISERS[mgrVal].category === "EXCOMM" || ADVISERS[mgrVal].rank === "EXCOMM");
  if (isExcomm) {
    // Auto-set VP to same as manager, lock the dropdown
    vpSel.value = mgrVal;
    vpSel.style.background = "#F3F4F6";
    vpSel.style.opacity = "0.6";
    vpSel.style.pointerEvents = "none";
    // Show lock notice
    var note = document.getElementById("tm-vp-note");
    if (!note) {
      note = document.createElement("div");
      note.id = "tm-vp-note";
      note.style.cssText = "font-size:10px;color:#92400E;margin-top:3px;";
      vpWrap.appendChild(note);
    }
    note.textContent = "\uD83D\uDD12 Auto-set to same as Manager — EXCOMM absorbs full 20%, no separate VP overriding.";
  } else {
    // Unlock VP dropdown
    vpSel.style.background = "";
    vpSel.style.opacity = "";
    vpSel.style.pointerEvents = "";
    var note = document.getElementById("tm-vp-note");
    if (note) note.remove();
  }
}

function tmCC() {
  var c = document.getElementById("tm-cat").value;
  document.getElementById("tm-upline").style.display = (c === "EXCOMM") ? "none" : "";
  document.getElementById("tm-df").style.display     = (c === "MGR" || c === "VP") ? "" : "none";
  document.getElementById("tm-vf").style.display     = (c === "VP") ? "" : "none";
  var hint = document.getElementById("tm-cat-hint");
  if (hint) {
    hint.textContent = tmCatHint(c);
    hint.style.background = c === "EXCOMM" ? "#FEF3C7" : "#F0FDF4";
    hint.style.color       = c === "EXCOMM" ? "#92400E" : "#166534";
  }
}

function tmSave(advId) {
  var c   = document.getElementById("tm-cat").value;
  var mgr = (c === "EXCOMM") ? null : (document.getElementById("tm-mgr").value || null);
  // If manager is EXCOMM, VP auto-set to same manager (20% fixed, no separate indirect)
  var mgrIsEXCOMM_save = mgr && mgr !== "COMPANY" && ADVISERS[mgr]
    && (ADVISERS[mgr].category === "EXCOMM" || ADVISERS[mgr].rank === "EXCOMM");
  var vp = (c === "EXCOMM") ? null : (mgrIsEXCOMM_save ? mgr : (document.getElementById("tm-vp").value || null));

  if (!YTD[advId]) YTD[advId] = {ytd_personal:0, mtd_personal:0, ytd_direct:0, ytd_district:0};
  YTD[advId].ytd_personal = parseFloat(document.getElementById("tm-yp").value) || 0;
  YTD[advId].mtd_personal = parseFloat(document.getElementById("tm-mp").value) || 0;
  YTD[advId].ytd_direct   = (c==="MGR"||c==="VP") ? (parseFloat(document.getElementById("tm-yd").value)||0) : 0;
  YTD[advId].ytd_district = (c==="VP")             ? (parseFloat(document.getElementById("tm-yv").value)||0) : 0;

  ADVISERS[advId].category      = c;
  ADVISERS[advId].uplineManager = mgr;
  ADVISERS[advId].uplineVP      = vp;

  // Set rank based on category and YTD
  if (c === "EXCOMM") {
    ADVISERS[advId].rank = "EXCOMM";
  } else if (c === "MGR") {
    var mt = getMgrTier(YTD[advId].ytd_direct);
    ADVISERS[advId].rank = mt.rank; // Manager / Senior Manager / Partner
  } else if (c === "VP") {
    var vt = getVPTier(YTD[advId].ytd_district);
    ADVISERS[advId].rank = vt.rank; // Vice President / Senior VP / Senior Partner
  } else {
    ADVISERS[advId].rank = getWPTier(YTD[advId].ytd_personal).rank;
  }

  // Persist to backend (previously this modal only mutated memory, so changes reverted on reload).
  // Bank/address are intentionally omitted — the backend COALESCEs them so they're preserved.
  var A = ADVISERS[advId];
  apiPut("/api/advisers/" + advId, {
    name:A.name, initials:A.initials, rank:A.rank, category:A.category,
    ifast:A.ifast||"", cmsrl:A.cmsrl||"", email:A.email, personal_email:A.personalEmail||"",
    phone:A.phone||"", must_change_pass:A.mustChangePass?1:0,
    upline_manager:A.uplineManager||null, upline_vp:A.uplineVP||null
  });
  apiPut("/api/ytd/" + advId, YTD[advId]);

  document.getElementById("tm-overlay").remove();
  renderAdminPanel();
  showToast("success", "Saved: " + ADVISERS[advId].name + " → " + ADVISERS[advId].rank);
}


function viewAsAdviser(id) {
  const prev = currentUser;
  currentUser = id;
  isAdmin = false;
  isAdminPreview = true;

  // Show adviser nav, hide admin nav
  document.getElementById("admin-nav-section").style.display = "none";
  document.getElementById("admin-nav-section-2").style.display = "none";
  document.getElementById("nav-dashboard").style.display = "";
  document.getElementById("nav-statements").style.display = "";
  // CPE Compliance (a scroll to the dashboard card) and the sidebar Statements list
  // duplicated Dashboard / Commission Statement — off the menu (walkthrough 29 Oct 2026).
  document.getElementById("sidebar-badge").style.display = "";
  document.getElementById("nav-admin").classList.remove("active");

  initApp();

  // Add a "Back to Admin" banner
  const banner = document.createElement("div");
  banner.id = "preview-banner";
  banner.style.cssText = "position:fixed;top:0;left:0;right:0;background:#B8962E;color:#0B2545;text-align:center;padding:8px;font-size:12px;font-weight:700;z-index:8888;";
  banner.innerHTML = `👁 Previewing as ${escapeHtml(ADVISERS[id].name)} &nbsp;<button onclick="backToAdmin()" style="background:#0B2545;color:#fff;border:none;border-radius:6px;padding:3px 12px;cursor:pointer;font-size:11px;font-weight:700;">Back to Advisers</button>`;
  document.body.prepend(banner);
}

function backToAdmin() {
  const banner = document.getElementById("preview-banner");
  if(banner) banner.remove();
  currentUser = "ADMIN";
  isAdmin = true;
  isAdminPreview = false;
  initAdminApp();
}

// ── Add Adviser Modal ─────────────────────────────────────────────────────────
function openAddAdviserModal() {
  // Build a simple inline modal
  const overlay = document.createElement("div");
  overlay.id = "add-adviser-overlay";
  overlay.className = "modal-overlay open";
  overlay.innerHTML = `
    <div class="modal-box" style="width:500px;">
      <div class="modal-title">Add New Adviser</div>
      <div class="modal-sub">New adviser will receive login credentials by email.</div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">
        <div class="modal-field"><label>LIFA ID *</label><input id="new-lifa-id" placeholder="e.g. LIFA007"/></div>
        <div class="modal-field"><label>Full Name *</label><input id="new-name" placeholder="FULL NAME IN CAPS"/></div>
        <div class="modal-field"><label>Corporate Email *</label><input id="new-corp-email" placeholder="name@lifa.com.my"/></div>
        <div class="modal-field"><label>Personal Email *</label><input id="new-pers-email" placeholder="personal@gmail.com"/></div>
        <div class="modal-field"><label>CMSRL No</label><input id="new-cmsrl" placeholder="eCMSRL/C0000/2025"/></div>
        <div class="modal-field"><label>iFAST ID</label><input id="new-ifast" placeholder="LFA00000"/></div>
        <div class="modal-field"><label>Display Name</label><input id="new-display-name" placeholder="e.g. Chin Soon"/></div>
        <div class="modal-field"><label>Contact Number</label><input id="new-contact" placeholder="e.g. 0121234567"/></div>
        <div class="modal-field"><label>Category</label>
          <select id="new-category" style="width:100%;padding:10px 14px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;box-sizing:border-box;">
            <option value="WP">Wealth Planner (WP) — 50%</option>
            <option value="EXCOMM">Executive Comm (EXCOMM) — 80%</option>
          </select>
        </div>
        <div class="modal-field"><label>Temp Password</label><input id="new-temp-pass" placeholder="Leave blank to auto-generate"/></div>
      </div>
      <div class="modal-err" id="add-adviser-err"></div>
      <button class="modal-btn primary" onclick="submitAddAdviser()" style="margin-top:8px;">Add Adviser & Send Welcome Email</button>
      <button class="modal-btn ghost" onclick="document.getElementById('add-adviser-overlay').remove()">Cancel</button>
    </div>
  `;
  document.body.appendChild(overlay);
}

function submitAddAdviser() {
  const id       = document.getElementById("new-lifa-id").value.trim().toUpperCase();
  const name     = document.getElementById("new-name").value.trim().toUpperCase();
  const corp     = document.getElementById("new-corp-email").value.trim().toLowerCase();
  const pers     = document.getElementById("new-pers-email").value.trim().toLowerCase();
  const cmsrl    = document.getElementById("new-cmsrl").value.trim();
  const ifast    = document.getElementById("new-ifast").value.trim();
  const displayName = document.getElementById("new-display-name").value.trim();
  const contact  = document.getElementById("new-contact").value.trim();
  const cat      = document.getElementById("new-category").value;
  let   tmpPass  = document.getElementById("new-temp-pass").value.trim();
  const err      = document.getElementById("add-adviser-err");

  if(!id||!name||!corp||!pers){err.textContent="LIFA ID, Name, and both emails are required.";return;}
  if(ADVISERS[id]){err.textContent=`${id} already exists.`;return;}
  if(!corp.endsWith("@lifa.com.my")){err.textContent="Corporate email must be @lifa.com.my";return;}

  if(!tmpPass) tmpPass = generateTempPassword();

  // Add to ADVISERS
  const rate = cat==="EXCOMM"?0.8:0.5;
  const rank = cat==="EXCOMM"?"EXCOMM":"Wealth Planner";
  const parts = name.split(" ");
  const initials = (parts[0][0]+(parts[parts.length-1][0])).toUpperCase();

  const newAdviser = {
    name, initials, rank, ifast, cmsrl,
    email: corp, personalEmail: pers,
    displayName: displayName || name.split(" ")[0],
    contact,
    pass: tmpPass, mustChangePass: true
  };
  ADVISERS[id] = newAdviser;
  STATEMENTS[id] = [];

  // Create in D1 (POST = INSERT OR REPLACE, hashes the password), then email the
  // welcome (login + temp password) via Resend — no EmailJS.
  showToast("sending", "Saving "+name+" and sending welcome email…");
  apiPost("/api/advisers", {
    id, name, initials, rank, category: cat,
    ifast, cmsrl,
    email: corp, personal_email: pers,
    phone: contact||null,
    pass: tmpPass, must_change_pass: 1,
    upline_manager: null, upline_vp: null
  })
    .then(function(){
      return apiPost("/api/advisers/" + id + "/reset-password", { password: tmpPass, forceChange: true });
    })
    .then(function(res){
      if (res && res.ok) {
        showToast("success", "✓ " + name + " added. Welcome email sent to " + corp + (res.personalSent ? " + personal email" : "") + ".");
      } else {
        showToast("error", "⚠ " + name + " saved, but welcome email failed: " + ((res && res.error) || "unknown") + ".");
      }
      if (typeof loadAllData === "function") loadAllData();
    })
    .catch(function(e){ showToast("error", "⚠ " + name + " — error: " + e); });

  document.getElementById("add-adviser-overlay").remove();
  // Rebuild sidebar AND panel so new adviser appears immediately
  initAdminApp();
}

// ── Remove Adviser ────────────────────────────────────────────────────────────
function terminateAdviser(id) {
  var adv = ADVISERS[id] || {};
  if(!confirm("Mark " + (adv.name || id) + " as TERMINATED?\n\nThey move to the Terminated Advisers section and are hidden from the active list, sidebar and commission generation. Records are kept — you can Reinstate them later.")) return;
  apiPost("/api/advisers/" + id + "/terminate", { terminated: true }).then(function(r){
    if (r && r.ok) { showToast("success", "✓ " + (adv.name || id) + " terminated."); loadAllData().then(function(){ renderAdminPanel(); }); }
    else { showToast("error", "✗ " + ((r && r.error) || "Failed to terminate")); }
  }).catch(function(e){ showToast("error", "✗ " + e); });
}
function reinstateAdviser(id) {
  var adv = ADVISERS[id] || {};
  if(!confirm("Reinstate " + (adv.name || id) + " as an active adviser?")) return;
  apiPost("/api/advisers/" + id + "/terminate", { terminated: false }).then(function(r){
    if (r && r.ok) { showToast("success", "✓ " + (adv.name || id) + " reinstated."); loadAllData().then(function(){ renderAdminPanel(); }); }
    else { showToast("error", "✗ " + ((r && r.error) || "Failed to reinstate")); }
  }).catch(function(e){ showToast("error", "✗ " + e); });
}

async function confirmRemoveAdviser(id) {
  const adv = ADVISERS[id];
  if(!confirm(`Remove ${adv.name} (${id}) from the portal?\n\nThis cannot be undone.`)) return;
  // Delete from D1 FIRST and only update the UI if it actually succeeded — otherwise
  // the row silently reappears on reload (and orphan compliance data is left behind).
  try {
    const r = await apiPost("/api/advisers/" + id + "/delete", {});
    if (r && r.error) throw new Error(r.error);
    delete ADVISERS[id];
    delete STATEMENTS[id];
    renderAdminPanel();
    showToast("success", `✓ ${adv.name} removed from portal.`);
  } catch (e) {
    showToast("error", `Could not remove ${adv.name}: ${e.message || e}`);
  }
}






// ══════════════════════════════════════════════════════════════════════════════
// UPLOAD PANEL v4
//
// COMMISSION CYCLE:
//   iFAST 25th of month  → 1st half of SAME month  (23-Jan → Jan 1–15)
//   iFAST  9th of month  → 2nd half of PREV month  (10-Feb → Jan 16–31)
//   Phillip 12th of month→ full statement of PREV month (12-Feb → Jan)
//   Trailer / Wrap Fees  → always same earning month as the ZIP they come from
//
//   iFAST sends password-protected ZIP (password: LFA888)
//   Drop the ZIP directly — files extracted and parsed automatically
// ══════════════════════════════════════════════════════════════════════════════

var UP_FILTER = { month: "all" };
var MONTH_NAMES = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

// ── Detect earning month + role from filename ─────────────────────────────────
// COMMISSION CYCLE:
//   iFAST ~25th of month  → 1st half of SAME month   (23-Jan → Jan 01–15)
//   iFAST ~10th of month  → 2nd half of PREV month   (10-Feb → Jan 16–31)
//   Trailer / WrapFees    → always same earning month as the ZIP they come from
//   Phillip ~12th of month→ full statement of PREV month (12-Feb → Jan)
//
// RULE: if issueDay ≤ 15 → 2nd half of prev month
//       if issueDay > 15 → 1st half of same month
var MONTH_FULL = ["January","February","March","April","May","June","July","August","September","October","November","December"];
function upDetectFileRole(filename, zipDateHint) {
  var fn = filename.toLowerCase();
  var isPhillip  = /pmb|phillip/i.test(fn) || fn.endsWith(".pdf");
  var isTrailer  = /trailer/i.test(fn);
  var isWrapFees = /wrap.?fee/i.test(fn);
  var isBond     = /bond/i.test(fn) && !isTrailer && !isWrapFees;
  var isDPMS     = /dpms/i.test(fn);
  var isStock    = /stock/i.test(fn);

  var fileType = isTrailer ? "Trailer" : isWrapFees ? "WrapFees"
               : isDPMS ? "DPMS" : isStock ? "Stock" : isBond ? "Bond" : "UT";

  // Helper: derive earning month from an issue date string "DD-Mon-YYYY"
  function fromIssueDate(dateStr) {
    var dm = dateStr && dateStr.match(/(\d{1,2})-([A-Za-z]{3})-(\d{4})/);
    if (!dm) return null;
    var day  = parseInt(dm[1]);
    var mon  = MONTH_NAMES.findIndex(function(m){ return m.toLowerCase()===dm[2].toLowerCase(); });
    var year = parseInt(dm[3]);
    if (mon < 0) return null;
    if (isPhillip || day <= 15) {
      // issued on/before 15th → earning month = previous month
      var pm = mon === 0 ? 11 : mon - 1;
      var py = mon === 0 ? year-1 : year;
      return { earningMonth: MONTH_NAMES[pm]+" "+py, role: isPhillip?"Phillip":"2nd",
               label: isPhillip?"Phillip":"iFAST 2nd Half" };
    } else {
      // issued after 15th → earning month = same month
      return { earningMonth: MONTH_NAMES[mon]+" "+year, role:"1st", label:"iFAST 1st Half" };
    }
  }

  var earningMonth = null, role = null, label = fileType;

  // 1. Try DD-Mon-YYYY date from filename
  var dm = filename.match(/(\d{1,2})-([A-Za-z]{3})-(\d{4})/);
  var fromFile = dm ? fromIssueDate(dm[0]) : null;

  // 2. For Phillip: also try full month name "January_2026" or "January 2026" in filename
  if (isPhillip && !fromFile) {
    for (var mi = 0; mi < MONTH_FULL.length; mi++) {
      var mre = new RegExp(MONTH_FULL[mi]+"[_\\s](\\d{4})", "i");
      var mm = filename.match(mre);
      if (mm) {
        fromFile = { earningMonth: MONTH_NAMES[mi]+" "+mm[1], role:"Phillip", label:"Phillip" };
        break;
      }
    }
  }

  // 3. For Trailer/WrapFees: ALWAYS use zipDateHint if available (same ZIP = same earning period)
  if (isTrailer || isWrapFees) {
    var src = zipDateHint ? fromIssueDate(zipDateHint) : (fromFile || null);
    if (src) {
      earningMonth = src.earningMonth;
      role = isTrailer ? "Trailer" : "WrapFees";
      label = isTrailer ? "Trailer" : "Wrap Fees";
    } else {
      // No date hint at all — default to last month
      var now = new Date();
      var em = now.getMonth() === 0 ? 11 : now.getMonth() - 1;
      var ey = now.getMonth() === 0 ? now.getFullYear()-1 : now.getFullYear();
      earningMonth = MONTH_NAMES[em] + " " + ey;
      role = isTrailer ? "Trailer" : "WrapFees";
      label = isTrailer ? "Trailer" : "Wrap Fees";
    }
  } else if (fromFile) {
    earningMonth = fromFile.earningMonth;
    role = fromFile.role;
    label = fromFile.label;
  } else if (zipDateHint) {
    // File has no date in name but came from a dated ZIP — use ZIP date
    var fromZip = fromIssueDate(zipDateHint);
    if (fromZip) { earningMonth = fromZip.earningMonth; role = fromZip.role; label = fromZip.label; }
  }

  return { earningMonth:earningMonth, role:role||fileType, label:label,
           fileType:fileType, isPhillip:isPhillip };
}
// ── Derive earning month from the internal Commission Received Date in the file ──
// e.g. "01-Jan-2026 - 15-Jan-2026" → "Jan 2026"  (1st half)
//      "16-Jan-2026 - 31-Jan-2026" → "Jan 2026"  (2nd half)
// "Aug 2026" -> "2026-08" (the inbox row's period key). Null if not a month label.
function _ymFromMonthLabel(label) {
  var p = String(label||"").trim().split(/\s+/); if (p.length !== 2) return null;
  var mi = MONTH_NAMES.findIndex(function(m){ return m.toLowerCase()===p[0].toLowerCase(); });
  var y = parseInt(p[1], 10); if (mi < 0 || !y) return null;
  return y + "-" + String(mi+1).padStart(2, "0");
}
function upEarningMonthFromDateRange(dateRange) {
  if (!dateRange) return null;
  // Take the END date of the range (or only date if single)
  var parts = dateRange.split(" - ");
  var endDate = parts[parts.length - 1].trim();
  var dm = endDate.match(/(\d{1,2})-([A-Za-z]{3})-(\d{4})/);
  if (!dm) return null;
  var mon = MONTH_NAMES.findIndex(function(m){ return m.toLowerCase()===dm[2].toLowerCase(); });
  if (mon < 0) return null;
  return MONTH_NAMES[mon] + " " + dm[3];
}

// ── Month helpers ─────────────────────────────────────────────────────────────
function upGetActiveMonths() {
  var seen = {};
  ["iFAST","Phillip"].forEach(function(p) {
    Object.keys(UPLOADS[p]).forEach(function(m) { seen[m] = true; });
  });
  // Always include current month
  var now = new Date();
  seen[MONTH_NAMES[now.getMonth()]+" "+now.getFullYear()] = true;
  return Object.keys(seen).sort(function(a,b){
    var sa=a.split(" "), sb=b.split(" ");
    var y=parseInt(sa[1])-parseInt(sb[1]);
    return y!==0?y:MONTH_NAMES.indexOf(sa[0])-MONTH_NAMES.indexOf(sb[0]);
  });
}

// Switch upload month from the year/month pickers
function upSetYear(yr) {
  UP_FILTER._selYear = parseInt(yr);
  // Reset month to first available in that year, or current month if same year
  var now = new Date();
  var curYear = now.getFullYear();
  var curMonthIdx = now.getMonth();
  if (parseInt(yr) === curYear) {
    UP_FILTER.month = MONTH_NAMES[curMonthIdx] + " " + curYear;
  } else {
    // Pick December of selected past year (latest available past month)
    UP_FILTER.month = MONTH_NAMES[11] + " " + yr;
  }
  renderUploadPanel();
}
function upSetMonth(mon) {
  var yr = UP_FILTER._selYear || new Date().getFullYear();
  UP_FILTER.month = mon + " " + yr;
  renderUploadPanel();
}

function upGetMonthStatus(month) {
  var iFiles = UPLOADS["iFAST"][month]||[];
  var pFiles = UPLOADS["Phillip"][month]||[];
  // A file counts for 1st half if batch ends in "_1st" or IS "1st" (legacy)
  var has1st   = iFiles.some(function(f){ return f.batch==="1st" || (f._role==="1st") || f.batch.endsWith("_1st"); });
  var has2nd   = iFiles.some(function(f){ return f.batch==="2nd" || (f._role==="2nd") || f.batch.endsWith("_2nd"); });
  var hasTrail = iFiles.some(function(f){ return f.batch==="Trailer"; });
  var hasWrap  = iFiles.some(function(f){ return f.batch==="WrapFees"; });
  var hasPMB   = pFiles.length>0;
  var stmtCount= Object.keys(STATEMENTS).filter(function(id){
    return (STATEMENTS[id]||[]).some(function(s){return s.period===month;});
  }).length;
  return {has1st:has1st,has2nd:has2nd,hasTrail:hasTrail,hasWrap:hasWrap,
          hasPMB:hasPMB,ready:hasTrail,stmtCount:stmtCount,
          iFiles:iFiles,pFiles:pFiles};
}

function renderUploadPanel() {
  var now = new Date();
  var curYear  = now.getFullYear();
  var curMonIdx = now.getMonth(); // 0-based

  // Default to current month if no selection yet
  var defaultMonth = MONTH_NAMES[curMonIdx] + " " + curYear;
  if (!UP_FILTER.month || UP_FILTER.month === "all") UP_FILTER.month = defaultMonth;

  // Parse selected month
  var selParts = UP_FILTER.month.split(" ");
  var selMonName = selParts[0];
  var selYear    = parseInt(selParts[1]) || curYear;
  UP_FILTER._selYear = selYear;
  var selMonth = selMonName + " " + selYear;
  UP_FILTER.month = selMonth;

  // Build year options: from 2020 up to current year
  var startYear = 2020;
  var yearOpts = "";
  for (var y = curYear; y >= startYear; y--) {
    yearOpts += '<option value="'+y+'"'+(y===selYear?" selected":"")+'>'+y+'</option>';
  }

  // Build month options: if selected year == current year, only show Jan..current month
  // For past years, show all 12 months
  var monthOpts = "";
  var maxMonIdx = (selYear === curYear) ? curMonIdx : 11;
  for (var mi = maxMonIdx; mi >= 0; mi--) {
    var mn = MONTH_NAMES[mi];
    var ms = upGetMonthStatus(mn + " " + selYear);
    var indicator = ms.stmtCount > 0 ? " ✓" : ms.ready ? " ●" : (ms.iFiles.length||ms.pFiles.length) ? " ·" : "";
    monthOpts += '<option value="'+mn+'"'+(mn===selMonName?" selected":"")+'>'+mn+indicator+'</option>';
  }

  var months = upGetActiveMonths();
  var st = upGetMonthStatus(selMonth);
  var allFiles = st.iFiles.map(function(f){return{partner:"iFAST",f:f};})
    .concat(st.pFiles.map(function(f){return{partner:"Phillip",f:f};}));

  // ── Month selector (year → month dropdowns) ────────────────────────────────
  var statusDot = st.stmtCount>0
    ? '<span style="background:#DCFCE7;color:#166534;padding:2px 9px;border-radius:12px;font-size:11px;font-weight:700;">✓ Generated</span>'
    : st.ready
    ? '<span style="background:#FEF9C3;color:#92400E;padding:2px 9px;border-radius:12px;font-size:11px;font-weight:700;">● Ready</span>'
    : (st.iFiles.length||st.pFiles.length)
    ? '<span style="background:#EDE9FE;color:#6D28D9;padding:2px 9px;border-radius:12px;font-size:11px;font-weight:700;">· In Progress</span>'
    : '<span style="background:#F1F5F9;color:#9CA3AF;padding:2px 9px;border-radius:12px;font-size:11px;font-weight:700;">Empty</span>';

  var monthPickerHtml = '<div style="border-bottom:1px solid #F1F5F9;background:#FAFAFA;padding:14px 20px;display:flex;align-items:center;gap:12px;flex-wrap:wrap;">'
    + '<div style="font-size:12px;font-weight:700;color:#6B7280;text-transform:uppercase;letter-spacing:.05em;">Period:</div>'
    // Year select
    + '<div style="display:flex;align-items:center;gap:6px;">'
    + '<label style="font-size:11px;color:#9CA3AF;font-weight:600;">Year</label>'
    + '<select onchange="upSetYear(this.value)" style="padding:6px 10px;border:1px solid #E2E8F0;border-radius:8px;font-size:13px;font-weight:700;color:#0B2545;background:#fff;cursor:pointer;">'
    + yearOpts + '</select></div>'
    // Month select
    + '<div style="display:flex;align-items:center;gap:6px;">'
    + '<label style="font-size:11px;color:#9CA3AF;font-weight:600;">Month</label>'
    + '<select onchange="upSetMonth(this.value)" style="padding:6px 10px;border:1px solid #E2E8F0;border-radius:8px;font-size:13px;font-weight:700;color:#0B2545;background:#fff;cursor:pointer;">'
    + monthOpts + '</select></div>'
    // Current selection + status badge
    + '<div style="margin-left:4px;font-size:15px;font-weight:800;color:#0B2545;">'+selMonth+'</div>'
    + statusDot
    + '</div>';

  // Checklist
  var items = [
    {key:"1st",     label:"iFAST 1st Half",  sub:"Issued ~25th of earning month",   done:st.has1st,  req:false},
    {key:"2nd",     label:"iFAST 2nd Half",  sub:"Issued ~9th of following month",  done:st.has2nd,  req:false},
    {key:"Trailer", label:"iFAST Trailer",   sub:"Monthly trailer commission file", done:st.hasTrail,req:true },
    {key:"WrapFees",label:"iFAST Wrap Fees", sub:"Monthly wrap fee commission",     done:st.hasWrap, req:false},
    {key:"Phillip", label:"Phillip Mutual",  sub:"Issued ~12th of following month", done:st.hasPMB,  req:false},
  ];
  var checklist = items.map(function(item){
    var files = item.key==="Phillip" ? st.pFiles : st.iFiles.filter(function(f){return f.batch===item.key;});
    var chips = files.map(function(f){
      var short = f.name.replace(/^.{0,20}_/,"").substring(0,32);
      return '<span style="display:inline-flex;align-items:center;gap:4px;background:#F0FDF4;color:#166534;border-radius:5px;padding:2px 8px;font-size:10px;font-weight:600;margin:2px;">'
        +'✓ '+short
        +'<button onclick="upDeleteFile(\''+(item.key==="Phillip"?"Phillip":"iFAST")+'\',\''+selMonth+'\',\''+f.name+'\')" style="background:none;border:none;color:#DC2626;cursor:pointer;font-size:10px;padding:0;margin-left:2px;line-height:1;">✕</button>'
        +'</span>';
    }).join("");
    return '<div style="display:flex;gap:10px;padding:10px 0;border-bottom:1px solid #F1F5F9;align-items:flex-start;">'
      +'<div style="flex-shrink:0;width:22px;height:22px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:12px;margin-top:1px;'
      +(item.done?"background:#DCFCE7;color:#166534;":item.req?"background:#FEF2F2;color:#D1D5DB;":"background:#F9FAFB;color:#D1D5DB;")
      +'">'+(item.done?"✓":"○")+'</div>'
      +'<div style="flex:1;min-width:0;">'
      +'<div style="font-size:13px;font-weight:700;color:'+(item.done?"#166534":"#374151")+';">'+item.label
      +(item.req?"":"&nbsp;<span style='font-size:10px;background:#F1F5F9;color:#9CA3AF;padding:1px 5px;border-radius:3px;font-weight:500;'>optional</span>")
      +'</div>'
      +'<div style="font-size:11px;color:#9CA3AF;">'+item.sub+'</div>'
      +(chips?'<div style="margin-top:4px;display:flex;flex-wrap:wrap;">'+chips+'</div>':"")
      +'</div></div>';
  }).join("");

  // Staged files table rows
  var stagedRows = allFiles.map(function(x){
    var f=x.f; var partner=x.partner;
    var agents = Object.keys(f.agentTotals||{}).length;
    var comm = 0;
    Object.values(f.agentTotals||{}).forEach(function(a){comm+=a.ifast_comm||0;});
    var warn = f.periodWarning?'<span title="'+f.periodWarning+'" style="color:#DC2626;cursor:help;margin-left:3px;">⚠️</span>':"";
    return '<tr style="border-bottom:1px solid #F1F5F9;">'
      +'<td style="padding:9px 10px;max-width:180px;"><div style="font-size:12px;font-weight:600;color:#374151;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" title="'+f.name+'">'+f.name+'</div>'
      +'<div style="margin-top:3px;">'+upBatchLabel(f.batch||f.type)+'</div></td>'
      +'<td style="padding:9px 10px;font-size:12px;color:#6B7280;">'+f.date+warn+'</td>'
      +'<td style="padding:9px 10px;font-size:12px;text-align:right;">'+(agents>0?'<b>'+agents+'</b>':'<span style="color:#DC2626;font-weight:700;">0 ⚠</span>')+'</td>'
      +'<td style="padding:9px 10px;font-size:12px;text-align:right;color:#166534;font-weight:700;">'+(comm>0?'RM'+comm.toFixed(2):"—")+'</td>'
      +'<td style="padding:9px 10px;white-space:nowrap;">'
      +'<button onclick="upViewFile(\''+partner+'\',\''+selMonth+'\',\''+f.name+'\')" style="padding:4px 9px;background:#F0F9FF;border:1px solid #BAE6FD;color:#0369A1;border-radius:6px;font-size:11px;font-weight:600;cursor:pointer;">👁 View</button>'
      +'</td></tr>';
  }).join("");

  var html = '<div style="padding:24px 28px;max-width:1060px;">'

  // Header + cycle info
  +'<div style="margin-bottom:16px;">'
  +'<div style="font-size:21px;font-weight:700;color:#0B2545;">Commission Statements</div>'
  +'<div style="font-size:13px;color:#6B7280;margin-top:2px;">Upload partner files — auto-detected by issue date in filename — then generate agent payouts</div>'
  +'</div>'

  // Cycle reference bar
  // The cycle timings and the ZIP password used to sit on screen permanently —
  // facts the admin already knows, re-read on every visit. They live behind the
  // ℹ️ now: one tap away, never in the way.
  +'<div style="background:#F8FAFC;border:1px solid #E2E8F0;border-radius:10px;padding:10px 16px;margin-bottom:16px;display:flex;gap:10px;flex-wrap:wrap;align-items:center;">'
  +'<div style="font-size:11px;font-weight:700;color:#6B7280;text-transform:uppercase;letter-spacing:.05em;white-space:nowrap;">Cycle</div>'
  +'<span title="~23rd — iFAST 1st half (same month)&#10;~10th — iFAST 2nd half (previous month)&#10;~12th — Phillip (previous month)&#10;&#10;ZIP password: '+IFAST_ZIP_PASS+'" style="cursor:help;font-size:13px">ℹ️</span>'
  +'</div>'

  // Main card
  +'<div style="background:#fff;border-radius:14px;box-shadow:0 2px 16px rgba(0,0,0,.08);overflow:hidden;">'

  // Month picker
  +monthPickerHtml

  // Two-column layout
  +'<div style="display:grid;grid-template-columns:320px 1fr;">'

  // LEFT — checklist + generate
  +'<div style="border-right:1px solid #F1F5F9;padding:20px;display:flex;flex-direction:column;">'
  +'<div style="font-size:13px;font-weight:700;color:#0B2545;margin-bottom:2px;">'+selMonth+' — Required Files</div>'
  +'<div style="font-size:11px;color:#9CA3AF;margin-bottom:12px;">All 4 required files must be staged to generate statements</div>'
  +checklist
  +'<div style="margin-top:auto;padding-top:16px;">'
  +(st.ready||st.stmtCount>0
    ?'<button onclick="upGenerateAll(\''+selMonth+'\')" style="width:100%;padding:11px;background:'+(st.stmtCount>0?"#374151":"#0B2545")+';color:#fff;border:none;border-radius:10px;font-size:14px;font-weight:700;cursor:pointer;">'
      +(st.stmtCount>0?"↻ Regenerate":"⚡ Generate")+" Statements"+'</button>'
    :'<div style="width:100%;padding:11px;background:#F8FAFC;border:2px dashed #E2E8F0;border-radius:10px;text-align:center;font-size:12px;color:#9CA3AF;">Upload required files to enable</div>')
  +(st.stmtCount>0?'<div style="text-align:center;font-size:11px;color:#166534;margin-top:6px;font-weight:700;">✓ '+st.stmtCount+' statement(s) generated</div>':"")
  +(st.stmtCount>0?'<button onclick="upViewGenerated(\''+selMonth+'\')" style="width:100%;margin-top:8px;padding:9px;background:#fff;border:1.5px solid #0B2545;color:#0B2545;border-radius:10px;font-size:12px;font-weight:700;cursor:pointer;">&#128065; View generated statements</button>':"")
  +'</div></div>'

  // RIGHT — drop zone + staged files
  +'<div style="padding:20px;">'

  // Drop zone
  +'<div id="up-drop-zone"'
  +' ondragover="event.preventDefault();this.style.borderColor=\'#0B2545\';this.style.background=\'#EFF6FF\';"'
  +' ondragleave="this.style.borderColor=\'#CBD5E1\';this.style.background=\'#F8FAFC\';"'
  +' ondrop="event.preventDefault();this.style.borderColor=\'#CBD5E1\';this.style.background=\'#F8FAFC\';upHandleDrop(event);"'
  +' onclick="document.getElementById(\'up-file-input\').click();"'
  +' style="border:2px dashed #CBD5E1;border-radius:12px;padding:32px 20px;text-align:center;cursor:pointer;background:#F8FAFC;transition:border-color .15s,background .15s;user-select:none;">'
  +'<div style="font-size:36px;margin-bottom:8px;pointer-events:none;">📦</div>'
  +'<div style="font-size:14px;font-weight:700;color:#374151;pointer-events:none;">Drop files or ZIP here, or click to browse</div>'
  +'<div style="font-size:12px;color:#9CA3AF;margin-top:4px;pointer-events:none;">iFAST ZIP ('+IFAST_ZIP_PASS+' applied automatically) · individual .xlsx · Phillip .pdf</div>'
  +'<div style="margin-top:10px;display:flex;justify-content:center;gap:8px;pointer-events:none;">'
  +'<span style="font-size:11px;background:#FEF3C7;color:#92400E;padding:3px 10px;border-radius:20px;font-weight:700;">📦 .zip</span>'
  +'<span style="font-size:11px;background:#DBEAFE;color:#1D4ED8;padding:3px 10px;border-radius:20px;font-weight:600;">.xlsx</span>'
  +'<span style="font-size:11px;background:#F0FDF4;color:#166534;padding:3px 10px;border-radius:20px;font-weight:600;">.pdf</span>'
  +'</div>'
  +'<div style="margin-top:12px;pointer-events:none;display:inline-flex;align-items:center;gap:6px;background:#FFF7ED;border:1px solid #FED7AA;border-radius:8px;padding:6px 14px;">'
  +'<span style="font-size:12px;">🗓️</span>'
  +'<span style="font-size:11px;font-weight:700;color:#92400E;">Files must belong to: <span style="color:#0B2545;">'+selMonth+'</span></span>'
  +'</div>'
  +'</div>'
  +'<button onclick="upImportFromEmail()" id="up-import-btn" style="width:100%;margin-top:10px;padding:11px;background:#0B2545;color:#fff;border:none;border-radius:10px;font-size:13px;font-weight:700;cursor:pointer;">📥 Import from Gmail</button>'
  +'<div style="text-align:center;font-size:10px;color:#9CA3AF;margin-top:4px;">Auto-fetched from your Gmail <span title="Imports iFAST + Phillip files for '+selMonth+', decrypts them and parses with your existing rules." style="cursor:help">ℹ️</span></div>'
  +'<input type="file" id="up-file-input" multiple accept=".xlsx,.pdf,.zip" style="display:none;" onchange="upHandleInputChange(this);">'
  +'<div id="up-status" style="min-height:20px;margin-top:8px;font-size:12px;line-height:1.6;"></div>'

  // Staged table
  +(allFiles.length
    ?'<div style="margin-top:12px;">'
    +'<div style="font-size:11px;font-weight:700;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:6px;">'+allFiles.length+' File(s) Staged</div>'
    +'<table style="width:100%;border-collapse:collapse;">'
    +'<thead><tr style="background:#F8FAFC;">'
    +'<th style="padding:7px 10px;text-align:left;font-size:10px;color:#9CA3AF;font-weight:600;">File / Type</th>'
    +'<th style="padding:7px 10px;text-align:left;font-size:10px;color:#9CA3AF;font-weight:600;">Period</th>'
    +'<th style="padding:7px 10px;text-align:right;font-size:10px;color:#9CA3AF;font-weight:600;">Agents</th>'
    +'<th style="padding:7px 10px;text-align:right;font-size:10px;color:#9CA3AF;font-weight:600;">Comm</th>'
    +'<th style="padding:7px 10px;font-size:10px;color:#9CA3AF;"></th>'
    +'</tr></thead>'
    +'<tbody>'+stagedRows+'</tbody></table></div>'
    :'<div style="text-align:center;padding:24px 0;color:#CBD5E1;font-size:13px;">No files staged for '+selMonth+'</div>')

  +'</div>' // right
  +'</div>' // grid
  +'</div>' // card

  // All-months overview
  +upAllMonthsPipeline(months)

  // Approving and paying a month moved to its own screen, and so did bank
  // statements. This screen's job is now one job — get the partner files in and
  // generate the statements. Both destinations are one tap away; nothing that
  // used to be reachable from here has stopped being reachable.
  +'<div style="margin-top:16px;padding:14px 18px;background:#fff;border-radius:14px;box-shadow:0 2px 16px rgba(0,0,0,.08);display:flex;gap:20px;flex-wrap:wrap;align-items:center;">'
  +'<span style="font-size:13px;color:#6B7280;">Once the statements are generated:</span>'
  +'<button onclick="showCloseList()" style="background:none;border:0;padding:0;font-size:13px;font-weight:700;color:#0B2545;cursor:pointer;text-decoration:underline;">Approve and pay the month &rarr;</button>'
  +'<button onclick="showView(\'bankstmts\')" style="background:none;border:0;padding:0;font-size:13px;font-weight:700;color:#0B2545;cursor:pointer;text-decoration:underline;">Bank statements &rarr;</button>'
  +'</div>'

  // Archived commission statement files (every file ever pulled, viewable)
  +'<details class="admin-sec"><summary>Commission statement files — iFAST / Phillip archive</summary><div class="sec-body">'
  +'<div style="font-size:12px;color:#6B7280;margin-bottom:8px;">Every statement file pulled from Gmail, filed by earning month. PDFs open in a tab; iFAST ZIPs download (password '+IFAST_ZIP_PASS+').</div>'
  +'<div id="comm-arch-list" style="font-size:12px;color:#94A3B8;">Loading…</div>'
  +'</div></details>'
  +'</div>'; // outer

  document.getElementById("main-content").innerHTML = html;
  setTimeout(function(){ commArchLoad(); }, 0);
}

// View the statements generated for a month — admin can open any adviser's full breakdown.
function upViewGenerated(month){
  var ex=document.getElementById('vg-overlay'); if(ex) ex.remove();
  var rm=function(n){ return 'RM '+Number(n||0).toLocaleString('en-MY',{minimumFractionDigits:2,maximumFractionDigits:2}); };
  var items=[];
  Object.keys(STATEMENTS).forEach(function(id){
    if(!ADVISERS[id]) return;
    (STATEMENTS[id]||[]).forEach(function(s,idx){ if(s.period===month) items.push({id:id, idx:idx, name:(ADVISERS[id].name||id), s:s}); });
  });
  items.sort(function(a,b){ return (b.s.total_payout||0)-(a.s.total_payout||0); });
  var total=items.reduce(function(a,it){ return a+(it.s.total_payout||0); },0);
  var rows=items.map(function(it){
    var ovr=(typeof _ovrLines==='function')?_ovrLines(it.s):{total:0};
    var sub='Personal '+rm(it.s.personal_payout)+(ovr.total>0?' + overriding '+rm(ovr.total):'');
    return '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;padding:9px 0;border-top:1px solid #F1F5F9">'
      +'<div><div style="font-weight:600;color:#0B2545">'+it.name+'</div><div style="font-size:11px;color:#9CA3AF">'+sub+'</div></div>'
      +'<div style="display:flex;align-items:center;gap:10px"><b style="color:#166534">'+rm(it.s.total_payout)+'</b>'
      +'<button onclick="document.getElementById(\'vg-overlay\').remove();viewStatement('+it.idx+',\''+it.id+'\')" style="background:#0B2545;color:#fff;border:0;padding:5px 12px;border-radius:8px;font-size:11px;font-weight:700;cursor:pointer">View</button></div></div>';
  }).join('') || '<div style="color:#9CA3AF;padding:10px 0">No statements for '+month+'.</div>';
  var ov=document.createElement('div'); ov.id='vg-overlay';
  ov.style.cssText='position:fixed;inset:0;background:rgba(11,37,69,.45);z-index:9000;display:flex;align-items:center;justify-content:center;padding:20px;';
  ov.innerHTML='<div style="background:#fff;border-radius:16px;max-width:460px;width:100%;max-height:88vh;overflow:auto;padding:24px 26px;box-shadow:0 20px 60px rgba(0,0,0,.3)">'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px"><div style="font-size:16px;font-weight:700;color:#0B2545">Generated statements — '+month+'</div>'
    +'<button onclick="document.getElementById(\'vg-overlay\').remove()" style="background:none;border:0;font-size:20px;color:#9CA3AF;cursor:pointer;line-height:1">&times;</button></div>'
    +'<div style="font-size:12px;color:#6B7280;margin-bottom:8px">'+items.length+' adviser(s) &middot; total payout '+rm(total)+'</div>'
    +rows+'</div>';
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
}

// ── Monthly Close board (audit tally · verify gate · finance · adviser notify) ──
function _mcDate(ts){ return ts ? (' ' + new Date(ts*1000).toLocaleDateString('en-MY',{timeZone:'Asia/Kuala_Lumpur',day:'2-digit',month:'short'})) : ''; }
async function mcLoad(){
  // The refresh seam. Approve / tell finance / payment made / publish all call
  // mcLoad() when they are done; the Monthly Close board now lives on its own
  // screen, so send them there rather than editing eight call sites.
  if(document.getElementById('close-body')) return closeLoad();
  var box=document.getElementById('mc-list'); if(!box) return;
  try{
    var rows=await apiGet('/api/commission/close-status');
    if(rows&&rows.error) throw new Error(rows.error);
    if(!rows||!rows.length){ box.innerHTML='<span style="color:#94A3B8">No generated months yet — import &amp; generate first.</span>'; return; }
    // Bank tally per period (uploaded statements / screenshots)
    var bank={};
    try{ var bts=await apiGet('/api/commission/bank-tally'); (bts||[]).forEach(function(t){ if(t&&t.period) bank[t.period]=t; }); }catch(e){}
    window._mcBank = bank;
    var rm=function(n){ return 'RM '+Number(n||0).toLocaleString('en-MY',{minimumFractionDigits:2,maximumFractionDigits:2}); };
    box.innerHTML=rows.map(function(r){
      var paid=!!(r.finance_confirmed_at)||r.finance_status==='confirmed_paid'||r.finance_status==='paid';
      var tally = r.tally
        ? '<span style="color:#15803D;font-weight:600">&#10003; tally</span>'
        : '<span style="color:#B91C1C;font-weight:700">&#10007; MISMATCH — do not pay</span>';
      // Bank chip — cash received vs commission gross for this month
      var bt=bank[r.period], bankChip;
      if(!bt){ bankChip='<span style="color:#94A3B8">🏦 no bank statement yet</span>'; }
      else {
        var credTip=(bt.credits||[]).map(function(c){ return c.date+' '+(c.payer==='phillip'?'Phillip':'iFAST')+' RM'+Number(c.amount).toFixed(2); }).join('\n');
        if(Math.abs(bt.diff)<0.05) bankChip='<span title="'+credTip+'" style="color:#15803D;font-weight:700">🏦 &#10003; cash matched '+rm(bt.matched)+'</span>';
        else if(bt.diff>0) bankChip='<span title="'+credTip+'" style="color:#B45309;font-weight:700">🏦 received '+rm(bt.matched)+' — short '+rm(bt.diff)+' (next tranche pending)</span>';
        else bankChip='<span title="'+credTip+'" style="color:#B91C1C;font-weight:700">🏦 received '+rm(bt.matched)+' — MORE than gross by '+rm(Math.abs(bt.diff))+'</span>';
      }
      var audit='<div style="font-size:11px;color:#6B7280;margin-top:3px">Gross '+rm(r.gross)
        // Firm revenue = investment + will fees. Show the split when will fees exist.
        +(r.will_gross>0?' <span style="color:#B8891A">(investment '+rm(r.invest_gross)+' + will '+rm(r.will_gross)+')</span>':'')
        +' = Payout '+rm(r.payout)+' + Retention '+rm(r.retention)+' &middot; '+tally+' &middot; '+bankChip+'</div>';
      // §MIN_PAYOUT — what finance is actually asked to pay vs what rolls to next month.
      // An adviser under RM50 isn't paid; the balance accumulates until it reaches RM50.
      if(r.carried_out>0){
        audit+='<div style="font-size:11px;color:#92400E;margin-top:2px">&#8635; To pay '+rm(r.to_pay||0)+' &middot; '+rm(r.carried_out)+' carried to next month ('
          +r.carried_count+' adviser'+(r.carried_count===1?'':'s')+' under RM50)</div>';
      }
      // Step 1 — Verify (gated on a clean tally)
      var stepVerify = r.verified_at
        ? '<span style="background:#DCFCE7;color:#15803D;padding:2px 8px;border-radius:9px;font-size:11px;font-weight:700">&#10003; Month approved'+_mcDate(r.verified_at)+'</span> <button onclick="mcVerify(\''+r.period+'\',true)" style="background:none;border:0;color:#94A3B8;font-size:10px;cursor:pointer;text-decoration:underline">undo</button>'
        : '<button onclick="mcVerify(\''+r.period+'\',false)" '+(r.tally?'':'disabled ')+'style="background:'+(r.tally?'#0B2545':'#CBD5E1')+';color:#fff;border:0;padding:4px 12px;border-radius:8px;font-size:11px;font-weight:700;cursor:'+(r.tally?'pointer':'not-allowed')+'">&#10003; Approve month</button>';
      // Step 2 — Finance (gated on Verified)
      var stepFinance;
      // "Already paid" is the OWNER's final-step shortcut (money already out) — never finance's.
      var ownerAlready=r.is_owner ? ' <button onclick="mcMarkPaid(\''+r.period+'\')" style="background:none;border:0;color:#15803D;font-size:10px;cursor:pointer;text-decoration:underline">already paid</button>' : '';
      if(!r.verified_at){ stepFinance='<span style="color:#CBD5E1;font-size:11px">Vinnie pays — complete step 1 first</span>'; }
      else if(paid){ stepFinance='<span style="background:#DCFCE7;color:#15803D;padding:2px 8px;border-radius:9px;font-size:11px;font-weight:700">&#10003; Payment made</span>'; }
      // §MIN_PAYOUT — everyone under RM50: no finance step; month closed, statements published with the carry banner.
      else if(r.finance_status==='carried_forward'){ stepFinance='<span style="background:#FEF3C7;color:#92400E;padding:2px 8px;border-radius:9px;font-size:11px;font-weight:700">&#8635; All carried — nothing to pay</span>'; }
      else if(r.to_pay===0){ stepFinance='<span style="background:#FEF3C7;color:#92400E;padding:2px 8px;border-radius:9px;font-size:11px;font-weight:700">Nothing to pay — carried forward</span>'; }
      // Step 2b — Vinnie has confirmed the payment is CREATED; the OWNER confirms Payment made.
      else if(r.finance_status==='payment_created'){ stepFinance='<span style="background:#DBEAFE;color:#1D4ED8;padding:2px 8px;border-radius:9px;font-size:11px;font-weight:700">&#10003; Vinnie: payment created</span>'
        +(r.is_owner
          ? ' <button onclick="mcPaymentMade(\''+r.period+'\')" style="background:#15803D;color:#fff;border:0;padding:4px 12px;border-radius:8px;font-size:11px;font-weight:700;cursor:pointer">&#10003; Payment made</button>'
          : ' <span style="color:#94A3B8;font-size:11px">awaiting owner&#39;s Payment made</span>'); }
      else if(r.finance_sent_at){ stepFinance='<span style="background:#FEF3C7;color:#92400E;padding:2px 8px;border-radius:9px;font-size:11px;font-weight:700">&#9203; Vinnie notified — awaiting payment created</span>'
        +' <button onclick="mcSendFinance(\''+r.period+'\')" style="background:none;border:0;color:#1D4ED8;font-size:10px;cursor:pointer;text-decoration:underline">resend</button>'
        +ownerAlready; }
      else { stepFinance='<button onclick="mcPreviewFinance(\''+r.period+'\')" style="background:#fff;border:1.5px solid #0B2545;color:#0B2545;padding:3px 10px;border-radius:8px;font-size:11px;font-weight:700;cursor:pointer">Preview</button>'
        +' <button onclick="mcSendFinance(\''+r.period+'\')" style="background:#0B2545;color:#fff;border:0;padding:4px 12px;border-radius:8px;font-size:11px;font-weight:700;cursor:pointer">Notify Vinnie</button>'
        +(r.is_owner ? ' <button onclick="mcMarkPaid(\''+r.period+'\')" style="background:none;border:1px solid #15803D;color:#15803D;padding:3px 10px;border-radius:8px;font-size:11px;font-weight:600;cursor:pointer">Already paid</button>' : ''); }
      // Step 3 — Advisers (auto on finance confirm; manual fallback)
      var stepAdv = r.advisers_notified_at
        ? '<span style="background:#DCFCE7;color:#15803D;padding:2px 8px;border-radius:9px;font-size:11px;font-weight:700">&#10003; Statements published</span>'
        : paid
          ? '<button onclick="mcNotify(\''+r.period+'\')" style="background:#0B2545;color:#fff;border:0;padding:4px 12px;border-radius:8px;font-size:11px;font-weight:700;cursor:pointer">Publish statements</button>'
          : '<span style="color:#CBD5E1;font-size:11px">Publishes when Vinnie confirms</span>';
      // Drill-in — list each agent's statement for this period; click one for the full detailed statement (read-only).
      var nStmt = _mcPeriodStatements(r.period).length;
      var pj = JSON.stringify(r.period).replace(/"/g,'&quot;');
      var drill = nStmt
        ? '<div style="margin-top:7px"><button onclick="mcToggleStatements('+pj+',this)" style="background:#fff;border:1.5px solid #CBD5E1;color:#0B2545;padding:4px 12px;border-radius:8px;font-size:11px;font-weight:600;cursor:pointer">&#9656; View '+nStmt+' agent statement'+(nStmt===1?'':'s')+'</button>'
          +'<div class="mc-stmts" data-period="'+pj+'" style="display:none;margin-top:8px;border:1px solid #E2E8F0;border-radius:8px;overflow:hidden"></div></div>'
        : '';
      // Will fees — the owner checks the figures BEFORE approving the month,
      // exactly as he does for investment ("I will always need to check before
      // approving, this is always the case for investment").
      drill += '<div style="margin-top:6px"><button onclick="wcOpen('+pj+')" style="background:#fff;border:1.5px solid #E7C976;color:#8A6D1F;padding:4px 12px;border-radius:8px;font-size:11px;font-weight:600;cursor:pointer">&#128220; Will fees'
        +(r.will_gross>0?' — '+rm(r.will_gross):'')+' &middot; review before approving</button></div>';
      return '<div style="padding:10px 0;border-top:1px solid #F1F5F9">'
        +'<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap"><b style="color:#0B2545;min-width:78px">'+r.period+'</b>'
        +'<span style="font-size:11px;color:#6B7280">'+r.generated+' statement'+(r.generated===1?'':'s')+'</span></div>'
        +audit
        +'<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-top:7px">'+stepVerify+'<span style="color:#CBD5E1">&#8594;</span>'+stepFinance+'<span style="color:#CBD5E1">&#8594;</span>'+stepAdv
        +(r.verified_at ? '<span style="color:#CBD5E1">·</span><button onclick="mcAuditExport(\''+r.period+'\')" title="One JSON for the auditor: every statement version, sign-off + AI check, numbered instructions, finance confirmations, adjustments, bank tally, log" style="background:none;border:0;color:#6B7280;font-size:10px;cursor:pointer;text-decoration:underline">audit export</button>' : '')
        +'</div>'
        +drill
        +'</div>';
    }).join('');
  }catch(e){ box.innerHTML='<span style="color:#B91C1C">'+e.message+'</span>'; }
}
// All loaded statements for a period, as {advId, idx, name, payout} — idx is the position in STATEMENTS[advId] (what viewStatement expects).
function _mcPeriodStatements(period){
  var out=[];
  Object.keys(STATEMENTS||{}).forEach(function(advId){
    (STATEMENTS[advId]||[]).forEach(function(s, idx){
      if(s.period===period){
        var adv=ADVISERS[advId]||{};
        out.push({advId:advId, idx:idx, name:adv.name||advId, payout:(s.total_payout!=null?s.total_payout:s.personal_payout)||0});
      }
    });
  });
  out.sort(function(a,b){ return (b.payout||0)-(a.payout||0); });
  return out;
}
// Expand/collapse the per-period agent statement list (read-only drill-in).
function mcToggleStatements(period, btn){
  // Find the panel via the clicked button (its sibling) — robust regardless of the
  // period string. The old data-period querySelector never matched because the HTML
  // parser decodes &quot; in the attribute but querySelector does not, so panel was null.
  var panel = btn ? btn.parentElement.querySelector('.mc-stmts') : document.querySelector('.mc-stmts');
  if(!panel) return;
  var open=panel.style.display==='none';
  panel.style.display=open?'block':'none';
  var n=_mcPeriodStatements(period).length;
  if(btn) btn.innerHTML=(open?'&#9662;':'&#9656;')+' View '+n+' agent statement'+(n===1?'':'s');
  if(open && !panel.dataset.filled){
    var list=_mcPeriodStatements(period);
    var rm=function(n){ return 'RM '+Number(n||0).toLocaleString('en-MY',{minimumFractionDigits:2,maximumFractionDigits:2}); };
    panel.innerHTML=list.map(function(x){
      return '<div style="display:flex;align-items:center;gap:10px;padding:7px 12px;border-top:1px solid #F1F5F9;background:#fff">'
        +'<span style="flex:1;color:#374151;font-size:12px;font-weight:600">'+x.name+'</span>'
        +'<span style="color:#166534;font-size:12px">'+rm(x.payout)+'</span>'
        +'<button onclick="mcViewAgentStatement(\''+x.advId+'\','+x.idx+')" style="background:#0B2545;color:#fff;border:0;padding:3px 10px;border-radius:6px;font-size:11px;font-weight:600;cursor:pointer">View statement &#8594;</button>'
        +'</div>';
    }).join('')||'<div style="padding:8px 12px;color:#94A3B8;font-size:12px">No statements loaded for this period.</div>';
    panel.dataset.filled='1';
  }
}
// Open one agent's full detailed statement (reuses the existing adviser-facing renderer, read-only).
function mcViewAgentStatement(advId, idx){
  if(!STATEMENTS[advId] || !STATEMENTS[advId][idx]){ showToast('error','Statement not loaded'); return; }
  viewStatement(idx, advId);
}
// Upload a bank statement PDF or M2U screenshot → credits auto-match to months.
async function mcBankUpload(input){
  var f=input.files&&input.files[0]; if(!f) return;
  var msg=document.getElementById('mc-bank-msg');
  try{
    if(msg) msg.textContent='Reading '+f.name+'…';
    var b64=await new Promise(function(res,rej){ var rd=new FileReader(); rd.onload=function(){ res(String(rd.result).split(',')[1]); }; rd.onerror=rej; rd.readAsDataURL(f); });
    if(msg) msg.textContent='Finding iFAST / Phillip credits…';
    var r=await apiPost('/api/commission/bank-tally/upload',{filename:f.name, mime:f.type||'application/pdf', data:b64});
    if(r&&r.error) throw new Error(r.error);
    var ps=(r.periods||[]).map(function(p){
      if(Math.abs(p.diff)<0.05) return p.period+' ✓ fully matched';
      if(p.diff>0) return p.period+' — received RM '+Number(p.matched).toFixed(2)+', waiting RM '+Number(p.diff).toFixed(2)+' more';
      return p.period+' — ⚠ received MORE than gross, check the file';
    }).join(' · ');
    if(msg) msg.textContent='';
    showToast('success', ps ? 'Bank credits matched: '+ps : 'No iFAST/Phillip credits found in that file');
    mcLoad();
  }catch(e){ if(msg) msg.textContent=''; showToast('error', e.message||'Upload failed'); }
  input.value='';
}
// ── Will fees for a period — what the owner reviews before approving ────────
// He asked for the will pipeline to work the way investment already does:
// figures on screen first, his approval second ("I will always need to check
// before approving"). This is READ-ONLY — nothing here approves or pays.
function _wcRM(n){ return 'RM '+Number(n||0).toLocaleString('en-MY',{minimumFractionDigits:2,maximumFractionDigits:2}); }
function _wcPct(p){ return (Math.round(Number(p||0)*1000)/10)+'%'; }
function _wcEsc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
async function wcOpen(period){
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(11,37,69,.45);z-index:9000;display:flex;align-items:flex-start;justify-content:center;padding:24px;overflow:auto';
  ov.innerHTML='<div id="wc-box" style="background:#fff;border-radius:14px;max-width:900px;width:100%;padding:22px;box-shadow:0 18px 50px rgba(11,37,69,.28)">'
    +'<div style="color:#6B7280">Loading will fees for '+_wcEsc(period)+'…</div></div>';
  document.body.appendChild(ov);
  ov.onclick=function(e){ if(e.target===ov) ov.remove(); };
  var d;
  try{ d=await apiGet('/api/commission/fp/'+encodeURIComponent(period)); }
  catch(e){ d={error:e.message||'Could not load'}; }
  var box=ov.querySelector('#wc-box');
  if(!d || d.error){ box.innerHTML='<div style="color:#B91C1C;font-weight:600">'+_wcEsc((d&&d.error)||'Could not load will fees.')+'</div>'
    +'<button onclick="this.closest(\'div[style*=fixed]\').remove()" class="mini-btn" style="margin-top:14px">Close</button>'; return; }
  window._wcData=d;
  var advs=d.advisers||[], pipe=d.pipeline||[];
  var head='<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:12px;flex-wrap:wrap">'
      +'<div><div style="font-weight:700;font-size:18px;color:#0B2545">Will fees — '+_wcEsc(period)+'</div>'
      +'<div style="color:#6B7280;font-size:13px;margin-top:2px">Fees collected in full and receipted. These are the figures that merge into the monthly statement when you approve the month.</div></div>'
      +'<button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:0;color:#6B7280;font-size:22px;line-height:1;cursor:pointer;padding:0">&times;</button></div>';
  var cards='<div style="display:flex;gap:12px;margin:16px 0;flex-wrap:wrap">'
      +'<div style="flex:1;min-width:150px;background:#F6F8FB;border-radius:10px;padding:14px"><div style="font-size:12px;color:#6B7280">Fees collected</div>'
        +'<div style="font-weight:700;font-size:19px;color:#0B2545;margin-top:2px">'+_wcRM(d.fees_settled)+'</div></div>'
      +'<div style="flex:1;min-width:150px;background:#FFF9E9;border-radius:10px;padding:14px"><div style="font-size:12px;color:#8A6D1F">To advisers</div>'
        +'<div style="font-weight:700;font-size:19px;color:#8A6D1F;margin-top:2px">'+_wcRM(d.total_payout)+'</div></div>'
      +'<div style="flex:1;min-width:150px;background:#F6F8FB;border-radius:10px;padding:14px"><div style="font-size:12px;color:#6B7280">Advisers earning</div>'
        +'<div style="font-weight:700;font-size:19px;color:#0B2545;margin-top:2px">'+advs.length+'</div></div></div>';
  var table;
  if(!advs.length){
    table='<div style="background:#F6F8FB;border-radius:10px;padding:20px;text-align:center;color:#6B7280">'
      +'No will fees fully settled in '+_wcEsc(period)+'.'
      +(pipe.length?'<div style="font-size:12px;margin-top:6px">'+pipe.length+' invoice'+(pipe.length===1?'':'s')+' still outstanding — see below.</div>':'')+'</div>';
  }else{
    table='<table style="width:100%;border-collapse:collapse;font-size:13px">'
      +'<tr style="text-align:left;color:#6B7280;font-size:11px;text-transform:uppercase;letter-spacing:.04em">'
      +'<th style="padding:8px 6px">Adviser</th><th style="padding:8px 6px">Rank</th>'
      +'<th style="padding:8px 6px;text-align:right">Fees</th><th style="padding:8px 6px;text-align:right">Personal</th>'
      +'<th style="padding:8px 6px;text-align:right">Over-riding</th><th style="padding:8px 6px;text-align:right">Total</th><th></th></tr>'
      +advs.map(function(a,i){
        var tot=Number(a.personal||0)+Number(a.overriding||0);
        return '<tr style="border-top:1px solid #F1F5F9">'
          +'<td style="padding:9px 6px;font-weight:600;color:#0B2545">'+_wcEsc(a.name||a.adviser_id)+'</td>'
          +'<td style="padding:9px 6px;color:#6B7280">'+_wcEsc(_wcTierName(a.tier))+'</td>'
          +'<td style="padding:9px 6px;text-align:right;font-variant-numeric:tabular-nums">'+_wcRM(a.base)+'</td>'
          +'<td style="padding:9px 6px;text-align:right;font-variant-numeric:tabular-nums">'+_wcRM(a.personal)+'</td>'
          +'<td style="padding:9px 6px;text-align:right;font-variant-numeric:tabular-nums">'+_wcRM(a.overriding)+'</td>'
          +'<td style="padding:9px 6px;text-align:right;font-weight:700;color:#0B2545;font-variant-numeric:tabular-nums">'+_wcRM(tot)+'</td>'
          +'<td style="padding:9px 6px;text-align:right"><button onclick="wcDetail('+i+')" style="background:none;border:0;color:#1D4ED8;font-size:12px;text-decoration:underline;cursor:pointer;padding:0">detail</button></td></tr>'
          +'<tr id="wc-d-'+i+'" style="display:none"><td colspan="7" style="padding:0 6px 12px"></td></tr>';
      }).join('')
      +'</table>';
  }
  // The pipeline is where unrecorded money shows up: an invoice reading
  // part_paid whose balance actually arrived in the bank earns nothing until
  // it is recorded, so it is worth a look every month.
  var pipeHtml='';
  if(pipe.length){
    pipeHtml='<div style="margin-top:22px"><div style="font-weight:700;color:#0B2545;font-size:14px">Not yet earning — '+_wcRM(d.pipeline_outstanding)+' outstanding</div>'
      +'<div style="color:#6B7280;font-size:12px;margin:2px 0 8px">Commission is earned only once the client has paid in full and the official receipt is issued. If money for one of these has reached the bank, record it and it joins this month.</div>'
      +'<table style="width:100%;border-collapse:collapse;font-size:12px">'
      +'<tr style="text-align:left;color:#6B7280;font-size:11px"><th style="padding:6px">Invoice</th><th style="padding:6px">Client</th><th style="padding:6px">Adviser</th>'
      +'<th style="padding:6px;text-align:right">Total</th><th style="padding:6px;text-align:right">Received</th><th style="padding:6px;text-align:right">Outstanding</th></tr>'
      +pipe.map(function(p){
        var part=Number(p.received||0)>0;
        return '<tr style="border-top:1px solid #F1F5F9'+(part?';background:#FFFBEB':'')+'">'
          +'<td style="padding:7px 6px">'+_wcEsc(p.number)+(part?' <span style="color:#B45309;font-weight:700;font-size:10px">PART PAID</span>':'')+'</td>'
          +'<td style="padding:7px 6px">'+_wcEsc(p.client)+'</td><td style="padding:7px 6px;color:#6B7280">'+_wcEsc(p.adviser)+'</td>'
          +'<td style="padding:7px 6px;text-align:right;font-variant-numeric:tabular-nums">'+_wcRM(p.total)+'</td>'
          +'<td style="padding:7px 6px;text-align:right;font-variant-numeric:tabular-nums">'+_wcRM(p.received)+'</td>'
          +'<td style="padding:7px 6px;text-align:right;font-weight:600;font-variant-numeric:tabular-nums">'+_wcRM(p.outstanding)+'</td></tr>';
      }).join('')+'</table></div>';
  }
  box.innerHTML=head+cards+table+pipeHtml
    +'<div style="margin-top:20px;padding-top:14px;border-top:1px solid #E2E8F0;color:#6B7280;font-size:12px">'
    +'Nothing here pays anyone. Approve the month on the Monthly Close row when these figures look right.</div>';
}
function _wcTierName(t){
  t=String(t||'').toLowerCase();
  if(t==='vp') return 'VP';
  if(t==='excomm') return 'EXCOMM';
  if(t==='exco') return 'EXCO';
  if(t==='full') return 'VP / EXCOMM';
  return t?t.charAt(0).toUpperCase()+t.slice(1):'Adviser';
}
// Per-adviser drill-in: every invoice behind the figure, and — for an adviser
// who writes their own will with nobody above them — the three components the
// rate is made of (owner: "you can breakdown personal sales comm / direct OR /
// indirect OR / so total come out to 70%"). Same money, shown as its parts.
function wcDetail(i){
  var row=document.getElementById('wc-d-'+i); if(!row) return;
  if(row.style.display!=='none'){ row.style.display='none'; return; }
  var a=((window._wcData||{}).advisers||[])[i]; if(!a) return;
  var items=a.items||[];
  var html='<div style="background:#F8FAFC;border-radius:8px;padding:12px">';
  if(!items.length) html+='<div style="color:#6B7280;font-size:12px">No line items.</div>';
  items.forEach(function(it){
    html+='<div style="padding:8px 0;border-bottom:1px solid #E9EEF5">'
      +'<div style="display:flex;justify-content:space-between;gap:10px;flex-wrap:wrap">'
        +'<div><b style="color:#0B2545">'+_wcEsc(it.client||'')+'</b> '
          +'<span style="color:#6B7280;font-size:12px">'+_wcEsc(it.invoice||'')+' &middot; '+_wcEsc(it.kind==='custodian'?'Custody':'Will')+'</span></div>'
        +'<div style="font-weight:700;color:#0B2545;font-variant-numeric:tabular-nums">'+_wcRM(it.amount)+'</div></div>'
      +'<div style="color:#6B7280;font-size:12px;margin-top:2px">Fee '+_wcRM(it.base)+' &middot; '+_wcEsc(it.role)+' '+_wcPct(it.pct)
        +(it.receipt?' &middot; receipt '+_wcEsc(it.receipt):'')+'</div>';
    if(it.components && it.components.length){
      html+='<div style="margin-top:6px;padding-left:12px;border-left:2px solid #E7C976">';
      it.components.forEach(function(c){
        html+='<div style="display:flex;justify-content:space-between;font-size:12px;color:#475569;padding:1px 0">'
          +'<span>'+_wcEsc(c.label)+' <span style="color:#94A3B8">'+_wcPct(c.pct)+'</span></span>'
          +'<span style="font-variant-numeric:tabular-nums">'+_wcRM(c.amount)+'</span></div>';
      });
      html+='<div style="font-size:11px;color:#94A3B8;margin-top:3px">All three because they wrote it themselves with no over-riding above them.</div></div>';
    }
    html+='</div>';
  });
  html+='</div>';
  row.firstElementChild.innerHTML=html;
  row.style.display='';
}
async function mcVerify(period, undo){
  var bt=(window._mcBank||{})[period];
  var bankWarn = !bt ? '\n⚠ NO BANK STATEMENT uploaded for '+period+' — cash received not verified.\n'
    : (Math.abs(bt.diff)>=0.05 ? '\n⚠ BANK TALLY SHORT RM '+Number(bt.diff).toFixed(2)+' — cash not fully received yet.\n' : '');
  if(!undo && !confirm('Approve '+period+'?\n'+bankWarn+'\nThis is the ONE approval for the month:\n• payable advisers (RM50 and above) — the summary goes straight to finance (Vinnie)\n• will-writing fees (Financial Planning) are folded into the same statement\n• everyone under RM50 — carried forward automatically\n• statements publish to agent portals when finance confirms payment\n\nNo per-agent approval needed.')) return;
  // WILL-WRITING FEES JOIN THE SAME STATEMENT (owner: "merge").
  // The FP figures are computed from settled will invoices; merging them here —
  // BEFORE the month is verified and the finance summary is built — is what puts
  // Financial Planning income on the monthly statement and into the ONE payout
  // per adviser. The endpoint is idempotent (recomputes, never accumulates), so
  // re-approving a month cannot double-pay. Fail-soft: a will-fee hiccup must
  // never block the investment payout.
  if(!undo){
    try{ await apiPost('/api/commission/fp/'+encodeURIComponent(period)+'/merge',{}); }
    catch(e){ showToast('error','Will-writing fees could not be merged — investment figures are unaffected. Tell admin before paying.'); }
  }
  try{ var r=await apiPost('/api/commission/verify',{period:period,undo:!!undo}); if(r&&r.error) throw new Error(r.error);
    var msg = undo ? ('Approval removed — '+period)
      : (r.auto && r.auto.carried) ? (period+' approved — nothing to pay (all under RM50). Statements published with the carried-forward note.')
      : (r.auto && r.auto.sent) ? (period+' approved — summary sent to finance ('+(r.auto.count||0)+' adviser'+(r.auto.count===1?'':'s')+', RM '+Number(r.auto.total||0).toFixed(2)+'). Statements publish when finance confirms.')
      : (period+' approved.');
    // §SIGNOFF (22 Sep 2026) — the AI check ran on approve; say what it found. A
    // failing check does NOT undo the approval (the owner's flow: he checks first, the
    // report sits beside it) — but it is never hidden inside a green toast.
    var so = r.signoff || null;
    if (so && so.error) { showToast('error', 'Approved, but the sign-off snapshot could not be written: ' + so.error); }
    else if (so && Array.isArray(so.findings) && so.findings.length) {
      showToast('error', period + ' approved — but the AI check found ' + so.findings.length + ' problem(s). Read them before finance pays.');
      alert('AI check — ' + period + ' — ' + so.findings.length + ' finding(s):\n\n' + so.findings.map(function(f){ return '• ' + f; }).join('\n') + '\n\nSign-off #' + so.id + ' is recorded with these findings. Fix and re-approve, or tell the auditor why they stand.');
    } else if (so && so.id) {
      msg += ' AI check passed · sign-off #' + so.id + (r.auto && r.auto.instruction_no ? ' · instruction ' + r.auto.instruction_no : '') + '.';
    }
    showToast('success', msg); mcLoad(); }
  catch(e){ showToast('error', e.message||'Approve failed'); }
}
// §AUDIT — one JSON per month for the auditor: every statement version, sign-offs
// with their check reports, numbered instructions, finance's per-line confirmations,
// adjustments, bank tally, admin log.
async function mcAuditExport(period){
  try{
    var r = await fetch(API + '/api/commission/audit-export?period=' + encodeURIComponent(period), { headers: _apiHeaders() });
    if(!r.ok){ var t = await r.text(); throw new Error(t || ('HTTP ' + r.status)); }
    var blob = await r.blob(); var a = document.createElement('a'); a.href = URL.createObjectURL(blob);
    a.download = 'LIFA_commission_audit_' + period.replace(/\s+/g, '_') + '.json'; document.body.appendChild(a); a.click(); a.remove();
    showToast('success', 'Audit export downloaded — ' + period);
  } catch(e){ showToast('error', e.message || 'Export failed'); }
}
async function mcPreviewFinance(period){
  try{ var r=await apiPost('/api/commission/send-finance-summary',{period:period,dry_run:true}); if(r&&r.error) throw new Error(r.error);
    var lines=(r.advisers||[]).map(function(a){return '• '+a.name+' — RM '+Number(a.amount||0).toFixed(2);}).join('\n');
    alert('Finance summary preview — '+period+'\nTo: '+r.to+'  (cc '+r.cc+')\n\n'+lines+'\n\nTotal: RM '+Number(r.total||0).toFixed(2)+' to '+r.count+' adviser(s).\n\nNothing sent yet — use "Send to finance" to email.'); }
  catch(e){ showToast('error', e.message||'Preview failed'); }
}
async function mcSendFinance(period){
  if(!confirm('Send the '+period+' commission payment summary to finance now?\n\nThis emails finance the payable breakdown with a confirm-paid link. When they confirm, advisers are notified automatically.')) return;
  try{ var r=await apiPost('/api/commission/send-finance-summary',{period:period}); if(r&&r.error) throw new Error(r.error);
    if(r.ok===false) throw new Error(r.error||'Send failed');
    showToast('success','Finance summary sent — '+period+' (RM '+Number(r.total||0).toFixed(2)+')'); mcLoad(); if(typeof poLoadList==='function') poLoadList(); }
  catch(e){ showToast('error', e.message||'Send failed'); }
}
async function mcMarkPaid(period){
  if(!confirm('Mark '+period+' as already paid by finance?\n\nUse this when Vinnie has already made the transfers and you don\'t need to send the email flow.\n\nStatements will publish to advisers immediately.')) return;
  try{ var r=await apiPost('/api/commission/mark-paid',{period:period}); if(r&&r.error) throw new Error(r.error);
    showToast('success',period+' marked as paid — statements published'); mcLoad(); if(typeof poLoadList==='function') poLoadList(); }
  catch(e){ showToast('error', e.message||'Failed to mark as paid'); }
}
async function mcPaymentMade(period){
  if(!confirm('Confirm PAYMENT MADE for '+period+'?\n\nOnly do this once the money is actually out. This publishes the statements and notifies the advisers. (Finance has already confirmed the payment was created.)')) return;
  try{ var r=await apiPost('/api/commission/payment-made',{period:period}); if(r&&r.error) throw new Error(r.error);
    showToast('success',period+' — payment made · statements published'); mcLoad(); if(typeof poLoadList==='function') poLoadList(); }
  catch(e){ showToast('error', e.message||'Failed to confirm payment made'); }
}
async function mcNotify(period){
  if(!confirm('Email the advisers paid for '+period+' to log in and check their commission statement?')) return;
  try{ var r=await apiPost('/api/commission/notify-advisers',{period:period}); if(r&&r.error) throw new Error(r.error);
    showToast('success','Advisers notified — '+period); mcLoad(); }
  catch(e){ showToast('error', e.message||'Notify failed'); }
}

// ── Commission statement file archive (every file pulled from Gmail, viewable) ──
// Earning month: iFAST zips issued day ≤15 carry the PREVIOUS month's 2nd-half earnings.
function _commArchEffLabel(x){
      // §PERIOD-LABEL — once the file has been parsed, the row carries the period from
      // the file's OWN date range (server-side, set on import). That beats the
      // payout-date guess below, which is only right by convention.
      if(x.date_range && x.period) return _periodLabel(x.period)||'—';
  var m=String(x.filename||"").match(/_(\d{1,2})-([A-Za-z]{3})-(\d{4})/);
  if(x.source==="ifast" && m && parseInt(m[1],10)<=15){
    var mi=MONTH_NAMES.findIndex(function(n){return n.toLowerCase()===m[2].toLowerCase();});
    var y=parseInt(m[3],10);
    if(mi>=0){ mi--; if(mi<0){mi=11;y--;} return MONTH_NAMES[mi]+" "+y; }
  }
  return _periodLabel(x.period)||"—";
}
async function commArchLoad(){
  var box=document.getElementById('comm-arch-list'); if(!box) return;
  try{
    var rows=await apiGet('/api/commission-inbox');
    if(rows&&rows.error) throw new Error(rows.error);
    if(!rows||!rows.length){ box.innerHTML='<span style="color:#94A3B8">No files in the archive yet.</span>'; return; }
    var MON={Jan:1,Feb:2,Mar:3,Apr:4,May:5,Jun:6,Jul:7,Aug:8,Sep:9,Oct:10,Nov:11,Dec:12};
    rows.forEach(function(r){ r._eff=_commArchEffLabel(r); var p=r._eff.split(' '); r._k=(parseInt(p[1])||0)*100+(MON[p[0]]||0); });
    rows.sort(function(a,b){ return b._k-a._k || (a.source>b.source?1:-1); });
    var lastMonth=null;
    box.innerHTML=rows.map(function(r){
      var hdr = r._eff!==lastMonth ? '<div style="font-weight:700;color:#0B2545;margin-top:8px">'+r._eff+'</div>' : '';
      lastMonth=r._eff;
      return hdr+'<div style="display:flex;align-items:center;gap:10px;padding:4px 0;border-top:1px solid #F1F5F9;color:#374151">'
        +'<span style="min-width:52px;color:#64748B">'+(r.source==='ifast'?'iFAST':'Phillip')+'</span>'
        +'<span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+r.filename
        +(r.date_range?'<div style="font-size:11px;color:#64748B">covers '+_amlEsc(r.date_range)+(r.payout_date?' &middot; paid '+_amlEsc(_periodLabel(r.payout_date)||r.payout_date):'')+'</div>':'')+'</span>'
        +'<span style="font-size:11px;color:'+(r.status==='imported'?'#15803D':'#B45309')+'">'+r.status+'</span>'
        +'<button onclick="commArchView('+r.id+',\''+(r.content_type||'')+'\',\''+String(r.filename).replace(/[^a-zA-Z0-9 ._-]/g,'')+'\')" style="background:#fff;border:1.5px solid #0B2545;color:#0B2545;padding:3px 10px;border-radius:6px;font-size:11px;cursor:pointer">View</button>'
        +'</div>';
    }).join('');
  }catch(e){ box.innerHTML='<span style="color:#B91C1C">'+e.message+'</span>'; }
}
async function commArchView(id, ctype, fname){
  try{
    var r=await fetch(API+'/api/commission-inbox/'+id+'/file',{headers:_apiHeaders()});
    if(!r.ok) throw new Error('HTTP '+r.status);
    var b=await r.blob();
    var u=URL.createObjectURL(b);
    if(/pdf/i.test(ctype||'')){ window.open(u,'_blank'); }
    else { var a=document.createElement('a'); a.href=u; a.download=fname||'statement'; a.click(); }
    setTimeout(function(){URL.revokeObjectURL(u);},60000);
  }catch(e){ showToast('error',e.message); }
}

// ── Payout workflow monitor: generated → finance notified → PAID (finance-confirmed) → advisers notified ──
async function poLoadList(){
  var box=document.getElementById('po-list'); if(!box) return;
  try{
    var rows=await apiGet('/api/commission/payouts');
    if(rows&&rows.error) throw new Error(rows.error);
    if(!rows||!rows.length){ box.innerHTML='<span style="color:#94A3B8">No payout cycles yet — generate statements, then send the finance summary.</span>'; return; }
    // Clean board: settled months (paid / carried / superseded) collapse behind
    // "show settled"; only months that still need action show by default.
    function ord(p){ var t=Date.parse('01 '+String(p.period||'').replace(/^Settlement to /,'')); return isNaN(t)?0:t; }
    rows.sort(function(a,b){ return ord(b)-ord(a); });
    var render=function(p){
      var paid=(p.status==='confirmed_paid'||p.status==='advisers_notified'||p.status==='paid'||p.status==='confirmed'||!!p.confirmed_at);
      var carried=(p.status==='carried_forward');
      var chip = paid
        ? '<span style="background:#DCFCE7;color:#15803D;padding:2px 10px;border-radius:10px;font-size:11px;font-weight:700">✅ PAID'+(p.confirmed_at?' '+new Date(p.confirmed_at*1000).toLocaleDateString('en-MY',{timeZone:'Asia/Kuala_Lumpur',day:'2-digit',month:'short'}):'')+'</span>'
        : carried
        ? '<span style="background:#F1F5F9;color:#64748B;padding:2px 10px;border-radius:10px;font-size:11px;font-weight:700">↻ Carried forward — settled</span>'
        : '<span style="background:#FEF3C7;color:#92400E;padding:2px 10px;border-radius:10px;font-size:11px;font-weight:700">⏳ Awaiting Vinnie</span>';
      var rem = (!paid && !carried && p.last_reminder_at) ? '<div style="font-size:10.5px;color:#94A3B8;margin-top:2px">daily chase to Vinnie · last '+new Date(p.last_reminder_at*1000).toLocaleDateString('en-MY',{timeZone:'Asia/Kuala_Lumpur',day:'2-digit',month:'short'})+'</div>' : '';
      return '<div style="padding:8px 0;border-top:1px solid #F1F5F9">'
        +'<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap">'
        +'<b style="color:#0B2545;min-width:80px">'+p.period+'</b>'
        +(carried?'':'<span style="color:#374151">RM '+Number(p.total_to_pay||0).toFixed(2)+'</span>')
        +chip+'</div>'+rem+'</div>';
    };
    var active=rows.filter(function(p){ return p.status==='awaiting_finance'; });
    var settled=rows.filter(function(p){ return p.status!=='awaiting_finance' && p.status!=='superseded'; });
    var html = active.length
      ? active.map(render).join('')
      : '<div style="padding:8px 0;color:#15803D;font-size:12px;font-weight:600">✓ Nothing awaiting payment — all settled.</div>';
    if(settled.length){
      html+='<details style="margin-top:6px"><summary style="cursor:pointer;font-size:11px;color:#94A3B8;font-weight:600">Show '+settled.length+' settled month'+(settled.length===1?'':'s')+'</summary>'
        +settled.map(render).join('')+'</details>';
    }
    box.innerHTML=html;
  }catch(e){ box.innerHTML='<span style="color:#B91C1C">'+e.message+'</span>'; }
}

// ── Bank statements (audit) ───────────────────────────────────────────────────
async function bsLoadList(){
  // Same seam as mcLoad: bsVerify / bsVerifyAll refresh through here, and the
  // list they are refreshing is now the Bank statements screen.
  if(document.getElementById('bank-body')) return bankLoad();
  var box=document.getElementById('bs-list'); if(!box) return;
  try{
    var rows=await apiGet('/api/bank-statements');
    if(rows&&rows.error) throw new Error(rows.error);
    if(!rows||!rows.length){ box.innerHTML='<span style="color:#94A3B8">No bank statements uploaded yet.</span>'; return; }
    // ── ONE overall reconciliation (no per-statement repetition) ──
    var head='';
    (function(){
      var verified=rows.filter(function(s){return s.verify_json;}).map(function(s){try{return JSON.parse(s.verify_json);}catch(e){return null;}}).filter(Boolean);
      if(!verified.length) return;
      // Canonical payables = matches ∪ unmatched from any one report (same full set in each)
      var payables=(verified[0].matches||[]).concat(verified[0].unmatched_payables||[]);
      var totalPayable=payables.reduce(function(a,p){return a+(p.amount||0);},0);
      // Paid: exact matches + name-detected transfers, deduped across statements
      var seen={}, exact=0, named=0, namedLines=[];
      verified.forEach(function(v){
        (v.matches||[]).forEach(function(m){var k='e'+m.adviser+m.period+m.amount; if(!seen[k]){seen[k]=1; exact+=m.amount||0;}});
        (v.name_payments||[]).forEach(function(n){var k='n'+n.adviser+n.date+n.amount; if(!seen[k]){seen[k]=1; named+=n.amount||0; namedLines.push(n);}});
      });
      var byAdv={};
      payables.forEach(function(p){byAdv[p.adviser]=(byAdv[p.adviser]||0)+(p.amount||0);});
      verified.forEach(function(v){(v.matches||[]).forEach(function(m){var k='eb'+m.adviser+m.period+m.amount; if(!seen[k]){seen[k]=1; byAdv[m.adviser]-=(m.amount||0);}});});
      namedLines.forEach(function(n){ if(byAdv[n.adviser]!=null) byAdv[n.adviser]-=(n.amount||0); });
      var out=totalPayable-exact-named;
      var rcv=0; verified.forEach(function(v){(v.commission_received||[]).forEach(function(c){rcv+=c.amount||0;});});
      head='<div style="background:#F8FAFC;border-radius:10px;padding:12px 14px;margin-bottom:12px;font-size:12.5px">'
        +'<div style="font-weight:700;color:#0B2545;margin-bottom:4px">📊 Reconciliation to date ('+verified.length+' statement'+(verified.length===1?'':'s')+' verified)</div>'
        +'<div>Payable RM '+totalPayable.toFixed(2)+' · Paid RM '+(exact+named).toFixed(2)
        +namedLines.map(function(n){return ' <span style="color:#B45309">(⚠ '+n.adviser.split(' ')[0]+' RM '+Number(n.amount).toFixed(2)+(n.date?' on '+n.date:'')+' — amount mismatch)</span>';}).join('')
        +' · <b style="color:'+(out>0.005?'#B91C1C':'#15803D')+'">OUTSTANDING RM '+out.toFixed(2)+'</b></div>'
        +'<div style="margin-top:3px">'+Object.keys(byAdv).filter(function(k){return byAdv[k]>0.005;}).map(function(k){return k+': <b style="color:#B45309">RM '+byAdv[k].toFixed(2)+' owed</b>';}).join(' · ')+'</div>'
        +'<div style="color:#1E40AF;margin-top:3px">Commission received from iFAST/Phillip across these statements: RM '+rcv.toFixed(2)+'</div>'
        +'</div>';
    })();
    box.innerHTML=head+rows.map(function(s){
      var v=null; try{ v=s.verify_json?JSON.parse(s.verify_json):null; }catch(e){}
      var vline='';
      if(v){
        // MINIMALIST: only what's IN this statement — payouts found + money received. One line each.
        var rc=v.commission_received||[]; var rcSum=rc.reduce(function(a,x){return a+(x.amount||0);},0);
        var paidLines=(v.matches||[]).map(function(x){return '<div style="color:#15803D">&nbsp;&nbsp;✓ paid '+x.adviser+' RM '+Number(x.amount).toFixed(2)+' ('+x.period+(x.txn_date?', '+x.txn_date:'')+')</div>';})
          .concat((v.name_payments||[]).map(function(x){return '<div style="color:#B45309">&nbsp;&nbsp;⚠ paid '+x.adviser+' RM '+Number(x.amount).toFixed(2)+(x.date?' ('+x.date+')':'')+' — amount mismatch vs payable</div>';}));
        vline='<div style="font-size:11px;margin-top:3px;padding-left:2px">'
          +(paidLines.length?paidLines.join(''):'<div style="color:#94A3B8">No adviser payments in this statement</div>')
          +(rc.length?'<div style="color:#1E40AF">Commission received: RM '+rcSum.toFixed(2)+'</div>'
            +rc.map(function(x){return '<div style="color:#1E40AF">&nbsp;&nbsp;RM '+Number(x.amount).toFixed(2)+(x.date?' ('+x.date+')':'')+' — <b>'+(x.cycle||x.source)+'</b></div>';}).join(''):'')
          +'</div>';
      }
      return '<div style="padding:6px 0;border-top:1px solid #F1F5F9;color:#374151">'
        +'<div style="display:flex;align-items:center;gap:10px">'
        +'<span style="font-weight:600;min-width:90px">'+(s.period||'—')+'</span>'
        +'<span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+s.filename+'</span>'
        +'<span style="color:#94A3B8;font-size:11px">'+(s.created_at||'').slice(0,10)+'</span>'
        +'<button onclick="bsVerify('+s.id+',this)" style="background:#0B2545;color:#fff;border:0;padding:3px 12px;border-radius:6px;font-size:11px;font-weight:600;cursor:pointer" title="AI reads the statement and matches transfers against adviser commission payables">🔍 '+(v?'Re-verify':'Verify payments')+'</button>'
        +'<button onclick="bsView('+s.id+')" style="background:#fff;border:1.5px solid #0B2545;color:#0B2545;padding:3px 10px;border-radius:6px;font-size:11px;cursor:pointer">View</button>'
        +'</div>'+vline+'</div>';
    }).join('');
  }catch(e){ box.innerHTML='<span style="color:#B91C1C">'+e.message+'</span>'; }
}
// Best-effort period from a filename: "Jan 2026", "statement_2026-01.pdf", "012026", "202601" …
function _bsPeriodFromName(name){
  var MON={jan:'Jan',feb:'Feb',mar:'Mar',apr:'Apr',may:'May',jun:'Jun',jul:'Jul',aug:'Aug',sep:'Sep',oct:'Oct',nov:'Nov',dec:'Dec'};
  var n=String(name||'').toLowerCase();
  var m=n.match(/(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*[\s_\-\.]*('?\d{2,4})/);
  if(m){ var y=m[2].replace("'",''); if(y.length===2) y='20'+y; return MON[m[1]]+' '+y; }
  m=n.match(/(20\d{2})[\s_\-\.]?(0[1-9]|1[0-2])/);              // 2026-01 / 202601
  if(m) return Object.values(MON)[parseInt(m[2],10)-1]+' '+m[1];
  m=n.match(/(0[1-9]|1[0-2])[\s_\-\.]?(20\d{2})/);              // 01-2026 / 012026
  if(m) return Object.values(MON)[parseInt(m[1],10)-1]+' '+m[2];
  return '';
}
// A server error is often an HTML page, not JSON. Strip it to a short readable
// line rather than showing a wall of markup — or, as before, nothing at all.
function _bsSnippet(raw){
  var s=String(raw||'').replace(/<[^>]*>/g,' ').replace(/\s+/g,' ').trim();
  if(!s) return '';
  return s.length>180 ? s.slice(0,180)+'…' : s;
}
function _bsKB(n){ return Math.max(1, Math.round(Number(n||0)/1024))+' KB'; }
// Upload one or many bank statements (12-month batch friendly).
//
// A failure now says WHY — the HTTP status and the server's own message, named
// per file, left on the page. Three things used to hide the reason:
//   1. `catch(e){ fail++; }` threw the reason away entirely.
//   2. `await r.json()` THROWS when the response is not JSON (a gateway error
//      page, a plain-text 413, a redirect to a login page). The real status
//      code went into that same swallowed exception, so a rejected upload was
//      indistinguishable from a parse problem.
//   3. The result was reported with showToast('warn', …) — 'warn' is not one of
//      showToast's types, so it rendered as the BLUE "sending" toast and
//      auto-cleared after 6 seconds. A failure looked like a progress note.
async function bsUpload(){
  var files=((document.getElementById('bs-file')||{}).files)||[];
  if(!files.length) return showToast('error','Choose bank statement file(s) first');
  var manual=((document.getElementById('bs-period')||{}).value||'').trim();
  var status=document.getElementById('bs-status');
  var ok=0, problems=[];
  if(status) status.innerHTML='<div style="color:#6B7280;font-size:12.5px;padding:8px 0">Uploading '+files.length+' file'+(files.length===1?'':'s')+'…</div>';
  for(var i=0;i<files.length;i++){
    var f=files[i];
    var period=manual || _bsPeriodFromName(f.name);
    var fd=new FormData(); fd.append('file',f); fd.append('period',period);
    try{
      var r=await fetch(API+'/api/bank-statements',{method:'POST',headers:{Authorization:'Bearer '+SESSION_TOKEN},body:fd});
      // Read the body as TEXT first, then try to parse it. This keeps the status
      // code even when the body is not JSON.
      var raw=''; try{ raw=await r.text(); }catch(e){}
      var j=null; try{ j=raw?JSON.parse(raw):null; }catch(e){}
      if(!r.ok){
        problems.push({name:f.name, size:f.size, why:'HTTP '+r.status+(r.statusText?' '+r.statusText:'')
          +' — '+((j&&(j.error||j.message))||_bsSnippet(raw)||'the server sent no message')});
      }else if(j && j.error){
        problems.push({name:f.name, size:f.size, why:String(j.error)});
      }else{ ok++; }
    }catch(e){
      // fetch itself rejected: offline, DNS, CORS, or the request never left.
      problems.push({name:f.name, size:f.size, why:'The request never reached the server — '+((e&&e.message)||'network error')});
    }
    if(files.length>1) bsLoadList();   // show progress as they land
  }
  if(status){
    status.innerHTML=(problems.length
      ? '<div style="border:1px solid #FCA5A5;background:#FEF2F2;border-radius:10px;padding:12px 14px;margin:10px 0">'
        +'<div style="font-weight:700;color:#B91C1C;font-size:13.5px">'+problems.length+' of '+files.length+' file'+(files.length===1?'':'s')+' did not upload — nothing was saved for these</div>'
        +problems.map(function(p){
          return '<div style="font-size:12.5px;color:#7F1D1D;margin-top:8px">'
            +'<b>'+escapeHtml(p.name)+'</b> <span style="color:#B91C1C">('+_bsKB(p.size)+')</span>'
            +'<div style="margin-top:1px">'+escapeHtml(p.why)+'</div></div>';
        }).join('')
        +'</div>'
      : '')
      +(ok?'<div style="color:#166534;font-size:12.5px;padding:4px 0">'+ok+' file'+(ok===1?'':'s')+' uploaded.</div>':'');
  }
  showToast(problems.length?'error':'success', problems.length
    ? ok+' uploaded · '+problems.length+' failed — the reason for each is shown above the list.'
    : ok+' uploaded');
  bsLoadList();
  // Keep the chosen files when something failed, so a retry needs no re-picking.
  if(!problems.length){
    var fi=document.getElementById('bs-file'); if(fi) fi.value='';
    var pi=document.getElementById('bs-period'); if(pi) pi.value='';
  }
}
// Run AI payment-matching on every statement that hasn't been verified yet.
async function bsVerifyAll(){
  var rows=await apiGet('/api/bank-statements');
  if(rows&&rows.error) return showToast('error',rows.error);
  var todo=(rows||[]).filter(function(s){return !s.verify_json;});
  if(!todo.length) return showToast('warn','Every statement has been checked — use "Check again" on a row to redo one.');
  showToast('info','Verifying '+todo.length+' statement'+(todo.length===1?'':'s')+'… (AI reads each one)');
  var matched=0, fail=0, why='';
  for(var i=0;i<todo.length;i++){
    try{
      var r=await apiPost('/api/bank-statements/'+todo[i].id+'/verify',{});
      if(r&&r.error) throw new Error(r.error);
      matched+=(r.matches||[]).length;
      bsLoadList();
    }catch(e){ fail++; if(!why) why=(e&&e.message)||'no reason given'; }   // keep the first reason instead of dropping it
  }
  // 'warn' is not a showToast type — it rendered blue and cleared itself after 6s,
  // so a failure read as a progress note. An error toast stays until dismissed.
  showToast(fail?'error':'success','Done — '+matched+' commission payment'+(matched===1?'':'s')+' matched across '+(todo.length-fail)+' statement'+((todo.length-fail)===1?'':'s')+(fail?' · '+fail+' failed: '+why:''));
  bsLoadList();
}
// AI verify: Claude reads the bank statement, worker matches transfers ↔ commission payables.
async function bsVerify(id, btn){
  if(btn){ btn.disabled=true; btn.textContent='Reading…'; }
  try{
    var r=await apiPost('/api/bank-statements/'+id+'/verify',{});
    if(r&&r.error) throw new Error(r.error);
    var m=(r.matches||[]).length, u=(r.unmatched_payables||[]).length;
    // 'warn' is not a showToast type — it renders as the blue "sending" toast
    // and clears itself, so a nothing-found result read as progress.
    showToast(m? 'success':'info', m+' adviser payment'+(m===1?'':'s')+' found in this statement'+(u?' · '+u+' still not found anywhere':''));
    bsLoadList();
  }catch(e){ showToast('error', e.message); if(btn){ btn.disabled=false; btn.textContent='Check payments'; } }
}
async function bsView(id){
  try{
    var r=await fetch(API+'/api/bank-statements/'+id+'/file',{headers:_apiHeaders()});
    if(!r.ok) throw new Error('HTTP '+r.status);
    var b=await r.blob(); var u=URL.createObjectURL(b); window.open(u,'_blank'); setTimeout(function(){URL.revokeObjectURL(u);},60000);
  }catch(e){ showToast('error',e.message); }
}

/* ═══════════════════════════════════════════════════════════════════════════
   MONTHLY CLOSE, REBUILT — three screens, to the owner-approved mock
   (artifact 0ed0041b · source docs/mocks/admin_redesign.html)

   The incident this answers: two bank statements were uploaded, a green
   success message was shown, and neither file could be found afterwards.
   Both doors were real — Monthly Close → 🏦 Bank tally read the numbers off
   the PDF and discarded the bytes by design, while 🏦 Bank Statements (audit)
   kept the file. Two boxes that looked alike, two stores, neither aware of
   the other.

   The rules the drawing encodes, and which every line below obeys:
     · Finished work is GREY. Colour is spent once per screen, on the one
       thing that needs him.
     · Numbers stack, right-aligned, tabular-nums. Never strung along a line.
     · Plain words — earned · arrived in the bank · still to arrive · paid to
       advisers · kept by the firm · too small to pay yet. Not gross / payout /
       retention / tally / tranche / carried.
     · Roles, not people. "finance", never a person's first name.
     · One upload box, and the file is always kept.

   Nothing is removed: every figure, control and warning that was on the old
   Monthly Close / Payout Status / Bank Statements sections is reachable here.
   Where the mock had no place for something it is kept as a quiet line or a
   ghost link rather than dropped.
   ═══════════════════════════════════════════════════════════════════════ */

// Which month is open on screen 2. null = screen 1, the ledger.
var CLOSE_MONTH = null;

// One stylesheet, injected once. Scoped to .lcx-* so nothing else in the
// portal is touched. Light only — the rest of the portal has no dark mode and
// a half-dark screen beside a light sidebar reads as a fault, not a feature.
function _clCss(){
  if(document.getElementById('lcx-css')) return;
  var s=document.createElement('style'); s.id='lcx-css';
  s.textContent=[
    '.lcx{--paper:#FCFBF9;--card:#FFF;--ink:#15191F;--ink2:#3C444F;--muted:#6E7683;--faint:#98A0AC;',
    '--line:#E7E3DD;--line2:#F1EEE9;--brand:#0B2545;--brand-soft:#EDF1F6;',
    '--att:#8A5210;--att-bg:#FBF3E7;--att-line:#E7D2AF;',
    'max-width:820px;margin:0 auto;padding:30px 22px 80px;color:var(--ink);',
    'font-size:16px;line-height:1.55;-webkit-font-smoothing:antialiased}',
    '.lcx *{box-sizing:border-box}',
    '.lcx-device{background:var(--card);border:1px solid var(--line);border-radius:14px;overflow:hidden}',
    '.lcx-bar{display:flex;align-items:center;gap:10px;padding:13px 20px;border-bottom:1px solid var(--line2);font-size:13px;color:var(--faint)}',
    '.lcx-bar b{color:var(--ink2);font-weight:600;font-size:13.5px}',
    '.lcx-bar .sp{flex:1}',
    '.lcx-body{padding:24px 20px 26px}',
    '.lcx h2{font-size:19px;font-weight:640;letter-spacing:-.012em;margin:0 0 3px}',
    '.lcx h3{font-size:13px;font-weight:660;letter-spacing:.07em;text-transform:uppercase;color:var(--faint);margin:0 0 10px}',
    /* the one thing that needs you */
    '.lcx-needs{border:1px solid var(--att-line);background:var(--att-bg);border-radius:11px;padding:16px 18px;margin:0 0 26px}',
    '.lcx-needs .lbl{font-size:11px;letter-spacing:.13em;text-transform:uppercase;color:var(--att);font-weight:680;margin:0 0 6px}',
    '.lcx-needs p{margin:0 0 13px;font-size:16.5px;color:var(--ink);max-width:52ch}',
    '.lcx-needs.calm{border-color:var(--line);background:transparent;padding:0}',
    '.lcx-needs.calm p{color:var(--muted);margin:0;font-size:15.5px}',
    '.lcx-btn{appearance:none;border:0;cursor:pointer;font:inherit;font-size:14.5px;font-weight:600;background:var(--brand);color:#FCFBF9;padding:9px 18px;border-radius:9px}',
    '.lcx-btn[disabled]{background:var(--line);color:var(--faint);cursor:not-allowed}',
    '.lcx-btn:focus-visible{outline:2px solid var(--ink);outline-offset:2px}',
    '.lcx-btn.ghost{background:transparent;color:var(--muted);text-decoration:underline;padding:9px 0;font-weight:500}',
    '.lcx-btn.ghost[disabled]{background:transparent;text-decoration:none}',
    '.lcx-btn.sm{font-size:13.5px;padding:6px 14px}',
    '.lcx-btn.ghost.sm{padding:6px 0}',
    /* the ledger */
    '.lcx-ledger{border-top:1px solid var(--line)}',
    '.lcx-row{display:grid;grid-template-columns:1fr auto;gap:6px 20px;align-items:baseline;padding:15px 2px;',
    'border-bottom:1px solid var(--line2);cursor:pointer;background:none;border-left:0;border-right:0;border-top:0;',
    'width:100%;text-align:left;font:inherit;color:inherit}',
    '.lcx-row:hover{background:var(--line2)}',
    '.lcx-row:focus-visible{outline:2px solid var(--brand);outline-offset:-2px}',
    '.lcx-row .m{font-size:16.5px;font-weight:600;letter-spacing:-.008em}',
    '.lcx-row .amt{font-size:16.5px;font-weight:600;font-variant-numeric:tabular-nums;letter-spacing:-.01em;text-align:right;white-space:nowrap}',
    '.lcx-row .sub{grid-column:1;font-size:13.5px;color:var(--muted)}',
    '.lcx-row .state{grid-column:2;font-size:13.5px;color:var(--faint);text-align:right;white-space:nowrap}',
    '.lcx-row .state.act{color:var(--att);font-weight:600}',
    '.lcx-row .amt.zero{color:var(--faint);font-weight:500}',
    /* a month, opened */
    '.lcx-back{appearance:none;background:none;border:0;cursor:pointer;font:inherit;font-size:13.5px;color:var(--muted);padding:0;margin:0 0 18px}',
    '.lcx-back:hover{color:var(--ink)}',
    '.lcx-group{margin:0 0 26px}',
    '.lcx-line{display:flex;justify-content:space-between;align-items:baseline;gap:20px;padding:9px 0;border-bottom:1px solid var(--line2)}',
    '.lcx-line:last-child{border-bottom:0}',
    '.lcx-line span:first-child{color:var(--ink2);font-size:15px}',
    '.lcx-line span:last-child{font-variant-numeric:tabular-nums;font-size:15.5px;font-weight:600;white-space:nowrap}',
    '.lcx-line.q span{color:var(--muted);font-weight:500;font-size:14px}',
    '.lcx-line.att span{color:var(--att);font-weight:600;font-size:14.5px}',
    '.lcx-line.total{border-top:1px solid var(--line);border-bottom:0;margin-top:4px;padding-top:12px}',
    '.lcx-line.total span{font-size:17px;font-weight:680}',
    '.lcx-steps{list-style:none;margin:0;padding:0}',
    '.lcx-steps li{display:flex;gap:11px;align-items:flex-start;padding:7px 0;font-size:15px;color:var(--muted)}',
    '.lcx-steps li .tick{color:var(--faint);font-size:13px;line-height:1.6;width:14px;flex:none}',
    '.lcx-steps li.now{color:var(--ink);font-weight:600}',
    '.lcx-steps li.now .tick{color:var(--att)}',
    '.lcx-steps li.todo{color:var(--faint)}',
    '.lcx-act{margin-top:8px;display:flex;gap:14px;align-items:center;flex-wrap:wrap;font-weight:400}',
    '.lcx-foot{display:flex;gap:22px;flex-wrap:wrap;align-items:baseline}',
    '.lcx-stmts{margin-top:10px;border:1px solid var(--line);border-radius:10px;overflow:hidden;width:100%}',
    '.lcx-stmt{display:flex;align-items:center;gap:12px;padding:9px 13px;border-top:1px solid var(--line2);font-size:14px}',
    '.lcx-stmt:first-child{border-top:0}',
    '.lcx-stmt .n{flex:1;color:var(--ink2)}',
    '.lcx-stmt .a{font-variant-numeric:tabular-nums;color:var(--ink);font-weight:600}',
    /* upload */
    '.lcx-drop{border:1.5px dashed var(--line);border-radius:12px;padding:34px 22px;text-align:center;color:var(--muted);cursor:pointer;user-select:none}',
    '.lcx-drop.over{border-color:var(--brand);background:var(--brand-soft)}',
    '.lcx-drop b{display:block;color:var(--ink);font-size:16.5px;font-weight:620;margin-bottom:5px}',
    '.lcx-drop .note{font-size:13.5px;margin-top:14px;color:var(--faint);max-width:46ch;margin-left:auto;margin-right:auto}',
    '.lcx-filerow{display:flex;justify-content:space-between;gap:16px;align-items:baseline;padding:12px 2px;border-bottom:1px solid var(--line2);font-size:15px}',
    '.lcx-filerow .meta{color:var(--faint);font-size:13.5px;font-variant-numeric:tabular-nums;white-space:nowrap}',
    '.lcx-note{font-size:13.5px;color:var(--muted);margin:14px 0 0}',
    '.lcx-note label{color:var(--faint);margin-right:8px}',
    '.lcx-in{font:inherit;font-size:14px;padding:7px 10px;border:1px solid var(--line);border-radius:8px;background:var(--card);color:var(--ink);width:190px}',
    '@media (max-width:560px){.lcx{padding:20px 14px 60px}.lcx-body{padding:20px 16px 22px}}'
  ].join('');
  document.head.appendChild(s);
}

function _clRM(n){ return 'RM '+Number(n||0).toLocaleString('en-MY',{minimumFractionDigits:2,maximumFractionDigits:2}); }
function _clDay(ts){ return ts ? new Date(ts*1000).toLocaleDateString('en-MY',{timeZone:'Asia/Kuala_Lumpur',day:'numeric',month:'long'}) : ''; }
function _clOrd(period){ var t=Date.parse('01 '+String(period||'')); return isNaN(t)?0:t; }
function _clNextMonth(period){
  var p=String(period||'').split(' '); var i=MONTH_NAMES.indexOf(p[0]); var y=parseInt(p[1],10);
  if(i<0||!y) return 'the next month';
  i++; if(i>11){ i=0; y++; }
  return MONTH_NAMES[i]+' '+y;
}
function _clPlural(n,w){ return n+' '+w+(Number(n)===1?'':'s'); }
// How many advisers are actually being paid this month. The server field is
// used when it exists; otherwise it is derived from the statements generated
// less those held back under RM 50. When neither is safe, no count is shown —
// a wrong number on a payment screen is worse than no number.
function _clPayCount(r){
  var n = r.pay_count!=null ? r.pay_count : (r.payable_count!=null ? r.payable_count : (r.to_pay_count!=null ? r.to_pay_count : null));
  if(n!=null && !isNaN(Number(n))) return Number(n);
  var g=Number(r.generated||0), c=Number(r.carried_count||0);
  return (g>0 && c>=0 && g-c>0) ? g-c : null;
}
function _clPaid(r){ return !!(r.finance_confirmed_at) || r.finance_status==='confirmed_paid' || r.finance_status==='paid'; }
function _clCarried(r){ return r.finance_status==='carried_forward' || (!!r.verified_at && Number(r.to_pay||0)===0); }

// One derivation of a month's state, read by BOTH screens so they can never
// disagree — the "has this month been paid, answered twice in different words"
// problem the audit recorded as Finding 3.
function _clState(r, bt){
  var paid=_clPaid(r), carried=_clCarried(r), n=_clPayCount(r);
  var who = n!=null ? _clPlural(n,'adviser') : 'advisers';
  // §ROUNDS — paid once, then regenerated with more money: approve it again.
  if(paid && Number(r.to_pay_now||0)>0.005){
    var nn = r.pay_count_now!=null ? _clPlural(r.pay_count_now,'adviser') : 'advisers';
    return {key:'more', amount:_clRM(r.to_pay_now), zero:false, sub:'More to pay '+nn+' — new statements came in', state:'Approve again', act:true};
  }
  if(paid) return {key:'paid', amount:_clRM(r.to_pay), zero:false, sub:'Paid to '+who, state:'Done', act:false};
  if(carried) return {key:'carried', amount:'Nothing to pay', zero:true,
    sub:'All '+_clPlural(r.carried_count||0,'amount')+' too small — carried forward', state:'Done', act:false};
  if(r.verified_at){
    if(r.finance_status==='payment_created')
      return {key:'created', amount:_clRM(r.to_pay), zero:false, sub:'To pay '+who, state:'Finance has paid — confirm it', act:true};
    if(r.finance_sent_at)
      return {key:'awaiting', amount:_clRM(r.to_pay), zero:false, sub:'To pay '+who, state:'Waiting to be paid', act:true};
    return {key:'tell', amount:_clRM(r.to_pay), zero:false, sub:'To pay '+who, state:'Finance has not been told', act:true};
  }
  if(!r.tally) return {key:'mismatch', amount:'Not closed yet', zero:true, sub:'The figures do not tally — do not pay', state:'Open', act:true};
  if(!bt)     return {key:'nobank',   amount:'Not closed yet', zero:true, sub:'Waiting for the bank statement', state:'Open', act:false};
  return {key:'ready', amount:'Not closed yet', zero:true, sub:'Ready for you to approve', state:'Open', act:true};
}

// ── data ────────────────────────────────────────────────────────────────────
async function _clFetch(){
  var rows=await apiGet('/api/commission/close-status');
  if(rows&&rows.error) throw new Error(rows.error);
  rows=rows||[];
  var bank={};
  try{ var bts=await apiGet('/api/commission/bank-tally'); (bts||[]).forEach(function(t){ if(t&&t.period) bank[t.period]=t; }); }catch(e){}
  // Only for the reminder date — the chase to finance is recorded here and
  // nowhere else, and it is the thing that says how long a month has been stuck.
  var po={};
  try{ var ps=await apiGet('/api/commission/payouts'); (ps||[]).forEach(function(p){ if(p&&p.period) po[p.period]=p; }); }catch(e){}
  rows.sort(function(a,b){ return _clOrd(a.period)-_clOrd(b.period); });
  window._mcBank=bank;   // mcVerify reads this for its bank warning — keep it fed
  window._mcRows=rows;   // §AUDIT reads the month's gross/payout/retention from here
  return {rows:rows, bank:bank, po:po};
}

// ── screen 1: the months ────────────────────────────────────────────────────
function _clNeeds(d){
  // The single month that is actually stuck, oldest first within each rank.
  var pick=null, rank=99;
  d.rows.forEach(function(r){
    var st=_clState(r, d.bank[r.period]), k=st.key, q=99;
    if(k==='created')  q=0;
    else if(k==='awaiting') q=1;
    else if(k==='tell')     q=2;
    else if(k==='more')     q=2;
    else if(_clPaid(r) && !r.advisers_notified_at) q=3;
    else if(k==='mismatch') q=4;
    else if(k==='ready')    q=5;
    else if(k==='nobank')   q=6;
    if(q<rank){ rank=q; pick={r:r, st:st}; }
  });
  if(!pick) return '<div class="lcx-needs calm" style="margin-bottom:24px"><p>Nothing needs you. Every closed month is paid and every statement is out.</p></div>';
  var r=pick.r, p=r.period, po=d.po[p]||{}, msg='', extra='';
  var open='<button class="lcx-btn" onclick="closeOpen(\''+p+'\')">Open '+p+'</button>';
  if(pick.st.key==='more'){ msg=p+' was paid once ('+_clRM(r.paid_before)+'). New statements added '+_clRM(r.to_pay_now)+' — approve it again to pay the difference.'; }
  else if(rank===0){ msg=p+' is approved and finance has created the payment. Confirm it once the money is out.'; }
  else if(rank===1){
    msg=p+' is approved but the advisers have not been paid. Finance was told on '+_clDay(r.finance_sent_at)+'.';
    if(po.last_reminder_at) msg+=' Last reminded on '+_clDay(po.last_reminder_at)+'.';
    extra='<button class="lcx-btn ghost" style="margin-left:14px" onclick="mcSendFinance(\''+p+'\')">Remind finance</button>';
  }
  else if(rank===2){ msg=p+' is approved. Finance has not been told yet.'; }
  else if(rank===3){ msg=p+' is paid, but the statements have not gone out to the advisers yet.'; }
  else if(rank===4){ msg=p+' does not tally — the money earned and the money shared out do not agree. Do not pay it until that is settled.'; }
  else if(rank===5){ msg=p+' is ready for you to approve.'; }
  else {
    msg=p+' cannot be checked yet — there is no bank statement for it.';
    open='<button class="lcx-btn" onclick="showView(\'bankstmts\')">Add a bank statement</button>';
    extra='<button class="lcx-btn ghost" style="margin-left:14px" onclick="closeOpen(\''+p+'\')">Open '+p+'</button>';
  }
  return '<div class="lcx-needs"><p class="lbl">Needs you</p><p>'+escapeHtml(msg)+'</p>'+open+extra+'</div>';
}

function _clList(d){
  if(!d.rows.length) return '<div class="lcx-needs calm"><p>No months yet. Bring the partner files in on Upload Statements and generate the statements first.</p></div>';
  var rows=d.rows.map(function(r){
    var st=_clState(r, d.bank[r.period]);
    return '<button class="lcx-row" onclick="closeOpen(\''+r.period+'\')">'
      +'<span class="m">'+escapeHtml(r.period)+'</span>'
      +'<span class="amt'+(st.zero?' zero':'')+'">'+escapeHtml(st.amount)+'</span>'
      +'<span class="sub">'+escapeHtml(st.sub)+'</span>'
      +'<span class="state'+(st.act?' act':'')+'">'+escapeHtml(st.state)+'</span>'
      +'</button>';
  }).join('');
  return _clNeeds(d)+'<h3>All months</h3><div class="lcx-ledger">'+rows+'</div>';
}

// ── screen 2: a month, opened ───────────────────────────────────────────────
function _clMonth(d, period){
  var r=null; d.rows.forEach(function(x){ if(x.period===period) r=x; });
  if(!r) return '<button class="lcx-back" onclick="closeBack()">&larr; All months</button>'
    +'<div class="lcx-needs calm"><p>'+escapeHtml(period)+' is no longer on the list.</p></div>';
  var bt=d.bank[period], paid=_clPaid(r), carried=_clCarried(r);
  var pq=JSON.stringify(period).replace(/"/g,'&quot;');
  var n=_clPayCount(r), who=n!=null?_clPlural(n,'adviser'):'advisers';

  // ── Money in ──
  var willG=Number(r.will_gross||0);
  var investG = willG>0 ? Number(r.invest_gross||0) : Number(r.gross||0);
  var mIn='<div class="lcx-line"><span>Commission earned from iFAST and Phillip</span><span>'+_clRM(investG)+'</span></div>';
  if(willG>0) mIn+='<div class="lcx-line"><span>Will-writing fees collected</span><span>'+_clRM(willG)+'</span></div>';
  if(bt){
    // The individual credits stay available on hover, exactly as before.
    var tip=(bt.credits||[]).map(function(c){ return c.date+' '+(c.payer==='phillip'?'Phillip':'iFAST')+' '+_clRM(c.amount); }).join('\n');
    mIn+='<div class="lcx-line"'+(tip?' title="'+escapeHtml(tip)+'"':'')+'><span>Arrived in the bank</span><span>'+_clRM(bt.matched)+'</span></div>';
    if(Number(bt.diff)>0.05) mIn+='<div class="lcx-line q"><span>Still to arrive — the next payment run</span><span>'+_clRM(bt.diff)+'</span></div>';
    else if(Number(bt.diff)<-0.05) mIn+='<div class="lcx-line att"><span>More arrived than was earned — check the statement</span><span>'+_clRM(Math.abs(bt.diff))+'</span></div>';
  } else {
    mIn+='<div class="lcx-line q"><span>Not checked against a bank statement yet</span>'
      +'<span><button class="lcx-btn ghost sm" onclick="showView(\'bankstmts\')">Add one</button></span></div>';
  }

  // ── Money out ──
  var more = paid && Number(r.to_pay_now||0)>0.005;
  var mOut='';
  if(Number(r.paid_before||0)>0.005 && Number(r.to_pay_now||0)>0.005){
    // §ROUNDS — an earlier round already paid part of this month.
    mOut+='<div class="lcx-line"><span>Paid earlier'+(r.round&&r.round>1?' (round '+(r.round-1)+')':'')+'</span><span>'+_clRM(r.paid_before)+'</span></div>'
      +'<div class="lcx-line"><span>To pay now '+(r.pay_count_now!=null?_clPlural(r.pay_count_now,'adviser'):'')+'</span><span>'+_clRM(r.to_pay_now)+'</span></div>';
  } else {
    mOut+='<div class="lcx-line"><span>'+(paid?'Paid to ':'To pay ')+who+'</span><span>'+_clRM(r.to_pay)+'</span></div>';
  }
  mOut+='<div class="lcx-line"><span>Kept by the firm</span><span>'+_clRM(r.retention)+'</span></div>';
  if(Number(r.carried_out||0)>0)
    mOut+='<div class="lcx-line q"><span>Under RM 50 — carried into '+escapeHtml(_clNextMonth(period))
      +' ('+_clPlural(r.carried_count||0,'adviser')+')</span><span>'+_clRM(r.carried_out)+'</span></div>';
  mOut+='<div class="lcx-line total"><span>Advisers&rsquo; share</span><span>'+_clRM(r.payout)+'</span></div>';
  if(!r.tally) mOut+='<div class="lcx-line att"><span>The figures do not tally — do not pay this month until that is settled</span><span></span></div>';

  // ── Where it got to ── the live step carries its own action, so the button
  // for what happens next is where the eye already is.
  function li(cls, tick, text, act){
    return '<li class="'+cls+'"><span class="tick">'+tick+'</span><span>'+text+(act?'<div class="lcx-act">'+act+'</div>':'')+'</span></li>';
  }
  var steps='';
  if(r.verified_at){
    steps+=li('','&#10003;','You approved the month — '+_clDay(r.verified_at)
      +' <button class="lcx-btn ghost sm" style="padding:0;font-size:13px" onclick="mcVerify(\''+period+'\',true)">undo</button>','');
  } else {
    steps+=li('now','&#9679;','Approve the month',
      '<button class="lcx-btn sm" onclick="mcVerify(\''+period+'\',false)"'+(r.tally?'':' disabled')+'>Approve '+escapeHtml(period)+'</button>'
      +(r.tally?'':'<span style="color:var(--att);font-size:13.5px">The figures must tally first</span>')
      +'<button class="lcx-btn ghost sm" onclick="wcOpen('+pq+')">Check the will-writing fees first</button>');
  }
  var ownerAlready = r.is_owner ? '<button class="lcx-btn ghost sm" onclick="mcMarkPaid(\''+period+'\')">Already paid</button>' : '';
  if(more){
    steps+=li('now','&#9679;','New statements added '+_clRM(r.to_pay_now)+' after the month was paid — approve it again to pay the difference',
      '<button class="lcx-btn sm" onclick="mcVerify(\''+period+'\',false)">Approve '+escapeHtml(period)+' again</button>');
  } else if(carried){
    steps+=li('','&#10003;','Nothing to pay — every amount was carried into '+escapeHtml(_clNextMonth(period)),'');
  } else if(paid){
    steps+=li('','&#10003;','Finance made the payment'+(r.finance_confirmed_at?' — '+_clDay(r.finance_confirmed_at):''),'');
  } else if(!r.verified_at){
    steps+=li('todo','&#9675;','Finance pays the advisers','');
  } else if(r.finance_status==='payment_created'){
    steps+=li('now','&#9679;','Finance has created the payment',
      r.is_owner ? '<button class="lcx-btn sm" onclick="mcPaymentMade(\''+period+'\')">The money is out</button>'
                 : '<span style="color:var(--muted);font-size:14px">Waiting for the owner to confirm the money is out</span>');
  } else if(r.finance_sent_at){
    steps+=li('now','&#9679;','Finance was told on '+_clDay(r.finance_sent_at)+' — waiting for the payment',
      '<button class="lcx-btn sm" onclick="mcSendFinance(\''+period+'\')">Remind finance</button>'+ownerAlready);
  } else {
    steps+=li('now','&#9679;','Tell finance to pay '+who+' — '+_clRM(r.to_pay),
      '<button class="lcx-btn sm" onclick="mcSendFinance(\''+period+'\')">Tell finance</button>'
      +'<button class="lcx-btn ghost sm" onclick="mcPreviewFinance(\''+period+'\')">See what they will get</button>'+ownerAlready);
  }
  var nStmt=_mcPeriodStatements(period).length;
  // §SUMMARY honesty (owner 2026-09-13 "fix this"): this line used the STATEMENT
  // COUNT, which is not who was told. publishStatements makes every statement
  // visible in its adviser's portal; notifyAdvisersPaid EMAILS only advisers
  // actually PAID this month — never the owner (EXCLUDE_PAYOUT_IDS), never anyone
  // carried under RM50, never anyone with no address on file. Printing 7 where 3
  // were emailed told the owner more people had heard from us than had.
  var mailed=(r.advisers||[]).filter(function(a){
    if(a.owner || !(Number(a.paid)>0)) return false;
    var ad=ADVISERS[a.id]||{};
    return String(ad.personalEmail||ad.email||"").indexOf("@")>=0;
  }).length;
  if(r.advisers_notified_at) steps+=li('','&#10003;',
    'Statements published'+(nStmt?' to '+_clPlural(nStmt,'adviser'):'')
      +' &mdash; '+(mailed?_clPlural(mailed,'paid adviser')+' emailed':'nobody emailed (nobody was paid)'),'');
  else if(paid||carried) steps+=li('now','&#9679;','Send the statements to the advisers',
    '<button class="lcx-btn sm" onclick="mcNotify(\''+period+'\')">Send the statements</button>');
  else steps+=li('todo','&#9675;','Statements go out once finance has paid','');

  // ── quiet ways to look deeper ── (the statements link only when there are any:
  // a control that can only tell you there is nothing is a dead button)
  // §AUDIT (owner 2026-09-13: "how to do internal audit to confirm the statements
  // are generated correctly"). Every commission defect found this week was silent
  // because NOTHING ever compared the statements against the documents they came
  // from. This does, in one tap, for the month on screen.
  var foot='<div class="lcx-foot">'
    +'<button class="lcx-btn ghost" onclick="mcAudit('+pq+',this)">🔍 Audit this month</button>'
    +(nStmt?'<span><button class="lcx-btn ghost" onclick="closeStatements('+pq+',this)">See the '+nStmt+' adviser statement'+(nStmt===1?'':'s')+'</button></span>':'')
    +'<button class="lcx-btn ghost" onclick="wcOpen('+pq+')">Will-writing fees'+(willG>0?' — '+_clRM(willG):'')+'</button>'
    +'<button class="lcx-btn ghost" onclick="mcReconcile('+pq+',this)">&#9878; Settle a correction</button>'
    +'</div>';

  // §SUMMARY (owner 2026-09-13): "a simple way of knowing how much each provider
  // has paid me every month and how much each advisor is getting". Three lines
  // and a list, read straight off close-status. The owner's own share is never
  // paid, so it sits with the firm, in a bracket (his ruling, verbatim).
  var sum='';
  if(r.providers && Number(r.generated||0)>0){
    var pv=r.providers, adv=(r.advisers||[]).filter(function(a){return !a.owner;});
    var rows=adv.map(function(a){
      // "paid" only once the money is SETTLED; a payable amount still in a round reads "to pay".
      var incl = a.carried_in>0 ? ' (incl. '+_clRM(a.carried_in)+' carried in)' : '';
      var st = a.paid>0 ? ((a.settled>=a.paid-0.005 ? 'paid ' : 'to pay ')+_clRM(a.paid)+incl)
             : (a.carried_out>0 ? 'carried forward '+_clRM(a.carried_out) : (a.earned>0?'pending':'—'));
      return '<div class="lcx-line"><span>'+escapeHtml(a.name)+'</span><span>'+_clRM(a.earned)+' <span style="color:var(--muted);font-size:13px">&middot; '+st+'</span></span></div>';
    }).join('');
    // §SUMMARY honesty: the iFAST/Phillip SPLIT only exists for months generated
    // by the 2026-09-13 parser. Before it, Phillip money was lumped into
    // ifast_comm and the firm-level statement was dropped entirely — so a split
    // line for those months would assert "Phillip paid RM 0.00" when Phillip
    // actually paid ~RM247, and credit its money to iFAST. When there is no
    // recorded Phillip figure, the two are shown TOGETHER, as they are stored.
    var split = Number(pv.phillip||0) > 0;
    sum='<div class="lcx-group"><h3>Summary</h3>'
      +(split
        ? '<div class="lcx-line"><span>iFAST paid LIFA</span><span>'+_clRM(pv.ifast)+'</span></div>'
          +'<div class="lcx-line"><span>Phillip paid LIFA</span><span>'+_clRM(pv.phillip)+'</span></div>'
        : '<div class="lcx-line"><span>iFAST and Phillip paid LIFA</span><span>'+_clRM(Number(pv.ifast||0)+Number(pv.phillip||0))+'</span></div>')
      +'<div class="lcx-line"><span>Will-writing fees</span><span>'+_clRM(pv.will)+'</span></div>'
      +'<div class="lcx-line total"><span>Total revenue</span><span>'+_clRM(r.gross)+'</span></div>'
      +'<div class="lcx-line total" style="margin-top:10px"><span>Commission to advisers</span><span>'+_clRM(r.advisers_paid)+'</span></div>'
      +rows
      +'<div class="lcx-line total" style="margin-top:10px"><span>Firm retention <span style="color:var(--muted);font-weight:400;font-size:13px">(of which Gan Chin Soon share '+_clRM(r.owner_share)+')</span></span><span>'+_clRM(r.firm_total)+'</span></div>'
      +'</div>';
  }
  return '<button class="lcx-back" onclick="closeBack()">&larr; All months</button>'
    +'<h2 style="margin-bottom:22px">'+escapeHtml(period)+'</h2>'
    +sum
    +'<div class="lcx-group"><h3>Money in</h3>'+mIn+'</div>'
    +'<div class="lcx-group"><h3>Money out</h3>'+mOut+'</div>'
    +'<div class="lcx-group"><h3>Where it got to</h3><ul class="lcx-steps">'+steps+'</ul></div>'
    +foot;
}

// The per-adviser drill-in, in plain words. Reuses _mcPeriodStatements for the
// data so there is still one source for "who has a statement this month".
function closeStatements(period, btn){
  if(!btn) return;
  var panel=btn.parentElement.querySelector('.lcx-stmts');
  if(panel){ panel.remove(); return; }
  var list=_mcPeriodStatements(period);
  if(!list.length) return showToast('warn','No statements have been generated for '+period+' yet.');
  var el=document.createElement('div'); el.className='lcx-stmts';
  el.innerHTML=list.map(function(x){
    return '<div class="lcx-stmt"><span class="n">'+escapeHtml(x.name)+'</span><span class="a">'+_clRM(x.payout)+'</span>'
      +'<button class="lcx-btn ghost sm" onclick="mcViewAgentStatement(\''+x.advId+'\','+x.idx+')">Open</button></div>';
  }).join('');
  btn.parentElement.appendChild(el);
}

// ── the view ────────────────────────────────────────────────────────────────
function renderCloseView(){
  _clCss();
  document.getElementById('main-content').innerHTML=
    '<div class="lcx"><div class="lcx-device">'
    +'<div class="lcx-bar"><b>Monthly close</b><span class="sp"></span><span>Lifa Planners</span></div>'
    +'<div class="lcx-body" id="close-body"><span style="color:#98A0AC">Loading…</span></div>'
    +'</div></div>';
  closeLoad();
}
async function closeLoad(){
  var box=document.getElementById('close-body'); if(!box) return;
  try{
    var d=await _clFetch();
    box.innerHTML = CLOSE_MONTH ? _clMonth(d, CLOSE_MONTH) : _clList(d);
  }catch(e){ box.innerHTML='<div class="lcx-needs"><p class="lbl">Could not load</p><p>'+escapeHtml(e.message||'Unknown error')+'</p></div>'; }
}
function closeOpen(period){ CLOSE_MONTH=period; if(currentView!=='close') return showView('close'); closeLoad(); window.scrollTo({top:0,behavior:'smooth'}); }
function closeBack(){ CLOSE_MONTH=null; closeLoad(); window.scrollTo({top:0,behavior:'smooth'}); }
// Arriving from the sidebar (or from Upload Statements) always lands on the
// ledger, never on whichever month happened to be open last.
function showCloseList(){ CLOSE_MONTH=null; showView('close'); }

/* ── screen 3: one bank-statement door ──────────────────────────────────────
   The file is ALWAYS kept, and the same file is read for both directions:
     · POST /api/bank-statements          — keeps the file (money going out)
     · POST /api/commission/bank-tally/upload — reads the credits (money in)
   Two stores still, because that is what the server has; one door, because
   that is what a person needs. A statement can no longer land in one store,
   report success, and be missing from the other. */
var _BANK_TALLY_OK=/^(application\/pdf|image\/(png|jpe?g|webp))$/i;
function _clKB(n){ n=Number(n||0); return n>0 ? Math.max(1,Math.round(n/1024))+' KB' : ''; }

function renderBankStatements(){
  _clCss();
  document.getElementById('main-content').innerHTML=
    '<div class="lcx"><div class="lcx-device">'
    +'<div class="lcx-bar"><b>Bank statements</b><span class="sp"></span><span>Lifa Planners</span></div>'
    +'<div class="lcx-body">'
    +'<div class="lcx-needs calm" style="margin-bottom:24px"><p>One place for bank statements. Every statement is kept, and read for both '
      +'the money coming in from the fund houses and the money going out to advisers.</p></div>'
    +'<div class="lcx-drop" id="bank-drop"'
      +' ondragover="event.preventDefault();this.classList.add(\'over\')"'
      +' ondragleave="this.classList.remove(\'over\')"'
      +' ondrop="event.preventDefault();this.classList.remove(\'over\');bankDrop(event)"'
      +' onclick="document.getElementById(\'bank-file\').click()">'
      +'<b>Drop a bank statement here</b>PDF or a screenshot &middot; one month or twelve'
      +'<div class="note">The month is read from the file name. The file is kept, so you can open it again later.</div>'
    +'</div>'
    +'<input type="file" id="bank-file" multiple accept=".pdf,.csv,.xlsx,image/*" style="display:none" onchange="bankPick(this)">'
    +'<p class="lcx-note"><label for="bank-month">If the file name does not say which month</label>'
      +'<input id="bank-month" class="lcx-in" placeholder="e.g. May 2026"></p>'
    +'<div id="bank-status"></div>'
    +'<div id="bank-body" style="margin-top:30px"><span style="color:#98A0AC">Loading…</span></div>'
    +'</div></div></div>';
  bankLoad();
}

function bankPick(input){ var f=Array.prototype.slice.call(input.files||[]); input.value=''; bankSend(f); }
function bankDrop(ev){
  var dt=ev.dataTransfer, out=[];
  if(dt&&dt.files) for(var i=0;i<dt.files.length;i++) out.push(dt.files[i]);
  bankSend(out);
}

// Upload, then read. A failure says which file and why, on the page — a toast
// cannot carry a reason per file, because only one toast exists at a time.
async function bankSend(files){
  if(!files||!files.length) return;
  var monthEl=document.getElementById('bank-month');
  var manual=((monthEl||{}).value||'').trim();
  var status=document.getElementById('bank-status');
  var kept=0, problems=[], read=[];
  var say=function(h){ if(status) status.innerHTML=h; };
  say('<p class="lcx-note">Keeping '+_clPlural(files.length,'file')+'…</p>');
  for(var i=0;i<files.length;i++){
    var f=files[i];
    var period=manual || _bsPeriodFromName(f.name);
    try{
      var fd=new FormData(); fd.append('file',f); fd.append('period',period);
      var r=await fetch(API+'/api/bank-statements',{method:'POST',headers:{Authorization:'Bearer '+SESSION_TOKEN},body:fd});
      var raw=''; try{ raw=await r.text(); }catch(e){}
      var j=null; try{ j=raw?JSON.parse(raw):null; }catch(e){}
      if(!r.ok) throw new Error('HTTP '+r.status+(r.statusText?' '+r.statusText:'')+' — '+((j&&(j.error||j.message))||_bsSnippet(raw)||'the server sent no message'));
      if(j&&j.error) throw new Error(String(j.error));
      kept++;
    }catch(e){
      problems.push({name:f.name, size:f.size, why:(e&&e.message)||'The request never reached the server'});
      continue;   // the file was not kept — do not pretend to read it
    }
    // Same file, second job: find the iFAST / Phillip credits in it.
    if(_BANK_TALLY_OK.test(f.type||'')){
      try{
        say('<p class="lcx-note">Reading '+escapeHtml(f.name)+' for money that arrived…</p>');
        var b64=await new Promise(function(res,rej){ var rd=new FileReader(); rd.onload=function(){ res(String(rd.result).split(',')[1]); }; rd.onerror=rej; rd.readAsDataURL(f); });
        var t=await apiPost('/api/commission/bank-tally/upload',{filename:f.name, mime:f.type||'application/pdf', data:b64});
        if(t&&t.error) throw new Error(t.error);
        (t.periods||[]).forEach(function(p){
          read.push(Math.abs(p.diff)<0.05 ? p.period+' — everything earned has arrived'
            : p.diff>0 ? p.period+' — '+_clRM(p.matched)+' arrived, '+_clRM(p.diff)+' still to come'
            : p.period+' — more arrived than was earned, worth checking');
        });
      }catch(e){
        read.push('The money coming in could not be read from '+f.name+' — '+((e&&e.message)||'no reason given')+'. The file is kept.');
      }
    }
  }
  var html='';
  if(problems.length){
    html+='<div class="lcx-needs" style="margin:16px 0"><p class="lbl">Not saved</p>'
      +'<p>'+_clPlural(problems.length,'file')+' did not upload — nothing was saved for '+(problems.length===1?'it':'them')+'.</p>'
      +problems.map(function(p){ return '<p style="font-size:14px;margin:0 0 6px"><b>'+escapeHtml(p.name)+'</b> '+escapeHtml(_clKB(p.size))
        +'<br><span style="color:var(--att)">'+escapeHtml(p.why)+'</span></p>'; }).join('')+'</div>';
  }
  if(kept) html+='<p class="lcx-note">'+_clPlural(kept,'statement')+' kept.'
    +(read.length?'<br>'+read.map(escapeHtml).join('<br>'):'')+'</p>';
  say(html);
  if(monthEl && !problems.length) monthEl.value='';
  bankLoad();
  // The months screen reads the same credits — keep it honest if it is loaded.
  if(document.getElementById('close-body')) closeLoad();
}

// Writing a difference off the books is a decision, so it asks once, in plain
// words, naming exactly who and how much — and records a reason.
async function _clWriteOff(itemsJson){
  var items=[]; try{ items=JSON.parse(itemsJson); }catch(e){ return; }
  if(!items.length) return;
  var total=items.reduce(function(a,i){ return a+(i.amount||0); },0);
  var who=items.map(function(i){ return i.adviser+' '+_clRM(i.amount); }).join(', ');
  if(!confirm('Write off '+_clRM(total)+' as settled?\n\n'+who
    +'\n\nThis clears it from the reconciliation. The amounts stay on record with your name and today\u2019s date — nothing is deleted.')) return;
  var note=prompt('Why is this settled? (kept on the record)','Settled outside the app');
  if(note===null) return;
  var r=await apiPost('/api/bank-statements/writeoffs',{items:items, note:String(note||'').trim()});
  if(r&&r.error){ showToast('error', r.error); return; }
  showToast('success','Written off as settled.');
  bankLoad();
}

async function bankLoad(){
  var box=document.getElementById('bank-body'); if(!box) return;
  try{
    var res=await apiGet('/api/bank-statements');
    if(res&&res.error) throw new Error(res.error);
    // ⚠️ STILL ACCEPTS BOTH SHAPES. The endpoint is back to a bare array (an
    // object broke every cached bundle), but this stays tolerant so the two
    // sides can be deployed in either order without a blank screen.
    var rows=Array.isArray(res)?res:((res&&res.statements)||[]);
    // The baseline is its own request — and its own failure. If it cannot be
    // read the reconciliation shows EVERYTHING rather than silently hiding
    // months: on a money screen, too much is recoverable and too little is not.
    var baseline='';
    try{ var bl=await apiGet('/api/bank-statements/reset'); baseline=(bl&&bl.recon_reset_ym)||''; }catch(e){}
    var writeoffs=[];
    try{ var wo=await apiGet('/api/bank-statements/writeoffs'); if(Array.isArray(wo)) writeoffs=wo; }catch(e){}
    if(!rows.length){ box.innerHTML='<h3>Statements held</h3><p class="lcx-note">None yet.</p>'; return; }
    var unchecked=rows.filter(function(s){ return !s.verify_json; }).length;
    var head='<h3 style="margin-top:0">Statements held</h3>';
    var recon=_clRecon(rows, baseline, writeoffs);
    var list=rows.map(function(s){
      var v=null; try{ v=s.verify_json?JSON.parse(s.verify_json):null; }catch(e){}
      var when=(s.created_at||'').slice(0,10);
      return '<div class="lcx-filerow"><span>'+escapeHtml(s.period||'Month not read')
        +'<div style="font-size:13px;color:var(--faint)">'+escapeHtml(s.filename||'')+'</div>'
        +_clStmtDetail(v)+'</span>'
        +'<span class="meta">'+escapeHtml(when)
        +' <button class="lcx-btn ghost sm" onclick="bsView('+s.id+')">Open</button>'
        +' <button class="lcx-btn ghost sm" onclick="bsVerify('+s.id+',this)">'+(v?'Check again':'Check payments')+'</button>'
        +'</span></div>';
    }).join('');
    var all = unchecked ? '<p class="lcx-note"><button class="lcx-btn ghost" onclick="bsVerifyAll()">Check the '
      +_clPlural(unchecked,'statement')+' not checked yet</button></p>' : '';
    box.innerHTML=recon+head+list+all;
  }catch(e){ box.innerHTML='<p class="lcx-note" style="color:var(--att)">'+escapeHtml(e.message||'Could not load')+'</p>'; }
}

// What one statement was found to contain — who was paid out of THIS file, and
// what commission arrived in it. Quiet, and only once the file has been read.
function _clStmtDetail(v){
  if(!v) return '';
  var out=[];
  (v.matches||[]).forEach(function(m){
    out.push('Paid '+escapeHtml(m.adviser)+' '+_clRM(m.amount)+' for '+escapeHtml(m.period||'')+(m.txn_date?' on '+escapeHtml(m.txn_date):''));
  });
  (v.name_payments||[]).forEach(function(n){
    out.push('<span style="color:var(--att)">Paid '+escapeHtml(n.adviser)+' '+_clRM(n.amount)+(n.date?' on '+escapeHtml(n.date):'')+' — not the amount owed</span>');
  });
  (v.commission_received||[]).forEach(function(c){
    out.push('Came in '+_clRM(c.amount)+(c.date?' on '+escapeHtml(c.date):'')+' — '+escapeHtml(c.cycle||c.source||''));
  });
  if(!out.length) out.push('Nothing to do with advisers&rsquo; commission in this one');
  return '<div style="font-size:13px;color:var(--muted);margin-top:5px;line-height:1.5">'+out.join('<br>')+'</div>';
}

// One reconciliation across every checked statement — what was owed, what went
// out, what is still owed and to whom. Same arithmetic as the old audit panel;
// only the words and the layout changed.
// 🔖 THE RECONCILIATION BASELINE (owner, 2026-08-17: "start reconciliation from
// Jan 2026 onwards"). Payables in the AI's readings reach back to Jul 2025;
// those months are settled outside the app and were permanent noise here.
// ⚠️ A CUTOFF, NOT A DELETE — every statement and every reading stays on file.
// This only decides what the OPEN reconciliation counts.
var _CL_MN={jan:1,feb:2,mar:3,apr:4,may:5,jun:6,jul:7,aug:8,sep:9,oct:10,nov:11,dec:12};
function _clYm(period){
  var m=String(period||'').trim().match(/^([A-Za-z]{3})[a-z]*\s+(\d{4})$/);
  if(!m) return null;
  var mo=_CL_MN[m[1].toLowerCase()]; if(!mo) return null;
  return m[2]+'-'+String(mo).padStart(2,'0');
}
function _clOnOrAfter(period, baseline){
  if(!baseline) return true;              // no baseline set → everything counts
  var ym=_clYm(period);
  return ym ? ym>=baseline : true;        // unparseable period is never hidden
}
function _clRecon(rows, baseline, writeoffs){
  var verified=rows.filter(function(s){return s.verify_json;})
    .map(function(s){ try{ return JSON.parse(s.verify_json); }catch(e){ return null; } }).filter(Boolean);
  if(!verified.length) return '';
  var _keep=function(p){ return _clOnOrAfter(p&&p.period, baseline); };
  var payables=(verified[0].matches||[]).concat(verified[0].unmatched_payables||[]).filter(_keep);
  var totalPayable=payables.reduce(function(a,p){return a+(p.amount||0);},0);
  var seen={}, exact=0, named=0, namedLines=[];
  verified.forEach(function(v){
    (v.matches||[]).filter(_keep).forEach(function(m){ var k='e'+m.adviser+m.period+m.amount; if(!seen[k]){ seen[k]=1; exact+=m.amount||0; } });
    (v.name_payments||[]).forEach(function(nn){ var k='n'+nn.adviser+nn.date+nn.amount; if(!seen[k]){ seen[k]=1; named+=nn.amount||0; namedLines.push(nn); } });
  });
  var byAdv={};
  payables.forEach(function(p){ byAdv[p.adviser]=(byAdv[p.adviser]||0)+(p.amount||0); });
  verified.forEach(function(v){ (v.matches||[]).filter(_keep).forEach(function(m){ var k='eb'+m.adviser+m.period+m.amount; if(!seen[k]){ seen[k]=1; byAdv[m.adviser]-=(m.amount||0); } }); });
  namedLines.forEach(function(nn){ if(byAdv[nn.adviser]!=null) byAdv[nn.adviser]-=(nn.amount||0); });
  var out=totalPayable-exact-named;
  var rcv=0; verified.forEach(function(v){ (v.commission_received||[]).forEach(function(c){ rcv+=c.amount||0; }); });
  // ✍️ WRITTEN OFF — a difference chased and settled outside the app. It is
  // subtracted here, never erased: the write-off rows are kept so the number
  // can always be explained back to what it was and who decided it.
  var woByAdv={}, woTotal=0;
  (writeoffs||[]).forEach(function(w){
    var amt=Number(w.amount)||0;
    woByAdv[w.adviser]=(woByAdv[w.adviser]||0)+amt; woTotal+=amt;
  });
  Object.keys(woByAdv).forEach(function(k){ if(byAdv[k]!=null) byAdv[k]-=woByAdv[k]; });
  out-=woTotal;
  var owed=Object.keys(byAdv).filter(function(k){ return byAdv[k]>0.005; });
  var h='<div class="lcx-group"><h3>Checked so far</h3>'
    +'<div class="lcx-line"><span>Owed to advisers across '+_clPlural(verified.length,'statement')+'</span><span>'+_clRM(totalPayable)+'</span></div>'
    +'<div class="lcx-line"><span>Gone out of the bank</span><span>'+_clRM(exact+named)+'</span></div>'
    +'<div class="lcx-line"><span>Commission that came in from iFAST and Phillip</span><span>'+_clRM(rcv)+'</span></div>'
    // Never clamped: more money out than was owed is a real thing to know, and
    // hiding it behind a friendly zero is how a wrong payment goes unnoticed.
    +'<div class="lcx-line total'+(Math.abs(out)>0.005?' att':'')+'"><span>'
      +(out>0.005?'Still owed':(out<-0.005?'More went out than was owed':'Nothing still owed'))
      +'</span><span>'+_clRM(Math.abs(out))+'</span></div>';
  if(woTotal>0.005) h+='<div class="lcx-line"><span>Written off as settled</span><span>'+_clRM(woTotal)+'</span></div>';
  if(owed.length){
    h+='<p class="lcx-note">Still owed to '+owed.map(function(k){ return escapeHtml(k)+' '+_clRM(byAdv[k]); }).join(' &middot; ')+'</p>';
    // One action, and only when there is something to act on.
    var pay=owed.map(function(k){ return {adviser:k, amount:Math.round(byAdv[k]*100)/100}; });
    h+='<p class="lcx-note"><button onclick=\'_clWriteOff('+JSON.stringify(JSON.stringify(pay))+')\' style="background:none;border:0;color:#1D4ED8;font-size:inherit;text-decoration:underline;cursor:pointer;padding:0">Write off as settled</button></p>';
  }
  if(namedLines.length) h+='<p class="lcx-note" style="color:var(--att)">Paid, but not for the amount owed: '
    +namedLines.map(function(nn){ return escapeHtml(nn.adviser)+' '+_clRM(nn.amount)+(nn.date?' on '+escapeHtml(nn.date):''); }).join(' &middot; ')+'</p>';
  return h+'</div>';
}

function upBatchLabel(batch) {
  // Handle new compound batch names like "UT_1st", "DPMS_2nd", "Bond_2nd", "Stock_2nd"
  var display = batch;
  var bg="#F1F5F9", fg="#374151";
  if (batch === "Trailer" || batch === "Trailer_1st") { bg="#DCFCE7"; fg="#166534"; display="Trailer"; }
  else if (batch === "WrapFees") { bg="#FFF7ED"; fg="#C2410C"; display="Wrap Fees"; }
  else if (batch === "Phillip")  { bg="#FEF9C3"; fg="#92400E"; display="Phillip"; }
  else if (batch.endsWith("_1st") || batch === "1st") { bg="#DBEAFE"; fg="#1D4ED8"; 
    var type = batch.replace("_1st",""); display = (type&&type!=="1st"?type+" ":"")+"1st Half"; }
  else if (batch.endsWith("_2nd") || batch === "2nd") { bg="#EDE9FE"; fg="#7C3AED"; 
    var type2 = batch.replace("_2nd",""); display = (type2&&type2!=="2nd"?type2+" ":"")+"2nd Half"; }
  else if (batch === "UT")    { bg="#EFF6FF"; fg="#1D4ED8"; }
  else if (batch === "DPMS")  { bg="#FFF7ED"; fg="#C2410C"; }
  else if (batch === "Stock") { bg="#FDF4FF"; fg="#7E22CE"; }
  else if (batch === "Bond")  { bg="#F0FDF4"; fg="#166534"; }
  else if (batch === "PMB Commission") { bg="#FEF9C3"; fg="#92400E"; display="Phillip"; }
  return '<span style="background:'+bg+';color:'+fg+';padding:2px 8px;border-radius:5px;font-size:10px;font-weight:700;">'+display+'</span>';
}

function upAllMonthsPipeline(months) {
  var rows="";
  months.forEach(function(m){
    var s=upGetMonthStatus(m);
    if(!s.iFiles.length&&!s.pFiles.length) return;
    var badge = s.stmtCount>0
      ? '<span style="background:#DCFCE7;color:#166534;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700;">✓ '+s.stmtCount+' generated</span>'
      : s.ready
      ? '<span style="background:#FEF3C7;color:#92400E;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700;">⚡ Ready</span>'
      : '<span style="background:#F1F5F9;color:#6B7280;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700;">⏳ Pending</span>';
    function tick(done,lbl,req){
      var r=req===false;
      return '<span style="display:inline-flex;align-items:center;gap:3px;padding:2px 8px;border-radius:12px;font-size:10px;font-weight:700;margin-right:4px;'
        +(done?'background:#DCFCE7;color:#166534;':(r?'background:#F9FAFB;color:#D1D5DB;':'background:#FEF2F2;color:#E5E7EB;'))
        +'">'+(done?'✓':'✗')+' '+lbl+'</span>';
    }
    rows+='<tr style="border-bottom:1px solid #F1F5F9;">'
      +'<td style="padding:10px 14px;font-weight:700;color:#0B2545;white-space:nowrap;">'+m+'</td>'
      +'<td style="padding:10px 14px;">'+tick(s.has1st,"1st")+tick(s.has2nd,"2nd")+tick(s.hasTrail,"Trailer")+tick(s.hasWrap,"Wrap",false)+tick(s.hasPMB,"Phillip")+'</td>'
      +'<td style="padding:10px 14px;">'+badge+'</td>'
      +'<td style="padding:10px 14px;text-align:right;"><button onclick="adminOpenMonth(\''+m+'\')" style="padding:5px 14px;background:'+(s.ready&&s.stmtCount===0?'#B8962E':'#0B2545')+';color:#fff;border:none;border-radius:7px;font-size:11px;cursor:pointer;font-weight:600;">'+(s.ready&&s.stmtCount===0?'⚡ Generate & Open':'Open ↗')+'</button></td>'
      +'</tr>';
  });
  if(!rows) return "";
  return '<div style="background:#fff;border-radius:14px;box-shadow:0 2px 16px rgba(0,0,0,.08);overflow:hidden;margin-top:16px;">'
    +'<div style="padding:14px 18px;border-bottom:1px solid #F1F5F9;font-size:13px;font-weight:700;color:#0B2545;">All Months</div>'
    +'<table style="width:100%;border-collapse:collapse;">'
    +'<thead><tr style="background:#F8FAFC;"><th style="padding:8px 14px;text-align:left;font-size:10px;color:#9CA3AF;font-weight:600;">Month</th><th style="padding:8px 14px;text-align:left;font-size:10px;color:#9CA3AF;font-weight:600;">Files</th><th style="padding:8px 14px;text-align:left;font-size:10px;color:#9CA3AF;font-weight:600;">Status</th><th></th></tr></thead>'
    +'<tbody>'+rows+'</tbody></table></div>';
}

// ── File input change handler ─────────────────────────────────────────────────
function upHandleInputChange(input) {
  upProcessFiles(Array.from(input.files));
  // Reset so same file can be re-selected if needed
  input.value = "";
}

// ── Drag and drop handler ─────────────────────────────────────────────────────
function upHandleDrop(event) {
  var files = [];
  var items = event.dataTransfer.items;
  if (items && items.length) {
    var promises = [];
    for (var i=0; i<items.length; i++) {
      var item = items[i];
      var entry = item.webkitGetAsEntry ? item.webkitGetAsEntry() : null;
      if (entry && entry.isDirectory) {
        promises.push(upReadDir(entry));
      } else if (item.kind==="file") {
        var f = item.getAsFile();
        if (f) files.push(f);
      }
    }
    if (promises.length) {
      Promise.all(promises).then(function(arrs){
        arrs.forEach(function(a){ files = files.concat(a); });
        upProcessFiles(files);
      }).catch(function(){ upProcessFiles(files); });
      return;
    }
  } else {
    files = Array.from(event.dataTransfer.files||[]);
  }
  upProcessFiles(files);
}

function upReadDir(dirEntry) {
  return new Promise(function(resolve){
    var reader = dirEntry.createReader();
    var all=[], pending=0, done=false;
    function tryResolve(){ if(done&&pending===0) resolve(all); }
    function read(){
      reader.readEntries(function(entries){
        if(!entries.length){ done=true; tryResolve(); return; }
        entries.forEach(function(e){
          if(e.isFile){ pending++;
            e.file(function(f){ all.push(f); pending--; tryResolve(); }, function(){ pending--; tryResolve(); });
          } else if(e.isDirectory){ pending++;
            upReadDir(e).then(function(sub){ sub.forEach(function(f){all.push(f);}); pending--; tryResolve(); });
          }
        });
        read();
      }, function(){ done=true; tryResolve(); });
    }
    read();
  });
}

// ── Core processing ───────────────────────────────────────────────────────────
// "2026-05" → "May 2026" (matches UP_FILTER.month format, abbreviated months)
function _periodLabel(p){
  var pp=String(p||"").split("-"); if(pp.length<2||!pp[1]) return "";
  var idx=parseInt(pp[1],10)-1; if(idx<0||idx>11) return "";
  return MONTH_NAMES[idx]+" "+pp[0];
}
// Import commission files that the worker already pulled from Gmail (no download/
// upload). Fetches the staged bytes, wraps them as File objects, and runs them
// through the SAME upProcessFiles pipeline (decrypt LFA888 + parse + stage).
// §AUTOPILOT — zero-touch month close. Runs once when an admin opens the portal:
// if a month's files are COMPLETE in the Gmail inbox (iFAST 1st + 2nd half + Phillip,
// same completeness rule as the worker's 9am check) and NO statements exist yet,
// it imports and generates by itself. The admin's only action left is
// "✓ Approve month" at Monthly Close. Parsing lives in the browser (zip decrypt +
// XLSX + PDF), which is why this runs client-side on portal open, not on the server.
function _hasInvestStatements(lbl){
  return Object.keys(STATEMENTS).some(function(id){ return (STATEMENTS[id]||[]).some(function(s){ return s.period===lbl && Number(s.ifast_comm||0)>0; }); });
}
async function upAutoPilot(){
  if (typeof isAdmin === "undefined" || !isAdmin) return;
  try{
    var inbox = await apiGet("/api/commission-inbox");
    if(!Array.isArray(inbox) || !inbox.length) return;
    var MN=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    function issue(fn){ var m=String(fn||"").match(/_(\d{1,2})-([A-Za-z]{3})-(\d{4})/); if(!m) return null;
      var mi=MN.findIndex(function(n){return n.toLowerCase()===m[2].toLowerCase();}); if(mi<0) return null;
      return {day:parseInt(m[1],10), mo:mi, y:parseInt(m[3],10)}; }
    var months={};
    function bucket(y,mo){ var k=y+"-"+mo; if(!months[k]) months[k]={y:y,mo:mo,has1st:false,has2nd:false,hasPhil:false,pending:0}; return months[k]; }
    // §ROUNDS (owner 2026-09-13): a month is "done" when its FILES are imported,
    // not when ANY statement exists. A will fee approved early creates a
    // statement before the iFAST/Phillip files arrive — that used to make the
    // autopilot skip the month for ever (Aug 2026: three files sat "received").
    function mark(b,x){ if(String(x.status||"")!=="imported") b.pending++; }
    inbox.forEach(function(x){
      if(x.source==="ifast"){ var is=issue(x.filename); if(!is) return;
        if(is.day>=20){ var b1=bucket(is.y,is.mo); b1.has1st=true; mark(b1,x); }                       // 1st half ~25th of M
        if(is.day<=15){ var pm=is.mo-1, py=is.y; if(pm<0){pm=11;py--;} var b2=bucket(py,pm); b2.has2nd=true; mark(b2,x); }  // 2nd half ~10th of M+1
      } else if(x.source==="phillip" && x.period){ var p=String(x.period).split("-");
        if(p.length===2){ var b3=bucket(parseInt(p[0],10), parseInt(p[1],10)-1); b3.hasPhil=true; mark(b3,x); } }
    });
    var candidates=Object.keys(months).map(function(k){return months[k];})
      .filter(function(m){ return m.has1st&&m.has2nd&&m.hasPhil&&m.pending>0; })
      .map(function(m){ return {label:MN[m.mo]+" "+m.y, ord:m.y*12+m.mo}; })
      .sort(function(a,b){ return a.ord-b.ord; });
    var target=null;
    for(var i=0;i<candidates.length;i++){
      var lbl=candidates[i].label;
      var has=_hasInvestStatements(lbl);   // an iFAST/Phillip statement — a will-fee-only row does not count
      if(!has && !sessionStorage.getItem("autogen_done_"+lbl)){ target=lbl; break; }
    }
    if(!target) return;
    sessionStorage.setItem("autogen_done_"+target,"1");   // one attempt per session — never loops
    showToast("success", "🤖 "+target+" files are complete — importing & generating automatically…");
    UP_FILTER.month = target;
    showView("upload");
    await new Promise(function(r){ setTimeout(r,800); });
    await upImportFromEmail();
    var waited=0;
    while(waited<120000){
      await new Promise(function(r){ setTimeout(r,1500); }); waited+=1500;
      var st=upGetMonthStatus(target);
      if(st && st.ready){
        if(!_hasInvestStatements(target)) await upGenerateAll(target);
        showToast("success", "✅ "+target+" statements generated — open Monthly Close to approve it.");
        return;
      }
    }
    showToast("error", target+" auto-generate did not finish — open Upload Statements and click Import from Gmail.");
  }catch(e){ console.error("upAutoPilot", e); }
}

async function upImportFromEmail(){
  var statusEl=document.getElementById("up-status");
  var btn=document.getElementById("up-import-btn");
  if(btn){ btn.disabled=true; btn.textContent="⏳ Fetching from Gmail…"; }
  try{
    var inbox=await apiGet("/api/commission-inbox");
    if(!Array.isArray(inbox)) throw new Error((inbox&&inbox.error)||"Could not load Gmail inbox");
    var sel=UP_FILTER.month;
    // EARNING-month mapping: iFAST zips issued on day ≤15 contain the PREVIOUS month's
    // 2nd-half earnings (e.g. LFA_Commission_10-Jun.zip = May 2nd half). Phillip files
    // are already named by earning month. Without this, 2nd-half batches are never
    // importable under the right month.
    function _effLabel(x){
      // §PERIOD-LABEL — once the file has been parsed, the row carries the period from
      // the file's OWN date range (server-side, set on import). That beats the
      // payout-date guess below, which is only right by convention.
      if(x.date_range && x.period) return _periodLabel(x.period)||'—';
      var m=String(x.filename||"").match(/_(\d{1,2})-([A-Za-z]{3})-(\d{4})/);
      if(x.source==="ifast" && m && parseInt(m[1],10)<=15){
        var mi=MONTH_NAMES.findIndex(function(n){return n.toLowerCase()===m[2].toLowerCase();});
        var y=parseInt(m[3],10);
        if(mi>=0){ mi--; if(mi<0){mi=11;y--;} return MONTH_NAMES[mi]+" "+y; }
      }
      return _periodLabel(x.period);
    }
    // Include already-imported files too — a month must be staged COMPLETE before
    // regeneration (generation replaces the month from staged files only).
    var want=inbox.filter(function(x){ return _effLabel(x)===sel; });
    if(!want.length){
      var others={}; inbox.forEach(function(x){ var l=_effLabel(x); if(l) others[l]=1; });
      var avail=Object.keys(others);
      if(statusEl) statusEl.innerHTML='<span style="color:#92400E;">No Gmail commission files staged for <b>'+sel+'</b>.'+(avail.length?' Available for: '+avail.join(", ")+' — switch the period above and import.':' (none pulled yet — the daily 9am sync will fetch new ones)')+'</span>';
      if(btn){ btn.disabled=false; btn.textContent="📥 Import from Gmail"; }
      return;
    }
    if(statusEl) statusEl.innerHTML='<span style="color:#6B7280;">⏳ Downloading '+want.length+' file(s) from secure storage…</span>';
    var files=[];
    for(var i=0;i<want.length;i++){
      var row=want[i];
      var resp=await fetch(API+"/api/commission-inbox/"+row.id+"/file",{headers:_apiHeaders()});
      if(!resp.ok) throw new Error("download failed for "+row.filename);
      var blob=await resp.blob();
      files.push(new File([blob], row.filename, {type:row.content_type||"application/octet-stream"}));
    }
    // mark newly-received rows imported (best-effort) then run the existing decrypt/parse/stage pipeline
    want.forEach(function(row){ if(row.status==="received") apiPost("/api/commission-inbox/"+row.id+"/imported",{}).catch(function(){}); });
    // §PERIOD-LABEL — the parser will read each file's own date range; remember which
    // inbox row the file came from so that range can be written back to it.
    window._inboxIdByName = {};
    want.forEach(function(row){ window._inboxIdByName[row.filename] = row.id; });
    upProcessFiles(files);  // re-renders the panel on finish
  }catch(e){
    if(statusEl) statusEl.innerHTML='<span style="color:#B91C1C;">Import failed: '+(e.message||e)+'</span>';
    if(btn){ btn.disabled=false; btn.textContent="📥 Import from Gmail"; }
  }
}

function upProcessFiles(files) {
  // Accept xlsx, pdf, zip
  files = files.filter(function(f){
    var n=f.name.toLowerCase();
    return n.endsWith(".xlsx")||n.endsWith(".pdf")||n.endsWith(".zip");
  });

  var statusEl = document.getElementById("up-status");
  if (!files.length) {
    if(statusEl) statusEl.innerHTML='<span style="color:#DC2626;">❌ No supported files found (.xlsx · .pdf · .zip)</span>';
    return;
  }
  if(statusEl) statusEl.innerHTML='<span style="color:#6B7280;">⏳ Processing '+files.length+' file(s)…</span>';

  var results=[], pending=files.length;
  function done(r){ results.push(r); if(--pending===0) upFinishUpload(results); }

  files.forEach(function(file){
    var n=file.name.toLowerCase();
    var reader=new FileReader();
    reader.onerror=function(){ done({name:file.name,status:"error",msg:"File read failed"}); };
    reader.onload=function(e){
      var buf=e.target.result;
      if(n.endsWith(".zip")){
        // Expand ZIP with password LFA888 (AES-256)
        var statusEl2=document.getElementById("up-status");
        if(statusEl2) statusEl2.innerHTML='<span style="color:#6B7280;">⏳ Decrypting ZIP: '+file.name+' (AES-256)…</span>';
        // Extract date from ZIP filename for passing to files that lack dates (e.g. Trailer)
        var zipDateMatch = file.name.match(/(\d{1,2})-([A-Za-z]{3})-(\d{4})/);
        var zipDateHint = zipDateMatch ? (zipDateMatch[1]+'-'+zipDateMatch[2]+'-'+zipDateMatch[3]) : null;
        ZipAES.extractAllAsync(buf,IFAST_ZIP_PASS).then(async function(extracted){
          var xlsxNames=Object.keys(extracted).filter(function(k){
            return k.toLowerCase().endsWith(".xlsx") && !k.includes("__MACOSX") && !k.split('/').pop().startsWith('._');
          });
          if(!xlsxNames.length){done({name:file.name,status:"error",msg:"No .xlsx files found in ZIP (decryption succeeded)"});return;}
          // §CONTROL-TOTAL — read iFAST's own self-billed invoice out of the archive
          // FIRST, so every file staged from this zip carries the figure it must be
          // proved against before a statement can be generated.
          var invName=Object.keys(extracted).filter(function(k){
            return k.toLowerCase().endsWith(".pdf") && /selfbilled|invoice/i.test(k) && !k.includes("__MACOSX");
          })[0];
          var inv=null;
          if(invName){ try{ inv=await upParseSelfBilledInvoice(extracted[invName]); }catch(e){ inv=null; } }
          var inner=xlsxNames.length, innerResults=[];
          xlsxNames.forEach(function(innerPath){
            var shortName=innerPath.split("/").pop();
            try{
              var wb=XLSX.read(extracted[innerPath],{type:"array"});
              var rows=XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]],{header:1,defval:null});
              var r=upParseOneFile(shortName,wb,rows,zipDateHint,{zip:file.name,invoice:inv});
              innerResults.push(r);
            }catch(ex){ innerResults.push({name:shortName,status:"error",msg:ex.message}); }
            if(--inner===0){
              innerResults.forEach(function(r){ results.push(r); });
              if(--pending===0) upFinishUpload(results);
            }
          });
        }).catch(function(err){ done({name:file.name,status:"error",msg:"ZIP decrypt failed: "+err.message+" — check that ZIP password matches '"+IFAST_ZIP_PASS+"' in Admin Panel"}); });
      } else if(n.endsWith(".pdf")){
        upParsePhillipPDFBuffer(buf,file.name).then(function(parsed){
          parsed.batch="Phillip";
          var det=upDetectFileRole(file.name, null);
          var r=upStageOne(file.name,"Phillip",parsed,det.earningMonth||UP_FILTER.month,"Phillip");
          done(r);
        }).catch(function(ex){ done({name:file.name,status:"error",msg:ex.message}); });
      } else {
        try{
          var wb2=XLSX.read(new Uint8Array(buf),{type:"array"});
          var rows2=XLSX.utils.sheet_to_json(wb2.Sheets[wb2.SheetNames[0]],{header:1,defval:null});
          var r2=upParseOneFile(file.name,wb2,rows2);
          done(r2);
        }catch(ex){ done({name:file.name,status:"error",msg:ex.message}); }
      }
    };
    reader.readAsArrayBuffer(file);
  });
}

function upParseOneFile(filename,wb,rows,zipDateHint,batchInfo){
  // Pass zipDateHint directly into detection so Trailer/WrapFees use ZIP date
  var det=upDetectFileRole(filename, zipDateHint);
  
  var parsed;
  if(/trailer/i.test(filename)){
    parsed=upParseTrailer(rows,filename); 
    parsed.batch="Trailer";
  } else if(/wrap.?fee/i.test(filename)){
    parsed=upParseWrapFees(wb,filename); 
    parsed.batch="WrapFees";
  } else {
    parsed=upParseiFAST(rows,filename,wb);
    var role = det.role||"1st";
    parsed.batch = (parsed.type||"UT") + "_" + role;
    parsed._role = role;
    // BONUS: if the file has an internal Commission Received Date range, use it as ground truth
    // e.g. "01-Jan-2026 - 15-Jan-2026" → Jan 2026 — but NOT for Stock (its date is a payout date)
    if (parsed.date && parsed.type !== "Stock") {
      var internalMonth = upEarningMonthFromDateRange(parsed.date);
      if (internalMonth) det.earningMonth = internalMonth;
      // §PERIOD-LABEL — tell the inbox row what this file actually covers. A 10-Sep
      // payout file covers 16–31 Aug; the row's label must say so, not the payout month.
      var _ibId = window._inboxIdByName && window._inboxIdByName[filename];
      var _ym = internalMonth ? _ymFromMonthLabel(internalMonth) : null;
      if (_ibId && _ym) apiPost("/api/commission-inbox/"+_ibId+"/imported", {period:_ym, date_range:String(parsed.date)}).catch(function(){});
    }
  }
  var label = det.label || (parsed._role==="1st"?"iFAST 1st Half":"iFAST 2nd Half");
  // §CONTROL-TOTAL — the archive this file came from, and what iFAST says the
  // archive paid. Both travel with the staged file so the generator can prove the
  // advisers add up before it writes a single statement.
  if(batchInfo){
    parsed.zipName=batchInfo.zip||"";
    if(batchInfo.invoice){ parsed.invoiceTotal=batchInfo.invoice.total; parsed.invoiceNo=batchInfo.invoice.invoice; }
  }
  return upStageOne(filename,"iFAST",parsed,det.earningMonth||UP_FILTER.month,label);
}

function upStageOne(filename,partner,parsed,targetMonth,label){
  if(!targetMonth||targetMonth==="all"){
    return {name:filename,status:"error",msg:"Could not detect earning month. Include the issue date in the filename, e.g. IFA_trailer_commission_25-Jan-2026_LFA.xlsx"};
  }
  // ── MONTH MISMATCH CHECK ──────────────────────────────────────────────────
  // If admin is viewing a specific month tab, the file MUST belong to that month.
  var expectedMonth = (UP_FILTER && UP_FILTER.month && UP_FILTER.month !== "all") ? UP_FILTER.month : null;
  if (expectedMonth && targetMonth !== expectedMonth) {
    return {
      name: filename, status: "wrong_month",
      detectedMonth: targetMonth, expectedMonth: expectedMonth,
      label: label, batch: parsed.batch
    };
  }
  // ─────────────────────────────────────────────────────────────────────────
  var existing=(UPLOADS[partner][targetMonth]||[]).find(function(x){return x.batch===parsed.batch;});
  if(existing) return {name:filename,status:"duplicate",month:targetMonth,batch:parsed.batch,existing:existing.name,label:label};
  if(!UPLOADS[partner][targetMonth]) UPLOADS[partner][targetMonth]=[];
  UPLOADS[partner][targetMonth].push(parsed);
  return {name:filename,status:"ok",month:targetMonth,label:label,batch:parsed.batch,agents:Object.keys(parsed.agentTotals||{}).length};
}

function upFinishUpload(results){
  var ok       = results.filter(function(r){return r.status==="ok";});
  var dups     = results.filter(function(r){return r.status==="duplicate";});
  var errs     = results.filter(function(r){return r.status==="error";});
  var wrongMon = results.filter(function(r){return r.status==="wrong_month";});

  // ── Show blocking error modal if any files were rejected ─────────────────
  var rejected = wrongMon.concat(dups).concat(errs);
  if (rejected.length) {
    var modalRows = "";

    wrongMon.forEach(function(r) {
      modalRows += '<div style="display:flex;gap:12px;align-items:flex-start;background:#FFF5F5;border:1px solid #FECACA;border-radius:10px;padding:12px 14px;margin-bottom:10px;">'
        + '<div style="font-size:22px;flex-shrink:0;">🗓️</div>'
        + '<div style="flex:1;min-width:0;">'
        + '<div style="font-size:12px;font-weight:800;color:#DC2626;margin-bottom:4px;">Wrong Month — File Rejected</div>'
        + '<div style="font-size:12px;font-weight:700;color:#374151;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" title="'+r.name+'">📄 '+r.name+'</div>'
        + '<div style="font-size:11px;color:#6B7280;margin-top:5px;line-height:1.7;">'
        + '<span style="background:#FEE2E2;color:#DC2626;padding:1px 8px;border-radius:5px;font-weight:700;">File belongs to: '+r.detectedMonth+'</span>'
        + '&nbsp;&nbsp;'
        + '<span style="background:#DBEAFE;color:#1D4ED8;padding:1px 8px;border-radius:5px;font-weight:700;">Selected period: '+r.expectedMonth+'</span>'
        + '</div>'
        + '<div style="font-size:11px;color:#374151;margin-top:6px;background:#fff;border-radius:6px;padding:6px 10px;border:1px dashed #FCA5A5;">'
        + '👉 Switch the period selector to <b>'+r.detectedMonth+'</b>, then upload this file again.'
        + '</div>'
        + '</div></div>';
    });

    dups.forEach(function(r) {
      modalRows += '<div style="display:flex;gap:12px;align-items:flex-start;background:#FFFBEB;border:1px solid #FDE68A;border-radius:10px;padding:12px 14px;margin-bottom:10px;">'
        + '<div style="font-size:22px;flex-shrink:0;">⚠️</div>'
        + '<div style="flex:1;min-width:0;">'
        + '<div style="font-size:12px;font-weight:800;color:#B45309;margin-bottom:4px;">Duplicate File — Rejected</div>'
        + '<div style="font-size:12px;font-weight:700;color:#374151;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" title="'+r.name+'">📄 '+r.name+'</div>'
        + '<div style="font-size:11px;color:#6B7280;margin-top:4px;line-height:1.7;">'
        + '<b>'+r.batch+'</b> for <b>'+r.month+'</b> is already staged as: <span style="color:#92400E;font-weight:700;">'+r.existing+'</span>'
        + '</div>'
        + '<div style="font-size:11px;color:#374151;margin-top:6px;background:#fff;border-radius:6px;padding:6px 10px;border:1px dashed #FDE68A;">'
        + '👉 Delete the existing file first (✕ button in checklist) before uploading a replacement.'
        + '</div>'
        + '</div></div>';
    });

    errs.forEach(function(r) {
      modalRows += '<div style="display:flex;gap:12px;align-items:flex-start;background:#FFF5F5;border:1px solid #FECACA;border-radius:10px;padding:12px 14px;margin-bottom:10px;">'
        + '<div style="font-size:22px;flex-shrink:0;">❌</div>'
        + '<div style="flex:1;min-width:0;">'
        + '<div style="font-size:12px;font-weight:800;color:#DC2626;margin-bottom:4px;">Upload Error</div>'
        + '<div style="font-size:12px;font-weight:700;color:#374151;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" title="'+r.name+'">📄 '+r.name+'</div>'
        + '<div style="font-size:11px;color:#DC2626;margin-top:4px;font-family:monospace;background:#FEF2F2;border-radius:4px;padding:4px 8px;">'+r.msg+'</div>'
        + '<div style="font-size:11px;color:#374151;margin-top:6px;background:#fff;border-radius:6px;padding:6px 10px;border:1px dashed #FCA5A5;">'
        + '👉 Check that the file is a valid iFAST or Phillip export, then try again.'
        + '</div>'
        + '</div></div>';
    });

    var summary = [];
    if (wrongMon.length) summary.push('<span style="color:#DC2626;font-weight:700;">'+wrongMon.length+' wrong-month</span>');
    if (dups.length)     summary.push('<span style="color:#B45309;font-weight:700;">'+dups.length+' duplicate</span>');
    if (errs.length)     summary.push('<span style="color:#DC2626;font-weight:700;">'+errs.length+' error</span>');
    var okNote = ok.length ? '<div style="margin-top:12px;background:#F0FDF4;border:1px solid #BBF7D0;border-radius:8px;padding:8px 12px;font-size:11px;color:#166534;font-weight:700;">✓ '+ok.length+' file(s) staged successfully alongside these rejections.</div>' : "";

    var modal = document.createElement("div");
    modal.id = "up-error-modal";
    modal.style.cssText = "position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;";
    modal.innerHTML = '<div style="background:#fff;border-radius:16px;box-shadow:0 24px 64px rgba(0,0,0,.25);width:100%;max-width:560px;max-height:85vh;display:flex;flex-direction:column;overflow:hidden;">'
      // Header
      + '<div style="background:linear-gradient(135deg,#DC2626,#991B1B);padding:18px 22px;display:flex;align-items:center;gap:12px;">'
      + '<div style="width:36px;height:36px;background:rgba(255,255,255,0.2);border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0;">⛔</div>'
      + '<div style="flex:1;">'
      + '<div style="font-size:15px;font-weight:800;color:#fff;">Upload Rejected — Action Required</div>'
      + '<div style="font-size:11px;color:rgba(255,255,255,0.75);margin-top:2px;">'+summary.join(", ")+' file(s) could not be accepted</div>'
      + '</div>'
      + '<button onclick="document.getElementById(\'up-error-modal\').remove()" style="background:rgba(255,255,255,0.15);border:none;color:#fff;font-size:18px;cursor:pointer;border-radius:8px;padding:4px 10px;font-weight:700;flex-shrink:0;">✕</button>'
      + '</div>'
      // Body
      + '<div style="overflow-y:auto;padding:18px 22px;flex:1;">'
      + modalRows
      + okNote
      + '</div>'
      // Footer
      + '<div style="padding:14px 22px;border-top:1px solid #F1F5F9;display:flex;justify-content:flex-end;background:#FAFAFA;">'
      + '<button onclick="document.getElementById(\'up-error-modal\').remove()" style="padding:10px 28px;background:#DC2626;color:#fff;border:none;border-radius:8px;font-size:13px;font-weight:700;cursor:pointer;">I Understand — Close</button>'
      + '</div>'
      + '</div>';

    // Remove any existing modal first
    var existing = document.getElementById("up-error-modal");
    if (existing) existing.remove();
    document.body.appendChild(modal);

    // Click backdrop to close
    modal.addEventListener("click", function(e){ if(e.target===modal) modal.remove(); });
  }

  // ── Status line (successes only, shown below drop zone) ───────────────────
  if (ok.length) {
    var statusEl = document.getElementById("up-status");
    if (statusEl) {
      statusEl.innerHTML = '<div style="background:#F0FDF4;border:1px solid #BBF7D0;border-radius:8px;padding:8px 12px;font-size:12px;color:#166534;font-weight:700;">'
        + '✓ Staged '+ok.length+' file(s): '
        + ok.map(function(r){ return '<span style="background:#DCFCE7;padding:1px 7px;border-radius:4px;margin:1px;display:inline-block;">'+r.label+' → '+r.month+' ('+r.agents+' agents)</span>'; }).join(" ")
        + '</div>';
    }
  } else {
    var statusEl = document.getElementById("up-status");
    if (statusEl && !rejected.length) statusEl.innerHTML = "";
  }

  if (ok.length && ok[0].month) UP_FILTER.month = ok[0].month;
  renderUploadPanel();
}

// ── iFAST Excel Parsers ───────────────────────────────────────────────────────
function upParseiFAST(rows,filename,wb){
  var title=(rows[8]||[])[0]||"";
  var type="UT";
  if(/dpms/i.test(title)||/dpms/i.test(filename)) type="DPMS";
  else if(/stock/i.test(title)||/stock/i.test(filename)) type="Stock";
  else if(/bond/i.test(filename)||/bond/i.test(title)) type="Bond";

  var dateRange="";
  for(var i=0;i<Math.min(20,rows.length);i++){
    var r=rows[i]; if(!r) continue;
    var r1=(r[1]||"").toString(), r2=(r[2]||"").toString().trim();
    if(/(Commission.*(Received|Payout) Date|Commission Payout Date)/i.test(r1)){dateRange=r2;break;}
  }

  // Bond files: route to Bond parser with full workbook access (Buy + Sell sheets)
  if(type==="Bond") return upParseiFASTBond(wb||{SheetNames:[],Sheets:{}},filename,dateRange);

  var agentTotals={},currentAgent=null,headerRow=null;
  var stockParseError=null; var utParseError="", utFileTotal=null;

  // ── the file's own TOTALS BLOCK, and why it must be found ────────────────
  // 🔥 ROOT CAUSE OF THE 2026-09-13 COMMISSION DEFECT. An iFAST sheet is a run of
  // "Adviser Name: X [LFAnnnnn]" sections followed, ONCE, by the FILE's totals:
  //     row A: Gross Investment Amount | Nett Investment Amount | iFast Comm | Adviser Comm (MYR)
  //     row B: Grand Total : | 43500.00 | 42869.65 | 35.02 | 490.27      <- ALL advisers
  //     row C: BUY | 2 | Adviser Comm (MYR) | 490.27 | 39.22 | 529.4928  <- the same money +8% SST
  // The parser had no concept of a file-level block, so "everything until the next
  // Adviser Name" swept those rows into the LAST adviser's section. DPMS then read
  // row B (490.27) AND added row C (529.49) — the same commission twice, once with
  // tax — and booked 1,019.76 against one adviser. UT did the sibling thing: it
  // assigned the file total to the last-listed adviser ON TOP of everyone's real
  // rows. Verified on IFA_dpms/ut_commission_10-Sep-2026: per-adviser truth is
  // DPMS {Tong 488.18, Cheng 2.09, Koek 0} and UT {Chu 133.06, Tong 20.40,
  // Cheng 4.96, Gan 0} — and in BOTH files those per-row figures sum EXACTLY to
  // the Grand Total. The per-row "Adviser Comm (MYR)" column was correct all along.
  function upTotalsBlockStart(rows){
    for(var i=0;i<rows.length;i++){
      var r=rows[i]; if(!r) continue;
      if((r[0]||"").toString()==="Contract No") continue;          // a TRANSACTION header
      if(/Grand Total/i.test((r[0]||"").toString())||/Grand Total/i.test((r[8]||"").toString())) return i;
      var lbl=r.some(function(c){return c&&/Adviser Comm/i.test(c.toString());});
      var gross=r.some(function(c){return c&&/Gross Investment Amount/i.test(c.toString());});
      if(lbl&&gross) return i;                                     // the file's own header row
    }
    return rows.length;
  }
  function upFileGrandTotal(rows){
    // The adviser-commission figure on the "Grand Total :" row, read by its own
    // header (never a fixed column, never the SST-inclusive one).
    for(var i=0;i<rows.length;i++){
      var r=rows[i]; if(!r) continue;
      if(!(/Grand Total/i.test((r[0]||"").toString())||/Grand Total/i.test((r[8]||"").toString()))) continue;
      for(var j=i-1;j>=Math.max(0,i-3);j--){
        var h=rows[j]; if(!h) continue;
        var k=h.findIndex(function(c){return c&&/Adviser Comm/i.test(c.toString());});
        if(k>=0) return {ok:true,total:parseFloat(r[k]||0)||0};
      }
    }
    return {ok:false,total:0};
  }
  function upAdvCommCol(headerRow){
    if(!headerRow) return -1;
    return headerRow.findIndex(function(c){return c&&/Adviser Comm/i.test(c.toString().replace(/\n/g," "));});
  }

  if(type==="DPMS"){
    // Per adviser: the sum of their OWN rows' "Adviser Comm (MYR)". Negatives are
    // kept — a clawback is money iFAST took back, and dropping it would pay out
    // commission the firm no longer holds. The per-adviser sums are then checked
    // against the file's Grand Total; a mismatch REFUSES the file rather than
    // guessing, the way the Phillip reader now refuses an unmatched name.
    var dpmsAgentTotals={};
    var stop=upTotalsBlockStart(rows);
    var cur=null, curHdr=null;
    for(var ri=0;ri<stop;ri++){
      var row=rows[ri]; if(!row) continue;
      var c0=(row[0]||"").toString();
      var m=c0.match(/^Adviser Name:\s*(.+?)\s*\[(\w+)\]/);
      if(m){
        cur=m[2]; curHdr=null;
        if(!dpmsAgentTotals[cur]) dpmsAgentTotals[cur]={name:m[1].trim(),ifast_comm:0,transactions:[]};
        continue;
      }
      if(c0==="Contract No"){ curHdr=row; continue; }
      if(!cur||!curHdr||!c0) continue;
      var ac=upAdvCommCol(curHdr); if(ac<0) continue;
      var v=parseFloat(row[ac]||0)||0;
      if(!v) continue;
      dpmsAgentTotals[cur].ifast_comm=parseFloat((dpmsAgentTotals[cur].ifast_comm+v).toFixed(2)); // GUARD-ALLOW: accumulation x = x + v, written as assignment only to round to 2dp. v is this row's own adviser-comm column.
      var t=upBuildTxn(row,curHdr,"DPMS"); t.ifast_comm=v; t.type="DPMS";
      dpmsAgentTotals[cur].transactions.push(t);
    }
    Object.keys(dpmsAgentTotals).forEach(function(id){Object.keys(ADVISERS).forEach(function(k){if((ADVISERS[k].ifast||"").toUpperCase()===id.toUpperCase()) dpmsAgentTotals[id].name=ADVISERS[k].name;});});
    var gt=upFileGrandTotal(rows);
    var sum=Object.keys(dpmsAgentTotals).reduce(function(a,k){return a+dpmsAgentTotals[k].ifast_comm;},0);
    var err="";
    if(gt.ok && Math.abs(sum-gt.total)>0.011)
      err="DPMS file does not reconcile: advisers add up to RM"+sum.toFixed(2)+" but the file's Grand Total is RM"+gt.total.toFixed(2)+". Nothing was generated — send the file to whoever maintains the parser.";
    return {name:filename,type:type,date:dateRange,partner:"iFAST",agentTotals:dpmsAgentTotals,
            fileTotal:gt.ok?gt.total:null,parseError:err};
  }

  // UT and Stock: agent sections with transaction rows
  for(var ri=0;ri<rows.length;ri++){
    var row=rows[ri]; if(!row) continue;
    var c0=(row[0]||"").toString();
    var m=c0.match(/^Adviser Name:\s*(.+?)\s*\[(\w+)\]/);
    if(m){ currentAgent=m[2]; if(!agentTotals[currentAgent]) agentTotals[currentAgent]={name:m[1].trim(),ifast_comm:0,transactions:[]}; headerRow=null; continue; }
    if(c0==="Contract No"){ headerRow=row; continue; }
    if(!currentAgent||!headerRow||!c0||/Grand Total/.test(c0)) continue;
    if(type==="Stock"){
      // §NO-FABRICATION — a stock row carries its OWN "Adviser Commission (MYR)". The old code
      // asserted it did not, skipped the column, then took the file's Grand Total and either
      // spread it evenly over the rows (destroying their real amounts) or invented a
      // "(Stock trades)" row. Both are fabrication. The per-row column is read here; the
      // Grand Total is used ONLY as a control to compare against, never as a source.
      if(/^[A-Z]/.test(c0)){
        var h2={}; headerRow.forEach(function(c,i){if(c) h2[c.toString().replace(/\n/g," ").trim()]=i;});
        var get2=function(k){return h2[k]!==undefined?row[h2[k]]:null;};
        var stkComm=parseFloat(get2("Adviser Commission (MYR)")||get2("Adviser Commission")||0)||0;
        agentTotals[currentAgent].transactions.push({contract:c0,client:(get2("Client Name")||"").toString(),txn_date:(get2("Transaction Date")||"").toString().substring(0,10),fund:(get2("Product Name")||"").toString(),txn_type:(get2("Transaction Type")||"Sell").toString(),amount:parseFloat(get2("Transacted Amount\n(Product Curr)")||get2("Transacted Amount (Product Curr)")||0)||0,ifast_comm:stkComm,type:"Stock"});
        agentTotals[currentAgent].ifast_comm+=stkComm;
      }
    } else {
      if(/^[A-Z]/.test(c0)){
        var txn=upBuildTxn(row,headerRow,type);
        // A NEGATIVE row is a clawback — money iFAST has already taken back. It used
        // to be dropped as an "internal fee deduction", which left the per-adviser
        // sum higher than the file's own net and paid out commission the firm no
        // longer holds. Kept, so the section total equals what iFAST actually paid.
        if(txn && txn.ifast_comm !== 0){ agentTotals[currentAgent].transactions.push(txn); agentTotals[currentAgent].ifast_comm=parseFloat((agentTotals[currentAgent].ifast_comm+txn.ifast_comm).toFixed(2)); } // GUARD-ALLOW: accumulation x = x + txn.ifast_comm, rounded; txn comes from upBuildTxn on this row.
      }
    }
  }
  // ── UT: the file total is a CHECK, never an assignment ────────────────────
  // It used to be assigned to `utAgent` — simply the last "Adviser Name:" seen —
  // on top of everybody's real per-row credits, so the file's whole total was
  // booked a second time against one person (Apr 2026: Tong Huey Pyng credited
  // RM488.56 on rows totalling MINUS 17.08, and paid half of it). The per-row
  // column is authoritative; the Grand Total now only confirms it.
  if(type==="UT"){
    var utSum=Object.keys(agentTotals).reduce(function(a,k){return a+agentTotals[k].ifast_comm;},0);
    var utGt=upFileGrandTotal(rows);
    if(utGt.ok && Math.abs(utSum-utGt.total)>0.011)
      utParseError="Unit trust file does not reconcile: advisers add up to RM"+utSum.toFixed(2)+" but the file's Grand Total is RM"+utGt.total.toFixed(2)+". Nothing was generated — send the file to whoever maintains the parser.";
    utFileTotal=utGt.ok?utGt.total:null;
  }
  // §NO-FABRICATION — the Grand Total is a CONTROL, never a source. The adviser figure is
  // SUM(their own rows). If the rows do not add up to what iFAST printed on the file, the
  // month STOPS. It is never reconciled by overwriting the rows or inventing one.
  if(type==="Stock"){
    var stkAgent=null, stkPrinted=null;
    for(var ri=0;ri<rows.length;ri++){
      var row=rows[ri]; if(!row) continue;
      var c0=(row[0]||"").toString();
      var sm=c0.match(/^Adviser Name:\s*(.+?)\s*\[(\w+)\]/);
      if(sm){ stkAgent=sm[2]; continue; }
      if(c0==="Contract No") continue;
      var advCol=row.findIndex(function(c){return c&&/Adviser Comm/i.test(c.toString())&&!/WHT|after/i.test(c.toString());});
      if(advCol>=0 && !row.some(function(c){return c&&/Contract No/i.test(c.toString());})){
        for(var nri=ri+1;nri<Math.min(ri+4,rows.length);nri++){
          var nr=rows[nri]; if(!nr) continue;
          var pv=parseFloat(nr[advCol]||0);
          if(!isNaN(pv)){ stkPrinted=(stkPrinted===null?0:stkPrinted)+pv; }
          break;
        }
      }
    }
    if(stkPrinted!==null){
      var stkSum=0;
      Object.keys(agentTotals).forEach(function(a){ stkSum+=agentTotals[a].ifast_comm||0; });
      stkSum=Math.round(stkSum*100)/100; stkPrinted=Math.round(stkPrinted*100)/100;
      if(Math.abs(stkSum-stkPrinted)>0.011)
        stockParseError="Stock file does not reconcile: the advisers' own transaction rows add up to RM"+stkSum.toFixed(2)+" but the file's Grand Total is RM"+stkPrinted.toFixed(2)+". Nothing was generated.";
    }
  }
  return {name:filename,type:type,date:dateRange,partner:"iFAST",agentTotals:agentTotals,fileTotal:utFileTotal,parseError:utParseError};
}

function upParseiFASTBond(wb,filename,dateRange){
  // Bond file: has "Bond Buy Comm" and "Bond Sell Comm" sheets
  // Each sheet: "Ifa Company | Ifa Id | Status | Contract No | ... | Adviser Comm | ..."
  // All agent data is in flat rows — no per-agent sections
  var agentTotals={};
  
  wb.SheetNames.forEach(function(sheetName){
    if(!/bond/i.test(sheetName)&&!/sell/i.test(sheetName)&&!/buy/i.test(sheetName)) return;
    var rows=XLSX.utils.sheet_to_json(wb.Sheets[sheetName],{header:1,defval:null});
    var headerRow=null;
    for(var ri=0;ri<rows.length;ri++){
      var row=rows[ri]; if(!row) continue;
      var c0=(row[0]||"").toString().trim();
      var c1=(row[1]||"").toString().trim();
      // Header row: starts with "Ifa Company"
      if(/^Ifa Company$/i.test(c0)){ headerRow=row; continue; }
      if(!headerRow) continue;
      // Skip Grand Total and empty rows
      if(/Grand Total/i.test(c0)||/Grand Total/i.test(c1)) continue;
      if(!c1||!c1.startsWith("LFA")) continue;
      // Build header map
      var h={}; headerRow.forEach(function(c,i){if(c) h[c.toString().replace(/\n/g," ").trim()]=i;});
      var agentId=c1.trim();
      var advComm=parseFloat(row[h["Adviser Comm"]]||row[h["Adviser Comm (MYR)"]]||0)||0;
      var client=(row[h["Client Name"]]||row[h["Refno"]]||"").toString();
      var bondName=(row[h["Bond Name"]]||"").toString().trim();
      var txnDate=(row[h["Transaction Date"]]||"").toString().substring(0,10);
      var txnType=(row[h["Transaction Type"]]||sheetName.replace(" Comm","")).toString();
      if(!agentTotals[agentId]) agentTotals[agentId]={name:agentId,ifast_comm:0,transactions:[]};
      agentTotals[agentId].ifast_comm+=advComm;
      if(advComm>0) agentTotals[agentId].transactions.push({contract:(row[h["Contract No"]]||"").toString(),client:client,txn_date:txnDate,fund:bondName,txn_type:txnType,amount:parseFloat(row[h["Quantity"]]||0)||0,ifast_comm:advComm,type:"Bond"});
    }
  });
  
  // Look up names from ADVISERS
  Object.keys(agentTotals).forEach(function(id){Object.keys(ADVISERS).forEach(function(k){if((ADVISERS[k].ifast||"").toUpperCase()===id.toUpperCase()) agentTotals[id].name=ADVISERS[k].name;});});
  return {name:filename,type:"Bond",date:dateRange,partner:"iFAST",agentTotals:agentTotals};
}

function upBuildTxn(row,headerRow,type){
  var h={}; headerRow.forEach(function(c,i){if(c) h[c.toString().replace(/\n/g," ").trim()]=i;});
  var get=function(k){return h[k]!==undefined?row[h[k]]:null;};
  if(type==="Stock"){
    var comm=0; for(var k in h){if(/adviser comm/i.test(k)){comm=parseFloat(row[h[k]]||0)||0;break;}}
    return {contract:(row[0]||"").toString(),client:(get("Client Name")||"").toString(),txn_date:(get("Transaction Date")||"").toString().substring(0,10),fund:(get("Product Name")||"").toString(),txn_type:"Sell",amount:parseFloat(get("Transacted Amount\n(Product Curr)")||0)||0,ifast_comm:comm,type:"Stock"};
  }
  var comm2=parseFloat(get("Adviser Comm (MYR)")||0)||0;
  return {contract:(row[0]||"").toString(),client:(get("Client Name")||"").toString(),txn_date:(get("Txn Date")||"").toString().substring(0,10),fund:(get("Fund Name")||get("Portfolio Name")||"").toString(),txn_type:(get("Transaction Type")||"Buy").toString(),amount:parseFloat(get("Gross Investment Amount")||0)||0,ifast_comm:comm2,type:type};
}

function upParseTrailer(rows,filename){
  var header=rows[0]; if(!header) return {name:filename,type:"Trailer",date:"",partner:"iFAST",agentTotals:{},batch:"Trailer"};
  var h={}; header.forEach(function(c,i){if(c) h[c.toString()]=i;});
  var agentTotals={};
  for(var ri=1;ri<rows.length;ri++){
    var row=rows[ri]; if(!row||!row.some(function(v){return v!==null;})) continue;
    var id=(row[h["Agent ID"]]||"").toString().trim();
    if(!id.startsWith("LFA")) continue;
    var comm=(parseFloat(row[h["Trailer Cash"]]||0)||0)+(parseFloat(row[h["Trailer EPF"]]||0)||0);
    if(!agentTotals[id]) agentTotals[id]={name:id,ifast_comm:0,transactions:[]};
    agentTotals[id].ifast_comm+=comm;
    if(comm>0) agentTotals[id].transactions.push({contract:"—",client:(row[h["Client Name"]]||"").toString(),txn_date:"",fund:(row[h["Fund Name"]]||"").toString(),txn_type:"Trailer",amount:parseFloat(row[h["Aum Cash"]]||0)||0,ifast_comm:comm,type:(row[h["Product Type"]]||"UT")+" Trailer"});
  }
  Object.keys(agentTotals).forEach(function(id){Object.keys(ADVISERS).forEach(function(k){if((ADVISERS[k].ifast||"").toUpperCase()===id.toUpperCase()) agentTotals[id].name=ADVISERS[k].name;});});
  return {name:filename,type:"Trailer",date:"",partner:"iFAST",batch:"Trailer",agentTotals:agentTotals};
}

function upParseWrapFees(wb,filename){
  var agentTotals={},dateRange="";
  wb.SheetNames.forEach(function(sheetName){
    var rows=XLSX.utils.sheet_to_json(wb.Sheets[sheetName],{header:1,defval:null});
    var currentAgent=null,headerRow=null;
    for(var ri=0;ri<rows.length;ri++){
      var row=rows[ri]; if(!row) continue;
      var c0=(row[0]||"").toString();
      if(!dateRange&&/Commission Payout Date/i.test((row[1]||"").toString())) dateRange=(row[2]||"").toString().trim();
      var m=c0.match(/^Adviser Name:\s*(.+?)\s*\[(\w+)\]/);
      if(m){currentAgent=m[2];if(!agentTotals[currentAgent])agentTotals[currentAgent]={name:m[1].trim(),ifast_comm:0,transactions:[]};headerRow=null;continue;}
      if(c0==="QTR"){headerRow=row;continue;}
      // §STRUCTURAL — a wrap data row opens with the QTR column, which is a NUMBER. The
      // file's summary block ("Grand Total Wrap Fee (RM):", "Total iFAST Share (RM):") opens
      // with text and is NOT a transaction. This was previously masked by a payable<=0 filter,
      // which silently dropped those rows AND every genuine zero-value wrap fee with them.
      if(!currentAgent||!headerRow||!c0) continue;
      if(!/^\d+(\.\d+)?$/.test(c0.toString().trim())) continue;
      var h={}; headerRow.forEach(function(col,i){if(col) h[col.toString().trim()]=i;});
      var payable=parseFloat(row[h["FINAL PAYABLE TO FA (RM)"]]||0)||0;
      // §NO-SILENT-DROP — a zero or negative wrap fee is a real row and is shown. Dropping it
      // made the adviser's statement unreconcilable against iFAST's own row count.
      agentTotals[currentAgent].ifast_comm+=payable;
      agentTotals[currentAgent].transactions.push({contract:(row[h["INVOICE NO"]]||"").toString(),client:(row[h["CUST NAME"]]||"").toString(),txn_date:(row[h["DATE RECEIVED"]]||"").toString(),fund:"Wrap Fee — "+sheetName+" ("+(row[h["WRAP FEE METHOD"]]||"")+")",txn_type:"Wrap Fee",amount:parseFloat(row[h["TOTAL WRAP FEES (RM)"]]||0)||0,ifast_comm:payable,type:"Wrap Fee "+sheetName});
    }
  });
  return {name:filename,type:"Wrap Fees",date:dateRange,partner:"iFAST",batch:"WrapFees",agentTotals:agentTotals};
}

// ── §CONTROL-TOTAL — iFAST's own self-billed invoice ─────────────────────────
// Every iFAST archive carries a self-billed invoice PDF stating what iFAST
// actually paid. It is produced by iFAST, it never passes through our parser,
// and it is therefore the ONE independent authority we can prove our figures
// against.
//
// This is a batch control total, the oldest control in data processing, and its
// absence is what let a file's own summary line be read as one adviser's
// earnings for four months. Sep 2026: Tong Huey Pyng was credited RM488.56 —
// the whole April file, for all four advisers — because she is the last name in
// it and nothing checked that the advisers added up to the file's own total.
// With this check that month could never have been generated.
async function upParseSelfBilledInvoice(arrayBuffer){
  if (typeof pdfjsLib === 'undefined') return null;           // no PDF.js → no claim
  var pdf = await pdfjsLib.getDocument({ data: new Uint8Array(arrayBuffer) }).promise;
  var txt = [];
  for (var p = 1; p <= pdf.numPages; p++){
    var page = await pdf.getPage(p);
    var c = await page.getTextContent();
    txt = txt.concat(c.items.map(function(i){ return i.str; }));
  }
  var flat = txt.join(" ").replace(/\s+/g," ");
  var m = flat.match(/Grand Total\s*MYR\s*([\d,]+\.\d\d)/i);
  if (!m) return null;
  var inv = flat.match(/Invoice No\s*(\S+)/i);
  return { total: parseFloat(m[1].replace(/,/g,"")), invoice: inv ? inv[1] : "" };
}

// ── Phillip PDF Parser (uses PDF.js for proper text extraction) ───────────────
// PDF structure from Lifa_PMB_Commission_Statements_January_2026.pdf:
// Each agent section starts with: Consultant Code: LFPxxxx / Name (on same or adjacent page)
// Commission amounts appear after fund names with "Total XX.XX" or as line items
// We parse the full text then extract by LFP code sections

async function upParsePhillipPDFAsync(arrayBuffer, filename) {
  var phillipParseError = null;
  var agentTotals = {};
  
  try {
    if (typeof pdfjsLib === 'undefined') throw new Error('PDF.js not loaded');
    var pdf = await pdfjsLib.getDocument({ data: new Uint8Array(arrayBuffer) }).promise;
    var allText = [];
    
    for (var p = 1; p <= pdf.numPages; p++) {
      var page = await pdf.getPage(p);
      var content = await page.getTextContent();
      // Collect text items preserving order
      var items = content.items.map(function(item) { return item.str.trim(); }).filter(Boolean);
      allText = allText.concat(items);
    }
    
    // §PHILLIP PARSE (rewritten 2026-09-13, owner "check again" / "make sure this
    // dont happen again"). The PDF is SEVERAL statements in one file. Each
    // statement opens with the tokens "Consultant Code :" then "Tier :", the
    // consultant's NAME (or "Lifa Planners Sdn Bhd" for the firm), and its code
    // (LFP0000 = the firm's own overriding statement; LFPnnnn = an adviser). Inside
    // the firm statement every row is labelled with the ADVISER's code + name
    // ("LFP0002 Gan Chin Soon") — those are row labels, NOT a new statement, and
    // treating them as one is exactly what credited the firm's RM238.12 as a
    // transaction under LFP0002 and then overwrote its total with RM9.08.
    // So: the statement code is read ONLY after "Consultant Code :", and every
    // "Grand Total" belongs to the statement that is open at that point.
    // §NO-FABRICATION (2026-09-13) — the old code read the statement's Grand Total and
    // REPLACED the transaction list with one invented row {contract:"PMB", client:"—",
    // fund:"PMB Commission"}. That row is not in the PDF. Phillip prints real particulars
    // ("Trailer Commission 8.91", "Commission Adjustment 267.63"); those are the detail,
    // the total is SUM(detail), and the printed Total is a CONTROL compared against it.
    // A statement appears TWICE in the file — a summary page carrying "Particulars" and a
    // detail page carrying "Currency : MYR". Only the summary page is read; reading both
    // doubles every figure. On the summary page the Total renders VALUE-FIRST ("8.91",
    // "Total") and a bare section header can sit immediately before it, so the Total's
    // value is located first and is never consumed as a line item.
    var firmTotal = 0;
    var PH_LABEL = /^(Overriding\s+)?(Upfront|Trailer|Wrap Fee|Wrap)\s+Commission$|^Commission Adjustment$/i;
    var phNum = function(t){ var v = parseFloat(String(t == null ? "" : t).replace(/,/g, "")); return isNaN(v) ? null : v; };
    var phStarts = [];
    for (var i = 0; i < allText.length; i++) if (allText[i] === "Consultant Code :") phStarts.push(i);
    phStarts.push(allText.length);
    for (var sIdx = 0; sIdx < phStarts.length - 1; sIdx++) {
      var seg = allText.slice(phStarts[sIdx], phStarts[sIdx + 1]);
      if (seg.indexOf("Particulars") < 0) continue;           // detail page repeats the same figures
      var code = null, name = null;
      for (var j = 0; j < Math.min(10, seg.length); j++) if (/^LFP\d{4}$/.test(seg[j])) { code = seg[j]; break; }
      if (!code) continue;
      var cand = seg[2] || "";
      if (cand && !/^(Statement|LFP|Currency|Account|Particulars|Tier)/.test(cand) && !/^\d/.test(cand)) name = cand;
      // locate the Total and its value BEFORE collecting anything
      var printed = null, totalValIdx = -1;
      for (var ti = 0; ti < seg.length; ti++) {
        if (/^(Grand )?Total$/i.test(seg[ti])) {
          var tv = phNum(seg[ti - 1]), tvi = ti - 1;
          if (tv === null) { tv = phNum(seg[ti + 1]); tvi = ti + 1; }
          if (tv !== null) { printed = tv; totalValIdx = tvi; break; }
        }
      }
      // §PHILLIP-8.90 (2026-09-15, owner "yes" to fixing the two live defects). The
      // firm's "Overriding Upfront Commission" row is TWO columns — "LumpSum",
      // "1,201,000.00" (Personal / Group Sales), "8.90" (Commission) — so the token
      // after the label is a word, not the amount, and f0ebf92 dropped RM8.90 from
      // every firm statement (RM71.20 Jan–Aug). The commission is the LAST number
      // before the next structural token (a label, Subtotal, Total, Account Type).
      // A row with NO number before the next structural token (the blank-commission
      // trailer row on the wrap section) is not an item. The printed Total remains
      // the control, and it is now RETURNED so a misread stops the month.
      var PH_STRUCT = /^Subtotal$|^(Grand )?Total$|^Account Type/i;
      var items = [];
      for (var k2 = 0; k2 < seg.length; k2++) {
        if (!PH_LABEL.test(seg[k2])) continue;
        if (totalValIdx >= 0 && k2 >= totalValIdx) continue;   // nothing after the Total is an item
        var v2 = null;
        for (var k3 = k2 + 1; k3 < seg.length && k3 - k2 <= 4; k3++) {
          if (totalValIdx >= 0 && k3 >= totalValIdx) break;    // that number is the Total
          if (PH_LABEL.test(seg[k3]) || PH_STRUCT.test(seg[k3])) break;
          var vn = phNum(seg[k3]);
          if (vn !== null) v2 = vn;                            // keep the LAST number = Commission column
        }
        if (v2 !== null) items.push({ label: seg[k2], amount: v2 });
      }
      var sum = Math.round(items.reduce(function(a, x){ return a + x.amount; }, 0) * 100) / 100;
      // the printed Total is a CONTROL. A statement that does not reconcile STOPS the month.
      if (printed !== null && Math.abs(sum - printed) > 0.011) {
        phillipParseError = "Phillip statement " + code + " does not reconcile: its own printed lines add up to RM" +
          sum.toFixed(2) + " but the statement's Total is RM" + printed.toFixed(2) + ". Nothing was generated.";
      }
      if (code === "LFP0000") { firmTotal = sum; continue; }
      if (!agentTotals[code]) agentTotals[code] = { name: name || code, phillipCode: code, ifast_comm: 0, transactions: [] };
      else if (name && agentTotals[code].name === code) agentTotals[code].name = name;
      agentTotals[code].ifast_comm = sum;  // GUARD-ALLOW: sum is SUM(items) built from this statement's own printed lines above; the printed Total is the control, not the source.
      agentTotals[code].transactions = items.map(function(x){
        return { contract: "PMB", client: name || code, txn_date: "", fund: x.label,
                 txn_type: "Commission", amount: 0, ifast_comm: x.amount, type: "PMB Commission" };
      });
    }

    // Fallback: if no agents found via Grand Total, try "Total MYR XX.XX" pattern
    var hasData = Object.values(agentTotals).some(function(a){ return a.ifast_comm > 0; }) || firmTotal > 0;
    if (!hasData) {
      currentCode = null;
      for (var i2 = 0; i2 < allText.length; i2++) {
        var t2 = allText[i2];
        if (/^LFP(\d{4})$/.test(t2) && t2 !== "LFP0000") {
          currentCode = t2;
          if (!agentTotals[currentCode]) agentTotals[currentCode] = {name:t2,phillipCode:t2,ifast_comm:0,transactions:[]};
        }
        if (currentCode && (t2 === "Total MYR" || t2 === "Total")) {
          var next2 = allText[i2+1] || "";
          var amt2 = parseFloat(next2.replace(/,/g,''));
          // §NO-FABRICATION — this fallback used to ASSIGN the scraped total and INVENT a
          // {client:"—"} row to display it. If the real parse above found nothing, that is an
          // exception to be investigated, not a hole to fill with a manufactured transaction.
          if (!isNaN(amt2) && amt2 > 0 && agentTotals[currentCode].ifast_comm === 0) {
            phillipParseError = "Phillip statement " + currentCode + " shows a Total of RM" +
              amt2.toFixed(2) + " but no commission lines could be read from it. Nothing was " +
              "generated — send the statement to whoever maintains the parser.";
          }
        }
      }
    }
    
  } catch(ex) {
    console.error("PDF.js parse error:", ex.message);
    // Return empty but valid structure
  }
  
  // §PHILLIP-8.90 — the reconcile error used to be set and then thrown away here;
  // upGenerateAll's gate reads f.parseError, so a Phillip file that did not tie to
  // its own Total was never able to stop the month. Now it is returned.
  return { name:filename, type:"PMB Commission", date:"Monthly", partner:"Phillip", batch:"Phillip", agentTotals:agentTotals, firmTotal:firmTotal, parseError:phillipParseError };
}

// Synchronous wrapper - returns promise (callers must await or .then())
function upParsePhillipPDFBuffer(arrayBuffer, filename) {
  // Return a promise that resolves to the parsed result
  return upParsePhillipPDFAsync(arrayBuffer, filename);
}

// ── Generate statements ───────────────────────────────────────────────────────
async function upGenerateAll(month){
  // ⛔ A Phillip line that matches no adviser STOPS the month. Dropping it quietly
  // is how RM238/month went missing and RM9/month went to the wrong person.
  // A file that could not be reconciled against its own Grand Total STOPS the
  // month. Generating from it is how RM2,551 of commission that iFAST never paid
  // was booked across five months without a single error on screen.
  var broken=[];
  ["iFAST","Phillip"].forEach(function(partner){
    (UPLOADS[partner][month]||[]).forEach(function(f){ if(f.parseError) broken.push(f.name+": "+f.parseError); });
  });
  if(broken.length){ showToast("error", broken.join("  |  ")); return; }
  // 🔒 NEVER GENERATE FROM A HALF-STAGED MONTH. Generating REPLACES the month's
  // statements with whatever is loaded in this tab. With no iFAST file staged that
  // silently rewrites every adviser downward, and the firm's Phillip revenue to
  // zero — it undid a correct RM238.12 in testing and reported success.
  if(!(UPLOADS["iFAST"][month]||[]).length){
    showToast("error","No iFAST file is loaded for "+month+" — generating now would erase the month. Press Import from Gmail first.");
    return;
  }
  // ── §CONTROL-TOTAL — THE GATE ─────────────────────────────────────────────
  // Every iFAST archive carries the invoice iFAST issued itself. Group this
  // month's staged files by the archive they came from, add up every adviser in
  // every file of that archive, and prove the sum against the invoice. A penny
  // out and NOTHING is generated.
  //
  // This is the control that was missing. Its absence let a file's own summary
  // line be read as the last adviser's earnings for four months, and nothing on
  // screen ever said a word. Read the research in the audit pack before you
  // weaken it — the whole point is that it uses a document our parser never
  // touches, so it can catch a parser fault that every other check is blind to.
  var byZip={};
  (UPLOADS["iFAST"][month]||[]).forEach(function(f){
    var z=f.zipName||("(loose) "+f.name);
    if(!byZip[z]) byZip[z]={sum:0,invoice:(f.invoiceTotal===undefined?null:f.invoiceTotal),invoiceNo:f.invoiceNo||"",files:[]};
    if(byZip[z].invoice===null && f.invoiceTotal!==undefined) { byZip[z].invoice=f.invoiceTotal; byZip[z].invoiceNo=f.invoiceNo||""; }
    byZip[z].files.push(f.name);
    Object.keys(f.agentTotals||{}).forEach(function(k){ byZip[z].sum+=Number(f.agentTotals[k].ifast_comm)||0; });
  });
  var ctFail=[], ctNoInvoice=[];
  Object.keys(byZip).forEach(function(z){
    var b=byZip[z], sum=Math.round(b.sum*100)/100;
    if(b.invoice===null||b.invoice===undefined){ ctNoInvoice.push(z); return; }
    if(Math.abs(sum-b.invoice)>0.011)
      ctFail.push(z+": the advisers in it add up to RM"+sum.toFixed(2)+" but iFAST's own invoice"
        +(b.invoiceNo?" ("+b.invoiceNo+")":"")+" says RM"+Number(b.invoice).toFixed(2)
        +" — a difference of RM"+(sum-b.invoice).toFixed(2));
  });
  if(ctFail.length){
    showToast("error","Nothing was generated. "+ctFail.length+" iFAST file(s) do not reconcile against iFAST's own invoice:  "+ctFail.join("   |   ")
      +"   —  send the file to whoever maintains the parser; do NOT pay from it.");
    return;
  }
  if(ctNoInvoice.length){
    showToast("error","Nothing was generated. No self-billed invoice could be read from: "+ctNoInvoice.join(", ")
      +" — without it the figures cannot be proved. Re-import the month from Gmail so the full archive is loaded.");
    return;
  }

  var unmatched=[];
  (UPLOADS["Phillip"][month]||[]).forEach(function(f){
    Object.keys(f.agentTotals||{}).forEach(function(rawId){
      var ag=f.agentTotals[rawId];
      if(!upResolveAgent(rawId,"Phillip",ag&&ag.name)) unmatched.push(rawId+" "+(ag&&ag.name||"")+" RM"+Number(ag&&ag.ifast_comm||0).toFixed(2));
    });
  });
  if(unmatched.length){
    showToast("error","Phillip statement has "+unmatched.length+" line(s) that match no adviser by name — fix the adviser's name in Admin Panel, then generate again: "+unmatched.join("; "));
    return;
  }
  var merged={};
  ["iFAST","Phillip"].forEach(function(partner){
    (UPLOADS[partner][month]||[]).forEach(function(f){
      Object.keys(f.agentTotals||{}).forEach(function(rawId){
        var ag=f.agentTotals[rawId];
        var advId=upResolveAgent(rawId,partner,ag&&ag.name); if(!advId) return;
        if(!merged[advId]) merged[advId]={ifast_comm:0,phillip_comm:0,transactions:[],sources:[]};
        merged[advId].ifast_comm+=ag.ifast_comm||0;
        if(partner==="Phillip") merged[advId].phillip_comm+=ag.ifast_comm||0;   // §SUMMARY: what Phillip paid, separately
        merged[advId].transactions=merged[advId].transactions.concat((ag.transactions||[]).map(function(t){return Object.assign({},t,{_src:partner});}));
        var src=partner+" "+(f.batch||f.type);
        if(merged[advId].sources.indexOf(src)<0) merged[advId].sources.push(src);
      });
    });
  });
  // Upline's direct-team + district-group YTD (from downlines' personal YTD) → sets tier rate
  function _uplineYtd(uplineId){
    var direct=0, district=0;
    Object.keys(ADVISERS).forEach(function(id){
      var a=ADVISERS[id]; if(!a||a.terminated||id===uplineId) return;
      var yp=(YTD[id]&&YTD[id].ytd_personal)||0;
      if(a.uplineManager===uplineId){ direct+=yp; district+=yp; }
      else if(a.uplineVP===uplineId){ district+=yp; }
    });
    return {direct:direct, district:district};
  }
  // rec[advId] = { revenue, personal, rate, overriding_out, earned[], sources[], transactions[] }
  var rec={};
  function _ensure(id){ if(!rec[id]) rec[id]={revenue:0,personal:0,rate:0,overriding_out:0,earned:[],sources:[],transactions:[]}; return rec[id]; }
  // Pass A — personal commission per producing adviser
  Object.keys(merged).forEach(function(advId){
    var adv=ADVISERS[advId]; if(!adv||adv.terminated) return;
    // A NET-NEGATIVE month is a real month. iFAST clawed money back; the adviser's
    // statement must say so. Skipping them here left a STALE row behind on every
    // regeneration — Apr 2026 kept TONG HUEY PYNG at RM488.56 (the old file-total
    // defect) while every other adviser was corrected, which is worse than either
    // state. Only a genuinely absent adviser (revenue exactly 0 and nothing earned)
    // is skipped below.
    var revenue=parseFloat(merged[advId].ifast_comm.toFixed(2)); if(revenue===0) return;
    // Tier must be based on YTD personal BEFORE this month. ytd_personal already includes the current
    // month after a first generate-run, so subtract any existing statement for `month` — this keeps the
    // rate stable if the admin re-runs the same month in one session (no false tier jump) while still
    // honouring server-seeded historical YTD not present in STATEMENTS.
    var _existThis=((STATEMENTS[advId]||[]).filter(function(s){return s.period===month;}).reduce(function(a,s){return a+(s.ifast_comm||0);},0));
    var _basisYtd=Math.max(0,((YTD[advId]&&YTD[advId].ytd_personal)||0)-_existThis);
    var rate=adv.rank==="EXCOMM"?0.80:getWPTier(_basisYtd).rate;
    // §NEG-100 — OWNER RULING, 18 September 2026, verbatim: "negative comission/
    // charges is 100% carried by the advisor. no sharing with manager, and company."
    // A clawback is returned by the adviser IN FULL, not at their rank rate.
    // ⚠️ THIS REVERSES the comment that stood here before, which read "on a clawback
    // the SAME rate applies ... the kind of thing a later reader would 'fix' to 100%".
    // It is not a later reader's fix — it is the owner's ruling, and it is the reason
    // Tong Huey Pyng carried only half of RM27.70 of clawbacks Jan-Aug 2026 while the
    // firm absorbed the rest. A POSITIVE month is untouched: the rate still applies.
    var r=_ensure(advId);
    // §NEG-100 READ PER TRANSACTION (owner, 18 Sep 2026: "fix this").
    // The ruling is about the CHARGE, not about a month that happens to net
    // negative. Every NEGATIVE row is returned by the adviser in full; every
    // POSITIVE row is still earned at their own rate. A month-level reading is
    // wrong in BOTH directions — it over-charges an adviser whose negative month
    // still holds real trailers, and it lets the firm silently absorb part of a
    // charge that sits inside a month which nets positive.
    var _rows=(merged[advId].transactions||[]);
    var _pos=0, _neg=0;
    _rows.forEach(function(t){ var v=+(t.ifast_comm||0); if(v>0) _pos+=v; else _neg+=v; });
    _pos=parseFloat(_pos.toFixed(2)); _neg=parseFloat(_neg.toFixed(2));
    // If a source gave a month total but no itemised rows, fall back to the net so
    // nothing is silently dropped — and that case is the month-level reading, stated.
    if(Math.abs(_pos+_neg-revenue)>0.005){ _pos=revenue>0?revenue:0; _neg=revenue<0?revenue:0; }
    r.revenue=revenue; r.rate=rate; r.pos=_pos; r.neg=_neg;
    r.personal=parseFloat((_neg + _pos*rate).toFixed(2));
    r.phillip=parseFloat((merged[advId].phillip_comm||0).toFixed(2));
    r.sources=merged[advId].sources; r.transactions=merged[advId].transactions;
  });
  // Pass B — overriding flows.
  // §EXCOMM-OR (Gan's rule, Aug 2026): when the upline is EXCOMM the overriding
  // is a FLAT 20% of the downline's gross — EXCOMM direct = 20%; with a Manager
  // in between the Manager takes 8% and the EXCOMM 12% (total still 20%).
  // Non-EXCOMM uplines keep the tiered Mgr (6/10/12%) / VP (2/4/6%) tables.
  // This replaced the old tier-only logic that paid Woei Sean 2% in Jul 2026.
  function _isEx(id){ var a=ADVISERS[id]; return !!(a&&(a.category==="EXCOMM"||a.rank==="EXCOMM")); }
  function _validUp(id){ return id&&id!=="COMPANY"&&ADVISERS[id]&&!ADVISERS[id].terminated ? id : null; }
  // §OVERRIDE-SIGN (owner ruling 14 Sep 2026, verbatim: "the negative over-riding also
  // need to credit to woei sean"). The override FOLLOWS THE SIGN of the downline's
  // gross: a negative downline month (zero-sales-charge fee) produces a negative
  // override on the upline, not nothing. The old `rev<=0` / `amt>0` guards paid
  // the override positive-only and over-credited Tong Woei Sean RM5.54 Jan–Aug 2026.
  Object.keys(rec).forEach(function(advId){
    // The override base is the POSITIVE portion, never the net: "no sharing with
    // manager, and company" is about the negative rows, so a charge passes nothing up
    // while the earnings beside it in the same month still do.
    var adv=ADVISERS[advId]; var rev=(rec[advId].pos!==undefined?rec[advId].pos:rec[advId].revenue);
    if(Math.abs(rev)<0.005) return;
    // §NEG-100 (owner ruling 18 September 2026) — "no sharing with manager, and company".
    // A NEGATIVE month passes NOTHING up: the adviser carries the whole clawback, the
    // manager's override is not reversed, and the firm bears none of it.
    // ⚠️ THIS SUPERSEDES §OVERRIDE-SIGN above (owner ruling 14 September 2026). That
    // ruling is left stated, not deleted, because it is the record of what was asked
    // for — but under BOTH rules together the firm RECOVERED MORE than it lost on a
    // clawback (RM +5.54 on RM 27.70), which no one intended. The 18 Sep wording wins.
    var out=0;
    var mId=_validUp(adv.uplineManager), vId=_validUp(adv.uplineVP);
    if(mId&&mId===vId) mId=null; // same person in both fields → single upline
    function pay(toId, type, rate){
      var amt=parseFloat((rev*rate).toFixed(2));
      if(amt!==0){ _ensure(toId).earned.push({from_id:advId,from_name:adv.name,type:type,base:rev,rate:rate,amount:amt}); out+=amt; }
    }
    var topId = vId||mId;
    if(topId&&_isEx(topId)){
      if(vId&&mId){ pay(mId,"Direct override",0.08); pay(vId,"EXCOMM override",0.12); }
      else pay(topId,"EXCOMM override",0.20);
    } else {
      if(mId) pay(mId,"Direct override",getMgrTier(_uplineYtd(mId).direct).rate);
      if(vId) pay(vId,"Indirect override",getVPTier(_uplineYtd(vId).district).rate);
    }
    rec[advId].overriding_out=parseFloat(out.toFixed(2));
  });
  // Pass C — build + persist each statement (personal + overriding breakdown)
  var generated=0, saves=[], failed=[];
  Object.keys(rec).forEach(function(advId){
    var adv=ADVISERS[advId]; if(!adv||adv.terminated) return;
    var R=rec[advId];
    var ovrTotal=parseFloat(R.earned.reduce(function(a,o){return a+o.amount;},0).toFixed(2));
    var total=parseFloat((R.personal+ovrTotal).toFixed(2));
    if(R.revenue===0 && total===0) return;
    // Firm keeps: this adviser's revenue minus their personal payout minus overriding paid to THEIR uplines.
    var retention=parseFloat((R.revenue - R.personal - R.overriding_out).toFixed(2));
    var stmt={period:month,date:new Date().toLocaleDateString("en-MY",{day:"2-digit",month:"short",year:"numeric"}),status:"Pending",
      ifast_comm:R.revenue,phillip_comm:R.phillip||0,personal_rate:R.rate,rank:adv.rank,personal_payout:R.personal,
      overridings:R.earned, total_payout:total, lifa_retention:retention,
      source:(R.sources||[]).join(", "),
      transactions:(R.transactions||[]).map(function(t){var _v=+(t.ifast_comm||0);return {type:t.type,client:t.client||"—",product:t.fund||"—",date:t.txn_date||"—",ifast_comm:parseFloat(_v.toFixed(2)),
        // §NEG-100 per transaction — a charge is carried in full, so the ROWS still
        // sum to the header. At the old rate they did not on any month holding one.
        payout:parseFloat((_v<0?_v:_v*R.rate).toFixed(2))};})};
    if(!STATEMENTS[advId]) STATEMENTS[advId]=[];
    STATEMENTS[advId]=STATEMENTS[advId].filter(function(s){return s.period!==month;});
    STATEMENTS[advId].push(stmt);
    // 🔒 A SAVE THAT WAS REFUSED IS NOT A SAVE. This used to be fire-and-forget:
    // the screen announced "N statements generated" without reading one reply, so
    // an expired session or a rejected payload removed an adviser from the month
    // in silence (RM143.78 credited to nobody, Aug 2026). The promise is collected
    // and every failure is named before the toast is allowed to say "generated".
    saves.push(apiPost("/api/statements", Object.assign({adviser_id:advId}, stmt))
      .then(function(r){ if(!r || r.error || r.ok===false) failed.push((adv.name||advId)+": "+((r&&r.error)||"refused")); })
      .catch(function(e){ failed.push((adv.name||advId)+": "+(e&&e.message||"could not reach the server")); }));
    if(!YTD[advId]) YTD[advId]={ytd_personal:0,mtd_personal:0,ytd_direct:0,ytd_district:0};
    YTD[advId].mtd_personal=R.revenue;
    var yr=parseInt(month.split(" ")[1]||"0");
    YTD[advId].ytd_personal=parseFloat((STATEMENTS[advId]||[]).filter(function(s){
      return parseInt((s.period||"").split(" ")[1]||"0")===yr;
    }).reduce(function(a,s){return a+(s.ifast_comm||0);},0).toFixed(2));
    apiPut("/api/ytd/"+advId, YTD[advId]);
    generated++;
  });
  // §SUMMARY: the firm-level Phillip total rides with the month, not with an adviser.
  // 🔒 ONLY WHEN A PHILLIP FILE IS ACTUALLY LOADED. Writing a computed 0 because
  // nothing was staged is not a fact about the month — it erased a correct figure.
  var pFiles=(UPLOADS["Phillip"][month]||[]);
  if(pFiles.length){
    var firmPhillip=pFiles.reduce(function(a,f){return a+(Number(f.firmTotal)||0);},0);
    saves.push(apiPost("/api/commission/month-firm",{period:month, phillip_firm:parseFloat(firmPhillip.toFixed(2))})
      .then(function(r){ if(!r||r.error) failed.push("Phillip firm total: "+((r&&r.error)||"refused")); })
      .catch(function(e){ failed.push("Phillip firm total: "+(e&&e.message||"unreachable")); }));
  }
  await Promise.all(saves);
  if(failed.length){
    showToast("error", failed.length+" of "+generated+" statement(s) were NOT saved for "+month
      +" — the month is incomplete, do not pay it: "+failed.join("; "));
  } else {
    showToast("success","⚡ "+generated+" agent statement(s) saved for "+month+" (incl. overriding)");
  }
  renderUploadPanel();
}


// ── Admin: open a month for review & publish ─────────────────────────────────
function adminOpenMonth(month) {
  currentView = "adminMonthReview";
  // Clear adviser sidebar active states
  Object.keys(ADVISERS).forEach(function(id) {
    var el = document.getElementById("nav-adviser-"+id);
    if (el) el.classList.remove("active");
  });
  // Auto-generate if files are ready but no statements exist yet
  var st = upGetMonthStatus(month);
  var hasStmts = Object.keys(STATEMENTS).some(function(id){
    return (STATEMENTS[id]||[]).some(function(s){ return s.period===month; });
  });
  if(st.ready && !hasStmts) {
    upGenerateAll(month);
  }
  document.getElementById("main-content").innerHTML = renderAdminMonthReview(month);
}

function getAdviserPendingCount(id) {
  // §MIN_PAYOUT single-approval pipeline — per-agent approval is RETIRED.
  // Statements publish automatically: at finance confirm (paid months) or at
  // month approval (all-carried months). No per-adviser to-do, no red badges.
  return 0;
}

function refreshAdviserSidebarBadges() {
  Object.keys(ADVISERS).forEach(function(id) {
    var el = document.getElementById("nav-adviser-"+id);
    if (!el) return;
    var existing = el.querySelector(".adviser-pending-badge");
    if (existing) existing.remove();
    var pendingCount = getAdviserPendingCount(id);
    if (pendingCount > 0) {
      var b = document.createElement("span");
      b.className = "adviser-pending-badge";
      b.style.cssText = "background:#DC2626;color:#fff;font-size:9px;font-weight:700;padding:1px 6px;border-radius:10px;margin-left:auto;";
      b.textContent = pendingCount + " to approve";
      el.appendChild(b);
    }
  });
}

// ── Admin: view all statements for a specific adviser ─────────────────────────
function changeAdminYear(y) {
  adminSelectedYear = parseInt(y);
  var advId = document.querySelector('.adviser-folder-active');
  // Re-render current adviser folder with new year
  var el = document.querySelector('[data-adv-folder]');
  if (el) adminViewAdviserFolder(el.dataset.advFolder);
}

function adminViewAdviserFolder(advId) {
  currentView = "adviserFolder";
  // Update sidebar active state
  Object.keys(ADVISERS).forEach(function(id) {
    var el = document.getElementById("nav-adviser-"+id);
    if (el) el.classList.toggle("active", id === advId);
  });
  var navAdmin = document.getElementById("nav-admin");
  if (navAdmin) navAdmin.classList.remove("active");
  var navUpload = document.getElementById("nav-upload");
  if (navUpload) navUpload.classList.remove("active");
  document.getElementById("main-content").innerHTML = renderAdviserFolder(advId);
  loadAdviserOnboarding(advId);
}

function adminApproveStatement(advId, period) {
  var stmt = (STATEMENTS[advId] || []).find(function(s){ return s.period === period; });
  if (!stmt) return;
  stmt.status = "Paid";
  if (stmt._dbId) apiPut("/api/statements/" + stmt._dbId, Object.assign({adviser_id: advId}, stmt));
  showToast("success", "✅ Statement for " + period + " approved & published to " + (ADVISERS[advId] ? ADVISERS[advId].name : advId) + "'s portal.");
  refreshAdviserSidebarBadges();
  adminViewAdviserFolder(advId);
}

function renderAdviserFolder(advId) {
  var adv = ADVISERS[advId];
  if (!adv) return "<div style='padding:40px;color:#9CA3AF;'>Adviser not found.</div>";

  function pd(label, val, full) {
    return '<div' + (full ? ' style="grid-column:1/-1;"' : '') + '>'
      + '<div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;margin-bottom:2px;">' + label + '</div>'
      + '<div style="color:#0B2545;font-weight:600;word-break:break-word;">' + (val ? escapeHtml(String(val)) : '<span style="color:#CBD5E1;font-weight:400;">—</span>') + '</div></div>';
  }
  var detailsCard = '<div style="background:#fff;border-radius:12px;box-shadow:0 2px 12px rgba(0,0,0,.07);padding:16px 20px;margin-bottom:20px;">'
    + '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;">'
    +   '<span style="font-size:13px;font-weight:700;color:#0B2545;">Personal Details</span>'
    +   '<div style="display:flex;gap:8px;">'
    +     '<button onclick="viewAsAdviser(\'' + advId + '\')" style="background:#B8962E;color:#0B2545;border:none;padding:5px 12px;border-radius:7px;font-size:12px;font-weight:700;cursor:pointer;">&#128065; Preview as adviser</button>'
    +     '<button onclick="openDetailsModal(\'' + advId + '\')" style="background:#fff;border:1.5px solid #E2E8F0;color:#374151;padding:5px 12px;border-radius:7px;font-size:12px;font-weight:600;cursor:pointer;">&#9998; Edit</button>'
    +   '</div>'
    + '</div>'
    + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px 24px;font-size:13px;">'
    +   pd('Corporate email', adv.email)
    +   pd('Personal email', adv.personalEmail)
    +   pd('Contact number', adv.phone || adv.contact)
    +   pd('iFAST code', adv.ifast)
    +   pd('CMSRL', adv.cmsrl)
    +   pd('Bank name', adv.bankName)
    +   pd('Bank account', adv.bankAccount)
    +   pd('Mailing address', adv.mailingAddress, true)
    + '</div></div>';

  var allStmts = STATEMENTS[advId] || [];

  // Available years: 2025 onwards
  var adminYears = [];
  for (var ay = 2025; ay <= new Date().getFullYear(); ay++) adminYears.push(ay);
  if (adminSelectedYear < 2025) adminSelectedYear = new Date().getFullYear();

  // Filter stmts by selected year
  var stmts = allStmts.filter(function(s){ return parseInt((s.period||"").split(" ")[1]||"0") === adminSelectedYear; });

  var adminYearSelector = '<select onchange="adminSelectedYear=parseInt(this.value);adminViewAdviserFolder(\''+advId+'\')" style="padding:6px 12px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;font-family:inherit;color:#0B2545;background:#fff;cursor:pointer;">'
    + adminYears.map(function(y){ return '<option value="'+y+'"'+(y===adminSelectedYear?' selected':'')+'>'+y+'</option>'; }).join('')
    + '</select>';

  // Build a list of all months in selected year
  var allMonths = {};
  allStmts.forEach(function(s) {
    if (parseInt((s.period||"").split(" ")[1]||"0") === adminSelectedYear) allMonths[s.period] = true;
  });
  // Sort months desc
  var monthOrder = Object.keys(allMonths).sort(function(a, b) {
    var ma = new Date("01 " + a), mb = new Date("01 " + b);
    return mb - ma;
  });

  // If no months at all in system, show a placeholder range (last 3 months)
  if (monthOrder.length === 0) {
    var now = new Date();
    for (var mi = 0; mi < 3; mi++) {
      var d = new Date(now.getFullYear(), now.getMonth() - mi, 1);
      var mn = d.toLocaleDateString("en-MY", {month:"short", year:"numeric"});
      monthOrder.push(mn);
    }
  }

  var stmtByPeriod = {};
  stmts.forEach(function(s) { stmtByPeriod[s.period] = s; });

  var cat = adv.category || (adv.rank === "EXCOMM" ? "EXCOMM" : "WP");
  var catColors = { EXCOMM:"#92400E", WP:"#166534", MGR:"#1D4ED8", VP:"#7C3AED" };
  var catBg     = { EXCOMM:"#FEF3C7", WP:"#DCFCE7", MGR:"#DBEAFE", VP:"#EDE9FE" };

  var monthRows = monthOrder.map(function(period) {
    var s = stmtByPeriod[period];
    if (!s) {
      // NIL month — this adviser had no commission this period
      return '<tr style="border-bottom:1px solid #F1F5F9;">'
        + '<td style="padding:12px 16px;font-weight:600;color:#0B2545;">' + period + '</td>'
        + '<td style="padding:12px 16px;"><span style="background:#F1F5F9;color:#9CA3AF;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:600;">— NIL</span></td>'
        + '<td style="padding:12px 16px;color:#9CA3AF;font-size:12px;">—</td>'
        + '<td style="padding:12px 16px;color:#9CA3AF;font-size:12px;">—</td>'
        + '<td style="padding:12px 16px;color:#9CA3AF;font-size:12px;">—</td>'
        + '<td style="padding:12px 16px;"></td>'
        + '</tr>';
    }

    var statusBadge, actionBtn;
    if (s.status === "Paid") {
      statusBadge = '<span style="background:#DCFCE7;color:#166534;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700;">✓ Published</span>';
      actionBtn = '<button onclick="adminViewStmtDetail(\''+advId+'\',\''+period+'\')" style="padding:5px 12px;background:#0B2545;color:#fff;border:none;border-radius:6px;font-size:11px;cursor:pointer;font-weight:600;">View →</button>';
    } else {
      statusBadge = s.status === 'Carried'
        ? '<span style="background:#FEF3C7;color:#92400E;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700;">↻ Carried forward</span>'
        : '<span style="background:#F1F5F9;color:#64748B;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700;">Not yet published</span>';
      actionBtn = '<button onclick="adminViewStmtDetail(\''+advId+'\',\''+period+'\')" style="padding:5px 12px;background:#F1F5F9;color:#374151;border:1px solid #E2E8F0;border-radius:6px;font-size:11px;cursor:pointer;font-weight:600;">View</button>';
    }

    return '<tr style="border-bottom:1px solid #F1F5F9;">'
      + '<td style="padding:12px 16px;font-weight:700;color:#0B2545;">' + period + '</td>'
      + '<td style="padding:12px 16px;">' + statusBadge + '</td>'
      + '<td style="padding:12px 16px;font-family:\'Cormorant Garamond\',serif;font-size:15px;font-weight:700;color:#0B2545;">MYR ' + s.ifast_comm.toLocaleString('en-MY',{minimumFractionDigits:2}) + '</td>'
      + '<td style="padding:12px 16px;font-family:\'Cormorant Garamond\',serif;font-size:15px;font-weight:700;color:#166534;">MYR ' + s.personal_payout.toLocaleString('en-MY',{minimumFractionDigits:2}) + '</td>'
      + '<td style="padding:12px 16px;font-size:12px;color:#6B7280;">' + s.date + '</td>'
      + '<td style="padding:12px 16px;text-align:right;">' + actionBtn + '</td>'
      + '</tr>';
  }).join("");

  var totalRevenue = stmts.reduce(function(a,s){ return a + (s.ifast_comm||0); }, 0);
  var totalPayout  = stmts.reduce(function(a,s){ return a + (s.personal_payout||0); }, 0);
  var pendingCount = stmts.filter(function(s){ return s.status === 'Pending'; }).length;

  // Compute MTD from year-filtered stmts (latest uploaded month)
  var folderStmtsSorted = stmts.slice().sort(function(a,b){ return new Date("01 "+b.period) - new Date("01 "+a.period); });
  var folderMtdStmt = folderStmtsSorted[0] || null;
  var folderMtdLabel = folderMtdStmt ? folderMtdStmt.period : "—";
  var folderMtdRevenue = folderMtdStmt ? (folderMtdStmt.ifast_comm||0) : 0;
  var folderMtdPayout  = folderMtdStmt ? (folderMtdStmt.personal_payout||0) : 0;

  return '<div class="fade-in" style="padding:28px 32px;max-width:1000px;">'
    // Header
    + '<div style="background:linear-gradient(135deg,#0B2545,#1a3a6b);border-radius:14px;padding:22px 28px;margin-bottom:20px;display:flex;align-items:center;gap:18px;">'
    + '<div style="width:52px;height:52px;background:rgba(255,255,255,0.15);border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:18px;font-weight:700;color:#fff;flex-shrink:0;">' + adv.initials + '</div>'
    + '<div style="flex:1;">'
    + '<div style="font-size:20px;font-weight:800;color:#fff;">' + adv.name + '</div>'
    + '<div style="font-size:12px;color:rgba(255,255,255,0.5);margin-top:3px;">'
    + advId + ' &middot; ' + (adv.ifast || '—') + ' &middot; ' + adv.email
    + '</div></div>'
    + '<span style="background:' + catBg[cat] + ';color:' + catColors[cat] + ';padding:4px 12px;border-radius:20px;font-size:12px;font-weight:700;">' + adv.rank + '</span>'
    + '</div>'
    // Personal details (read-only, edit opens the same modal as the Admin Panel)
    + detailsCard
    + '<div id="adv-onboarding"></div>'
    // Summary cards — all based on year-filtered stmts
    + '<div style="display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:12px;margin-bottom:20px;">'
    + '<div style="background:#fff;border-radius:10px;padding:14px 16px;box-shadow:0 2px 8px rgba(0,0,0,.06);">'
    + '<div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:4px;">Statements ' + adminSelectedYear + '</div>'
    + '<div style="font-size:20px;font-weight:700;color:#0B2545;">' + stmts.length + '</div></div>'
    + '<div style="background:#fff;border-radius:10px;padding:14px 16px;box-shadow:0 2px 8px rgba(0,0,0,.06);">'
    + '<div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:4px;">Pending Approval</div>'
    + '<div style="font-size:20px;font-weight:700;color:' + (pendingCount > 0 ? '#92400E' : '#166534') + ';">' + pendingCount + '</div></div>'
    + '<div style="background:#fff;border-radius:10px;padding:14px 16px;box-shadow:0 2px 8px rgba(0,0,0,.06);">'
    + '<div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:4px;">YTD Revenue ' + adminSelectedYear + '</div>'
    + '<div style="font-size:16px;font-weight:700;color:#0B2545;">MYR ' + totalRevenue.toLocaleString('en-MY',{minimumFractionDigits:2}) + '</div></div>'
    + '<div style="background:#F0FDF4;border-radius:10px;padding:14px 16px;box-shadow:0 2px 8px rgba(0,0,0,.06);">'
    + '<div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:4px;">MTD — ' + folderMtdLabel + '</div>'
    + '<div style="font-size:16px;font-weight:700;color:#166534;">MYR ' + folderMtdRevenue.toLocaleString('en-MY',{minimumFractionDigits:2}) + '</div></div>'
    + '</div>'
    // Statements table
    + '<div style="background:#fff;border-radius:12px;box-shadow:0 2px 12px rgba(0,0,0,.07);overflow:hidden;">'
    + '<div style="padding:14px 16px;border-bottom:1px solid #F1F5F9;display:flex;align-items:center;justify-content:space-between;"><span style="font-size:13px;font-weight:700;color:#0B2545;">Statement History</span>' + adminYearSelector + '</div>'
    + (monthRows
      ? '<table style="width:100%;border-collapse:collapse;">'
        + '<thead><tr style="background:#F8FAFC;">'
        + '<th style="padding:10px 16px;text-align:left;font-size:10px;color:#9CA3AF;font-weight:600;text-transform:uppercase;">Period</th>'
        + '<th style="padding:10px 16px;text-align:left;font-size:10px;color:#9CA3AF;font-weight:600;text-transform:uppercase;">Status</th>'
        + '<th style="padding:10px 16px;text-align:left;font-size:10px;color:#9CA3AF;font-weight:600;text-transform:uppercase;">Revenue</th>'
        + '<th style="padding:10px 16px;text-align:left;font-size:10px;color:#9CA3AF;font-weight:600;text-transform:uppercase;">Payout</th>'
        + '<th style="padding:10px 16px;text-align:left;font-size:10px;color:#9CA3AF;font-weight:600;text-transform:uppercase;">Generated</th>'
        + '<th></th>'
        + '</tr></thead><tbody>' + monthRows + '</tbody></table>'
      : '<div style="padding:40px;text-align:center;color:#9CA3AF;font-size:13px;">No statements generated yet for this adviser.</div>')
    + '</div></div>';
}

// ── Admin: view a single adviser statement in detail ──────────────────────────
function adminViewStmtDetail(advId, period) {
  var s = (STATEMENTS[advId] || []).find(function(x){ return x.period === period; });
  var adv = ADVISERS[advId];
  if (!s || !adv) return;

  var revenue = s.ifast_comm;
  var personalRate = s.personal_rate;
  // §NEG-100 / §I2 — READ the stored figure, never re-derive it. The generator is the
  // single source of truth; a screen that recomputes `revenue * rate` disagrees with the
  // statement it is displaying the moment any rule is not a flat multiplication — which
  // is exactly the case on a NEGATIVE month, where the adviser carries 100% and this
  // line would otherwise show half of it. Falls back only for a legacy row that has no
  // stored payout.
  var personalPayout = (s && s.personal_payout !== undefined && s.personal_payout !== null)
    ? +(+s.personal_payout).toFixed(2)
    : +(revenue * personalRate).toFixed(2);
  var mgrId   = adv.uplineManager;
  var mgrAdv  = (mgrId && mgrId !== "COMPANY") ? ADVISERS[mgrId] : null;
  var mgrName = mgrId === "COMPANY" ? "Company Direct" : mgrAdv ? mgrAdv.name : null;
  var vpId    = adv.uplineVP;
  var vpAdv   = (vpId && vpId !== "COMPANY") ? ADVISERS[vpId] : null;
  var vpName  = vpId === "COMPANY" ? "Company Direct" : vpAdv ? vpAdv.name : null;
  var isEXCOMM = s.rank === "EXCOMM";
  var directRate=0, directPayout=0, directLabel="", indirectRate=0, indirectPayout=0, indirectLabel="";
  if (isEXCOMM) {
    // EXCOMM: 80% to agent, 20% retained by LIFA — no overriding to anyone
  } else if (mgrAdv) {
    // Overriding ONLY when uplineManager is a real assigned adviser
    directRate=s.direct_overriding_rate||0.06; directPayout=+(revenue*directRate).toFixed(2); directLabel="Direct Overriding &rarr; "+mgrAdv.name;
    if (vpAdv) {
      // VP indirect ONLY when uplineVP is a real assigned adviser
      var vpIsEXCOMM=vpAdv.rank==="EXCOMM";
      indirectRate=vpIsEXCOMM?+(0.20-directRate).toFixed(2):directRate;
      indirectPayout=+(revenue*indirectRate).toFixed(2);
      indirectLabel="Indirect Overriding &rarr; "+vpAdv.name+(vpIsEXCOMM?" (20%&minus;"+(directRate*100).toFixed(0)+"%)":"");
    }
  }
  var totalPaidOut=+(personalPayout+directPayout+indirectPayout).toFixed(2);
  var lifaRetention=+(revenue-totalPaidOut).toFixed(2);

  var byType={};
  (s.transactions||[]).forEach(function(t){ byType[t.type]=byType[t.type]||[]; byType[t.type].push(t); });
  var txnHtml=Object.keys(byType).map(function(type){
    var txns=byType[type];
    var typeRev=txns.reduce(function(a,t){return a+t.ifast_comm;},0);
    var typeComm=txns.reduce(function(a,t){return a+t.payout;},0);
    return '<div style="margin-bottom:14px;">'
      +'<div style="font-size:11px;font-weight:700;color:#0B2545;background:#F8FAFC;padding:7px 12px;border-radius:6px 6px 0 0;border:1px solid #E2E8F0;border-bottom:none;">'
      +type+' &mdash; Payout: <span style="color:#166534;">MYR '+typeComm.toLocaleString('en-MY',{minimumFractionDigits:2})+'</span></div>'
      +'<table style="width:100%;font-size:12px;border-collapse:collapse;border:1px solid #E2E8F0;">'
      +'<thead><tr style="background:#F8FAFC;">'
      +'<th style="padding:7px 10px;text-align:left;color:#9CA3AF;font-weight:600;">Date</th>'
      +'<th style="padding:7px 10px;text-align:left;color:#9CA3AF;font-weight:600;">Client</th>'
      +'<th style="padding:7px 10px;text-align:left;color:#9CA3AF;font-weight:600;">Product</th>'
      +'<th style="padding:7px 10px;text-align:right;color:#9CA3AF;font-weight:600;">iFAST Comm</th>'
      +'<th style="padding:7px 10px;text-align:right;color:#9CA3AF;font-weight:600;">Agent Payout</th>'
      +'</tr></thead><tbody>'
      +txns.map(function(t){
        return '<tr style="border-bottom:1px solid #F1F5F9;">'
          +'<td style="padding:7px 10px;">'+t.date+'</td>'
          +'<td style="padding:7px 10px;">'+t.client+'</td>'
          +'<td style="padding:7px 10px;max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">'+t.product+'</td>'
          +'<td style="padding:7px 10px;text-align:right;">'+t.ifast_comm.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
          +'<td style="padding:7px 10px;text-align:right;font-weight:700;color:#166534;">'+t.payout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
          +'</tr>';
      }).join("")
      +'<tr style="background:#F0FDF4;"><td colspan="3" style="padding:7px 10px;font-weight:700;">Subtotal</td>'
      +'<td style="padding:7px 10px;text-align:right;font-weight:700;">'+typeRev.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
      +'<td style="padding:7px 10px;text-align:right;font-weight:700;color:#166534;">'+typeComm.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
      +'</tr></tbody></table></div>';
  }).join("")||'<div style="padding:20px;color:#9CA3AF;font-size:12px;">No transactions this period.</div>';

  var approveSection = (s.status !== "Paid" && (isChecker || isAdmin))
    ? '<div style="background:#F1F5F9;border:1px solid #E2E8F0;border-radius:10px;padding:12px 18px;margin-bottom:20px;font-size:12px;color:#475569;">'
      + (s.status === 'Carried'
        ? '↻ <b>Carried forward</b> — under RM50; published with the carry note, pays out with a future month.'
        : 'Publishes automatically — approve the month at <b>Upload Statements → Monthly Close</b>; statements go to agent portals when finance confirms payment.')
      +'</div>'
    : (s.status === "Paid"
      ? '<div style="background:#DCFCE7;border:1px solid #BBF7D0;border-radius:10px;padding:12px 18px;margin-bottom:20px;font-size:13px;font-weight:600;color:#166534;">✓ Statement approved and published to agent portal.</div>'
      : '');

  document.getElementById("main-content").innerHTML = '<div class="fade-in" style="padding:28px 32px;max-width:1000px;">'
    +'<div style="display:flex;align-items:center;gap:12px;margin-bottom:20px;">'
    +'<button onclick="adminViewAdviserFolder(\''+advId+'\')" style="padding:6px 14px;background:#F1F5F9;border:1px solid #E2E8F0;border-radius:8px;font-size:12px;cursor:pointer;font-weight:600;color:#374151;">&#8592; Back to '+adv.name+'</button>'
    +'</div>'
    +approveSection
    +'<div style="background:linear-gradient(135deg,#0B2545,#1a3a6b);border-radius:14px;padding:22px 28px;margin-bottom:20px;display:flex;align-items:center;justify-content:space-between;">'
    +'<div><div style="font-size:18px;font-weight:700;color:#fff;">'+adv.name+'</div>'
    +'<div style="font-size:12px;color:rgba(255,255,255,0.5);margin-top:3px;">'+advId+' &middot; '+(adv.ifast||'—')+' &middot; Generated '+s.date+'</div></div>'
    +'<span style="background:rgba(184,150,46,0.25);color:#B8962E;padding:5px 14px;border-radius:20px;font-size:13px;font-weight:700;">'+period+'</span>'
    +'</div>'
    +'<div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:14px;margin-bottom:20px;">'
    +'<div style="background:#fff;border-radius:10px;padding:18px;box-shadow:0 2px 8px rgba(0,0,0,.06);"><div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:6px;">Revenue</div><div style="font-size:22px;font-weight:700;color:#0B2545;">MYR '+revenue.toLocaleString('en-MY',{minimumFractionDigits:2})+'</div></div>'
    +'<div style="background:#fff;border-radius:10px;padding:18px;box-shadow:0 2px 8px rgba(0,0,0,.06);"><div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:6px;">Rate</div><div style="font-size:22px;font-weight:700;color:#0B2545;">'+(personalRate*100).toFixed(0)+'% <span style="font-size:12px;color:#9CA3AF;">('+s.rank+')</span></div></div>'
    +'<div style="background:#F0FDF4;border-radius:10px;padding:18px;box-shadow:0 2px 8px rgba(0,0,0,.06);"><div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:6px;">Agent Payout</div><div style="font-size:22px;font-weight:700;color:#166534;">MYR '+personalPayout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</div></div>'
    +'</div>'
    +'<div style="background:#fff;border-radius:12px;padding:18px 22px;box-shadow:0 2px 8px rgba(0,0,0,.06);margin-bottom:20px;">'
    +'<div style="font-size:13px;font-weight:700;color:#0B2545;margin-bottom:12px;">Commission Breakdown</div>'
    +'<table style="width:100%;font-size:13px;border-collapse:collapse;">'
    +'<tr style="border-bottom:1px solid #F1F5F9;"><td style="padding:9px 0;color:#374151;font-weight:600;">Revenue from iFAST</td><td></td><td style="text-align:right;font-weight:700;color:#0B2545;">MYR '+revenue.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>'
    +'<tr style="border-bottom:1px solid #F1F5F9;background:#F8FFF8;"><td style="padding:9px 0 9px 12px;color:#166534;"><b>Personal Payout</b> <span style="font-size:11px;color:#9CA3AF;">'+s.rank+' &mdash; '+(personalRate*100).toFixed(0)+'%</span></td><td style="text-align:center;color:#166534;font-weight:700;">&times; '+(personalRate*100).toFixed(0)+'%</td><td style="text-align:right;font-weight:700;color:#166534;">MYR '+personalPayout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>'
    +(directRate>0?'<tr style="border-bottom:1px solid #F1F5F9;background:#EFF6FF;"><td style="padding:9px 0 9px 12px;color:#1D4ED8;"><b>'+directLabel+'</b></td><td style="text-align:center;color:#1D4ED8;font-weight:700;">&times; '+(directRate*100).toFixed(0)+'%</td><td style="text-align:right;font-weight:700;color:#1D4ED8;">MYR '+directPayout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>':"")
    +(indirectRate>0?'<tr style="border-bottom:1px solid #F1F5F9;background:#F5F3FF;"><td style="padding:9px 0 9px 12px;color:#7C3AED;"><b>'+indirectLabel+'</b></td><td style="text-align:center;color:#7C3AED;font-weight:700;">&times; '+(indirectRate*100).toFixed(0)+'%</td><td style="text-align:right;font-weight:700;color:#7C3AED;">MYR '+indirectPayout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>':"")
    +'<tr style="border-bottom:2px solid #E2E8F0;"><td style="padding:9px 0 9px 12px;color:#9CA3AF;">LIFA Retention</td><td style="text-align:center;color:#9CA3AF;font-size:11px;">remainder</td><td style="text-align:right;color:#9CA3AF;">MYR '+lifaRetention.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>'
    +'<tr><td style="padding:11px 0 4px;font-weight:700;color:#0B2545;">Total Paid Out</td><td></td><td style="text-align:right;font-weight:700;color:#0B2545;font-size:15px;">MYR '+totalPaidOut.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>'
    +'</table></div>'
    +'<div style="font-size:13px;font-weight:700;color:#0B2545;margin-bottom:12px;">Transaction Detail</div>'
    +txnHtml
    +'</div>';
}



function adminPublishMonth(month) {
  var count = 0;
  Object.keys(STATEMENTS).forEach(function(advId) {
    (STATEMENTS[advId] || []).forEach(function(s) {
      if (s.period === month) {
        s.status = "Paid"; count++;
        // Save to D1
        if(s._dbId) apiPut("/api/statements/"+s._dbId, Object.assign({adviser_id:advId}, s));
      }
    });
  });
  showToast("success", "✅ " + count + " statement(s) for " + month + " saved & published to agent folders.");
  refreshAdviserSidebarBadges();
  adminOpenMonth(month);
}

// ── Helper: payout breakdown for a statement entry — READ FROM THE STORE ─────
// Investigation 14 Sep 2026, bug 8 ("a second, older formula in the admin
// review"): this screen used to RECOMPUTE the override as revenue × 0.06 via
// the manager chain, so Tong Woei Sean's EXCOMM override read "—" and the ✓
// check (personal + overrides + retention = revenue, with retention DERIVED as
// the remainder) could never fail. Owner "fix all these", 21 Sep 2026.
//
// Now every figure is the stored one. The overrides PAID OUT of this adviser's
// revenue are found on the UPLINE's statement for the same month
// (overridings[].from_id === this adviser), which is where the generator wrote
// them. `lifa_retention` is the stored column, so the ✓ check is a REAL check:
// personal + overrides-paid-out + stored retention must equal revenue.
// `stmtList` is the month's statement list ({advId, s}); when it is not passed
// the overrides read as none, and the check will say so rather than invent them.
function amrCalcBreakdown(advId, s, stmtList) {
  var adv = ADVISERS[advId]; if (!adv) return null;
  var revenue = +(+(s.ifast_comm || 0)).toFixed(2);
  var personalRate = s.personal_rate;
  var personalPayout = (s && s.personal_payout !== undefined && s.personal_payout !== null)
    ? +(+s.personal_payout).toFixed(2)
    : +(revenue * personalRate).toFixed(2);
  var isEXCOMM = s.rank === "EXCOMM";
  // overrides paid out of THIS adviser's revenue, as stored on the uplines' rows
  var paidOut = [];
  (stmtList || []).forEach(function (e) {
    if (!e || !e.s || e.advId === advId) return;
    var ov = e.s.overridings;
    if (typeof ov === "string") { try { ov = JSON.parse(ov); } catch (_) { ov = []; } }
    (Array.isArray(ov) ? ov : []).forEach(function (o) {
      if (!o || (o.from_id || o.adviser_id) !== advId) return;
      var to = ADVISERS[e.advId] ? ADVISERS[e.advId].name : e.advId;
      paidOut.push({ to: to, toId: e.advId, type: o.type || "Overriding", rate: +(o.rate || 0), amount: +(+(o.amount || 0)).toFixed(2) });
    });
  });
  var direct = paidOut[0] || null, indirect = paidOut[1] || null;
  var directRate = direct ? direct.rate : 0, directPayout = direct ? direct.amount : 0;
  var directLabel = direct ? (direct.type + " to " + direct.to) : "";
  var indirectRate = indirect ? indirect.rate : 0, indirectPayout = indirect ? indirect.amount : 0;
  var indirectLabel = indirect ? (indirect.type + " to " + indirect.to) : "";
  var extraPayout = +paidOut.slice(2).reduce(function (a, o) { return a + o.amount; }, 0).toFixed(2);
  var overridesOut = +(directPayout + indirectPayout + extraPayout).toFixed(2);
  var totalPaidOut = +(personalPayout + overridesOut).toFixed(2);
  // the STORED retention — never the remainder, or the check is a tautology
  var lifaRetention = (s.lifa_retention !== undefined && s.lifa_retention !== null)
    ? +(+s.lifa_retention).toFixed(2)
    : +(revenue - totalPaidOut).toFixed(2);
  // a will-fee month carries its own base + shares in the fp_* columns (§10x.2419);
  // the check covers them too, or Lee An Chyi's RM3,570 August reads as a RM1,530 gap
  var fpBase = +(+(s.fp_base || 0)).toFixed(2), fpPaid = +((+(s.fp_personal || 0)) + (+(s.fp_overriding || 0))).toFixed(2);
  var checkGap = +(personalPayout + overridesOut + fpPaid + lifaRetention - revenue - fpBase).toFixed(2);
  return { revenue:revenue, personalRate:personalRate, personalPayout:personalPayout,
    directRate:directRate, directPayout:directPayout, directLabel:directLabel,
    indirectRate:indirectRate, indirectPayout:indirectPayout, indirectLabel:indirectLabel,
    overridesOut:overridesOut, paidOut:paidOut, checkGap:checkGap, storedRetention:(s.lifa_retention !== undefined && s.lifa_retention !== null),
    totalPaidOut:totalPaidOut, lifaRetention:lifaRetention, isEXCOMM:isEXCOMM };
}

// ── Email a commission payout summary for a month to the admin inbox ──────────
function amrEmailPayoutSummary(month) {
  var rows = [];
  Object.keys(STATEMENTS).forEach(function(advId){
    (STATEMENTS[advId]||[]).forEach(function(s){ if(s.period===month) rows.push({advId:advId, s:s}); });
  });
  if(!rows.length){ showToast("error","No statements for "+month+" to summarise."); return; }
  rows.sort(function(a,b){ return (ADVISERS[a.advId]||{name:""}).name.localeCompare((ADVISERS[b.advId]||{name:""}).name); });

  var firmRevenue=0, firmAgentPayout=0, firmOverridings=0, firmRetention=0;
  var pendingCount=0;
  var lineRows = rows.map(function(e){
    var adv = ADVISERS[e.advId]||{name:e.advId};
    var b = amrCalcBreakdown(e.advId, e.s, rows) || {revenue:e.s.ifast_comm||0, personalPayout:e.s.personal_payout||0, directPayout:0, indirectPayout:0, lifaRetention:e.s.lifa_retention||0};
    var overr = +(b.overridesOut!==undefined ? b.overridesOut : ((b.directPayout||0)+(b.indirectPayout||0))).toFixed(2);
    var totalPaid = +((b.personalPayout||0)+overr).toFixed(2);
    firmRevenue += b.revenue; firmAgentPayout += b.personalPayout; firmOverridings += overr; firmRetention += b.lifaRetention;
    if(e.s.status!=="Paid") pendingCount++;
    var fmt = function(n){ return Number(n||0).toLocaleString('en-MY',{minimumFractionDigits:2,maximumFractionDigits:2}); };
    return {name:adv.name, id:e.advId, rank:e.s.rank||"—", status:e.s.status||"Pending",
      revenue:b.revenue, payout:b.personalPayout, overr:overr, total:totalPaid, retention:b.lifaRetention, fmt:fmt};
  });
  firmRevenue=+firmRevenue.toFixed(2); firmAgentPayout=+firmAgentPayout.toFixed(2);
  firmOverridings=+firmOverridings.toFixed(2); firmRetention=+firmRetention.toFixed(2);
  var firmTotalPaid=+(firmAgentPayout+firmOverridings).toFixed(2);
  var f = function(n){ return 'MYR '+Number(n||0).toLocaleString('en-MY',{minimumFractionDigits:2,maximumFractionDigits:2}); };

  if(!confirm("Email the "+month+" payout summary ("+rows.length+" agents, total payout "+f(firmTotalPaid)+") to the admin inbox?")) return;

  // ── Build HTML ──
  var trHtml = lineRows.map(function(r){
    return '<tr>'
      +'<td style="padding:8px 10px;border-bottom:1px solid #eee;font-weight:600;color:#0B2545;">'+r.name+'<div style="font-size:11px;color:#9CA3AF;font-weight:400;">'+r.id+' · '+r.rank+'</div></td>'
      +'<td style="padding:8px 10px;border-bottom:1px solid #eee;text-align:right;">'+f(r.revenue)+'</td>'
      +'<td style="padding:8px 10px;border-bottom:1px solid #eee;text-align:right;color:#166534;">'+f(r.payout)+'</td>'
      +'<td style="padding:8px 10px;border-bottom:1px solid #eee;text-align:right;color:#1D4ED8;">'+(r.overr>0?f(r.overr):'—')+'</td>'
      +'<td style="padding:8px 10px;border-bottom:1px solid #eee;text-align:right;font-weight:700;">'+f(r.total)+'</td>'
      +'<td style="padding:8px 10px;border-bottom:1px solid #eee;text-align:right;color:#374151;">'+f(r.retention)+'</td>'
      +'<td style="padding:8px 10px;border-bottom:1px solid #eee;text-align:center;font-size:11px;">'+(r.status==="Paid"?'<span style="color:#166534;">✓ Published</span>':r.status==="Carried"?'<span style="color:#92400E;">↻ Carried</span>':'<span style="color:#B45309;">Pending</span>')+'</td>'
      +'</tr>';
  }).join("");
  var html = '<div style="font-family:Arial,Helvetica,sans-serif;color:#0B2545;max-width:680px;margin:0 auto;">'
    +'<div style="font-size:22px;font-weight:800;letter-spacing:.04em;color:#B8962E;">LIFA</div>'
    +'<div style="font-size:11px;letter-spacing:.16em;text-transform:uppercase;color:#6B7280;margin-bottom:18px;">Planners · Commission Payout Summary</div>'
    +'<h2 style="font-size:18px;margin:0 0 4px;">'+month+' — Commission Payout Summary</h2>'
    +'<div style="font-size:12px;color:#6B7280;margin-bottom:18px;">'+rows.length+' agent statement(s)'+(pendingCount?(' · '+pendingCount+' still pending publish'):' · all published')+'</div>'
    +'<table style="border-collapse:collapse;width:100%;margin-bottom:18px;">'
    +'<tr>'
    +'<td style="padding:12px 14px;background:#F8FAFC;border-radius:8px;"><div style="font-size:10px;text-transform:uppercase;letter-spacing:.05em;color:#9CA3AF;">Total Revenue</div><div style="font-size:18px;font-weight:800;color:#0B2545;">'+f(firmRevenue)+'</div></td>'
    +'<td style="width:8px;"></td>'
    +'<td style="padding:12px 14px;background:#ECFDF5;border-radius:8px;"><div style="font-size:10px;text-transform:uppercase;letter-spacing:.05em;color:#9CA3AF;">Total Payout</div><div style="font-size:18px;font-weight:800;color:#166534;">'+f(firmTotalPaid)+'</div></td>'
    +'<td style="width:8px;"></td>'
    +'<td style="padding:12px 14px;background:#EFF6FF;border-radius:8px;"><div style="font-size:10px;text-transform:uppercase;letter-spacing:.05em;color:#9CA3AF;">LIFA Retention</div><div style="font-size:18px;font-weight:800;color:#1D4ED8;">'+f(firmRetention)+'</div></td>'
    +'</tr></table>'
    +'<table style="border-collapse:collapse;width:100%;font-size:13px;">'
    +'<thead><tr style="background:#F8FAFC;text-align:right;color:#6B7280;font-size:11px;">'
    +'<th style="padding:8px 10px;text-align:left;">Agent</th><th style="padding:8px 10px;">Revenue</th><th style="padding:8px 10px;">Agent Payout</th><th style="padding:8px 10px;">Overridings</th><th style="padding:8px 10px;">Total Payout</th><th style="padding:8px 10px;">Retention</th><th style="padding:8px 10px;text-align:center;">Status</th>'
    +'</tr></thead><tbody>'+trHtml
    +'<tr style="background:#F1F5F9;font-weight:800;">'
    +'<td style="padding:10px;">TOTAL ('+rows.length+')</td>'
    +'<td style="padding:10px;text-align:right;">'+f(firmRevenue)+'</td>'
    +'<td style="padding:10px;text-align:right;color:#166534;">'+f(firmAgentPayout)+'</td>'
    +'<td style="padding:10px;text-align:right;color:#1D4ED8;">'+(firmOverridings>0?f(firmOverridings):'—')+'</td>'
    +'<td style="padding:10px;text-align:right;">'+f(firmTotalPaid)+'</td>'
    +'<td style="padding:10px;text-align:right;color:#374151;">'+f(firmRetention)+'</td>'
    +'<td></td></tr>'
    +'</tbody></table>'
    +'<p style="font-size:11px;color:#9CA3AF;margin-top:22px;">Generated from the LIFA Planners portal · '+new Date().toLocaleString("en-MY",{timeZone:"Asia/Kuala_Lumpur"})+' (MYT)</p>'
    +'</div>';

  // ── Build plain text ──
  var pad=function(s,n){ s=String(s); return s.length>=n?s:s+Array(n-s.length+1).join(' '); };
  var textLines = lineRows.map(function(r){ return '  '+pad(r.name,24)+pad(r.fmt(r.total),14)+'('+r.status+')'; });
  var text = month+' — COMMISSION PAYOUT SUMMARY\n'
    +rows.length+' agent statement(s)'+(pendingCount?(', '+pendingCount+' pending publish'):', all published')+'\n\n'
    +'Total Revenue:   '+f(firmRevenue)+'\n'
    +'Total Payout:    '+f(firmTotalPaid)+'  (agent '+f(firmAgentPayout)+' + overridings '+f(firmOverridings)+')\n'
    +'LIFA Retention:  '+f(firmRetention)+'\n\n'
    +'Per agent (total payout):\n'+textLines.join('\n')+'\n\n'
    +'— LIFA Planners portal';

  showToast("info","Sending "+month+" payout summary…");
  apiPost("/api/statements/email-summary", {period:month, subject:"["+month+"] LIFA Commission Payout Summary — "+f(firmTotalPaid), html:html, text:text})
    .then(function(res){
      if(res && res.ok) showToast("success","📧 Payout summary for "+month+" emailed to "+(res.to||"admin")+".");
      else showToast("error","Failed to email summary: "+((res&&res.error)||"unknown error"));
    })
    .catch(function(e){ showToast("error","Failed to email summary: "+e); });
}

function renderAdminMonthReview(month) {
  var stmtList = [];
  Object.keys(STATEMENTS).forEach(function(advId) {
    (STATEMENTS[advId] || []).forEach(function(s) {
      if (s.period === month) stmtList.push({ advId: advId, s: s });
    });
  });
  // Sort by adviser name
  stmtList.sort(function(a,b){ return (ADVISERS[a.advId]||{name:""}).name.localeCompare((ADVISERS[b.advId]||{name:""}).name); });

  var allPublished = stmtList.length > 0 && stmtList.every(function(x){ return x.s.status === "Paid"; });
  var publishBtn = allPublished
    ? '<button disabled style="padding:9px 22px;background:#D1FAE5;color:#166534;border:none;border-radius:8px;font-size:13px;font-weight:700;cursor:default;">&#10003; All Published</button>'
    : '<button onclick="adminPublishMonth(\''+month+'\')" style="padding:9px 22px;background:#166534;color:#fff;border:none;border-radius:8px;font-size:13px;font-weight:700;cursor:pointer;">&#128190; Save &amp; Publish All</button>';

  if (!stmtList.length) {
    return '<div class="fade-in" style="padding:28px 32px;max-width:1100px;">'
      + '<div style="display:flex;align-items:center;gap:14px;margin-bottom:24px;">'
      + '<button onclick="showView(\'upload\')" style="padding:6px 14px;background:#F1F5F9;border:1px solid #E2E8F0;border-radius:8px;font-size:12px;cursor:pointer;font-weight:600;color:#374151;">&#8592; Back</button>'
      + '<div style="font-size:18px;font-weight:800;color:#0B2545;">' + month + ' &mdash; Statement Review</div>'
      + '</div>'
      + '<div style="text-align:center;padding:60px;color:#9CA3AF;"><div style="font-size:40px;margin-bottom:12px;">&#128587;</div>'
      + '<div style="font-size:14px;">No statements generated for ' + month + ' yet.</div>'
      + '<div style="font-size:12px;margin-top:6px;">Go back, upload the required files and click Generate Statements.</div></div></div>';
  }

  // ── Compute all breakdowns up front ────────────────────────────────────────
  var breakdowns = {};
  stmtList.forEach(function(e){ breakdowns[e.advId] = amrCalcBreakdown(e.advId, e.s, stmtList); });

  // ── Firm-level totals ───────────────────────────────────────────────────────
  var firmRevenue = 0, firmCommPaid = 0, firmRetention = 0;
  stmtList.forEach(function(e){
    var b = breakdowns[e.advId]; if(!b) return;
    firmRevenue    += b.revenue;
    firmCommPaid   += b.personalPayout;
    firmRetention  += b.lifaRetention;
  });
  firmRevenue   = +firmRevenue.toFixed(2);
  firmCommPaid  = +firmCommPaid.toFixed(2);
  firmRetention = +firmRetention.toFixed(2);

  // ── Reconciliation: sum all individual transactions vs firm total ───────────
  var txnSum = 0;
  stmtList.forEach(function(e){
    (e.s.transactions||[]).forEach(function(t){ txnSum += t.ifast_comm||0; });
  });
  txnSum = +txnSum.toFixed(2);
  var reconOK = Math.abs(txnSum - firmRevenue) < 0.02;

  // ── Tab IDs ─────────────────────────────────────────────────────────────────
  var TAB_SUMMARY = "__summary__";
  var tabPanelId = "amr-tab-panel-" + month.replace(/\s/g,"_");

  // ── Build tab bar ───────────────────────────────────────────────────────────
  function tabBar(activeTab) {
    var tabs = '<div style="display:flex;gap:0;overflow-x:auto;border-bottom:2px solid #E2E8F0;margin-bottom:0;background:#F8FAFC;border-radius:12px 12px 0 0;">';
    // Summary tab
    var isSumAct = activeTab === TAB_SUMMARY;
    tabs += '<button onclick="amrSwitchTab(\''+month+'\',\''+TAB_SUMMARY+'\')" style="padding:11px 18px;border:none;border-bottom:'+(isSumAct?'2px solid #0B2545':'2px solid transparent')+';background:transparent;font-size:12px;font-weight:'+(isSumAct?'800':'600')+';color:'+(isSumAct?'#0B2545':'#6B7280')+';cursor:pointer;white-space:nowrap;border-radius:'+(isSumAct?'10px 10px 0 0':'0')+';margin-bottom:-2px;">📋 Summary</button>';
    stmtList.forEach(function(e){
      var adv = ADVISERS[e.advId]||{name:e.advId};
      var isAct = activeTab === e.advId;
      var isPend = e.s.status !== "Paid";
      tabs += '<button onclick="amrSwitchTab(\''+month+'\',\''+e.advId+'\')" style="padding:11px 16px;border:none;border-bottom:'+(isAct?'2px solid #0B2545':'2px solid transparent')+';background:transparent;font-size:12px;font-weight:'+(isAct?'800':'600')+';color:'+(isAct?'#0B2545':'#6B7280')+';cursor:pointer;white-space:nowrap;border-radius:'+(isAct?'10px 10px 0 0':'0')+';margin-bottom:-2px;display:flex;align-items:center;gap:5px;">'
        + adv.name.split(" ")[0]
        + (isPend ? '<span style="width:7px;height:7px;border-radius:50%;background:#F59E0B;display:inline-block;"></span>' : '<span style="width:7px;height:7px;border-radius:50%;background:#22C55E;display:inline-block;"></span>')
        + '</button>';
    });
    tabs += '</div>';
    return tabs;
  }

  // ── Render summary tab ──────────────────────────────────────────────────────
  function renderSummaryTab() {
    var reconRow = reconOK
      ? '<div style="display:flex;align-items:center;gap:8px;background:#DCFCE7;border:1px solid #BBF7D0;border-radius:8px;padding:10px 14px;margin-top:12px;">'
        + '<span style="font-size:16px;">✅</span><span style="font-size:12px;font-weight:700;color:#166534;">Reconciliation OK — Transaction sum MYR '+txnSum.toLocaleString('en-MY',{minimumFractionDigits:2})+' matches firm revenue.</span></div>'
      : '<div style="display:flex;align-items:center;gap:8px;background:#FEF2F2;border:1px solid #FECACA;border-radius:8px;padding:10px 14px;margin-top:12px;">'
        + '<span style="font-size:16px;">⚠️</span><span style="font-size:12px;font-weight:700;color:#DC2626;">Reconciliation Gap — Transaction sum MYR '+txnSum.toLocaleString('en-MY',{minimumFractionDigits:2})+' vs firm revenue MYR '+firmRevenue.toLocaleString('en-MY',{minimumFractionDigits:2})+' (diff: MYR '+(firmRevenue-txnSum).toFixed(2)+').</span></div>';

    // Firm KPI cards
    var kpiHtml = '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:20px;">'
      + '<div style="background:#fff;border-radius:10px;padding:16px 18px;box-shadow:0 1px 8px rgba(0,0,0,.07);">'
      + '<div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:5px;">Total Revenue Received</div>'
      + '<div style="font-size:22px;font-weight:800;color:#0B2545;">MYR '+firmRevenue.toLocaleString('en-MY',{minimumFractionDigits:2})+'</div>'
      + '<div style="font-size:10px;color:#9CA3AF;margin-top:3px;">Gross commission from iFAST</div></div>'
      + '<div style="background:#fff;border-radius:10px;padding:16px 18px;box-shadow:0 1px 8px rgba(0,0,0,.07);">'
      + '<div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:5px;">Total Commission Paid Out</div>'
      + '<div style="font-size:22px;font-weight:800;color:#166534;">MYR '+firmCommPaid.toLocaleString('en-MY',{minimumFractionDigits:2})+'</div>'
      + '<div style="font-size:10px;color:#9CA3AF;margin-top:3px;">'+((firmRevenue>0?(firmCommPaid/firmRevenue*100):0).toFixed(1))+'% of total revenue</div></div>'
      + '<div style="background:#EFF6FF;border-radius:10px;padding:16px 18px;box-shadow:0 1px 8px rgba(0,0,0,.07);">'
      + '<div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:5px;">LIFA Net Retention</div>'
      + '<div style="font-size:22px;font-weight:800;color:#1D4ED8;">MYR '+firmRetention.toLocaleString('en-MY',{minimumFractionDigits:2})+'</div>'
      + '<div style="font-size:10px;color:#9CA3AF;margin-top:3px;">'+((firmRevenue>0?(firmRetention/firmRevenue*100):0).toFixed(1))+'% of total revenue</div></div>'
      + '</div>';

    // Per-agent checker table — with full split: Agent Payout | Overridings | Retention = Revenue
    var firmOverridings = +stmtList.reduce(function(a,e){ var b=breakdowns[e.advId]; return a+(b?(b.overridesOut!==undefined?b.overridesOut:b.directPayout+b.indirectPayout):0); },0).toFixed(2);
    var tableRows = stmtList.map(function(e) {
      var adv = ADVISERS[e.advId]||{name:e.advId,rank:"—",ifast:"—"};
      var b = breakdowns[e.advId];
      var isPaid = e.s.status === "Paid";
      var overridings = +(b.overridesOut!==undefined ? b.overridesOut : (b.directPayout + b.indirectPayout)).toFixed(2);
      var checkOK = Math.abs(b.checkGap!==undefined ? b.checkGap : (b.personalPayout + overridings + b.lifaRetention - b.revenue)) < 0.02;   // REAL: retention is the stored column
      return '<tr style="border-bottom:1px solid #F1F5F9;">'
        + '<td style="padding:10px 12px;font-weight:700;color:#0B2545;">'+adv.name+'<div style="font-size:10px;color:#9CA3AF;font-weight:400;margin-top:1px;">'+e.advId+' &middot; '+(adv.ifast||"—")+'</div></td>'
        + '<td style="padding:10px 12px;"><span style="background:#EDE9FE;color:#6D28D9;padding:2px 8px;border-radius:12px;font-size:10px;font-weight:700;">'+e.s.rank+'</span><div style="font-size:10px;color:#9CA3AF;margin-top:2px;">'+(b.personalRate*100).toFixed(0)+'% personal</div></td>'
        + '<td style="padding:10px 12px;text-align:right;font-weight:700;color:#0B2545;">MYR '+b.revenue.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
        + '<td style="padding:10px 12px;text-align:right;color:#166534;font-weight:700;">MYR '+b.personalPayout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
        + '<td style="padding:10px 12px;text-align:right;color:#1D4ED8;font-weight:600;">'+(overridings>0?'MYR '+overridings.toLocaleString('en-MY',{minimumFractionDigits:2}):'<span style="color:#D1D5DB;">—</span>')+'</td>'
        + '<td style="padding:10px 12px;text-align:right;color:#374151;font-weight:600;">MYR '+b.lifaRetention.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
        + '<td style="padding:10px 12px;text-align:center;">'+(checkOK?'<span style="color:#166534;font-size:13px;">✓</span>':'<span style="color:#DC2626;font-size:13px;">✗</span>')+'</td>'
        + '<td style="padding:10px 12px;text-align:center;">'
          + (isPaid
            ? '<span style="background:#DCFCE7;color:#166534;padding:3px 10px;border-radius:20px;font-size:10px;font-weight:700;">✓ Published</span>'
            : '<button onclick="amrSwitchTab(\''+month+'\',\''+e.advId+'\')" style="background:#FEF3C7;color:#92400E;border:none;padding:3px 10px;border-radius:20px;font-size:10px;font-weight:700;cursor:pointer;">⏳ Review →</button>')
          + '</td>'
        + '</tr>';
    }).join("");

    // Totals row — must equal firmRevenue
    var firmTotalPaid = +(firmCommPaid + firmOverridings).toFixed(2);
    var firmCheckOK = Math.abs(firmCommPaid + firmOverridings + firmRetention - firmRevenue) < 0.02;
    tableRows += '<tr style="background:#F1F5F9;font-weight:800;border-top:2px solid #E2E8F0;">'
      + '<td colspan="2" style="padding:11px 12px;color:#0B2545;">TOTAL ('+stmtList.length+' agents)</td>'
      + '<td style="padding:11px 12px;text-align:right;color:#0B2545;">MYR '+firmRevenue.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
      + '<td style="padding:11px 12px;text-align:right;color:#166534;">MYR '+firmCommPaid.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
      + '<td style="padding:11px 12px;text-align:right;color:#1D4ED8;">'+(firmOverridings>0?'MYR '+firmOverridings.toLocaleString('en-MY',{minimumFractionDigits:2}):'—')+'</td>'
      + '<td style="padding:11px 12px;text-align:right;color:#374151;">MYR '+firmRetention.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
      + '<td style="padding:11px 12px;text-align:center;">'+(firmCheckOK?'<span style="color:#166534;font-size:13px;">✓</span>':'<span style="color:#DC2626;font-size:13px;">✗</span>')+'</td>'
      + '<td></td></tr>';

    // Revenue breakdown by source
    var bySource = {};
    stmtList.forEach(function(e){
      (e.s.transactions||[]).forEach(function(t){
        var src = (t.type||"Other").replace(/ Trailer$/,"").replace(/_[12]nd$/,"").replace(/_1st$/,"");
        bySource[src] = +(( bySource[src]||0) + (t.ifast_comm||0)).toFixed(2);
      });
    });
    var sourceRows = Object.keys(bySource).sort().map(function(src){
      return '<tr style="border-bottom:1px solid #F1F5F9;">'
        +'<td style="padding:8px 12px;color:#374151;">'+src+'</td>'
        +'<td style="padding:8px 12px;text-align:right;font-weight:600;color:#0B2545;">MYR '+bySource[src].toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
        +'<td style="padding:8px 12px;text-align:right;color:#9CA3AF;">'+(firmRevenue>0?(bySource[src]/firmRevenue*100).toFixed(1)+'%':'—')+'</td>'
        +'</tr>';
    }).join("");
    var sourceTotal = +Object.values(bySource).reduce(function(a,v){return a+v;},0).toFixed(2);
    var sourceTotalOK = Math.abs(sourceTotal - firmRevenue) < 0.02;
    sourceRows += '<tr style="background:#F1F5F9;font-weight:800;border-top:2px solid #E2E8F0;">'
      +'<td style="padding:10px 12px;color:#0B2545;">TOTAL</td>'
      +'<td style="padding:10px 12px;text-align:right;color:#0B2545;">MYR '+sourceTotal.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
      +'<td style="padding:10px 12px;text-align:right;color:#0B2545;">100%</td>'
      +'</tr>';

    var sourceReconRow = sourceTotalOK
      ? '<div style="display:flex;align-items:center;gap:8px;background:#DCFCE7;border:1px solid #BBF7D0;border-radius:0 0 10px 10px;padding:9px 14px;"><span>✅</span><span style="font-size:11px;font-weight:700;color:#166534;">Source total MYR '+sourceTotal.toLocaleString('en-MY',{minimumFractionDigits:2})+' = Firm revenue ✓</span></div>'
      : '<div style="display:flex;align-items:center;gap:8px;background:#FEF2F2;border:1px solid #FECACA;border-radius:0 0 10px 10px;padding:9px 14px;"><span>⚠️</span><span style="font-size:11px;font-weight:700;color:#DC2626;">Source total MYR '+sourceTotal.toLocaleString('en-MY',{minimumFractionDigits:2})+' ≠ Firm revenue MYR '+firmRevenue.toLocaleString('en-MY',{minimumFractionDigits:2})+'</span></div>';

    return '<div style="padding:20px 24px;">'
      + '<div style="font-size:13px;font-weight:700;color:#0B2545;margin-bottom:14px;">'+month+' — Firm Summary</div>'
      + kpiHtml
      // Agent table
      + '<div style="background:#fff;border-radius:10px;box-shadow:0 1px 8px rgba(0,0,0,.07);overflow:hidden;margin-bottom:16px;">'
      + '<div style="padding:12px 14px;border-bottom:1px solid #F1F5F9;display:flex;align-items:center;justify-content:space-between;">'
      + '<div style="font-size:12px;font-weight:700;color:#0B2545;">Per-Agent Commission Summary</div>'
      + '<div style="font-size:10px;color:#9CA3AF;">Agent Payout + Overridings + Retention must = Revenue ✓</div></div>'
      + '<table style="width:100%;border-collapse:collapse;font-size:12px;">'
      + '<thead><tr style="background:#F8FAFC;">'
      + '<th style="padding:9px 12px;text-align:left;color:#9CA3AF;font-weight:600;">Agent</th>'
      + '<th style="padding:9px 12px;text-align:left;color:#9CA3AF;font-weight:600;">Tier / Rate</th>'
      + '<th style="padding:9px 12px;text-align:right;color:#9CA3AF;font-weight:600;">Revenue (A)</th>'
      + '<th style="padding:9px 12px;text-align:right;color:#166534;font-weight:600;">Agent Payout (B)</th>'
      + '<th style="padding:9px 12px;text-align:right;color:#1D4ED8;font-weight:600;">Overridings (C)</th>'
      + '<th style="padding:9px 12px;text-align:right;color:#374151;font-weight:600;">LIFA Retention (D)</th>'
      + '<th style="padding:9px 12px;text-align:center;color:#9CA3AF;font-weight:600;">B+C+D=A</th>'
      + '<th style="padding:9px 12px;text-align:center;color:#9CA3AF;font-weight:600;">Status</th>'
      + '</tr></thead><tbody>'+tableRows+'</tbody></table></div>'
      // Source breakdown
      + '<div style="background:#fff;border-radius:10px;box-shadow:0 1px 8px rgba(0,0,0,.07);overflow:hidden;margin-bottom:16px;">'
      + '<div style="padding:12px 14px;border-bottom:1px solid #F1F5F9;display:flex;align-items:center;justify-content:space-between;">'
      + '<div style="font-size:12px;font-weight:700;color:#0B2545;">Revenue by Source</div>'
      + '<div style="font-size:10px;color:#9CA3AF;">Cross-reference: sum of all transaction types = firm total</div></div>'
      + '<table style="width:100%;border-collapse:collapse;font-size:12px;">'
      + '<thead><tr style="background:#F8FAFC;">'
      + '<th style="padding:9px 12px;text-align:left;color:#9CA3AF;font-weight:600;">Source</th>'
      + '<th style="padding:9px 12px;text-align:right;color:#9CA3AF;font-weight:600;">Amount</th>'
      + '<th style="padding:9px 12px;text-align:right;color:#9CA3AF;font-weight:600;">% of Total</th>'
      + '</tr></thead><tbody>'+sourceRows+'</tbody></table>'
      + sourceReconRow
      + '</div>'
      + reconRow
      + '</div>';
  }

  // ── Render individual agent tab ─────────────────────────────────────────────
  function renderAgentTab(advId) {
    var entry = null;
    stmtList.forEach(function(e){ if(e.advId===advId) entry=e; });
    if(!entry) return '<div style="padding:40px;color:#9CA3AF;">Not found.</div>';
    var s = entry.s, adv = ADVISERS[advId]||{name:advId};
    var b = breakdowns[advId];

    var byType = {};
    (s.transactions||[]).forEach(function(t){ byType[t.type]=byType[t.type]||[]; byType[t.type].push(t); });
    var txnHtml = Object.keys(byType).map(function(type){
      var txns = byType[type];
      var typeRev  = +txns.reduce(function(a,t){return a+t.ifast_comm;},0).toFixed(2);
      var typeComm = +txns.reduce(function(a,t){return a+t.payout;},0).toFixed(2);
      return '<div style="margin-bottom:14px;">'
        +'<div style="font-size:11px;font-weight:700;color:#0B2545;background:#F8FAFC;padding:7px 10px;border-radius:6px 6px 0 0;border:1px solid #E2E8F0;border-bottom:none;display:flex;justify-content:space-between;">'
        +'<span>'+type+'</span><span style="color:#166534;">Payout: MYR '+typeComm.toLocaleString('en-MY',{minimumFractionDigits:2})+'</span></div>'
        +'<table style="width:100%;font-size:11px;border-collapse:collapse;border:1px solid #E2E8F0;">'
        +'<thead><tr style="background:#F8FAFC;">'
        +'<th style="padding:6px 9px;text-align:left;color:#9CA3AF;font-weight:600;">Date</th>'
        +'<th style="padding:6px 9px;text-align:left;color:#9CA3AF;font-weight:600;">Client</th>'
        +'<th style="padding:6px 9px;text-align:left;color:#9CA3AF;font-weight:600;">Product</th>'
        +'<th style="padding:6px 9px;text-align:right;color:#9CA3AF;font-weight:600;">iFAST Comm</th>'
        +'<th style="padding:6px 9px;text-align:right;color:#9CA3AF;font-weight:600;">Agent Payout</th>'
        +'</tr></thead><tbody>'
        +txns.map(function(t){
          return '<tr style="border-bottom:1px solid #F1F5F9;">'
            +'<td style="padding:6px 9px;color:#374151;">'+t.date+'</td>'
            +'<td style="padding:6px 9px;">'+t.client+'</td>'
            +'<td style="padding:6px 9px;max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">'+t.product+'</td>'
            +'<td style="padding:6px 9px;text-align:right;">'+t.ifast_comm.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
            +'<td style="padding:6px 9px;text-align:right;font-weight:700;color:#166534;">'+t.payout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
            +'</tr>';
        }).join("")
        +'<tr style="background:#F0FDF4;">'
        +'<td colspan="3" style="padding:6px 9px;font-weight:700;">Subtotal</td>'
        +'<td style="padding:6px 9px;text-align:right;font-weight:700;">'+typeRev.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
        +'<td style="padding:6px 9px;text-align:right;font-weight:700;color:#166534;">'+typeComm.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
        +'</tr></tbody></table></div>';
    }).join("")||'<div style="padding:16px;color:#9CA3AF;font-size:12px;">No transactions this period.</div>';

    var approveBar = (s.status !== "Paid")
      ? '<div style="background:#F1F5F9;border:1px solid #E2E8F0;border-radius:10px;padding:11px 16px;margin-bottom:18px;font-size:12px;color:#475569;">'
        + (s.status === 'Carried' ? '↻ <b>Carried forward</b> — under RM50; pays out with a future month.' : 'Publishes automatically when the month is approved at Monthly Close and finance confirms payment.')
        +'</div>'
      : '<div style="background:#DCFCE7;border:1px solid #BBF7D0;border-radius:10px;padding:11px 16px;margin-bottom:18px;font-size:12px;font-weight:600;color:#166534;">✓ Statement published to agent portal.</div>';

    return '<div style="padding:20px 24px;">'
      + approveBar
      + '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:16px;">'
      + '<div style="background:#fff;border-radius:10px;padding:16px;box-shadow:0 1px 8px rgba(0,0,0,.07);">'
      + '<div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:4px;">Revenue</div>'
      + '<div style="font-size:20px;font-weight:800;color:#0B2545;">MYR '+b.revenue.toLocaleString('en-MY',{minimumFractionDigits:2})+'</div></div>'
      + '<div style="background:#fff;border-radius:10px;padding:16px;box-shadow:0 1px 8px rgba(0,0,0,.07);">'
      + '<div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:4px;">Rate</div>'
      + '<div style="font-size:20px;font-weight:800;color:#0B2545;">'+(b.personalRate*100).toFixed(0)+'% <span style="font-size:11px;color:#9CA3AF;">('+s.rank+')</span></div></div>'
      + '<div style="background:#F0FDF4;border-radius:10px;padding:16px;box-shadow:0 1px 8px rgba(0,0,0,.07);">'
      + '<div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:4px;">Agent Payout</div>'
      + '<div style="font-size:20px;font-weight:800;color:#166534;">MYR '+b.personalPayout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</div></div>'
      + '</div>'
      + '<div style="background:#fff;border-radius:10px;padding:16px;box-shadow:0 1px 8px rgba(0,0,0,.07);margin-bottom:16px;">'
      + '<div style="font-size:12px;font-weight:700;color:#0B2545;margin-bottom:10px;">Commission Breakdown</div>'
      + '<table style="width:100%;font-size:12px;border-collapse:collapse;">'
      + '<tr style="border-bottom:1px solid #F1F5F9;"><td style="padding:8px 0;color:#374151;font-weight:600;">Revenue from iFAST</td><td></td><td style="text-align:right;font-weight:700;color:#0B2545;">MYR '+b.revenue.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>'
      + '<tr style="border-bottom:1px solid #F1F5F9;background:#F8FFF8;"><td style="padding:8px 0 8px 10px;color:#166534;"><b>Personal Payout</b> <span style="font-size:10px;color:#9CA3AF;">'+s.rank+' &mdash; '+(b.personalRate*100).toFixed(0)+'%</span></td><td style="text-align:center;color:#166534;font-weight:700;">&times; '+(b.personalRate*100).toFixed(0)+'%</td><td style="text-align:right;font-weight:700;color:#166534;">MYR '+b.personalPayout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>'
      + (b.directRate>0 ? '<tr style="border-bottom:1px solid #F1F5F9;background:#EFF6FF;"><td style="padding:8px 0 8px 10px;color:#1D4ED8;"><b>'+b.directLabel+'</b></td><td style="text-align:center;color:#1D4ED8;font-weight:700;">&times; '+(b.directRate*100).toFixed(0)+'%</td><td style="text-align:right;font-weight:700;color:#1D4ED8;">MYR '+b.directPayout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>' : "")
      + (b.indirectRate>0 ? '<tr style="border-bottom:1px solid #F1F5F9;background:#F5F3FF;"><td style="padding:8px 0 8px 10px;color:#7C3AED;"><b>'+b.indirectLabel+'</b></td><td style="text-align:center;color:#7C3AED;font-weight:700;">&times; '+(b.indirectRate*100).toFixed(0)+'%</td><td style="text-align:right;font-weight:700;color:#7C3AED;">MYR '+b.indirectPayout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>' : "")
      + '<tr style="border-bottom:2px solid #E2E8F0;"><td style="padding:8px 0 8px 10px;color:#9CA3AF;">LIFA Retention</td><td style="text-align:center;color:#9CA3AF;font-size:10px;">remainder</td><td style="text-align:right;color:#9CA3AF;">MYR '+b.lifaRetention.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>'
      + '<tr><td style="padding:9px 0 3px;font-weight:700;color:#0B2545;">Total Paid Out</td><td></td><td style="text-align:right;font-weight:700;color:#0B2545;font-size:14px;">MYR '+b.totalPaidOut.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>'
      + '</table></div>'
      + '<div style="font-size:12px;font-weight:700;color:#0B2545;margin-bottom:10px;">Transaction Detail</div>'
      + txnHtml
      + '</div>';
  }

  // ── Initial active tab = Summary ────────────────────────────────────────────
  var initContent = renderSummaryTab();

  // ── Assemble full page ──────────────────────────────────────────────────────
  return '<div class="fade-in" style="padding:24px 28px;max-width:1100px;">'
    // Header
    + '<div style="display:flex;align-items:center;gap:12px;margin-bottom:18px;">'
    + '<button onclick="showView(\'upload\')" style="padding:6px 14px;background:#F1F5F9;border:1px solid #E2E8F0;border-radius:8px;font-size:12px;cursor:pointer;font-weight:600;color:#374151;">&#8592; Back</button>'
    + '<div style="flex:1;">'
    + '<div style="font-size:18px;font-weight:800;color:#0B2545;">'+month+' &mdash; Statement Review</div>'
    + '<div style="font-size:12px;color:#9CA3AF;margin-top:2px;">'+stmtList.length+' agent statement(s) &middot; Review before publishing to agent folders</div>'
    + '</div>'
    + '<button onclick="amrEmailPayoutSummary(\''+month+'\')" style="padding:9px 18px;background:#fff;color:#0B2545;border:1.5px solid #B8962E;border-radius:8px;font-size:13px;font-weight:700;cursor:pointer;margin-right:10px;" title="Email a payout summary for '+month+' to the admin inbox">&#128231; Email Summary</button>'
    + publishBtn
    + '</div>'
    // Tab container
    + '<div id="'+tabPanelId+'" style="background:#fff;border-radius:12px;box-shadow:0 2px 16px rgba(0,0,0,.08);overflow:hidden;">'
    + tabBar(TAB_SUMMARY)
    + '<div id="'+tabPanelId+'-content">' + initContent + '</div>'
    + '</div>'
    + '</div>';
}

function amrSwitchTab(month, tabId) {
  var TAB_SUMMARY = "__summary__";
  var tabPanelId = "amr-tab-panel-" + month.replace(/\s/g,"_");
  var container = document.getElementById(tabPanelId);
  if (!container) return;

  // Re-compute stmtList for this month
  var stmtList = [];
  Object.keys(STATEMENTS).forEach(function(advId) {
    (STATEMENTS[advId]||[]).forEach(function(s){
      if(s.period===month) stmtList.push({advId:advId,s:s});
    });
  });
  stmtList.sort(function(a,b){ return (ADVISERS[a.advId]||{name:""}).name.localeCompare((ADVISERS[b.advId]||{name:""}).name); });

  // Rebuild tab bar with new active state
  var tabs = '<div style="display:flex;gap:0;overflow-x:auto;border-bottom:2px solid #E2E8F0;margin-bottom:0;background:#F8FAFC;border-radius:12px 12px 0 0;">';
  var isSumAct = tabId === TAB_SUMMARY;
  tabs += '<button onclick="amrSwitchTab(\''+month+'\',\''+TAB_SUMMARY+'\')" style="padding:11px 18px;border:none;border-bottom:'+(isSumAct?'2px solid #0B2545':'2px solid transparent')+';background:transparent;font-size:12px;font-weight:'+(isSumAct?'800':'600')+';color:'+(isSumAct?'#0B2545':'#6B7280')+';cursor:pointer;white-space:nowrap;border-radius:'+(isSumAct?'10px 10px 0 0':'0')+';margin-bottom:-2px;">📋 Summary</button>';
  stmtList.forEach(function(e){
    var adv = ADVISERS[e.advId]||{name:e.advId};
    var isAct = tabId === e.advId;
    var isPend = e.s.status !== "Paid";
    tabs += '<button onclick="amrSwitchTab(\''+month+'\',\''+e.advId+'\')" style="padding:11px 16px;border:none;border-bottom:'+(isAct?'2px solid #0B2545':'2px solid transparent')+';background:transparent;font-size:12px;font-weight:'+(isAct?'800':'600')+';color:'+(isAct?'#0B2545':'#6B7280')+';cursor:pointer;white-space:nowrap;border-radius:'+(isAct?'10px 10px 0 0':'0')+';margin-bottom:-2px;display:flex;align-items:center;gap:5px;">'
      + adv.name.split(" ")[0]
      + (isPend ? '<span style="width:7px;height:7px;border-radius:50%;background:#F59E0B;display:inline-block;"></span>' : '<span style="width:7px;height:7px;border-radius:50%;background:#22C55E;display:inline-block;"></span>')
      + '</button>';
  });
  tabs += '</div>';

  // Update tab bar
  var tabBar = container.querySelector('div[style*="border-bottom:2px solid #E2E8F0"]');
  if (tabBar) tabBar.outerHTML = tabs;
  else container.innerHTML = tabs + container.innerHTML.replace(/^<div[^>]*>/, "");

  // Rebuild content for active tab
  var breakdowns = {};
  stmtList.forEach(function(e){ breakdowns[e.advId] = amrCalcBreakdown(e.advId, e.s, stmtList); });
  var firmRevenue=0, firmCommPaid=0, firmRetention=0;
  stmtList.forEach(function(e){ var b=breakdowns[e.advId]; if(!b) return; firmRevenue+=b.revenue; firmCommPaid+=b.personalPayout; firmRetention+=b.lifaRetention; });
  firmRevenue=+firmRevenue.toFixed(2); firmCommPaid=+firmCommPaid.toFixed(2); firmRetention=+firmRetention.toFixed(2);
  var txnSum=0; stmtList.forEach(function(e){ (e.s.transactions||[]).forEach(function(t){txnSum+=t.ifast_comm||0;}); }); txnSum=+txnSum.toFixed(2);
  var reconOK = Math.abs(txnSum - firmRevenue) < 0.02;

  var content = "";
  if (tabId === TAB_SUMMARY) {
    // Summary tab content — rebuild inline (identical logic, called from amrSwitchTab)
    var reconRow = reconOK
      ? '<div style="display:flex;align-items:center;gap:8px;background:#DCFCE7;border:1px solid #BBF7D0;border-radius:8px;padding:10px 14px;margin-top:12px;"><span style="font-size:16px;">✅</span><span style="font-size:12px;font-weight:700;color:#166534;">Reconciliation OK — Transaction sum MYR '+txnSum.toLocaleString('en-MY',{minimumFractionDigits:2})+' matches firm revenue.</span></div>'
      : '<div style="display:flex;align-items:center;gap:8px;background:#FEF2F2;border:1px solid #FECACA;border-radius:8px;padding:10px 14px;margin-top:12px;"><span style="font-size:16px;">⚠️</span><span style="font-size:12px;font-weight:700;color:#DC2626;">Reconciliation Gap — Transaction sum MYR '+txnSum.toLocaleString('en-MY',{minimumFractionDigits:2})+' vs firm revenue MYR '+firmRevenue.toLocaleString('en-MY',{minimumFractionDigits:2})+'.</span></div>';
    var kpiHtml = '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:20px;">'
      +'<div style="background:#fff;border-radius:10px;padding:16px 18px;box-shadow:0 1px 8px rgba(0,0,0,.07);"><div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:5px;">Total Revenue Received</div><div style="font-size:22px;font-weight:800;color:#0B2545;">MYR '+firmRevenue.toLocaleString('en-MY',{minimumFractionDigits:2})+'</div><div style="font-size:10px;color:#9CA3AF;margin-top:3px;">Gross commission from iFAST</div></div>'
      +'<div style="background:#fff;border-radius:10px;padding:16px 18px;box-shadow:0 1px 8px rgba(0,0,0,.07);"><div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:5px;">Total Commission Paid Out</div><div style="font-size:22px;font-weight:800;color:#166534;">MYR '+firmCommPaid.toLocaleString('en-MY',{minimumFractionDigits:2})+'</div><div style="font-size:10px;color:#9CA3AF;margin-top:3px;">'+((firmRevenue>0?(firmCommPaid/firmRevenue*100):0).toFixed(1))+'% of total revenue</div></div>'
      +'<div style="background:#EFF6FF;border-radius:10px;padding:16px 18px;box-shadow:0 1px 8px rgba(0,0,0,.07);"><div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:5px;">LIFA Net Retention</div><div style="font-size:22px;font-weight:800;color:#1D4ED8;">MYR '+firmRetention.toLocaleString('en-MY',{minimumFractionDigits:2})+'</div><div style="font-size:10px;color:#9CA3AF;margin-top:3px;">'+((firmRevenue>0?(firmRetention/firmRevenue*100):0).toFixed(1))+'% of total revenue</div></div>'
      +'</div>';
    var tableRows = stmtList.map(function(e){
      var adv=ADVISERS[e.advId]||{name:e.advId,ifast:"—"}; var b=breakdowns[e.advId]; var isPaid=e.s.status==="Paid";
      var overridings=+(b.overridesOut!==undefined?b.overridesOut:(b.directPayout+b.indirectPayout)).toFixed(2);
      var checkOK=Math.abs(b.checkGap!==undefined?b.checkGap:(b.personalPayout+overridings+b.lifaRetention-b.revenue))<0.02;   // REAL: retention is the stored column
      return '<tr style="border-bottom:1px solid #F1F5F9;">'
        +'<td style="padding:10px 12px;font-weight:700;color:#0B2545;">'+adv.name+'<div style="font-size:10px;color:#9CA3AF;font-weight:400;margin-top:1px;">'+e.advId+' &middot; '+(adv.ifast||"—")+'</div></td>'
        +'<td style="padding:10px 12px;"><span style="background:#EDE9FE;color:#6D28D9;padding:2px 8px;border-radius:12px;font-size:10px;font-weight:700;">'+e.s.rank+'</span><div style="font-size:10px;color:#9CA3AF;margin-top:2px;">'+(b.personalRate*100).toFixed(0)+'% personal</div></td>'
        +'<td style="padding:10px 12px;text-align:right;font-weight:700;color:#0B2545;">MYR '+b.revenue.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
        +'<td style="padding:10px 12px;text-align:right;color:#166534;font-weight:700;">MYR '+b.personalPayout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
        +'<td style="padding:10px 12px;text-align:right;color:#1D4ED8;font-weight:600;">'+(overridings>0?'MYR '+overridings.toLocaleString('en-MY',{minimumFractionDigits:2}):'<span style="color:#D1D5DB;">—</span>')+'</td>'
        +'<td style="padding:10px 12px;text-align:right;color:#374151;font-weight:600;">MYR '+b.lifaRetention.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
        +'<td style="padding:10px 12px;text-align:center;">'+(checkOK?'<span style="color:#166534;font-size:13px;">✓</span>':'<span style="color:#DC2626;font-size:13px;">✗</span>')+'</td>'
        +'<td style="padding:10px 12px;text-align:center;">'+(isPaid?'<span style="background:#DCFCE7;color:#166534;padding:3px 10px;border-radius:20px;font-size:10px;font-weight:700;">✓ Published</span>':'<button onclick="amrSwitchTab(\''+month+'\',\''+e.advId+'\')" style="background:#FEF3C7;color:#92400E;border:none;padding:3px 10px;border-radius:20px;font-size:10px;font-weight:700;cursor:pointer;">⏳ Review →</button>')+'</td>'
        +'</tr>';
    }).join("");
    var firmOverridings=+stmtList.reduce(function(a,e){var b=breakdowns[e.advId];return a+(b?(b.overridesOut!==undefined?b.overridesOut:b.directPayout+b.indirectPayout):0);},0).toFixed(2);
    var firmCheckOK=Math.abs(firmCommPaid+firmOverridings+firmRetention-firmRevenue)<0.02;
    tableRows+='<tr style="background:#F1F5F9;font-weight:800;border-top:2px solid #E2E8F0;">'
      +'<td colspan="2" style="padding:11px 12px;color:#0B2545;">TOTAL ('+stmtList.length+' agents)</td>'
      +'<td style="padding:11px 12px;text-align:right;color:#0B2545;">MYR '+firmRevenue.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
      +'<td style="padding:11px 12px;text-align:right;color:#166534;">MYR '+firmCommPaid.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
      +'<td style="padding:11px 12px;text-align:right;color:#1D4ED8;">'+(firmOverridings>0?'MYR '+firmOverridings.toLocaleString('en-MY',{minimumFractionDigits:2}):'—')+'</td>'
      +'<td style="padding:11px 12px;text-align:right;color:#374151;">MYR '+firmRetention.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td>'
      +'<td style="padding:11px 12px;text-align:center;">'+(firmCheckOK?'<span style="color:#166534;font-size:13px;">✓</span>':'<span style="color:#DC2626;font-size:13px;">✗</span>')+'</td>'
      +'<td></td></tr>';
    // Source breakdown
    var bySource={};
    stmtList.forEach(function(e){ (e.s.transactions||[]).forEach(function(t){ var src=(t.type||"Other"); bySource[src]=+((bySource[src]||0)+(t.ifast_comm||0)).toFixed(2); }); });
    var sourceRows=Object.keys(bySource).sort().map(function(src){
      return '<tr style="border-bottom:1px solid #F1F5F9;"><td style="padding:8px 12px;color:#374151;">'+src+'</td><td style="padding:8px 12px;text-align:right;font-weight:600;color:#0B2545;">MYR '+bySource[src].toLocaleString('en-MY',{minimumFractionDigits:2})+'</td><td style="padding:8px 12px;text-align:right;color:#9CA3AF;">'+(firmRevenue>0?(bySource[src]/firmRevenue*100).toFixed(1)+'%':'—')+'</td></tr>';
    }).join("");
    var sourceTotal=+Object.values(bySource).reduce(function(a,v){return a+v;},0).toFixed(2);
    var sourceTotalOK=Math.abs(sourceTotal-firmRevenue)<0.02;
    sourceRows+='<tr style="background:#F1F5F9;font-weight:800;border-top:2px solid #E2E8F0;"><td style="padding:10px 12px;color:#0B2545;">TOTAL</td><td style="padding:10px 12px;text-align:right;color:#0B2545;">MYR '+sourceTotal.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td><td style="padding:10px 12px;text-align:right;color:#0B2545;">100%</td></tr>';
    var sourceReconRow=sourceTotalOK
      ?'<div style="display:flex;align-items:center;gap:8px;background:#DCFCE7;border:1px solid #BBF7D0;border-radius:0 0 10px 10px;padding:9px 14px;"><span>✅</span><span style="font-size:11px;font-weight:700;color:#166534;">Source total MYR '+sourceTotal.toLocaleString('en-MY',{minimumFractionDigits:2})+' = Firm revenue ✓</span></div>'
      :'<div style="display:flex;align-items:center;gap:8px;background:#FEF2F2;border:1px solid #FECACA;border-radius:0 0 10px 10px;padding:9px 14px;"><span>⚠️</span><span style="font-size:11px;font-weight:700;color:#DC2626;">Source total MYR '+sourceTotal.toLocaleString('en-MY',{minimumFractionDigits:2})+' ≠ Firm revenue MYR '+firmRevenue.toLocaleString('en-MY',{minimumFractionDigits:2})+'</span></div>';
    content='<div style="padding:20px 24px;">'
      +'<div style="font-size:13px;font-weight:700;color:#0B2545;margin-bottom:14px;">'+month+' — Firm Summary</div>'
      +kpiHtml
      +'<div style="background:#fff;border-radius:10px;box-shadow:0 1px 8px rgba(0,0,0,.07);overflow:hidden;margin-bottom:16px;">'
      +'<div style="padding:12px 14px;border-bottom:1px solid #F1F5F9;display:flex;align-items:center;justify-content:space-between;"><div style="font-size:12px;font-weight:700;color:#0B2545;">Per-Agent Commission Summary</div><div style="font-size:10px;color:#9CA3AF;">Agent Payout + Overridings + Retention must = Revenue ✓</div></div>'
      +'<table style="width:100%;border-collapse:collapse;font-size:12px;"><thead><tr style="background:#F8FAFC;">'
      +'<th style="padding:9px 12px;text-align:left;color:#9CA3AF;font-weight:600;">Agent</th>'
      +'<th style="padding:9px 12px;text-align:left;color:#9CA3AF;font-weight:600;">Tier / Rate</th>'
      +'<th style="padding:9px 12px;text-align:right;color:#9CA3AF;font-weight:600;">Revenue (A)</th>'
      +'<th style="padding:9px 12px;text-align:right;color:#166534;font-weight:600;">Agent Payout (B)</th>'
      +'<th style="padding:9px 12px;text-align:right;color:#1D4ED8;font-weight:600;">Overridings (C)</th>'
      +'<th style="padding:9px 12px;text-align:right;color:#374151;font-weight:600;">LIFA Retention (D)</th>'
      +'<th style="padding:9px 12px;text-align:center;color:#9CA3AF;font-weight:600;">B+C+D=A</th>'
      +'<th style="padding:9px 12px;text-align:center;color:#9CA3AF;font-weight:600;">Status</th>'
      +'</tr></thead><tbody>'+tableRows+'</tbody></table></div>'
      +'<div style="background:#fff;border-radius:10px;box-shadow:0 1px 8px rgba(0,0,0,.07);overflow:hidden;margin-bottom:16px;">'
      +'<div style="padding:12px 14px;border-bottom:1px solid #F1F5F9;display:flex;align-items:center;justify-content:space-between;"><div style="font-size:12px;font-weight:700;color:#0B2545;">Revenue by Source</div><div style="font-size:10px;color:#9CA3AF;">Cross-reference: sum of all transaction types = firm total</div></div>'
      +'<table style="width:100%;border-collapse:collapse;font-size:12px;"><thead><tr style="background:#F8FAFC;">'
      +'<th style="padding:9px 12px;text-align:left;color:#9CA3AF;font-weight:600;">Source</th>'
      +'<th style="padding:9px 12px;text-align:right;color:#9CA3AF;font-weight:600;">Amount</th>'
      +'<th style="padding:9px 12px;text-align:right;color:#9CA3AF;font-weight:600;">% of Total</th>'
      +'</tr></thead><tbody>'+sourceRows+'</tbody></table>'
      +sourceReconRow+'</div>'
      +reconRow+'</div>';
  } else {
    // Agent tab
    var entry=null; stmtList.forEach(function(e){if(e.advId===tabId) entry=e;});
    if(entry){
      var s=entry.s, adv=ADVISERS[tabId]||{name:tabId}; var b=breakdowns[tabId];
      var byType={};
      (s.transactions||[]).forEach(function(t){byType[t.type]=byType[t.type]||[];byType[t.type].push(t);});
      var txnHtml=Object.keys(byType).map(function(type){
        var txns=byType[type];
        var typeRev=+txns.reduce(function(a,t){return a+t.ifast_comm;},0).toFixed(2);
        var typeComm=+txns.reduce(function(a,t){return a+t.payout;},0).toFixed(2);
        return '<div style="margin-bottom:14px;">'
          +'<div style="font-size:11px;font-weight:700;color:#0B2545;background:#F8FAFC;padding:7px 10px;border-radius:6px 6px 0 0;border:1px solid #E2E8F0;border-bottom:none;display:flex;justify-content:space-between;"><span>'+type+'</span><span style="color:#166534;">Payout: MYR '+typeComm.toLocaleString('en-MY',{minimumFractionDigits:2})+'</span></div>'
          +'<table style="width:100%;font-size:11px;border-collapse:collapse;border:1px solid #E2E8F0;"><thead><tr style="background:#F8FAFC;">'
          +'<th style="padding:6px 9px;text-align:left;color:#9CA3AF;font-weight:600;">Date</th>'
          +'<th style="padding:6px 9px;text-align:left;color:#9CA3AF;font-weight:600;">Client</th>'
          +'<th style="padding:6px 9px;text-align:left;color:#9CA3AF;font-weight:600;">Product</th>'
          +'<th style="padding:6px 9px;text-align:right;color:#9CA3AF;font-weight:600;">iFAST Comm</th>'
          +'<th style="padding:6px 9px;text-align:right;color:#9CA3AF;font-weight:600;">Agent Payout</th>'
          +'</tr></thead><tbody>'
          +txns.map(function(t){return '<tr style="border-bottom:1px solid #F1F5F9;"><td style="padding:6px 9px;color:#374151;">'+t.date+'</td><td style="padding:6px 9px;">'+t.client+'</td><td style="padding:6px 9px;max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">'+t.product+'</td><td style="padding:6px 9px;text-align:right;">'+t.ifast_comm.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td><td style="padding:6px 9px;text-align:right;font-weight:700;color:#166534;">'+t.payout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>';}).join("")
          +'<tr style="background:#F0FDF4;"><td colspan="3" style="padding:6px 9px;font-weight:700;">Subtotal</td><td style="padding:6px 9px;text-align:right;font-weight:700;">'+typeRev.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td><td style="padding:6px 9px;text-align:right;font-weight:700;color:#166534;">'+typeComm.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>'
          +'</tbody></table></div>';
      }).join("")||'<div style="padding:16px;color:#9CA3AF;font-size:12px;">No transactions this period.</div>';
      var approveBar=(s.status!=="Paid")
        ?'<div style="background:#F1F5F9;border:1px solid #E2E8F0;border-radius:10px;padding:11px 16px;margin-bottom:18px;font-size:12px;color:#475569;">'+(s.status==='Carried'?'↻ <b>Carried forward</b> — under RM50; pays out with a future month.':'Publishes automatically when the month is approved at Monthly Close and finance confirms payment.')+'</div>'
        :'<div style="background:#DCFCE7;border:1px solid #BBF7D0;border-radius:10px;padding:11px 16px;margin-bottom:18px;font-size:12px;font-weight:600;color:#166534;">✓ Statement published to agent portal.</div>';
      content='<div style="padding:20px 24px;">'
        +approveBar
        +'<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:16px;">'
        +'<div style="background:#fff;border-radius:10px;padding:16px;box-shadow:0 1px 8px rgba(0,0,0,.07);"><div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:4px;">Revenue</div><div style="font-size:20px;font-weight:800;color:#0B2545;">MYR '+b.revenue.toLocaleString('en-MY',{minimumFractionDigits:2})+'</div></div>'
        +'<div style="background:#fff;border-radius:10px;padding:16px;box-shadow:0 1px 8px rgba(0,0,0,.07);"><div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:4px;">Rate</div><div style="font-size:20px;font-weight:800;color:#0B2545;">'+(b.personalRate*100).toFixed(0)+'% <span style="font-size:11px;color:#9CA3AF;">('+s.rank+')</span></div></div>'
        +'<div style="background:#F0FDF4;border-radius:10px;padding:16px;box-shadow:0 1px 8px rgba(0,0,0,.07);"><div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;margin-bottom:4px;">Agent Payout</div><div style="font-size:20px;font-weight:800;color:#166534;">MYR '+b.personalPayout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</div></div>'
        +'</div>'
        +'<div style="background:#fff;border-radius:10px;padding:16px;box-shadow:0 1px 8px rgba(0,0,0,.07);margin-bottom:16px;">'
        +'<div style="font-size:12px;font-weight:700;color:#0B2545;margin-bottom:10px;">Commission Breakdown</div>'
        +'<table style="width:100%;font-size:12px;border-collapse:collapse;">'
        +'<tr style="border-bottom:1px solid #F1F5F9;"><td style="padding:8px 0;color:#374151;font-weight:600;">Revenue from iFAST</td><td></td><td style="text-align:right;font-weight:700;color:#0B2545;">MYR '+b.revenue.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>'
        +'<tr style="border-bottom:1px solid #F1F5F9;background:#F8FFF8;"><td style="padding:8px 0 8px 10px;color:#166534;"><b>Personal Payout</b> <span style="font-size:10px;color:#9CA3AF;">'+s.rank+' &mdash; '+(b.personalRate*100).toFixed(0)+'%</span></td><td style="text-align:center;color:#166534;font-weight:700;">&times; '+(b.personalRate*100).toFixed(0)+'%</td><td style="text-align:right;font-weight:700;color:#166534;">MYR '+b.personalPayout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>'
        +(b.directRate>0?'<tr style="border-bottom:1px solid #F1F5F9;background:#EFF6FF;"><td style="padding:8px 0 8px 10px;color:#1D4ED8;"><b>'+b.directLabel+'</b></td><td style="text-align:center;color:#1D4ED8;font-weight:700;">&times; '+(b.directRate*100).toFixed(0)+'%</td><td style="text-align:right;font-weight:700;color:#1D4ED8;">MYR '+b.directPayout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>':"")
        +(b.indirectRate>0?'<tr style="border-bottom:1px solid #F1F5F9;background:#F5F3FF;"><td style="padding:8px 0 8px 10px;color:#7C3AED;"><b>'+b.indirectLabel+'</b></td><td style="text-align:center;color:#7C3AED;font-weight:700;">&times; '+(b.indirectRate*100).toFixed(0)+'%</td><td style="text-align:right;font-weight:700;color:#7C3AED;">MYR '+b.indirectPayout.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>':"")
        +'<tr style="border-bottom:2px solid #E2E8F0;"><td style="padding:8px 0 8px 10px;color:#9CA3AF;">LIFA Retention</td><td style="text-align:center;color:#9CA3AF;font-size:10px;">remainder</td><td style="text-align:right;color:#9CA3AF;">MYR '+b.lifaRetention.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>'
        +'<tr><td style="padding:9px 0 3px;font-weight:700;color:#0B2545;">Total Paid Out</td><td></td><td style="text-align:right;font-weight:700;color:#0B2545;font-size:14px;">MYR '+b.totalPaidOut.toLocaleString('en-MY',{minimumFractionDigits:2})+'</td></tr>'
        +'</table></div>'
        +'<div style="font-size:12px;font-weight:700;color:#0B2545;margin-bottom:10px;">Transaction Detail</div>'
        +txnHtml+'</div>';
    }
  }
  document.getElementById(tabPanelId+"-content").innerHTML = content;
}


function upResolveAgent(rawId,partner,nameHint){
  var found=null;
  // §SUMMARY (2026-09-13): a Phillip LFP code is NOT the iFAST number — LFP0002 is
  // Gan Chin Soon, while LFA00002 is Koek. Deriving one from the other credited
  // Gan's Phillip commission to Koek. The statement prints the adviser's NAME
  // beside the code, so match on that first; the numeric guess is the fallback.
  if(partner!=="iFAST" && nameHint){
    var want=String(nameHint).toUpperCase().replace(/[^A-Z]/g,"");
    if(want) Object.keys(ADVISERS).forEach(function(k){
      var a=ADVISERS[k]; if(!a||!a.name) return;
      if(a.name.toUpperCase().replace(/[^A-Z]/g,"")===want) found=k;
    });
    if(found) return found;
    // ⛔ NO NUMERIC GUESS FOR PHILLIP (owner 2026-09-13: "make sure this dont
    // happen again"). An unmatched Phillip name resolves to NOBODY, and
    // upGenerateAll refuses the month until an admin fixes the adviser's name.
    return null;
  }
  Object.keys(ADVISERS).forEach(function(k){
    var a=ADVISERS[k];
    if(partner==="iFAST"){if((a.ifast||"").toUpperCase()===rawId.toUpperCase()) found=k;}
    else{if(a.ifast){var num=parseInt(a.ifast.replace(/[^0-9]/g,""));if("LFP"+String(num).padStart(4,"0")===rawId) found=k;}}
  });
  return found;
}

// ── View file modal ───────────────────────────────────────────────────────────
function upViewFile(partner,month,fname){
  var f=(UPLOADS[partner][month]||[]).find(function(x){return x.name===fname;}); if(!f) return;
  var allTxns=[];
  Object.keys(f.agentTotals||{}).forEach(function(id){
    var ag=f.agentTotals[id]; var advId=upResolveAgent(id,partner,ag&&ag.name);
    var name=ag.name||(advId&&ADVISERS[advId]?ADVISERS[advId].name:id);
    (ag.transactions||[]).forEach(function(t){allTxns.push({agentId:id,agentName:name,t:t});});
  });
  var sumRows=Object.keys(f.agentTotals||{}).map(function(id){
    var ag=f.agentTotals[id]; var advId=upResolveAgent(id,partner,ag&&ag.name);
    return '<tr style="border-bottom:1px solid #F1F5F9;"><td style="padding:8px;">'+id+'</td><td style="padding:8px;">'+ag.name+'</td><td style="padding:8px;">'+(advId?'<span style="color:#166534;font-weight:600;">✓ '+advId+'</span>':'<span style="color:#DC2626;">⚠ Unmatched</span>')+'</td><td style="padding:8px;text-align:right;font-weight:700;color:#166534;">RM'+(ag.ifast_comm||0).toFixed(2)+'</td></tr>';
  }).join("");
  var txnRows=allTxns.map(function(x){
    return '<tr style="border-bottom:1px solid #F1F5F9;"><td style="padding:6px 8px;font-size:11px;color:#1D4ED8;font-weight:600;">'+x.agentName+'</td><td style="padding:6px 8px;font-size:11px;">'+x.t.txn_date+'</td><td style="padding:6px 8px;font-size:11px;max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" title="'+x.t.fund+'">'+x.t.fund+'</td><td style="padding:6px 8px;font-size:11px;">'+x.t.client+'</td><td style="padding:6px 8px;font-size:11px;text-align:right;font-weight:700;color:#166534;">RM'+(x.t.ifast_comm||0).toFixed(2)+'</td></tr>';
  }).join("")||'<tr><td colspan="5" style="padding:20px;text-align:center;color:#9CA3AF;">No transactions parsed</td></tr>';
  var ov=document.createElement("div");
  ov.style.cssText="display:flex;position:fixed;inset:0;background:rgba(11,37,69,.7);z-index:9999;align-items:center;justify-content:center;";
  ov.innerHTML='<div style="background:#fff;border-radius:14px;width:860px;max-width:96vw;max-height:90vh;overflow:hidden;display:flex;flex-direction:column;box-shadow:0 24px 64px rgba(0,0,0,.25);">'
    +'<div style="padding:14px 18px;border-bottom:1px solid #F1F5F9;display:flex;justify-content:space-between;align-items:center;">'
    +'<div><div style="font-size:14px;font-weight:700;color:#0B2545;">'+fname+'</div>'
    +'<div style="font-size:11px;color:#9CA3AF;margin-top:2px;">'+upBatchLabel(f.batch||f.type)+' &nbsp;·&nbsp; '+month+' &nbsp;·&nbsp; Period: '+(f.date||"—")+'</div></div>'
    +'<button onclick="this.closest(\'[style*=fixed]\').remove()" style="background:#F3F4F6;border:none;border-radius:8px;padding:6px 14px;cursor:pointer;font-weight:600;">✕</button></div>'
    +'<div style="overflow-y:auto;padding:16px 18px;">'
    +'<div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.05em;color:#6B7280;margin-bottom:6px;">Agents</div>'
    +'<table style="width:100%;border-collapse:collapse;font-size:12px;margin-bottom:18px;"><thead><tr style="background:#F8FAFC;"><th style="padding:7px 8px;text-align:left;font-size:10px;color:#9CA3AF;">Code</th><th style="padding:7px 8px;text-align:left;font-size:10px;color:#9CA3AF;">Name</th><th style="padding:7px 8px;text-align:left;font-size:10px;color:#9CA3AF;">LIFA Match</th><th style="padding:7px 8px;text-align:right;font-size:10px;color:#9CA3AF;">Commission</th></tr></thead><tbody>'+sumRows+'</tbody></table>'
    +'<div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.05em;color:#6B7280;margin-bottom:6px;">Transactions ('+allTxns.length+')</div>'
    +'<table style="width:100%;border-collapse:collapse;font-size:12px;"><thead><tr style="background:#F8FAFC;"><th style="padding:6px 8px;text-align:left;font-size:10px;color:#9CA3AF;">Agent</th><th style="padding:6px 8px;font-size:10px;color:#9CA3AF;">Date</th><th style="padding:6px 8px;font-size:10px;color:#9CA3AF;">Fund</th><th style="padding:6px 8px;font-size:10px;color:#9CA3AF;">Client</th><th style="padding:6px 8px;text-align:right;font-size:10px;color:#9CA3AF;">Commission</th></tr></thead><tbody>'+txnRows+'</tbody></table>'
    +'</div></div>';
  ov.addEventListener("click",function(e){if(e.target===ov) ov.remove();});
  document.body.appendChild(ov);
}

function upDeleteFile(partner,month,fname){
  if(!confirm('Remove "'+fname+'" from staging?\n\nGenerated statements will not be affected.')) return;
  if(UPLOADS[partner][month]){
    UPLOADS[partner][month]=UPLOADS[partner][month].filter(function(f){return f.name!==fname;});
    if(!UPLOADS[partner][month].length) delete UPLOADS[partner][month];
  }
  showToast("success","Removed: "+fname);
  renderUploadPanel();
}

// ── APPLICATIONS (AI Interview admin) ─────────────────────────────────────────
const APPLY_API = "https://lifaportal-apply-api.lifa-gan.workers.dev";
function _applyHeaders() {
  const h = { "Content-Type": "application/json" };
  if (SESSION_TOKEN) h["Authorization"] = "Bearer " + SESSION_TOKEN;
  return h;
}
async function applyGet(path)         { const r = await fetch(APPLY_API + path, { headers: _applyHeaders() }); return r.json(); }
async function applyPut(path, body)   { const r = await fetch(APPLY_API + path, { method: "PUT",  headers: _applyHeaders(), body: JSON.stringify(body) }); return r.json(); }
async function applyPost(path, body)  { const r = await fetch(APPLY_API + path, { method: "POST", headers: _applyHeaders(), body: body ? JSON.stringify(body) : undefined }); return r.json(); }

// Mark a candidate's interview attendance (monitoring): attended → under consideration.
async function applyMarkAttended(appId, noShow){
  if(!confirm(noShow ? "Mark this candidate as a NO-SHOW?" : "Mark interview as attended (under consideration)?")) return;
  let remark = null;
  if(!noShow){
    remark = prompt("Remark (optional — e.g. impression, next step):", "Under consideration");
    if(remark===null) return; // cancelled
  }
  try{
    const r = await applyPost(`/api/apply/admin/applications/${appId}/attendance`, {status: noShow?'no_show':'attended', remark});
    if(r && r.error) throw new Error(r.error);
    showToast('success', noShow ? 'Marked no-show' : 'Marked attended — under consideration');
    renderApplicationsList();
  }catch(e){ showToast('error', e.message); }
}
// Edit the admin remark on a candidate (shown under their appointment line).
async function applyEditRemark(appId, current){
  const remark = prompt("Admin remark:", current||"");
  if(remark===null) return;
  try{
    const r = await applyPost(`/api/apply/admin/applications/${appId}/attendance`, {remark_only:true, remark});
    if(r && r.error) throw new Error(r.error);
    showToast('success','Remark saved');
    renderApplicationsList();
  }catch(e){ showToast('error', e.message); }
}
// Reference-check outcome: admin/Vinnie records pass / fail / uncontactable + a remark.
async function applyReferenceCheck(appId, result){
  const label = {pass:'PASS', fail:'FAIL', uncontactable:'UNCONTACTABLE'}[result] || result;
  const remark = prompt(`Reference check — mark as ${label}.\n\nRemark (who you spoke to, what they said):`, "");
  if(remark===null) return;
  try{
    const r = await applyPost(`/api/apply/admin/applications/${appId}/reference-check`, {result, remark});
    if(r && r.error) throw new Error(r.error);
    let msg = `Reference check saved: ${label}`;
    if(result==='pass' && r.invite){
      if(r.invite.already)      msg += ` — invite NOT re-sent (${r.invite.reason||'already invited/booked'})`;
      else if(r.invite.ok)      msg += ` — interview invite sent (email${r.invite.whatsapp && r.invite.whatsapp.ok ? ' + WhatsApp' : ', WhatsApp via gateway'})`;
      else                      msg += ` — ⚠ invite did NOT send: ${(r.invite.error||'unknown')}`;
    }
    showToast(result==='pass' && r.invite && !r.invite.ok && !r.invite.already ? 'error' : 'success', msg);
    renderApplicationsList();
  }catch(e){ showToast('error', e.message); }
}
async function applyApproveSlot(appId, action) {
  try {
    const r = await applyPost(`/api/apply/admin/applications/${appId}/appointment`, { action });
    if (r && r.error) throw new Error(r.error);
    showToast('success', action === 'confirm' ? 'Slot confirmed — candidate notified.' : 'Slot rejected — candidate asked to rebook.');
    renderApplicationsList();
  } catch(e) { showToast('error', e.message); }
}
async function applyDelete(path)      { const r = await fetch(APPLY_API + path, { method: "DELETE", headers: _applyHeaders() }); return r.json(); }

const APPLY_ROLE_LABEL  = { admin_executive: "Admin Executive", financial_advisor: "Financial Advisor", wealth_advisor: "Wealth Advisor" };
const APPLY_STATUS_LABEL = {
  registered:"Registered", particulars_done:"Particulars done",
  stage1_done:"Video done", assessment_done:"Assessment done", stage2_done:"Written done",
  submitted_pending_analysis:"Analysing…",
  analysed:"Analysed",
  walk_in_scheduled:"🏢 Walk-in scheduled",
  shortlisted:"Shortlisted", interview_invited:"📅 Interview invited", interviewed:"✅ Interviewed", rejected:"Rejected", hired:"Hired",
};
// The statuses the backend accepts on PUT /status (lifaportal-apply-worker admin.js).
const APPLY_SETTABLE_STATUS = new Set(["registered","particulars_done","stage2_done","submitted_pending_analysis","analysed","shortlisted","rejected","hired"]);
const APPLY_INTERVIEW_PREF_BADGE = {
  video:    '<span style="background:#DBEAFE;color:#1E40AF;padding:2px 7px;border-radius:10px;font-size:11px;font-weight:600">📹 video</span>',
  walk_in:  '<span style="background:#FEF3C7;color:#92400E;padding:2px 7px;border-radius:10px;font-size:11px;font-weight:600">🏢 walk-in</span>',
};
const APPLY_REC_BADGE = {
  shortlist: '<span style="background:#DCFCE7;color:#166534;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:600">SHORTLIST</span>',
  maybe:     '<span style="background:#FEF3C7;color:#92400E;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:600">MAYBE</span>',
  reject:    '<span style="background:#FEE2E2;color:#991B1B;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:600">REJECT</span>',
};
const APPLY_MATRIX_BADGE = {
  strong_hire: '<span style="background:#DCFCE7;color:#166534;padding:4px 14px;border-radius:20px;font-size:12px;font-weight:700;letter-spacing:.04em">STRONG HIRE</span>',
  hire:        '<span style="background:#DBEAFE;color:#1E40AF;padding:4px 14px;border-radius:20px;font-size:12px;font-weight:700;letter-spacing:.04em">HIRE</span>',
  risky:       '<span style="background:#FEF3C7;color:#92400E;padding:4px 14px;border-radius:20px;font-size:12px;font-weight:700;letter-spacing:.04em">RISKY</span>',
  reject:      '<span style="background:#FEE2E2;color:#991B1B;padding:4px 14px;border-radius:20px;font-size:12px;font-weight:700;letter-spacing:.04em">REJECT</span>',
};


// ─── Phase 1+2 helpers: progress timeline + activity log + timestamp formatting ───
function _fmtTs(ts) {
  if (!ts) return "—";
  const d = new Date(Number(ts) * 1000);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}
function _ago(ts) {
  if (!ts) return "";
  const secs = Math.max(0, Math.floor(Date.now()/1000 - Number(ts)));
  if (secs < 60) return secs + "s ago";
  if (secs < 3600) return Math.floor(secs/60) + "m ago";
  if (secs < 86400) return Math.floor(secs/3600) + "h ago";
  return Math.floor(secs/86400) + "d ago";
}
function _buildProgress(a, p, as, iv) {
  const respByQ = {};
  for (const r of (iv.responses || [])) respByQ[r.q_index] = r;
  const s1Qs = (iv.questions || []).filter(q => q.stage === 1);
  const s2Qs = (iv.questions || []).filter(q => q.stage === 2);
  const s1Done = s1Qs.filter(q => respByQ[q.q_index] && (respByQ[q.q_index].text_answer || respByQ[q.q_index].transcript || respByQ[q.q_index].video_key));
  const s2Done = s2Qs.filter(q => respByQ[q.q_index] && (respByQ[q.q_index].text_answer || respByQ[q.q_index].transcript));
  const lastRespTs = (iv.responses || []).reduce((mx, r) => Math.max(mx, Number(r.recorded_at) || 0), 0);
  const STATUS_ICON = { done: "✅", partial: "🟡", none: "⚪" };
  const step = (label, status, when, detail) => ({ label, status, when, detail, icon: STATUS_ICON[status] || "—" });
  const steps = [];
  steps.push(step("1. Particulars",
    p && p.application_id ? "done" : (a.status === "registered" ? "none" : "partial"),
    null,
    p ? "Submitted" : "Not submitted"
  ));
  if (s2Qs.length > 0) {
    const s2Status = s2Done.length === s2Qs.length ? "done" : (s2Done.length > 0 ? "partial" : "none");
    const lastS2 = s2Done.length ? Math.max(...s2Done.map(q => Number(respByQ[q.q_index].recorded_at) || 0)) : 0;
    steps.push(step("2. Personality / Written", s2Status, lastS2,
      `${s2Done.length}/${s2Qs.length} answered` +
      (s2Done.length > 0 && s2Done.length < s2Qs.length ? ` · last: Q${s2Done[s2Done.length-1].q_index} at ${_fmtTs(lastS2)}` : "")
    ));
  }
  steps.push(step("3. Practical Assessment",
    as ? "done" : "none", as ? Number(as.submitted_at || 0) : 0,
    as ? `Submitted (took ${Math.floor((as.duration_sec||0)/60)}m ${(as.duration_sec||0)%60}s)${(as.duration_sec === 0 || as.duration_sec == null) ? ' ⚠️ timer error — duration not captured' : ''}` : "Not submitted"
  ));
  if (s1Qs.length > 0) {
    const s1Status = s1Done.length === s1Qs.length ? "done" : (s1Done.length > 0 ? "partial" : "none");
    const lastS1 = s1Done.length ? Math.max(...s1Done.map(q => Number(respByQ[q.q_index].recorded_at) || 0)) : 0;
    steps.push(step("4. Video Interview", s1Status, lastS1,
      `${s1Done.length}/${s1Qs.length} answered` +
      (s1Done.length > 0 && s1Done.length < s1Qs.length ? ` · last: Q${s1Done[s1Done.length-1].q_index} at ${_fmtTs(lastS1)}` : "")
    ));
  }
  return { steps, lastActivity: Math.max(lastRespTs, Number(a.updated_at) || 0, as ? Number(as.submitted_at) : 0) };
}
function _renderProgressBlock(prog, a) {
  const rows = prog.steps.map(s => `
    <tr>
      <td style="padding:10px 12px;font-size:13px">${s.icon}</td>
      <td style="padding:10px 12px;font-size:13px;font-weight:500">${escapeHtml(s.label)}</td>
      <td style="padding:10px 12px;font-size:13px;color:#374151">${escapeHtml(s.detail)}</td>
      <td style="padding:10px 12px;font-size:12px;color:#6B7280;text-align:right">${s.when ? _fmtTs(s.when) : ""}</td>
    </tr>`).join("");
  return `
    <div style="background:#fff;padding:20px 24px;border-radius:12px;box-shadow:0 4px 24px rgba(11,37,69,.06);margin-bottom:20px">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;flex-wrap:wrap;gap:8px">
        <h3 style="font-family:Cormorant Garamond,serif;font-size:20px">Progress</h3>
        <div style="font-size:12px;color:#6B7280">
          Registered ${_fmtTs(a.created_at)} · Last activity ${prog.lastActivity ? _ago(prog.lastActivity) + " (" + _fmtTs(prog.lastActivity) + ")" : "—"}
        </div>
      </div>
      <table style="width:100%;border-collapse:collapse">
        <tbody>${rows}</tbody>
      </table>
    </div>`;
}
// WhatsApp activity panel for the candidate detail view. Data comes from the
// nightly chat_analysis sync on the Mac mini (sync_whatsapp_activity_to_d1.py).
function _renderWhatsappActivity(wa, app) {
  if (!wa || !wa.found || !wa.activity) {
    return `
      <div style="background:#fff;padding:18px 24px;border-radius:12px;box-shadow:0 4px 24px rgba(11,37,69,.06);margin-bottom:20px;display:flex;justify-content:space-between;align-items:center;gap:12px;flex-wrap:wrap">
        <div>
          <div style="font-family:Cormorant Garamond,serif;font-size:20px;color:#0B2545">💬 WhatsApp activity</div>
          <div style="font-size:13px;color:#9CA3AF;margin-top:2px">No messages found on +60 11-5589 1833 from this number${wa?.phone ? ' (+60' + escapeHtml(wa.phone) + ')' : ''}.</div>
        </div>
        ${app?.phone ? `<a href="https://wa.me/${escapeHtml(_normPhoneForWa(app.phone))}?text=${encodeURIComponent('Hi ' + (app.name || 'there') + ' — this is LIFA Planners following up on your application.')}" target="_blank" rel="noopener" style="background:#25D366;color:#fff;text-decoration:none;padding:8px 14px;border-radius:8px;font-size:13px;font-weight:500;white-space:nowrap">💬 Start WhatsApp</a>` : ''}
      </div>`;
  }
  const w = wa.activity;
  const recentHot = (w.count_last_7d || 0) >= 3;
  const dotColor = (w.count_last_7d || 0) > 0 ? '#16A34A' : '#9CA3AF';
  const fmtTs = ts => ts ? new Date(ts).toLocaleString() : '—';
  const ago = ts => {
    if (!ts) return '—';
    const s = Math.floor((Date.now() - new Date(ts).getTime())/1000);
    if (s < 60) return 'just now';
    if (s < 3600) return Math.floor(s/60) + 'm ago';
    if (s < 86400) return Math.floor(s/3600) + 'h ago';
    return Math.floor(s/86400) + 'd ago';
  };
  return `
    <div style="background:#fff;padding:20px 24px;border-radius:12px;box-shadow:0 4px 24px rgba(11,37,69,.06);margin-bottom:20px">
      <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:16px;flex-wrap:wrap;margin-bottom:14px">
        <div>
          <h3 style="font-family:Cormorant Garamond,serif;font-size:22px;margin-bottom:4px">
            <span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${dotColor};margin-right:6px;vertical-align:middle"></span>
            💬 WhatsApp activity ${recentHot ? '<span style="background:#DCFCE7;color:#166534;font-size:11px;padding:2px 8px;border-radius:10px;margin-left:6px;font-weight:600">HOT</span>' : ''}
          </h3>
          <div style="font-size:13px;color:#6B7280">Conversations with this candidate on <b>+60 11-5589 1833</b> (via OpenClaw)</div>
        </div>
        ${app?.phone ? `<a href="https://wa.me/${escapeHtml(_normPhoneForWa(app.phone))}?text=${encodeURIComponent('Hi ' + (app.name || 'there') + ' — this is LIFA Planners')}" target="_blank" rel="noopener" style="background:#25D366;color:#fff;text-decoration:none;padding:8px 14px;border-radius:8px;font-size:13px;font-weight:500;white-space:nowrap;align-self:flex-start">💬 Reply on WhatsApp</a>` : ''}
      </div>
      <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:12px;margin:8px 0 14px">
        <div style="background:#FAFAF7;padding:12px 14px;border-radius:8px;text-align:center">
          <div style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6B7280;font-weight:600">Total msgs</div>
          <div style="font-size:24px;font-weight:600;color:#0B2545;font-family:Cormorant Garamond,serif;margin-top:2px">${w.message_count || 0}</div>
        </div>
        <div style="background:#FAFAF7;padding:12px 14px;border-radius:8px;text-align:center">
          <div style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6B7280;font-weight:600">From them</div>
          <div style="font-size:24px;font-weight:600;color:#0B2545;font-family:Cormorant Garamond,serif;margin-top:2px">${w.user_msg_count || 0}</div>
        </div>
        <div style="background:#FAFAF7;padding:12px 14px;border-radius:8px;text-align:center">
          <div style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6B7280;font-weight:600">Last 7 days</div>
          <div style="font-size:24px;font-weight:600;color:${(w.count_last_7d||0)>0?'#166534':'#9CA3AF'};font-family:Cormorant Garamond,serif;margin-top:2px">${w.count_last_7d || 0}</div>
        </div>
        <div style="background:#FAFAF7;padding:12px 14px;border-radius:8px;text-align:center">
          <div style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6B7280;font-weight:600">Last 30d</div>
          <div style="font-size:24px;font-weight:600;color:#0B2545;font-family:Cormorant Garamond,serif;margin-top:2px">${w.count_last_30d || 0}</div>
        </div>
      </div>
      <div style="font-size:13px;color:#374151;line-height:1.7">
        <div><b style="color:#6B7280;font-weight:600">WhatsApp name:</b> ${escapeHtml(w.display_name || '(no name on WhatsApp)')}</div>
        <div><b style="color:#6B7280;font-weight:600">First seen:</b> ${escapeHtml(fmtTs(w.first_ts))}</div>
        <div><b style="color:#6B7280;font-weight:600">Last seen:</b> ${escapeHtml(fmtTs(w.last_ts))} <span style="color:#9CA3AF">(${escapeHtml(ago(w.last_ts))})</span></div>
        ${w.last_session_id ? `<div><b style="color:#6B7280;font-weight:600">OpenClaw session:</b> <code style="background:#F1F5F9;padding:1px 6px;border-radius:4px;font-size:12px">${escapeHtml(w.last_session_id)}</code></div>` : ''}
      </div>
      ${w.last_user_msg_snippet ? `
        <div style="margin-top:12px;background:#FAFAF7;border-left:3px solid #B8962E;padding:10px 14px;border-radius:0 8px 8px 0">
          <div style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#B8962E;font-weight:600;margin-bottom:4px">Last message from them</div>
          <div style="font-size:13px;color:#374151;line-height:1.5;white-space:pre-wrap">${escapeHtml(w.last_user_msg_snippet)}</div>
        </div>` : ''}
      <div style="font-size:11px;color:#9CA3AF;margin-top:12px">Synced ${w.updated_at ? ago(new Date(w.updated_at*1000).toISOString()) : 'never'} from OpenClaw chat_analysis. Re-sync on Mac mini: <code>python3 ~/Desktop/screenshot/scripts/sync_whatsapp_activity_to_d1.py</code></div>
    </div>`;
}
function _normPhoneForWa(p) {
  // For wa.me URL — needs digits only, no +
  let d = String(p || "").replace(/\D/g, "");
  if (d.startsWith("0")) d = "60" + d.slice(1);
  return d;
}

function _renderActivityLog(events) {
  if (!events || !events.length) return "";
  const rows = events.map(ev => {
    const sevColor = ev.severity === "error" ? "#991B1B" : ev.severity === "warning" ? "#92400E" : "#6B7280";
    const sevBg    = ev.severity === "error" ? "#FEE2E2" : ev.severity === "warning" ? "#FEF3C7" : "transparent";
    return `<tr style="border-top:1px solid #F1F5F9">
      <td style="padding:6px 10px;color:#6B7280;white-space:nowrap;font-size:12px">${_fmtTs(ev.ts)}</td>
      <td style="padding:6px 10px;font-size:12px"><span style="background:${sevBg};color:${sevColor};padding:2px 8px;border-radius:10px;font-weight:600">${escapeHtml(ev.event_type)}</span></td>
      <td style="padding:6px 10px;color:#374151;font-size:12px">${escapeHtml(ev.step || "—")}${ev.q_index != null ? ` · Q${ev.q_index}` : ""}</td>
      <td style="padding:6px 10px;color:#374151;font-size:12px">${escapeHtml(ev.message || "")}</td>
    </tr>`;
  }).join("");
  return `
    <div style="background:#fff;padding:24px;border-radius:12px;box-shadow:0 4px 24px rgba(11,37,69,.06);margin-bottom:20px">
      <h3 style="font-family:Cormorant Garamond,serif;font-size:22px;margin-bottom:6px">Activity Log <span style="font-size:13px;color:#9CA3AF;font-weight:400">· ${events.length} event(s)</span></h3>
      <p style="font-size:12px;color:#6B7280;margin-bottom:14px">Page views, paste warnings, errors and other client-side events captured during the candidate's session — useful for understanding where they got stuck or whether they pasted AI-generated answers.</p>
      <table style="width:100%;border-collapse:collapse">
        <thead><tr style="background:#F1F5F9;text-align:left">
          <th style="padding:8px 10px;font-weight:600;font-size:12px">Time</th>
          <th style="padding:8px 10px;font-weight:600;font-size:12px">Type</th>
          <th style="padding:8px 10px;font-weight:600;font-size:12px">Step</th>
          <th style="padding:8px 10px;font-weight:600;font-size:12px">Detail</th>
        </tr></thead>
        <tbody>${rows}</tbody>
      </table>
    </div>`;
}

let _applyFilterRole = "";
let _applyFilterBucket = "needs_you";  // needs_you | leads | shortlisted | interview | hired | rejected
let _applyFilterSearch = "";   // free-text: name / email / phone / app id
let _cachedApplicationRows = null;   // cached from last fetch; null = not yet loaded
let _cachedLeads = null;
let _cachedExpiredLeads = null;

// Pipeline stage buckets — maps raw application status → pipeline stage key.
// "leads" stage is sourced_leads (pre-registration) loaded separately.
const APPLY_BUCKETS = {
  registered:  ["registered"],
  in_progress: ["particulars_done","stage2_done","assessment_done","submitted_pending_analysis","analysed"],
  bg_check:    ["shortlisted"],
  interview:   ["interview_invited","walk_in_scheduled","interviewed"],
  hired:       ["hired"],
  rejected:    ["rejected"],
};
// Sub-stage label shown inside "In Progress" rows.
const APPLY_PROGRESS_LABEL = {
  particulars_done:          "Personal info done",
  stage2_done:               "Written section done",
  assessment_done:           "Assessment done",
  submitted_pending_analysis:"Video uploaded — analysing…",
  analysed:                  "Analysis complete",
};
// Assign each application to exactly ONE pipeline stage.
function _applyStageOf(r) {
  if (r.status === 'hired') return 'hired';
  if (r.status === 'rejected') return 'rejected';
  if (r.interview_appointment_at ||
      ['interview_invited','walk_in_scheduled','interviewed'].includes(r.status)) return 'interview';
  if (r.status === 'shortlisted') return 'bg_check';
  if (APPLY_BUCKETS.in_progress.includes(r.status)) return 'in_progress';
  return 'registered';
}
// Candidates parked on one of the admin's decisions — the daily action queue.
function _applyNeedsYou(r) {
  if (r.status === 'rejected' || r.status === 'hired') return false;
  const ap = r.interview_appointment_status || '';
  if (ap === 'requested' || ap === 'attended') return true;
  if (ap === 'confirmed' && r.interview_appointment_at && (r.interview_appointment_at * 1000) < Date.now()) return true;
  if (r.status === 'analysed' && Number(r.overall_score) >= 55 && (r.recommendation === 'maybe' || r.recommendation === 'shortlist' || r.recommendation === 'hire')) return true;
  return false;
}

// ─── Register Attempts log (every POST to /register, success + failure) ──────
let _regAttemptsFilter = { q: "", days: 30 };
async function renderRegisterAttempts() {
  const main = document.getElementById("main-content");
  const sinceTs = _regAttemptsFilter.days ? Math.floor(Date.now()/1000) - (_regAttemptsFilter.days*86400) : 0;
  main.innerHTML = `
    <div style="padding:24px">
      <div style="display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:16px;flex-wrap:wrap;gap:12px">
        <div>
          <h2 style="font-family:Cormorant Garamond,serif;font-size:28px">Register Attempts</h2>
          <p style="color:#6B7280;font-size:13px">Every POST to /api/apply/register — success or fail. Use this to diagnose "I tried to apply but it didn't work" complaints.</p>
        </div>
        <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">
          <input id="ra-search" type="search" value="${escapeHtml(_regAttemptsFilter.q)}" placeholder="Search name / email / phone / app ID" style="padding:8px 12px;border:1px solid #cbd5e1;border-radius:8px;font:inherit;font-size:13px;width:280px" autocomplete="off"/>
          <select id="ra-days" style="padding:8px 10px;border:1px solid #cbd5e1;border-radius:8px;font:inherit;font-size:13px">
            <option value="1" ${_regAttemptsFilter.days===1?'selected':''}>Last 24h</option>
            <option value="7" ${_regAttemptsFilter.days===7?'selected':''}>Last 7 days</option>
            <option value="30" ${_regAttemptsFilter.days===30?'selected':''}>Last 30 days</option>
            <option value="0" ${_regAttemptsFilter.days===0?'selected':''}>All time</option>
          </select>
          <button id="ra-refresh" style="padding:8px 12px;border:1px solid #cbd5e1;background:#fff;border-radius:8px;cursor:pointer;font:inherit;font-size:13px">↻</button>
        </div>
      </div>
      <div id="ra-body" style="background:#fff;border-radius:12px;box-shadow:0 4px 24px rgba(11,37,69,.06);overflow:hidden">
        <p style="padding:32px;text-align:center;color:#9CA3AF">Loading…</p>
      </div>
    </div>`;
  const searchEl = document.getElementById("ra-search");
  let _t = null;
  searchEl.addEventListener("input", e => {
    const val = e.target.value, pos = e.target.selectionStart;
    clearTimeout(_t); _t = setTimeout(() => {
      _regAttemptsFilter.q = val; renderRegisterAttempts();
      const fresh = document.getElementById("ra-search");
      if (fresh) { fresh.focus(); try { fresh.setSelectionRange(pos, pos); } catch {} }
    }, 200);
  });
  document.getElementById("ra-days").addEventListener("change", e => { _regAttemptsFilter.days = Number(e.target.value); renderRegisterAttempts(); });
  document.getElementById("ra-refresh").addEventListener("click", renderRegisterAttempts);

  let res;
  try {
    const qs = [];
    if (_regAttemptsFilter.q) qs.push("q=" + encodeURIComponent(_regAttemptsFilter.q));
    if (sinceTs > 0) qs.push("since=" + sinceTs);
    qs.push("limit=500");
    res = await applyGet("/api/apply/admin/register-attempts?" + qs.join("&"));
    if (res.error) throw new Error(res.error);
  } catch (e) {
    document.getElementById("ra-body").innerHTML = `<div style="padding:24px;color:#991B1B">Failed to load: ${escapeHtml(e.message)}</div>`;
    return;
  }
  const list = res.attempts || [];
  const fmt = ts => new Date(ts*1000).toLocaleString();
  const codePill = c => {
    const ok = c === 200 || c === 201, conflict = c === 409;
    const bg = ok ? '#DCFCE7' : conflict ? '#FEF3C7' : '#FEE2E2';
    const fg = ok ? '#166534' : conflict ? '#92400E' : '#991B1B';
    return `<span style="background:${bg};color:${fg};padding:2px 8px;border-radius:10px;font-size:11px;font-weight:600">${c}</span>`;
  };
  document.getElementById("ra-body").innerHTML = `
    <div style="padding:14px 18px;border-bottom:1px solid #E5E7EB;background:#FAFAF7;font-size:13px;color:#374151"><b>${list.length}</b> attempt${list.length===1?'':'s'} in this view</div>
    ${list.length === 0
      ? '<p style="padding:48px;text-align:center;color:#9CA3AF">No register attempts match. 🎉</p>'
      : `<table style="width:100%;border-collapse:collapse">
          <thead><tr style="background:#F1F5F9;text-align:left;font-size:11px;letter-spacing:.06em;text-transform:uppercase;color:#6B7280">
            <th style="padding:10px 12px">When</th>
            <th style="padding:10px 12px">Code</th>
            <th style="padding:10px 12px">Name</th>
            <th style="padding:10px 12px">Email</th>
            <th style="padding:10px 12px">Phone</th>
            <th style="padding:10px 12px">Result</th>
            <th style="padding:10px 12px">App ID</th>
          </tr></thead>
          <tbody>${list.map(r => `
            <tr class="ra-row" data-app-id="${r.app_id || ''}" style="border-top:1px solid #F1F5F9;cursor:${r.app_id?'pointer':'default'}" onmouseover="if(this.dataset.appId) this.style.background='#FAFAF7'" onmouseout="this.style.background=''">
              <td style="padding:10px 12px;color:#6B7280;font-family:monospace;font-size:12px;white-space:nowrap">${fmt(r.ts)}</td>
              <td style="padding:10px 12px">${codePill(r.status_code)}</td>
              <td style="padding:10px 12px;font-size:13px;color:#0B2545;font-weight:500">${escapeHtml(r.name) || '<i style="color:#9CA3AF">(empty)</i>'}</td>
              <td style="padding:10px 12px;font-size:12px;color:#6B7280">${escapeHtml(r.email) || '<i style="color:#9CA3AF">(empty)</i>'}</td>
              <td style="padding:10px 12px;font-size:12px;color:#374151;font-family:monospace;white-space:nowrap">${escapeHtml(r.phone) || '<i style="color:#9CA3AF">(empty)</i>'}</td>
              <td style="padding:10px 12px;font-size:12px;color:#374151">${escapeHtml(r.error) || (r.status_code < 300 ? 'ok' : '?')}</td>
              <td style="padding:10px 12px;font-family:monospace;font-size:11px;color:#9CA3AF;white-space:nowrap">${escapeHtml((r.app_id || '').slice(-8))}</td>
            </tr>`).join("")}
          </tbody></table>`}`;
  document.querySelectorAll(".ra-row").forEach(r => r.addEventListener("click", () => {
    if (r.dataset.appId) renderApplicationDetail(r.dataset.appId);
  }));
}

// ─── Portal-wide Error Log ──────────────────────────────────────────────────
// ══════════════════════════════════════════════════════════════════════════════
// COMMS LOG — per-adviser communication history (email + WhatsApp, sent + received)
let _commsFilter = { adviser:"", channel:"all", direction:"all", days:30 };
async function renderCommsLog(){
  const main=document.getElementById("main-content");
  const advOpts = Object.keys(ADVISERS).sort().map(id=>`<option value="${id}" ${_commsFilter.adviser===id?'selected':''}>${id} — ${escapeHtml((ADVISERS[id].name||'').slice(0,24))}</option>`).join("");
  main.innerHTML = `
    <div style="padding:24px">
      <div style="display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:16px;flex-wrap:wrap;gap:12px">
        <div>
          <h2 style="font-family:Cormorant Garamond,serif;font-size:28px">Communication Log</h2>
          <p style="color:#6B7280;font-size:13px">Every email &amp; WhatsApp between admin and advisers — sent and received. Filter by adviser and period to verify past correspondence.</p>
        </div>
        <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">
          <label style="font-size:12px;color:#6B7280">Adviser</label>
          <select id="cl-adviser" style="padding:6px 10px;border:1px solid #e2e8f0;border-radius:6px;font:inherit;font-size:13px">
            <option value="">All advisers</option>${advOpts}
          </select>
          <label style="font-size:12px;color:#6B7280">Channel</label>
          <select id="cl-channel" style="padding:6px 10px;border:1px solid #e2e8f0;border-radius:6px;font:inherit;font-size:13px">
            <option value="all" ${_commsFilter.channel==='all'?'selected':''}>All</option>
            <option value="email" ${_commsFilter.channel==='email'?'selected':''}>📧 Email</option>
            <option value="whatsapp" ${_commsFilter.channel==='whatsapp'?'selected':''}>📱 WhatsApp</option>
          </select>
          <label style="font-size:12px;color:#6B7280">Direction</label>
          <select id="cl-direction" style="padding:6px 10px;border:1px solid #e2e8f0;border-radius:6px;font:inherit;font-size:13px">
            <option value="all" ${_commsFilter.direction==='all'?'selected':''}>Both</option>
            <option value="outbound" ${_commsFilter.direction==='outbound'?'selected':''}>↗ Sent</option>
            <option value="inbound" ${_commsFilter.direction==='inbound'?'selected':''}>↙ Received</option>
          </select>
          <label style="font-size:12px;color:#6B7280">Period</label>
          <select id="cl-days" style="padding:6px 10px;border:1px solid #e2e8f0;border-radius:6px;font:inherit;font-size:13px">
            <option value="7" ${_commsFilter.days===7?'selected':''}>Last 7 days</option>
            <option value="30" ${_commsFilter.days===30?'selected':''}>Last 30 days</option>
            <option value="90" ${_commsFilter.days===90?'selected':''}>Last 90 days</option>
            <option value="365" ${_commsFilter.days===365?'selected':''}>Last 12 months</option>
            <option value="0" ${_commsFilter.days===0?'selected':''}>All time</option>
          </select>
        </div>
      </div>
      <div id="cl-list" style="background:#fff;border-radius:12px;box-shadow:0 2px 12px rgba(0,0,0,.07);overflow:hidden;font-size:13px;color:#6B7280;padding:20px">Loading…</div>
    </div>`;
  ["cl-adviser","cl-channel","cl-direction","cl-days"].forEach(id=>{
    document.getElementById(id).onchange=function(){
      _commsFilter.adviser=document.getElementById("cl-adviser").value;
      _commsFilter.channel=document.getElementById("cl-channel").value;
      _commsFilter.direction=document.getElementById("cl-direction").value;
      _commsFilter.days=parseInt(document.getElementById("cl-days").value);
      _loadCommsLog();
    };
  });
  _loadCommsLog();
}
async function _loadCommsLog(){
  const box=document.getElementById("cl-list"); if(!box) return;
  box.innerHTML='<div style="padding:20px;color:#9CA3AF">Loading…</div>';
  try{
    const qs=[];
    if(_commsFilter.adviser) qs.push("adviser="+encodeURIComponent(_commsFilter.adviser));
    if(_commsFilter.channel!=="all") qs.push("channel="+_commsFilter.channel);
    if(_commsFilter.direction!=="all") qs.push("direction="+_commsFilter.direction);
    if(_commsFilter.days>0) qs.push("days="+_commsFilter.days);
    const rows=await apiGet("/api/comms-log"+(qs.length?"?"+qs.join("&"):""));
    if(rows && rows.error) throw new Error(rows.error);
    if(!rows || !rows.length){ box.innerHTML='<div style="padding:24px;text-align:center;color:#94A3B8">No correspondence in this period.</div>'; return; }
    const esc = escapeHtml; // consolidated → canonical escapeHtml (line ~7379)
    box.innerHTML = `<table style="width:100%;border-collapse:collapse">
      <thead style="background:#0B2545;color:#fff"><tr>
        <th style="text-align:left;padding:10px 14px;font-size:12px">When</th>
        <th style="text-align:left;padding:10px 14px;font-size:12px">Adviser</th>
        <th style="text-align:left;padding:10px 14px;font-size:12px">Channel</th>
        <th style="text-align:left;padding:10px 14px;font-size:12px">To / From</th>
        <th style="text-align:left;padding:10px 14px;font-size:12px">Subject / Message</th>
        <th style="text-align:left;padding:10px 14px;font-size:12px">Status</th>
      </tr></thead><tbody>` +
      rows.map(r=>{
        const adv = r.adviser_id && ADVISERS[r.adviser_id] ? `${ADVISERS[r.adviser_id].name}` : (r.adviser_id||'<span style="color:#CBD5E1">—</span>');
        const chip = r.channel==='whatsapp' ? '📱 WhatsApp' : (r.channel==='admin-alert' ? '🔔 Alert' : '📧 Email');
        const dir = r.direction==='inbound'
          ? '<span style="background:#EFF6FF;color:#1D4ED8;padding:1px 8px;border-radius:10px;font-size:11px;font-weight:700">↙ received</span>'
          : '<span style="background:#F0FDF4;color:#15803D;padding:1px 8px;border-radius:10px;font-size:11px;font-weight:700">↗ sent</span>';
        const who = r.direction==='inbound' ? (r.sender||'') : (r.recipient||'');
        const what = esc(r.subject||'') + (r.snippet ? `<div style="color:#94A3B8;font-size:11.5px;margin-top:2px">${esc(String(r.snippet).slice(0,110))}${String(r.snippet).length>110?'…':''}</div>` : '');
        const stat = r.ok ? '<span style="color:#15803D">✓</span>' : `<span style="color:#B91C1C" title="${esc(r.error||'failed')}">✗ failed</span>`;
        return `<tr style="border-top:1px solid #F1F5F9;vertical-align:top">
          <td style="padding:9px 14px;white-space:nowrap;color:#475569">${esc((r.created_at||'').slice(0,16))}</td>
          <td style="padding:9px 14px;font-weight:600;color:#0B2545">${esc(adv)}</td>
          <td style="padding:9px 14px;white-space:nowrap">${chip} ${dir}</td>
          <td style="padding:9px 14px;color:#475569;font-size:12px">${esc(who)}</td>
          <td style="padding:9px 14px;color:#0B2545;max-width:420px">${what}</td>
          <td style="padding:9px 14px">${stat}</td>
        </tr>`;
      }).join("") + `</tbody></table>
      <div style="padding:10px 14px;color:#94A3B8;font-size:11px">${rows.length} record${rows.length===1?'':'s'} · WhatsApp replies sync daily (9am) · email replies to admin@lifa.com.my sync daily</div>`;
  }catch(e){ box.innerHTML='<div style="padding:24px;color:#B91C1C">Could not load: '+e.message+'</div>'; }
}

let _errorLogFilter = { severity: "error", since: 7, view: "grouped" }; // grouped | flat
async function renderErrorLog() {
  const main = document.getElementById("main-content");
  const sinceTs = Math.floor(Date.now()/1000) - (_errorLogFilter.since * 86400);
  main.innerHTML = `
    <div style="padding:24px">
      <div style="display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:16px;flex-wrap:wrap;gap:12px">
        <div>
          <h2 style="font-family:Cormorant Garamond,serif;font-size:28px">Error Log</h2>
          <p style="color:#6B7280;font-size:13px">Frontend + API errors across all candidates. Use this to spot active bugs blocking submissions.</p>
        </div>
        <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">
          <label style="font-size:12px;color:#6B7280">Severity</label>
          <select id="el-severity" style="padding:6px 10px;border:1px solid #e2e8f0;border-radius:6px;font:inherit;font-size:13px">
            <option value="error" ${_errorLogFilter.severity==='error'?'selected':''}>Errors only</option>
            <option value="warning" ${_errorLogFilter.severity==='warning'?'selected':''}>Warnings only</option>
            <option value="" ${_errorLogFilter.severity===''?'selected':''}>All events</option>
          </select>
          <label style="font-size:12px;color:#6B7280">Since</label>
          <select id="el-since" style="padding:6px 10px;border:1px solid #e2e8f0;border-radius:6px;font:inherit;font-size:13px">
            <option value="1" ${_errorLogFilter.since===1?'selected':''}>Last 24h</option>
            <option value="3" ${_errorLogFilter.since===3?'selected':''}>Last 3 days</option>
            <option value="7" ${_errorLogFilter.since===7?'selected':''}>Last 7 days</option>
            <option value="30" ${_errorLogFilter.since===30?'selected':''}>Last 30 days</option>
            <option value="0" ${_errorLogFilter.since===0?'selected':''}>All time</option>
          </select>
          <label style="font-size:12px;color:#6B7280">View</label>
          <select id="el-view" style="padding:6px 10px;border:1px solid #e2e8f0;border-radius:6px;font:inherit;font-size:13px">
            <option value="grouped" ${_errorLogFilter.view==='grouped'?'selected':''}>Grouped</option>
            <option value="flat" ${_errorLogFilter.view==='flat'?'selected':''}>Flat (every row)</option>
          </select>
          <button id="el-refresh" style="padding:6px 12px;border:1px solid #cbd5e1;background:#fff;border-radius:6px;cursor:pointer;font:inherit;font-size:13px">↻ Refresh</button>
        </div>
      </div>
      <div id="el-body" style="background:#fff;border-radius:12px;box-shadow:0 4px 24px rgba(11,37,69,.06);overflow:hidden">
        <p style="padding:32px;text-align:center;color:#9CA3AF">Loading…</p>
      </div>
    </div>`;
  document.getElementById("el-severity").addEventListener("change", e => { _errorLogFilter.severity = e.target.value; renderErrorLog(); });
  document.getElementById("el-since").addEventListener("change", e => { _errorLogFilter.since = Number(e.target.value); renderErrorLog(); });
  document.getElementById("el-view").addEventListener("change", e => { _errorLogFilter.view = e.target.value; renderErrorLog(); });
  document.getElementById("el-refresh").addEventListener("click", renderErrorLog);

  let res;
  try {
    const qs = [];
    if (_errorLogFilter.severity) qs.push("severity=" + encodeURIComponent(_errorLogFilter.severity));
    if (_errorLogFilter.since > 0) qs.push("since=" + sinceTs);
    qs.push("limit=500");
    res = await applyGet("/api/apply/admin/events?" + qs.join("&"));
    if (res.error) throw new Error(res.error);
  } catch (e) {
    document.getElementById("el-body").innerHTML = `<div style="padding:24px;color:#991B1B">Failed to load: ${escapeHtml(e.message)}</div>`;
    return;
  }
  const events = res.events || [];
  const fmt = ts => new Date(ts*1000).toLocaleString();
  const sevPill = sev => {
    const c = sev === 'error' ? '#991B1B' : sev === 'warning' ? '#92400E' : '#374151';
    const bg = sev === 'error' ? '#FEE2E2' : sev === 'warning' ? '#FEF3C7' : '#F1F5F9';
    return `<span style="background:${bg};color:${c};padding:2px 8px;border-radius:10px;font-size:11px;font-weight:600;white-space:nowrap">${sev || 'info'}</span>`;
  };
  const eventRow = ev => `
    <tr class="el-row" data-app-id="${ev.application_id || ''}" style="border-top:1px solid #F1F5F9;cursor:${ev.application_id?'pointer':'default'}" onmouseover="if(this.dataset.appId) this.style.background='#FAFAF7'" onmouseout="this.style.background=''">
      <td style="padding:10px 12px;color:#6B7280;font-family:monospace;white-space:nowrap;font-size:12px">${fmt(ev.ts)}</td>
      <td style="padding:10px 12px">${sevPill(ev.severity)}</td>
      <td style="padding:10px 12px;font-size:13px;color:#374151">${escapeHtml(ev.step || '—')}${ev.q_index != null ? ` · Q${ev.q_index}` : ''}</td>
      <td style="padding:10px 12px;font-size:13px">
        <div style="font-weight:500;color:#0B2545">${escapeHtml(ev.name || '(no candidate)')}</div>
        <div style="font-size:11px;color:#9CA3AF">${escapeHtml(ev.email || '')}</div>
      </td>
      <td style="padding:10px 12px;font-size:13px;color:#374151;font-family:monospace;white-space:nowrap">${escapeHtml(ev.phone || '—')}</td>
      <td style="padding:10px 12px;font-size:12px;color:#6B7280">${escapeHtml(ev.message || '')}</td>
      <td style="padding:10px 12px;font-family:monospace;font-size:11px;color:#9CA3AF;white-space:nowrap">${escapeHtml((ev.application_id || '').slice(-8))}</td>
    </tr>`;
  const tableHead = `
    <tr style="background:#F1F5F9;text-align:left;font-size:11px;letter-spacing:.06em;text-transform:uppercase;color:#6B7280">
      <th style="padding:10px 12px">When</th>
      <th style="padding:10px 12px">Sev</th>
      <th style="padding:10px 12px">Step</th>
      <th style="padding:10px 12px">Candidate</th>
      <th style="padding:10px 12px">Phone</th>
      <th style="padding:10px 12px">Message</th>
      <th style="padding:10px 12px">App ID</th>
    </tr>`;

  let body;
  if (_errorLogFilter.view === "flat") {
    body = events.length === 0
      ? '<p style="padding:48px;text-align:center;color:#9CA3AF">No events in this window. 🎉</p>'
      : `<table style="width:100%;border-collapse:collapse"><thead>${tableHead}</thead>
          <tbody>${events.map(eventRow).join("")}</tbody></table>`;
  } else {
    // Grouped — split into app sections so errors from different apps don't mix.
    // App source is inferred from event_type + message pattern:
    //   • analysis_failed / cron: ... → Apply Worker (background job)
    //   • api_error with /api/apply/... → Apply Flow (candidate frontend)
    //   • paste_detected / network_error → Apply Flow (candidate frontend)
    //   • unhandled_rejection / client_error with jQuery / portal UI tokens → Admin Portal
    function _errorAppSource(ev) {
      const msg = (ev.message || "").toLowerCase();
      const type = (ev.event_type || "").toLowerCase();
      if (type === "analysis_failed" || msg.startsWith("cron:")) return "worker";
      if (type === "api_error" && msg.includes("/api/apply/")) return "apply";
      if (type === "paste_detected" || type === "network_error") return "apply";
      if (type === "api_error") return "apply";
      return "portal"; // unhandled_rejection / client_error
    }
    // Plain-English explanation for known error patterns.
    function _errorPlain(g) {
      const msg = g.message || "";
      const type = g.type || "";
      if (msg.includes("stage1/complete") || msg.includes("assessment/submit")) {
        return "Candidate submitted but their phone dropped the connection, so the app retried. First submit worked fine — this retry was rejected to prevent double-processing. No action needed.";
      }
      if (msg.includes("ANTHROPIC_API_KEY not set") || msg.includes("API_KEY not set")) {
        return "🔴 CRITICAL: The AI analysis key is missing from the apply worker. Candidates who finish their interview are NOT being scored — they are stuck. Fix: add ANTHROPIC_API_KEY to the apply worker Wrangler secrets.";
      }
      if (type === "paste_detected") {
        return "The system detected a candidate copy-pasted a large block of text into their written answer instead of typing. Flagged for recruiter review — not a technical crash.";
      }
      if (type === "network_error") {
        return "Candidate lost their internet connection mid-interview. Their progress is saved on-device and resumes when they reconnect.";
      }
      if (type === "analysis_failed") {
        return "The AI scoring job failed after this candidate submitted. Their application may be stuck at 'pending analysis'. Check if the API key or analysis service is down.";
      }
      if (msg.includes("null is not an object") || msg.includes("undefined is not an object")) {
        return "A UI element was missing from the page when a script tried to update it. Likely a timing issue on page load — usually harmless.";
      }
      return null;
    }

    const groups = {};
    for (const ev of events) {
      const k = (ev.event_type || "?") + "|" + (ev.message || "").slice(0, 120);
      if (!groups[k]) groups[k] = { type: ev.event_type, message: ev.message, count: 0, first: ev.ts, last: ev.ts, examples: [], affected: new Set(), app: _errorAppSource(ev) };
      groups[k].count++;
      groups[k].first = Math.min(groups[k].first, ev.ts);
      groups[k].last  = Math.max(groups[k].last,  ev.ts);
      if (ev.application_id) groups[k].affected.add(ev.application_id);
      if (groups[k].examples.length < 8) groups[k].examples.push(ev);
    }
    const allGroups = Object.values(groups).sort((a, b) => b.last - a.last);

    const APP_SECTIONS = [
      { key: "apply",  label: "Apply Flow",   url: "apply.lifa.com.my",   desc: "Errors from candidates doing the interview (videos, written tasks, assessments).", color: "#1D4ED8" },
      { key: "worker", label: "Apply Worker", url: "apply worker (background jobs)", desc: "Errors from automated background tasks — scoring, analysis, reminders.", color: "#7C3AED" },
      { key: "portal", label: "Admin Portal", url: "portal.lifa.com.my",  desc: "Errors that happened while you or an admin were using this portal.", color: "#065F46" },
    ];

    const renderGroup = g => {
      const plain = _errorPlain(g);
      const isCritical = plain && plain.startsWith("🔴");
      return `
        <details style="border-bottom:1px solid #F1F5F9${isCritical ? ';background:#FFF5F5' : ''}">
          <summary style="padding:14px 18px;cursor:pointer;display:flex;justify-content:space-between;align-items:center;gap:12px">
            <div style="flex:1;min-width:0">
              <div style="font-family:monospace;font-size:12px;color:${isCritical ? '#991B1B' : '#374151'};white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${escapeHtml(g.message || '(no message)')}</div>
              <div style="font-size:11px;color:#9CA3AF;margin-top:2px">${escapeHtml(g.type || '?')} · ${g.affected.size} candidate${g.affected.size===1?'':'s'} · first ${fmt(g.first)} · last ${fmt(g.last)}</div>
              ${plain ? `<div style="font-size:11px;color:${isCritical ? '#991B1B' : '#4B5563'};margin-top:4px;font-style:italic;white-space:normal">${escapeHtml(plain)}</div>` : ''}
            </div>
            <div style="font-size:13px;font-weight:600;color:${g.count >= 10 ? '#991B1B' : g.count >= 3 ? '#92400E' : '#374151'};white-space:nowrap">×${g.count}</div>
          </summary>
          <div style="background:#FAFAF7;padding:6px 0">
            <table style="width:100%;border-collapse:collapse"><thead>${tableHead}</thead>
              <tbody>${g.examples.map(eventRow).join("")}</tbody>
            </table>
            ${g.count > g.examples.length ? `<div style="padding:8px 18px;color:#9CA3AF;font-size:12px;font-style:italic">… ${g.count - g.examples.length} more (switch to Flat view to see all)</div>` : ''}
          </div>
        </details>`;
    };

    if (allGroups.length === 0) {
      body = '<p style="padding:48px;text-align:center;color:#9CA3AF">No events in this window. 🎉</p>';
    } else {
      const sectionHtmls = APP_SECTIONS.map(sec => {
        const secGroups = allGroups.filter(g => g.app === sec.key);
        if (!secGroups.length) return '';
        return `
          <div style="margin-bottom:4px">
            <div style="padding:12px 18px;background:#F8FAFC;border-bottom:2px solid ${sec.color};display:flex;align-items:center;justify-content:space-between;gap:12px">
              <div>
                <span style="font-size:13px;font-weight:700;color:${sec.color}">${sec.label}</span>
                <span style="font-size:11px;color:#6B7280;margin-left:8px">${sec.url}</span>
                <div style="font-size:11px;color:#9CA3AF;margin-top:2px">${sec.desc}</div>
              </div>
              <span style="font-size:12px;font-weight:600;color:#6B7280;white-space:nowrap">${secGroups.length} group${secGroups.length===1?'':'s'}</span>
            </div>
            ${secGroups.map(renderGroup).join("")}
          </div>`;
      }).join("");

      // AdvisorFit link — separate system, errors tracked at advisorfit.lifa.com.my
      const advisorfitLink = `
        <div style="margin-top:4px;border-top:2px solid #C9A84C;background:#FFFBF0">
          <div style="padding:12px 18px;display:flex;align-items:center;justify-content:space-between;gap:12px">
            <div>
              <span style="font-size:13px;font-weight:700;color:#92400E">AdvisorFit</span>
              <span style="font-size:11px;color:#6B7280;margin-left:8px">advisorfit.lifa.com.my</span>
              <div style="font-size:11px;color:#9CA3AF;margin-top:2px">Errors from the WealthAdvisor assessment app — stored in a separate system.</div>
            </div>
            <a href="https://advisorfit.lifa.com.my/admin/errors" target="_blank"
               style="padding:6px 14px;background:#0D1B2A;color:#C9A84C;border-radius:6px;font-size:12px;font-weight:600;text-decoration:none;white-space:nowrap">
              View AdvisorFit Errors →
            </a>
          </div>
        </div>`;

      body = `<div>${sectionHtmls}${advisorfitLink}</div>`;
    }
  }

  document.getElementById("el-body").innerHTML = `
    <div style="padding:14px 18px;border-bottom:1px solid #E5E7EB;display:flex;justify-content:space-between;align-items:center;background:#FAFAF7;flex-wrap:wrap;gap:8px">
      <div style="font-size:13px;color:#374151"><b>${events.length}</b> events</div>
      <div style="font-size:12px;color:#6B7280">Click a row to open the candidate</div>
    </div>
    ${body}`;
  document.querySelectorAll(".el-row").forEach(r => r.addEventListener("click", () => {
    if (r.dataset.appId) renderApplicationDetail(r.dataset.appId);
  }));
}

// ─── Reminder utility (WhatsApp + Email) ────────────────────────────────────
const APPLY_INCOMPLETE_STATUSES = new Set([
  "registered","consent","particulars_done","stage2_done","assessment_done","stage1_done"
]);
const APPLY_ROLE_LABEL_FOR_MSG = { admin_executive: "Admin Executive", wealth_advisor: "Wealth Advisor" };

function _toIntlPhone(phone) {
  const digits = String(phone || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("60")) return digits;
  if (digits.startsWith("0"))  return "6" + digits;
  return digits;
}
function _reminderMessage(row) {
  const name = (row.name || "").trim() || "there";
  const email = row.email || "";
  const role = APPLY_ROLE_LABEL_FOR_MSG[row.role] || "the role you applied for";
  return `Hi ${name}, this is a reminder from LIFA Planners — your application for ${role} is still incomplete. We've fixed the submission issues reported earlier, so please log back in at https://apply.lifa.com.my using the same email (${email}) to continue or restart cleanly. If you face any issue, just reply to this message and we'll help straight away. Thanks!

Salam ${name}, ini peringatan daripada LIFA Planners — permohonan anda untuk ${role} belum selesai. Isu submission yang dilaporkan dah dibetulkan, sila log masuk semula di https://apply.lifa.com.my guna email yang sama (${email}). Kalau ada apa-apa masalah, sila reply mesej ini dan kami akan tolong segera. Terima kasih.`;
}
function _emailSubject() { return "LIFA Planners — please complete your application"; }
function _waUrl(row) {
  const phone = _toIntlPhone(row.phone);
  if (!phone) return null;
  return `https://wa.me/${phone}?text=${encodeURIComponent(_reminderMessage(row))}`;
}
function _mailUrl(row) {
  if (!row.email) return null;
  return `mailto:${encodeURIComponent(row.email)}?subject=${encodeURIComponent(_emailSubject())}&body=${encodeURIComponent(_reminderMessage(row))}`;
}
function _logReminder(row, channel) {
  // Persist a small local audit trail of who got pinged. Stored in localStorage so any admin
  // on this browser sees who was already reminded today (stops accidental double-spamming).
  try {
    const KEY = "lifa-reminder-log";
    const log = JSON.parse(localStorage.getItem(KEY) || "{}");
    log[row.id] = { ts: Date.now(), channel, name: row.name };
    localStorage.setItem(KEY, JSON.stringify(log));
  } catch {}
}
function _relTime(ts) {
  if (!ts) return '';
  const sec = Math.floor((Date.now()/1000) - ts);
  if (sec < 60) return 'just now';
  if (sec < 3600) return Math.floor(sec/60) + 'm ago';
  if (sec < 86400) return Math.floor(sec/3600) + 'h ago';
  const days = Math.floor(sec/86400);
  if (days < 30) return days + 'd ago';
  return new Date(ts*1000).toLocaleDateString();
}
function _wasRecentlyReminded(id) {
  try {
    const log = JSON.parse(localStorage.getItem("lifa-reminder-log") || "{}");
    const entry = log[id];
    if (!entry) return null;
    const hoursAgo = (Date.now() - entry.ts) / 3600000;
    return hoursAgo < 48 ? entry : null;
  } catch { return null; }
}
async function sendReminderForRow(row, opts) {
  opts = opts || {};
  // Default to "email" — WhatsApp is on hold until a dedicated SIM is provisioned.
  // Pass channel: "whatsapp" or "both" explicitly when the WhatsApp deep-link is wanted.
  const channel = opts.channel || "email";
  // Try direct send via worker (Twilio WhatsApp + SendGrid email). Falls back to opening
  // wa.me / mailto: tabs in the admin's own browser if the backend reports "not configured".
  try {
    const res = await applyPost(`/api/apply/admin/applications/${encodeURIComponent(row.id)}/send-reminder`, { channel });
    if (res && res.error) throw new Error(res.error);
    const parts = [];
    if (res.whatsapp) {
      if (res.whatsapp.ok) parts.push("WhatsApp ✓");
      else if (res.whatsapp.configured === false) parts.push("WhatsApp (not configured — opening wa.me)");
      else parts.push(`WhatsApp ✗ ${res.whatsapp.error || ''}`);
    }
    if (res.email) {
      if (res.email.ok) parts.push("Email ✓");
      else if (res.email.configured === false) parts.push("Email (not configured — opening mailto)");
      else parts.push(`Email ✗ ${res.email.error || ''}`);
    }
    // Fallback to deep-links for any unconfigured channel
    let fallbackOpened = false;
    if (res.whatsapp && res.whatsapp.configured === false) {
      const wa = _waUrl(row); if (wa) { window.open(wa, "_blank", "noopener"); fallbackOpened = true; }
    }
    if (res.email && res.email.configured === false) {
      const mail = _mailUrl(row); if (mail) { window.open(mail, "_blank", "noopener"); fallbackOpened = true; }
    }
    _logReminder(row, channel);
    const sentDirect = (res.whatsapp && res.whatsapp.ok) || (res.email && res.email.ok);
    showToast(sentDirect || fallbackOpened ? "success" : "error", `${row.name}: ${parts.join(", ")}`);
  } catch (e) {
    // API itself failed — fall back to deep-link tabs.
    const wa = _waUrl(row), mail = _mailUrl(row);
    if (!wa && !mail) { showToast("error", "No phone or email on file"); return; }
    if (wa)   { window.open(wa,   "_blank", "noopener"); }
    if (mail) { window.open(mail, "_blank", "noopener"); }
    _logReminder(row, channel);
    showToast("error", `Backend send failed — opened reminder tabs for ${row.name}`);
  }
}
async function remindAllIncomplete(rows) {
  const incomplete = rows.filter(r => APPLY_INCOMPLETE_STATUSES.has(r.status));
  const alreadyWa = incomplete.filter(r => r.last_wa_pinged_at);
  // Default-skip anyone emailed in the last 48h
  const FORTY_EIGHT_H = 48 * 3600;
  const nowSec = Math.floor(Date.now()/1000);
  const recentlyEmailed = incomplete.filter(r => r.last_email_pinged_at && (nowSec - r.last_email_pinged_at) < FORTY_EIGHT_H);
  const eligible = incomplete.filter(r => !r.last_wa_pinged_at && r.email && !(r.last_email_pinged_at && (nowSec - r.last_email_pinged_at) < FORTY_EIGHT_H));
  if (!eligible.length) {
    const reasons = [];
    if (alreadyWa.length) reasons.push(`${alreadyWa.length} marked WA-pinged`);
    if (recentlyEmailed.length) reasons.push(`${recentlyEmailed.length} emailed within last 48h`);
    showToast("warn", "No eligible candidates" + (reasons.length ? ` — ${reasons.join(', ')}` : '.'));
    return;
  }
  await openReminderPreviewModal(eligible, alreadyWa.length, recentlyEmailed.length);
}

// Preview + confirm modal: shows the full rendered email for the first eligible candidate
// (substitutions resolved by the worker), the recipient checklist, and a single Send button.
async function openReminderPreviewModal(targets, skippedWa, skippedRecentEmail) {
  // Pull preview for the FIRST candidate as the visual sample
  let preview;
  try {
    preview = await applyGet(`/api/apply/admin/applications/${encodeURIComponent(targets[0].id)}/reminder-preview`);
    if (preview.error) throw new Error(preview.error);
  } catch (e) { showToast("error", "Couldn't load preview: " + e.message); return; }

  const overlay = document.createElement('div');
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(11,37,69,.45);z-index:99998;display:flex;align-items:flex-start;justify-content:center;overflow:auto;padding:32px';
  overlay.innerHTML = `
    <div style="background:#fff;border-radius:14px;width:100%;max-width:1080px;max-height:calc(100vh - 64px);display:flex;flex-direction:column;box-shadow:0 12px 60px rgba(11,37,69,.3);overflow:hidden">
      <div style="padding:18px 24px;border-bottom:1px solid #E5E7EB;display:flex;justify-content:space-between;align-items:center;background:#FAFAF7">
        <div>
          <div style="font-family:Cormorant Garamond,serif;font-size:22px;color:#0B2545">Send email reminder</div>
          <div style="font-size:12px;color:#6B7280;margin-top:2px">From <b>${escapeHtml(preview.from_name)} &lt;${escapeHtml(preview.from_email)}&gt;</b> · Subject: ${escapeHtml(preview.subject)}</div>
        </div>
        <button id="rmd-close" style="border:none;background:transparent;font-size:22px;cursor:pointer;color:#6B7280;padding:4px 10px">×</button>
      </div>
      <div style="display:flex;flex:1;min-height:0">
        <div style="width:340px;border-right:1px solid #E5E7EB;display:flex;flex-direction:column;min-height:0">
          <div style="padding:14px 18px;border-bottom:1px solid #E5E7EB;background:#fff">
            <div style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6B7280;font-weight:600;margin-bottom:6px">Recipients · ${targets.length} candidate${targets.length===1?'':'s'}</div>
            <label style="display:flex;align-items:center;gap:6px;font-size:12px;color:#374151;cursor:pointer;user-select:none">
              <input type="checkbox" id="rmd-all" checked style="margin:0"> Select all
            </label>
            ${(skippedWa || skippedRecentEmail) ? `<div style="font-size:11px;color:#92400E;margin-top:6px;line-height:1.5">${[skippedWa ? `Skipping ${skippedWa} already WA-pinged` : '', skippedRecentEmail ? `Skipping ${skippedRecentEmail} emailed in last 48h` : ''].filter(Boolean).join(' · ')}</div>` : ''}
          </div>
          <div id="rmd-list" style="flex:1;overflow-y:auto;padding:8px 0">
            ${targets.map((r, i) => `
              <label data-app-id="${r.id}" style="display:flex;align-items:flex-start;gap:8px;padding:8px 18px;font-size:13px;cursor:pointer;border-bottom:1px solid #F1F5F9">
                <input type="checkbox" class="rmd-pick" data-i="${i}" checked style="margin:3px 0 0">
                <div style="flex:1;min-width:0">
                  <div style="font-weight:500;color:#0B2545;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${escapeHtml(r.name || '(no name)')}</div>
                  <div style="font-size:11px;color:#6B7280;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${escapeHtml(r.email || '')}</div>
                  <div style="font-size:11px;color:#9CA3AF">${escapeHtml(r.status || '')}</div>
                </div>
              </label>`).join('')}
          </div>
        </div>
        <div style="flex:1;display:flex;flex-direction:column;min-width:0">
          <div style="padding:10px 16px;background:#F1F5F9;border-bottom:1px solid #E5E7EB;font-size:11px;color:#6B7280;letter-spacing:.06em;text-transform:uppercase;font-weight:600">Preview · rendered for ${escapeHtml(preview.candidate.name || preview.candidate.id)}</div>
          <iframe id="rmd-iframe" style="flex:1;border:none;background:#FAFAF7" sandbox=""></iframe>
        </div>
      </div>
      <div style="padding:14px 24px;border-top:1px solid #E5E7EB;display:flex;justify-content:space-between;align-items:center;background:#FAFAF7;gap:12px;flex-wrap:wrap">
        <div id="rmd-status" style="font-size:13px;color:#6B7280">Ready to send</div>
        <div style="display:flex;gap:10px">
          <button id="rmd-cancel" style="background:#fff;color:#374151;border:1px solid #cbd5e1;padding:9px 18px;border-radius:8px;cursor:pointer;font:inherit;font-size:14px">Cancel</button>
          <button id="rmd-send" style="background:#0B2545;color:#fff;border:none;padding:9px 22px;border-radius:8px;cursor:pointer;font:inherit;font-size:14px;font-weight:500">Send to <span id="rmd-count">${targets.length}</span></button>
        </div>
      </div>
    </div>`;
  document.body.appendChild(overlay);
  const iframe = overlay.querySelector('#rmd-iframe');
  iframe.srcdoc = preview.html;

  const close = () => overlay.remove();
  overlay.querySelector('#rmd-close').addEventListener('click', close);
  overlay.querySelector('#rmd-cancel').addEventListener('click', close);
  overlay.addEventListener('click', e => { if (e.target === overlay) close(); });

  const updateCount = () => {
    const n = overlay.querySelectorAll('.rmd-pick:checked').length;
    overlay.querySelector('#rmd-count').textContent = n;
    overlay.querySelector('#rmd-send').disabled = n === 0;
  };
  overlay.querySelector('#rmd-all').addEventListener('change', e => {
    overlay.querySelectorAll('.rmd-pick').forEach(c => c.checked = e.target.checked);
    updateCount();
  });
  overlay.querySelectorAll('.rmd-pick').forEach(c => c.addEventListener('change', updateCount));

  overlay.querySelector('#rmd-send').addEventListener('click', async () => {
    const picked = Array.from(overlay.querySelectorAll('.rmd-pick'))
      .filter(c => c.checked)
      .map(c => targets[Number(c.dataset.i)]);
    if (!picked.length) return;
    const sendBtn = overlay.querySelector('#rmd-send');
    const status = overlay.querySelector('#rmd-status');
    sendBtn.disabled = true; sendBtn.textContent = 'Sending…';
    let ok = 0, fail = 0;
    for (let i = 0; i < picked.length; i++) {
      const r = picked[i];
      status.textContent = `Sending ${i+1}/${picked.length} — ${r.name}…`;
      try {
        const res = await applyPost(`/api/apply/admin/applications/${encodeURIComponent(r.id)}/send-reminder`, { channel: "email" });
        if (res?.email?.ok) { ok++; _logReminder(r, "email"); }
        else { fail++; console.warn('email failed for', r.id, res?.email); }
      } catch (e) { fail++; console.warn(e); }
      await new Promise(res => setTimeout(res, 250));
    }
    status.innerHTML = `<b>Done.</b> Sent <b style="color:#166534">${ok}</b>${fail ? ` · failed <b style="color:#991B1B">${fail}</b> (see Error Log)` : ''}`;
    sendBtn.textContent = 'Close'; sendBtn.disabled = false;
    sendBtn.onclick = () => { close(); renderApplicationsList(); };
  });
}

// ── Applications: BG Check + Interview cards ──────────────────────────────────
// Design approved by the owner 2 Nov 2026 ("approve") from the working mock
// https://claude.ai/artifact/1mJhdoQWdXEpfq1NSd1ZZL : one forward action + one Reject per
// card, reasons per stage, inline note (no pop-ups), Undo for 6 s, side panel on click.
// Reasons — BG Check: owner 2 Nov 2026 "either fail bg and explain why / cannot reach and ask
// for new reference but no reply". Interview: owner 2 Nov 2026 "no show, other job offer, fail interview etc".
const APL_REASONS = {
  bg_check: [
    {code:'fail_background_check', label:'Failed background check', must:true,  hint:'Explain why (required)'},
    {code:'bg_no_reply',           label:'Cannot reach — asked for new references, no reply', must:false, hint:'Note (optional)'}
  ],
  interview: [
    {code:'no_show', label:'No show'}, {code:'other_job_offer', label:'Other job offer'},
    {code:'fail_interview', label:'Fail interview'}, {code:'other', label:'Other'}
  ]
};
let _aplAsk = null;      // {id, act:'go'|'stop'} — the card whose confirm panel is open
let _aplPending = null;  // {id, timer} — a decision waiting out its Undo window
const _aplRows = {};     // id -> row, for the side panel

function _aplWaiting(r){
  return r.ref_result === 'uncontactable' && ['awaiting_new_references','pending_candidate_ref','new_refs_submitted'].includes(r.bg_check_status);
}
// The forward action for this card: BG Check → Move to Interview; Interview → Approve slot
// while a slot waits for approval, otherwise Hire (labels from the portal and the mock).
function _aplGo(r, stage){
  if (stage === 'bg_check') return {label:'Move to Interview', done:'moved to Interview',
    run: note => applyPost(`/api/apply/admin/applications/${encodeURIComponent(r.id)}/reference-check`, {result:'pass', remark: note || ''})};
  if ((r.interview_appointment_status || '') === 'requested') return {label:'Approve slot', done:'slot approved',
    run: () => applyPost(`/api/apply/admin/applications/${encodeURIComponent(r.id)}/appointment`, {action:'confirm'})};
  return {label:'Hire', done:'hired',
    run: note => applyPut(`/api/apply/admin/applications/${encodeURIComponent(r.id)}/status`, {status:'hired', admin_remark: note || undefined})};
}
function _aplWho(r, stage, needsYou){
  if (stage === 'bg_check') return _aplWaiting(r) ? ['wait','Waiting on candidate'] : ['stop','Needs you'];
  return needsYou ? ['stop','Needs you'] : ['wait','Waiting on candidate'];
}
function _aplDays(r){
  const t = r.updated_at || r.created_at; if (!t) return '';
  const d = Math.max(0, Math.floor((Date.now()/1000 - t) / 86400));
  return d === 0 ? 'today' : d + (d === 1 ? ' day' : ' days') + ' in stage';
}
function _aplCss(){
  if (document.getElementById('apl-css')) return;
  const s = document.createElement('style'); s.id = 'apl-css';
  s.textContent = `
  .apl-card{background:#fff;border:1px solid #E4E1D8;border-radius:14px;margin:0 0 10px;padding:14px 16px;display:grid;grid-template-columns:44px minmax(0,1fr) auto;gap:4px 14px;align-items:center;cursor:pointer;transition:opacity .25s,transform .2s}
  .apl-card:hover{border-color:#C9CFDA} .apl-card.apl-gone{opacity:0;transform:translateX(24px);pointer-events:none}
  .apl-av{width:44px;height:44px;border-radius:50%;background:#EEF1F6;color:#0B2545;display:grid;place-items:center;font-weight:700;grid-row:span 2}
  .apl-name{font-weight:600;font-size:15px;color:#16233A;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
  .apl-contact{color:#5E6A7D;font-size:13px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
  .apl-st{grid-column:2;display:flex;flex-wrap:wrap;gap:8px;align-items:center;margin-top:4px;font-size:13px;color:#16233A}
  .apl-pill{display:inline-flex;align-items:center;gap:6px;border-radius:999px;padding:3px 10px;font-weight:600;font-size:12.5px}
  .apl-pill::before{content:"";width:7px;height:7px;border-radius:50%;background:currentColor}
  .apl-pill.wait{background:#FBF1DC;color:#8A5A00} .apl-pill.stop{background:#FBECEC;color:#A32222}
  .apl-since{color:#5E6A7D}
  .apl-acts{grid-column:3;grid-row:1 / span 2;display:flex;gap:8px}
  .apl-btn{font:inherit;font-size:14px;font-weight:600;border-radius:10px;padding:9px 16px;min-height:42px;cursor:pointer;border:1px solid transparent;white-space:nowrap}
  .apl-btn.go{background:#17703C;color:#fff} .apl-btn.stop{background:#fff;color:#A32222;border-color:#E6A5A5} .apl-btn.ghost{background:#fff;color:#5E6A7D;border-color:#E4E1D8}
  .apl-confirm{grid-column:1 / -1;display:flex;flex-wrap:wrap;gap:10px;align-items:center;margin-top:10px;padding-top:12px;border-top:1px dashed #E4E1D8;cursor:default}
  .apl-reasons{display:flex;flex-wrap:wrap;gap:6px;width:100%}
  .apl-rsn{display:inline-flex;align-items:center;gap:6px;font-size:13px;border:1px solid #E4E1D8;border-radius:999px;padding:6px 12px;cursor:pointer;color:#16233A}
  .apl-rsn:has(input:checked){border-color:#A32222;background:#FBECEC;color:#A32222;font-weight:600}
  .apl-rsn input{margin:0;accent-color:#A32222}
  .apl-lbl{width:100%;font-size:13px;color:#5E6A7D} .apl-mail{display:flex;align-items:center;gap:8px;width:100%;font-size:14px;color:#16233A}
  .apl-note{flex:1 1 260px;min-width:0;font:inherit;font-size:14px;border:1px solid #E4E1D8;border-radius:10px;padding:10px 12px;min-height:42px}
  .apl-err{width:100%;font-size:13px;color:#A32222}
  .apl-toast{position:fixed;left:50%;bottom:calc(20px + env(safe-area-inset-bottom,0px));transform:translate(-50%,140%);background:#0B2545;color:#fff;border-radius:12px;padding:12px 14px 12px 18px;display:flex;gap:14px;align-items:center;font-size:14px;box-shadow:0 10px 30px rgba(0,0,0,.25);transition:transform .25s;z-index:3000;max-width:calc(100% - 32px)}
  .apl-toast.show{transform:translate(-50%,0)} .apl-toast button{font:inherit;font-weight:700;background:none;border:0;color:#D4B45A;cursor:pointer;padding:6px 8px}
  .apl-scrim{position:fixed;inset:0;background:rgba(8,16,30,.35);z-index:2000}
  .apl-drawer{position:fixed;top:0;right:0;bottom:0;width:min(440px,100%);background:#fff;border-left:1px solid #E4E1D8;z-index:2001;display:flex;flex-direction:column}
  .apl-dh{padding:20px 22px 14px;border-bottom:1px solid #E4E1D8;display:flex;gap:12px;align-items:flex-start}
  .apl-dh h2{font-family:'Cormorant Garamond',Georgia,serif;font-size:26px;margin:0;color:#0B2545;line-height:1.1}
  .apl-x{margin-left:auto;font:inherit;font-size:22px;background:none;border:0;color:#5E6A7D;cursor:pointer;width:40px;height:40px;border-radius:10px}
  .apl-db{padding:18px 22px;overflow:auto;flex:1;display:flex;flex-direction:column;gap:16px;font-size:14px}
  .apl-kv{display:grid;grid-template-columns:100px minmax(0,1fr);gap:8px 12px} .apl-kv dt{color:#5E6A7D} .apl-kv dd{margin:0;overflow-wrap:anywhere}
  .apl-df{padding:14px 22px calc(14px + env(safe-area-inset-bottom,0px));border-top:1px solid #E4E1D8;display:flex;gap:10px;flex-wrap:wrap} .apl-df .apl-btn{flex:1}
  @media (max-width:640px){ .apl-card{grid-template-columns:44px minmax(0,1fr)} .apl-acts{grid-column:1 / -1;grid-row:auto;margin-top:10px} .apl-acts .apl-btn{flex:1} }`;
  document.head.appendChild(s);
}
function _aplCardHtml(r, stage, statusText, needsYou){
  _aplRows[r.id] = Object.assign({}, r, {_stage: stage, _status: statusText});
  const go = _aplGo(r, stage), [tone, who] = _aplWho(r, stage, needsYou);
  const first = escapeHtml(String(r.name || '').split(' ')[0]);
  const ask = _aplAsk && _aplAsk.id === r.id ? _aplAsk.act : null;
  const reasons = APL_REASONS[stage] || [];
  const firstHint = stage === 'bg_check' ? reasons[0].hint : 'Note (optional)';
  const panel = !ask ? '' : `<div class="apl-confirm" data-apl-panel="1">
      ${ask === 'stop' ? `<div class="apl-reasons" role="radiogroup" aria-label="Reason">${reasons.map((x,i) =>
        `<label class="apl-rsn"><input type="radio" name="apl-rs-${r.id}" value="${x.code}" data-must="${x.must?1:0}" data-hint="${x.hint||'Note (optional)'}" ${stage==='bg_check'&&i===0?'checked':''}> ${escapeHtml(x.label)}</label>`).join('')}</div>
        <label class="apl-mail"><input type="checkbox" id="apl-em-${r.id}"> Send rejection email to ${first}</label>` : ''}
      <label class="apl-lbl" for="apl-nt-${r.id}" id="apl-lb-${r.id}">${ask === 'go' ? escapeHtml(go.label) + ' — note (optional)' : firstHint}</label>
      <input class="apl-note" id="apl-nt-${r.id}" placeholder="${stage==='bg_check' ? 'Who you spoke to, what they said' : ''}">
      <button class="apl-btn ${ask}" data-apl="confirm" data-id="${r.id}">${ask === 'go' ? escapeHtml(go.label) : 'Reject'}</button>
      <button class="apl-btn ghost" data-apl="cancel" data-id="${r.id}">Cancel</button>
      <span class="apl-err" id="apl-er-${r.id}" hidden></span></div>`;
  return `<div class="apl-card apply-row" data-app-id="${r.id}" data-apl-card="1">
    <div class="apl-av" aria-hidden="true">${escapeHtml((r.name||'?').charAt(0).toUpperCase())}</div>
    <div class="apl-name">${escapeHtml(r.name)}</div>
    <div class="apl-contact">${escapeHtml(r.email || '')}${r.phone ? ' · ' + escapeHtml(r.phone) : ''}</div>
    <div class="apl-st"><span class="apl-pill ${tone}">${who}</span><span>${escapeHtml(statusText)}</span><span class="apl-since">· ${_aplDays(r)}</span></div>
    <div class="apl-acts"><button class="apl-btn go" data-apl="go" data-id="${r.id}">${escapeHtml(go.label)}</button><button class="apl-btn stop" data-apl="stop" data-id="${r.id}">Reject</button></div>
    ${panel}</div>`;
}
function _aplToast(msg, onUndo){
  let t = document.getElementById('apl-toast');
  if (!t) { t = document.createElement('div'); t.id = 'apl-toast'; t.className = 'apl-toast'; t.setAttribute('role','status'); document.body.appendChild(t); }
  t.innerHTML = `<span></span>${onUndo ? '<button type="button">Undo</button>' : ''}`;
  t.firstChild.textContent = msg;
  if (onUndo) t.querySelector('button').onclick = onUndo;
  t.classList.add('show'); clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('show'), 6000);
}
// Decide after a 6-second Undo window: nothing reaches the server (or the candidate) until it ends.
function _aplDecide(id, act, note, reason, email){
  const r = _aplRows[id]; if (!r) return;
  const first = String(r.name || '').split(' ')[0];
  const go = _aplGo(r, r._stage);
  const card = document.querySelector(`.apl-card[data-app-id="${CSS.escape(id)}"]`);
  if (card) card.classList.add('apl-gone');
  _aplAsk = null;
  const run = act === 'go' ? () => go.run(note)
    : () => applyPut(`/api/apply/admin/applications/${encodeURIComponent(id)}/status`, {status:'rejected', rejection_reason: reason, admin_remark: note || undefined, send_email: !!email});
  const msg = act === 'go' ? `${first} ${go.done}` : `${first} rejected · ${email ? 'email will be sent' : 'no email sent'}`;
  const timer = setTimeout(async () => {
    _aplPending = null;
    try { const res = await run(); if (res && res.error) throw new Error(res.error); }
    catch (e) { showToast('error', `${first}: ${e.message || 'could not save'}`); }
    renderApplicationsList();
  }, 6000);
  _aplPending = {id, timer};
  _aplToast(msg, () => { clearTimeout(timer); _aplPending = null; if (card) card.classList.remove('apl-gone'); _aplToast(`Undone — nothing was sent`); });
}
function _aplOpenDrawer(id){
  const r = _aplRows[id]; if (!r) return;
  _aplCloseDrawer();
  const go = _aplGo(r, r._stage);
  const steps = ['Applied','Form','Written interview','Practical assessment','BG Check','Interview','Decision'];
  const at = r._stage === 'bg_check' ? 4 : 5;
  const wrap = document.createElement('div'); wrap.id = 'apl-dwrap';
  wrap.innerHTML = `<div class="apl-scrim"></div><aside class="apl-drawer" aria-label="Candidate">
    <div class="apl-dh"><div><h2></h2><div style="color:#5E6A7D;font-size:13px;margin-top:4px">${escapeHtml(APPLY_ROLE_LABEL[r.role] || r.role || '')} · ${escapeHtml(r.id)}</div></div><button class="apl-x" aria-label="Close">×</button></div>
    <div class="apl-db">
      <div>${escapeHtml(r._status)} <span class="apl-since">· ${_aplDays(r)}</span></div>
      <dl class="apl-kv"><dt>Email</dt><dd>${escapeHtml(r.email||'')}</dd><dt>Phone</dt><dd>${escapeHtml(r.phone||'—')}</dd><dt>Applied</dt><dd>${r.created_at ? new Date(r.created_at*1000).toLocaleDateString('en-MY',{day:'numeric',month:'short',year:'numeric'}) : '—'}</dd>${r.admin_remark ? `<dt>Remark</dt><dd>${escapeHtml(r.admin_remark)}</dd>` : ''}</dl>
      <ol style="list-style:none;margin:0;padding:0">${steps.map((s,i) => `<li style="display:flex;gap:10px;padding:5px 0;color:${i<=at?'#16233A':'#9AA6B8'};font-weight:${i===at?600:400}"><span style="width:12px;height:12px;border-radius:50%;margin-top:4px;flex:none;border:2px solid ${i<at?'#17703C':i===at?'#B8962E':'#E4E1D8'};background:${i<at?'#17703C':i===at?'#B8962E':'transparent'}"></span>${s}</li>`).join('')}</ol>
      ${_aplWaiting(r) ? `<div style="color:#5E6A7D">The references could not be reached. The candidate was asked for 2 new ones and has not replied yet.</div>` : ''}
      <a href="#" id="apl-full" style="color:#0B2545;font-weight:600">Full details ›</a>
    </div>
    <div class="apl-df"><button class="apl-btn go" id="apl-dgo">${escapeHtml(go.label)}</button><button class="apl-btn stop" id="apl-dstop">Reject</button></div></aside>`;
  wrap.querySelector('h2').textContent = r.name;
  document.body.appendChild(wrap);
  wrap.querySelector('.apl-scrim').onclick = _aplCloseDrawer;
  wrap.querySelector('.apl-x').onclick = _aplCloseDrawer;
  wrap.querySelector('#apl-full').onclick = e => { e.preventDefault(); _aplCloseDrawer(); renderApplicationDetail(id); };
  wrap.querySelector('#apl-dgo').onclick = () => { _aplCloseDrawer(); _aplAsk = {id, act:'go'}; renderApplicationsList(false); };
  wrap.querySelector('#apl-dstop').onclick = () => { _aplCloseDrawer(); _aplAsk = {id, act:'stop'}; renderApplicationsList(false); };
}
function _aplCloseDrawer(){ const w = document.getElementById('apl-dwrap'); if (w) w.remove(); }
document.addEventListener('keydown', e => { if (e.key === 'Escape') _aplCloseDrawer(); });
// One click handler for every card on the list.
function _aplWire(main){
  _aplCss();
  if (main._aplWired) return;   // #main-content outlives each render — wire once
  main._aplWired = true;
  main.addEventListener('click', e => {
    const b = e.target.closest('[data-apl]');
    if (b) {
      e.stopPropagation();
      const id = b.dataset.id, a = b.dataset.apl;
      if (a === 'go' || a === 'stop') { _aplAsk = {id, act:a}; renderApplicationsList(false); setTimeout(() => { const n = document.getElementById('apl-nt-'+id); if (n) n.focus(); }, 60); return; }
      if (a === 'cancel') { _aplAsk = null; renderApplicationsList(false); return; }
      if (a === 'confirm') {
        const act = _aplAsk && _aplAsk.act, note = (document.getElementById('apl-nt-'+id) || {}).value || '';
        const er = document.getElementById('apl-er-'+id);
        const rs = document.querySelector(`input[name="apl-rs-${CSS.escape(id)}"]:checked`);
        if (act === 'stop' && !rs) { er.textContent = 'Pick a reason.'; er.hidden = false; return; }
        if (rs && rs.dataset.must === '1' && !note.trim()) { er.textContent = 'Say why the background check failed.'; er.hidden = false; document.getElementById('apl-nt-'+id).focus(); return; }
        _aplDecide(id, act, note.trim(), rs ? rs.value : '', (document.getElementById('apl-em-'+id) || {}).checked);
      }
      return;
    }
    const r = e.target.closest('input[type=radio][name^="apl-rs-"]');
    if (r) { const id = r.name.slice(7); const lb = document.getElementById('apl-lb-'+id); if (lb) lb.textContent = r.dataset.hint; const er = document.getElementById('apl-er-'+id); if (er) er.hidden = true; return; }
    if (e.target.closest('[data-apl-panel]')) { e.stopPropagation(); return; }
    const card = e.target.closest('[data-apl-card]');
    if (card) { e.stopPropagation(); _aplOpenDrawer(card.dataset.appId); }
  }, true);
}

async function renderApplicationsList(forceRefresh = true) {
  const main = document.getElementById("main-content");

  // Only fetch from server when: first load, tab/role change, or explicit refresh.
  // Search and filter-bucket changes reuse cached data so there's no API round-trip.
  if (forceRefresh || _cachedApplicationRows === null) {
    main.innerHTML = '<div style="padding:24px"><h2 style="font-family:Cormorant Garamond,serif;font-size:28px;margin-bottom:8px">Applications</h2><p style="color:#6B7280;margin-bottom:16px">Loading pipeline…</p></div>';
    try {
      const qs = [];
      if (_applyFilterRole) qs.push("role=" + encodeURIComponent(_applyFilterRole));
      const [appsRes, leadsRes] = await Promise.all([
        applyGet("/api/apply/admin/applications" + (qs.length ? "?" + qs.join("&") : "")),
        applyGet("/api/apply/admin/sourcing-leads"),
      ]);
      if (appsRes.error) throw new Error(appsRes.error);
      _cachedApplicationRows = (appsRes || []).filter(r => !/@example\.com$/i.test((r.email || '').trim()));
      const _allLeads = (Array.isArray(leadsRes) ? leadsRes : []).filter(l => !l.application_id);
      // Expired leads are not Leads: they leave the tab and every count, and
      // live in their own tab until restored (owner spec 2026-10-19).
      _cachedLeads        = _allLeads.filter(l => l.status !== 'expired');
      _cachedExpiredLeads = _allLeads.filter(l => l.status === 'expired');
    } catch (e) {
      main.innerHTML = '<div style="padding:24px"><div style="background:#FEE2E2;color:#991B1B;padding:12px 16px;border-radius:8px">Failed to load applications: ' + e.message + '</div></div>';
      return;
    }
  }

  const rows = _cachedApplicationRows;
  const leads = _cachedLeads;
  const allRows = rows.slice();

  // Stage counts for badges
  const counts = {
    needs_you:   allRows.filter(_applyNeedsYou).length,
    leads:       leads.length,
    expired:     (_cachedExpiredLeads || []).length,
    registered:  0, in_progress: 0, bg_check: 0, interview: 0, hired: 0, rejected: 0,
  };
  for (const r of allRows) { const s = _applyStageOf(r); if (counts[s] != null) counts[s]++; }

  // Determine which rows to show based on active bucket
  let displayRows   = [];
  let displayLeads  = [];
  let isLeadsTab    = false;
  let isExpiredTab  = false;

  if (_applyFilterBucket === 'needs_you') {
    displayRows = allRows.filter(_applyNeedsYou).sort((a, b) => {
      const rank = x => (x.interview_appointment_status === 'requested') ? 0 : (x.interview_appointment_status === 'attended') ? 1 : 2;
      return rank(a) - rank(b);
    });
  } else if (_applyFilterBucket === 'leads') {
    isLeadsTab   = true;
    displayLeads = leads;
  } else if (_applyFilterBucket === 'expired') {
    isLeadsTab   = true;
    isExpiredTab = true;
    displayLeads = _cachedExpiredLeads || [];
  } else if (APPLY_BUCKETS[_applyFilterBucket]) {
    displayRows = allRows.filter(r => _applyStageOf(r) === _applyFilterBucket);
    if (_applyFilterBucket === 'interview') {
      displayRows.sort((a, b) => (a.interview_appointment_at || 9e12) - (b.interview_appointment_at || 9e12));
    }
  } else {
    displayRows = allRows;
  }

  // Free-text search — when active, search ALL rows (including rejected/hired)
  // so any candidate is findable regardless of which tab is open.
  if (_applyFilterSearch) {
    const q = _applyFilterSearch.trim().toLowerCase();
    const qDigits = q.replace(/\D/g, '');
    if (isLeadsTab) {
      const _pool = isExpiredTab ? (_cachedExpiredLeads || []) : leads;
      displayLeads = _pool.filter(l => {
        return (l.name || '').toLowerCase().includes(q) || (l.email || '').toLowerCase().includes(q);
      });
    } else {
      displayRows = allRows.filter(r => {
        if ((r.name||'').toLowerCase().includes(q)) return true;
        if ((r.email||'').toLowerCase().includes(q)) return true;
        if ((r.id||'').toLowerCase().includes(q)) return true;
        if (qDigits && (r.phone||'').replace(/\D/g,'').includes(qDigits)) return true;
        return false;
      });
    }
  }

  const tab = (key, label, count) => `
    <button data-bucket="${key}" class="apply-tab" style="padding:7px 13px;border:none;background:${_applyFilterBucket===key?'#0B2545':'#F1F5F9'};color:${_applyFilterBucket===key?'#fff':'#374151'};border-radius:8px;cursor:pointer;font:inherit;font-size:13px;font-weight:500;white-space:nowrap">
      ${label}${count ? ` <span style="opacity:.65;font-weight:400;font-size:12px">· ${count}</span>` : ''}
    </button>`;

  // Pipeline tab strip: Needs You | Leads | Registered | In Progress | BG Check | Interview | Hired | Rejected
  const tabStrip = [
    tab('needs_you',   'Needs you',       counts.needs_you   || ''),
    tab('leads',       'Leads',           counts.leads       || ''),
    tab('registered',  'Registered',      counts.registered  || ''),
    tab('in_progress', 'In Progress',     counts.in_progress || ''),
    tab('bg_check',    'BG Check',        counts.bg_check    || ''),
    tab('interview',   'Interview',       counts.interview   || ''),
    tab('hired',       'Hired',           counts.hired       || ''),
    tab('rejected',    'Rejected',        counts.rejected    || ''),
    tab('expired',     'Expired',         counts.expired     || ''),
  ].join('');

  // Slim row renderer for an application
  const _fmtDate = ts => ts ? new Date(ts*1000).toLocaleDateString('en-MY',{day:'numeric',month:'short',year:'numeric'}) : '';
  const _fmtDateTime = ts => ts ? new Date(ts*1000).toLocaleString('en-MY',{timeZone:'Asia/Kuala_Lumpur',weekday:'short',day:'numeric',month:'short',hour:'numeric',minute:'2-digit',hour12:true}) : '';

  function _appRowHtml(r) {
    const stage   = _applyStageOf(r);
    const needsYou = _applyNeedsYou(r);
    const ap = r.interview_appointment_status || '';

    // Right-side stage badge
    let stageBadge = '';
    if (stage === 'registered')   stageBadge = `<span style="background:#F1F5F9;color:#64748B;padding:3px 9px;border-radius:12px;font-size:11px;font-weight:600">Registered</span>`;
    if (stage === 'in_progress') {
      const lbl = APPLY_PROGRESS_LABEL[r.status] || r.status;
      stageBadge = `<span style="background:#FEF3C7;color:#92400E;padding:3px 9px;border-radius:12px;font-size:11px;font-weight:600">${escapeHtml(lbl)}</span>`;
      if (r.status === 'analysed' && r.overall_score != null) {
        const sc = Number(r.overall_score).toFixed(0);
        const scoreColor = sc >= 70 ? '#166534' : sc >= 55 ? '#92400E' : '#991B1B';
        stageBadge += ` <span style="font-weight:700;color:${scoreColor};font-size:13px">${sc}</span>`;
      }
    }
    if (stage === 'bg_check') {
      const bgLbl = r.ref_result ? `BG: ${r.ref_result.toUpperCase()}` : 'BG Check — pending Pavithra';
      const bgBg  = r.ref_result === 'pass' ? '#DCFCE7' : r.ref_result === 'fail' ? '#FEE2E2' : '#FEF3C7';
      const bgFg  = r.ref_result === 'pass' ? '#166534' : r.ref_result === 'fail' ? '#991B1B' : '#92400E';
      stageBadge = `<span style="background:${bgBg};color:${bgFg};padding:3px 9px;border-radius:12px;font-size:11px;font-weight:600">${bgLbl}</span>`;
    }
    if (stage === 'interview') {
      if (ap === 'requested') {
        stageBadge = `<span style="background:${r.appt_rescheduled?'#DBEAFE':'#FDE68A'};color:${r.appt_rescheduled?'#1E40AF':'#92400E'};padding:3px 9px;border-radius:12px;font-size:11px;font-weight:700">${r.appt_rescheduled?'🔁 Slot rescheduled':'⏳ Slot pending your approval'}</span>`;
      } else if (ap === 'confirmed' && r.interview_appointment_at) {
        const past = (r.interview_appointment_at * 1000) < Date.now();
        stageBadge = `<span style="background:${past?'#DBEAFE':'#DCFCE7'};color:${past?'#1E40AF':'#166534'};padding:3px 9px;border-radius:12px;font-size:11px;font-weight:600">${past?'Interview done — decide':'✓ Confirmed: '+_fmtDateTime(r.interview_appointment_at)}</span>`;
      } else if (ap === 'attended') {
        stageBadge = `<span style="background:#DBEAFE;color:#1E40AF;padding:3px 9px;border-radius:12px;font-size:11px;font-weight:600">Attended — decide</span>`;
      } else if (ap === 'no_show') {
        stageBadge = `<span style="background:#FEE2E2;color:#991B1B;padding:3px 9px;border-radius:12px;font-size:11px;font-weight:600">No-show</span>`;
      } else if (r.interview_appointment_at) {
        stageBadge = `<span style="background:#F1F5F9;color:#374151;padding:3px 9px;border-radius:12px;font-size:11px">📅 ${_fmtDateTime(r.interview_appointment_at)}</span>`;
      } else {
        stageBadge = `<span style="background:#F1F5F9;color:#374151;padding:3px 9px;border-radius:12px;font-size:11px">Interview invited</span>`;
      }
    }
    if (stage === 'hired')    stageBadge = `<span style="background:#DCFCE7;color:#166534;padding:3px 9px;border-radius:12px;font-size:11px;font-weight:700">Hired</span>`;
    if (stage === 'rejected') {
      const rLabel = {'low_score':'Low score','fail_background_check':'Fail BG','bg_no_reply':'Cannot reach — no reply','no_show':'No show','other_job_offer':'Other offer','fail_interview':'Fail interview','abandoned':'Abandoned','dropped_out':'Dropped out','other':'Other'}[r.rejection_reason] || '';
      stageBadge = `<span style="background:#FEE2E2;color:#991B1B;padding:3px 9px;border-radius:12px;font-size:11px;font-weight:600">Rejected${rLabel?' · '+rLabel:''}</span>`;
    }

    if (stage === 'bg_check' || stage === 'interview') {
      const statusText = (stage === 'bg_check' && _aplWaiting(r)) ? 'Waiting for new references'
        : stageBadge.replace(/<[^>]+>/g, '').replace(/&amp;/g, '&').trim();
      return _aplCardHtml(r, stage, statusText, needsYou);
    }
    // Action buttons (right side of row)
    let actions = '';
    if (APPLY_INCOMPLETE_STATUSES.has(r.status)) {
      actions += `<button class="apply-row-remind" data-app-id="${r.id}" style="border:1px solid #B8962E;background:#fff;color:#0B2545;padding:5px 10px;border-radius:6px;cursor:pointer;font-size:12px;font:inherit">Email</button> `;
    }
    if (r.status === 'analysed' && Number(r.overall_score) >= 55 && (r.recommendation === 'maybe' || r.recommendation === 'shortlist' || r.recommendation === 'hire')) {
      actions += `<button class="apply-row-invite" data-app-id="${r.id}" data-app-name="${escapeHtml(r.name)}" style="border:1px solid #16A34A;background:#DCFCE7;color:#166534;padding:5px 10px;border-radius:6px;cursor:pointer;font-size:12px;font:inherit;font-weight:600">Invite →</button> `;
    }
    if (stage === 'bg_check' && !r.ref_result) {
      actions += `<button onclick="event.stopPropagation();applyReferenceCheck('${r.id}','pass')" style="border:1px solid #16A34A;background:#DCFCE7;color:#166534;padding:5px 10px;border-radius:6px;cursor:pointer;font-size:12px;font-weight:600;font:inherit">✓ Pass</button> <button onclick="event.stopPropagation();applyReferenceCheck('${r.id}','fail')" style="border:1px solid #FCA5A5;background:#FEF2F2;color:#991B1B;padding:5px 10px;border-radius:6px;cursor:pointer;font-size:12px;font:inherit">✗ Fail</button> <button onclick="event.stopPropagation();applyReferenceCheck('${r.id}','uncontactable')" style="border:1px solid #F59E0B;background:#FEF3C7;color:#92400E;padding:5px 10px;border-radius:6px;cursor:pointer;font-size:12px;font:inherit">❓ Cannot contact</button> `;
    }
    if (stage === 'interview') {
      if (ap === 'requested') {
        actions += `<button onclick="event.stopPropagation();applyApproveSlot('${r.id}','confirm')" style="background:#DCFCE7;border:1px solid #16A34A;color:#166534;padding:5px 10px;border-radius:6px;font-size:12px;font-weight:700;cursor:pointer;font:inherit">✓ Confirm</button> <button onclick="event.stopPropagation();applyApproveSlot('${r.id}','reject')" style="background:#FEF2F2;border:1px solid #FCA5A5;color:#991B1B;padding:5px 10px;border-radius:6px;font-size:12px;cursor:pointer;font:inherit">✗</button> `;
      }
      if (ap === 'confirmed' && r.interview_appointment_at && (r.interview_appointment_at * 1000) < Date.now()) {
        actions += `<button onclick="event.stopPropagation();applyMarkAttended('${r.id}', false)" style="border:1px solid #1E40AF;background:#DBEAFE;color:#1E40AF;padding:5px 10px;border-radius:6px;cursor:pointer;font-size:12px;font:inherit">Attended</button>`;
        actions += `<button onclick="event.stopPropagation();applyMarkAttended('${r.id}', true)" style="border:1px solid #FCA5A5;background:#fff;color:#991B1B;padding:5px 10px;border-radius:6px;cursor:pointer;font-size:12px;font:inherit">No-show</button>`;
      }
      actions += `<button class="apply-row-hire" data-app-id="${r.id}" data-app-name="${escapeHtml(r.name)}" style="border:1px solid #16A34A;background:#DCFCE7;color:#166534;padding:5px 10px;border-radius:6px;cursor:pointer;font-size:12px;font:inherit;font-weight:600">Hire</button> `;
    }
    if (['in_progress','bg_check','interview'].includes(stage) || r.status === 'analysed') {
      actions += `<button class="apply-row-reject" data-app-id="${r.id}" data-app-name="${escapeHtml(r.name)}" style="border:1px solid #FCA5A5;background:#FEF2F2;color:#991B1B;padding:5px 10px;border-radius:6px;cursor:pointer;font-size:12px;font:inherit">Reject</button> `;
    }
    if (['registered','rejected'].includes(stage)) {
      actions += `<button class="apply-row-del" data-app-id="${r.id}" data-app-name="${escapeHtml(r.name)}" style="border:1px solid #E5E7EB;background:#fff;color:#9CA3AF;padding:5px 10px;border-radius:6px;cursor:pointer;font-size:12px;font:inherit">Del</button>`;
    }

    const needsYouDot = needsYou ? `<span style="display:inline-block;width:7px;height:7px;background:#EF4444;border-radius:50%;margin-right:6px;vertical-align:middle"></span>` : '';

    return `
      <div class="apply-row" data-app-id="${r.id}" style="display:flex;align-items:center;gap:12px;padding:12px 16px;border-bottom:1px solid #F1F5F9;cursor:pointer;transition:background .1s" onmouseover="this.style.background='#FAFAF7'" onmouseout="this.style.background=''">
        <div style="width:36px;height:36px;border-radius:50%;background:#E2E8F0;color:#64748B;font-size:13px;font-weight:600;display:flex;align-items:center;justify-content:center;flex-shrink:0">${escapeHtml((r.name||'?').charAt(0).toUpperCase())}</div>
        <div style="flex:1;min-width:0">
          <div style="font-weight:600;font-size:14px;color:#0B2545;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${needsYouDot}${escapeHtml(r.name)}</div>
          <div style="font-size:12px;color:#9CA3AF;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${escapeHtml(r.email)}${r.phone ? ' · ' + escapeHtml(r.phone) : ''}</div>
          ${r.admin_remark ? `<div style="font-size:11px;color:#64748B;margin-top:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">📝 ${escapeHtml(r.admin_remark)}</div>` : ''}
        </div>
        <div style="flex-shrink:0;text-align:right">
          <div style="margin-bottom:4px">${stageBadge}</div>
          <div style="font-size:11px;color:#CBD5E1">${_fmtDate(r.created_at)}</div>
        </div>
        ${actions ? `<div style="flex-shrink:0;display:flex;gap:4px;align-items:center" onclick="event.stopPropagation()">${actions}</div>` : ''}
      </div>`;
  }

  // Lead row (sourced but not yet registered)
  function _leadRowHtml(l) {
    const srcBadge = l.source === 'AJobThing'
      ? `<span style="background:#E0E7FF;color:#3730A3;padding:2px 7px;border-radius:10px;font-size:10px;font-weight:600">AJobThing</span>`
      : `<span style="background:#FEF3C7;color:#92400E;padding:2px 7px;border-radius:10px;font-size:10px;font-weight:600">SEEK</span>`;
    const daysAgo = l.invited_at ? Math.floor((Date.now()/1000 - l.invited_at) / 86400) : null;
    const agoStr  = daysAgo != null ? (daysAgo === 0 ? 'today' : daysAgo + 'd ago') : '';
    return `
      <div class="lead-row" style="display:flex;align-items:center;gap:12px;padding:12px 16px;border-bottom:1px solid #F1F5F9">
        <div style="width:36px;height:36px;border-radius:50%;background:#FEF3C7;color:#92400E;font-size:13px;font-weight:600;display:flex;align-items:center;justify-content:center;flex-shrink:0">${escapeHtml((l.name||'?').charAt(0).toUpperCase())}</div>
        <div style="flex:1;min-width:0">
          <div style="font-weight:600;font-size:14px;color:#0B2545">${escapeHtml(l.name)}</div>
          <div style="font-size:12px;color:#9CA3AF">${escapeHtml(l.email)}</div>
        </div>
        <div style="flex-shrink:0;text-align:right">
          <div style="margin-bottom:3px">${srcBadge} <span style="background:#F1F5F9;color:#64748B;padding:2px 7px;border-radius:10px;font-size:10px">Invited${agoStr?' · '+agoStr:''}</span></div>
          ${l.deadline ? `<div style="font-size:11px;color:#CBD5E1">Deadline: ${escapeHtml(l.deadline)}</div>` : ''}
          ${l.status === 'expired' ? `<div style="font-size:11px;color:#9CA3AF;margin-top:3px">Invited ${_fmtDate(l.invited_at)}${daysAgo != null ? ' · ' + daysAgo + ' days old' : ''}</div>` : ''}
        </div>
        ${l.status === 'expired' ? `<button class="lead-restore" data-lead="${escapeHtml(l.id)}" style="flex-shrink:0;padding:5px 11px;border:1px solid #CBD5E1;background:#fff;color:#374151;border-radius:7px;cursor:pointer;font:inherit;font-size:12px">Restore</button>` : ''}
      </div>`;
  }

  // Build rows HTML
  const totalShown = isLeadsTab ? displayLeads.length : displayRows.length;
  let rowsHtml = '';
  if (isLeadsTab) {
    rowsHtml = displayLeads.length === 0
      ? '<div style="padding:40px;text-align:center;color:#9CA3AF;font-size:14px">No unregistered sourced leads. Use SEEK or AJobThing button to send invites.</div>'
      : displayLeads.map(_leadRowHtml).join('');
  } else {
    const emptyMsg = _applyFilterBucket === 'needs_you' ? "Nothing needs your attention — you're all caught up." : 'No applications in this view.';
    rowsHtml = displayRows.length === 0
      ? `<div style="padding:40px;text-align:center;color:#9CA3AF;font-size:14px">${emptyMsg}</div>`
      : displayRows.map(_appRowHtml).join('');
  }

  const html = `
    <div style="padding:24px">
      <div style="display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:16px;flex-wrap:wrap;gap:12px">
        <div>
          <h2 style="font-family:Cormorant Garamond,serif;font-size:28px;margin:0">Applications</h2>
          <p style="color:#6B7280;font-size:13px;margin:4px 0 0">${totalShown} in this view</p>
        </div>
        <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">
          <select id="apply-role" style="padding:7px 10px;border:1px solid #cbd5e1;border-radius:8px;font:inherit;font-size:13px">
            <option value="" ${_applyFilterRole===''?'selected':''}>All roles</option>
            <option value="admin_executive" ${_applyFilterRole==='admin_executive'?'selected':''}>Admin Executive</option>
            <option value="financial_advisor" ${_applyFilterRole==='financial_advisor'?'selected':''}>Financial Advisor</option>
          </select>
          <input id="apply-search" type="search" value="${escapeHtml(_applyFilterSearch)}" placeholder="Search all — name / email / phone / ID" style="padding:7px 12px;border:1px solid #cbd5e1;border-radius:8px;font:inherit;font-size:13px;width:220px" autocomplete="off"/>
          <details id="apply-tools" style="position:relative">
            <summary style="list-style:none;padding:7px 14px;border:1.5px solid #E2E8F0;background:#fff;color:#374151;border-radius:8px;cursor:pointer;font-size:13px;font-weight:600;user-select:none">Tools ▾</summary>
            <div style="position:absolute;right:0;top:110%;z-index:600;background:#fff;border:1px solid #E2E8F0;border-radius:10px;box-shadow:0 8px 28px rgba(0,0,0,.14);padding:8px;display:flex;flex-direction:column;gap:6px;min-width:260px">
              <button id="apply-remind-all" style="padding:8px 14px;border:1px solid #B8962E;background:#fff;color:#0B2545;border-radius:8px;cursor:pointer;font:inherit;font-size:13px;text-align:left">📧 Email all incomplete</button>
              <button id="apply-invite-all" style="padding:8px 14px;border:1px solid #16A34A;background:#DCFCE7;color:#166534;border-radius:8px;cursor:pointer;font:inherit;font-size:13px;text-align:left">📧 Invite all qualifying</button>
              <button id="apply-jobstreet-invite" style="padding:8px 14px;border:1px solid #0B2545;background:#fff;color:#0B2545;border-radius:8px;cursor:pointer;font:inherit;font-size:13px;text-align:left">📧 Sourcing invite (SEEK / AJobThing)</button>
              <button id="apply-video-health" style="padding:8px 14px;border:1px solid #1D4ED8;background:#fff;color:#1E40AF;border-radius:8px;cursor:pointer;font:inherit;font-size:13px;text-align:left">📹 Video health</button>
              <button id="apply-recover-stuck" style="padding:8px 14px;border:1px solid #16A34A;background:#fff;color:#166534;border-radius:8px;cursor:pointer;font:inherit;font-size:13px;text-align:left">🔁 Recover stuck videos</button>
              <button id="apply-reanalyse-30char" style="padding:8px 14px;border:1px solid #92400E;background:#fff;color:#92400E;border-radius:8px;cursor:pointer;font:inherit;font-size:13px;text-align:left">🔁 Re-analyse 30-char-affected</button>
              <button id="apply-expire-leads" style="padding:8px 14px;border:1px solid #6B7280;background:#fff;color:#374151;border-radius:8px;cursor:pointer;font:inherit;font-size:13px;text-align:left">🗂 Expire stale leads now</button>
              <button id="apply-expiry-days" style="padding:8px 14px;border:1px solid #6B7280;background:#fff;color:#374151;border-radius:8px;cursor:pointer;font:inherit;font-size:13px;text-align:left">⏱ Lead expiry threshold…</button>
            </div>
          </details>
        </div>
      </div>
      <div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:16px">
        ${tabStrip}
      </div>
      <div style="background:#fff;border-radius:12px;box-shadow:0 4px 24px rgba(11,37,69,.06);overflow:hidden">
        ${rowsHtml}
      </div>
    </div>`;
  main.innerHTML = html;
  // Wire tabs
  main.querySelectorAll(".apply-tab").forEach(b => b.addEventListener("click", () => {
    _applyFilterBucket = b.dataset.bucket; renderApplicationsList(false); // use cached rows
  }));

  // Restore one expired lead back into Leads.
  main.querySelectorAll(".lead-restore").forEach(b => b.addEventListener("click", async () => {
    b.disabled = true; b.textContent = "…";
    try {
      const r = await applyPost("/api/apply/admin/leads/" + encodeURIComponent(b.dataset.lead) + "/restore", {});
      if (r && r.error) throw new Error(r.error);
      showToast("success", "Restored to Leads");
      renderApplicationsList(true);                       // refetch so both tabs are right
    } catch (e) {
      b.disabled = false; b.textContent = "Restore";
      showToast("error", "Could not restore: " + e.message);
    }
  }));

  // Tools → expire stale leads. Shows the count FIRST and asks; the number in
  // the question is the number that moves (same rule server-side). Silent:
  // expiry sends nothing to the candidate.
  const _expBtn = main.querySelector("#apply-expire-leads");
  if (_expBtn) _expBtn.addEventListener("click", async () => {
    try {
      const pv = await applyGet("/api/apply/admin/leads/expire-preview");
      if (pv && pv.error) throw new Error(pv.error);
      if (!pv.count) { showToast("success", "Nothing to expire — no lead is older than " + pv.days + " days without applying."); return; }
      if (!confirm(pv.count + " lead" + (pv.count === 1 ? "" : "s") + " invited more than " + pv.days + " days ago never applied.\n\nMove them to Expired? Nothing is deleted and no message is sent to them.")) return;
      const r = await applyPost("/api/apply/admin/leads/expire-now", {});
      if (r && r.error) throw new Error(r.error);
      showToast("success", "Moved " + r.expired + " to Expired");
      renderApplicationsList(true);
    } catch (e) { showToast("error", "Could not expire: " + e.message); }
  });

  // Tools → change the threshold (stored server-side, default 20).
  const _daysBtn = main.querySelector("#apply-expiry-days");
  if (_daysBtn) _daysBtn.addEventListener("click", async () => {
    try {
      const cur = await applyGet("/api/apply/admin/leads/expiry-setting");
      const ans = prompt("Expire a lead after how many days without applying?", String(cur.days || 20));
      if (ans === null) return;
      const r = await applyPost("/api/apply/admin/leads/expiry-setting", { days: parseInt(ans, 10) });
      if (r && r.error) throw new Error(r.error);
      showToast("success", "Threshold set to " + r.days + " days");
    } catch (e) { showToast("error", "Could not save: " + e.message); }
  });
  // Wire search (debounced — re-render after 200ms idle, preserve focus + caret position)
  const roleSel = main.querySelector("#apply-role");
  if (roleSel) roleSel.addEventListener("change", () => { _applyFilterRole = roleSel.value; renderApplicationsList(); });
  const searchInput = main.querySelector("#apply-search");
  if (searchInput) {
    let _searchTimer = null;
    searchInput.addEventListener("input", e => {
      clearTimeout(_searchTimer);
      const val = e.target.value;
      const pos = e.target.selectionStart;
      _searchTimer = setTimeout(() => {
        _applyFilterSearch = val;
        renderApplicationsList(false); // use cached rows — no re-fetch
        const fresh = document.getElementById("apply-search");
        if (fresh) { fresh.focus(); try { fresh.setSelectionRange(pos, pos); } catch {} }
      }, 200);
    });
    if (_applyFilterSearch) {
      searchInput.focus();
      try { searchInput.setSelectionRange(_applyFilterSearch.length, _applyFilterSearch.length); } catch {}
    }
  }
  // Open detail drawer when clicking a row (new slim-row format)
  _aplWire(main);
  main.querySelectorAll(".apply-row:not([data-apl-card])").forEach(row => row.addEventListener("click", () => {
    const id = row.dataset.appId;
    if (id) renderApplicationDetail(id);
  }));
  // Bulk reminder
  const remindAllBtn = main.querySelector("#apply-remind-all");
  if (remindAllBtn) remindAllBtn.addEventListener("click", () => remindAllIncomplete(displayRows));
  // Bulk recovery for "uploaded videos but stuck" candidates
  const recoverBtn = main.querySelector("#apply-recover-stuck");
  if (recoverBtn) recoverBtn.addEventListener("click", async () => {
    recoverBtn.disabled = true; const original = recoverBtn.textContent;
    recoverBtn.textContent = "🔁 Searching…";
    try {
      const res = await applyPost("/api/apply/admin/recover-stuck-analysis", {});
      if (res.error) throw new Error(res.error);
      if (!res.found) {
        showToast("success", "No stuck candidates found (all video-completers are already analysed).");
      } else {
        const names = (res.triggered || []).map(t => t.name || t.id).join(", ");
        showToast("success", `Recovery triggered for ${res.found} candidate${res.found===1?'':'s'}: ${names}. Analysis runs in background — refresh in 60s to see updated status.`);
      }
    } catch (e) { showToast("error", "Recovery failed: " + e.message); }
    recoverBtn.disabled = false; recoverBtn.textContent = original;
    setTimeout(renderApplicationsList, 1000);
  });
  // Bulk reanalyse for candidates whose data was lost to the old 30-char validation bug
  const reanalyseBtn = main.querySelector("#apply-reanalyse-30char");
  if (reanalyseBtn) reanalyseBtn.addEventListener("click", async () => {
    if (!confirm("Re-analyse the candidates whose Stage 2 answers were lost to the old 30-char validation bug?\n\nAnalysis runs in the background. Refresh in 60s to see updated scores.")) return;
    reanalyseBtn.disabled = true; const original = reanalyseBtn.textContent;
    reanalyseBtn.textContent = "🔁 Triggering…";
    try {
      const res = await applyPost("/api/apply/admin/reanalyse-30char-affected", {});
      if (res.error) throw new Error(res.error);
      if (!res.found) {
        showToast("success", "No 30-char-affected candidates found.");
      } else {
        const names = (res.triggered || []).map(t => t.name || t.id).join(", ");
        showToast("success", `Re-analyse triggered for ${res.found} candidate${res.found===1?'':'s'}: ${names}. Refresh in 60s to see updated scores.`);
      }
    } catch (e) { showToast("error", "Re-analyse failed: " + e.message); }
    reanalyseBtn.disabled = false; reanalyseBtn.textContent = original;
    setTimeout(renderApplicationsList, 1000);
  });
  // Per-row WhatsApp pinged toggle
  main.querySelectorAll(".apply-row-wa").forEach(b => b.addEventListener("click", async e => {
    e.stopPropagation();
    const id = b.dataset.appId;
    const wasPinged = b.dataset.pinged === "1";
    b.disabled = true;
    try {
      const path = `/api/apply/admin/applications/${encodeURIComponent(id)}/mark-wa-pinged`;
      if (wasPinged) {
        await applyDelete(path);
        showToast("success", "Unmarked");
      } else {
        await applyPost(path, {});
        showToast("success", "Marked as WhatsApp-pinged");
      }
      renderApplicationsList();
    } catch (err) {
      showToast("error", err.message);
      b.disabled = false;
    }
  }));
  // Per-row reminder — confirm if a recent email was already sent (server-side record)
  main.querySelectorAll(".apply-row-remind").forEach(b => b.addEventListener("click", e => {
    e.stopPropagation();
    const id = b.dataset.appId;
    const row = displayRows.find(x => x.id === id);
    if (!row) return;
    if (row.last_email_pinged_at) {
      const when = new Date(row.last_email_pinged_at * 1000).toLocaleString();
      const ago = _relTime(row.last_email_pinged_at);
      if (!confirm(`📧 ${row.name} was already emailed ${ago} (${when}).\n\nSend another email reminder?\n\n(Click Cancel to skip — recommended unless 48h has passed.)`)) return;
    } else {
      const recent = _wasRecentlyReminded(id);
      if (recent) {
        const hoursAgo = ((Date.now() - recent.ts) / 3600000).toFixed(1);
        if (!confirm(`${row.name} was already reminded ${hoursAgo}h ago (this browser). Send another reminder anyway?`)) return;
      }
    }
    sendReminderForRow(row);
  }));
  // "Video Health" — per-candidate video upload status
  const vhBtn = main.querySelector("#apply-video-health");
  if (vhBtn) vhBtn.addEventListener("click", async () => {
    const overlay = document.createElement("div");
    overlay.style.cssText = "position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:99999;display:flex;align-items:flex-start;justify-content:center;padding:24px;overflow-y:auto";
    overlay.innerHTML = `
      <div style="background:#fff;border-radius:14px;max-width:1000px;width:100%;padding:24px 28px;box-shadow:0 20px 60px rgba(0,0,0,.3);margin-top:24px">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px">
          <h2 style="margin:0;font-family:'Cormorant Garamond',serif;font-size:24px;color:#0B2545">📹 Video Health</h2>
          <button id="vh-close" style="background:none;border:none;font-size:24px;cursor:pointer;color:#9CA3AF">×</button>
        </div>
        <p style="margin:0 0 14px;color:#4B5563;font-size:13px">Per-candidate video upload status — candidates doing the video interview. "Stuck" = chose video, idle 20+ min, not all uploaded.</p>
        <div id="vh-body" style="min-height:120px"><div style="text-align:center;padding:32px;color:#6B7280;font-size:14px"><span class="spinner"></span> Loading…</div></div>
      </div>`;
    document.body.appendChild(overlay);
    overlay.addEventListener("click", e => { if (e.target === overlay) overlay.remove(); });
    document.getElementById("vh-close").onclick = () => overlay.remove();
    try {
      const r = await applyGet("/api/apply/admin/video-health");
      if (r.error) throw new Error(r.error);
      const s = r.summary || {}, cands = r.candidates || [];
      const esc = escapeHtml; // consolidated → canonical escapeHtml (line ~7379)
      const stStyle = { complete:{bg:"#DCFCE7",fg:"#166534",lbl:"Complete"}, partial:{bg:"#FEF3C7",fg:"#92400E",lbl:"Partial"}, none:{bg:"#FEE2E2",fg:"#991B1B",lbl:"None yet"}, "no-video":{bg:"#F1F5F9",fg:"#6B7280",lbl:"Walk-in / no video"} };
      let chips = `<div style="display:flex;gap:10px;flex-wrap:wrap;margin-bottom:14px">`
        + `<div style="background:#DCFCE7;color:#166534;padding:6px 12px;border-radius:20px;font-size:12px;font-weight:600">✓ ${s.complete||0} complete</div>`
        + `<div style="background:#FEF3C7;color:#92400E;padding:6px 12px;border-radius:20px;font-size:12px;font-weight:600">◐ ${s.partial||0} partial</div>`
        + `<div style="background:#FEE2E2;color:#991B1B;padding:6px 12px;border-radius:20px;font-size:12px;font-weight:600">○ ${s.none||0} none</div>`
        + (s.stuck ? `<div style="background:#FEE2E2;color:#991B1B;padding:6px 12px;border-radius:20px;font-size:12px;font-weight:700">⚠ ${s.stuck} STUCK</div>` : "")
        + (s.candidates_with_errors ? `<div style="background:#FEF3C7;color:#92400E;padding:6px 12px;border-radius:20px;font-size:12px;font-weight:600">⚠ ${s.candidates_with_errors} with upload errors</div>` : "")
        + `<div style="background:#F1F5F9;color:#374151;padding:6px 12px;border-radius:20px;font-size:12px;font-weight:600">📋 ${s.total||0} total</div></div>`;
      let table = chips + `<div style="overflow-x:auto"><table style="width:100%;border-collapse:collapse;font-size:13px"><thead><tr style="background:#0B2545;color:#fff"><th style="padding:8px;text-align:left">Candidate</th><th style="padding:8px;text-align:center">Videos</th><th style="padding:8px;text-align:center">Transcripts</th><th style="padding:8px;text-align:center">Errors (48h)</th><th style="padding:8px;text-align:left">State</th></tr></thead><tbody>`;
      for (const c of cands) {
        const st = stStyle[c.state] || stStyle.partial;
        const stuckTag = c.stuck ? ` <span style="background:#991B1B;color:#fff;padding:1px 6px;border-radius:10px;font-size:10px;font-weight:700">STUCK ${c.idle_minutes}m</span>` : "";
        const vColor = c.videos_up >= c.video_total ? "#166534" : (c.videos_up > 0 ? "#92400E" : "#991B1B");
        table += `<tr style="border-top:1px solid #E5E7EB">`
          + `<td style="padding:8px"><b>${esc(c.name)}</b><div style="font-size:11px;color:#9CA3AF">${esc(c.email)}</div></td>`
          + `<td style="padding:8px;text-align:center;font-weight:700;color:${vColor}">${c.videos_up}/${c.video_total}</td>`
          + `<td style="padding:8px;text-align:center">${c.transcripts}</td>`
          + `<td style="padding:8px;text-align:center;color:${c.recent_errors>0?'#991B1B':'#9CA3AF'};font-weight:${c.recent_errors>0?'700':'400'}">${c.recent_errors||'—'}</td>`
          + `<td style="padding:8px"><span style="background:${st.bg};color:${st.fg};padding:3px 10px;border-radius:12px;font-size:11px;font-weight:600">${st.lbl}</span>${stuckTag}</td>`
          + `</tr>`;
      }
      table += `</tbody></table></div>`;
      if (!cands.length) table = chips + `<div style="background:#F1F5F9;border-radius:8px;padding:18px;text-align:center;color:#6B7280">No video-interview candidates yet.</div>`;
      document.getElementById("vh-body").innerHTML = table;
    } catch (e) {
      const b = document.getElementById("vh-body");
      if (b) b.innerHTML = `<div style="background:#FEE2E2;color:#991B1B;border-radius:8px;padding:16px">Failed to load: ${e.message}</div>`;
    }
  });
  // "Email delivery status" — modal showing every share-link send + Brevo's actual delivery outcome
  const deliveryBtn = main.querySelector("#apply-delivery-status");
  if (deliveryBtn) deliveryBtn.addEventListener("click", async () => {
    const overlay = document.createElement("div");
    overlay.style.cssText = "position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:99999;display:flex;align-items:flex-start;justify-content:center;padding:24px;overflow-y:auto";
    overlay.innerHTML = `
      <div style="background:#fff;border-radius:14px;max-width:1100px;width:100%;padding:24px 28px;box-shadow:0 20px 60px rgba(0,0,0,.3);margin-top:24px">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px">
          <h2 style="margin:0;font-family:'Cormorant Garamond',serif;font-size:24px;color:#0B2545">📨 Email delivery status</h2>
          <button id="ds-close" style="background:none;border:none;font-size:24px;cursor:pointer;color:#9CA3AF">×</button>
        </div>
        <p style="margin:0 0 14px;color:#4B5563;font-size:13px;line-height:1.5">Every share-link email sent in the last <select id="ds-days" style="border:1px solid #cbd5e1;border-radius:6px;padding:2px 6px;font:13px DM Sans,sans-serif"><option value="7">7</option><option value="14">14</option><option value="30" selected>30</option><option value="60">60</option><option value="90">90</option></select> days, with Brevo's actual delivery outcome.</p>
        <div id="ds-body" style="min-height:120px"><div style="text-align:center;padding:32px;color:#6B7280;font-size:14px"><span class="spinner"></span> Loading delivery events from Brevo…</div></div>
      </div>`;
    document.body.appendChild(overlay);
    overlay.addEventListener("click", e => { if (e.target === overlay) overlay.remove(); });
    document.getElementById("ds-close").onclick = () => overlay.remove();
    const STATUS_STYLE = {
      delivered: { bg: "#DCFCE7", fg: "#166534", icon: "✅", label: "Delivered" },
      opened:    { bg: "#DBEAFE", fg: "#1E40AF", icon: "📬", label: "Opened" },
      clicked:   { bg: "#E0E7FF", fg: "#3730A3", icon: "🔗", label: "Clicked" },
      bounced:   { bg: "#FEE2E2", fg: "#991B1B", icon: "❌", label: "Bounced" },
      failed:    { bg: "#FEE2E2", fg: "#991B1B", icon: "⚠️", label: "Send failed" },
      accepted:  { bg: "#FEF3C7", fg: "#92400E", icon: "⏳", label: "Accepted (in flight)" },
    };
    const load = async (days) => {
      const body = document.getElementById("ds-body");
      body.innerHTML = `<div style="text-align:center;padding:32px;color:#6B7280;font-size:14px"><span class="spinner"></span> Loading…</div>`;
      try {
        const r = await applyGet(`/api/apply/admin/share-link-deliveries?days=${days}`);
        if (r.error) throw new Error(r.error);
        const rows = r.records || [];
        if (rows.length === 0) {
          body.innerHTML = `<div style="background:#F1F5F9;border-radius:8px;padding:18px;text-align:center;color:#6B7280;font-size:14px">No share-link emails sent in the last ${days} days.</div>`;
          return;
        }
        const fmt = ts => { const d = new Date(ts * 1000); return d.toLocaleString("en-MY", { timeZone: "Asia/Kuala_Lumpur", day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }); };
        const esc = escapeHtml; // consolidated → canonical escapeHtml (line ~7379)
        // Summary tally
        const tally = { delivered: 0, opened: 0, clicked: 0, bounced: 0, failed: 0, accepted: 0 };
        rows.forEach(rec => { tally[rec.status] = (tally[rec.status] || 0) + 1; });
        let summaryHtml = `<div style="display:flex;gap:10px;flex-wrap:wrap;margin-bottom:14px">`;
        Object.keys(STATUS_STYLE).forEach(k => {
          if (!tally[k]) return;
          const s = STATUS_STYLE[k];
          summaryHtml += `<div style="background:${s.bg};color:${s.fg};padding:6px 12px;border-radius:20px;font-size:12px;font-weight:600">${s.icon} ${tally[k]} ${s.label}</div>`;
        });
        summaryHtml += `<div style="background:#F1F5F9;color:#374151;padding:6px 12px;border-radius:20px;font-size:12px;font-weight:600">📋 ${rows.length} total</div></div>`;
        let table = summaryHtml + `<div style="overflow-x:auto"><table style="width:100%;border-collapse:collapse;font-size:13px"><thead><tr style="background:#0B2545;color:#fff"><th style="padding:8px 6px;text-align:left">When</th><th style="padding:8px 6px;text-align:left">Candidate</th><th style="padding:8px 6px;text-align:left">Recipient</th><th style="padding:8px 6px;text-align:left">Status</th><th style="padding:8px 6px;text-align:left">Detail</th></tr></thead><tbody>`;
        for (const rec of rows) {
          const s = STATUS_STYLE[rec.status] || STATUS_STYLE.accepted;
          const detail = rec.bounce_reason
            ? `<span style="color:#991B1B;font-size:11px;font-family:Menlo,Consolas,monospace">${esc(rec.bounce_reason)}</span>`
            : rec.brevo_events && rec.brevo_events.length
              ? `<span style="color:#6B7280;font-size:11px">${rec.brevo_events.map(e => esc(e.event)).join(", ")}</span>`
              : `<span style="color:#9CA3AF;font-size:11px;font-style:italic">no events yet</span>`;
          table += `<tr style="border-bottom:1px solid #E5E7EB">` +
            `<td style="padding:8px 6px;font-size:12px;color:#6B7280;white-space:nowrap">${esc(fmt(rec.ts))}</td>` +
            `<td style="padding:8px 6px"><div style="font-weight:600">${esc(rec.candidate_name || rec.application_id || "—")}</div><div style="font-size:11px;color:#9CA3AF"><code>${esc(rec.application_id || "")}</code></div></td>` +
            `<td style="padding:8px 6px"><div style="font-size:13px">${esc(rec.recipient || "")}</div>${rec.bcc ? `<div style="font-size:11px;color:#9CA3AF">bcc: ${esc(rec.bcc)}</div>` : ""}</td>` +
            `<td style="padding:8px 6px"><span style="background:${s.bg};color:${s.fg};padding:3px 9px;border-radius:12px;font-size:11px;font-weight:700;white-space:nowrap">${s.icon} ${s.label}</span></td>` +
            `<td style="padding:8px 6px">${detail}</td>` +
            `</tr>`;
        }
        table += `</tbody></table></div>`;
        body.innerHTML = table;
      } catch (e) {
        body.innerHTML = `<div style="background:#FEE2E2;color:#991B1B;padding:14px;border-radius:8px;font-size:13px">Failed to load: ${e.message}</div>`;
      }
    };
    load(30);
    document.getElementById("ds-days").addEventListener("change", e => load(Number(e.target.value)));
  });

  // "Templates" — review/amend every email + WhatsApp template the worker sends.
  const tplBtn = main.querySelector("#apply-templates");
  if (tplBtn) tplBtn.addEventListener("click", async () => {
    const esc = escapeHtml; // consolidated → canonical escapeHtml (line ~7379)
    const overlay = document.createElement("div");
    overlay.style.cssText = "position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:99999;display:flex;align-items:flex-start;justify-content:center;padding:24px;overflow-y:auto";
    overlay.innerHTML = `
      <div style="background:#fff;border-radius:14px;max-width:1100px;width:100%;padding:24px 28px;box-shadow:0 20px 60px rgba(0,0,0,.3);margin-top:24px">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px">
          <h2 style="margin:0;font-family:'Cormorant Garamond',serif;font-size:24px;color:#0B2545">📝 Templates</h2>
          <button id="tpl-close" style="background:none;border:none;font-size:24px;cursor:pointer;color:#9CA3AF">×</button>
        </div>
        <p style="margin:0 0 16px;color:#4B5563;font-size:13px;line-height:1.5">Every automated message the system can send. Cron-fired ones (yellow border) are editable; admin-manual ones (grey, read-only) are shown for visibility — bodies are baked in code and will be made editable next round. Placeholders use <code style="background:#F1F5F9;padding:1px 5px;border-radius:4px;font-size:11px">{{snake_case}}</code> syntax.</p>
        <div id="tpl-body" style="min-height:160px"><div style="text-align:center;padding:32px;color:#6B7280;font-size:14px"><span class="spinner"></span> Loading templates…</div></div>
      </div>`;
    document.body.appendChild(overlay);
    overlay.addEventListener("click", e => { if (e.target === overlay) overlay.remove(); });
    document.getElementById("tpl-close").onclick = () => overlay.remove();

    function renderList(items) {
      const body = document.getElementById("tpl-body");
      const cards = items.map(it => {
        const isWA = it.channel === "whatsapp";
        const isRO = !!it.readonly;
        const overridden = !!it.override && (it.override.subject || it.override.body_text || it.override.body_html);
        const borderColor = isRO ? "#E5E7EB" : (overridden ? "#16A34A" : "#B8962E");
        const bg = isRO ? "#FAFAF7" : "#fff";
        const channelChip = isWA
          ? `<span style="background:#DCFCE7;color:#166534;padding:2px 8px;border-radius:10px;font-size:11px;font-weight:600">💬 WhatsApp</span>`
          : `<span style="background:#DBEAFE;color:#1E40AF;padding:2px 8px;border-radius:10px;font-size:11px;font-weight:600">📧 Email</span>`;
        const roChip = isRO
          ? `<span style="background:#F1F5F9;color:#6B7280;padding:2px 8px;border-radius:10px;font-size:11px;font-weight:600">read-only</span>`
          : `<span style="background:#FEF3C7;color:#92400E;padding:2px 8px;border-radius:10px;font-size:11px;font-weight:600">editable</span>`;
        const ovChip = overridden
          ? `<span style="background:#DCFCE7;color:#166534;padding:2px 8px;border-radius:10px;font-size:11px;font-weight:600">✏️ overridden</span>`
          : "";
        const liveSubject = (it.override && it.override.subject) || it.defaults.subject || "(no subject)";
        const liveBody = (it.override && it.override.body_text) || it.defaults.body_text || "(uses baked-in body — see code)";
        return `
          <div data-key="${esc(it.key)}" style="border:2px solid ${borderColor};background:${bg};border-radius:10px;padding:14px 16px;margin-bottom:12px">
            <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px;margin-bottom:6px">
              <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">${channelChip} ${roChip} ${ovChip}<b style="font-size:14px;color:#0B2545">${esc(it.label)}</b></div>
              ${isRO ? "" : `<button data-edit="${esc(it.key)}" style="background:#0B2545;color:#fff;border:none;padding:6px 14px;border-radius:6px;cursor:pointer;font:12px DM Sans,sans-serif;font-weight:500">Edit</button>`}
            </div>
            <div style="font-size:12px;color:#6B7280;margin:0 0 8px;line-height:1.5">${esc(it.description)}</div>
            <div style="font-size:11px;color:#9CA3AF;margin:0 0 8px"><b>Fires:</b> ${esc(it.fires_on)} · <b>Placeholders:</b> ${(it.placeholders || []).map(p => `<code style="background:#F1F5F9;padding:1px 4px;border-radius:3px">{{${esc(p)}}}</code>`).join(" ") || "—"}</div>
            ${liveSubject ? `<div style="font-size:12px;color:#374151;margin:0 0 4px"><b>Subject:</b> ${esc(liveSubject)}</div>` : ""}
            <pre style="background:#F8FAFC;border:1px solid #E5E7EB;border-radius:6px;padding:10px 12px;font:12px/1.5 Menlo,Consolas,monospace;color:#0B2545;white-space:pre-wrap;word-break:break-word;margin:0;max-height:200px;overflow-y:auto">${esc(liveBody)}</pre>
          </div>`;
      }).join("");
      body.innerHTML = `<div>${cards}</div>`;
      body.querySelectorAll("button[data-edit]").forEach(btn => {
        btn.addEventListener("click", () => openEditor(items.find(x => x.key === btn.dataset.edit)));
      });
    }

    function openEditor(it) {
      const isWA = it.channel === "whatsapp";
      const ovS = (it.override && it.override.subject)   || "";
      const ovT = (it.override && it.override.body_text) || "";
      const ovH = (it.override && it.override.body_html) || "";
      const editor = document.createElement("div");
      editor.style.cssText = "position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:100000;display:flex;align-items:flex-start;justify-content:center;padding:24px;overflow-y:auto";
      editor.innerHTML = `
        <div style="background:#fff;border-radius:14px;max-width:780px;width:100%;padding:24px 28px;box-shadow:0 20px 60px rgba(0,0,0,.3);margin-top:24px">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px">
            <h3 style="margin:0;font-family:'Cormorant Garamond',serif;font-size:20px;color:#0B2545">Edit: ${esc(it.label)}</h3>
            <button id="tpl-edit-close" style="background:none;border:none;font-size:22px;cursor:pointer;color:#9CA3AF">×</button>
          </div>
          <p style="margin:6px 0 16px;color:#6B7280;font-size:12px;line-height:1.5">Leave a field blank to keep the baked-in default. Placeholders available: ${(it.placeholders || []).map(p => `<code style="background:#F1F5F9;padding:1px 4px;border-radius:3px">{{${esc(p)}}}</code>`).join(" ")}</p>
          ${isWA ? "" : `
          <label style="display:block;font-size:12px;font-weight:600;color:#374151;margin:10px 0 4px">Subject ${it.defaults.subject ? `<span style="color:#9CA3AF;font-weight:normal">(default: ${esc(it.defaults.subject)})</span>` : ""}</label>
          <input id="tpl-subj" type="text" value="${esc(ovS)}" placeholder="${esc(it.defaults.subject || "(no default)")}" style="width:100%;padding:8px 10px;border:1px solid #E5E7EB;border-radius:6px;font:13px DM Sans,sans-serif;color:#0B2545">`}
          <label style="display:block;font-size:12px;font-weight:600;color:#374151;margin:14px 0 4px">${isWA ? "Message body" : "Plain-text body"} ${it.defaults.body_text ? "" : `<span style="color:#9CA3AF;font-weight:normal">(default is baked HTML — leave blank to use it)</span>`}</label>
          <textarea id="tpl-text" rows="12" placeholder="${esc(it.defaults.body_text || "(uses baked default)")}" style="width:100%;padding:10px 12px;border:1px solid #E5E7EB;border-radius:6px;font:12px/1.5 Menlo,Consolas,monospace;color:#0B2545;resize:vertical;min-height:200px">${esc(ovT)}</textarea>
          <div style="display:flex;justify-content:space-between;align-items:center;margin-top:18px;gap:10px">
            <button id="tpl-revert" style="background:transparent;color:#991B1B;border:1px solid #FCA5A5;padding:8px 16px;border-radius:6px;cursor:pointer;font:13px DM Sans,sans-serif">Revert to default</button>
            <div style="display:flex;gap:10px">
              <button id="tpl-cancel" style="background:transparent;color:#4B5563;border:1px solid #cbd5e1;padding:8px 16px;border-radius:6px;cursor:pointer;font:13px DM Sans,sans-serif">Cancel</button>
              <button id="tpl-save" style="background:#0B2545;color:#fff;border:none;padding:8px 22px;border-radius:6px;cursor:pointer;font:13px/1 DM Sans,sans-serif;font-weight:500">Save override</button>
            </div>
          </div>
          <p id="tpl-status" style="margin:10px 0 0;font-size:12px;color:#6B7280"></p>
        </div>`;
      document.body.appendChild(editor);
      editor.addEventListener("click", e => { if (e.target === editor) editor.remove(); });
      document.getElementById("tpl-edit-close").onclick = () => editor.remove();
      document.getElementById("tpl-cancel").onclick = () => editor.remove();
      document.getElementById("tpl-save").onclick = async () => {
        const subj = isWA ? "" : (document.getElementById("tpl-subj").value || "").trim();
        const text = (document.getElementById("tpl-text").value || "").trim();
        const status = document.getElementById("tpl-status");
        status.textContent = "Saving…";
        const r = await applyPut(`/api/apply/admin/templates/${it.key}`, { subject: subj, body_text: text, body_html: "" });
        if (r && r.ok) {
          status.style.color = "#166534";
          status.textContent = r.reverted ? "✓ Reverted to default" : `✓ Saved (by ${r.updated_by})`;
          setTimeout(() => { editor.remove(); load(); }, 600);
        } else {
          status.style.color = "#991B1B";
          status.textContent = "❌ " + (r?.error || "Save failed");
        }
      };
      document.getElementById("tpl-revert").onclick = async () => {
        if (!confirm("Revert to baked-in default? Any custom edits will be lost.")) return;
        const status = document.getElementById("tpl-status");
        status.textContent = "Reverting…";
        const r = await applyDelete(`/api/apply/admin/templates/${it.key}`);
        if (r && r.ok) { editor.remove(); load(); }
        else { status.style.color = "#991B1B"; status.textContent = "❌ " + (r?.error || "Revert failed"); }
      };
    }

    async function load() {
      const body = document.getElementById("tpl-body");
      body.innerHTML = `<div style="text-align:center;padding:32px;color:#6B7280;font-size:14px"><span class="spinner"></span> Loading…</div>`;
      try {
        const r = await applyGet("/api/apply/admin/templates");
        if (r.error) throw new Error(r.error);
        renderList(r.items || []);
      } catch (e) {
        body.innerHTML = `<div style="background:#FEE2E2;color:#991B1B;padding:14px;border-radius:8px;font-size:13px">Failed to load: ${e.message}</div>`;
      }
    }
    load();
  });

  // "JobStreet sourcing invite" — opens modal, takes a list of Name <email> lines, batch-sends via Brevo
  const jsInviteBtn = main.querySelector("#apply-jobstreet-invite");
  if (jsInviteBtn) jsInviteBtn.addEventListener("click", () => {
    const overlay = document.createElement("div");
    overlay.style.cssText = "position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:99999;display:flex;align-items:center;justify-content:center;padding:24px";
    overlay.innerHTML = `
      <div style="background:#fff;border-radius:16px;max-width:680px;width:100%;max-height:90vh;overflow-y:auto;padding:28px 32px;box-shadow:0 20px 60px rgba(0,0,0,.3)">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px">
          <h2 style="margin:0;font-family:'Cormorant Garamond',serif;font-size:24px;color:#0B2545">📧 Sourcing invite (SEEK / AJobThing)</h2>
          <button id="js-modal-close" style="background:none;border:none;font-size:24px;cursor:pointer;color:#9CA3AF">×</button>
        </div>
        <p style="margin:0 0 14px;color:#4B5563;font-size:14px;line-height:1.5">Paste the candidates from SEEK Inbox, one per line. Format: <code style="background:#F1F5F9;padding:2px 6px;border-radius:4px">Name &lt;email@example.com&gt;</code> &mdash; first-name greeting is auto-extracted. Email is sent from <b>career@lifa.com.my</b> via Brevo with <b>career@lifa.com.my</b> BCC'd.</p>
        <textarea id="js-paste" rows="10" placeholder="Fathin Sofea &lt;sofeafathin@gmail.com&gt;
Farhah Atiqah &lt;farhahatiqah@gmail.com&gt;
Fatin Umaira &lt;fatinumaira24@gmail.com&gt;
NUR AZITA &lt;nurazitashari@yahoo.com&gt;
Kalpana Devi &lt;kdevi1976@gmail.com&gt;
Fazrin Munirah &lt;fazrinmunirah@gmail.com&gt;" style="width:100%;padding:12px 14px;border:1px solid #E5E7EB;border-radius:8px;font:13px/1.5 Menlo,Consolas,monospace;resize:vertical;min-height:200px;color:#0B2545"></textarea>
        <div style="margin-top:12px">
          <label style="font-size:12px;color:#6B7280;display:block;margin-bottom:4px">Deadline (optional &mdash; default: 7 days from today)</label>
          <input id="js-deadline" type="text" placeholder="Tuesday, 19 May 2026" style="width:100%;padding:10px 12px;border:1px solid #E5E7EB;border-radius:8px;font:14px DM Sans,sans-serif;color:#0B2545"/>
        </div>
        <div id="js-preview" style="margin-top:14px"></div>
        <div style="display:flex;justify-content:flex-end;gap:10px;margin-top:18px">
          <button id="js-cancel" style="background:transparent;color:#4B5563;border:1px solid #cbd5e1;padding:10px 20px;border-radius:8px;cursor:pointer;font:14px DM Sans,sans-serif">Cancel</button>
          <button id="js-preview-btn" style="background:#F1F5F9;color:#0B2545;border:1px solid #cbd5e1;padding:10px 20px;border-radius:8px;cursor:pointer;font:14px/1 DM Sans,sans-serif;font-weight:500">Preview</button>
          <button id="js-send" style="background:#0B2545;color:#fff;border:none;padding:10px 22px;border-radius:8px;cursor:pointer;font:14px/1 DM Sans,sans-serif;font-weight:500">Send all →</button>
        </div>
        <p id="js-status" style="margin:12px 0 0;font-size:13px;color:#6B7280"></p>
      </div>`;
    document.body.appendChild(overlay);
    function parseList() {
      const lines = (document.getElementById("js-paste").value || "").split("\n").map(l => l.trim()).filter(Boolean);
      const out = [];
      for (const ln of lines) {
        // Format: "Name <email>" or "Name email" or just "email"
        const m = ln.match(/^(.*?)[\s<]+([^\s<>]+@[^\s<>]+)[>]?\s*$/);
        if (m) {
          let name = m[1].trim().replace(/[<>"]/g, "").trim();
          const email = m[2].trim().toLowerCase();
          // Greeting = full name, title-cased (AJobStreet/SEEK often gives ALL CAPS)
          const titled = name.split(/\s+/).map(w => w ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : w).join(" ");
          out.push({ name: titled || name || email.split("@")[0], email, fullName: name });
        } else if (/^[^\s<>]+@[^\s<>]+$/.test(ln)) {
          const email = ln.toLowerCase();
          const handle = email.split("@")[0];
          out.push({ name: handle.charAt(0).toUpperCase() + handle.slice(1), email, fullName: handle });
        }
      }
      return out;
    }
    document.getElementById("js-modal-close").onclick = () => overlay.remove();
    document.getElementById("js-cancel").onclick = () => overlay.remove();
    document.getElementById("js-preview-btn").onclick = () => {
      const list = parseList();
      const prev = document.getElementById("js-preview");
      if (!list.length) { prev.innerHTML = `<div style="color:#991B1B;background:#FEE2E2;padding:10px 14px;border-radius:6px;font-size:13px">No valid entries parsed. Use format: <code>Name &lt;email@x.com&gt;</code></div>`; return; }
      prev.innerHTML = `<div style="background:#FAFAF7;padding:12px 14px;border-radius:8px;font-size:13px;color:#0B2545"><b>${list.length} candidate${list.length===1?'':'s'}</b> parsed:<ul style="margin:6px 0 0;padding-left:18px;font-family:Menlo,Consolas,monospace;font-size:12px">${list.map(c => `<li>"Hi ${escapeHtml(c.name)}," &rarr; ${escapeHtml(c.email)}</li>`).join("")}</ul></div>`;
    };
    document.getElementById("js-send").onclick = async () => {
      const list = parseList();
      const status = document.getElementById("js-status");
      if (!list.length) { status.textContent = "❌ No valid entries to send."; status.style.color = "#991B1B"; return; }
      if (!confirm(`Send sourcing email to ${list.length} candidate${list.length===1?'':'s'} via Brevo (career@lifa.com.my)?\n\nFirst 3: ${list.slice(0,3).map(c => c.name + ' <' + c.email + '>').join(", ")}${list.length>3?'…':''}`)) return;
      document.getElementById("js-send").disabled = true;
      document.getElementById("js-send").textContent = "Sending…";
      status.textContent = "📤 Sending…"; status.style.color = "#0B2545";
      try {
        const deadline = (document.getElementById("js-deadline").value || "").trim() || undefined;
        const payload = { candidates: list.map(c => ({ name: c.name, email: c.email })), deadline };
        const res = await applyPost("/api/apply/admin/send-jobstreet-invite", payload);
        if (res.error) throw new Error(res.error);
        const sent = res.sent || 0, failed = res.failed || 0;
        status.innerHTML = `✅ Sent <b>${sent}</b> of ${res.total}${failed?` &mdash; <b style="color:#991B1B">${failed} failed</b>`:''}.<br/><span style="color:#6B7280;font-size:12px">Deadline: ${escapeHtml(res.deadline)}</span>${failed?`<br/><br/>Failed:<br/>${res.results.filter(r=>!r.ok).map(r=>`<code>${escapeHtml(r.email)}</code>: ${escapeHtml(r.error)}`).join("<br/>")}`:''}`;
        status.style.color = failed ? "#92400E" : "#166534";
        showToast(failed ? "error" : "success", `Sent ${sent}/${res.total}${failed?', '+failed+' failed':''}`);
        if (sent > 0) setTimeout(() => { overlay.remove(); renderApplicationsList(); }, 1800);
      } catch (e) {
        status.textContent = "❌ " + e.message; status.style.color = "#991B1B";
        showToast("error", "Send failed: " + e.message);
      }
      document.getElementById("js-send").disabled = false;
      document.getElementById("js-send").textContent = "Send all →";
    };
    overlay.addEventListener("click", e => { if (e.target === overlay) overlay.remove(); });
  });
  // "Invite all qualifying" — bulk send interview-invitation emails to all analysed rows with rec=maybe/hire
  const inviteAllBtn = main.querySelector("#apply-invite-all");
  if (inviteAllBtn) inviteAllBtn.addEventListener("click", async () => {
    const targets = allRows.filter(r => r.status === "analysed" && (r.recommendation === "maybe" || r.recommendation === "shortlist" || r.recommendation === "hire"));
    if (!targets.length) { showToast("warn", "No qualifying candidates (need status=analysed and rec=maybe/hire)."); return; }
    const names = targets.map(t => `• ${t.name} (overall ${t.overall_score ?? "?"}, ${t.recommendation})`).join("\n");
    if (!confirm(`Send interview-invitation email to ${targets.length} candidate${targets.length===1?'':'s'}?\n\n${names}\n\nStatus will move to "shortlisted" on success.`)) return;
    inviteAllBtn.disabled = true; const orig = inviteAllBtn.textContent; inviteAllBtn.textContent = "📧 Sending…";
    const results = [];
    for (const t of targets) {
      try {
        const res = await applyPost(`/api/apply/admin/applications/${encodeURIComponent(t.id)}/send-interview-invite`, {});
        results.push({ name: t.name, ok: !!res.sent, err: res.error });
      } catch (e) { results.push({ name: t.name, ok: false, err: e.message }); }
    }
    const sent = results.filter(r => r.ok).length;
    const failed = results.filter(r => !r.ok);
    if (failed.length === 0) showToast("success", `Sent ${sent} invite${sent===1?'':'s'}.`);
    else showToast("error", `Sent ${sent}, failed ${failed.length}: ${failed.map(f=>f.name+'('+f.err+')').join('; ')}`);
    inviteAllBtn.disabled = false; inviteAllBtn.textContent = orig;
    setTimeout(renderApplicationsList, 2000);
  });
  // Per-row "Invite to Interview" — sends interview-invitation email (analysed candidates with rec=maybe/hire)
  main.querySelectorAll(".apply-row-invite").forEach(b => b.addEventListener("click", async e => {
    e.stopPropagation();
    const id = b.dataset.appId, name = b.dataset.appName;
    if (!confirm(`Send interview-invitation email to ${name}?\n\nThey'll get an email asking them to pick video or walk-in.\nStatus will move to "shortlisted".`)) return;
    b.disabled = true; const orig = b.textContent; b.textContent = "📧 Sending…";
    try {
      const res = await applyPost(`/api/apply/admin/applications/${encodeURIComponent(id)}/send-interview-invite`, {});
      if (res.error) throw new Error(res.error);
      if (res.sent) showToast("success", `Invite sent to ${name} (${res.email})`);
      else showToast("error", `Failed: ${res.error || "unknown"}`);
    } catch (err) { showToast("error", "Failed: " + err.message); }
    b.disabled = false; b.textContent = orig;
    setTimeout(renderApplicationsList, 1500);
  }));
  // (row click is now wired via .apply-row above, replacing the old .apply-row-cell approach)
  // Inline delete
  main.querySelectorAll(".apply-row-del").forEach(b => b.addEventListener("click", async e => {
    e.stopPropagation();
    const id = b.dataset.appId; const name = b.dataset.appName;
    if (!confirm("Permanently delete the application for " + name + "?\nThis removes everything: particulars, videos, transcripts, assessment, AI analysis. Cannot be undone.")) return;
    b.disabled = true; b.innerText = "…";
    try {
      const r = await applyDelete("/api/apply/admin/applications/" + encodeURIComponent(id));
      if (r.error) throw new Error(r.error);
      showToast("success", "Deleted " + name);
      renderApplicationsList();
    } catch (err) {
      showToast("error", err.message);
      b.disabled = false; b.innerText = "Delete";
    }
  }));
  main.querySelectorAll(".apply-row-reject").forEach(b => b.addEventListener("click", e => {
    e.stopPropagation();
    const id = b.dataset.appId; const name = b.dataset.appName;
    const reasons = [["low_score","Low score"],["fail_background_check","Fail background check"],["no_show","No show"],["other_job_offer","Other job offer"],["fail_interview","Fail interview"],["other","Other"]];
    const overlay = document.createElement("div");
    overlay.style.cssText = "position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9000;display:flex;align-items:center;justify-content:center";
    overlay.innerHTML = `<div style="background:#fff;border-radius:14px;padding:28px 32px;max-width:380px;width:90%;box-shadow:0 8px 40px rgba(0,0,0,.2)">
      <h3 style="margin:0 0 4px;font-size:17px;color:#0B2545">Reject ${name.split(' ')[0]}?</h3>
      <p style="margin:0 0 16px;font-size:13px;color:#6B7280">Pick a reason — optional, you can skip it.</p>
      ${reasons.map(([k,v]) => `<label style="display:flex;align-items:center;gap:10px;padding:9px 12px;border:1.5px solid #E2E8F0;border-radius:8px;margin-bottom:8px;cursor:pointer;font-size:14px"><input type="radio" name="rej_reason_row" value="${k}" style="accent-color:#991B1B"> ${v}</label>`).join("")}
      <textarea id="rej-row-note" placeholder="Add a note (optional) — saved to the candidate's remark" style="width:100%;box-sizing:border-box;min-height:54px;padding:8px 10px;border:1px solid #E2E8F0;border-radius:8px;font:inherit;font-size:13px;resize:vertical;margin-top:4px"></textarea>
      <div style="display:flex;gap:10px;margin-top:18px">
        <button id="rej-row-cancel" style="flex:1;padding:10px;border:1px solid #E2E8F0;background:#fff;border-radius:8px;cursor:pointer;font:inherit;font-size:14px">Cancel</button>
        <button id="rej-row-confirm" style="flex:1;padding:10px;background:#991B1B;color:#fff;border:none;border-radius:8px;cursor:pointer;font:inherit;font-size:14px;font-weight:600">Confirm rejection</button>
      </div>
    </div>`;
    document.body.appendChild(overlay);
    overlay.querySelector("#rej-row-cancel").addEventListener("click", () => document.body.removeChild(overlay));
    overlay.querySelector("#rej-row-confirm").addEventListener("click", async () => {
      const chosen = overlay.querySelector("input[name=rej_reason_row]:checked");
      const note = (overlay.querySelector("#rej-row-note").value || "").trim();
      document.body.removeChild(overlay);
      b.disabled = true; b.textContent = "…";
      try {
        const r = await applyPut("/api/apply/admin/applications/" + encodeURIComponent(id) + "/status", { status: "rejected", rejection_reason: chosen ? chosen.value : undefined, admin_remark: note || undefined });
        if (r.error) throw new Error(r.error);
        showToast("success", name.split(' ')[0] + " rejected");
        renderApplicationsList();
      } catch (err) { showToast("error", err.message); b.disabled = false; b.textContent = "✗ Reject"; }
    });
  }));
  main.querySelectorAll(".apply-row-hire").forEach(b => b.addEventListener("click", e => {
    e.stopPropagation();
    const id = b.dataset.appId; const name = b.dataset.appName;
    const overlay = document.createElement("div");
    overlay.style.cssText = "position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9000;display:flex;align-items:center;justify-content:center";
    overlay.innerHTML = `<div style="background:#fff;border-radius:14px;padding:28px 32px;max-width:380px;width:90%;box-shadow:0 8px 40px rgba(0,0,0,.2)">
      <h3 style="margin:0 0 4px;font-size:17px;color:#0B2545">Hire ${name.split(' ')[0]}?</h3>
      <p style="margin:0 0 14px;font-size:13px;color:#6B7280">Marks them Hired and moves them out of the Interview stage.</p>
      <textarea id="hire-row-note" placeholder="Add a note (optional) — e.g. interview impressions, start date" style="width:100%;box-sizing:border-box;min-height:64px;padding:8px 10px;border:1px solid #E2E8F0;border-radius:8px;font:inherit;font-size:13px;resize:vertical"></textarea>
      <div style="display:flex;gap:10px;margin-top:18px">
        <button id="hire-row-cancel" style="flex:1;padding:10px;border:1px solid #E2E8F0;background:#fff;border-radius:8px;cursor:pointer;font:inherit;font-size:14px">Cancel</button>
        <button id="hire-row-confirm" style="flex:1;padding:10px;background:#166534;color:#fff;border:none;border-radius:8px;cursor:pointer;font:inherit;font-size:14px;font-weight:600">Confirm hire</button>
      </div>
    </div>`;
    document.body.appendChild(overlay);
    overlay.querySelector("#hire-row-cancel").addEventListener("click", () => document.body.removeChild(overlay));
    overlay.querySelector("#hire-row-confirm").addEventListener("click", async () => {
      const note = (overlay.querySelector("#hire-row-note").value || "").trim();
      document.body.removeChild(overlay);
      b.disabled = true; b.textContent = "…";
      try {
        const r = await applyPut("/api/apply/admin/applications/" + encodeURIComponent(id) + "/status", { status: "hired", admin_remark: note || undefined });
        if (r.error) throw new Error(r.error);
        showToast("success", name.split(' ')[0] + " hired 🎉");
        renderApplicationsList();
      } catch (err) { showToast("error", err.message); b.disabled = false; b.textContent = "✓ Hire"; }
    });
  }));
}

function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }

function _safeJson(s) { try { return JSON.parse(s); } catch { return null; } }
function _fmtMonth(s) { if (!s) return ""; const d = new Date(s + "-01"); return isNaN(d) ? s : d.toLocaleDateString("en-GB", { month: "short", year: "numeric" }); }

function renderParticularsBlock(p) {
  if (!p) return '<div style="background:#fff;padding:24px;border-radius:12px;box-shadow:0 4px 24px rgba(11,37,69,.06);margin-bottom:20px;color:#9CA3AF">No particulars submitted yet.</div>';
  const langs = _safeJson(p.languages_json) || [];
  const emp   = _safeJson(p.employment_history_json) || [];
  const refs  = _safeJson(p.references_json) || [];
  const cell = (k,v) => `<div><div style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#9CA3AF">${k}</div><div>${escapeHtml(v) || '—'}</div></div>`;
  const subhead = t => `<h4 style="font-family:Cormorant Garamond,serif;font-size:18px;margin:20px 0 10px;border-bottom:1px solid #E5E7EB;padding-bottom:6px">${t}</h4>`;
  return `
    <div style="background:#fff;padding:24px;border-radius:12px;box-shadow:0 4px 24px rgba(11,37,69,.06);margin-bottom:20px">
      <h3 style="font-family:Cormorant Garamond,serif;font-size:22px;margin-bottom:4px">Particulars</h3>

      ${subhead("Personal")}
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px 28px;font-size:14px">
        ${cell("IC No.", p.ic_no)}
        ${cell("DOB", p.dob)}
        ${cell("Age", p.age)}
        ${cell("Gender", p.gender)}
        ${cell("Nationality", p.nationality)}
        ${cell("Marital Status", p.marital_status)}
        ${cell("Children", p.number_of_children)}
        ${cell("Own transport", p.has_own_transport ? "Yes" : "No")}
      </div>

      ${subhead("Address")}
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px 28px;font-size:14px">
        ${cell("Address", [p.address, p.city, p.state, p.postcode].filter(Boolean).join(", "))}
        ${p.state === "Johor"
          ? cell("Travel time to Taman Molek (mins)", p.travel_time_minutes)
          : cell("Willing to relocate to JB", (p.relocate_to_jb ? `Yes${p.relocate_notice_days ? ` (${p.relocate_notice_days} days notice)` : ''}` : "No"))}
      </div>

      ${subhead("Education")}
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px 28px;font-size:14px">
        ${cell("Highest qualification", p.highest_education)}
        ${cell("Field of study", p.field_of_study)}
        ${cell("Institution", p.institution)}
        ${cell("Graduation year", p.graduation_year)}
      </div>

      ${subhead("Languages")}
      ${langs.length === 0 ? '<div style="color:#9CA3AF;font-size:13px">—</div>' :
        '<div style="display:flex;flex-wrap:wrap;gap:8px">' +
        langs.map(l => `<span style="padding:5px 12px;background:#F1F5F9;border-radius:20px;font-size:13px"><b>${escapeHtml(l.language)}</b> <span style="color:#6B7280">· ${escapeHtml(l.fluency)}</span></span>`).join("") +
        '</div>'}

      ${subhead("Employment History")}
      ${emp.length === 0 ? '<div style="color:#9CA3AF;font-size:13px">No prior roles entered.</div>' :
        emp.map((r, i) => `
          <div style="background:#FAFAF7;padding:14px 16px;border-radius:10px;margin-bottom:10px;border-left:3px solid #B8962E">
            <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:12px;flex-wrap:wrap">
              <div>
                <div style="font-weight:600">${escapeHtml(r.position) || '—'} <span style="color:#6B7280;font-weight:400">@ ${escapeHtml(r.company) || '—'}</span></div>
                <div style="font-size:12px;color:#6B7280;margin-top:2px">${_fmtMonth(r.start)} – ${r.present ? "Present" : (_fmtMonth(r.end) || '—')}</div>
              </div>
              <div style="font-size:13px;color:#374151">${r.salary ? "RM " + Number(r.salary).toLocaleString() + "/mo" : ""}</div>
            </div>
            ${r.scope ? `<div style="font-size:13px;margin-top:8px;line-height:1.5"><b style="color:#9CA3AF;font-size:11px;letter-spacing:.06em;text-transform:uppercase">Scope:</b> ${escapeHtml(r.scope)}</div>` : ""}
            ${r.reason ? `<div style="font-size:13px;margin-top:4px;color:#6B7280"><b style="color:#9CA3AF;font-size:11px;letter-spacing:.06em;text-transform:uppercase">Reason for leaving:</b> ${escapeHtml(r.reason)}</div>` : ""}
          </div>`).join("")}

      ${subhead("Compensation & Availability")}
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px 28px;font-size:14px">
        ${cell("Currently employed", p.currently_employed ? "Yes" : "No")}
        ${cell("Years experience", p.years_experience)}
        ${cell("Current salary (RM)", p.current_salary != null ? Number(p.current_salary).toLocaleString() : null)}
        ${cell("Expected salary (RM)", p.expected_salary != null ? Number(p.expected_salary).toLocaleString() : null)}
        ${cell("Notice period (days)", p.notice_period_days)}
        ${cell("Earliest start", p.earliest_start_date)}
      </div>

      ${subhead("References")}
      ${refs.length === 0 ? '<div style="color:#9CA3AF;font-size:13px">—</div>' :
        '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px">' +
        refs.map((r, i) => `
          <div style="background:#FAFAF7;padding:12px 16px;border-radius:10px;border-left:3px solid ${r.is_new ? '#16A34A' : '#0EA5E9'}">
            <div style="font-weight:600">${escapeHtml(r.name) || '—'} ${r.is_new ? '<span style="background:#DCFCE7;color:#166534;padding:1px 7px;border-radius:10px;font-size:10px;font-weight:700;vertical-align:middle">\u{1F195} NEW</span>' : ''}</div>
            <div style="font-size:13px;color:#6B7280">${escapeHtml(r.position) || ''}${r.company ? ' · ' + escapeHtml(r.company) : ''}</div>
            <div style="font-size:13px;margin-top:4px"><a href="tel:${escapeHtml(r.phone)}" style="color:#0B2545">${escapeHtml(r.phone) || '—'}</a></div>
            ${r.relationship ? `<div style="font-size:12px;color:#9CA3AF;margin-top:2px">${escapeHtml(r.relationship)}</div>` : ""}
          </div>`).join("") +
        '</div>'}
    </div>`;
}

async function renderApplicationDetail(id) {
  const main = document.getElementById("main-content");
  main.innerHTML = '<div style="padding:24px"><a href="#" onclick="showView(\'applications\');return false" style="color:#0B2545;font-size:13px">← Back to applications</a><p style="margin-top:16px;color:#6B7280">Loading…</p></div>';
  let d, wa;
  try { d = await applyGet("/api/apply/admin/applications/" + encodeURIComponent(id)); if (d.error) throw new Error(d.error); }
  catch (e) { main.innerHTML = '<div style="padding:24px"><div style="background:#FEE2E2;color:#991B1B;padding:12px 16px;border-radius:8px">'+e.message+'</div></div>'; return; }
  // Fetch WhatsApp activity in parallel — non-blocking, missing data is fine
  try { wa = await applyGet("/api/apply/admin/applications/" + encodeURIComponent(id) + "/whatsapp"); } catch { wa = null; }
  const a = d.application || {};
  const p = d.particulars || null;
  const an = d.analysis || null;
  const as = d.assessment || null;
  const iv = d.interview || { questions:[], responses:[] };
  const respByQ = {};
  for (const r of iv.responses || []) respByQ[r.q_index] = r;

  const willScore = an?.will_score != null ? Number(an.will_score) : null;
  const skillScore = an?.skill_score != null ? Number(an.skill_score) : null;
  const overallScore = an?.overall_score != null ? Number(an.overall_score) : null;
  const isWA = a.role === "wealth_advisor";

  const scorePill = (label, val, sub) => `
    <div style="flex:1;min-width:160px;background:#FAFAF7;padding:16px;border-radius:10px;text-align:center;border:1px solid #E5E7EB">
      <div style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6B7280;font-weight:600">${label}</div>
      <div style="font-size:32px;font-weight:600;color:#0B2545;margin-top:4px;font-family:Cormorant Garamond,serif">${val == null ? '—' : Number(val).toFixed(0)}</div>
      <div style="font-size:11px;color:#9CA3AF">${sub || '/100'}</div>
    </div>`;

  // Parse the AI raw to surface per-competency scores
  let willComp = {}, skillComp = {}, lcsiData = null;
  try {
    if (an?.raw_json) {
      const m = an.raw_json.match(/\{[\s\S]*\}/);
      if (m) {
        const parsed = JSON.parse(m[0]);
        willComp = parsed.will || {};
        skillComp = parsed.skill || {};
        if (parsed.lcsi) lcsiData = parsed;
      }
    }
  } catch {}
  const compRow = obj => Object.entries(obj || {}).map(([k,v]) =>
    `<div style="display:flex;justify-content:space-between;padding:8px 12px;border-bottom:1px solid #F1F5F9;font-size:13px">
       <span style="text-transform:capitalize;color:#374151">${escapeHtml(k.replace(/_/g, ' '))}</span>
       <span style="font-weight:600;color:#0B2545">${v}<span style="color:#9CA3AF;font-size:11px">/5</span></span>
     </div>`).join("");

  // Stage1 + Stage2 split
  const s1Qs = (iv.questions || []).filter(q => q.stage === 1);
  const s2Qs = (iv.questions || []).filter(q => q.stage === 2);

  const renderInterviewQ = (q) => {
    const r = respByQ[q.q_index] || {};
    const isText = (q.mode || r.mode) === 'text';
    const modePill = isText
      ? '<span style="background:#DBEAFE;color:#1E40AF;padding:2px 8px;border-radius:20px;font-size:10px;font-weight:600;letter-spacing:.06em">TEXT</span>'
      : '<span style="background:#FEE2E2;color:#991B1B;padding:2px 8px;border-radius:20px;font-size:10px;font-weight:600;letter-spacing:.06em">VIDEO</span>';
    let body = '';
    if (isText) {
      body = `
        <div style="background:#F1F5F9;padding:12px 16px;border-radius:10px;margin-bottom:8px"><b style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6B7280">Candidate's answer</b><br><span style="font-size:14px;line-height:1.6;white-space:pre-wrap">${escapeHtml(r.text_answer) || '<i style="color:#9CA3AF">(none)</i>'}</span></div>
        ${r.ai_probe ? `<div style="background:#FEF3C7;padding:12px 16px;border-radius:10px;margin-bottom:8px;border-left:3px solid #F59E0B"><b style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#92400E">AI Probe</b><br><span style="font-size:14px;line-height:1.6">${escapeHtml(r.ai_probe)}</span></div>` : ''}
        ${r.text_followup ? `<div style="background:#F1F5F9;padding:12px 16px;border-radius:10px"><b style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6B7280">Candidate's follow-up</b><br><span style="font-size:14px;line-height:1.6;white-space:pre-wrap">${escapeHtml(r.text_followup)}</span></div>` : '<div style="color:#9CA3AF;font-style:italic;font-size:13px">No follow-up answered</div>'}
      `;
    } else {
      body = r.video_key
        ? `<video controls preload="metadata" style="width:100%;max-width:480px;border-radius:8px;background:#111" data-vid-key="${escapeHtml(r.video_key)}"><div style="color:#9CA3AF;font-size:12px;padding:6px;text-align:center">Loading video…</div></video>
           <div style="margin-top:8px;font-size:13px;color:#374151;background:#FAFAF7;padding:10px 14px;border-radius:8px;border-left:3px solid #B8962E">
             <b style="font-size:11px;letter-spacing:.06em;text-transform:uppercase;color:#6B7280">Transcript</b><br>${escapeHtml(r.transcript) || '<span style="color:#9CA3AF">(not transcribed)</span>'}
           </div>`
        : '<div style="color:#9CA3AF;font-style:italic">No response recorded</div>';
    }
    return `
      <div style="padding:18px 0;border-top:1px solid #E5E7EB">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;gap:8px;flex-wrap:wrap">
          <div style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#B8962E;font-weight:600">Q${(q.q_index % 5) + 1} · ${escapeHtml(q.category)}</div>
          ${modePill}
        </div>
        <div style="font-weight:500;margin-bottom:12px;line-height:1.5">${escapeHtml(q.question)}</div>
        ${body}
      </div>`;
  };

  // Assessment
  const assessTasks   = as?.tasks_json        ? _safeJson(as.tasks_json)        : null;
  const assessScores  = as?.tasks_scores_json ? _safeJson(as.tasks_scores_json) : {};

  main.innerHTML = `
    <div style="padding:24px;max-width:1100px">
      <a href="#" onclick="showView('applications');return false" style="color:#0B2545;font-size:13px;text-decoration:none">← Back to applications</a>

      <div style="display:flex;justify-content:space-between;align-items:flex-start;margin:14px 0 24px;flex-wrap:wrap;gap:12px">
        <div>
          <h2 style="font-family:Cormorant Garamond,serif;font-size:30px">${escapeHtml(a.name)}</h2>
          <div style="color:#6B7280;font-size:14px">
            <span style="font-family:monospace">${a.id}</span> ·
            ${APPLY_ROLE_LABEL[a.role] || a.role} ·
            ${escapeHtml(a.email)} · ${escapeHtml(a.phone)}
          </div>
          ${a.interview_preference === 'walk_in' && a.interview_appointment_at ? `
            <div style="margin-top:12px;background:${a.interview_appointment_status === 'confirmed' ? '#DCFCE7' : a.interview_appointment_status === 'rejected' ? '#FEE2E2' : '#FEF3C7'};border:1px solid ${a.interview_appointment_status === 'confirmed' ? '#16A34A' : a.interview_appointment_status === 'rejected' ? '#DC2626' : '#F59E0B'};border-radius:8px;padding:10px 14px;display:flex;align-items:center;gap:12px;flex-wrap:wrap">
              <div style="font-size:24px">${a.interview_appointment_status === 'confirmed' ? '✅' : a.interview_appointment_status === 'rejected' ? '🔁' : (a.appt_rescheduled ? '🔁' : '⏳')}</div>
              <div style="flex:1;font-size:13px;color:${a.interview_appointment_status === 'confirmed' ? '#166534' : a.interview_appointment_status === 'rejected' ? '#991B1B' : '#92400E'};line-height:1.4">
                ${a.appt_rescheduled ? `<span style="display:inline-block;background:#1E40AF;color:#fff;font-size:10px;font-weight:700;padding:2px 8px;border-radius:10px;margin-bottom:5px;letter-spacing:.03em">🔁 CANDIDATE RESCHEDULED</span><br/>` : ''}
                <b>Walk-in ${a.interview_appointment_status === 'confirmed' ? 'CONFIRMED' : a.interview_appointment_status === 'rejected' ? 'REJECTED' : (a.appt_rescheduled ? 'changed by candidate — needs your RE-approval' : 'REQUESTED — needs your approval')}</b><br/>
                ${a.appt_rescheduled && a.appt_prev_at ? `<span style="color:#991B1B;font-size:12px">Was <s>${escapeHtml(new Date(a.appt_prev_at*1000).toLocaleString('en-MY', {timeZone:'Asia/Kuala_Lumpur',weekday:'short',day:'numeric',month:'short',hour:'numeric',minute:'2-digit',hour12:true}))}</s></span> → <br/>` : ''}
                📅 <b>${escapeHtml(new Date(a.interview_appointment_at*1000).toLocaleString('en-MY', {timeZone:'Asia/Kuala_Lumpur',weekday:'long',day:'numeric',month:'long',year:'numeric',hour:'numeric',minute:'2-digit',hour12:true}))}</b> (Malaysia time)
              </div>
              ${a.interview_appointment_status !== 'confirmed' ? `<button id="appt-confirm" style="background:#16A34A;color:#fff;border:none;padding:8px 14px;border-radius:6px;cursor:pointer;font:inherit;font-size:13px;font-weight:500">✓ Confirm</button>` : ''}
              ${a.interview_appointment_status !== 'rejected' ? `<button id="appt-reject" style="background:#fff;color:#991B1B;border:1px solid #FCA5A5;padding:8px 14px;border-radius:6px;cursor:pointer;font:inherit;font-size:13px">Reject</button>` : ''}
            </div>` : ''}
        </div>
        <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">
          ${an && an.matrix ? APPLY_MATRIX_BADGE[an.matrix] || '' : ''}
          ${an && an.recommendation ? APPLY_REC_BADGE[an.recommendation] || '' : ''}
          <select id="apply-status" style="padding:8px 12px;border:1px solid #e2e8f0;border-radius:8px;font:inherit;font-size:13px">
            ${Object.entries(APPLY_STATUS_LABEL).filter(([k]) => APPLY_SETTABLE_STATUS.has(k) || a.status === k).map(([k,v]) => `<option value="${k}" ${a.status===k?'selected':''}>${v}</option>`).join("")}
          </select>
          <button class="btn-secondary" id="apply-reanalyse" style="padding:8px 14px;border:1px solid #cbd5e1;background:#fff;border-radius:8px;cursor:pointer;font:inherit;font-size:13px">🔁 Re-analyse</button>
          <details style="position:relative">
            <summary style="list-style:none;padding:8px 14px;border:1.5px solid #E2E8F0;background:#fff;color:#374151;border-radius:8px;cursor:pointer;font-size:14px;line-height:1;user-select:none" title="More actions">⋯</summary>
            <div style="position:absolute;right:0;top:110%;z-index:600;background:#fff;border:1px solid #E2E8F0;border-radius:10px;box-shadow:0 8px 28px rgba(0,0,0,.14);padding:8px;display:flex;flex-direction:column;gap:6px;min-width:210px">
              <button id="apply-share-link" style="padding:8px 14px;border:1px solid #0B2545;background:#fff;color:#0B2545;border-radius:8px;cursor:pointer;font:inherit;font-size:13px;text-align:left" title="Email a read-only 7-day share link to a 3rd party">📧 Email to 3rd party</button>
              <button id="apply-delete-videos" style="padding:8px 14px;border:1px solid #FCA5A5;background:#fff;color:#991B1B;border-radius:8px;cursor:pointer;font:inherit;font-size:13px;text-align:left">🗑 Delete videos</button>
              <button id="apply-delete-app" style="padding:8px 14px;border:1px solid #DC2626;background:#fff;color:#DC2626;border-radius:8px;cursor:pointer;font:inherit;font-size:13px;text-align:left">🗑 Delete profile</button>
            </div>
          </details>
        </div>
      </div>

      ${_renderProgressBlock(_buildProgress(a, p, as, iv), a)}

      ${renderParticularsBlock(p)}

      ${(function(){
        // Hiring for — own firm (default) or a third party (owner ruling 2026-09-09).
        // Third party: bg-check pass → hirer decides Proceed/Reject → ticks Zoom slots → candidate books.
        var tp = Number(a.third_party||0)===1;
        var esc = function(x){ return String(x==null?'':x).replace(/[<>&"]/g,function(c){return {'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[c];}); };
        var dt = function(ts){ return ts ? new Date(ts*1000).toLocaleString('en-MY',{timeZone:'Asia/Kuala_Lumpur',day:'2-digit',month:'short',hour:'numeric',minute:'2-digit'}) : ''; };
        var hdr = '<div style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6B7280;font-weight:700;margin-bottom:8px">Hiring for</div>';
        var status = '';
        if (tp) {
          var slots = []; try { slots = JSON.parse(a.tp_slots_json||'[]'); } catch(e) {}
          if (a.status==='rejected' && a.rejection_reason==='third_party_reject') status = '<div style="color:#991B1B;font-weight:600">&#10007; '+esc(a.tp_name)+' rejected this candidate'+(a.tp_decision_at?' on '+dt(a.tp_decision_at):'')+'</div>';
          else if (a.interview_appointment_status==='confirmed' && a.interview_mode==='zoom') status = '<div style="color:#166534;font-weight:600">&#10003; Zoom interview booked — '+esc(dt(a.interview_appointment_at))+'</div>'+(a.zoom_join_url?'<div style="font-size:12px;margin-top:3px"><a href="'+esc(a.zoom_join_url)+'" target="_blank" rel="noopener">Zoom link</a></div>':'<div style="font-size:12px;color:#92400E;margin-top:3px">Zoom link not created — check events.</div>');
          else if (a.tp_decision==='proceed' && slots.length) status = '<div style="color:#1E40AF;font-weight:600">&#9203; '+esc(a.tp_name)+' ticked '+slots.length+' slot'+(slots.length>1?'s':'')+' — candidate invited to book'+(a.interview_invite_sent_at?' on '+dt(a.interview_invite_sent_at):'')+'</div><div style="font-size:12px;color:#6B7280;margin-top:3px">Candidate gets up to 2 reminders, 3 days apart.</div>';
          else if (a.tp_decision==='proceed') status = '<div style="color:#92400E;font-weight:600">&#9203; '+esc(a.tp_name)+' said PROCEED — waiting for their available slots</div><div style="font-size:12px;color:#6B7280;margin-top:3px">Daily reminder runs automatically.</div>';
          else if (a.tp_decision==='pending') status = '<div style="color:#92400E;font-weight:600">&#9203; Sent to '+esc(a.tp_name)+' for Proceed / Reject'+(a.tp_request_sent_at?' on '+dt(a.tp_request_sent_at):'')+'</div><div style="font-size:12px;color:#6B7280;margin-top:3px">Daily reminder runs automatically'+(a.tp_reminder_count?' ('+a.tp_reminder_count+' sent)':'')+'.</div>';
          else status = '<div style="font-size:12px;color:#6B7280">After the background check passes, '+esc(a.tp_name)+' will be asked to Proceed or Reject, then tick Zoom slots.</div>';
        }
        var resend = (tp && a.status!=='rejected' && a.tp_decision && !(a.interview_appointment_status==='confirmed')) ? '<button id="tp-resend" style="margin-top:10px;padding:7px 14px;border:1px solid #0B2545;background:#fff;color:#0B2545;border-radius:8px;cursor:pointer;font:inherit;font-size:12px;font-weight:600">Resend to '+esc(a.tp_name)+'</button>' : '';
        var form = '<div id="tp-form" style="display:'+(tp?'block':'none')+';margin-top:10px">'
          +'<div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px">'
          +'<input id="tp-name" placeholder="Hirer name" value="'+esc(a.tp_name)+'" style="padding:8px 10px;border:1px solid #CBD5E1;border-radius:8px;font:inherit;font-size:13px">'
          +'<input id="tp-email" placeholder="Hirer email" value="'+esc(a.tp_email)+'" style="padding:8px 10px;border:1px solid #CBD5E1;border-radius:8px;font:inherit;font-size:13px">'
          +'<input id="tp-phone" placeholder="Hirer WhatsApp (+65…)" value="'+esc(a.tp_phone)+'" style="padding:8px 10px;border:1px solid #CBD5E1;border-radius:8px;font:inherit;font-size:13px">'
          +'</div><button id="tp-save" style="margin-top:8px;padding:8px 16px;border:none;background:#0B2545;color:#fff;border-radius:8px;cursor:pointer;font:inherit;font-size:13px;font-weight:600">Save hirer</button></div>';
        var toggle = '<label style="font-size:13px;display:flex;align-items:center;gap:8px;cursor:pointer"><input type="checkbox" id="tp-toggle" '+(tp?'checked':'')+'> Hiring for a <b>third party</b> (not our own firm)</label>';
        return '<div style="background:'+(tp?'#EEF2FF':'#F8FAFC')+';border:1px solid '+(tp?'#C7D2FE':'#E5E7EB')+';border-radius:12px;padding:16px 20px;margin-bottom:20px">'+hdr+toggle+form+(status?'<div style="margin-top:12px;font-size:13px">'+status+'</div>':'')+resend+'</div>';
      })()}

      ${(function(){
        var s = a.bg_check_status;
        var dt = function(ts){ return ts ? new Date(ts*1000).toLocaleDateString('en-MY',{day:'2-digit',month:'short'}) : ''; };
        var box = function(inner,bg,bd){ return '<div style="background:'+bg+';border:1px solid '+bd+';border-radius:12px;padding:16px 20px;margin-bottom:20px">'+inner+'</div>'; };
        var hdr = '<div style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6B7280;font-weight:700;margin-bottom:8px">Background check</div>';
        if(s==='passed'){
          return box(hdr+'<div style="font-size:14px;color:#166534;font-weight:600">&#10003; Passed'+(a.bg_check_confirmed_at?' on '+dt(a.bg_check_confirmed_at):'')+'</div>'+(a.interview_invite_sent_at?'<div style="font-size:12px;color:#374151;margin-top:4px">Candidate invited to face-to-face interview on '+dt(a.interview_invite_sent_at)+' (email + WhatsApp).</div>':''),'#F0FDF4','#BBF7D0');
        }
        if(s==='failed'){
          return box(hdr+'<div style="font-size:14px;color:#991B1B;font-weight:600">&#10007; Did not pass'+(a.bg_check_confirmed_at?' on '+dt(a.bg_check_confirmed_at):'')+'</div><div style="font-size:12px;color:#6B7280;margin-top:4px">No interview invite was sent.</div>','#FEF2F2','#FECACA');
        }
        if(s==='sent'){
          return box(hdr+'<div style="font-size:14px;color:#92400E;font-weight:600">&#9203; Sent to Pavithra'+(a.bg_check_sent_at?' on '+dt(a.bg_check_sent_at):'')+' — awaiting her confirmation</div><div style="font-size:12px;color:#6B7280;margin-top:4px">Daily urgent reminders run automatically'+(a.bg_check_reminder_count?' ('+a.bg_check_reminder_count+' sent)':'')+'. On pass, the candidate is auto-invited to interview.</div><button id="apply-bgcheck" style="margin-top:10px;padding:7px 14px;border:1px solid #0B2545;background:#fff;color:#0B2545;border-radius:8px;cursor:pointer;font:inherit;font-size:12px;font-weight:600">Resend to Pavithra</button>','#FFFBEB','#FDE68A');
        }
        var hot = (overallScore!=null && overallScore>55);
        return box(hdr+'<div style="font-size:13px;color:#374151;margin-bottom:10px">'+(hot?'Score above 55 — ready for background check.':'Not yet sent for background check.')+'</div><button id="apply-bgcheck" style="padding:9px 18px;border:none;background:#0B2545;color:#fff;border-radius:8px;cursor:pointer;font:inherit;font-size:13px;font-weight:600">&#128203; Send to Pavithra for background check</button>', hot?'#FEFCE8':'#F8FAFC', hot?'#FDE68A':'#E5E7EB');
      })()}

      ${an ? `
        <div style="background:#fff;padding:24px;border-radius:12px;box-shadow:0 4px 24px rgba(11,37,69,.06);margin-bottom:20px">
          <h3 style="font-family:Cormorant Garamond,serif;font-size:22px;margin-bottom:14px">AI Hiring Analysis</h3>
          ${isWA ? (() => {
            const lcsiTraitNames = {COA:"Coachability",RES:"Resilience",INI:"Initiative",CON:"Conscientiousness",COM:"Compliance Mindset",EMP:"Client Empathy",PRO:"Problem Solving",SAL:"Sales Grit"};
            const traits = lcsiData?.fc_traits || assessScores.fc_traits || {};
            const ci = lcsiData?.consistency_index ?? assessScores.consistency_index ?? null;
            const biasF = (lcsiData?.bias_flags || assessScores.bias_flags || []);
            const riskF = (lcsiData?.risk_flags || []);
            const tier  = lcsiData?.recommendation_tier || '';
            const tierColor = tier.includes("Fast") ? "#166534" : tier.includes("Proceed") ? "#1E40AF" : tier.includes("Borderline") ? "#92400E" : "#991B1B";
            const traitBar = (code, val) => `
              <div>
                <div style="display:flex;justify-content:space-between;font-size:12px;margin-bottom:3px">
                  <span style="color:#374151">${lcsiTraitNames[code]||code}</span>
                  <span style="font-weight:600;color:${val>=75?'#166534':val>=60?'#92400E':'#991B1B'}">${val??'—'}</span>
                </div>
                <div style="height:6px;background:#E5E7EB;border-radius:3px">
                  <div style="width:${Math.min(val||0,100)}%;height:100%;background:${val>=75?'#16A34A':val>=60?'#F59E0B':'#DC2626'};border-radius:3px"></div>
                </div>
              </div>`;
            return `
              <div style="display:flex;gap:12px;margin-bottom:18px;flex-wrap:wrap">
                ${scorePill("FC Overall (50%)", willScore)}
                ${scorePill("SJT Overall (35%)", skillScore)}
                ${scorePill("Final Score", overallScore)}
                <div style="flex:1;min-width:160px;background:#FAFAF7;padding:16px;border-radius:10px;text-align:center;border:1px solid #E5E7EB;display:flex;flex-direction:column;justify-content:center">
                  <div style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6B7280;font-weight:600;margin-bottom:8px">LCSI Tier</div>
                  <div style="font-size:13px;font-weight:600;color:${tierColor}">${tier||'—'}</div>
                </div>
              </div>
              ${Object.keys(traits).length ? `
                <div style="margin-bottom:18px">
                  <div style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6B7280;font-weight:600;margin-bottom:10px">Trait Profile</div>
                  <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px 24px">
                    ${Object.entries(traits).map(([k,v])=>traitBar(k,v)).join("")}
                  </div>
                </div>` : ''}
              ${ci !== null ? `<div style="font-size:13px;color:#374151;margin-bottom:6px">Consistency Index: <b style="color:${ci>=85?'#166534':ci>=70?'#92400E':'#991B1B'}">${ci}/100</b></div>` : ''}
              ${biasF.length ? `<div style="font-size:13px;color:#92400E;margin-bottom:6px">⚠ ${biasF.join(' · ')}</div>` : ''}
              ${riskF.length ? `<div style="margin-bottom:10px">${riskF.map(f=>`<div style="font-size:12px;background:#FEF2F2;border:1px solid #FECACA;border-radius:6px;padding:6px 10px;margin-bottom:4px;color:#991B1B">⛔ ${escapeHtml(f)}</div>`).join("")}</div>` : ''}`;
          })() : `
          <div style="display:flex;gap:12px;margin-bottom:18px;flex-wrap:wrap">
            ${scorePill("Will (60%)", willScore)}
            ${scorePill("Skill (40%)", skillScore)}
            ${scorePill("Overall", overallScore)}
            <div style="flex:1;min-width:160px;background:#FAFAF7;padding:16px;border-radius:10px;text-align:center;border:1px solid #E5E7EB;display:flex;flex-direction:column;justify-content:center">
              <div style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6B7280;font-weight:600;margin-bottom:8px">Matrix Decision</div>
              <div>${an.matrix ? APPLY_MATRIX_BADGE[an.matrix] || an.matrix : '—'}</div>
            </div>
          </div>

          ${Object.keys(willComp).length || Object.keys(skillComp).length ? `
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:18px;margin-bottom:18px">
              <div>
                <h4 style="font-family:Cormorant Garamond,serif;font-size:16px;margin-bottom:6px;color:#166534">High Will</h4>
                ${compRow(willComp)}
              </div>
              <div>
                <h4 style="font-family:Cormorant Garamond,serif;font-size:16px;margin-bottom:6px;color:#1E40AF">High Skill</h4>
                ${compRow(skillComp)}
              </div>
            </div>` : ''}`}

          <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:14px">
            <div><div style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#166534;font-weight:600;margin-bottom:6px">Strengths</div><div style="font-size:14px;line-height:1.6">${escapeHtml(an.strengths)}</div></div>
            <div><div style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#991B1B;font-weight:600;margin-bottom:6px">Concerns &amp; Red Flags</div><div style="font-size:14px;line-height:1.6;white-space:pre-wrap">${escapeHtml(an.concerns)}</div></div>
          </div>
          <div><div style="font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6B7280;font-weight:600;margin-bottom:6px">Summary for hiring manager</div><div style="font-size:14px;line-height:1.6">${escapeHtml(an.summary)}</div></div>
        </div>` : '<div style="background:#FEF3C7;color:#92400E;padding:12px 16px;border-radius:8px;margin-bottom:20px">AI analysis not yet available. Click <b>Re-analyse</b> to score whatever the candidate has submitted so far (works on partial submissions too).</div>'}

      <div style="background:#fff;padding:24px;border-radius:12px;box-shadow:0 4px 24px rgba(11,37,69,.06);margin-bottom:20px">
        <h3 style="font-family:Cormorant Garamond,serif;font-size:22px;margin-bottom:8px">Video Interview</h3>
        ${s1Qs.length === 0 ? '<div style="color:#9CA3AF">Not started.</div>' : s1Qs.map(renderInterviewQ).join("")}
      </div>

      <div style="background:#fff;padding:24px;border-radius:12px;box-shadow:0 4px 24px rgba(11,37,69,.06);margin-bottom:20px">
        <h3 style="font-family:Cormorant Garamond,serif;font-size:22px;margin-bottom:14px">${isWA ? "LCSI Personality Assessment" : "Practical Assessment"} ${as?.duration_sec ? `<span style="font-size:13px;color:#9CA3AF;font-weight:400">· took ${Math.floor(as.duration_sec/60)}m ${as.duration_sec%60}s${assessTasks?.auto_submitted ? ' (auto-submitted at timeout)':''}</span>` : ''}${as && (as.duration_sec === 0 || as.duration_sec == null) ? `<span style="font-size:12px;background:#FEF3C7;color:#92400E;border:1px solid #F59E0B;border-radius:6px;padding:2px 8px;margin-left:8px;font-weight:500">⚠️ timer not captured</span>` : ''}</h3>
        ${assessTasks ? (isWA ? (() => {
          const lcsiTraitNames2 = {COA:"Coachability",RES:"Resilience",INI:"Initiative",CON:"Conscientiousness",COM:"Compliance Mindset",EMP:"Client Empathy",PRO:"Problem Solving",SAL:"Sales Grit"};
          const traits2 = assessScores.fc_traits || {};
          const ci2 = assessScores.consistency_index ?? null;
          const biasF2 = assessScores.bias_flags || [];
          const thresholds = {COA:75,RES:70,INI:70,CON:70,COM:75,EMP:65,PRO:65,SAL:55};
          return `
            <div style="display:flex;gap:10px;flex-wrap:wrap;margin-bottom:18px">
              ${scorePill("FC Overall", assessScores.fc_overall ?? '—', '/100')}
              ${ci2 !== null ? scorePill("Consistency", ci2, '/100') : ''}
            </div>
            ${Object.keys(traits2).length ? `
              <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px 28px">
                ${Object.entries(traits2).map(([k,v]) => {
                  const min = thresholds[k] || 60;
                  const c = v >= min+5 ? '#16A34A' : v >= min-5 ? '#F59E0B' : '#DC2626';
                  return `<div>
                    <div style="display:flex;justify-content:space-between;font-size:12px;margin-bottom:3px">
                      <span style="color:#374151">${lcsiTraitNames2[k]||k}</span>
                      <span style="font-weight:600;color:${c}">${v}</span>
                    </div>
                    <div style="height:6px;background:#E5E7EB;border-radius:3px">
                      <div style="width:${Math.min(v,100)}%;height:100%;background:${c};border-radius:3px"></div>
                    </div>
                  </div>`;
                }).join("")}
              </div>` : '<div style="color:#9CA3AF;font-size:13px">FC trait scores not yet computed.</div>'}
            ${biasF2.length ? `<div style="margin-top:14px;font-size:13px;color:#92400E;background:#FFFBEB;padding:10px 14px;border-radius:8px;border-left:3px solid #F59E0B">⚠ ${biasF2.join('<br>⚠ ')}</div>` : ''}
            <div style="margin-top:14px;font-size:12px;color:#9CA3AF">${assessTasks.fc_responses?.length ?? 0} of 36 FC blocks answered · ${assessTasks.auto_submitted ? 'auto-submitted at timer expiry' : 'submitted by candidate'}</div>
          `;
        })() : `
          <div style="display:flex;gap:10px;flex-wrap:wrap;margin-bottom:18px">
            ${scorePill("Error Spotting", assessScores.error_spotting_score, '/100')}
            ${scorePill("Math/Logic", assessScores.math_score, '/100')}
          </div>

          <h4 style="font-family:Cormorant Garamond,serif;font-size:16px;margin:14px 0 6px">1 · Email — Medical Repricing</h4>
          <div style="font-size:13px;line-height:1.6;white-space:pre-wrap;background:#FAFAF7;padding:12px 14px;border-radius:8px;border-left:3px solid #B8962E">${escapeHtml(assessTasks.email_draft) || '<i style="color:#9CA3AF">(blank)</i>'}</div>

          <h4 style="font-family:Cormorant Garamond,serif;font-size:16px;margin:14px 0 6px">2 · Priorities (3 things at 9:05 AM)</h4>
          <div style="font-size:13px;color:#6B7280;margin-bottom:6px">Order chosen: ${(assessTasks.priorities_order || []).join(' → ') || '(none)'}</div>
          ${Object.entries(assessTasks.priorities_explanation || {}).map(([k,v]) => `
            <div style="font-size:13px;background:#FAFAF7;padding:10px 12px;border-radius:8px;margin-bottom:6px"><b>${escapeHtml(k)}:</b> ${escapeHtml(v)}</div>
          `).join("") || '<div style="color:#9CA3AF">(none)</div>'}

          <h4 style="font-family:Cormorant Garamond,serif;font-size:16px;margin:14px 0 6px">3 · Errors flagged in insurance form</h4>
          <ul style="font-size:13px;line-height:1.7;padding-left:20px">${(assessTasks.errors || []).map(e => `<li>${escapeHtml(e.text)}</li>`).join("") || '<li style="color:#9CA3AF">(none)</li>'}</ul>

          <h4 style="font-family:Cormorant Garamond,serif;font-size:16px;margin:14px 0 6px">4 · Math/Logic — Commission (correct: RM 8,169.60)</h4>
          <div style="font-size:14px"><b>Answer:</b> ${escapeHtml(assessTasks.math_answer) || '<i style="color:#9CA3AF">(blank)</i>'}</div>
          <div style="font-size:13px;line-height:1.6;white-space:pre-wrap;background:#FAFAF7;padding:10px 12px;border-radius:8px;margin-top:6px">${escapeHtml(assessTasks.math_working) || '<i style="color:#9CA3AF">(no working shown)</i>'}</div>

          <h4 style="font-family:Cormorant Garamond,serif;font-size:16px;margin:14px 0 6px">5 · Comprehension — Reply email to client</h4>
          <div style="font-size:13px;line-height:1.6;white-space:pre-wrap;background:#FAFAF7;padding:12px 14px;border-radius:8px;border-left:3px solid #0EA5E9">${escapeHtml(assessTasks.comprehension_email) || '<i style="color:#9CA3AF">(blank)</i>'}</div>
        `) : '<div style="color:#9CA3AF">Not submitted.</div>'}
      </div>

      <div style="background:#fff;padding:24px;border-radius:12px;box-shadow:0 4px 24px rgba(11,37,69,.06);margin-bottom:20px">
        <h3 style="font-family:Cormorant Garamond,serif;font-size:22px;margin-bottom:8px">Written Interview</h3>
        ${s2Qs.length === 0 ? '<div style="color:#9CA3AF">Not started.</div>' : s2Qs.map(renderInterviewQ).join("")}
      </div>

      ${_renderWhatsappActivity(wa, a)}
      ${_renderActivityLog(d.events)}
    </div>`;

  // Load candidate videos with auth headers (video src= can't send Bearer token)
  document.querySelectorAll('video[data-vid-key]').forEach(async v => {
    const key = v.dataset.vidKey;
    try {
      const res = await fetch(APPLY_API + '/api/apply/admin/video?key=' + encodeURIComponent(key), { headers: _applyHeaders() });
      if (res.ok) { v.src = URL.createObjectURL(await res.blob()); }
      else { v.insertAdjacentHTML('afterend', '<div style="color:#991B1B;font-size:12px;margin-top:4px">Video unavailable ('+res.status+')</div>'); }
    } catch (e) { v.insertAdjacentHTML('afterend', '<div style="color:#991B1B;font-size:12px;margin-top:4px">Video load error</div>'); }
  });

  // Send candidate to Vinnie for background check
  const bgBtn = document.getElementById("apply-bgcheck");
  if (bgBtn) bgBtn.addEventListener("click", async () => {
    if (!confirm(`Send ${a.name || "this candidate"} to Vinnie (lifa.pa@gmail.com) for a background check?\n\nShe gets the full profile + a Pass/Fail link, with cc to you and daily urgent reminders until she responds. On Pass, the candidate is automatically invited to a face-to-face interview.`)) return;
    bgBtn.disabled = true; bgBtn.textContent = "Sending…";
    try {
      const r = await applyPost(`/api/apply/admin/applications/${encodeURIComponent(id)}/send-bg-check`, {});
      if (r.error) throw new Error(r.error);
      showToast("success", "Sent to Pavithra for background check");
      renderApplicationDetail(id);
    } catch (e) { showToast("error", e.message || "Failed"); bgBtn.disabled = false; bgBtn.textContent = "Send to Pavithra for background check"; }
  });

  // Hiring for a third party — toggle / save / resend
  const tpToggle = document.getElementById("tp-toggle");
  if (tpToggle) tpToggle.addEventListener("change", async () => {
    const form = document.getElementById("tp-form");
    if (tpToggle.checked) { form.style.display = "block"; return; }
    if (!confirm("Switch this candidate back to own-firm hiring? The third-party details will be cleared.")) { tpToggle.checked = true; return; }
    try {
      const r = await applyPost(`/api/apply/admin/applications/${encodeURIComponent(id)}/third-party`, { enabled: false });
      if (r.error) throw new Error(r.error);
      showToast("success", "Own-firm hiring");
      renderApplicationDetail(id);
    } catch (e) { showToast("error", e.message || "Failed"); tpToggle.checked = true; }
  });
  const tpSave = document.getElementById("tp-save");
  if (tpSave) tpSave.addEventListener("click", async () => {
    const name = document.getElementById("tp-name").value.trim(), email = document.getElementById("tp-email").value.trim(), phone = document.getElementById("tp-phone").value.trim();
    if (!name || !email) { showToast("error", "Hirer name and email are required"); return; }
    tpSave.disabled = true; tpSave.textContent = "Saving…";
    try {
      const r = await applyPost(`/api/apply/admin/applications/${encodeURIComponent(id)}/third-party`, { enabled: true, name, email, phone });
      if (r.error) throw new Error(r.error);
      showToast("success", r.sent ? `Saved — ${name} has been asked to Proceed / Reject` : "Hirer saved");
      renderApplicationDetail(id);
    } catch (e) { showToast("error", e.message || "Failed"); tpSave.disabled = false; tpSave.textContent = "Save hirer"; }
  });
  const tpResend = document.getElementById("tp-resend");
  if (tpResend) tpResend.addEventListener("click", async () => {
    tpResend.disabled = true; tpResend.textContent = "Sending…";
    try {
      const r = await applyPost(`/api/apply/admin/applications/${encodeURIComponent(id)}/third-party/resend`, {});
      if (r.error) throw new Error(r.error);
      showToast("success", "Sent");
      renderApplicationDetail(id);
    } catch (e) { showToast("error", e.message || "Failed"); tpResend.disabled = false; tpResend.textContent = "Resend"; }
  });

  // Walk-in approve / reject
  const apptConfirm = document.getElementById("appt-confirm");
  if (apptConfirm) apptConfirm.addEventListener("click", async () => {
    if (!confirm(`Confirm this walk-in appointment? A confirmation email will be sent to ${a.email}.`)) return;
    apptConfirm.disabled = true; apptConfirm.textContent = "Confirming…";
    try {
      const r = await applyPost(`/api/apply/admin/applications/${encodeURIComponent(id)}/appointment`, { action: "confirm" });
      if (r.error) throw new Error(r.error);
      showToast("success", "Confirmed. Candidate notified by email.");
      renderApplicationDetail(id);
    } catch (e) { showToast("error", e.message); apptConfirm.disabled = false; apptConfirm.textContent = "✓ Confirm"; }
  });
  const apptReject = document.getElementById("appt-reject");
  if (apptReject) apptReject.addEventListener("click", async () => {
    if (!confirm(`Reject this walk-in request? The candidate will get an email asking them to pick a new time.`)) return;
    apptReject.disabled = true; apptReject.textContent = "Rejecting…";
    try {
      const r = await applyPost(`/api/apply/admin/applications/${encodeURIComponent(id)}/appointment`, { action: "reject" });
      if (r.error) throw new Error(r.error);
      showToast("success", "Rejected. Candidate emailed to re-pick.");
      renderApplicationDetail(id);
    } catch (e) { showToast("error", e.message); apptReject.disabled = false; apptReject.textContent = "Reject"; }
  });

  document.getElementById("apply-status").addEventListener("change", async e => {
    const newStatus = e.target.value;
    const sel = e.target;
    if (newStatus === "rejected") {
      const reasons = [
        ["low_score",             "Low score"],
        ["fail_background_check", "Fail background check"],
        ["no_show",               "No show"],
        ["other_job_offer",       "Other job offer"],
        ["fail_interview",        "Fail interview"],
        ["other",                 "Other"],
      ];
      const overlay = document.createElement("div");
      overlay.style.cssText = "position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9000;display:flex;align-items:center;justify-content:center";
      overlay.innerHTML = `<div style="background:#fff;border-radius:14px;padding:28px 32px;max-width:380px;width:90%;box-shadow:0 8px 40px rgba(0,0,0,.2)">
        <h3 style="margin:0 0 6px;font-size:17px;color:#0B2545">Reason for rejection</h3>
        <p style="margin:0 0 18px;font-size:13px;color:#6B7280">Pick a reason — optional, you can skip it.</p>
        ${reasons.map(([k,v]) => `<label style="display:flex;align-items:center;gap:10px;padding:9px 12px;border:1.5px solid #E2E8F0;border-radius:8px;margin-bottom:8px;cursor:pointer;font-size:14px"><input type="radio" name="rej_reason" value="${k}" style="accent-color:#991B1B"> ${v}</label>`).join("")}
        <div style="display:flex;gap:10px;margin-top:18px">
          <button id="rej-cancel" style="flex:1;padding:10px;border:1px solid #E2E8F0;background:#fff;border-radius:8px;cursor:pointer;font:inherit;font-size:14px">Cancel</button>
          <button id="rej-confirm" style="flex:1;padding:10px;background:#991B1B;color:#fff;border:none;border-radius:8px;cursor:pointer;font:inherit;font-size:14px;font-weight:600">Confirm rejection</button>
        </div>
      </div>`;
      document.body.appendChild(overlay);
      overlay.querySelector("#rej-cancel").addEventListener("click", () => { sel.value = sel.dataset.prev || ""; document.body.removeChild(overlay); });
      overlay.querySelector("#rej-confirm").addEventListener("click", async () => {
        const chosen = overlay.querySelector("input[name=rej_reason]:checked");
        document.body.removeChild(overlay);
        try {
          const r = await applyPut("/api/apply/admin/applications/" + encodeURIComponent(id) + "/status", { status: "rejected", rejection_reason: chosen ? chosen.value : undefined });
          if (r.error) throw new Error(r.error);
          sel.dataset.prev = "rejected";
          showToast("success", "Rejected");
          renderApplicationDetail(id);
        } catch (err) { showToast("error", err.message); sel.value = sel.dataset.prev || ""; }
      });
      sel.dataset.prev = sel.dataset.prev || a.status;
      return;
    }
    const _wasFinal = (sel.dataset.prev || a.status) === "hired" || (sel.dataset.prev || a.status) === "rejected";
    if (_wasFinal && !confirm("Re-open " + (a.name || "this candidate") + " from " + APPLY_STATUS_LABEL[sel.dataset.prev || a.status] + " to " + APPLY_STATUS_LABEL[newStatus] + "?")) {
      sel.value = sel.dataset.prev || a.status; return;
    }
    sel.dataset.prev = newStatus;
    try {
      const r = await applyPut("/api/apply/admin/applications/" + encodeURIComponent(id) + "/status", { status: newStatus, force: _wasFinal || undefined });
      if (r.error) throw new Error(r.error);
      showToast("success", "Status updated");
    } catch (err) { showToast("error", err.message); }
  });
  document.getElementById("apply-reanalyse").addEventListener("click", async () => {
    const btn = document.getElementById("apply-reanalyse");
    btn.disabled = true; btn.innerText = "Re-analysing…";
    // The worker's runAnalysis() can take 30-60s. Cloudflare's edge sometimes drops the
    // response after ~100s even though the worker successfully wrote the new analysis to D1.
    // Fix: capture the OLD analysed_at, then race the POST against a poller that watches
    // analysed_at advance. Whichever signal arrives first wins — so even if the POST hangs
    // or errors, we refresh the panel as soon as the DB shows a fresh analysis.
    const beforeTs = (a && a.analysis && a.analysis.analysed_at) || 0;
    const pollForNewAnalysis = async () => {
      for (let i = 0; i < 36; i++) { // 36 × 5s = 3 min max
        await new Promise(r => setTimeout(r, 5000));
        try {
          const d = await applyGet("/api/apply/admin/applications/" + encodeURIComponent(id));
          if (d && d.analysis && d.analysis.analysed_at > beforeTs) return d;
        } catch {}
      }
      return null;
    };
    try {
      const postPromise = applyPost("/api/apply/admin/applications/" + encodeURIComponent(id) + "/reanalyse?sync=1", null);
      const winner = await Promise.race([postPromise, pollForNewAnalysis()]);
      if (winner && winner.error) throw new Error(winner.error);
      showToast("success", "Analysis updated");
      renderApplicationDetail(id);
    } catch (err) {
      // POST errored / timed out. Worker may still have finished — check D1 before showing failure.
      try {
        const d = await applyGet("/api/apply/admin/applications/" + encodeURIComponent(id));
        if (d && d.analysis && d.analysis.analysed_at > beforeTs) {
          showToast("success", "Analysis updated (recovered from connection drop)");
          renderApplicationDetail(id);
          return;
        }
      } catch {}
      showToast("error", err.message);
      btn.disabled = false; btn.innerText = "Re-analyse";
    }
  });
  document.getElementById("apply-share-link").addEventListener("click", () => {
    const candidateName = (a && a.name) || id;
    const escAttr = escapeHtml; // consolidated → canonical escapeHtml (line ~7379)
    const overlay = document.createElement("div");
    overlay.style.cssText = "position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:99999;display:flex;align-items:center;justify-content:center;padding:24px";
    overlay.innerHTML = `<div style="background:#fff;border-radius:14px;max-width:560px;width:100%;padding:28px 32px;box-shadow:0 20px 60px rgba(0,0,0,.3)">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px">
        <h2 style="margin:0;font-family:'Cormorant Garamond',serif;font-size:22px;color:#0B2545">📧 Email candidate to 3rd party</h2>
        <button id="sl-close" style="background:none;border:none;font-size:24px;cursor:pointer;color:#9CA3AF">×</button>
      </div>
      <p style="margin:0 0 14px;font-size:14px;color:#4B5563">Sends a read-only link to <b>${escAttr(candidateName)}</b>'s results. Subject line: <b>Shortlisted candidate</b>. Recipient gets a "View Candidate profile" button — no login needed.</p>
      <label style="display:block;font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:#6B7280;font-weight:600;margin-bottom:6px">Recipient email</label>
      <input id="sl-to" type="email" placeholder="reviewer@example.com" autocomplete="email" style="width:100%;padding:11px 14px;border:1px solid #cbd5e1;border-radius:8px;font:14px DM Sans,sans-serif;color:#0B2545"/>
      <label style="display:block;font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:#6B7280;font-weight:600;margin:14px 0 6px">Optional note <span style="color:#9CA3AF;font-weight:400;text-transform:none;letter-spacing:0">(appears in the email)</span></label>
      <textarea id="sl-note" rows="2" placeholder="Worth a chat — strong communication." style="width:100%;padding:11px 14px;border:1px solid #cbd5e1;border-radius:8px;font:14px DM Sans,sans-serif;color:#0B2545;resize:vertical"></textarea>
      <div style="display:flex;justify-content:space-between;align-items:center;margin-top:18px">
        <span style="font-size:12px;color:#6B7280">Link expires in 7 days (14 for copied link)</span>
        <div style="display:flex;gap:8px">
          <button id="sl-copy" style="background:#fff;color:#0B2545;border:1px solid #0B2545;padding:10px 16px;border-radius:8px;cursor:pointer;font:14px DM Sans,sans-serif;font-weight:500" title="Copy a clean link to send via WhatsApp or your own email — avoids long-link breakage / blocked workers.dev links in some inboxes">📋 Copy link</button>
          <button id="sl-cancel" style="background:transparent;color:#4B5563;border:1px solid #cbd5e1;padding:10px 18px;border-radius:8px;cursor:pointer;font:14px DM Sans,sans-serif">Cancel</button>
          <button id="sl-send" style="background:#0B2545;color:#fff;border:none;padding:10px 22px;border-radius:8px;cursor:pointer;font:14px DM Sans,sans-serif;font-weight:500">Send email →</button>
        </div>
      </div>
      <p style="margin:10px 0 0;font-size:12px;color:#9CA3AF;line-height:1.5">Recipient can't open the emailed link? Use <b>Copy link</b> and send it via WhatsApp or your own email — some inboxes break the long link or block it.</p>
      <p id="sl-status" style="margin:10px 0 0;font-size:13px;color:#6B7280;min-height:18px"></p>
    </div>`;
    document.body.appendChild(overlay);
    setTimeout(() => document.getElementById("sl-to")?.focus(), 100);
    function close() { overlay.remove(); }
    document.getElementById("sl-close").onclick = close;
    document.getElementById("sl-cancel").onclick = close;
    overlay.addEventListener("click", e => { if (e.target === overlay) close(); });
    document.getElementById("sl-send").addEventListener("click", async () => {
      const toEl = document.getElementById("sl-to");
      const noteEl = document.getElementById("sl-note");
      const status = document.getElementById("sl-status");
      const recipient = (toEl.value || "").trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recipient)) { status.textContent = "❌ Enter a valid email"; status.style.color = "#991B1B"; toEl.focus(); return; }
      const sendBtn = document.getElementById("sl-send");
      sendBtn.disabled = true; sendBtn.textContent = "Sending…";
      status.textContent = "📤 Sending…"; status.style.color = "#0B2545";
      try {
        const r = await applyPost("/api/apply/admin/applications/" + encodeURIComponent(id) + "/email-share-link", { to: recipient, note: (noteEl.value || "").trim(), expires_days: 7 });
        if (r.error) throw new Error(r.error);
        status.innerHTML = `✅ Sent to <b>${escAttr(recipient)}</b>. Link expires in ${r.expires_in_days} days.`;
        status.style.color = "#166534";
        showToast("success", "Share email sent to " + recipient);
        setTimeout(close, 1800);
      } catch (err) {
        status.textContent = "❌ " + err.message;
        status.style.color = "#991B1B";
        sendBtn.disabled = false; sendBtn.textContent = "Send email →";
      }
    });
    document.getElementById("sl-copy").addEventListener("click", async () => {
      const status = document.getElementById("sl-status");
      const copyBtn = document.getElementById("sl-copy");
      copyBtn.disabled = true; copyBtn.textContent = "…";
      status.textContent = "Generating link…"; status.style.color = "#0B2545";
      try {
        const r = await applyGet("/api/apply/admin/applications/" + encodeURIComponent(id) + "/share-link?expires_days=14");
        if (r.error || !r.link) throw new Error(r.error || "Could not generate link");
        let copied = false;
        try { await navigator.clipboard.writeText(r.link); copied = true; } catch (e) {}
        status.innerHTML = `${copied ? "✅ <b>Link copied</b>" : "Link (copy manually)"} — expires in ${r.expires_in_days} days. Paste it into WhatsApp or your own email.<br><textarea readonly onclick="this.select()" style="width:100%;margin-top:8px;padding:8px;border:1px solid #cbd5e1;border-radius:6px;font:12px monospace;color:#374151;resize:vertical" rows="3">${escAttr(r.link)}</textarea>`;
        status.style.color = "#166534";
        if (copied) showToast("success", "Review link copied to clipboard");
      } catch (err) {
        status.textContent = "❌ " + err.message; status.style.color = "#991B1B";
      } finally { copyBtn.disabled = false; copyBtn.textContent = "📋 Copy link"; }
    });
  });
  document.getElementById("apply-delete-videos").addEventListener("click", async () => {
    if (!confirm("Delete all video recordings for this candidate? Transcripts and AI analysis will be kept. This cannot be undone.")) return;
    const btn = document.getElementById("apply-delete-videos");
    btn.disabled = true; btn.innerText = "Deleting…";
    try {
      const r = await applyDelete("/api/apply/admin/applications/" + encodeURIComponent(id) + "/videos");
      if (r.error) throw new Error(r.error);
      showToast("success", "Deleted " + (r.deleted || 0) + " video(s)");
      renderApplicationDetail(id);
    } catch (err) { showToast("error", err.message); btn.disabled = false; btn.innerText = "Delete videos"; }
  });
  document.getElementById("apply-delete-app").addEventListener("click", async () => {
    const name = (a && a.name) || id;
    if (!confirm("Permanently delete the entire profile for " + name + "?\\n\\nThis removes the application, particulars, interview videos, transcripts, assessment, and AI analysis. This cannot be undone.")) return;
    const btn = document.getElementById("apply-delete-app");
    btn.disabled = true; btn.innerText = "Deleting…";
    try {
      const r = await applyDelete("/api/apply/admin/applications/" + encodeURIComponent(id));
      if (r.error) throw new Error(r.error);
      showToast("success", "Profile deleted");
      showView("applications");
    } catch (err) { showToast("error", err.message); btn.disabled = false; btn.innerText = "Delete profile"; }
  });
}

// ─── SC CPE COMPLIANCE ────────────────────────────────────────────────────────

var _complianceCache = null;
var _complianceFilter = { janJunOnly: true, search: "", pendingOnly: true };

function _fmtDate(iso) {
  if (!iso) return "—";
  try { return new Date(iso + (iso.includes("T")?"":"T00:00:00")).toLocaleDateString("en-GB",{day:"2-digit",month:"short",year:"numeric"}); }
  catch { return iso; }
}
function _monthOf(iso) {
  if (!iso) return null;
  return new Date(iso + "T00:00:00").getUTCMonth() + 1; // 1-12
}
function _statusBadge(s) {
  const map = {
    Pending: ["#FEF3C7","#92400E"], Reminded: ["#DBEAFE","#1E40AF"],
    CertSubmitted: ["#E0E7FF","#3730A3"], Verified: ["#D1FAE5","#065F46"],
    Expired: ["#FEE2E2","#991B1B"], Exempt: ["#F3E8FF","#6B21A8"]
  };
  const [bg,fg] = map[s] || ["#F1F5F9","#475569"];
  return `<span style="background:${bg};color:${fg};padding:2px 10px;border-radius:999px;font-size:11px;font-weight:600;letter-spacing:.3px">${s||"—"}</span>`;
}
function _payBadge(s) {
  const map = { Unpaid:["#FEE2E2","#991B1B"], Submitted:["#FEF3C7","#92400E"], Confirmed:["#D1FAE5","#065F46"] };
  const [bg,fg] = map[s] || ["#F1F5F9","#475569"];
  return `<span style="background:${bg};color:${fg};padding:2px 8px;border-radius:6px;font-size:11px;font-weight:600">${s||"Unpaid"}</span>`;
}

// Compact horizontal year-pill timeline. Hover for full window.
function _timelineMini(timeline) {
  if (!timeline || !timeline.length) return "";
  const yearPill = t => {
    const ended = t.is_ended, running = t.is_running, focus = t.is_focus;
    const verified = t.status === "Verified";
    const waived = t.status === "Waived";
    let bg = "#F1F5F9", fg = "#94A3B8", title = `Y${t.year_index}: not yet started`;
    if (verified) { bg = "#D1FAE5"; fg = "#065F46"; title = `Y${t.year_index}: Verified ✓`; }
    else if (waived) { bg = "#F1F5F9"; fg = "#94A3B8"; title = `Y${t.year_index}: waived — not required (e.g. first licence year)`; }
    else if (focus) { bg = "#FEF3C7"; fg = "#92400E"; title = `Y${t.year_index}: IN FOCUS (${t.status})`; }
    else if (ended) { bg = "#FEE2E2"; fg = "#991B1B"; title = `Y${t.year_index}: ended ${t.end} — unverified`; }
    else if (running) { bg = "#DBEAFE"; fg = "#1E40AF"; title = `Y${t.year_index}: running until ${t.end}`; }
    return `<span title="${title} (${t.start} → ${t.end})" style="background:${bg};color:${fg};padding:1px 6px;border-radius:999px;font-size:10px;font-weight:700;margin-right:2px;${focus?'outline:1.5px solid #92400E;':''}">Y${t.year_index}${verified?"✓":""}${focus?"●":""}</span>`;
  };
  return `<div style="margin-top:4px">${timeline.map(yearPill).join("")}</div>`;
}

async function renderCompliance() {
  document.getElementById("main-content").innerHTML =
    `<div style="padding:24px"><h2 style="margin:0 0 4px 0;color:#0B2545">SC Compliance — CPE Monitoring</h2>
     <div style="color:#64748B;font-size:13px;margin-bottom:18px">Source of license dates: <a href="https://www.sc.com.my/investment-checker" target="_blank" rel="noopener">sc.com.my/investment-checker</a> · Annual requirement: 20 CPE hours within anniversary window</div>
     <div id="cpe-list" style="color:#64748B">Loading compliance data…</div></div>`;
  try {
    const data = await apiGet("/api/cpe");
    if (data && data.error) throw new Error(data.error);
    _complianceCache = Array.isArray(data) ? data : [];
    _renderComplianceList();
  } catch (e) {
    document.getElementById("cpe-list").innerHTML =
      `<div style="background:#FEE2E2;color:#991B1B;padding:12px;border-radius:8px">Failed to load: ${e.message}</div>`;
  }
}

function _renderComplianceList() {
  const rows = (_complianceCache||[]).filter(r => {
    if (_complianceFilter.pendingOnly && !_cpePending(r)) return false;   // default: action needed only
    if (_complianceFilter.janJunOnly) {
      const m = _monthOf(r.license_date);
      if (!m || m < 1 || m > 6) return false;
    }
    if (_complianceFilter.search) {
      const q = _complianceFilter.search.toLowerCase();
      if (!((r.name||"").toLowerCase().includes(q) || (r.cmsrl||"").toLowerCase().includes(q))) return false;
    }
    return true;
  });

  const counts = {
    total: (_complianceCache||[]).length,
    janJun: (_complianceCache||[]).filter(r => { const m=_monthOf(r.license_date); return m>=1 && m<=6; }).length,
    exempt: (_complianceCache||[]).filter(r => r.exempt_this_year).length,
    verified: (_complianceCache||[]).filter(r => r.cpe_record && r.cpe_record.status==="Verified").length,
    pending: (_complianceCache||[]).filter(r => !r.exempt_this_year && r.cpe_record && (r.cpe_record.status==="Pending"||r.cpe_record.status==="Reminded")).length
  };

  const summary =
    `<div style="display:grid;grid-template-columns:repeat(5,1fr);gap:12px;margin-bottom:18px">
       ${_kpi("Total reps", counts.total, "#0B2545")}
       ${_kpi("Jan–Jun anniversary", counts.janJun, "#10B981")}
       ${_kpi("Exempt (newly licensed)", counts.exempt, "#7C3AED")}
       ${_kpi("Verified this year", counts.verified, "#059669")}
       ${_kpi("Pending action", counts.pending, "#D97706")}
     </div>`;

  const toolbar =
    `<div style="display:flex;gap:12px;align-items:center;margin-bottom:14px;flex-wrap:wrap">
       <label style="display:flex;align-items:center;gap:6px;font-size:13px;color:#0B2545;cursor:pointer;font-weight:600">
         <input type="checkbox" ${_complianceFilter.pendingOnly?"checked":""} onchange="_complianceFilter.pendingOnly=this.checked;_renderComplianceList()" />
         Pending action only
       </label>
       <label style="display:flex;align-items:center;gap:6px;font-size:13px;color:#0B2545;cursor:pointer">
         <input type="checkbox" ${_complianceFilter.janJunOnly?"checked":""} onchange="_complianceFilter.janJunOnly=this.checked;_renderComplianceList()" />
         Jan–Jun anniversary only (SC Easy Reporting)
       </label>
       <input type="search" placeholder="Search name or CMSRL…" value="${_complianceFilter.search.replace(/"/g,'&quot;')}"
              oninput="_complianceFilter.search=this.value;_renderComplianceList()"
              style="padding:6px 10px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;flex:1;min-width:220px" />
       <button onclick="_remindAll()" style="background:#0B2545;color:#fff;border:0;padding:8px 14px;border-radius:8px;font-size:13px;cursor:pointer;font-weight:600">Send reminders to filtered</button>
     </div>`;

  let table;
  if (!rows.length) {
    table = _complianceFilter.pendingOnly
      ? `<div style="background:#F0FDF4;padding:24px;text-align:center;color:#15803D;border-radius:10px;font-weight:600">✅ No one needs action right now.<div style="font-weight:400;color:#64748B;font-size:12px;margin-top:4px">Untick "Pending action only" to see everyone.</div></div>`
      : `<div style="background:#F1F5F9;padding:24px;text-align:center;color:#64748B;border-radius:10px">No reps match the current filter.</div>`;
  } else {
    table =
      `<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden">
         <table style="width:100%;border-collapse:collapse;font-size:13px">
           <thead style="background:#F8FAFC">
             <tr>
               <th style="text-align:left;padding:10px 14px;color:#475569;font-weight:600">Rep</th>
               <th style="text-align:left;padding:10px 14px;color:#475569;font-weight:600">Anniversary window</th>
               <th style="text-align:left;padding:10px 14px;color:#475569;font-weight:600">CPE hours</th>
               <th style="text-align:left;padding:10px 14px;color:#475569;font-weight:600">CMSRL payment</th>
               <th style="text-align:right;padding:10px 14px;color:#475569;font-weight:600"></th>
             </tr>
           </thead>
           <tbody>
             ${rows.map(_renderComplianceRow).join("")}
           </tbody>
         </table>
       </div>`;
  }

  document.getElementById("cpe-list").innerHTML = summary + toolbar + table;
}

// ══════════════════════════════════════════════════════════════════════════════
// REPORTING CHECKLIST — firm-level SC/FIMM obligations: last cycle status + next due
async function renderRegReports(){
  const main=document.getElementById("main-content");
  main.innerHTML=`<div style="padding:24px">
    <h2 style="margin:0 0 4px 0;color:#0B2545">Reporting Checklist — SC / FIMM</h2>
    <div style="color:#64748B;font-size:13px;margin-bottom:18px">All recurring filings at a glance. Reminders go to admin (email + WhatsApp) automatically ahead of each deadline; marking a cycle done silences its reminders.</div>
    <div id="reg-list" style="color:#64748B">Loading…</div></div>`;
  try{
    const rows=await apiGet('/api/firm-compliance');
    if(rows&&rows.error) throw new Error(rows.error);
    const esc = escapeHtml; // consolidated → canonical escapeHtml (line ~7379)
    document.getElementById('reg-list').innerHTML=
      `<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden">
       <table style="width:100%;border-collapse:collapse;font-size:13px">
       <thead style="background:#F8FAFC"><tr>
         <th style="text-align:left;padding:10px 14px;color:#475569">Next due</th>
         <th style="text-align:left;padding:10px 14px;color:#475569">Obligation</th>
         <th style="text-align:left;padding:10px 14px;color:#475569">Last cycle</th>
         <th style="padding:10px 14px"></th>
       </tr></thead><tbody>`+
      rows.map(function(r){
        var c=r.days_left<0?'#B91C1C':(r.days_left<=30?'#B45309':'#475569');
        var lastCell, action='';
        if(r.last_done_at){
          lastCell='<span style="color:#15803D;font-weight:600">Done '+_fmtDate(r.last_done_at)+'</span>'
            +(r.last_note?'<div style="font-size:11px;color:#94A3B8;max-width:340px">'+esc(r.last_note)+'</div>':'');
          action='<a href="javascript:void(0)" onclick="regMarkDone(\''+r.key+'\','+r.last_year+',true)" style="color:#CBD5E1;font-size:11px;text-decoration:underline">undo</a>';
        } else {
          lastCell='<span style="color:#B45309;font-weight:600">Not recorded</span><div style="font-size:11px;color:#94A3B8">was due '+_fmtDate(r.last_due)+'</div>';
          action='<button onclick="regMarkDone(\''+r.key+'\','+r.last_year+',false)" style="background:#0B2545;color:#fff;border:0;padding:6px 12px;border-radius:7px;font-size:12px;cursor:pointer;font-weight:600">Mark done</button>';
        }
        return '<tr style="border-top:1px solid #F1F5F9;vertical-align:top">'
          +'<td style="padding:11px 14px;white-space:nowrap"><b style="color:'+c+'">'+(r.days_left<0?'OVERDUE '+(-r.days_left)+'d':r.days_left+' days')+'</b><div style="font-size:11px;color:#64748B">'+_fmtDate(r.next_due)+'</div></td>'
          +'<td style="padding:11px 14px"><b style="color:#0B2545">'+esc(r.name.split(' — ')[0])+'</b><div style="font-size:11px;color:#64748B;max-width:420px">'+esc(r.name.split(' — ').slice(1).join(' — '))+'</div></td>'
          +'<td style="padding:11px 14px">'+lastCell+'</td>'
          +'<td style="padding:11px 14px;text-align:right">'+action+'</td></tr>';
      }).join('')+'</tbody></table></div>';
  }catch(e){ document.getElementById('reg-list').innerHTML='<div style="color:#B91C1C">'+e.message+'</div>'; }
}

// ===== AML/CFT (AI) view =====
var _amlTab = "screen";
function _amlEsc(s){ return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;"); }
function _amlBadge(text, color, bg){ return '<span style="display:inline-block;padding:2px 8px;border-radius:999px;font-size:11px;font-weight:700;color:'+color+';background:'+bg+'">'+_amlEsc(text)+'</span>'; }
function _amlRatePill(r){ r=String(r||"").toLowerCase();
  if(r==="low") return _amlBadge("LOW","#15803D","#DCFCE7");
  if(r==="medium") return _amlBadge("MEDIUM","#B45309","#FEF3C7");
  if(r==="high") return _amlBadge("HIGH","#B91C1C","#FEE2E2");
  if(r==="prohibited") return _amlBadge("PROHIBITED","#fff","#B91C1C");
  return _amlBadge(r||"—","#475569","#F1F5F9"); }
function _amlStatusPill(s){ s=String(s||"").toLowerCase();
  var m={pending_review:["PENDING REVIEW","#B45309","#FEF3C7"],cleared:["CLEARED","#15803D","#DCFCE7"],edd:["EDD","#B45309","#FEF3C7"],escalated:["ESCALATED","#B91C1C","#FEE2E2"],rejected:["REJECTED","#fff","#B91C1C"]};
  var x=m[s]||[s.toUpperCase(),"#475569","#F1F5F9"]; return _amlBadge(x[0],x[1],x[2]); }

async function renderAML(){
  const main=document.getElementById("main-content");
  main.innerHTML=`<div style="padding:24px">
    <h2 style="margin:0 0 4px 0;color:#0B2545">AML/CFT — AI Screening &amp; Monitoring</h2>
    <div style="color:#64748B;font-size:13px;margin-bottom:10px;max-width:760px">Every verified KYC client is auto-screened against the <b>UN Consolidated + OFAC SDN + MOHA-domestic</b> sanctions lists (fuzzy match + AI adjudication), plus AI assessment of PEP, adverse-media and source-of-funds risk under the SC AML/CFT Guidelines &amp; AMLA 2001. A <b>self-declared PEP</b> is always treated as at least “possible”, and the whole book is <b>re-screened nightly</b> against the updated lists. <span style="color:#94A3B8">Commercial PEP / adverse-media data and verification of any flagged match remain a recorded MLRO step.</span></div>
    <div id="aml-sancstatus" style="font-size:11px;color:#64748B;margin-bottom:12px"></div>
    <div id="aml-summary" style="display:flex;gap:12px;flex-wrap:wrap;margin-bottom:16px"></div>
    <div style="display:flex;gap:8px;margin-bottom:14px;border-bottom:1px solid #E2E8F0">
      <button id="amltab-screen" onclick="amlTab('screen')" class="aml-tab" style="background:none;border:0;border-bottom:2px solid transparent;padding:8px 6px;cursor:pointer;font-weight:700;color:#64748B">Screening register</button>
      <button id="amltab-str" onclick="amlTab('str')" class="aml-tab" style="background:none;border:0;border-bottom:2px solid transparent;padding:8px 6px;cursor:pointer;font-weight:700;color:#64748B">STR register</button>
      <button id="amltab-risk" onclick="amlTab('risk')" class="aml-tab" style="background:none;border:0;border-bottom:2px solid transparent;padding:8px 6px;cursor:pointer;font-weight:700;color:#64748B">Risk assessment</button>
      <button id="amltab-training" onclick="amlTab('training')" class="aml-tab" style="background:none;border:0;border-bottom:2px solid transparent;padding:8px 6px;cursor:pointer;font-weight:700;color:#64748B">Training log</button>
    </div>
    <div id="aml-body" style="color:#64748B">Loading…</div></div>`;
  _amlLoadSummary();
  _amlLoadSanctionsStatus();
  amlTab(_amlTab);
}
async function _amlLoadSanctionsStatus(){
  try{ const s=await apiGet('/api/aml/sanctions/status'); const el=document.getElementById('aml-sancstatus'); if(!el) return;
    var loadBtn=' <button onclick="amlLoadDomestic()" style="background:#fff;border:1px solid #CBD5E1;color:#0B2545;padding:3px 8px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer">＋ Load MOHA / domestic list</button>';
    if(s&&s.meta){ el.innerHTML='🛡 Sanctions data: <b>'+(s.meta.total||0).toLocaleString()+'</b> entries (UN '+(s.meta.un_count||0).toLocaleString()+' + OFAC '+(s.meta.ofac_count||0).toLocaleString()+' + MOHA '+((s.meta.moha_count||0)).toLocaleString()+') · loaded '+_amlEsc((s.meta.loaded_at||'').slice(0,10))+loadBtn; }
    else { el.innerHTML='🛡 Sanctions data not loaded yet.'+loadBtn; }
  }catch(e){}
}
async function amlLoadDomestic(){
  var txt=prompt("Paste the MOHA / domestic (AMLA s.66B) designated names — ONE NAME PER LINE.\n\nThis REPLACES the current domestic list. The MLRO is responsible for using the official, current list from the Ministry of Home Affairs.");
  if(txt===null) return;
  var entries=txt.split(/\r?\n/).map(function(n){return {name:n.trim()};}).filter(function(e){return e.name;});
  if(!entries.length){ alert("No names found."); return; }
  if(!confirm("Load "+entries.length+" domestic name(s)? This replaces the existing MOHA list.")) return;
  try{ var r=await apiPost('/api/aml/sanctions/load-domestic',{entries:entries, replace:true}); if(r&&r.error){ alert(r.error); return; } alert("Loaded "+(r.inserted||0)+" domestic entries. They are now included in screening and the nightly re-screen."); _amlLoadSanctionsStatus(); }
  catch(e){ alert(e.message); }
}
async function _amlLoadSummary(){
  try{
    const s=await apiGet('/api/aml/summary'); if(!s||s.error) return;
    function card(label,val,color){ return '<div style="background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:10px 14px;min-width:120px"><div style="font-size:22px;font-weight:800;color:'+color+'">'+val+'</div><div style="font-size:11px;color:#64748B;font-weight:600">'+label+'</div></div>'; }
    var ra=s.latest_risk_assessment;
    document.getElementById('aml-summary').innerHTML=
      card('Pending review', s.pending_review||0, (s.pending_review>0?'#B45309':'#15803D'))
     +card('Under EDD', s.edd||0, '#B45309')
     +card('Escalated', s.escalated||0, (s.escalated>0?'#B91C1C':'#475569'))
     +card('Flagged, list-check due', s.flagged_unlisted||0, (s.flagged_unlisted>0?'#B91C1C':'#15803D'))
     +card('STR open', s.str_open||0, (s.str_open>0?'#B45309':'#475569'))
     +card('STR overdue', s.str_overdue||0, (s.str_overdue>0?'#B91C1C':'#475569'))
     +card('Total screened', s.total_screened||0, '#0B2545')
     +'<div style="background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:10px 14px;min-width:150px"><div style="font-size:12px;font-weight:700;color:#0B2545">Risk assessment</div><div style="font-size:11px;color:#64748B">'+(ra?(ra.year+' · '+_amlEsc(ra.status)+' · residual '+_amlEsc(ra.residual_rating||'—')):'none yet')+'</div></div>';
  }catch(e){}
}
function amlTab(t){
  _amlTab=t;
  ["screen","str","risk","training"].forEach(function(x){ var el=document.getElementById('amltab-'+x); if(el){ el.style.color=(x===t?'#0B2545':'#64748B'); el.style.borderBottomColor=(x===t?'#DC2626':'transparent'); } });
  if(t==="screen") _amlRenderScreenings();
  else if(t==="str") _amlRenderStr();
  else if(t==="training") _amlRenderTraining();
  else _amlRenderRisk();
}
async function _amlRenderTraining(){
  const body=document.getElementById('aml-body'); body.innerHTML='Loading…';
  try{
    const rows=await apiGet('/api/aml/training'); if(rows&&rows.error) throw new Error(rows.error);
    var st='width:100%;margin-top:3px;padding:8px 10px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px;box-sizing:border-box';
    var lab='font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;font-weight:600';
    var form='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;padding:16px 18px;margin-bottom:14px">'
      +'<div style="font-weight:700;color:#0B2545;margin-bottom:8px">Log an AML/CFT training session <span style="font-weight:500;color:#94A3B8;font-size:12px">— evidence for SC inspection</span></div>'
      +'<div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px 16px">'
      +'<div><div style="'+lab+'">Date</div><input id="amlt-date" type="date" value="'+new Date().toISOString().slice(0,10)+'" style="'+st+'"></div>'
      +'<div><div style="'+lab+'">Trainer</div><input id="amlt-trainer" style="'+st+'"></div>'
      +'<div><div style="'+lab+'">Mode</div><select id="amlt-mode" style="'+st+'"><option value="in_person">In person</option><option value="online">Online</option><option value="external">External course</option></select></div>'
      +'<div><div style="'+lab+'">Scope</div><select id="amlt-scope" style="'+st+'"><option value="all_staff">All staff</option><option value="reps">Reps/consultants</option><option value="new_joiners">New joiners</option><option value="mlro">MLRO</option></select></div>'
      +'<div style="grid-column:1/-1"><div style="'+lab+'">Topic</div><input id="amlt-topic" placeholder="e.g. CDD/EDD, PEP & sanctions, STR reporting under AMLA 2001" style="'+st+'"></div>'
      +'<div style="grid-column:1/-1"><div style="'+lab+'">Attendees (comma-separated)</div><input id="amlt-attendees" placeholder="Gan Chin Soon, Koek Yee Jeen, …" style="'+st+'"></div>'
      +'<div style="grid-column:1/-1"><div style="'+lab+'">Materials / notes</div><input id="amlt-notes" style="'+st+'"></div>'
      +'</div><div style="margin-top:10px"><button onclick="amlAddTraining()" style="background:#0B2545;color:#fff;border:0;padding:8px 16px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer">+ Log training</button></div></div>';
    var table;
    if(!rows.length){ table='<div style="color:#64748B;background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:16px">No training logged yet. An SC AML inspection expects evidence of staff/rep AML training.</div>'; }
    else { table='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden"><table style="width:100%;border-collapse:collapse;font-size:13px"><thead style="background:#F8FAFC"><tr>'
      +'<th style="text-align:left;padding:9px 12px;color:#475569">Date</th><th style="text-align:left;padding:9px 12px;color:#475569">Topic</th><th style="text-align:left;padding:9px 12px;color:#475569">Scope / mode</th><th style="text-align:left;padding:9px 12px;color:#475569">Attendees</th><th style="padding:9px 12px"></th></tr></thead><tbody>'
      +rows.map(function(r){ var att=[]; try{att=JSON.parse(r.attendees_json||'[]');}catch(e){}
        return '<tr style="border-top:1px solid #F1F5F9;vertical-align:top"><td style="padding:9px 12px;white-space:nowrap"><b style="color:#0B2545">'+_amlEsc(r.training_date||'')+'</b></td>'
          +'<td style="padding:9px 12px;max-width:300px"><b style="color:#0B2545">'+_amlEsc(r.topic||'')+'</b>'+(r.trainer?'<div style="font-size:11px;color:#94A3B8">by '+_amlEsc(r.trainer)+'</div>':'')+'</td>'
          +'<td style="padding:9px 12px;font-size:12px;color:#475569">'+_amlEsc((r.scope||'').replace(/_/g,' '))+' · '+_amlEsc((r.mode||'').replace(/_/g,' '))+'</td>'
          +'<td style="padding:9px 12px;font-size:12px;color:#475569;max-width:240px">'+(r.attendee_count||0)+(att.length?'<div style="font-size:10px;color:#94A3B8">'+_amlEsc(att.join(', ')).slice(0,180)+'</div>':'')+'</td>'
          +'<td style="padding:9px 12px;text-align:right"><button onclick="amlDelTraining('+r.id+')" style="background:#fff;border:1px solid #FECACA;color:#B91C1C;padding:4px 7px;border-radius:6px;font-size:11px;cursor:pointer">✕</button></td></tr>';
      }).join('')+'</tbody></table></div>'; }
    body.innerHTML=form+table;
  }catch(e){ body.innerHTML='<div style="color:#B91C1C">'+_amlEsc(e.message)+'</div>'; }
}
async function amlAddTraining(){
  var topic=(document.getElementById('amlt-topic')||{}).value||'';
  if(!topic.trim()){ alert('Enter a training topic.'); return; }
  var attendees=((document.getElementById('amlt-attendees')||{}).value||'').split(',').map(function(s){return s.trim();}).filter(Boolean);
  var body={ training_date:(document.getElementById('amlt-date')||{}).value, topic:topic, trainer:(document.getElementById('amlt-trainer')||{}).value||'',
    mode:(document.getElementById('amlt-mode')||{}).value, scope:(document.getElementById('amlt-scope')||{}).value, attendees:attendees, materials_note:(document.getElementById('amlt-notes')||{}).value||'' };
  var r=await apiPost('/api/aml/training', body);
  if(r&&r.error){ alert(r.error); return; }
  _amlLoadSummary(); _amlRenderTraining();
}
async function amlDelTraining(id){ if(!confirm('Delete this training record?')) return; var r=await apiDelete('/api/aml/training/'+id); if(r&&r.error){alert(r.error);return;} _amlRenderTraining(); }

async function _amlRenderScreenings(){
  const body=document.getElementById('aml-body');
  body.innerHTML='Loading…';
  try{
    const rows=await apiGet('/api/aml/screenings'); if(rows&&rows.error) throw new Error(rows.error);
    var head='<div style="margin-bottom:10px"><button onclick="amlRunScreen()" style="background:#0B2545;color:#fff;border:0;padding:8px 14px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer">▶ Screen a KYC case by ID</button></div>';
    if(!rows.length){ body.innerHTML=head+'<div style="color:#64748B;background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:18px">No screenings yet. Verified KYC clients are screened automatically; the daily job also screens any case that has none.</div>'; return; }
    body.innerHTML=head+'<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden"><table style="width:100%;border-collapse:collapse;font-size:13px"><thead style="background:#F8FAFC"><tr>'
      +'<th style="text-align:left;padding:9px 12px;color:#475569">Client</th><th style="text-align:left;padding:9px 12px;color:#475569">Rating</th><th style="text-align:left;padding:9px 12px;color:#475569">Flags</th><th style="text-align:left;padding:9px 12px;color:#475569">AI rationale</th><th style="text-align:left;padding:9px 12px;color:#475569">Status</th><th style="padding:9px 12px"></th></tr></thead><tbody>'
      +rows.map(function(r){
        var flags=[];
        if(r.pep_status&&r.pep_status!=='none'&&r.pep_status!=='unknown') flags.push(_amlBadge('PEP:'+r.pep_status,'#7C2D12','#FFEDD5'));
        if(r.sanctions_flag&&r.sanctions_flag!=='clear') flags.push(_amlBadge('SANC:'+r.sanctions_flag,'#B91C1C','#FEE2E2'));
        if(r.adverse_media_flag&&r.adverse_media_flag!=='none'&&r.adverse_media_flag!=='unknown') flags.push(_amlBadge('MEDIA:'+r.adverse_media_flag,'#9333EA','#F3E8FF'));
        if(r.sof_plausibility==='needs_review'||r.sof_plausibility==='implausible') flags.push(_amlBadge('SOF:'+r.sof_plausibility,'#B45309','#FEF3C7'));
        if(!flags.length) flags.push('<span style="color:#94A3B8;font-size:11px">—</span>');
        var lmc = r.list_match_count||0;
        var listWarn = (lmc>0
          ? '<div style="font-size:10px;color:#B91C1C;margin-top:3px;font-weight:700;cursor:pointer" onclick="amlShowMatches('+r.id+')">⚠ '+lmc+' sanctions-list match — view</div>'
          : (r.list_checked?'<div style="font-size:10px;color:#15803D;margin-top:3px">✓ UN+OFAC screened</div>':''))
          + ((r.pep_status==='possible'||r.pep_status==='confirmed')?'<div style="font-size:10px;color:#B45309;margin-top:2px">PEP — verify vs PEP list</div>':'');
        var act='';
        if(r.status==='pending_review'||r.status==='edd'){
          act='<button onclick="amlDecide('+r.id+',\'cleared\')" style="background:#DCFCE7;color:#15803D;border:0;padding:5px 9px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">Clear</button>'
             +'<button onclick="amlDecide('+r.id+',\'edd\')" style="background:#FEF3C7;color:#B45309;border:0;padding:5px 9px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">EDD</button>'
             +'<button onclick="amlDecide('+r.id+',\'escalated\')" style="background:#FEE2E2;color:#B91C1C;border:0;padding:5px 9px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">Escalate</button>'
             +'<button onclick="amlStrFrom(\''+_amlEsc(r.case_id)+'\',\''+_amlEsc((r.client_name||"").replace(/\x27/g,""))+'\')" style="background:#fff;border:1px solid #CBD5E1;color:#0B2545;padding:5px 9px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">→ STR</button>';
        } else {
          act='<span style="font-size:11px;color:#94A3B8">'+_amlEsc(r.decided_by||'')+'</span> <button onclick="amlReScreen(\''+_amlEsc(r.case_id)+'\')" style="background:#fff;border:1px solid #CBD5E1;color:#475569;padding:4px 8px;border-radius:6px;font-size:11px;cursor:pointer;margin-left:4px">re-screen</button>';
        }
        return '<tr style="border-top:1px solid #F1F5F9;vertical-align:top">'
          +'<td style="padding:10px 12px"><b style="color:#0B2545">'+_amlEsc(r.client_name||'?')+'</b><div style="font-size:10px;color:#94A3B8">'+_amlEsc(r.case_id||'')+' · '+_amlEsc(r.form_type||'')+'</div></td>'
          +'<td style="padding:10px 12px">'+_amlRatePill(r.risk_rating)+'<div style="font-size:10px;color:#94A3B8;margin-top:3px">rec: '+_amlEsc(r.recommended_action||'')+'</div></td>'
          +'<td style="padding:10px 12px">'+flags.join(' ')+listWarn+'</td>'
          +'<td style="padding:10px 12px;max-width:300px;font-size:12px;color:#475569">'+_amlEsc(r.rationale||'')+'</td>'
          +'<td style="padding:10px 12px">'+_amlStatusPill(r.status)+(r.decided_note?'<div style="font-size:10px;color:#94A3B8;max-width:160px">'+_amlEsc(r.decided_note)+'</div>':'')+'</td>'
          +'<td style="padding:10px 12px;text-align:right;white-space:nowrap">'+act+'</td></tr>';
      }).join('')+'</tbody></table></div>';
    window._amlScreenRows=rows;
  }catch(e){ body.innerHTML='<div style="color:#B91C1C">'+_amlEsc(e.message)+'</div>'; }
}
function amlShowMatches(id){
  var r=(window._amlScreenRows||[]).find(function(x){return x.id===id;}); if(!r) return;
  var lm=null; try{ lm=JSON.parse(r.list_matches_json||'null'); }catch(e){}
  if(!lm){ alert('No match detail stored.'); return; }
  var ms=(lm.matches||[]);
  var txt='Sanctions-list screening for '+(r.client_name||'')+'\n(searched: '+((lm.searched||[]).join(', ')||'UN, OFAC')+')\n\nOverall: '+(lm.overall||'').toUpperCase()+'\n'+(lm.rationale?('\n'+lm.rationale+'\n'):'');
  if(ms.length){ txt+='\nMatches:\n'+ms.map(function(m){return '• '+(m.name||'')+' ['+(m.source||'')+'] — '+(m.verdict||'')+'\n   '+(m.reason||'');}).join('\n'); }
  else { txt+='\nCandidates reviewed but none confirmed as the client.'; }
  alert(txt);
}
async function amlRunScreen(){
  var id=prompt("Enter the KYC case ID to screen (from the KYC app):"); if(!id) return;
  var b=document.getElementById('aml-body'); b.innerHTML='Screening '+_amlEsc(id)+' with AI…';
  try{ var r=await apiPost('/api/aml/screen/'+encodeURIComponent(id.trim()),{}); if(r&&r.error){ alert('Screening failed: '+r.error); } }
  catch(e){ alert('Error: '+e.message); }
  _amlLoadSummary(); _amlRenderScreenings();
}
async function amlReScreen(caseId){ if(!caseId) return; if(!confirm('Re-run AI screening for '+caseId+'?')) return;
  await apiPost('/api/aml/screen/'+encodeURIComponent(caseId),{}); _amlLoadSummary(); _amlRenderScreenings(); }
async function amlDecide(id, decision){
  var listChecked=false;
  if(decision==='cleared') listChecked=confirm("Confirm CLEAR.\n\nClick OK if you have also checked the client name against the official UN / OFAC / MOHA sanctions & PEP lists (this will be recorded).\n\nClick Cancel to clear without recording a list check.");
  var note=prompt("Decision note (optional):","")||"";
  try{ var r=await apiPost('/api/aml/screening/'+id+'/decide',{decision:decision, note:note, list_checked:listChecked}); if(r&&r.error){ alert(r.error); return; } }
  catch(e){ alert(e.message); return; }
  _amlLoadSummary(); _amlRenderScreenings();
}

async function _amlRenderStr(){
  const body=document.getElementById('aml-body'); body.innerHTML='Loading…';
  try{
    const rows=await apiGet('/api/aml/str'); if(rows&&rows.error) throw new Error(rows.error);
    var head='<div style="margin-bottom:10px"><button onclick="amlStrFrom()" style="background:#0B2545;color:#fff;border:0;padding:8px 14px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer">+ Draft STR from a case (AI)</button> <span style="font-size:11px;color:#94A3B8">Internal work-up only — lodgement with BNM FIU is a recorded human action.</span></div>';
    if(!rows.length){ body.innerHTML=head+'<div style="color:#64748B;background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:18px">No STR records.</div>'; return; }
    body.innerHTML=head+'<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden"><table style="width:100%;border-collapse:collapse;font-size:13px"><thead style="background:#F8FAFC"><tr>'
      +'<th style="text-align:left;padding:9px 12px;color:#475569">Subject</th><th style="text-align:left;padding:9px 12px;color:#475569">Narrative</th><th style="text-align:left;padding:9px 12px;color:#475569">Status</th><th style="padding:9px 12px"></th></tr></thead><tbody>'
      +rows.map(function(r){
        var sp={draft:["DRAFT","#B45309","#FEF3C7"],mlro_review:["MLRO REVIEW","#B45309","#FEF3C7"],reported:["REPORTED TO FIU","#15803D","#DCFCE7"],dismissed:["DISMISSED","#475569","#F1F5F9"]}[r.status]||[r.status,"#475569","#F1F5F9"];
        var act='';
        var open=(r.status==='draft'||r.status==='mlro_review');
        if(open){
          act='<button onclick="amlStrDecide('+r.id+',\'reported\')" style="background:#DCFCE7;color:#15803D;border:0;padding:5px 9px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">Mark filed (goAML)</button>'
             +'<button onclick="amlStrDecide('+r.id+',\'dismissed\')" style="background:#F1F5F9;color:#475569;border:0;padding:5px 9px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">Decide not to file</button>';
        } else if(r.lodged_ref){ act='<span style="font-size:11px;color:#94A3B8">ref '+_amlEsc(r.lodged_ref)+'</span>'; }
        var od=open && r.due_at && r.due_at < new Date().toISOString().slice(0,10);
        var dueLine=open && r.due_at ? '<div style="font-size:11px;color:'+(od?'#B91C1C':'#64748B')+';font-weight:'+(od?'700':'400')+'">File by '+_amlEsc(r.due_at)+(od?' · OVERDUE':'')+'</div>' : '';
        return '<tr style="border-top:1px solid #F1F5F9;vertical-align:top">'
          +'<td style="padding:10px 12px"><b style="color:#0B2545">'+_amlEsc(r.client_name||'?')+'</b><div style="font-size:10px;color:#94A3B8">'+_amlEsc(r.case_id||'')+'</div><div style="font-size:11px;color:#B45309;max-width:160px">'+_amlEsc(r.reason||'')+'</div>'+dueLine+'</td>'
          +'<td style="padding:10px 12px;max-width:360px;font-size:12px;color:#475569">'+_amlEsc(r.narrative||'')+'</td>'
          +'<td style="padding:10px 12px">'+_amlBadge(sp[0],sp[1],sp[2])+'</td>'
          +'<td style="padding:10px 12px;text-align:right;white-space:nowrap">'+act+'</td></tr>';
      }).join('')+'</tbody></table></div>';
  }catch(e){ body.innerHTML='<div style="color:#B91C1C">'+_amlEsc(e.message)+'</div>'; }
}
async function amlStrFrom(caseId, clientName){
  caseId = caseId || prompt("KYC case ID to work up an STR from:"); if(!caseId) return;
  var reason=prompt("What triggered the suspicion? (one line)","")||"";
  var body=document.getElementById('aml-body'); var prev=body.innerHTML; body.innerHTML='AI drafting STR work-up for '+_amlEsc(caseId)+'…';
  var ai;
  try{ ai=await apiPost('/api/aml/str/draft/'+encodeURIComponent(caseId),{reason:reason}); }
  catch(e){ alert(e.message); body.innerHTML=prev; return; }
  if(!ai||ai.error){ alert('Draft failed: '+((ai&&ai.error)||'unknown')); body.innerHTML=prev; return; }
  var ind=(ai.indicators||[]).join("\n • ");
  var ok=confirm("AI STR DRAFT (review before saving)\n\nNarrative:\n"+(ai.narrative||"")+"\n\nIndicators:\n • "+ind+"\n\nAI recommendation: "+(ai.recommended||"")+"\n\nSave this to the STR register for MLRO review?");
  if(!ok){ amlTab('str'); return; }
  try{ await apiPost('/api/aml/str',{case_id:caseId, client_name:clientName||ai.client_name||"", reason:reason, narrative:ai.narrative||"", indicators:ai.indicators||[], ai_json:ai}); }
  catch(e){ alert(e.message); }
  _amlLoadSummary(); amlTab('str');
}
async function amlStrDecide(id, status){
  var lodged="", note="";
  if(status==='reported'){
    lodged=(prompt("Enter the goAML / BNM FIU reference number to record that this STR was FILED:","")||"").trim();
    if(!lodged){ alert("A goAML / FIU reference is required to mark the STR as filed."); return; }
    note=prompt("Filing note (optional):","")||"";
  } else if(status==='dismissed'){
    note=(prompt("Decision NOT to file — document the reason (required for the audit trail):","")||"").trim();
    if(!note){ alert("A reason is required to record a decision not to file."); return; }
  }
  try{ var r=await apiPost('/api/aml/str/'+id+'/decide',{status:status, lodged_ref:lodged, note:note}); if(r&&r.error){ alert(r.error); return; } }
  catch(e){ alert(e.message); return; }
  _amlLoadSummary(); _amlRenderStr();
}

async function _amlRenderRisk(){
  const body=document.getElementById('aml-body'); body.innerHTML='Loading…';
  try{
    const rows=await apiGet('/api/aml/risk-assessment'); if(rows&&rows.error) throw new Error(rows.error);
    var head='<div style="margin-bottom:12px"><button onclick="amlGenRisk()" style="background:#0B2545;color:#fff;border:0;padding:8px 14px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer">⚙ Generate annual risk assessment (AI)</button> <span style="font-size:11px;color:#94A3B8">SC AML/CFT Guidelines — institutional risk assessment.</span></div>';
    if(!rows.length){ body.innerHTML=head+'<div style="color:#64748B;background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:18px">No risk assessment yet. Generate the first one — it drafts inherent risk across customers/products/geography/channels/transactions and rates residual risk after controls.</div>'; return; }
    var latest=rows[0];
    var inh=[]; try{ inh=JSON.parse(latest.inherent_json||"[]"); }catch(e){}
    var ctl=[]; try{ ctl=JSON.parse(latest.controls_json||"[]"); }catch(e){}
    var pri=[]; try{ var aj=JSON.parse(latest.ai_json||"{}"); pri=aj.priority_actions||[]; }catch(e){}
    function rrow(d,risk,basis){ var c=String(risk||"").toLowerCase(); var col=c==='high'?'#B91C1C':(c==='medium'?'#B45309':'#15803D');
      return '<tr style="border-top:1px solid #F1F5F9"><td style="padding:7px 12px;font-weight:600;color:#0B2545">'+_amlEsc(d)+'</td><td style="padding:7px 12px;color:'+col+';font-weight:700">'+_amlEsc(String(risk||'').toUpperCase())+'</td><td style="padding:7px 12px;font-size:12px;color:#475569">'+_amlEsc(basis)+'</td></tr>'; }
    function crow(c,eff,gap){ var e=String(eff||"").toLowerCase(); var col=e==='weak'?'#B91C1C':(e==='adequate'?'#B45309':'#15803D');
      return '<tr style="border-top:1px solid #F1F5F9"><td style="padding:7px 12px;font-weight:600;color:#0B2545">'+_amlEsc(c)+'</td><td style="padding:7px 12px;color:'+col+';font-weight:700">'+_amlEsc(String(eff||'').toUpperCase())+'</td><td style="padding:7px 12px;font-size:12px;color:#475569">'+_amlEsc(gap)+'</td></tr>'; }
    var resCol=String(latest.residual_rating||"").toLowerCase()==='high'?'#B91C1C':(String(latest.residual_rating||"").toLowerCase()==='medium'?'#B45309':'#15803D');
    body.innerHTML=head
      +'<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;padding:18px 20px;max-width:880px">'
      +'<div style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:10px"><div><b style="color:#0B2545;font-size:15px">Institutional AML/CFT Risk Assessment '+_amlEsc(latest.year)+'</b> '+_amlBadge(latest.status==='approved'?'APPROVED':'DRAFT',latest.status==='approved'?'#15803D':'#B45309',latest.status==='approved'?'#DCFCE7':'#FEF3C7')+'</div>'
      +'<div>Residual risk: <b style="color:'+resCol+'">'+_amlEsc(String(latest.residual_rating||'—').toUpperCase())+'</b>'+(latest.status!=='approved'?' &nbsp;<button onclick="amlApproveRisk('+latest.id+')" style="background:#0B2545;color:#fff;border:0;padding:6px 12px;border-radius:7px;font-size:12px;font-weight:700;cursor:pointer">Approve</button>':'')+'</div></div>'
      +'<div style="font-size:13px;color:#475569;margin:10px 0 16px">'+_amlEsc(latest.summary||'')+'</div>'
      +'<div style="font-weight:700;color:#0B2545;margin:6px 0">Inherent risk</div><table style="width:100%;border-collapse:collapse;font-size:13px"><tbody>'+inh.map(function(x){return rrow(x.dimension,x.risk,x.basis);}).join('')+'</tbody></table>'
      +'<div style="font-weight:700;color:#0B2545;margin:16px 0 6px">Controls</div><table style="width:100%;border-collapse:collapse;font-size:13px"><tbody>'+ctl.map(function(x){return crow(x.control,x.effectiveness,x.gap);}).join('')+'</tbody></table>'
      +(pri.length?'<div style="font-weight:700;color:#0B2545;margin:16px 0 6px">Priority actions</div><ul style="margin:0;padding-left:20px;font-size:13px;color:#475569">'+pri.map(function(p){return '<li>'+_amlEsc(p)+'</li>';}).join('')+'</ul>':'')
      +'<div style="font-size:11px;color:#94A3B8;margin-top:14px">AI-drafted ('+_amlEsc(latest.ai_model||'')+'). Review and approve as the firm’s officer before relying on it.</div>'
      +'</div>'
      +(rows.length>1?'<div style="font-size:12px;color:#94A3B8;margin-top:10px">'+rows.length+' assessment(s) on record.</div>':'');
  }catch(e){ body.innerHTML='<div style="color:#B91C1C">'+_amlEsc(e.message)+'</div>'; }
}
async function amlGenRisk(){
  if(!confirm("Generate this year's institutional AML/CFT risk assessment with AI? It will be saved as a DRAFT for your approval.")) return;
  var body=document.getElementById('aml-body'); body.innerHTML='AI drafting the institutional risk assessment…';
  try{ var r=await apiPost('/api/aml/risk-assessment/generate',{}); if(r&&r.error){ alert('Failed: '+r.error); } }
  catch(e){ alert(e.message); }
  _amlLoadSummary(); _amlRenderRisk();
}
async function amlApproveRisk(id){ if(!confirm("Approve this risk assessment as the firm's officer?")) return;
  await apiPost('/api/aml/risk-assessment/'+id+'/approve',{}); _amlLoadSummary(); _amlRenderRisk(); }

// ===== Complaints & Advertising (AI) view =====
var _caTab="complaints";
function _caRiskPill(r){ return _amlRatePill(r); }
function _caVerdictPill(v){ v=String(v||"").toLowerCase();
  if(v==="approved") return _amlBadge("APPROVED","#15803D","#DCFCE7");
  if(v==="rejected") return _amlBadge("REJECTED","#fff","#B91C1C");
  if(v==="changes_needed"||v==="changes_requested") return _amlBadge("CHANGES NEEDED","#B45309","#FEF3C7");
  if(v==="pending") return _amlBadge("PENDING","#475569","#F1F5F9");
  return _amlBadge(v||"—","#475569","#F1F5F9"); }
async function renderComplaintsAds(){
  const main=document.getElementById("main-content");
  main.innerHTML=`<div style="padding:24px">
    <h2 style="margin:0 0 4px 0;color:#0B2545">Complaints &amp; Advertising — AI-assisted</h2>
    <div style="color:#64748B;font-size:13px;margin-bottom:14px;max-width:780px">AI classifies complaints (category, severity, FIMM-reportability) and drafts the quarterly FIMM report; AI vets marketing material against the SC Guidelines on Advertising before publication. You decide and resolve.</div>
    <div id="ca-summary" style="display:flex;gap:12px;flex-wrap:wrap;margin-bottom:16px"></div>
    <div style="display:flex;gap:8px;margin-bottom:14px;border-bottom:1px solid #E2E8F0">
      <button id="catab-complaints" onclick="caTab('complaints')" style="background:none;border:0;border-bottom:2px solid transparent;padding:8px 6px;cursor:pointer;font-weight:700;color:#64748B">Complaints register</button>
      <button id="catab-ads" onclick="caTab('ads')" style="background:none;border:0;border-bottom:2px solid transparent;padding:8px 6px;cursor:pointer;font-weight:700;color:#64748B">Advertising review</button>
      <button id="catab-playbook" onclick="caTab('playbook')" style="background:none;border:0;border-bottom:2px solid transparent;padding:8px 6px;cursor:pointer;font-weight:700;color:#64748B">Handling Playbook</button>
    </div>
    <div id="ca-body" style="color:#64748B">Loading…</div></div>`;
  _caLoadSummary(); caTab(_caTab);
}
async function _caLoadSummary(){
  try{ const s=await apiGet('/api/complaints-ads/summary'); if(!s||s.error) return;
    function card(label,val,color){ return '<div style="background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:10px 14px;min-width:110px"><div style="font-size:22px;font-weight:800;color:'+color+'">'+val+'</div><div style="font-size:11px;color:#64748B;font-weight:600">'+label+'</div></div>'; }
    document.getElementById('ca-summary').innerHTML=
      card('Open complaints', s.open||0, (s.open>0?'#B45309':'#15803D'))
     +card('Overdue (SLA)', s.overdue||0, (s.overdue>0?'#B91C1C':'#15803D'))
     +card('High severity', s.high||0, (s.high>0?'#B91C1C':'#475569'))
     +card('Ads pending', s.ad_pending||0, (s.ad_pending>0?'#B45309':'#15803D'))
     +card('Complaints total', s.total_complaints||0, '#0B2545')
     +card('Ads reviewed', s.ad_total||0, '#0B2545');
  }catch(e){}
}
function caTab(t){ _caTab=t;
  ["complaints","ads","playbook"].forEach(function(x){ var el=document.getElementById('catab-'+x); if(el){ el.style.color=(x===t?'#0B2545':'#64748B'); el.style.borderBottomColor=(x===t?'#9333EA':'transparent'); } });
  if(t==="complaints") _caRenderComplaints(); else if(t==="ads") _caRenderAds(); else _caRenderPlaybook();
}
var _CA_PLAYBOOK=[
  {type:"Mis-selling / unsuitable advice",risk:"high",why:"Product did not match the client's risk profile or objective. Core SC conduct breach; classic SIDREC award; licence risk.",
   records:["Suitability assessment + LIFA Risk Score","Signed record of advice (why suitable, alternatives)","Risk acknowledgement"],
   steps:["Pull the suitability + advice record","If advice WAS suitable & documented — defend with the evidence","If not — remediate (unwind/compensate), self-assess, escalate to CO"]},
  {type:"Misrepresentation / 'guaranteed returns' / risk downplayed",risk:"high",why:"CMSA false-or-misleading conduct + SC advertising breach. Can be criminal.",
   records:["Marketing/advertising approval log","Record of advice & what was said","Product Highlights Sheet acknowledgement"],
   steps:["Pull marketing + advice records","If adviser over-promised — discipline + correct the client's understanding in writing","Treat as high regulatory risk; escalate to CO/Board"]},
  {type:"Undisclosed fees / sales charge / conflicts / related-party",risk:"high",why:"SC disclosure breach; client claims refund of charges.",
   records:["Signed disclosure (fees, sales/wrap charge, conflicts, cooling-off)","Conflicts-of-Interest register entry"],
   steps:["Produce the signed disclosure","If missing — remediate (refund where due) + tighten disclosure process","Log root cause in remediation tracker"]},
  {type:"Unauthorised transactions / churning",risk:"high",why:"Fraud-adjacent (switching to generate commission, or trading without instruction). Serious enforcement + PI claim.",
   records:["Signed/recorded transaction instructions","Switch-frequency / transaction history"],
   steps:["Pull the instruction trail to prove (or disprove) authority","If no authority — treat as SERIOUS: escalate to CO/MLRO/Board, notify PI insurer, consider self-report to SC/FIMM"]},
  {type:"Cooling-off rights not honoured (6 business days, UTS)",risk:"medium",why:"Clear rule breach; easy regulator finding.",
   records:["Cooling-off disclosure + date-stamped client instruction","Transaction timestamps"],
   steps:["Check the 6-business-day window vs the transaction","If breached — reverse/refund per the cooling-off right + apology in writing"]},
  {type:"Execution failure / delay (redemption, switch)",risk:"medium",why:"Loss claim + service finding.",
   records:["Instruction timestamp vs execution timestamp","Platform (iFAST) confirmations"],
   steps:["Pull timestamps to establish what happened","Rectify the transaction + consider goodwill for any quantified loss"]},
  {type:"PDPA / data mishandling",risk:"high",why:"Separate regulator (PDPA) with its own penalties; loss of client trust.",
   records:["Consent records","Access log / who-saw-what","Incident note"],
   steps:["Contain the breach + assess scope","Notify affected client(s) as appropriate","Log incident; review access controls"]},
  {type:"Misappropriation of client funds",risk:"critical",why:"Criminal; licence-ending.",
   records:["Transaction + bank trail","All client instructions & communications"],
   steps:["Escalate to Board IMMEDIATELY","Preserve all records","Self-report to SC + notify PI insurer + seek legal advice"]},
  {type:"Service / non-responsiveness",risk:"low",why:"Low individually, but volume signals weak controls.",
   records:["Communication log (email/WhatsApp)","Complaint register entry"],
   steps:["Acknowledge within 1 business day","Resolve + log","Track for recurring themes"]}
];
function _caRiskTag(r){ var m={critical:["CRITICAL","#fff","#B91C1C"],high:["HIGH","#B91C1C","#FEE2E2"],medium:["MEDIUM","#B45309","#FEF3C7"],low:["LOW","#15803D","#DCFCE7"]}[r]||["",""]; return _amlBadge(m[0],m[1],m[2]); }
function _caRenderPlaybook(){
  const body=document.getElementById('ca-body');
  var flow='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;padding:16px 18px;margin-bottom:16px">'
    +'<div style="font-weight:700;color:#0B2545;margin-bottom:8px">Standard complaint-handling flow <span style="font-weight:500;color:#94A3B8;font-size:12px">— SC/FIMM-expected process, every complaint</span></div>'
    +'<div style="display:flex;flex-wrap:wrap;gap:8px;font-size:12px">'
    +['1. Acknowledge ≤1 business day','2. Log in register (AI classifies)','3. Investigate — pull KYC/advice/disclosure/transaction/comms','4. Resolve ≤15 business days (or interim update) in writing','5. If unresolved → inform client of SIDREC (free, binding ≤RM250k)','6. Escalate serious cases to CO/MLRO/Board; notify PI insurer; consider self-report','7. Report to FIMM quarterly','8. Root-cause → remediation tracker'].map(function(s){return '<span style="background:#F1F5F9;color:#334155;border-radius:7px;padding:6px 10px">'+s+'</span>';}).join('')
    +'</div></div>';
  var rows=_CA_PLAYBOOK.map(function(p){
    return '<tr style="border-top:1px solid #F1F5F9;vertical-align:top">'
      +'<td style="padding:11px 12px;max-width:200px"><b style="color:#0B2545">'+_amlEsc(p.type)+'</b><div style="margin-top:4px">'+_caRiskTag(p.risk)+'</div></td>'
      +'<td style="padding:11px 12px;max-width:240px;font-size:12px;color:#64748B">'+_amlEsc(p.why)+'</td>'
      +'<td style="padding:11px 12px;font-size:12px;color:#334155">• '+p.records.map(_amlEsc).join('<br>• ')+'</td>'
      +'<td style="padding:11px 12px;font-size:12px;color:#15803D">'+p.steps.map(function(s,i){return (i+1)+'. '+_amlEsc(s);}).join('<br>')+'</td></tr>';
  }).join('');
  body.innerHTML=flow
    +'<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden"><table style="width:100%;border-collapse:collapse;font-size:13px"><thead style="background:#F8FAFC"><tr>'
    +'<th style="text-align:left;padding:10px 12px;color:#475569">Complaint type / risk</th><th style="text-align:left;padding:10px 12px;color:#475569">Why it matters</th><th style="text-align:left;padding:10px 12px;color:#475569">Records to produce</th><th style="text-align:left;padding:10px 12px;color:#475569">Action steps</th></tr></thead><tbody>'
    +rows+'</tbody></table></div>'
    +'<div style="font-size:11px;color:#94A3B8;margin-top:10px">Reference only — escalate any complaint alleging loss, mis-selling, fraud or a regulatory breach to the Compliance Officer. SC Guidelines on Conduct · FIMM complaint rules · SIDREC.</div>';
}

async function _caRenderComplaints(){
  const body=document.getElementById('ca-body'); body.innerHTML='Loading…';
  try{
    const rows=await apiGet('/api/complaints'); if(rows&&rows.error) throw new Error(rows.error);
    var form='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;padding:16px 18px;margin-bottom:14px">'
      +'<div style="font-weight:700;color:#0B2545;margin-bottom:8px">Log a complaint <span style="font-weight:500;color:#94A3B8;font-size:12px">— AI classifies it for you</span></div>'
      +'<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:8px">'
      +'<input id="cmp-complainant" placeholder="Complainant" style="flex:1;min-width:150px;padding:8px;border:1px solid #CBD5E1;border-radius:7px;font-size:13px">'
      +'<input id="cmp-client" placeholder="Client name (if any)" style="flex:1;min-width:150px;padding:8px;border:1px solid #CBD5E1;border-radius:7px;font-size:13px">'
      +'<input id="cmp-date" type="date" value="'+new Date().toISOString().slice(0,10)+'" style="padding:8px;border:1px solid #CBD5E1;border-radius:7px;font-size:13px">'
      +'</div>'
      +'<textarea id="cmp-text" placeholder="Paste or type the complaint message…" style="width:100%;box-sizing:border-box;min-height:80px;padding:8px;border:1px solid #CBD5E1;border-radius:7px;font-size:13px"></textarea>'
      +'<div style="margin-top:8px"><button onclick="caLogComplaint()" style="background:#0B2545;color:#fff;border:0;padding:8px 14px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer">🤖 AI classify &amp; log</button> '
      +'<button onclick="caQuarterlyReport()" style="background:#fff;border:1px solid #CBD5E1;color:#0B2545;padding:8px 14px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer;margin-left:6px">📄 Quarterly FIMM report (AI)</button></div>'
      +'<div id="cmp-aiout" style="margin-top:10px"></div></div>';
    var table='';
    if(!rows.length){ table='<div style="color:#64748B;background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:16px">No complaints logged.</div>'; }
    else { table='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden"><table style="width:100%;border-collapse:collapse;font-size:13px"><thead style="background:#F8FAFC"><tr>'
      +'<th style="text-align:left;padding:9px 12px;color:#475569">Received / SLA</th><th style="text-align:left;padding:9px 12px;color:#475569">Subject</th><th style="text-align:left;padding:9px 12px;color:#475569">Category</th><th style="text-align:left;padding:9px 12px;color:#475569">Status</th><th style="padding:9px 12px"></th></tr></thead><tbody>'
      +rows.map(function(r){
        var sevc=r.severity==='high'?'#B91C1C':(r.severity==='medium'?'#B45309':'#15803D');
        var today=new Date().toISOString().slice(0,10);
        var overdue=(r.status==='open'||r.status==='investigating')&&r.sla_resolve_due&&r.sla_resolve_due<today;
        var sp={open:["OPEN","#B45309","#FEF3C7"],investigating:["INVESTIGATING","#B45309","#FEF3C7"],resolved:["RESOLVED","#15803D","#DCFCE7"],escalated_sidrec:["→ SIDREC","#B91C1C","#FEE2E2"],dismissed:["DISMISSED","#475569","#F1F5F9"]}[r.status]||[r.status,"#475569","#F1F5F9"];
        var act='';
        if(r.status==='open'||r.status==='investigating'){
          act='<button onclick="caComplaintUpdate('+r.id+',\'investigating\')" style="background:#FEF3C7;color:#B45309;border:0;padding:5px 8px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">Investigating</button>'
             +'<button onclick="caComplaintUpdate('+r.id+',\'resolved\')" style="background:#DCFCE7;color:#15803D;border:0;padding:5px 8px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">Resolve</button>'
             +'<button onclick="caComplaintUpdate('+r.id+',\'escalated_sidrec\')" style="background:#FEE2E2;color:#B91C1C;border:0;padding:5px 8px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">SIDREC</button>';
        }
        return '<tr style="border-top:1px solid #F1F5F9;vertical-align:top">'
          +'<td style="padding:10px 12px;white-space:nowrap"><b style="color:#0B2545">'+_amlEsc(r.received_at||'')+'</b><div style="font-size:10px;color:'+(overdue?'#B91C1C':'#94A3B8')+'">'+(overdue?'⚠ overdue':'resolve by '+_amlEsc(r.sla_resolve_due||'—'))+'</div></td>'
          +'<td style="padding:10px 12px;max-width:300px"><b style="color:#0B2545">'+_amlEsc(r.client_name||r.complainant||'?')+'</b> <span style="color:'+sevc+';font-weight:700;font-size:11px">'+_amlEsc((r.severity||'').toUpperCase())+'</span><div style="font-size:12px;color:#475569">'+_amlEsc(r.summary||'')+'</div></td>'
          +'<td style="padding:10px 12px;font-size:12px;color:#475569">'+_amlEsc((r.category||'').replace(/_/g,' '))+(r.reportable_fimm?'<div style="font-size:10px;color:#9333EA">FIMM-reportable</div>':'')+'</td>'
          +'<td style="padding:10px 12px">'+_amlBadge(sp[0],sp[1],sp[2])+(r.resolution?'<div style="font-size:10px;color:#94A3B8;max-width:150px">'+_amlEsc(r.resolution)+'</div>':'')+'</td>'
          +'<td style="padding:10px 12px;text-align:right;white-space:nowrap">'+act+'</td></tr>';
      }).join('')+'</tbody></table></div>'; }
    body.innerHTML=form+table;
  }catch(e){ body.innerHTML='<div style="color:#B91C1C">'+_amlEsc(e.message)+'</div>'; }
}
async function caLogComplaint(){
  var text=(document.getElementById('cmp-text')||{}).value||"";
  if(!text.trim()){ alert("Paste the complaint message first."); return; }
  var complainant=(document.getElementById('cmp-complainant')||{}).value||"";
  var client=(document.getElementById('cmp-client')||{}).value||"";
  var date=(document.getElementById('cmp-date')||{}).value||new Date().toISOString().slice(0,10);
  var out=document.getElementById('cmp-aiout'); out.innerHTML='🤖 AI classifying…';
  var ai;
  try{ ai=await apiPost('/api/complaints/classify',{text:text, from:complainant, channel:'manual'}); }
  catch(e){ out.innerHTML='<span style="color:#B91C1C">'+e.message+'</span>'; return; }
  if(!ai||ai.error){ out.innerHTML='<span style="color:#B91C1C">'+((ai&&ai.error)||'classify failed')+'</span>'; return; }
  if(ai.is_complaint===false){ if(!confirm("AI assessment: this does NOT look like a complaint.\n\n"+(ai.summary||"")+"\n\nLog it anyway?")){ out.innerHTML='<span style="color:#94A3B8">Not logged.</span>'; return; } }
  var r=await apiPost('/api/complaints',{complainant:complainant, client_name:client, received_at:date, detail:text,
    summary:ai.summary, category:ai.category, severity:ai.severity, reportable_fimm:ai.reportable_fimm, is_complaint:ai.is_complaint, ai_json:ai});
  if(r&&r.error){ out.innerHTML='<span style="color:#B91C1C">'+r.error+'</span>'; return; }
  out.innerHTML='<div style="background:#F0FDF4;border:1px solid #BBF7D0;border-radius:8px;padding:10px 12px;font-size:12px;color:#166534">✓ Logged — '+_amlEsc(ai.category)+' / '+_amlEsc(ai.severity)+'. <b>Suggested acknowledgement:</b> '+_amlEsc(ai.draft_acknowledgement||'')+'</div>';
  ['cmp-text','cmp-complainant','cmp-client'].forEach(function(id){var e=document.getElementById(id); if(e)e.value='';});
  _caLoadSummary(); setTimeout(_caRenderComplaints, 1800);
}
async function caComplaintUpdate(id, status){
  var resolution=null;
  if(status==='resolved'||status==='dismissed'||status==='escalated_sidrec') resolution=prompt("Resolution / note:","")||"";
  var r=await apiPost('/api/complaints/'+id+'/update',{status:status, resolution:resolution});
  if(r&&r.error){ alert(r.error); return; }
  _caLoadSummary(); _caRenderComplaints();
}
async function caQuarterlyReport(){
  var q=prompt("Which quarter? (e.g. 2026Q2)", new Date().getUTCFullYear()+"Q"+(Math.floor(new Date().getUTCMonth()/3)+1));
  if(!q) return;
  var out=document.getElementById('cmp-aiout'); out.innerHTML='🤖 Drafting quarterly report…';
  var r;
  try{ r=await apiGet('/api/complaints/quarterly-report?q='+encodeURIComponent(q)); }
  catch(e){ out.innerHTML='<span style="color:#B91C1C">'+e.message+'</span>'; return; }
  if(!r||r.error){ out.innerHTML='<span style="color:#B91C1C">'+((r&&r.error)||'failed')+'</span>'; return; }
  var rep=r.report||{};
  out.innerHTML='<div style="background:#F8FAFC;border:1px solid #E2E8F0;border-radius:10px;padding:14px 16px"><b style="color:#0B2545">FIMM Complaint Report — '+_amlEsc(r.quarter)+'</b> <span style="font-size:11px;color:#94A3B8">('+r.count+' reportable; '+(rep.nil_return?'NIL return':'has entries')+')</span>'
    +'<div style="font-size:13px;color:#475569;margin-top:8px;white-space:pre-wrap">'+_amlEsc(rep.narrative||'')+'</div>'
    +((rep.themes&&rep.themes.length)?'<div style="font-size:12px;color:#0B2545;margin-top:8px"><b>Themes:</b> '+_amlEsc(rep.themes.join('; '))+'</div>':'')
    +((rep.actions&&rep.actions.length)?'<div style="font-size:12px;color:#0B2545;margin-top:4px"><b>Actions:</b> '+_amlEsc(rep.actions.join('; '))+'</div>':'')
    +'<div style="font-size:11px;color:#94A3B8;margin-top:8px">Draft for your review — submit to FIMM manually by the deadline.</div></div>';
}

async function _caRenderAds(){
  const body=document.getElementById('ca-body'); body.innerHTML='Loading…';
  try{
    const rows=await apiGet('/api/advertising'); if(rows&&rows.error) throw new Error(rows.error);
    var form='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;padding:16px 18px;margin-bottom:14px">'
      +'<div style="font-weight:700;color:#0B2545;margin-bottom:8px">Review marketing material <span style="font-weight:500;color:#94A3B8;font-size:12px">— AI checks it vs the SC Guidelines on Advertising</span></div>'
      +'<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:8px">'
      +'<input id="ad-title" placeholder="Title / campaign" style="flex:1;min-width:160px;padding:8px;border:1px solid #CBD5E1;border-radius:7px;font-size:13px">'
      +'<select id="ad-type" style="padding:8px;border:1px solid #CBD5E1;border-radius:7px;font-size:13px"><option value="social">Social post</option><option value="brochure">Brochure</option><option value="email">Email</option><option value="website">Website</option><option value="presentation">Presentation</option><option value="other">Other</option></select>'
      +'<input id="ad-channel" placeholder="Channel (e.g. Facebook)" style="flex:1;min-width:140px;padding:8px;border:1px solid #CBD5E1;border-radius:7px;font-size:13px">'
      +'</div>'
      +'<textarea id="ad-content" placeholder="Paste the marketing copy / caption / script…" style="width:100%;box-sizing:border-box;min-height:90px;padding:8px;border:1px solid #CBD5E1;border-radius:7px;font-size:13px"></textarea>'
      +'<div style="margin-top:8px"><button onclick="caReviewAd()" style="background:#0B2545;color:#fff;border:0;padding:8px 14px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer">🤖 AI compliance review</button></div>'
      +'<div id="ad-aiout" style="margin-top:10px"></div></div>';
    var table='';
    if(!rows.length){ table='<div style="color:#64748B;background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:16px">No material reviewed yet.</div>'; }
    else { table='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden"><table style="width:100%;border-collapse:collapse;font-size:13px"><thead style="background:#F8FAFC"><tr>'
      +'<th style="text-align:left;padding:9px 12px;color:#475569">Material</th><th style="text-align:left;padding:9px 12px;color:#475569">AI verdict</th><th style="text-align:left;padding:9px 12px;color:#475569">Status</th><th style="padding:9px 12px"></th></tr></thead><tbody>'
      +rows.map(function(r){
        var act='';
        if(r.status==='pending'){
          act='<button onclick="caAdDecide('+r.id+',\'approved\')" style="background:#DCFCE7;color:#15803D;border:0;padding:5px 8px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">Approve</button>'
             +'<button onclick="caAdDecide('+r.id+',\'changes_requested\')" style="background:#FEF3C7;color:#B45309;border:0;padding:5px 8px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">Changes</button>'
             +'<button onclick="caAdDecide('+r.id+',\'rejected\')" style="background:#FEE2E2;color:#B91C1C;border:0;padding:5px 8px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">Reject</button>';
        }
        act+='<button onclick="caAdView('+r.id+')" style="background:#fff;border:1px solid #CBD5E1;color:#0B2545;padding:5px 8px;border-radius:6px;font-size:11px;cursor:pointer;margin:1px">findings</button>';
        return '<tr style="border-top:1px solid #F1F5F9;vertical-align:top">'
          +'<td style="padding:10px 12px;max-width:280px"><b style="color:#0B2545">'+_amlEsc(r.title||'(untitled)')+'</b><div style="font-size:11px;color:#94A3B8">'+_amlEsc(r.material_type||'')+(r.channel?' · '+_amlEsc(r.channel):'')+'</div></td>'
          +'<td style="padding:10px 12px">'+_caVerdictPill(r.ai_verdict)+' '+_caRiskPill(r.ai_risk)+'</td>'
          +'<td style="padding:10px 12px">'+_caVerdictPill(r.status)+(r.decided_note?'<div style="font-size:10px;color:#94A3B8;max-width:150px">'+_amlEsc(r.decided_note)+'</div>':'')+'</td>'
          +'<td style="padding:10px 12px;text-align:right;white-space:nowrap">'+act+'</td></tr>';
      }).join('')+'</tbody></table></div>'; }
    body.innerHTML=form+table;
    window._caAdRows=rows;
  }catch(e){ body.innerHTML='<div style="color:#B91C1C">'+_amlEsc(e.message)+'</div>'; }
}
async function caReviewAd(){
  var content=(document.getElementById('ad-content')||{}).value||"";
  if(!content.trim()){ alert("Paste the marketing copy first."); return; }
  var title=(document.getElementById('ad-title')||{}).value||"";
  var type=(document.getElementById('ad-type')||{}).value||"other";
  var channel=(document.getElementById('ad-channel')||{}).value||"";
  var out=document.getElementById('ad-aiout'); out.innerHTML='🤖 AI reviewing against SC Advertising Guidelines…';
  var r;
  try{ r=await apiPost('/api/advertising/review',{title:title, material_type:type, channel:channel, content:content}); }
  catch(e){ out.innerHTML='<span style="color:#B91C1C">'+e.message+'</span>'; return; }
  if(!r||r.error){ out.innerHTML='<span style="color:#B91C1C">'+((r&&r.error)||'review failed')+'</span>'; return; }
  out.innerHTML=_caRenderAdFindings(r.review);
  _caLoadSummary(); setTimeout(_caRenderAds, 2500);
}
function _caRenderAdFindings(rev){
  if(!rev) return '';
  var col=rev.verdict==='rejected'?'#B91C1C':(rev.verdict==='approved'?'#15803D':'#B45309');
  var bg=rev.verdict==='rejected'?'#FEF2F2':(rev.verdict==='approved'?'#F0FDF4':'#FFFBEB');
  var h='<div style="background:'+bg+';border:1px solid #E2E8F0;border-radius:10px;padding:14px 16px">'
    +'<b style="color:'+col+';font-size:14px">'+_caVerdictPill(rev.verdict)+' '+_caRiskPill(rev.risk)+'</b>';
  if(rev.findings&&rev.findings.length){ h+='<div style="margin-top:10px"><b style="color:#0B2545;font-size:12px">Findings</b>'
    +rev.findings.map(function(f){ var sc=f.severity==='high'?'#B91C1C':(f.severity==='medium'?'#B45309':'#64748B');
      return '<div style="margin-top:6px;font-size:12px"><span style="color:'+sc+';font-weight:700">●</span> <b style="color:#0B2545">'+_amlEsc(f.issue)+'</b><div style="color:#64748B;margin-left:14px">'+_amlEsc(f.rule)+'</div><div style="color:#15803D;margin-left:14px">→ '+_amlEsc(f.fix)+'</div></div>'; }).join('')+'</div>'; }
  if(rev.suggested_rewrite){ h+='<div style="margin-top:10px;font-size:12px"><b style="color:#0B2545">Compliant rewrite</b><div style="color:#475569;white-space:pre-wrap;background:#fff;border:1px solid #E2E8F0;border-radius:6px;padding:8px;margin-top:4px">'+_amlEsc(rev.suggested_rewrite)+'</div></div>'; }
  h+='</div>'; return h;
}
function caAdView(id){
  var r=(window._caAdRows||[]).find(function(x){return x.id===id;}); if(!r) return;
  var rev=null; try{ rev=JSON.parse(r.ai_findings_json||"null"); }catch(e){}
  var out=document.getElementById('ad-aiout'); if(out){ out.innerHTML=_caRenderAdFindings(rev||{verdict:r.ai_verdict, risk:r.ai_risk}); out.scrollIntoView({behavior:'smooth',block:'nearest'}); }
}
async function caAdDecide(id, status){
  var note=prompt("Decision note (optional):","")||"";
  var r=await apiPost('/api/advertising/'+id+'/decide',{status:status, note:note});
  if(r&&r.error){ alert(r.error); return; }
  _caLoadSummary(); _caRenderAds();
}

// ===== Compliance Hub (AI RAG dashboard + remediation tracker) =====
function _ragColor(r){ r=String(r||"").toLowerCase(); return r==="red"?"#B91C1C":(r==="amber"?"#B45309":"#15803D"); }
function _ragBg(r){ r=String(r||"").toLowerCase(); return r==="red"?"#FEF2F2":(r==="amber"?"#FFFBEB":"#F0FDF4"); }
async function renderComplianceHub(){
  const main=document.getElementById("main-content");
  main.innerHTML=`<div style="padding:24px">
    <div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:10px">
      <div><h2 style="margin:0 0 4px 0;color:#0B2545">Compliance Hub</h2>
      <div style="color:#64748B;font-size:13px;max-width:680px">One live view of the firm's compliance health across filings, CPE, KYC, AML, complaints and advertising. An AI sweep runs daily and proposes remediation; you can also run it now.</div></div>
      <button onclick="hubRunMonitor()" id="hub-run-btn" style="background:#0B2545;color:#fff;border:0;padding:9px 16px;border-radius:8px;font-size:13px;font-weight:700;cursor:pointer;white-space:nowrap">🤖 Run AI monitor now</button>
    </div>
    <div id="hub-rag" style="margin:16px 0"></div>
    <div id="hub-metrics"></div>
    <h3 style="color:#0B2545;margin:22px 0 8px">Early-warning radar</h3>
    <div id="hub-radar" style="color:#64748B">Loading…</div>
    <h3 style="color:#0B2545;margin:22px 0 8px">Remediation tracker</h3>
    <div id="hub-remediation" style="color:#64748B">Loading…</div>
  </div>`;
  _hubLoadDashboard(); _hubLoadRadar(); _hubLoadRemediation();
}
async function _hubLoadRadar(){
  const el=document.getElementById('hub-radar'); if(!el) return;
  try{
    const d=await apiGet('/api/radar'); if(d&&d.error) throw new Error(d.error);
    var fb=d.feedback||[], rev=d.kyc_reviews_overdue||[];
    var items='';
    fb.forEach(function(f){
      var col=f.sentiment==='negative'?'#B91C1C':'#475569';
      items+='<div style="display:flex;align-items:flex-start;gap:10px;padding:9px 0;border-top:1px solid #F1F5F9">'
        +'<span style="color:'+col+';font-weight:700;font-size:11px;white-space:nowrap;margin-top:1px">'+(f.is_complaint?'COMPLAINT':(f.sentiment||'').toUpperCase())+'</span>'
        +'<div style="flex:1"><b style="color:#0B2545;font-size:13px">'+_amlEsc(f.client_name||'(anonymous)')+'</b>'+(f.contact?' <span style="font-size:11px;color:#94A3B8">'+_amlEsc(f.contact)+'</span>':'')
        +'<div style="font-size:12px;color:#475569">'+_amlEsc(f.summary||f.message||'')+'</div></div>'
        +'<div style="white-space:nowrap"><button onclick="radarFeedback('+f.id+',\'escalated\')" style="background:#FEE2E2;color:#B91C1C;border:0;padding:4px 8px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">Escalate</button>'
        +'<button onclick="radarFeedback('+f.id+',\'reviewed\')" style="background:#fff;border:1px solid #CBD5E1;color:#475569;padding:4px 8px;border-radius:6px;font-size:11px;cursor:pointer;margin:1px">Reviewed</button></div></div>';
    });
    rev.slice(0,8).forEach(function(r){
      var days=r.verified_at?Math.floor((Date.now()/1000-r.verified_at)/86400-365):0;
      items+='<div style="display:flex;align-items:center;gap:10px;padding:9px 0;border-top:1px solid #F1F5F9">'
        +'<span style="color:#B45309;font-weight:700;font-size:11px;white-space:nowrap">REVIEW DUE</span>'
        +'<div style="flex:1;font-size:13px;color:#0B2545">'+_amlEsc(r.client_name||r.id)+' <span style="font-size:11px;color:#94A3B8">KYC review overdue '+(days>0?days+'d':'')+'</span></div></div>';
    });
    (d.churning||[]).forEach(function(ch){
      items+='<div style="display:flex;align-items:center;gap:10px;padding:9px 0;border-top:1px solid #F1F5F9">'
        +'<span style="color:#B91C1C;font-weight:700;font-size:11px;white-space:nowrap">CHURNING?</span>'
        +'<div style="flex:1;font-size:13px;color:#0B2545">'+_amlEsc(ch.client_name||ch.account)+' <span style="font-size:11px;color:#94A3B8">'+_amlEsc(ch.account)+'</span>'
        +'<div style="font-size:11px;color:#B45309">sold on '+_amlEsc(ch.sell_date||'')+' then re-bought on '+_amlEsc(ch.buy_date||'')+' with a '+(ch.buy_charge||0)+'% sales charge'+(ch.fund?' ('+_amlEsc(ch.fund)+')':'')+' — within 3 months. Review.</div></div></div>';
    });
    (d.frequent_bonds||[]).forEach(function(fb2){
      items+='<div style="display:flex;align-items:center;gap:10px;padding:9px 0;border-top:1px solid #F1F5F9">'
        +'<span style="color:#B45309;font-weight:700;font-size:11px;white-space:nowrap">FREQUENT BONDS</span>'
        +'<div style="flex:1;font-size:13px;color:#0B2545">'+_amlEsc(fb2.client_name||fb2.account)+' <span style="font-size:11px;color:#94A3B8">'+_amlEsc(fb2.account)+'</span><div style="font-size:11px;color:#B45309">'+fb2.count+' wholesale-bond purchases in 90d (last '+_amlEsc(fb2.last||'')+') — bonds are exempt from churning, but review if excessive</div></div></div>';
    });
    (d.advice_gaps||[]).forEach(function(g){
      items+='<div style="display:flex;align-items:center;gap:10px;padding:9px 0;border-top:1px solid #F1F5F9">'
        +'<span style="color:#B91C1C;font-weight:700;font-size:11px;white-space:nowrap">ADVICE MISSING</span>'
        +'<div style="flex:1;font-size:13px;color:#0B2545">'+_amlEsc(g.client_name||g.account)+' <span style="font-size:11px;color:#94A3B8">traded on iFAST ('+_amlEsc(g.account)+', '+g.trades+' orders, last '+_amlEsc(g.last_trade||'')+') with no Record of Advice on file</span><div style="font-size:11px;color:#B45309">get the adviser to record the advice</div></div></div>';
    });
    if(!items) items='<div style="color:#15803D;font-size:13px;padding:6px 0">No early-warning signals — nothing to action.</div>';
    el.innerHTML='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;padding:6px 16px 12px">'
      +'<div style="font-size:11px;color:#94A3B8;padding:8px 0 0">Negative client feedback + clients due a review. Share your feedback link: <b>kyc.lifa.com.my/feedback</b></div>'
      +items+'</div>';
  }catch(e){ el.innerHTML='<div style="color:#B91C1C">'+_amlEsc(e.message)+'</div>'; }
}
async function radarFeedback(id,status){ var r=await apiPost('/api/feedback/'+id+'/status',{status:status}); if(r&&r.error){alert(r.error);return;} _hubLoadRadar(); }
async function _hubLoadDashboard(){
  try{
    const d=await apiGet('/api/compliance/dashboard'); if(!d||d.error) throw new Error((d&&d.error)||'failed');
    const m=d.metrics||{}; const snap=d.snapshot||null;
    var ragEl=document.getElementById('hub-rag');
    var overall=(m.overall||'green');
    ragEl.innerHTML='<div style="background:'+_ragBg(overall)+';border:1px solid '+_ragColor(overall)+'33;border-radius:12px;padding:16px 18px">'
      +'<div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap"><span style="display:inline-block;width:14px;height:14px;border-radius:50%;background:'+_ragColor(overall)+'"></span>'
      +'<b style="font-size:17px;color:'+_ragColor(overall)+'">'+overall.toUpperCase()+'</b>'
      +'<span style="font-size:13px;color:#475569">'+(snap&&snap.narrative?_amlEsc(snap.narrative):'Run the AI monitor to generate a status note.')+'</span></div>'
      +(snap&&snap.created_at?'<div style="font-size:11px;color:#94A3B8;margin-top:6px">Last AI sweep: '+_amlEsc(snap.created_at)+' UTC'+(snap.ai_model?' · '+_amlEsc(snap.ai_model):'')+'</div>':'')
      +'</div>';
    function metric(label, val, bad, link){ var c=bad?'#B91C1C':(val>0?'#B45309':'#15803D'); if(val===0) c='#15803D';
      return '<div onclick="'+(link||'')+'" style="background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:12px 14px;min-width:130px;'+(link?'cursor:pointer':'')+'"><div style="font-size:24px;font-weight:800;color:'+c+'">'+val+'</div><div style="font-size:11px;color:#64748B;font-weight:600">'+label+'</div></div>'; }
    var f=m.filings||{}, aml=m.aml||{}, cmp=m.complaints||{}, ad=m.advertising||{}, cpe=m.cpe||{}, kyc=m.kyc||{}, rem=m.remediation||{}, suit=m.suitability||{};
    var cards=metric('Filings overdue', f.overdue||0, (f.overdue>0), "showView('regreports')")
      +metric('Filings due ≤30d', f.due_soon||0, false, "showView('regreports')")
      +metric('CPE shortfall reps', cpe.shortfall_reps||0, false, "showView('compliance')")
      +metric('KYC reviews overdue', kyc.reviews_overdue||0, false)
      +metric('AML pending', aml.pending_review||0, false, "showView('aml')")
      +metric('AML escalated', aml.escalated||0, (aml.escalated>0), "showView('aml')")
      +metric('Sanctions list-check due', aml.flagged_unlisted||0, (aml.flagged_unlisted>0), "showView('aml')")
      +metric('Suitability flags', suit.open_flags||0, false, "showView('policies')")
      +metric('Complaints overdue', cmp.overdue||0, (cmp.overdue>0), "showView('compads')")
      +metric('Ads pending', ad.pending||0, false, "showView('compads')")
      +metric('Remediation open', rem.open||0, (rem.high_critical>0));
    var up='';
    if(f.upcoming&&f.upcoming.length){ up='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:12px 14px;margin-top:12px"><b style="color:#0B2545;font-size:13px">Upcoming filings (≤45 days)</b><div style="margin-top:6px">'
      +f.upcoming.map(function(u){ var c=u.days<0?'#B91C1C':(u.days<=14?'#B45309':'#475569'); return '<div style="font-size:12px;color:#475569;padding:2px 0"><b style="color:'+c+'">'+(u.days<0?'OVERDUE':u.days+'d')+'</b> · '+_amlEsc(u.name)+'</div>'; }).join('')+'</div></div>'; }
    document.getElementById('hub-metrics').innerHTML='<div style="display:flex;gap:10px;flex-wrap:wrap">'+cards+'</div>'+up;
  }catch(e){ document.getElementById('hub-rag').innerHTML='<div style="color:#B91C1C">'+_amlEsc(e.message)+'</div>'; }
}
async function hubRunMonitor(){
  var btn=document.getElementById('hub-run-btn'); if(btn){ btn.disabled=true; btn.textContent='🤖 Running…'; }
  try{ var r=await apiPost('/api/compliance/monitor/run',{}); if(r&&r.error) alert(r.error); }
  catch(e){ alert(e.message); }
  if(btn){ btn.disabled=false; btn.textContent='🤖 Run AI monitor now'; }
  _hubLoadDashboard(); _hubLoadRemediation();
}
async function _hubLoadRemediation(){
  const el=document.getElementById('hub-remediation'); el.innerHTML='Loading…';
  try{
    const rows=await apiGet('/api/remediation'); if(rows&&rows.error) throw new Error(rows.error);
    var form='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:12px 14px;margin-bottom:12px;display:flex;gap:8px;flex-wrap:wrap;align-items:center">'
      +'<input id="rem-title" placeholder="New remediation item…" style="flex:2;min-width:200px;padding:7px;border:1px solid #CBD5E1;border-radius:7px;font-size:13px">'
      +'<select id="rem-priority" style="padding:7px;border:1px solid #CBD5E1;border-radius:7px;font-size:13px"><option value="critical">Critical</option><option value="high">High</option><option value="medium" selected>Medium</option><option value="low">Low</option></select>'
      +'<input id="rem-owner" placeholder="Owner" style="flex:1;min-width:110px;padding:7px;border:1px solid #CBD5E1;border-radius:7px;font-size:13px">'
      +'<button onclick="hubAddRem()" style="background:#0B2545;color:#fff;border:0;padding:7px 14px;border-radius:7px;font-size:12px;font-weight:700;cursor:pointer">+ Add</button></div>';
    if(!rows.length){ el.innerHTML=form+'<div style="color:#64748B;background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:16px">No remediation items. The AI monitor adds items automatically when it finds gaps.</div>'; return; }
    el.innerHTML=form+'<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden"><table style="width:100%;border-collapse:collapse;font-size:13px"><thead style="background:#F8FAFC"><tr>'
      +'<th style="text-align:left;padding:9px 12px;color:#475569">Item</th><th style="text-align:left;padding:9px 12px;color:#475569">Priority</th><th style="text-align:left;padding:9px 12px;color:#475569">Owner</th><th style="text-align:left;padding:9px 12px;color:#475569">Status</th><th style="padding:9px 12px"></th></tr></thead><tbody>'
      +rows.map(function(r){
        var pc={critical:["CRITICAL","#fff","#B91C1C"],high:["HIGH","#B91C1C","#FEE2E2"],medium:["MEDIUM","#B45309","#FEF3C7"],low:["LOW","#15803D","#DCFCE7"]}[r.priority]||[r.priority,"#475569","#F1F5F9"];
        var sc={open:["OPEN","#B45309","#FEF3C7"],in_progress:["IN PROGRESS","#B45309","#FEF3C7"],done:["DONE","#15803D","#DCFCE7"],dismissed:["DISMISSED","#475569","#F1F5F9"]}[r.status]||[r.status,"#475569","#F1F5F9"];
        var act='';
        if(r.status==='open'||r.status==='in_progress'){
          act='<button onclick="hubRemUpdate('+r.id+',\'in_progress\')" style="background:#FEF3C7;color:#B45309;border:0;padding:5px 8px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">In progress</button>'
             +'<button onclick="hubRemUpdate('+r.id+',\'done\')" style="background:#DCFCE7;color:#15803D;border:0;padding:5px 8px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">Done</button>';
        }
        return '<tr style="border-top:1px solid #F1F5F9;vertical-align:top">'
          +'<td style="padding:10px 12px;max-width:340px"><b style="color:#0B2545">'+_amlEsc(r.title||'')+'</b>'+(r.ai_generated?' <span style="font-size:10px;color:#9333EA">AI</span>':'')+(r.board_escalate?' <span style="font-size:10px;color:#B91C1C;font-weight:700">⬆ BOARD</span>':'')
            +(r.action?'<div style="font-size:11px;color:#64748B">'+_amlEsc(r.action)+'</div>':'')+'</td>'
          +'<td style="padding:10px 12px">'+_amlBadge(pc[0],pc[1],pc[2])+(r.area?'<div style="font-size:10px;color:#94A3B8;margin-top:3px">'+_amlEsc(r.area)+'</div>':'')+'</td>'
          +'<td style="padding:10px 12px;font-size:12px;color:#475569">'+_amlEsc(r.owner||'—')+(r.target_date?'<div style="font-size:10px;color:#94A3B8">by '+_amlEsc(r.target_date)+'</div>':'')+'</td>'
          +'<td style="padding:10px 12px">'+_amlBadge(sc[0],sc[1],sc[2])+'</td>'
          +'<td style="padding:10px 12px;text-align:right;white-space:nowrap">'+act+'</td></tr>';
      }).join('')+'</tbody></table></div>';
  }catch(e){ el.innerHTML='<div style="color:#B91C1C">'+_amlEsc(e.message)+'</div>'; }
}
async function hubAddRem(){
  var title=(document.getElementById('rem-title')||{}).value||"";
  if(!title.trim()){ alert("Enter a remediation item."); return; }
  var priority=(document.getElementById('rem-priority')||{}).value||"medium";
  var owner=(document.getElementById('rem-owner')||{}).value||"";
  var r=await apiPost('/api/remediation',{title:title, priority:priority, owner:owner});
  if(r&&r.error){ alert(r.error); return; }
  _hubLoadRemediation();
}
async function hubRemUpdate(id, status){
  var r=await apiPost('/api/remediation/'+id+'/update',{status:status});
  if(r&&r.error){ alert(r.error); return; }
  _hubLoadDashboard(); _hubLoadRemediation();
}

// ===== Policies & Suitability (AI) =====
var _polTab="policies";
var _POL_KINDS=[["aml_programme","AML/CFT Programme"],["compliance_manual","Compliance Manual"],["record_keeping","Record-Keeping Policy"],["bcp","Business Continuity Plan"]];
async function renderPolicies(){
  const main=document.getElementById("main-content");
  main.innerHTML=`<div style="padding:24px">
    <h2 style="margin:0 0 4px 0;color:#0B2545">Policies &amp; Suitability — AI</h2>
    <div style="color:#64748B;font-size:13px;margin-bottom:14px;max-width:780px">AI drafts the firm's Malaysia-specific policy documents for your approval, and second-checks each client's advice suitability against their risk profile.</div>
    <div style="display:flex;gap:8px;margin-bottom:14px;border-bottom:1px solid #E2E8F0">
      <button id="poltab-policies" onclick="polTab('policies')" style="background:none;border:0;border-bottom:2px solid transparent;padding:8px 6px;cursor:pointer;font-weight:700;color:#64748B">Policy documents</button>
      <button id="poltab-suit" onclick="polTab('suit')" style="background:none;border:0;border-bottom:2px solid transparent;padding:8px 6px;cursor:pointer;font-weight:700;color:#64748B">Suitability reviews</button>
    </div>
    <div id="pol-body" style="color:#64748B">Loading…</div></div>`;
  polTab(_polTab);
}
function polTab(t){ _polTab=t;
  ["policies","suit"].forEach(function(x){ var el=document.getElementById('poltab-'+x); if(el){ el.style.color=(x===t?'#0B2545':'#64748B'); el.style.borderBottomColor=(x===t?'#0EA5E9':'transparent'); } });
  if(t==="policies") _polRenderDocs(); else _polRenderSuit();
}
async function _polRenderDocs(){
  const body=document.getElementById('pol-body'); body.innerHTML='Loading…';
  try{
    const rows=await apiGet('/api/policies'); if(rows&&rows.error) throw new Error(rows.error);
    var gen='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;padding:16px 18px;margin-bottom:14px"><div style="font-weight:700;color:#0B2545;margin-bottom:8px">Generate a policy <span style="font-weight:500;color:#94A3B8;font-size:12px">— AI drafts a Malaysia-specific document (SC / FIMM / AMLA / PDPA)</span></div><div style="display:flex;gap:8px;flex-wrap:wrap">'
      +_POL_KINDS.map(function(k){ return '<button onclick="polGen(\''+k[0]+'\')" style="background:#0B2545;color:#fff;border:0;padding:8px 14px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer">⚙ '+k[1]+'</button>'; }).join('')
      +'</div>'
      +'<div style="margin-top:12px;padding-top:12px;border-top:1px solid #F1F5F9;font-size:12px;color:#475569">Or attach a <b>reference file</b> (PDF) — e.g. SC fee schedule, PI insurance cert, an externally-drafted policy.'
      +'<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;margin-top:8px">'
      +'<input id="pol-ref-title" placeholder="Document title" style="flex:1;min-width:200px;padding:7px 10px;border:1px solid #CBD5E1;border-radius:8px;font-size:12px">'
      +'<input id="pol-ref-file" type="file" accept="application/pdf,.pdf" style="font-size:12px">'
      +'<button onclick="polUploadRef()" style="background:#0EA5E9;color:#fff;border:0;padding:8px 14px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer">⬆ Upload PDF</button>'
      +'</div></div>'
      +'<div id="pol-genout" style="margin-top:10px"></div></div>';
    var list='';
    if(!rows.length){ list='<div style="color:#64748B;background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:16px">No policy documents yet. Generate one above — it becomes a draft for your review &amp; approval.</div>'; }
    else { list='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden"><table style="width:100%;border-collapse:collapse;font-size:13px"><thead style="background:#F8FAFC"><tr>'
      +'<th style="text-align:left;padding:9px 12px;color:#475569">Document</th><th style="text-align:left;padding:9px 12px;color:#475569">Version</th><th style="text-align:left;padding:9px 12px;color:#475569">Status</th><th style="padding:9px 12px"></th></tr></thead><tbody>'
      +rows.map(function(r){
        var sp=r.status==='approved'?_amlBadge('APPROVED','#15803D','#DCFCE7'):_amlBadge('DRAFT','#B45309','#FEF3C7');
        return '<tr style="border-top:1px solid #F1F5F9"><td style="padding:10px 12px"><b style="color:#0B2545">'+_amlEsc(r.title||'')+'</b><div style="font-size:10px;color:#94A3B8">'+_amlEsc(r.ai_model||'')+'</div></td>'
          +'<td style="padding:10px 12px;font-size:12px;color:#475569">'+_amlEsc(r.version||'')+'<div style="font-size:10px;color:#94A3B8">'+_amlEsc((r.created_at||'').slice(0,10))+'</div></td>'
          +'<td style="padding:10px 12px">'+sp+'</td>'
          +'<td style="padding:10px 12px;text-align:right;white-space:nowrap">'
          +(r.attachment_key?'<button onclick="polFile('+r.id+')" style="background:#0B2545;color:#fff;border:0;padding:5px 10px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">⬇ PDF</button>':'<button onclick="polView('+r.id+')" style="background:#fff;border:1px solid #CBD5E1;color:#0B2545;padding:5px 10px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">Open</button>')
          +(r.status!=='approved'?'<button onclick="polApprove('+r.id+')" style="background:#0B2545;color:#fff;border:0;padding:5px 10px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">Approve</button>':'')+'</td></tr>';
      }).join('')+'</tbody></table></div>'; }
    body.innerHTML=gen+list;
  }catch(e){ body.innerHTML='<div style="color:#B91C1C">'+_amlEsc(e.message)+'</div>'; }
}
async function polGen(kind){
  var out=document.getElementById('pol-genout'); out.innerHTML='🤖 Drafting… (this takes ~15-30s for a full document)';
  try{ var r=await apiPost('/api/policies/generate',{kind:kind}); if(r&&r.error){ out.innerHTML='<span style="color:#B91C1C">'+r.error+'</span>'; return; } }
  catch(e){ out.innerHTML='<span style="color:#B91C1C">'+e.message+'</span>'; return; }
  out.innerHTML='<span style="color:#15803D">✓ Drafted. Opening…</span>';
  _polRenderDocs(); if(r&&r.id) setTimeout(function(){ polView(r.id); },300);
}
async function polView(id){
  var r;
  try{ r=await apiGet('/api/policies/'+id); }catch(e){ alert(e.message); return; }
  if(!r||r.error){ alert((r&&r.error)||'not found'); return; }
  _polDocModal(r);
}
async function polFile(id){
  try{
    var resp=await fetch(API+'/api/policies/'+id+'/file',{headers:_apiHeaders()});
    if(!resp.ok){ alert('Could not open the file ('+resp.status+').'); return; }
    var b=await resp.blob(); var u=URL.createObjectURL(b);
    window.open(u,'_blank'); setTimeout(function(){URL.revokeObjectURL(u);},60000);
  }catch(e){ alert(e.message); }
}
async function polUploadRef(){
  var title=(document.getElementById('pol-ref-title').value||'').trim();
  var fi=document.getElementById('pol-ref-file'); var f=fi&&fi.files&&fi.files[0];
  var out=document.getElementById('pol-genout');
  if(!title){ out.innerHTML='<span style="color:#B91C1C">Enter a document title.</span>'; return; }
  if(!f){ out.innerHTML='<span style="color:#B91C1C">Choose a PDF file.</span>'; return; }
  if(f.size>15*1024*1024){ out.innerHTML='<span style="color:#B91C1C">PDF too large (max 15 MB).</span>'; return; }
  out.innerHTML='⬆ Uploading…';
  try{
    var dataUri=await new Promise(function(res,rej){ var rd=new FileReader(); rd.onload=function(){res(rd.result);}; rd.onerror=function(){rej(new Error('read failed'));}; rd.readAsDataURL(f); });
    var r=await apiPost('/api/policies/upload-reference',{title:title,filename:f.name,pdf_base64:dataUri});
    if(r&&r.error){ out.innerHTML='<span style="color:#B91C1C">'+r.error+'</span>'; return; }
    out.innerHTML='<span style="color:#15803D">✓ Uploaded to the Policies library.</span>';
    document.getElementById('pol-ref-title').value=''; fi.value='';
    _polRenderDocs();
  }catch(e){ out.innerHTML='<span style="color:#B91C1C">'+e.message+'</span>'; }
}
function _polDocModal(doc){
  var ov=document.getElementById('pol-modal'); if(ov) ov.remove();
  ov=document.createElement('div'); ov.id='pol-modal';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9999;display:flex;align-items:center;justify-content:center;padding:20px';
  var safe=_amlEsc(doc.content||'');
  ov.innerHTML='<div style="background:#fff;border-radius:14px;max-width:820px;width:100%;max-height:88vh;display:flex;flex-direction:column;overflow:hidden;box-shadow:0 24px 64px rgba(0,0,0,.3)">'
    +'<div style="padding:14px 20px;border-bottom:1px solid #E2E8F0;display:flex;justify-content:space-between;align-items:center"><div><b style="color:#0B2545">'+_amlEsc(doc.title||'')+'</b> <span style="font-size:11px;color:#94A3B8">v'+_amlEsc(doc.version||'')+' · '+_amlEsc(doc.status||'')+'</span></div>'
    +'<div><button onclick="polDownload('+doc.id+')" style="background:#fff;border:1px solid #CBD5E1;color:#0B2545;padding:6px 12px;border-radius:7px;font-size:12px;font-weight:700;cursor:pointer;margin-right:6px">⬇ Download .md</button>'
    +'<button onclick="document.getElementById(\'pol-modal\').remove()" style="background:#0B2545;color:#fff;border:0;padding:6px 12px;border-radius:7px;font-size:12px;font-weight:700;cursor:pointer">Close</button></div></div>'
    +'<div style="padding:20px;overflow:auto"><pre style="white-space:pre-wrap;font-family:ui-monospace,Menlo,monospace;font-size:12.5px;line-height:1.55;color:#1F2937;margin:0">'+safe+'</pre></div></div>';
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  window._polDocCache=window._polDocCache||{}; window._polDocCache[doc.id]=doc;
}
function polDownload(id){
  var doc=(window._polDocCache||{})[id]; if(!doc) return;
  var blob=new Blob([doc.content||''],{type:'text/markdown'});
  var a=document.createElement('a'); a.href=URL.createObjectURL(blob); a.download='LIFA-'+(doc.kind||'policy')+'-'+(doc.version||'')+'.md'; a.click();
}
async function polApprove(id){ if(!confirm("Approve this policy as the firm's officer?")) return;
  var r=await apiPost('/api/policies/'+id+'/approve',{}); if(r&&r.error){ alert(r.error); return; } _polRenderDocs(); }

async function _polRenderSuit(){
  const body=document.getElementById('pol-body'); body.innerHTML='Loading…';
  try{
    const rows=await apiGet('/api/suitability/reviews'); if(rows&&rows.error) throw new Error(rows.error);
    var head='<div style="margin-bottom:10px"><button onclick="polRunSuit()" style="background:#0B2545;color:#fff;border:0;padding:8px 14px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer">▶ Review a case by ID</button> <span style="font-size:11px;color:#94A3B8">Verified KYC cases are auto-reviewed; this complements the rule-based LIFA Risk Score.</span></div>';
    if(!rows.length){ body.innerHTML=head+'<div style="color:#64748B;background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:16px">No suitability reviews yet.</div>'; return; }
    body.innerHTML=head+'<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden"><table style="width:100%;border-collapse:collapse;font-size:13px"><thead style="background:#F8FAFC"><tr>'
      +'<th style="text-align:left;padding:9px 12px;color:#475569">Client</th><th style="text-align:left;padding:9px 12px;color:#475569">Verdict</th><th style="text-align:left;padding:9px 12px;color:#475569">Flags / rationale</th><th style="text-align:left;padding:9px 12px;color:#475569">Status</th><th style="padding:9px 12px"></th></tr></thead><tbody>'
      +rows.map(function(r){
        var vp=r.verdict==='aligned'?_amlBadge('ALIGNED','#15803D','#DCFCE7'):(r.verdict==='mismatch'?_amlBadge('MISMATCH','#fff','#B91C1C'):_amlBadge('REVIEW','#B45309','#FEF3C7'));
        var flags=[]; try{ flags=JSON.parse(r.flags_json||'[]'); }catch(e){}
        var act=(r.status==='open')?'<button onclick="polSuitReviewed('+r.id+')" style="background:#DCFCE7;color:#15803D;border:0;padding:5px 9px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer">Mark reviewed</button>':'<span style="font-size:11px;color:#94A3B8">'+_amlEsc(r.decided_by||'')+'</span>';
        return '<tr style="border-top:1px solid #F1F5F9;vertical-align:top"><td style="padding:10px 12px"><b style="color:#0B2545">'+_amlEsc(r.client_name||'?')+'</b><div style="font-size:10px;color:#94A3B8">'+_amlEsc(r.case_id||'')+' · band '+_amlEsc(r.risk_band||'—')+'</div></td>'
          +'<td style="padding:10px 12px">'+vp+'</td>'
          +'<td style="padding:10px 12px;max-width:360px;font-size:12px;color:#475569">'+(flags.length?'<div style="color:#B45309">• '+flags.map(_amlEsc).join('<br>• ')+'</div>':'')+'<div>'+_amlEsc(r.rationale||'')+'</div></td>'
          +'<td style="padding:10px 12px">'+_amlBadge((r.status||'').toUpperCase(),'#475569','#F1F5F9')+'</td>'
          +'<td style="padding:10px 12px;text-align:right;white-space:nowrap">'+act+'</td></tr>';
      }).join('')+'</tbody></table></div>';
  }catch(e){ body.innerHTML='<div style="color:#B91C1C">'+_amlEsc(e.message)+'</div>'; }
}
async function polRunSuit(){
  var id=prompt("KYC case ID to review:"); if(!id) return;
  var body=document.getElementById('pol-body'); body.innerHTML='🤖 Reviewing suitability for '+_amlEsc(id)+'…';
  try{ var r=await apiPost('/api/suitability/review/'+encodeURIComponent(id.trim()),{}); if(r&&r.error) alert('Failed: '+r.error); }
  catch(e){ alert(e.message); }
  _polRenderSuit();
}
async function polSuitReviewed(id){ var r=await apiPost('/api/suitability/'+id+'/reviewed',{}); if(r&&r.error){ alert(r.error); return; } _polRenderSuit(); }

// ===== Compliance registers (COI · Gifts/Inducements · Outsourcing) =====
var _regTab="coi";
var _REGCFG={
  coi:{title:"Conflicts of Interest",
    fields:[{k:"date_raised",label:"Date",type:"date"},{k:"person",label:"Person"},{k:"category",label:"Category",type:"select",opts:["personal_interest","related_party","outside_business","referral_fee","gift","other"]},{k:"nature",label:"Nature of conflict",type:"textarea",full:true},{k:"client_affected",label:"Client affected"},{k:"mitigation",label:"Mitigation / how managed",type:"textarea",full:true}],
    cols:[["date_raised","Date"],["person","Person"],["category","Category"],["nature","Nature"],["mitigation","Mitigation"]],
    statuses:["open","managed","closed"]},
  gifts:{title:"Gifts & Inducements",
    fields:[{k:"gift_date",label:"Date",type:"date"},{k:"direction",label:"Direction",type:"select",opts:["received","given"]},{k:"person",label:"Staff / Adviser"},{k:"counterparty",label:"From / To"},{k:"value_myr",label:"Value (RM)",type:"number"},{k:"category",label:"Category",type:"select",opts:["gift","entertainment","inducement","other"]},{k:"description",label:"Description",type:"textarea",full:true}],
    cols:[["gift_date","Date"],["direction","Dir"],["person","Person"],["counterparty","Counterparty"],["value_myr","RM"],["category","Type"]],
    approvals:["approved","declined","pending"]},
  outsourcing:{title:"Outsourcing",
    fields:[{k:"service",label:"Service"},{k:"provider",label:"Provider"},{k:"category",label:"Category",type:"select",opts:["platform","it_cloud","admin","audit","other"]},{k:"criticality",label:"Criticality",type:"select",opts:["material","non_material"]},{k:"data_offshore",label:"Data offshore?",type:"select",opts:["0","1"]},{k:"risk_rating",label:"Risk",type:"select",opts:["low","medium","high"]},{k:"agreement_ref",label:"Agreement ref"},{k:"review_date",label:"Next review",type:"date"},{k:"controls",label:"Controls",type:"textarea",full:true}],
    cols:[["service","Service"],["provider","Provider"],["criticality","Criticality"],["data_offshore","Offshore"],["risk_rating","Risk"]],
    statuses:["active","terminated"]},
  submissions:{title:"Regulatory Submissions",
    fields:[{k:"sub_date",label:"Date",type:"date"},{k:"regulator",label:"Regulator",type:"select",opts:["SC","FIMM","SSM","BNM","other"]},{k:"item",label:"Item submitted"},{k:"ref",label:"Reference"},{k:"period",label:"Period"},{k:"status",label:"Status",type:"select",opts:["submitted","acknowledged","approved","returned","pending"]},{k:"storage_ref",label:"Where stored (EASy/FCS/Drive/email)"},{k:"notes",label:"Notes",type:"textarea",full:true}],
    cols:[["sub_date","Date"],["regulator","Reg"],["item","Item"],["ref","Ref"],["period","Period"],["storage_ref","Stored"]],
    statuses:["submitted","acknowledged","approved","returned","pending"]}
};
function renderRegisters(){
  const main=document.getElementById("main-content");
  main.innerHTML=`<div style="padding:24px">
    <h2 style="margin:0 0 4px 0;color:#0B2545">Compliance Registers</h2>
    <div style="color:#64748B;font-size:13px;margin-bottom:14px;max-width:760px">Live registers an SC/FIMM inspection expects you to maintain: conflicts of interest, gifts &amp; inducements, outsourcing, regulatory submissions, breaches &amp; incidents, and reps' fit-and-proper declarations.</div>
    <div style="display:flex;gap:8px;margin-bottom:14px;border-bottom:1px solid #E2E8F0;flex-wrap:wrap">
      <button id="regtab-coi" onclick="regTab('coi')" style="background:none;border:0;border-bottom:2px solid transparent;padding:8px 6px;cursor:pointer;font-weight:700;color:#64748B">Conflicts of Interest</button>
      <button id="regtab-gifts" onclick="regTab('gifts')" style="background:none;border:0;border-bottom:2px solid transparent;padding:8px 6px;cursor:pointer;font-weight:700;color:#64748B">Gifts &amp; Inducements</button>
      <button id="regtab-outsourcing" onclick="regTab('outsourcing')" style="background:none;border:0;border-bottom:2px solid transparent;padding:8px 6px;cursor:pointer;font-weight:700;color:#64748B">Outsourcing</button>
      <button id="regtab-submissions" onclick="regTab('submissions')" style="background:none;border:0;border-bottom:2px solid transparent;padding:8px 6px;cursor:pointer;font-weight:700;color:#64748B">Regulatory Submissions</button>
      <button id="regtab-breaches" onclick="regTab('breaches')" style="background:none;border:0;border-bottom:2px solid transparent;padding:8px 6px;cursor:pointer;font-weight:700;color:#64748B">Breaches &amp; Incidents</button>
      <button id="regtab-fitproper" onclick="regTab('fitproper')" style="background:none;border:0;border-bottom:2px solid transparent;padding:8px 6px;cursor:pointer;font-weight:700;color:#64748B">Fit &amp; Proper</button>
    </div>
    <div id="reg-body" style="color:#64748B">Loading…</div></div>`;
  regTab(_regTab);
}
function regTab(name){ _regTab=name;
  ["coi","gifts","outsourcing","submissions","breaches","fitproper"].forEach(function(x){ var el=document.getElementById('regtab-'+x); if(el){ el.style.color=(x===name?'#0B2545':'#64748B'); el.style.borderBottomColor=(x===name?'#0891B2':'transparent'); } });
  if(name==='breaches') return _regBreaches();
  if(name==='fitproper') return _regFitProper();
  _regRender(name);
}
// ── Breach & Incident Register ──
var _breachAI=null;
async function _regBreaches(){
  var body=document.getElementById('reg-body'); body.innerHTML='Loading…';
  var rows; try{ rows=await apiGet('/api/breaches'); if(rows&&rows.error) throw new Error(rows.error); }catch(e){ body.innerHTML='<div style="color:#B91C1C">'+_amlEsc(e.message)+'</div>'; return; }
  var stI='width:100%;margin-top:3px;padding:8px 10px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px;box-sizing:border-box';
  var lab='font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;font-weight:600';
  var cats=['conduct','suitability','aml_cft','data_pdpa','operational','regulatory','financial','other'];
  var form='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;padding:16px 18px;margin-bottom:14px">'
    +'<div style="font-weight:700;color:#0B2545;margin-bottom:8px">Log a breach / incident</div>'
    +'<div style="display:grid;grid-template-columns:2fr 1fr 1fr;gap:10px 16px">'
    +'<div><div style="'+lab+'">Title</div><input id="brf-title" style="'+stI+'"></div>'
    +'<div><div style="'+lab+'">Category</div><select id="brf-cat" style="'+stI+'">'+cats.map(function(c){return '<option value="'+c+'">'+c.replace(/_/g,'/')+'</option>';}).join('')+'</select></div>'
    +'<div><div style="'+lab+'">Identified by</div><input id="brf-by" style="'+stI+'"></div>'
    +'<div><div style="'+lab+'">Date occurred</div><input id="brf-occ" type="date" style="'+stI+'"></div>'
    +'<div><div style="'+lab+'">Date identified</div><input id="brf-idd" type="date" style="'+stI+'"></div>'
    +'<div><div style="'+lab+'">Owner</div><input id="brf-owner" style="'+stI+'"></div>'
    +'<div style="grid-column:1/-1"><div style="'+lab+'">What happened</div><textarea id="brf-desc" rows="3" style="'+stI+';resize:vertical"></textarea></div>'
    +'</div>'
    +'<div style="margin:10px 0"><button onclick="regBreachAssess()" style="background:#fff;border:1px solid #CBD5E1;color:#0B2545;padding:7px 13px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer">&#10024; Assess with AI</button> <span id="brf-aimsg" style="font-size:11px;color:#94A3B8"></span></div>'
    +'<div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px 16px">'
    +'<div><div style="'+lab+'">Materiality</div><select id="brf-mat" style="'+stI+'"><option value="undetermined">Undetermined</option><option value="non_material">Non-material</option><option value="material">Material</option></select></div>'
    +'<div><div style="'+lab+'">Regulator notification?</div><select id="brf-scn" style="'+stI+'"><option value="0">Not required</option><option value="1">Required</option></select></div>'
    +'<div></div>'
    +'<div style="grid-column:1/-1"><div style="'+lab+'">Root cause</div><textarea id="brf-root" rows="2" style="'+stI+';resize:vertical"></textarea></div>'
    +'<div style="grid-column:1/-1"><div style="'+lab+'">Remediation</div><textarea id="brf-rem" rows="2" style="'+stI+';resize:vertical"></textarea></div>'
    +'</div>'
    +'<div style="margin-top:10px"><button onclick="regBreachLog()" style="background:#0B2545;color:#fff;border:0;padding:8px 16px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer">+ Log breach</button></div></div>';
  var table;
  if(!rows.length){ table='<div style="color:#64748B;background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:16px">No breaches or incidents logged.</div>'; }
  else {
    table='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden"><table style="width:100%;border-collapse:collapse;font-size:13px"><thead style="background:#F8FAFC"><tr>'
      +['Ref','Title','Category','Materiality','Notify','Status',''].map(function(h){return '<th style="text-align:left;padding:9px 12px;color:#475569">'+h+'</th>';}).join('')
      +'</tr></thead><tbody>'
      +rows.map(function(r){
        var matB={material:["MATERIAL","#B91C1C","#FEE2E2"],non_material:["NON-MATERIAL","#475569","#F1F5F9"],undetermined:["TBD","#B45309","#FEF3C7"]}[r.materiality||'undetermined'];
        var notify = r.sc_notify_required ? (r.sc_notified_at?_amlBadge('NOTIFIED '+_amlEsc((r.sc_notified_at||'').slice(0,10)),"#15803D","#DCFCE7"):_amlBadge("REQUIRED","#B91C1C","#FEE2E2")) : '<span style="font-size:11px;color:#94A3B8">—</span>';
        var stB={open:["OPEN","#B45309","#FEF3C7"],investigating:["INVESTIGATING","#B45309","#FEF3C7"],remediated:["REMEDIATED","#0369A1","#E0F2FE"],closed:["CLOSED","#15803D","#DCFCE7"]}[r.status||'open'];
        var open=r.status!=='closed', act='';
        if(open){
          act='<select onchange="regBreachStatus('+r.id+',this.value)" style="font-size:11px;padding:3px 6px;border:1px solid #CBD5E1;border-radius:6px"><option value="">status…</option><option value="investigating">Investigating</option><option value="remediated">Remediated</option><option value="closed">Close</option></select>';
          if(r.sc_notify_required && !r.sc_notified_at) act+=' <button onclick="regBreachNotified('+r.id+')" style="background:#DCFCE7;color:#15803D;border:0;padding:4px 8px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer">Mark notified</button>';
        }
        return '<tr style="border-top:1px solid #F1F5F9;vertical-align:top">'
          +'<td style="padding:9px 12px;color:#64748B;white-space:nowrap">'+_amlEsc(r.ref||'')+'</td>'
          +'<td style="padding:9px 12px;max-width:240px"><b style="color:#0B2545">'+_amlEsc(r.title||'')+'</b><div style="font-size:11px;color:#64748B">'+_amlEsc(String(r.description||'').slice(0,90))+'</div></td>'
          +'<td style="padding:9px 12px;color:#334155">'+_amlEsc(String(r.category||'').replace(/_/g,'/'))+'</td>'
          +'<td style="padding:9px 12px">'+_amlBadge(matB[0],matB[1],matB[2])+'</td>'
          +'<td style="padding:9px 12px">'+notify+'</td>'
          +'<td style="padding:9px 12px">'+_amlBadge(stB[0],stB[1],stB[2])+'</td>'
          +'<td style="padding:9px 12px;white-space:nowrap">'+act+'</td></tr>';
      }).join('')+'</tbody></table></div>';
  }
  body.innerHTML=form+table;
}
async function regBreachAssess(){
  var desc=(document.getElementById('brf-desc')||{}).value||'', cat=(document.getElementById('brf-cat')||{}).value||'';
  if(!desc.trim()){ alert('Describe what happened first.'); return; }
  var msg=document.getElementById('brf-aimsg'); msg.textContent='Assessing…';
  try{ var ai=await apiPost('/api/breaches/classify',{description:desc,category:cat}); if(ai&&ai.error){ msg.textContent=ai.error; return; }
    _breachAI=ai;
    if(ai.materiality) document.getElementById('brf-mat').value=(['material','non_material','undetermined'].indexOf(ai.materiality)>=0?ai.materiality:'undetermined');
    document.getElementById('brf-scn').value=ai.sc_notify_required?'1':'0';
    if(ai.root_cause) document.getElementById('brf-root').value=ai.root_cause;
    if(ai.remediation_steps&&ai.remediation_steps.length) document.getElementById('brf-rem').value=ai.remediation_steps.map(function(s,i){return (i+1)+'. '+s;}).join('\n');
    msg.textContent='AI: '+(ai.materiality||'')+(ai.sc_notify_required?' · regulator notification likely':'')+(ai.notify_reason?' — '+ai.notify_reason:'');
  }catch(e){ msg.textContent=e.message; }
}
async function regBreachLog(){
  var g=function(id){return (document.getElementById(id)||{}).value||'';};
  if(!g('brf-title').trim()){ alert('Add a title.'); return; }
  if(!g('brf-desc').trim()){ alert('Describe what happened.'); return; }
  var payload={title:g('brf-title'),category:g('brf-cat'),description:g('brf-desc'),identified_by:g('brf-by'),date_occurred:g('brf-occ')||null,date_identified:g('brf-idd')||null,owner:g('brf-owner'),materiality:g('brf-mat'),sc_notify_required:g('brf-scn')==='1',root_cause:g('brf-root'),remediation:g('brf-rem'),ai_json:_breachAI||null,ai_model:(_breachAI&&_breachAI._model)||''};
  try{ var r=await apiPost('/api/breaches',payload); if(r&&r.error){ alert(r.error); return; } _breachAI=null; _regBreaches(); }
  catch(e){ alert(e.message); }
}
async function regBreachStatus(id,status){ if(!status) return; try{ var r=await apiPost('/api/breaches/'+id+'/update',{status:status}); if(r&&r.error){alert(r.error);return;} _regBreaches(); }catch(e){ alert(e.message); } }
async function regBreachNotified(id){ if(!confirm('Record that the regulator was notified today?')) return; try{ var r=await apiPost('/api/breaches/'+id+'/update',{sc_notified:true}); if(r&&r.error){alert(r.error);return;} _regBreaches(); }catch(e){ alert(e.message); } }
// ── Fit & Proper (admin status of reps' annual declarations) ──
async function _regFitProper(){
  var body=document.getElementById('reg-body'); body.innerHTML='Loading…';
  var d; try{ d=await apiGet('/api/fit-proper'); if(d&&d.error) throw new Error(d.error); }catch(e){ body.innerHTML='<div style="color:#B91C1C">'+_amlEsc(e.message)+'</div>'; return; }
  var reps=d.reps||[], done=reps.filter(function(r){return r.declaration;}).length;
  var head='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;padding:14px 18px;margin-bottom:14px"><b style="color:#0B2545">Annual fit-and-proper declarations — '+d.year+'</b><div style="font-size:12px;color:#64748B;margin-top:4px">'+done+' of '+reps.length+' representatives have declared. Each rep completes this in their own portal login. Required to confirm the 18 Apr ARAA licence renewal.</div></div>';
  var table='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden"><table style="width:100%;border-collapse:collapse;font-size:13px"><thead style="background:#F8FAFC"><tr>'
    +['Representative','Status','Disclosures','Signed'].map(function(h){return '<th style="text-align:left;padding:9px 12px;color:#475569">'+h+'</th>';}).join('')
    +'</tr></thead><tbody>'
    +reps.map(function(r){
      var dec=r.declaration, any = dec && (dec.q_bankruptcy||dec.q_criminal||dec.q_disciplinary||dec.q_civil||dec.q_investigation);
      var status = dec ? _amlBadge('DECLARED','#15803D','#DCFCE7') : _amlBadge('OUTSTANDING','#B45309','#FEF3C7');
      var discl = dec ? (any? '<span style="color:#B45309;font-weight:700">&#9888; '+_amlEsc(dec.disclosures||'see declaration')+'</span>' : '<span style="color:#15803D">None — clean</span>') : '—';
      return '<tr style="border-top:1px solid #F1F5F9"><td style="padding:9px 12px;color:#0B2545;font-weight:600">'+_amlEsc(r.name||r.adviser_id)+'</td><td style="padding:9px 12px">'+status+'</td><td style="padding:9px 12px;max-width:300px;color:#334155">'+discl+'</td><td style="padding:9px 12px;color:#64748B">'+(dec?_amlEsc(dec.signed_name||'')+' · '+_amlEsc((dec.signed_at||'').slice(0,10)):'—')+'</td></tr>';
    }).join('')+'</tbody></table></div>';
  body.innerHTML=head+table;
}
function _regFieldInput(name, f){
  var id='reg-'+name+'-'+f.k;
  var st='width:100%;margin-top:3px;padding:8px 10px;border:1.5px solid #E2E8F0;border-radius:7px;font-size:13px;box-sizing:border-box';
  var inner;
  if(f.type==='textarea') inner='<textarea id="'+id+'" rows="2" style="'+st+';resize:vertical"></textarea>';
  else if(f.type==='select') inner='<select id="'+id+'" style="'+st+'">'+f.opts.map(function(o){return '<option value="'+o+'">'+(o==='0'?'No':o==='1'?'Yes':_amlEsc(o.replace(/_/g,' ')))+'</option>';}).join('')+'</select>';
  else inner='<input id="'+id+'" type="'+(f.type||'text')+'" style="'+st+'">';
  return '<div'+(f.full?' style="grid-column:1/-1"':'')+'><div style="font-size:10px;color:#9CA3AF;text-transform:uppercase;letter-spacing:.04em;font-weight:600">'+f.label+'</div>'+inner+'</div>';
}
async function _regRender(name){
  const cfg=_REGCFG[name], body=document.getElementById('reg-body'); body.innerHTML='Loading…';
  try{
    const rows=await apiGet('/api/registers/'+name); if(rows&&rows.error) throw new Error(rows.error);
    var form='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;padding:16px 18px;margin-bottom:14px">'
      +'<div style="font-weight:700;color:#0B2545;margin-bottom:8px">Add to '+cfg.title+'</div>'
      +'<div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px 16px">'+cfg.fields.map(function(f){return _regFieldInput(name,f);}).join('')+'</div>'
      +'<div style="margin-top:10px"><button onclick="regAdd(\''+name+'\')" style="background:#0B2545;color:#fff;border:0;padding:8px 16px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer">+ Add entry</button></div></div>';
    var table;
    if(!rows.length){ table='<div style="color:#64748B;background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:16px">No entries yet.</div>'; }
    else {
      table='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden"><table style="width:100%;border-collapse:collapse;font-size:13px"><thead style="background:#F8FAFC"><tr>'
        +cfg.cols.map(function(c){return '<th style="text-align:left;padding:9px 12px;color:#475569">'+c[1]+'</th>';}).join('')
        +'<th style="text-align:left;padding:9px 12px;color:#475569">Status</th><th style="padding:9px 12px"></th></tr></thead><tbody>'
        +rows.map(function(r){
          var tds=cfg.cols.map(function(c){
            var v=r[c[0]];
            if(c[0]==='data_offshore') v=(v?'⚠ Yes':'No');
            if(c[0]==='value_myr'&&v!=null) v=Number(v).toLocaleString('en-MY',{minimumFractionDigits:2});
            return '<td style="padding:9px 12px;max-width:240px;color:#334155">'+_amlEsc(String(v==null?'—':v).replace(/_/g,' ')).slice(0,260)+'</td>';
          }).join('');
          var statusCell, act='';
          if(name==='gifts'){
            var ap={approved:["APPROVED","#15803D","#DCFCE7"],declined:["DECLINED","#B91C1C","#FEE2E2"],pending:["PENDING","#B45309","#FEF3C7"]}[r.approval||'pending'];
            statusCell=_amlBadge(ap[0],ap[1],ap[2])+(r.approver?'<div style="font-size:10px;color:#94A3B8">'+_amlEsc(r.approver)+'</div>':'');
            if((r.approval||'pending')==='pending') act='<button onclick="regGiftDecide('+r.id+',\'approved\')" style="background:#DCFCE7;color:#15803D;border:0;padding:4px 8px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">Approve</button><button onclick="regGiftDecide('+r.id+',\'declined\')" style="background:#FEE2E2;color:#B91C1C;border:0;padding:4px 8px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;margin:1px">Decline</button>';
          } else {
            var sv=r.status||cfg.statuses[0];
            var sc=(['managed','approved','acknowledged'].indexOf(sv)>=0)?["#15803D","#DCFCE7"]
                  :(sv==='returned')?["#B91C1C","#FEE2E2"]
                  :(['closed','terminated'].indexOf(sv)>=0)?["#475569","#F1F5F9"]
                  :["#B45309","#FEF3C7"];
            statusCell=_amlBadge(sv.toUpperCase(),sc[0],sc[1]);
            var next=cfg.statuses.filter(function(s){return s!==sv;});
            act=next.map(function(s){return '<button onclick="regSetStatus(\''+name+'\','+r.id+',\''+s+'\')" style="background:#fff;border:1px solid #CBD5E1;color:#475569;padding:4px 8px;border-radius:6px;font-size:11px;cursor:pointer;margin:1px">'+s+'</button>';}).join('');
          }
          act+='<button onclick="regDelete(\''+name+'\','+r.id+')" style="background:#fff;border:1px solid #FECACA;color:#B91C1C;padding:4px 7px;border-radius:6px;font-size:11px;cursor:pointer;margin:1px" title="Delete">✕</button>';
          return '<tr style="border-top:1px solid #F1F5F9;vertical-align:top">'+tds+'<td style="padding:9px 12px">'+statusCell+'</td><td style="padding:9px 12px;text-align:right;white-space:nowrap">'+act+'</td></tr>';
        }).join('')+'</tbody></table></div>';
    }
    body.innerHTML=form+table;
  }catch(e){ body.innerHTML='<div style="color:#B91C1C">'+_amlEsc(e.message)+'</div>'; }
}
async function regAdd(name){
  const cfg=_REGCFG[name]; var b={};
  cfg.fields.forEach(function(f){ var el=document.getElementById('reg-'+name+'-'+f.k); if(el && el.value!=='') b[f.k]=el.value; });
  if(!Object.keys(b).length){ alert('Enter at least one field.'); return; }
  var r=await apiPost('/api/registers/'+name, b);
  if(r&&r.error){ alert(r.error); return; }
  _regRender(name);
}
async function regSetStatus(name,id,status){ var r=await apiPost('/api/registers/'+name+'/'+id+'/update',{status:status}); if(r&&r.error){alert(r.error);return;} _regRender(name); }
async function regGiftDecide(id,approval){ var approver=prompt("Approver name:","")||""; var r=await apiPost('/api/registers/gifts/'+id+'/update',{approval:approval, approver:approver}); if(r&&r.error){alert(r.error);return;} _regRender('gifts'); }
async function regDelete(name,id){ if(!confirm('Delete this entry?')) return; var r=await apiDelete('/api/registers/'+name+'/'+id); if(r&&r.error){alert(r.error);return;} _regRender(name); }

// ===== Adviser Best Practice guide =====
function _protectionGuideHTML(){
  function box(title, color, items){
    return '<div style="break-inside:avoid;border:1px solid #E2E8F0;border-left:4px solid '+color+';border-radius:8px;padding:11px 14px;background:#fff">'
      +'<div style="font-weight:800;color:#0B2545;font-size:13px;margin-bottom:5px">'+title+'</div>'
      +'<ul style="margin:0;padding-left:18px;font-size:12.5px;line-height:1.6;color:#334155;list-style:none">'
      +items.map(function(i){return '<li style="position:relative;padding-left:14px;margin-bottom:3px"><span style="position:absolute;left:0;color:'+color+'">•</span>'+i+'</li>';}).join('')
      +'</ul></div>';
  }
  return '<div style="max-width:820px;margin:0 auto;color:#0B2545;font-family:inherit">'
    +'<div style="border-bottom:2px solid #0B2545;padding-bottom:8px;margin-bottom:12px">'
    +'<div style="font-size:19px;font-weight:800">Adviser Best Practice — Know Your Obligations</div>'
    +'<div style="font-size:12px;color:#64748B">LIFA Planners Sdn Bhd · SC &amp; FIMM framework · keep this in front of you</div></div>'
    +'<div style="background:#0B2545;color:#fff;border-radius:8px;padding:10px 14px;font-size:12.5px;margin-bottom:12px">Your licence is your personal responsibility. A complaint or enforcement action follows <b>you</b>, not the firm. Good practice is not paperwork — it is your protection.</div>'
    +'<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px">'
    +box('1. KNOW YOUR CLIENT (KYC)','#2563EB',[
        'Collect and verify IC/passport, occupation, income, net worth, investment experience — <b>before</b> any advice.',
        'Assess risk tolerance and investment horizon explicitly. Document the classification and your rationale.',
        '<b>Update KYC at least annually</b> or whenever the client\'s circumstances change materially.',
        'Corporate clients: identify the ultimate beneficial owner (UBO). Screen all clients against AML/PEP lists.',
        'No KYC = no advice. Advising an unverified client is a breach of SC licence conditions.'])
    +box('2. SUITABILITY — match, never push','#16A34A',[
        'Every recommendation must match the client\'s documented risk profile, objective, and horizon.',
        'Write a brief record of advice for every recommendation — <b>why this product suits this client</b>.',
        'If the client insists on an unsuitable product, document the client\'s override and your warning in writing. Decline if the risk is severe.',
        'Higher commission never justifies a mis-matched recommendation.',
        'Annual review: re-assess suitability if market conditions or client profile have changed.'])
    +box('3. DISCLOSE EVERYTHING','#9333EA',[
        'Before the client commits: disclose all fees, charges, sales charges, management fees, platform fees, and trail commissions — in writing.',
        'Disclose any conflict of interest (higher commission on a product you are recommending, related-party funds).',
        'Unit trusts: inform the client of the <b>6-business-day cooling-off right</b>. Get a signed acknowledgement.',
        '<b>Wrap-fee clients</b>: disclose the annual advisory fee as a % of portfolio value (e.g. 1% p.a. on RM100,000 = RM1,000/yr). No sales charge per transaction. Show the RM amount at the client\'s portfolio size so they understand the actual cost. <b>Sales-charge clients</b>: disclose the % charged per subscription (e.g. 3% on each top-up). These are two different disclosures — use the one that matches the client\'s account type.',
        'Disclosure must be client-specific — not just a generic prospectus handout.'])
    +box('4. YOUR CLIENT RECORDS — kept in LIFA system','#0891B2',[
        'All KYC, risk profiling, disclosures, and advice records are stored in <b>LIFA\'s system</b>. Records are retained for at least 7 years.',
        'Your responsibility: ensure every client\'s KYC is <b>complete, accurate, and up to date</b> in the system. An incomplete record is the same as no record.',
        'Complete the KYC form fully — do not leave fields blank or use placeholders. The system record is what the regulator sees.',
        'Communication log: <b>WhatsApp, email, and meeting notes are your personal responsibility</b> to retain. Save them — a screenshot is evidence.'])
    +box('5. CONDUCT — what you must and must not do','#D97706',[
        'Act in the client\'s best interest at all times. Disclose and manage conflicts — do not hide them.',
        'Never guarantee or imply guaranteed returns. State risk clearly every time.',
        'Never switch a client\'s funds to earn commission (churning) or without a clear client instruction.',
        'All marketing must be submitted for firm approval before use. No unapproved social posts, flyers, or presentations.',
        'Refer outside your competency — do not advise on tax, legal, or estate matters without the appropriate licence.'])
    +box('6. AML/CFT — your personal obligations (AMLA 2001)','#DC2626',[
        'Perform Customer Due Diligence (CDD) on every client. Enhanced due diligence (EDD) for PEPs and high-risk clients.',
        'If a transaction looks suspicious — unusual size, origin, frequency, or inconsistent with the client\'s profile — report to the Compliance Officer within 24 hours.',
        '<b>Do not tip off the client</b> that a suspicious transaction report (STR) has been or may be filed. This is an offence under AMLA.',
        'Accepting cash from a client is prohibited. All payments must be made to <b>iFAST or Phillip Capital</b> directly from the client\'s own bank account.',
        'Complete your annual AML/CFT training. Keep the certificate in your compliance file.'])
    +box('7. HANDLE COMPLAINTS — fast, professionally','#7C3AED',[
        'Address client complaint within <b>1 business day</b>. Never ignore, delay, or argue.',
        'Listen and log: write down every detail of the complaint, the client\'s concern, and the outcome they want.',
        'Tell the Compliance Officer immediately for any complaint involving alleged loss, mis-selling, or fraud.',
        'Investigate using your file (KYC, advice record, disclosure, instructions).',
        'Aim to resolve in writing within 14 business days. If unresolved, inform the client of <b>SIDREC</b> (free, binding up to RM250k) and escalate to your Manager immediately.',
        '<b>All complaints lodged by clients must be reported to the regulators.</b> This is a mandatory SC requirement — not optional even if you believe the complaint is unfounded.'])
    +box('8. YOUR LICENCE — maintain it actively','#059669',[
        'Complete a minimum of <b>20 CPE hours per year</b> (SC requirement). Keep certificates — SC can ask for them.',
        'Pay CMSRL and FIMM consultant renewal (RM 500/yr via LIFA) on time. Lapse = you cannot transact.',
        'Notify LIFA immediately of any change in your fit-and-proper status — conviction, bankruptcy, investigation, or disciplinary action.',
        'Social media: any post containing investment content must include your firm name, licence type, and a risk disclaimer. No cherry-picked performance data.',
        'WhatsApp with clients is a formal communication channel — treat it as such. Retain records.'])
    +'</div>'
    +'<div style="border:1px solid #FCA5A5;border-radius:8px;padding:11px 14px;background:#FEF2F2;margin-top:10px">'
    +'<div style="font-weight:800;color:#B91C1C;font-size:13px;margin-bottom:4px">RED LINES — any one of these can cost you your licence</div>'
    +'<div style="display:grid;grid-template-columns:1fr 1fr;gap:2px 20px;font-size:12.5px;color:#7F1D1D;line-height:1.7">'
    +'<div>Guarantee or imply guaranteed returns</div><div>Advise a client before completing KYC</div>'
    +'<div>Transact without a clear client instruction</div><div>Accept cash from a client</div>'
    +'<div>Switch funds to earn more commission (churning)</div><div>Tip off a client about an STR filing</div>'
    +'<div>Use unapproved marketing material</div><div>Ignore or delay responding to a complaint</div>'
    +'</div></div>'
    +'<div style="font-size:11px;color:#64748B;margin-top:10px;border-top:1px solid #E2E8F0;padding-top:8px">Reference: SC Guidelines on Conduct of Licensed Persons (GL-3) &middot; FIMM Code of Ethics &amp; Consolidated Rules &middot; AMLA 2001 &middot; PDPA 2010 &middot; SIDREC. This is internal guidance, not legal advice. Raise any uncertainty with the Compliance Officer.</div>'
    +'</div>';
}
function renderProtectionGuide(){
  document.getElementById('main-content').innerHTML='<div style="padding:24px">'
    +'<div style="max-width:820px;margin:0 auto 12px;display:flex;justify-content:flex-end"><button onclick="protectionPrint()" style="background:#0B2545;color:#fff;border:0;padding:9px 16px;border-radius:8px;font-size:13px;font-weight:700;cursor:pointer">Print / Save as PDF</button></div>'
    +_protectionGuideHTML()+'</div>';
}
function protectionPrint(){
  var w=window.open('','_blank');
  if(!w){ alert('Pop-up blocked — allow pop-ups to print, or use your browser Print (Ctrl/Cmd+P).'); window.print(); return; }
  w.document.write('<!doctype html><html><head><title>LIFA — Adviser & Firm Protection</title>'
    +'<style>@page{size:A4;margin:12mm}body{font-family:Arial,Helvetica,sans-serif;margin:0;padding:0}</style></head><body>'
    +_protectionGuideHTML()+'</body></html>');
  w.document.close();
  setTimeout(function(){ w.focus(); w.print(); }, 250);
}

// ===== Adviser onboarding & conduct gate modal =====
function _mdLite(md){
  var lines=String(md||'').split('\n'), out=[], inList=false;
  function close(){ if(inList){ out.push('</ul>'); inList=false; } }
  lines.forEach(function(raw){
    var ln=_amlEsc(raw).replace(/\*\*(.+?)\*\*/g,'<b>$1</b>');
    if(/^### /.test(raw)){ close(); out.push('<h4 style="margin:10px 0 3px;color:#0B2545">'+ln.replace(/^###\s*/,'')+'</h4>'); }
    else if(/^## /.test(raw)){ close(); out.push('<div style="margin:13px 0 4px;color:#0B2545;font-weight:800;font-size:14px">'+ln.replace(/^##\s*/,'')+'</div>'); }
    else if(/^# /.test(raw)){ close(); out.push('<div style="margin:0 0 8px;color:#0B2545;font-weight:800;font-size:17px">'+ln.replace(/^#\s*/,'')+'</div>'); }
    else if(/^\s*---\s*$/.test(raw)){ close(); out.push('<hr style="border:0;border-top:1px solid #E2E8F0;margin:12px 0">'); }
    else if(/^\s*[-*] /.test(raw) || /^\s*\d+\.\s/.test(raw)){ if(!inList){ out.push('<ul style="margin:4px 0;padding-left:20px;color:#334155;line-height:1.5">'); inList=true; } out.push('<li>'+ln.replace(/^\s*([-*]|\d+\.)\s*/,'')+'</li>'); }
    else if(ln.trim()===''){ close(); out.push('<div style="height:6px"></div>'); }
    else { close(); out.push('<div style="color:#334155;line-height:1.55">'+ln+'</div>'); }
  });
  close(); return out.join('');
}

var _onbGateSteps=[], _onbGateIdx=0, _onbGateVer='', _onbGateSigDrawn=false;

async function loadOnboarding(){
  if(isAdmin||isChecker||isAdminPreview) return;
  var card=document.getElementById('onboarding-card');
  try{
    var onb=await apiGet('/api/me/onboarding').catch(function(){return {items:[]};});
    var fp=await apiGet('/api/me/fit-proper').catch(function(){return {};});
    var items=(onb&&onb.items)||[], ver=(onb&&onb.version)||'';
    var fpDone=!!(fp&&fp.declaration);
    var agDone=!!(items.find(function(i){return i.item==='agreement'&&i.done&&i.current;}));
    var coeDone=!!(items.find(function(i){return i.item==='code_of_ethics'&&i.done&&i.current;}));
    if(fpDone&&agDone&&coeDone){
      var agItem=items.find(function(i){return i.item==='agreement';});
      var coeItem=items.find(function(i){return i.item==='code_of_ethics';});
      if(card) card.innerHTML='<div style="background:#ECFDF5;border:1px solid #A7F3D0;border-radius:14px;padding:13px 16px">'
        +'<div style="font-weight:700;color:#065F46;font-size:14px;margin-bottom:8px">Compliance items complete</div>'
        +'<div style="display:flex;gap:10px;flex-wrap:wrap">'
        +'<button onclick="_onbViewDoc(\'agreement\')" style="background:#fff;border:1px solid #A7F3D0;color:#065F46;border-radius:7px;font-size:12px;font-weight:600;padding:5px 12px;cursor:pointer">View Agreement</button>'
        +'<button onclick="_onbViewDoc(\'code_of_ethics\')" style="background:#fff;border:1px solid #A7F3D0;color:#065F46;border-radius:7px;font-size:12px;font-weight:600;padding:5px 12px;cursor:pointer">View Code of Ethics</button>'
        +'</div></div>';
      return;
    }
    if(card) card.innerHTML='';
    _onbGateSteps=[];
    if(!fpDone) _onbGateSteps.push({id:'declaration',label:'Annual Declaration'});
    if(!agDone) _onbGateSteps.push({id:'agreement',label:'Sign Agreement'});
    if(!coeDone) _onbGateSteps.push({id:'code_of_ethics',label:'Code of Ethics'});
    _onbGateVer=ver; _onbGateIdx=0;
    _onbGateBuild();
  }catch(e){}
}
function _onbGateBuild(){
  var old=document.getElementById('onb-gate'); if(old) old.remove();
  var el=document.createElement('div'); el.id='onb-gate';
  el.style.cssText='position:fixed;inset:0;background:rgba(11,37,69,.84);z-index:99999;display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box';
  document.body.appendChild(el);
  _onbGateRender();
}
function _onbGateRender(){
  var gate=document.getElementById('onb-gate'); if(!gate) return;
  var chips=_onbGateSteps.map(function(s,i){
    var done=i<_onbGateIdx, cur=i===_onbGateIdx;
    return '<span style="font-size:11px;font-weight:700;padding:4px 12px;border-radius:20px;background:'+(done?'#D1FAE5':cur?'#DBEAFE':'#F1F5F9')+';color:'+(done?'#065F46':cur?'#1D4ED8':'#94A3B8')+'">'+(done?'✓ ':'')+_amlEsc(s.label)+'</span>';
  }).join('');
  gate.innerHTML='<div style="background:#fff;border-radius:16px;max-width:720px;width:100%;max-height:92vh;display:flex;flex-direction:column;overflow:hidden;box-shadow:0 32px 80px rgba(0,0,0,.35)">'
    +'<div style="padding:18px 22px 14px;border-bottom:1px solid #E2E8F0;flex-shrink:0">'
    +'<div style="font-size:15px;font-weight:800;color:#0B2545">Before you continue</div>'
    +'<div style="font-size:12px;color:#64748B;margin-top:2px">Please complete all required items to access your portal</div>'
    +'<div style="display:flex;gap:6px;margin-top:10px;flex-wrap:wrap">'+chips+'</div>'
    +'</div>'
    +'<div id="onb-gate-body" style="flex:1;overflow-y:auto;padding:22px;-webkit-overflow-scrolling:touch"></div>'
    +'<div id="onb-gate-foot" style="padding:12px 22px;border-top:1px solid #E2E8F0;background:#F8FAFC;flex-shrink:0;display:flex;gap:10px;justify-content:flex-end"></div>'
    +'</div>';
  var step=_onbGateSteps[_onbGateIdx];
  if(step.id==='declaration') _onbGateDecl();
  else if(step.id==='agreement') _onbGateAgree();
  else if(step.id==='code_of_ethics') _onbGateCoE();
}
function _onbGateDecl(){
  var body=document.getElementById('onb-gate-body'), foot=document.getElementById('onb-gate-foot'); if(!body) return;
  var qs=[['gfp-bk','Have you been declared bankrupt or are you subject to bankruptcy proceedings?'],
          ['gfp-cr','Have you been convicted of any offence involving fraud, dishonesty or financial misconduct?'],
          ['gfp-di','Have you been subject to disciplinary action by the SC, FIMM, BNM or any professional body?'],
          ['gfp-cv','Are you a defendant in civil proceedings relating to your professional conduct?'],
          ['gfp-in','Are you currently under investigation by any regulator or law-enforcement agency?']];
  body.innerHTML='<div style="font-size:14px;font-weight:700;color:#0B2545;margin-bottom:4px">Annual Fit-and-Proper Declaration</div>'
    +'<div style="font-size:12px;color:#64748B;margin-bottom:16px">Required annually for LIFA\'s licence renewal. Answer honestly — if you answer "Yes" to any item, provide details below.</div>'
    +qs.map(function(q){return '<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:12px;padding:10px 0;border-bottom:1px solid #F1F5F9;font-size:13px;color:#334155"><span style="flex:1">'+q[1]+'</span><span style="white-space:nowrap"><label style="margin-left:6px"><input type="radio" name="'+q[0]+'" value="0" checked onchange="_gfpToggle()"> No</label><label style="margin-left:6px"><input type="radio" name="'+q[0]+'" value="1" onchange="_gfpToggle()"> Yes</label></span></div>';}).join('')
    +'<div id="gfp-disc-wrap" style="display:none;margin-top:10px"><label style="font-size:11px;color:#64748B;font-weight:600;text-transform:uppercase;letter-spacing:.04em">Details for any "Yes" answer</label><textarea id="gfp-disc" rows="3" style="width:100%;margin-top:4px;padding:8px 10px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px;box-sizing:border-box;resize:vertical"></textarea></div>'
    +'<label style="display:flex;gap:8px;align-items:flex-start;font-size:13px;margin-top:16px;cursor:pointer"><input type="checkbox" id="gfp-true"> I confirm the above answers are true and complete, and will notify LIFA Planners immediately of any change.</label>'
    +'<div style="margin-top:14px"><label style="font-size:11px;font-weight:600;color:#374151;text-transform:uppercase;letter-spacing:.04em">Type your full name to sign</label><input id="gfp-sign" placeholder="Full name" style="display:block;width:100%;max-width:300px;margin-top:5px;padding:10px 12px;border:1.5px solid #D1D5DB;border-radius:8px;font-size:14px;box-sizing:border-box"></div>'
    +'<div id="gfp-msg" style="font-size:12px;margin-top:8px;color:#B91C1C"></div>';
  foot.innerHTML='<button onclick="_onbGateDeclSubmit()" style="background:#0B2545;color:#fff;border:0;padding:10px 24px;border-radius:9px;font-size:14px;font-weight:700;cursor:pointer">Submit &amp; Continue</button>';
}
function _gfpToggle(){
  var w=document.getElementById('gfp-disc-wrap');
  if(w) w.style.display=['gfp-bk','gfp-cr','gfp-di','gfp-cv','gfp-in'].some(function(n){var el=document.querySelector('input[name="'+n+'"]:checked');return el&&el.value==='1';})?'block':'none';
}
async function _onbGateDeclSubmit(){
  var msg=document.getElementById('gfp-msg');
  if(!document.getElementById('gfp-true').checked){msg.textContent='Please tick the confirmation box.';return;}
  var sign=((document.getElementById('gfp-sign')||{}).value||'').trim(); if(!sign){msg.textContent='Type your full name to sign.';return;}
  var val=function(n){var el=document.querySelector('input[name="'+n+'"]:checked');return el&&el.value==='1'?1:0;};
  var anyYes=['gfp-bk','gfp-cr','gfp-di','gfp-cv','gfp-in'].some(function(n){return val(n)===1;});
  var disc=((document.getElementById('gfp-disc')||{}).value||'').trim();
  if(anyYes&&!disc){msg.textContent='Please give details for any "Yes" answer.';return;}
  var btn=document.querySelector('#onb-gate-foot button');if(btn){btn.disabled=true;btn.textContent='Submitting…';}
  try{
    var r=await apiPost('/api/me/fit-proper',{q_bankruptcy:val('gfp-bk'),q_criminal:val('gfp-cr'),q_disciplinary:val('gfp-di'),q_civil:val('gfp-cv'),q_investigation:val('gfp-in'),disclosures:disc,declared_true:true,signed_name:sign});
    if(r&&r.error){msg.textContent=r.error;if(btn){btn.disabled=false;btn.textContent='Submit & Continue';}return;}
    _onbGateNext();
  }catch(e){msg.textContent=e.message;if(btn){btn.disabled=false;btn.textContent='Submit & Continue';}}
}
async function _onbGateAgree(){
  var body=document.getElementById('onb-gate-body'),foot=document.getElementById('onb-gate-foot'); if(!body) return;
  body.innerHTML='<div style="color:#64748B;font-size:13px">Loading agreement…</div>'; foot.innerHTML='';
  try{
    var r=await apiGet('/api/me/onboarding/doc/agreement');
    if(!r||r.error){body.innerHTML='<div style="color:#DC2626">'+_amlEsc((r&&r.error)||'Failed to load')+'</div>';return;}
    _onbGateSigDrawn=false;
    body.innerHTML='<div style="font-size:14px;font-weight:700;color:#0B2545;margin-bottom:12px">'+_amlEsc(r.title)+'<span style="font-size:11px;color:#94A3B8;font-weight:400;margin-left:6px">v'+_amlEsc(r.version||'')+'</span></div>'
      +'<div style="font-size:13px;line-height:1.65;color:#334155;background:#F8FAFC;border:1px solid #E2E8F0;border-radius:10px;padding:16px;max-height:260px;overflow-y:auto;margin-bottom:16px">'+_mdLite(r.body)+'</div>'
      +'<div style="font-size:11px;font-weight:600;color:#374151;text-transform:uppercase;letter-spacing:.04em;margin-bottom:6px">Draw your signature</div>'
      +'<canvas id="onb-sig-c" width="600" height="150" style="width:100%;height:130px;border:1.5px solid #D1D5DB;border-radius:10px;background:#fff;cursor:crosshair;touch-action:none"></canvas>'
      +'<div style="margin-top:4px"><button onclick="_onbGateClearSig()" style="background:none;border:1px solid #CBD5E1;color:#64748B;border-radius:6px;font-size:11px;padding:3px 10px;cursor:pointer">Clear</button></div>'
      +'<div style="margin-top:14px"><label style="font-size:11px;font-weight:600;color:#374151;text-transform:uppercase;letter-spacing:.04em">Type your full name to confirm</label><input id="onb-sig-name" placeholder="Full name" style="display:block;width:100%;max-width:300px;margin-top:5px;padding:10px 12px;border:1.5px solid #D1D5DB;border-radius:8px;font-size:14px;box-sizing:border-box"></div>'
      +'<div id="onb-ag-msg" style="font-size:12px;margin-top:8px;color:#B91C1C"></div>';
    foot.innerHTML='<button onclick="_onbGateAgreeSubmit()" style="background:#0B2545;color:#fff;border:0;padding:10px 24px;border-radius:9px;font-size:14px;font-weight:700;cursor:pointer">Sign Agreement</button>';
    var c=document.getElementById('onb-sig-c'); if(!c) return;
    var ctx=c.getContext('2d'); ctx.lineWidth=2.5; ctx.lineCap='round'; ctx.strokeStyle='#0B2545';
    var dn=false,lp=null;
    var pos=function(ev){var r=c.getBoundingClientRect(),t=ev.touches?ev.touches[0]:ev;return {x:(t.clientX-r.left)*(c.width/r.width),y:(t.clientY-r.top)*(c.height/r.height)};};
    c.addEventListener('mousedown',function(ev){dn=true;lp=pos(ev);ev.preventDefault();});
    c.addEventListener('mousemove',function(ev){if(!dn)return;var p=pos(ev);ctx.beginPath();ctx.moveTo(lp.x,lp.y);ctx.lineTo(p.x,p.y);ctx.stroke();lp=p;_onbGateSigDrawn=true;ev.preventDefault();});
    window.addEventListener('mouseup',function(){dn=false;});
    c.addEventListener('touchstart',function(ev){dn=true;lp=pos(ev);ev.preventDefault();},{passive:false});
    c.addEventListener('touchmove',function(ev){if(!dn)return;var p=pos(ev);ctx.beginPath();ctx.moveTo(lp.x,lp.y);ctx.lineTo(p.x,p.y);ctx.stroke();lp=p;_onbGateSigDrawn=true;ev.preventDefault();},{passive:false});
    c.addEventListener('touchend',function(){dn=false;});
  }catch(e){body.innerHTML='<div style="color:#DC2626">'+_amlEsc(e.message)+'</div>';}
}
function _onbGateClearSig(){var c=document.getElementById('onb-sig-c');if(c){c.getContext('2d').clearRect(0,0,c.width,c.height);_onbGateSigDrawn=false;}}
async function _onbGateAgreeSubmit(){
  var msg=document.getElementById('onb-ag-msg');
  if(!_onbGateSigDrawn){msg.textContent='Please draw your signature in the box.';return;}
  var name=((document.getElementById('onb-sig-name')||{}).value||'').trim();if(!name){msg.textContent='Please type your full name.';return;}
  var c=document.getElementById('onb-sig-c');
  var btn=document.querySelector('#onb-gate-foot button');if(btn){btn.disabled=true;btn.textContent='Signing…';}
  try{
    var r=await apiPost('/api/me/onboarding/agree',{item:'agreement',signed_name:name,signature_b64:c?c.toDataURL('image/png'):''});
    if(r&&r.error){msg.textContent=r.error;if(btn){btn.disabled=false;btn.textContent='Sign Agreement';}return;}
    _onbGateNext();
  }catch(e){msg.textContent=e.message;if(btn){btn.disabled=false;btn.textContent='Sign Agreement';}}
}
async function _onbGateCoE(){
  var body=document.getElementById('onb-gate-body'),foot=document.getElementById('onb-gate-foot'); if(!body) return;
  body.innerHTML='<div style="color:#64748B;font-size:13px">Loading…</div>'; foot.innerHTML='';
  try{
    var r=await apiGet('/api/me/onboarding/doc/code_of_ethics');
    if(!r||r.error){body.innerHTML='<div style="color:#DC2626">'+_amlEsc((r&&r.error)||'Failed')+'</div>';return;}
    body.innerHTML='<div style="font-size:14px;font-weight:700;color:#0B2545;margin-bottom:12px">'+_amlEsc(r.title)+'</div>'
      +'<div style="font-size:13px;line-height:1.65;color:#334155;background:#F8FAFC;border:1px solid #E2E8F0;border-radius:10px;padding:16px;max-height:300px;overflow-y:auto;margin-bottom:16px">'+_mdLite(r.body)+'</div>'
      +'<label style="display:flex;gap:8px;align-items:flex-start;font-size:13px;cursor:pointer;margin-bottom:14px"><input type="checkbox" id="onb-coe-chk"> I have read and understood the Code of Ethics and agree to be bound by it.</label>'
      +'<div><label style="font-size:11px;font-weight:600;color:#374151;text-transform:uppercase;letter-spacing:.04em">Type your full name to agree</label><input id="onb-coe-name" placeholder="Full name" style="display:block;width:100%;max-width:300px;margin-top:5px;padding:10px 12px;border:1.5px solid #D1D5DB;border-radius:8px;font-size:14px;box-sizing:border-box"></div>'
      +'<div id="onb-coe-msg" style="font-size:12px;margin-top:8px;color:#B91C1C"></div>';
    foot.innerHTML='<button onclick="_onbGateCoESubmit()" style="background:#0B2545;color:#fff;border:0;padding:10px 24px;border-radius:9px;font-size:14px;font-weight:700;cursor:pointer">Agree &amp; Continue</button>';
  }catch(e){body.innerHTML='<div style="color:#DC2626">'+_amlEsc(e.message)+'</div>';}
}
async function _onbGateCoESubmit(){
  var msg=document.getElementById('onb-coe-msg');
  if(!document.getElementById('onb-coe-chk').checked){msg.textContent='Please tick the box to confirm you have read the Code of Ethics.';return;}
  var name=((document.getElementById('onb-coe-name')||{}).value||'').trim();if(!name){msg.textContent='Please type your full name.';return;}
  var btn=document.querySelector('#onb-gate-foot button');if(btn){btn.disabled=true;btn.textContent='Saving…';}
  try{
    var r=await apiPost('/api/me/onboarding/agree',{item:'code_of_ethics',signed_name:name});
    if(r&&r.error){msg.textContent=r.error;if(btn){btn.disabled=false;btn.textContent='Agree & Continue';}return;}
    _onbGateNext();
  }catch(e){msg.textContent=e.message;if(btn){btn.disabled=false;btn.textContent='Agree & Continue';}}
}
function _onbGateNext(){
  _onbGateIdx++;
  if(_onbGateIdx<_onbGateSteps.length){ _onbGateRender(); return; }
  var gate=document.getElementById('onb-gate'); if(!gate) return;
  gate.innerHTML='<div style="background:#fff;border-radius:16px;max-width:440px;width:100%;padding:48px 32px;text-align:center;box-shadow:0 32px 80px rgba(0,0,0,.35)">'
    +'<div style="font-size:48px;margin-bottom:16px">&#10003;</div>'
    +'<div style="font-size:20px;font-weight:800;color:#0B2545;margin-bottom:8px">All done</div>'
    +'<div style="font-size:14px;color:#64748B;line-height:1.7;margin-bottom:24px">All required compliance items have been completed and recorded.</div>'
    +'<button onclick="_onbGateDone()" style="background:#0B2545;color:#fff;border:0;padding:12px 32px;border-radius:10px;font-size:15px;font-weight:700;cursor:pointer">Continue to portal</button>'
    +'</div>';
}
function _onbGateDone(){
  var gate=document.getElementById('onb-gate'); if(gate) gate.remove();
  loadOnboarding();
}
async function _onbViewDoc(item){
  var r; try{ r=await apiGet('/api/me/onboarding/doc/'+item); }catch(e){ showToast('error',e.message); return; }
  if(!r||r.error){ showToast('error',(r&&r.error)||'Failed to load'); return; }
  var ov=document.getElementById('onb-view-modal'); if(ov) ov.remove();
  ov=document.createElement('div'); ov.id='onb-view-modal';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;display:flex;align-items:center;justify-content:center;padding:20px;box-sizing:border-box';
  ov.innerHTML='<div style="background:#fff;border-radius:14px;max-width:760px;width:100%;max-height:90vh;display:flex;flex-direction:column;overflow:hidden;box-shadow:0 24px 64px rgba(0,0,0,.3)">'
    +'<div style="padding:14px 20px;border-bottom:1px solid #E2E8F0;display:flex;justify-content:space-between;align-items:center;flex-shrink:0">'
    +'<div><div style="font-weight:800;color:#0B2545;font-size:14px">'+_amlEsc(r.title)+'</div><div style="font-size:11px;color:#94A3B8;margin-top:2px">v'+_amlEsc(r.version||'')+'</div></div>'
    +'<button onclick="document.getElementById(\'onb-view-modal\').remove()" style="background:#F1F5F9;border:0;border-radius:7px;padding:6px 14px;cursor:pointer;font-size:13px">Close</button></div>'
    +'<div style="padding:20px;overflow-y:auto;font-size:13px;line-height:1.65">'+_mdLite(r.body)+'</div>'
    +'</div>';
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
}
// Admin: show an adviser's onboarding status on their folder
async function loadAdviserOnboarding(advId){
  var el=document.getElementById('adv-onboarding'); if(!el) return;
  try{
    var r=await apiGet('/api/onboarding'); if(!r||!r.rows) return;
    var mine={}; r.rows.forEach(function(x){ if(x.adviser_id===advId) mine[x.item]=x; });
    function cell(item,label){ var d=mine[item]; var ok=d && d.doc_version===r.version;
      return '<span style="font-size:12px;color:'+(ok?'#15803D':'#B45309')+';font-weight:600">'+(ok?'✓':'✗')+' '+label+(ok?' <span style="color:#94A3B8;font-weight:400">'+_amlEsc((d.signed_at||'').slice(0,10))+'</span>':'')+'</span>'; }
    el.innerHTML='<div style="background:#fff;border-radius:12px;box-shadow:0 2px 12px rgba(0,0,0,.07);padding:14px 18px;margin-bottom:20px">'
      +'<div style="font-size:13px;font-weight:700;color:#0B2545;margin-bottom:8px">Onboarding &amp; Conduct</div>'
      +'<div style="display:flex;gap:18px;flex-wrap:wrap">'+cell('agreement','Appointment Agreement')+cell('code_of_ethics','Code of Ethics')+'</div></div>';
  }catch(e){}
}
async function regMarkDone(key, year, undo){
  var note=null;
  if(!undo){ note=prompt('Note (optional — e.g. "submitted via EASy"):',''); if(note===null) return; }
  else if(!confirm('Undo the done mark for this cycle? Reminders will resume.')) return;
  try{
    var r=await apiPost('/api/firm-compliance/'+key+'/done',{year:year, undo:!!undo, note:note});
    if(r&&r.error) throw new Error(r.error);
    showToast('success', undo?'Reverted':'Marked done — reminders for this cycle silenced');
    renderRegReports();
  }catch(e){ showToast('error',e.message); }
}

function _kpi(label, val, color) {
  return `<div style="background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:14px 16px">
    <div style="font-size:11px;text-transform:uppercase;letter-spacing:.5px;color:#64748B;font-weight:600">${label}</div>
    <div style="font-size:24px;font-weight:700;color:${color};margin-top:4px">${val}</div>
  </div>`;
}

// Plain hours (no confusing trailing .0) — 10 → "10", 10.5 → "10.5"
function _cpeHrs(n){ n = Number(n)||0; return String(n); }
// Human remark instead of "10.0 / 20": "Shortfall N hours" or "✅ CPE done"
function _cpeRemark(hours, req){
  hours = Number(hours)||0; req = Number(req)||20;
  if (hours >= req) return '<span style="color:#15803D;font-weight:700">✅ CPE done</span>';
  return '<span style="color:#B45309;font-weight:700">Shortfall '+_cpeHrs(req-hours)+' hours</span>';
}
// Row-level "view": single cert opens directly; multiple certs open the Detail
// panel where ALL of them are listed (with year + view buttons).
function _cpeQuickView(adviserId){
  const r = (_complianceCache||[]).find(x => x.id === adviserId);
  const certs = (r && (r.certificates_all && r.certificates_all.length ? r.certificates_all : r.certificates)) || [];
  if (!certs.length) return showToast("warn","No certificate uploaded yet for this rep");
  if (certs.length === 1) return _cpeCertView(certs[0].id);
  _complianceOpenDetail(adviserId);
}

// Does this rep need action now? (CPE shortfall in the critical window, or CMSRL unpaid
// when due.) Drives the default "pending only" view.
function _cpePending(r){
  if (r.exempt_this_year) return false;
  const rec = r.cpe_record || {}, anniv = r.anniversary || {};
  const hrs = rec.hours_completed||0, req = rec.required_hours||20;
  const daysLeft = anniv.end ? Math.round((new Date(anniv.end+"T00:00:00")-Date.now())/86400000) : 9999;
  if (daysLeft > 120) return false;                       // nothing due yet
  const cpePending = hrs < req && rec.status !== "Verified";
  const isExcomm = (r.category==="EXCOMM"||r.rank==="EXCOMM");
  const pay = rec.payment_status||"Unpaid";
  const payPending = !isExcomm && pay!=="Paid" && pay!=="Verified";
  return cpePending || payPending;
}

function _renderComplianceRow(r) {
  const rec = r.cpe_record || {};
  const anniv = r.anniversary || {};
  const hours = rec.hours_completed || 0;
  const req = rec.required_hours || 20;
  const pct = Math.min(100, Math.round(hours/req*100));
  const certs = r.certificates || [];
  const lastReminder = rec.last_reminder_at ? _fmtDate(rec.last_reminder_at.split(" ")[0]) + " (" + (rec.reminder_count||0) + ")" : "—";
  const displayStatus = r.exempt_this_year ? "Exempt" : (rec.status || "Pending");
  const exemptNote = r.exempt_this_year ? `<div style="font-size:10px;color:#6B21A8;margin-top:2px;font-weight:600">Newly licensed ${r.license_date?.slice(0,4)||""} — exempt from this year's reporting</div>` : "";
  return `
    <tr style="border-top:1px solid #F1F5F9">
      <td style="padding:12px 14px">
        <div style="font-weight:600;color:#0B2545">${escapeHtml(r.name)}</div>
        <div style="font-size:11px;color:#64748B">${r.id} · licensed ${_fmtDate(r.license_date)}</div>
      </td>
      <td style="padding:12px 14px;white-space:nowrap;font-size:12px">
        ${anniv.start?_fmtDate(anniv.start):"—"} → ${anniv.end?_fmtDate(anniv.end):"—"}
        ${_timelineMini(r.timeline)}
      </td>
      <td style="padding:12px 14px;min-width:150px">
        ${(function(){
          // MINIMALIST RULE: show only what needs action NOW.
          //  - exempt → one grey line
          //  - deadline far away + last year completed → just the green "done" line
          //  - deadline far away, nothing due → quiet progress, no warnings
          //  - deadline ≤120 days or overdue → the shortfall, loud
          const all=(r.certificates_all||certs);
          const certsBit = all.length?` · <a href="javascript:void(0)" onclick="_cpeQuickView('${r.id}')" style="color:#0B2545;font-weight:700;text-decoration:underline">📄 ${all.length} cert${all.length===1?"":"s"}</a>`:"";
          if(r.exempt_this_year) return `<div style="font-size:13px;color:#94A3B8;font-weight:600">Exempt this year</div>`;
          const daysLeft = anniv.end ? Math.round((new Date(anniv.end+"T00:00:00")-Date.now())/86400000) : 0;
          const done=(r.timeline||[]).filter(t=>t.status==='Verified').pop();
          const critical = daysLeft <= 120;
          if(!critical && done) return `<div style="font-size:13px;color:#15803D;font-weight:700">✅ Renewal ${new Date(done.end).getFullYear()} completed</div><div style="font-size:11px;color:#94A3B8;margin-top:3px">${certsBit?certsBit.replace(' · ',''):''}</div>`;
          if(!critical) return `<div style="font-size:13px;color:#64748B">${_cpeHrs(hours)} of ${req} hrs</div><div style="font-size:11px;color:#94A3B8;margin-top:3px">due ${_fmtDate(anniv.end)}${certsBit}</div>`;
          return `<div style="font-size:13px;margin-bottom:4px">${_cpeRemark(hours,req)}</div>
        <div style="background:#F1F5F9;border-radius:999px;height:6px;overflow:hidden">
          <div style="background:${pct>=100?'#10B981':pct>=50?'#3B82F6':'#F59E0B'};height:100%;width:${pct}%"></div>
        </div>
        <div style="font-size:11px;color:#94A3B8;margin-top:3px">${_cpeHrs(hours)} of ${req} hrs · ${daysLeft>=0?daysLeft+" days left":"OVERDUE"}${certsBit}</div>`;
        })()}
      </td>
      <td style="padding:12px 14px">
        ${(function(){
          // CMSRL payment, stated plainly — the CPE story already lives in the CPE column.
          if(r.exempt_this_year) return '<span style="color:#94A3B8;font-size:12px">—</span>'+exemptNote;
          const isExcomm=(r.category==="EXCOMM"||r.rank==="EXCOMM");
          const pay=rec.payment_status||"Unpaid";
          const daysLeft = anniv.end ? Math.round((new Date(anniv.end+"T00:00:00")-Date.now())/86400000) : 9999;
          let b;
          if(isExcomm) b='<span style="background:#F1F5F9;color:#64748B;padding:2px 9px;border-radius:10px;font-size:11px;font-weight:600" title="EXCOMM — CMSRL renewal paid by the firm">Firm pays</span>';
          else if(pay==="Paid"||pay==="Verified") b='<span style="background:#DCFCE7;color:#15803D;padding:2px 9px;border-radius:10px;font-size:11px;font-weight:600" title="Confirmed received by finance">Paid ✓</span>';
          else if(pay==="Submitted") b='<span style="background:#DBEAFE;color:#1E40AF;padding:2px 9px;border-radius:10px;font-size:11px;font-weight:600" title="Transfer slip uploaded — shows Paid only after finance confirms receipt">Slip uploaded · awaiting finance</span>';
          else if(daysLeft<=120) b='<span style="background:#FEF3C7;color:#92400E;padding:2px 9px;border-radius:10px;font-size:11px;font-weight:700">RM 500 unpaid</span>';
          else b='<span style="color:#94A3B8;font-size:12px">not due yet</span>';
          return '<div>'+b+'</div>'+(rec.last_reminder_at?`<div style="font-size:10.5px;color:#94A3B8;margin-top:3px">CPE reminded ${lastReminder}</div>`:'');
        })()}
      </td>
      <td style="padding:12px 14px;text-align:right;white-space:nowrap">
        <button onclick="_complianceSendReminder('${r.id}')" ${r.exempt_this_year?'disabled style="opacity:.35;cursor:not-allowed;"':''} style="background:#0B2545;color:#fff;border:0;padding:7px 14px;border-radius:7px;font-size:12px;cursor:pointer;margin-right:6px" title="${r.exempt_this_year?'Exempt — no reminder needed':'Sends email + WhatsApp automatically'}">Remind</button>
        <button onclick="_complianceOpenDetail('${r.id}')" style="background:#fff;color:#0B2545;border:1.5px solid #E2E8F0;padding:7px 14px;border-radius:7px;font-size:12px;cursor:pointer">Detail</button>
      </td>
    </tr>`;
}

async function _complianceSendReminder(adviserId) {
  // Don't double-chase: if a reminder went out in the last 7 days, skip (footnote shows the date).
  const _r=(_complianceCache||[]).find(x=>x.id===adviserId);
  const _last=_r&&_r.cpe_record&&_r.cpe_record.last_reminder_at;
  if(_last){
    const days=(Date.now()-new Date(_last.replace(" ","T")+"Z").getTime())/86400000;
    if(days<7) return showToast("warn","Already reminded "+_fmtDate(_last.split(" ")[0])+" — not sending again (wait "+Math.ceil(7-days)+" more day"+(Math.ceil(7-days)===1?"":"s")+")");
  }
  if (!confirm("Send compliance reminder to this rep via email + WhatsApp?")) return;
  try {
    const r = await apiPost(`/api/cpe/${adviserId}/send-reminder`, {channels:["email","whatsapp"]});
    if (r.error) throw new Error(r.error);
    const em = r.results && r.results.email, wa = r.results && r.results.whatsapp;
    const parts = [];
    if (em) parts.push("Email: " + (em.ok ? "sent ✓" : "failed — " + (em.error||"unknown")));
    if (wa) {
      if (wa.ok) parts.push("WhatsApp: sent via API ✓");
      else if (wa.fallback && wa.wa_link) {
        parts.push("WhatsApp: opened click-to-chat (admin to press Send)");
        // Open in new tab — WhatsApp Web with pre-filled message
        window.open(wa.wa_link, "_blank", "noopener");
      } else parts.push("WhatsApp: failed — " + (wa.error||"unknown"));
    }
    const anyOk = (em && em.ok) || (wa && (wa.ok || wa.fallback));
    showToast(anyOk ? "success" : "error", parts.join(" · ") || "Reminder logged");
    renderCompliance();
  } catch (e) { showToast("error", e.message); }
}

// One-click WhatsApp from any rep row — uses wa.me link pre-built by the API.
function _complianceWhatsApp(adviserId) {
  const r = (_complianceCache||[]).find(x => x.id === adviserId);
  if (!r) return showToast("error","Rep not found in cache");
  if (!r.phone) return showToast("error","No phone number on file for this rep — add it in the admin panel.");
  if (!r.wa_link) return showToast("error","Cannot build WhatsApp link (missing anniversary data)");
  window.open(r.wa_link, "_blank", "noopener");
}

async function _remindAll() {
  const rows = (_complianceCache||[]).filter(r => {
    if (r.exempt_this_year) return false;                            // skip exempt
    if (_complianceFilter.janJunOnly) { const m=_monthOf(r.license_date); if(!m||m<1||m>6) return false; }
    if (_complianceFilter.search) { const q=_complianceFilter.search.toLowerCase(); if(!((r.name||"").toLowerCase().includes(q)||(r.cmsrl||"").toLowerCase().includes(q))) return false; }
    return true;
  });
  const exemptCount = (_complianceCache||[]).filter(r => r.exempt_this_year && (!_complianceFilter.janJunOnly || (_monthOf(r.license_date)>=1 && _monthOf(r.license_date)<=6))).length;
  if (!rows.length) return showToast("warn", exemptCount?`No reminders to send — ${exemptCount} rep(s) in filter are exempt (newly licensed)`:"No reps in current filter");
  const exemptNote = exemptCount ? ` (${exemptCount} exempt rep${exemptCount===1?'':'s'} skipped)` : "";
  if (!confirm(`Send compliance reminders to ${rows.length} rep(s)?${exemptNote}`)) return;
  let ok=0, fail=0, waLinksOpened=0;
  for (const r of rows) {
    try {
      const res = await apiPost(`/api/cpe/${r.id}/send-reminder`, {channels:["email","whatsapp"]});
      if (res.skipped) continue;
      const em = res.results && res.results.email, wa = res.results && res.results.whatsapp;
      if (em && em.ok) ok++;
      else if (wa && wa.ok) ok++;
      else if (wa && wa.fallback && wa.wa_link) { window.open(wa.wa_link, "_blank", "noopener"); waLinksOpened++; ok++; }
      else fail++;
    } catch { fail++; }
  }
  const msg = `${ok} reminder(s) sent` + (waLinksOpened?` (${waLinksOpened} WhatsApp tab${waLinksOpened===1?'':'s'} opened — press Send in each)`:'') + (fail?`, ${fail} failed`:'') + exemptNote;
  showToast(fail?"error":"success", msg);
  renderCompliance();
}

function _complianceOpenDetail(adviserId) {
  const r = (_complianceCache||[]).find(x => x.id === adviserId);
  if (!r) return;
  const rec = r.cpe_record || {};
  const certs = r.certificates_all || r.certificates || [];   // every renewal year, newest first
  // Renewal year = year the anniversary window CLOSES (what the renewal is for).
  const renewYear = (r.anniversary||{}).end ? new Date((r.anniversary).end).getFullYear() : "";
  const isExcommRep = (r.category==="EXCOMM" || r.rank==="EXCOMM");
  const modal = document.createElement("div");
  modal.style.cssText = "position:fixed;inset:0;background:rgba(11,37,69,.55);display:flex;align-items:center;justify-content:center;z-index:9999;padding:20px";
  modal.onclick = e => { if (e.target === modal) modal.remove(); };
  modal.innerHTML = `
    <div style="background:#fff;border-radius:14px;max-width:760px;width:100%;max-height:90vh;overflow:auto;padding:24px;box-shadow:0 20px 60px rgba(0,0,0,.3)" onclick="event.stopPropagation()">
      <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:6px">
        <div>
          <div style="font-size:18px;font-weight:700;color:#0B2545">${escapeHtml(r.name)}</div>
          <div style="color:#64748B;font-size:12px">${escapeHtml(r.cmsrl)} · Licensed ${_fmtDate(r.license_date)}</div>
        </div>
        <button onclick="this.closest('div[style*=fixed]').remove()" style="background:transparent;border:0;font-size:24px;color:#64748B;cursor:pointer">×</button>
      </div>

      ${(function(){
        // Summary strip, minimalist rule: only what needs action now.
        const hrs=Number(rec.hours_completed)||0, req=Number(rec.required_hours)||20;
        const pct=Math.min(100,Math.round(hrs/req*100));
        const annivEnd=(r.anniversary||{}).end;
        const daysLeft = annivEnd ? Math.round((new Date(annivEnd+"T00:00:00")-Date.now())/86400000) : 0;
        const done=(r.timeline||[]).filter(t=>t.status==='Verified').pop();
        const critical = !r.exempt_this_year && daysLeft <= 120;
        const cmsrl = isExcommRep
          ? '<span style="background:#DCFCE7;color:#15803D;padding:2px 10px;border-radius:10px;font-size:11px;font-weight:600">CMSRL: firm pays</span>'
          : (rec.payment_status==="Verified"||rec.payment_status==="Paid")
            ? '<span style="background:#DCFCE7;color:#15803D;padding:2px 10px;border-radius:10px;font-size:11px;font-weight:600" title="Confirmed received by finance">CMSRL: paid ✓</span>'
            : rec.payment_status==="Submitted"
            ? '<span style="background:#DBEAFE;color:#1E40AF;padding:2px 10px;border-radius:10px;font-size:11px;font-weight:600" title="Shows paid only after finance confirms receipt">CMSRL: awaiting finance</span>'
            : '<span style="background:#FEF3C7;color:#92400E;padding:2px 10px;border-radius:10px;font-size:11px;font-weight:600">CMSRL: RM 500 outstanding</span>';
        let line;
        if(r.exempt_this_year)      line = '<span style="color:#94A3B8;font-weight:600">Exempt this year</span>';
        else if(!critical && done)  line = `<span style="color:#15803D;font-weight:700">✅ Renewal ${new Date(done.end).getFullYear()} completed</span>`;
        else if(!critical)          line = `<span style="color:#64748B">${_cpeHrs(hrs)} of ${req} hrs · due ${_fmtDate(annivEnd)}</span>`;
        else                        line = `${_cpeRemark(hrs,req)} <span style="color:#94A3B8">· ${_cpeHrs(hrs)} of ${req} hrs · ${daysLeft>=0?daysLeft+" days left":"OVERDUE"}</span>`;
        return `
      <div style="background:#F8FAFC;border-radius:12px;padding:14px 16px;margin:14px 0">
        <div style="display:flex;justify-content:space-between;align-items:center;gap:10px;flex-wrap:wrap">
          <div style="font-weight:700;color:#0B2545;font-size:14px">Renewal ${renewYear} <span style="color:#64748B;font-weight:500;font-size:12px">· ${_fmtDate((r.anniversary||{}).start)} → ${_fmtDate(annivEnd)}</span></div>
          <div>${cmsrl}</div>
        </div>
        ${critical?`<div style="background:#E2E8F0;border-radius:999px;height:7px;margin:10px 0 6px;overflow:hidden"><div style="background:${pct>=100?'#10B981':'#F59E0B'};height:100%;width:${pct}%"></div></div>`:'<div style="height:6px"></div>'}
        <div style="font-size:12.5px">${line}</div>
      </div>`;})()}

      <form id="cpe-upload-form" onsubmit="event.preventDefault();_cpeUpload('${r.id}', this)" style="display:flex;gap:10px;align-items:center;flex-wrap:wrap;background:#fff;border:1.5px dashed #CBD5E1;border-radius:12px;padding:14px 16px;margin:0 0 14px">
        <span style="font-size:13px;font-weight:700;color:#0B2545">⬆️ Upload cert</span>
        <input name="file" type="file" accept="application/pdf,image/*" onchange="this.closest('form').querySelector('.cpe-extra').style.display='block';_cpeExtract('${r.id}', this.closest('form'))" style="font-size:12px;flex:1;min-width:180px" />
        <button type="submit" style="background:#10B981;color:#fff;border:0;padding:9px 20px;border-radius:8px;font-size:13px;cursor:pointer;font-weight:600">Upload &amp; verify</button>
        <div class="cpe-extra" style="display:none;width:100%;margin-top:6px">
          <div style="display:grid;grid-template-columns:2fr 1fr 1fr;gap:8px">
            <input name="title" placeholder="auto-fills from cert" style="padding:8px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px" />
            <input name="training_date" type="date" style="padding:8px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px" />
            <input name="hours" type="number" step="0.5" min="0.5" placeholder="auto" style="padding:8px;border:1.5px solid #E2E8F0;border-radius:8px;font-size:13px" />
          </div>
          <input name="provider" placeholder="Provider (optional)" style="display:none" />
          <input name="payment_slip" type="file" style="display:none" />
        </div>
      </form>

      <h3 style="margin:14px 0 8px 0;color:#0B2545;font-size:14px">Certificates on file (${certs.length})</h3>
      ${certs.length ? `
        <table style="width:100%;border-collapse:collapse;font-size:12px">
          <thead style="background:#F8FAFC"><tr>
            <th style="text-align:left;padding:8px;color:#475569">Title</th>
            <th style="text-align:left;padding:8px;color:#475569">Training date</th>
            <th style="text-align:left;padding:8px;color:#475569">Renewal yr</th>
            <th style="text-align:left;padding:8px;color:#475569">Hours</th>
            <th style="text-align:left;padding:8px;color:#475569">Status</th>
            <th style="text-align:right;padding:8px;color:#475569"></th>
          </tr></thead>
          <tbody>
            ${certs.map(c => {
              const aiBadge = c.ai_match_status === "match" ? '<span style="background:#D1FAE5;color:#065F46;padding:1px 6px;border-radius:4px;font-size:10px;font-weight:600">AI ✓</span>'
                            : c.ai_match_status === "mismatch" ? '<span style="background:#FEE2E2;color:#991B1B;padding:1px 6px;border-radius:4px;font-size:10px;font-weight:600">AI ✗</span>'
                            : c.ai_match_status === "partial" ? '<span style="background:#FEF3C7;color:#92400E;padding:1px 6px;border-radius:4px;font-size:10px;font-weight:600">AI ?</span>'
                            : "";
              const aiTooltip = (c.ai_extracted_attendee||c.ai_extracted_title||c.ai_notes)
                ? `\nAttendee: ${c.ai_extracted_attendee||"—"}\nTitle: ${c.ai_extracted_title||"—"}\nDate: ${c.ai_extracted_date||"—"}\nHours: ${c.ai_extracted_hours||"—"}\nConfidence: ${c.ai_confidence||"—"}\n${c.ai_notes?"Notes: "+c.ai_notes:""}`
                : "";
              return `<tr style="border-top:1px solid #F1F5F9">
              <td style="padding:8px">${(c.title||"").replace(/</g,"&lt;")} <span title="AI extraction${aiTooltip.replace(/"/g,'&quot;')}">${aiBadge}</span></td>
              <td style="padding:8px">${_fmtDate(c.training_date)}</td>
              <td style="padding:8px;color:#475569">${c.anniversary_end ? new Date(c.anniversary_end).getFullYear() : '—'}</td>
              <td style="padding:8px">${c.hours}</td>
              <td style="padding:8px">${c.verified
                ? '<span style="color:#059669;font-weight:600">✓ counted</span>'
                : (c.in_window
                    ? '<span style="color:#92400E" title="'+(c.rejection_reason||'awaiting verification')+'">⏳ pending</span>'
                    : '<span style="color:#DC2626" title="'+(c.rejection_reason||'outside anniversary window')+'">✗ not counted</span>')}</td>
              <td style="padding:8px;text-align:right;white-space:nowrap">
                <button onclick="_cpeCertView(${c.id})" style="background:#fff;border:1.5px solid #0B2545;color:#0B2545;padding:4px 9px;border-radius:6px;font-size:11px;cursor:pointer;margin-right:4px" title="View / download the certificate file">📄 View</button>
                ${c.verified ? `<button onclick="_cpeCertReject(${c.id})" style="background:#fff;border:1.5px solid #FCA5A5;color:#991B1B;padding:4px 9px;border-radius:6px;font-size:11px;cursor:pointer">Reject</button>` :
                              `<button onclick="_cpeCertVerify(${c.id})" style="background:#10B981;color:#fff;border:0;padding:4px 9px;border-radius:6px;font-size:11px;cursor:pointer">Verify</button>`}
              </td>
            </tr>`;}).join("")}
          </tbody>
        </table>` : `<div style="background:#F8FAFC;padding:14px;text-align:center;color:#64748B;border-radius:8px;font-size:12px">No certificates uploaded yet.</div>`}

      <details style="margin-top:16px" ontoggle="if(this.open)_loadComplianceHistory('${r.id}')">
        <summary style="cursor:pointer;font-size:12.5px;font-weight:700;color:#64748B;user-select:none;list-style:none">▸ More — history &amp; admin actions</summary>
        <div style="margin-top:10px;display:flex;gap:8px;flex-wrap:wrap;align-items:center">
          ${rec.id ? (rec.status==="Verified"
            ? `<button onclick="_cpeYearUnverify(${rec.id})" style="background:#fff;border:1.5px solid #FCA5A5;color:#991B1B;padding:5px 12px;border-radius:7px;font-size:11.5px;cursor:pointer">Un-verify year</button>`
            : `<button onclick="_cpeYearVerify(${rec.id})" style="background:#fff;border:1.5px solid #10B981;color:#059669;padding:5px 12px;border-radius:7px;font-size:11.5px;cursor:pointer;font-weight:600">Mark year Verified</button>`) : ``}
          ${(!isExcommRep && rec.payment_slip_url) ? `<button onclick="_cpeViewSlip(${rec.id})" style="background:#fff;border:1.5px solid #0B2545;color:#0B2545;padding:5px 12px;border-radius:7px;font-size:11.5px;cursor:pointer">🧾 View slip</button>` : ``}
          ${(!isExcommRep) ? `<span style="font-size:11px;color:#94A3B8">CMSRL shows Paid only after finance confirms receipt (via their email link).</span>` : ``}
          <span style="font-size:11.5px;color:#94A3B8">${escapeHtml(r.email)} ${r.phone?"· "+escapeHtml(r.phone):""}</span>
        </div>
        <div id="cpe-history-${r.id}" style="background:#F8FAFC;padding:10px;border-radius:8px;font-size:12px;color:#64748B;max-height:220px;overflow:auto;margin-top:10px">Loading…</div>
      </details>
    </div>`;
  document.body.appendChild(modal);
}

async function _loadComplianceHistory(adviserId) {
  const container = document.getElementById("cpe-history-" + adviserId);
  if (!container) return;
  try {
    const r = await apiGet(`/api/cpe/reminders/${adviserId}`);
    if (r.error) throw new Error(r.error);
    const reminders = (r.reminders || []).map(e => ({...e, kind:"reminder"}));
    const audit     = (r.audit || []).map(e => ({...e, kind:"audit"}));
    const merged = [...reminders, ...audit].sort((a,b) => (b.event_at||"").localeCompare(a.event_at||""));
    if (!merged.length) { container.innerHTML = `<div style="text-align:center;padding:8px">No history yet.</div>`; return; }
    container.innerHTML = `
      <div style="display:grid;grid-template-columns:140px 110px 1fr 60px;gap:6px;font-weight:700;color:#475569;padding-bottom:6px;border-bottom:1px solid #E2E8F0;font-size:11px;text-transform:uppercase;letter-spacing:.4px">
        <div>When</div><div>Channel/Stage</div><div>Detail</div><div style="text-align:right">Status</div>
      </div>
      ${merged.map(e => {
        const when = _fmtHistDate(e.event_at);
        const channel = e.kind==="reminder"
          ? `<b>${(e.stage||"").replace(/</g,"&lt;")}</b> · ${(e.channel||"").replace(/</g,"&lt;")}`
          : `<i>${(e.action||"event").replace(/</g,"&lt;")}</i>`;
        let detail = "", status = "";
        try { const d = e.detail ? (typeof e.detail==="string"?JSON.parse(e.detail):e.detail) : null;
          if (d) {
            const parts = [];
            if (d.to) parts.push(`to: ${String(d.to).replace(/</g,"&lt;")}`);
            if (d.stage) parts.push(`stage: ${d.stage}`);
            if (d.days_overdue!=null) parts.push(`${d.days_overdue}d overdue`);
            if (d.error) parts.push(`<span style="color:#DC2626">err: ${String(d.error).replace(/</g,"&lt;").slice(0,80)}</span>`);
            if (d.reason) parts.push(`reason: ${String(d.reason).replace(/</g,"&lt;").slice(0,80)}`);
            if (d.filename) parts.push(`file: ${String(d.filename).replace(/</g,"&lt;")}`);
            detail = parts.join(" · ");
          }
        } catch {}
        if (e.kind === "reminder") status = e.ok ? '<span style="color:#059669;font-weight:600">✓ sent</span>' : '<span style="color:#DC2626;font-weight:600">✗ fail</span>';
        return `<div style="display:grid;grid-template-columns:140px 110px 1fr 60px;gap:6px;padding:6px 0;border-bottom:1px solid #F1F5F9;font-size:11px;color:#475569">
          <div>${when}</div>
          <div>${channel}</div>
          <div>${detail}</div>
          <div style="text-align:right">${status}</div>
        </div>`;
      }).join("")}`;
  } catch (e) {
    container.innerHTML = `<div style="color:#DC2626">Failed to load: ${e.message}</div>`;
  }
}

function _fmtHistDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso.includes("T") ? iso : iso.replace(" ","T") + "Z");
    return d.toLocaleString("en-GB", {day:"2-digit",month:"short",hour:"2-digit",minute:"2-digit",hour12:false});
  } catch { return iso; }
}

async function _cpeUpload(adviserId, form) {
  const fd = new FormData(form);
  // No manual entry required — just attach the cert; the server reads title/date/hours
  // off it with Claude if they're blank.
  const _f = fd.get("file");
  if (!_f || !_f.size) return showToast("error","Attach a certificate file first");
  const headers = {};
  if (SESSION_TOKEN) headers["Authorization"] = "Bearer " + SESSION_TOKEN;
  showToast("info","Uploading & running AI verification…");
  try {
    const r = await fetch(API + `/api/cpe/${adviserId}/cert`, {method:"POST", headers, body: fd});
    const data = await r.json();
    if (!r.ok || data.error) throw new Error(data.error||"Upload failed");
    const ai = data.ai;
    let msg;
    if (ai && ai.auto_verified) msg = "Cert uploaded & AI auto-verified ✓";
    else if (ai && ai.match_status === "mismatch") msg = "Cert uploaded but AI flagged mismatches — review in detail panel";
    else if (ai && ai.match_status === "partial") msg = "Cert uploaded — AI partial match, please review";
    else if (ai && ai.error) msg = "Cert uploaded (AI verify error: "+ai.error+")";
    else if (!data.in_window) msg = "Cert saved but date OUTSIDE anniversary window — won't count toward 20 hours";
    else msg = "Certificate uploaded. Pending verification.";
    showToast(ai && ai.auto_verified ? "success" : (ai && (ai.match_status==="mismatch"||ai.error)) ? "error" : "warn", msg);
    document.querySelector('div[style*="position:fixed"][style*="rgba(11,37,69"]')?.remove();
    // Reload fresh data, then REOPEN this adviser's detail so the new cert + updated
    // hours are immediately visible — no hunting through the table to confirm it saved.
    await renderCompliance();
    setTimeout(()=>{ try{ _complianceOpenDetail(adviserId); }catch(e){} }, 250);
  } catch (e) { showToast("error", e.message); }
}

async function _cpeExtract(adviserId, form) {
  const fileInput = form.querySelector('input[name="file"]');
  if (!fileInput.files.length) return showToast("error","Attach a cert file first");
  const fd = new FormData();
  fd.append("file", fileInput.files[0]);
  fd.append("adviser_id", adviserId);
  const headers = {};
  if (SESSION_TOKEN) headers["Authorization"] = "Bearer " + SESSION_TOKEN;
  showToast("info","Asking Claude to read the certificate…");
  try {
    const r = await fetch(API + "/api/cpe/extract", {method:"POST", headers, body: fd});
    const data = await r.json();
    if (!r.ok || data.error) throw new Error(data.error||"Extract failed");
    const ai = data.extraction || {};
    if (ai.error) throw new Error(ai.error);
    if (ai.title)     form.querySelector('input[name="title"]').value = ai.title;
    if (ai.date)      form.querySelector('input[name="training_date"]').value = ai.date;
    if (ai.hours)     form.querySelector('input[name="hours"]').value = ai.hours;
    if (ai.provider)  form.querySelector('input[name="provider"]').value = ai.provider;

    const hoursInput = form.querySelector('input[name="hours"]');
    const hoursMissing = !(ai.hours > 0);
    if (hoursMissing) {
      hoursInput.style.border = "2px solid #F59E0B";
      hoursInput.style.background = "#FFFBEB";
      hoursInput.placeholder = "⚠️ Enter hours manually";
      hoursInput.focus();
    }

    const bgColor = ai.match_status === "match" ? "#F0FDF4"
                  : ai.match_status === "mismatch" ? "#FEF2F2"
                  : "#FFFBEB";
    const borderColor = ai.match_status === "match" ? "#10B981"
                      : ai.match_status === "mismatch" ? "#DC2626"
                      : "#F59E0B";
    const hoursBanner = hoursMissing
      ? `<div style="background:#FEF3C7;border:1px solid #F59E0B;border-radius:6px;padding:8px;margin-top:6px;font-size:12px;color:#92400E"><b>⚠️ CPE hours not stated on this cert.</b> Please enter hours manually. Common values: FPAM CFP modules ≈ 20h, IBFIM ≈ 8h, FAME ≈ 4–8h.</div>`
      : "";
    const summary =
      `<div style="background:${bgColor};border:1px solid ${borderColor};border-radius:8px;padding:10px;margin-top:10px;font-size:12px">
        <b>AI extraction (Claude):</b>
        <div>Title: <b>${(ai.title||"—").replace(/</g,"&lt;")}</b></div>
        <div>Attendee: <b>${(ai.attendee||"—").replace(/</g,"&lt;")}</b></div>
        <div>Date: <b>${(ai.date||"—")}</b></div>
        <div>Hours: <b>${ai.hours!=null?ai.hours:"<i>not found</i>"}</b></div>
        <div>Provider: <b>${(ai.provider||"—").replace(/</g,"&lt;")}</b></div>
        <div>Confidence: <b>${ai.confidence||"—"}</b> · Match: <b>${ai.match_status||"—"}</b></div>
        ${(ai.checks||[]).map(c=>`<div>${c.ok?"✅":"⚠️"} ${c.field}: ${JSON.stringify(c.got)}${c.window?" (window "+c.window+")":""}${c.expected?" (expected "+c.expected+")":""}</div>`).join("")}
        ${ai.notes?'<div style="color:#475569;margin-top:4px">Notes: '+String(ai.notes).replace(/</g,"&lt;")+"</div>":""}
        ${hoursBanner}
      </div>`;
    let panel = form.querySelector("#ai-extract-panel");
    if (!panel) { panel = document.createElement("div"); panel.id="ai-extract-panel"; form.appendChild(panel); }
    panel.innerHTML = summary;
  } catch (e) { showToast("error", e.message); }
}

async function _cpeViewSlip(recId) {
  try {
    showToast("info","Opening transfer slip…");
    const r = await fetch(API + `/api/cpe/record/${recId}/slip`, { headers: _apiHeaders() });
    if (r.status === 404) { showToast("warn","No transfer slip uploaded yet for this renewal."); return; }
    if (!r.ok) { const e = await r.json().catch(()=>({})); throw new Error(e.error || ("HTTP "+r.status)); }
    const blob = await r.blob(); const url = URL.createObjectURL(blob);
    window.open(url, "_blank"); setTimeout(()=>URL.revokeObjectURL(url), 60000);
  } catch (e) { showToast("error", e.message); }
}
async function _cpeCertView(certId) {
  try {
    showToast("info","Opening certificate…");
    const r = await fetch(API + `/api/cpe/cert/${certId}/file`, { headers: _apiHeaders() });
    if (r.status === 404) { showToast("warn","Certificate file not found (may not have been uploaded)."); return; }
    if (!r.ok) { const e = await r.json().catch(()=>({})); throw new Error(e.error || ("HTTP "+r.status)); }
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
    setTimeout(()=>URL.revokeObjectURL(url), 60000);
  } catch (e) { showToast("error", e.message); }
}
async function _cpeCertVerify(certId) {
  try { const r = await apiPost(`/api/cpe/cert/${certId}/verify`, {}); if (r.error) throw new Error(r.error);
    showToast("success","Certificate verified"); document.querySelector('div[style*="position:fixed"][style*="rgba(11,37,69"]')?.remove(); renderCompliance();
  } catch (e) { showToast("error", e.message); }
}
async function _cpeCertReject(certId) {
  const reason = prompt("Reason for rejection?"); if (reason===null) return;
  try { const r = await apiPost(`/api/cpe/cert/${certId}/reject`, {reason}); if (r.error) throw new Error(r.error);
    showToast("success","Certificate rejected"); document.querySelector('div[style*="position:fixed"][style*="rgba(11,37,69"]')?.remove(); renderCompliance();
  } catch (e) { showToast("error", e.message); }
}
async function _cpeCertAiVerify(certId) {
  showToast("info","Re-running Claude on this certificate…");
  try {
    const r = await apiPost(`/api/cpe/cert/${certId}/ai-verify`, {});
    if (r.error) throw new Error(r.error);
    const ai = r.ai || {};
    showToast(ai.auto_verified?"success":((ai.match_status==="mismatch"||ai.error)?"error":"warn"),
      ai.error ? "AI error: "+ai.error :
      ai.auto_verified ? "AI auto-verified ✓" :
      "AI result: "+(ai.match_status||"unknown")+" (confidence: "+(ai.confidence||"—")+")");
    document.querySelector('div[style*="position:fixed"][style*="rgba(11,37,69"]')?.remove();
    renderCompliance();
  } catch (e) { showToast("error", e.message); }
}

async function _cpeYearVerify(recordId) {
  const note = prompt("Add an optional note (or leave blank):");
  if (note === null) return;
  if (!confirm("Mark this anniversary year as Verified? The focus will advance to the next year.")) return;
  try {
    const r = await apiPost(`/api/cpe/record/${recordId}/verify`, {note});
    if (r.error) throw new Error(r.error);
    showToast("success","Year verified — focus advanced");
    document.querySelector('div[style*="position:fixed"][style*="rgba(11,37,69"]')?.remove();
    renderCompliance();
  } catch (e) { showToast("error", e.message); }
}

async function _cpeYearUnverify(recordId) {
  if (!confirm("Un-verify this year? It'll come back into focus.")) return;
  try {
    const r = await apiPost(`/api/cpe/record/${recordId}/unverify`, {});
    if (r.error) throw new Error(r.error);
    showToast("success","Un-verified");
    document.querySelector('div[style*="position:fixed"][style*="rgba(11,37,69"]')?.remove();
    renderCompliance();
  } catch (e) { showToast("error", e.message); }
}

async function _cpeMarkPayment(recordId) {
  if (!recordId) return;
  try { const r = await apiPost(`/api/cpe/record/${recordId}/payment`, {status:"Confirmed", amount:500}); if (r.error) throw new Error(r.error);
    showToast("success","Payment recorded"); document.querySelector('div[style*="position:fixed"][style*="rgba(11,37,69"]')?.remove(); renderCompliance();
  } catch (e) { showToast("error", e.message); }
}


// ── Contract Signing Roster ───────────────────────────────────────────────────
async function renderSigningRoster(){
  document.getElementById('main-content').innerHTML='<div style="padding:28px 32px"><h2 style="margin:0 0 4px;color:#0B2545">Contract Signing</h2><p style="margin:0 0 20px;font-size:13px;color:#64748B">Adviser agreement and code of ethics — signing status.</p><div id="sr-body">Loading…</div></div>';
  try{
    var r=await apiGet('/api/onboarding');
    if(!r||r.error) throw new Error((r&&r.error)||'failed');
    var byAdv={};
    (r.rows||[]).forEach(function(row){ if(!byAdv[row.adviser_id]) byAdv[row.adviser_id]={}; byAdv[row.adviser_id][row.item]=row; });
    var ITEMS=['agreement','code_of_ethics'];
    var LABELS={agreement:'Appointment Agreement',code_of_ethics:'Code of Ethics'};
    function cell(d,ver){
      if(!d) return '<td style="padding:10px 12px;font-size:12px;color:#94A3B8">—</td>';
      var cur=d.doc_version===ver;
      return '<td style="padding:10px 12px;font-size:12px;color:'+(cur?'#15803D':'#B45309')+';white-space:nowrap">'+(cur?'✓':'↻')+' '+(d.signed_at||'').slice(0,10)+'</td>';
    }
    var ids=Object.keys(ADVISERS).filter(function(id){ return !ADVISERS[id].terminated; }).sort(function(a,b){ return (ADVISERS[a].name||'').localeCompare(ADVISERS[b].name||''); });
    var head='<tr style="background:#F8FAFC"><th style="padding:10px 12px;text-align:left;font-size:11px;font-weight:700;color:#64748B;text-transform:uppercase;letter-spacing:.4px;border-bottom:1px solid #E2E8F0">Adviser</th>'
      +ITEMS.map(function(k){ return '<th style="padding:10px 12px;text-align:left;font-size:11px;font-weight:700;color:#64748B;text-transform:uppercase;letter-spacing:.4px;border-bottom:1px solid #E2E8F0">'+LABELS[k]+'</th>'; }).join('')+'</tr>';
    var body=ids.map(function(id){
      var adv=ADVISERS[id], d=byAdv[id]||{};
      return '<tr style="border-bottom:1px solid #F1F5F9"><td style="padding:10px 12px;font-size:13px;font-weight:600;color:#0B2545">'+_amlEsc(adv.name||id)+'</td>'+ITEMS.map(function(k){ return cell(d[k],r.version); }).join('')+'</tr>';
    }).join('');
    document.getElementById('sr-body').innerHTML='<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden"><table style="width:100%;border-collapse:collapse">'+head+body+'</table></div>'
      +'<p style="font-size:11px;color:#94A3B8;margin-top:8px">✓ signed current version ('+_amlEsc(r.version||'')+')&nbsp;·&nbsp;↻ signed older version — re-sign needed&nbsp;·&nbsp;— not signed</p>';
  }catch(e){ document.getElementById('sr-body').innerHTML='<div style="color:#DC2626;font-size:13px">'+_amlEsc(e.message)+'</div>'; }
}

// ═══════════════════════════════════════════════════════════════════════════
// INVOICING & RECEIPTS UI (financial planning fees / will-writing)
// Restricted: admin grants access + tier; entitled advisers create plans → invoices.
// ═══════════════════════════════════════════════════════════════════════════
var _invState = { tab: "invoices", invoices: [], kyc: [], access: [], cfg: null, packages: null, draft: [] };

function _invCanUse(){ return isAdmin || isChecker || ((ADVISERS[currentUser]||{}).canInvoice); }
function _rm(n){ return "RM " + (Math.round((Number(n)||0)*100)/100).toLocaleString('en-MY',{minimumFractionDigits:2,maximumFractionDigits:2}); }

async function renderInvoicing(){
  var mc = document.getElementById("main-content");
  mc.innerHTML = '<div class="fade-in" style="padding:28px 32px;max-width:1040px"><div style="color:#6B7280">Loading…</div></div>';
  try{
    var calls = [apiGet("/api/invoices"), apiGet("/api/invoice/config").catch(function(){return null;})];
    var r = await Promise.all(calls);
    _invState.invoices = Array.isArray(r[0]) ? r[0] : [];
    _invState.cfg = r[1] && !r[1].error ? r[1] : null;
    _invState.packages = _invState.cfg ? _invState.cfg.packages : null;
  }catch(e){}
  _invRender();
}

function _invRender(){
  var admin = isAdmin || isChecker;
  var tabs = [["invoices","🧾 Invoices"]];
  if(admin){ tabs.push(["access","🔑 Access"]); tabs.push(["settings","⚙️ Settings"]); }
  var tabBar = tabs.map(function(t){
    var on = _invState.tab===t[0];
    return '<button onclick="_invTab(\''+t[0]+'\')" style="appearance:none;border:none;background:none;padding:10px 16px;font-weight:600;font-size:14px;cursor:pointer;color:'+(on?'#0B2545':'#64748b')+';border-bottom:2px solid '+(on?'#0B2545':'transparent')+';margin-bottom:-2px">'+t[1]+'</button>';
  }).join("");
  var body = _invState.tab==="access" ? _invAccessHTML() : _invState.tab==="settings" ? _invSettingsHTML() : _invInvoicesHTML();
  document.getElementById("main-content").innerHTML =
    '<div class="fade-in" style="padding:28px 32px;max-width:1040px">'
    + '<h1 style="font-size:22px;color:#0B2545;margin-bottom:2px">Invoicing &amp; Receipts</h1>'
    + '<div style="color:#6B7280;font-size:13px;margin-bottom:16px">Will-writing plans — financial planning fees. <span title="Issued by LIFA Planners Sdn Bhd [201501010372 (1135707-K)]" style="cursor:help">&#8505;&#65039;</span></div>'
    + '<div style="display:flex;gap:2px;border-bottom:2px solid #E2E8F0;margin-bottom:20px">'+tabBar+'</div>'
    + (_invState.tab==="invoices" ? '<div id="parked-credits"></div>' : '')
    + body + '</div>';
  if(_invState.tab==="access" && !_invState.access.length) _invLoadAccess();
  if(admin && _invState.tab==="invoices") _pcLoad();
}
function _invTab(t){ _invState.tab=t; _invRender(); }

// ── Parked credits — money received that no invoice could absorb ───────────
// Shown at the TOP of Invoices because it is money sitting in the account with
// nowhere to go: quiet when there is none, unmissable when there is. Nothing
// here moves money — resolving a row records what was decided, so the list can
// be cleared honestly rather than by forgetting about it.
async function _pcLoad(){
  var box=document.getElementById('parked-credits'); if(!box) return;
  var d; try{ d=await apiGet('/api/invoices/parked'); }catch(e){ return; }
  if(!d || d.error || !d.parked || !d.parked.length){ box.innerHTML=''; return; }
  window._pcData=d;
  var rm=function(n){ return 'RM '+Number(n||0).toLocaleString('en-MY',{minimumFractionDigits:2,maximumFractionDigits:2}); };
  var esc=function(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); };
  box.innerHTML='<div style="background:#FFFBEB;border:1px solid #FCD34D;border-radius:12px;padding:16px;margin-bottom:20px">'
    +'<div style="display:flex;justify-content:space-between;align-items:baseline;gap:10px;flex-wrap:wrap">'
      +'<div style="font-weight:700;color:#92400E">&#9888; '+rm(d.total)+' received with nowhere to go <span title="More was paid than the invoice asked for. The invoice was settled correctly and the extra is held here — it has not been applied anywhere." style="cursor:help;font-weight:400">&#8505;&#65039;</span></div>'
      +'<div style="color:#B45309;font-size:12px">'+d.parked.length+' item'+(d.parked.length===1?'':'s')+'</div></div>'
    +d.parked.map(function(p,i){
      return '<div style="background:#fff;border-radius:8px;padding:10px 12px;margin-top:8px">'
        +'<div style="display:flex;justify-content:space-between;gap:10px;flex-wrap:wrap">'
          +'<div><b style="color:#0B2545">'+rm(p.amount)+'</b> <span style="color:#6B7280;font-size:12px">over '+esc(p.invoice_number||'')+' &middot; '+esc(p.client_name||'')+'</span></div>'
          +'<button onclick="_pcResolve('+i+')" style="background:none;border:0;color:#1D4ED8;font-size:12px;text-decoration:underline;cursor:pointer;padding:0">record what was done</button></div>'
        +'<div style="color:#6B7280;font-size:12px;margin-top:2px">From '+esc(p.payer||'—')+(p.paid_on?' on '+esc(p.paid_on):'')+' &middot; '+esc(p.method||'')+'</div></div>';
    }).join('')+'</div>';
}
async function _pcResolve(i){
  var p=((window._pcData||{}).parked||[])[i]; if(!p) return;
  var note=prompt('What was done with this RM '+Number(p.amount).toFixed(2)+'?\n\nFor example: refunded to the client on 20 Aug, or applied to LIFA-INV-2026-0012.\n\nThis records the decision — it does not move any money.');
  if(note===null) return;
  if(String(note).trim().length<3){ showToast('error','Say what was done with this money.'); return; }
  var r=await apiPost('/api/invoices/parked/'+p.id+'/resolve',{note:String(note).trim()});
  if(r && r.error){ showToast('error',r.error); return; }
  showToast('success','Recorded.');
  _pcLoad();
}

// ── Invoices tab ──
function _invInvoicesHTML(){
  if(!_invCanUse()){
    return '<div style="background:#FFF7ED;border:1px solid #FED7AA;border-radius:10px;padding:20px 24px;color:#92400E">Invoicing is not enabled for your account. Ask an admin to switch it on under <b>Access</b>.</div>';
  }
  // 🧪 Practice invoices are HIDDEN by default — the whole point of the sandbox
  // is that fake clients stop cluttering the real list.
  var all=_invState.invoices||[];
  var nTest=all.filter(function(i){ return !!i.is_test; }).length;
  var shown=_invState.showTest ? all : all.filter(function(i){ return !i.is_test; });
  var rows = shown.map(function(i){
    var badge = i.status==="paid" ? '#15803D' : i.status==="part_paid" ? '#B45309' : '#64748b';
    return '<tr style="border-top:1px solid #EEF2F6'+(i.is_test?';background:#FFFBEB':'')+'">'
      + '<td style="padding:11px 12px;font-weight:600;color:#0B2545">'+escapeHtml(i.number)
        + (i.is_test?' <span style="background:#FDE68A;color:#92400E;font-size:10px;font-weight:800;padding:1px 6px;border-radius:5px;letter-spacing:.4px">TEST</span>':'')+'</td>'
      + '<td style="padding:11px 12px">'+escapeHtml(i.client_name||'')+'</td>'
      + '<td style="padding:11px 12px;color:#64748b">'+escapeHtml(i.planner_name||'')+'</td>'
      + '<td style="padding:11px 12px;text-align:right">'+_rm(i.total)+'</td>'
      + '<td style="padding:11px 12px;text-align:right;color:#64748b">'+_rm(i.balance)+'</td>'
      + '<td style="padding:11px 12px"><span style="font-size:11px;font-weight:700;color:'+badge+'">'+(i.status||'issued').replace('_',' ').toUpperCase()+'</span></td>'
      + '<td style="padding:11px 12px;text-align:right;white-space:nowrap">'
        + '<button onclick="_invView(\''+i.id+'\')" class="mini-btn">View</button> '
        // A test invoice is never sent — the button that would email a person
        // simply isn't there, rather than being there and refusing.
        + (i.is_test ? '' : '<button onclick="_invSend(\''+i.id+'\')" class="mini-btn">Send</button> ')
        + (i.status!=="paid" ? '<button onclick="_invPay(\''+i.id+'\','+ (i.balance||0) +')" class="mini-btn" style="background:#0B2545;color:#fff">Record payment</button> ' : '')
        // Practice can be thrown away; a real invoice never can.
        + (i.is_test && isAdmin ? '<button onclick="_invDeleteTest(\''+i.id+'\',\''+escapeHtml(i.number)+'\')" class="mini-btn" style="color:#B91C1C">Delete</button>' : '')
      + '</td></tr>';
  }).join("");
  var exportBtn = (isAdmin||isChecker) ? '<button onclick="_invExport()" class="mini-btn">⬇ Accountant CSV</button>' : '';
  var testToggle = nTest
    ? '<button onclick="_invToggleTest()" class="mini-btn" style="margin-right:8px">'
        + (_invState.showTest ? 'Hide' : 'Show')+' '+nTest+' test invoice'+(nTest===1?'':'s')+'</button>'
    : '';
  return '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px">'
    + '<button onclick="_invNew()" style="background:#0B2545;color:#fff;border:none;border-radius:9px;padding:11px 20px;font-weight:600;font-size:14px;cursor:pointer">+ New plan / invoice</button>'
    + '<div>' + testToggle + exportBtn + '</div></div>'
    + (rows ? '<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden"><table style="width:100%;border-collapse:collapse;font-size:13.5px"><thead><tr style="background:#F8FAFC"><th style="padding:10px 12px;text-align:left;font-size:11px;color:#64748b;text-transform:uppercase">Invoice</th><th style="padding:10px 12px;text-align:left;font-size:11px;color:#64748b;text-transform:uppercase">Client</th><th style="padding:10px 12px;text-align:left;font-size:11px;color:#64748b;text-transform:uppercase">Planner</th><th style="padding:10px 12px;text-align:right;font-size:11px;color:#64748b;text-transform:uppercase">Total</th><th style="padding:10px 12px;text-align:right;font-size:11px;color:#64748b;text-transform:uppercase">Balance</th><th style="padding:10px 12px;text-align:left;font-size:11px;color:#64748b;text-transform:uppercase">Status</th><th></th></tr></thead><tbody>'+rows+'</tbody></table></div>'
       : '<div style="background:#F8FAFC;border:1px dashed #CBD5E1;border-radius:12px;padding:30px;text-align:center;color:#64748b">No invoices yet. Click <b>+ New plan / invoice</b> to create one for a client who has completed KYC.</div>');
}

function _invToggleTest(){ _invState.showTest=!_invState.showTest; _invRender(); }
async function _invDeleteTest(id, number){
  if(!confirm('Delete test invoice '+number+'?\n\nThis is practice data — it is removed permanently. Real invoices can never be deleted.')) return;
  var r=await apiDelete('/api/invoices/'+id);
  if(r && r.error){ showToast('error', r.error); return; }
  _invState.invoices=(_invState.invoices||[]).filter(function(x){ return x.id!==id; });
  _invRender();
  showToast('success', number+' deleted.');
}

// ── Create plan / invoice ──
async function _invNew(){
  var mc = document.getElementById("main-content");
  mc.querySelector('.fade-in').insertAdjacentHTML('afterbegin','<div id="inv-loading" style="color:#6B7280;margin-bottom:10px">Loading clients…</div>');
  try{ var cases = await apiGet("/api/kyc/cases"); _invState.kyc = (Array.isArray(cases)?cases:[]).filter(function(c){return ["submitted","verified"].includes(c.status);}); }catch(e){ _invState.kyc=[]; }
  _invState.draft = [];
  _invNewRender();
}
function _invNewRender(){
  var opts = _invState.kyc.map(function(c){ return '<option value="'+c.id+'">'+escapeHtml(c.client_name||c.id)+' ('+c.id+')</option>'; }).join("");
  var pk = _invState.packages || {simple:{label:"Simple Will Package",fee:800,kind:"will"},comprehensive:{label:"Comprehensive Will Package",fee:1500,kind:"will"},platinum:{label:"Platinum Package",fee:3000,kind:"will",desc:"Up to 50 clauses, incl. 1 free rewrite (valid 2 years)"},custodian:{label:"Will Custodian Service",fee:1000,kind:"custodian"}};
  var pkRows = Object.keys(pk).map(function(k){
    var p=pk[k];
    return '<label style="display:flex;align-items:center;gap:10px;padding:11px 14px;border:1px solid #E2E8F0;border-radius:9px;margin-bottom:8px;cursor:pointer">'
      + '<input type="checkbox" class="inv-pk" value="'+k+'" data-kind="'+p.kind+'" onchange="_invCalc()" style="width:17px;height:17px">'
      + '<div style="flex:1"><div style="font-weight:600;color:#0B2545">'+escapeHtml(p.label)+'</div>'+(p.desc?'<div style="font-size:11.5px;color:#64748b">'+escapeHtml(p.desc)+'</div>':'')+'</div>'
      + '<div style="font-weight:700;color:#0B2545">'+_rm(p.fee)+'</div>'
      + '<input type="text" class="inv-person" data-pk="'+k+'" placeholder="for (name)" style="width:130px;padding:6px 8px;border:1px solid #E2E8F0;border-radius:7px;font-size:12px">'
      + '</label>';
  }).join("");
  document.getElementById("main-content").innerHTML =
    '<div class="fade-in" style="padding:28px 32px;max-width:720px">'
    + '<button onclick="showView(\'invoicing\')" style="background:none;border:none;color:#64748b;cursor:pointer;font-size:13px;margin-bottom:12px">← Back to invoices</button>'
    + '<h1 style="font-size:21px;color:#0B2545;margin-bottom:16px">New plan / invoice</h1>'
    + (opts ? '' : '<div style="background:#FFF7ED;border:1px solid #FED7AA;border-radius:10px;padding:14px 18px;color:#92400E;margin-bottom:16px">No clients with a completed KYC yet. A client must finish their KYC before you can invoice them.</div>')
    + '<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;padding:22px 24px">'
    // 🧪 THE SANDBOX QUESTION — asked FIRST, and nothing is pre-selected.
    // Both silent defaults are harmful: real lets practice into the books, test
    // silently drops a genuine invoice out of the accounts. So the adviser
    // chooses, or the Create button refuses.
    + '<label style="font-size:12px;font-weight:700;color:#0B2545;text-transform:uppercase;letter-spacing:.5px">Who is this for?</label>'
    + '<div id="inv-mode" style="display:flex;gap:10px;margin:8px 0 18px;flex-wrap:wrap">'
      + '<label style="flex:1;min-width:220px;display:flex;gap:10px;align-items:flex-start;border:1.5px solid #E2E8F0;border-radius:10px;padding:12px 14px;cursor:pointer" onclick="_invMode(this,0)">'
        + '<input type="radio" name="inv-real" value="0" style="margin-top:2px;width:17px;height:17px">'
        + '<span><b style="color:#0B2545">A real client</b><br><span style="color:#64748b;font-size:12.5px">The invoice is sent and recorded.</span></span></label>'
      + '<label style="flex:1;min-width:220px;display:flex;gap:10px;align-items:flex-start;border:1.5px solid #E2E8F0;border-radius:10px;padding:12px 14px;cursor:pointer" onclick="_invMode(this,1)">'
        + '<input type="radio" name="inv-real" value="1" style="margin-top:2px;width:17px;height:17px">'
        + '<span><b style="color:#92400E">Practice / testing</b><br><span style="color:#64748b;font-size:12.5px">Nothing is sent. No commission, not in the accounts.</span></span></label>'
    + '</div>'
    + '<label style="font-size:12px;font-weight:700;color:#0B2545;text-transform:uppercase;letter-spacing:.5px">Client (KYC complete)</label>'
    + '<select id="inv-client" style="width:100%;padding:11px;border:1px solid #E2E8F0;border-radius:9px;margin:6px 0 18px;font-size:14px"><option value="">— select a client —</option>'+opts+'</select>'
    + '<label style="font-size:12px;font-weight:700;color:#0B2545;text-transform:uppercase;letter-spacing:.5px">Packages</label>'
    + '<div style="margin:8px 0 6px">'+pkRows+'</div>'
    + '<label style="display:flex;align-items:center;gap:10px;padding:10px 0;cursor:pointer"><input type="checkbox" id="inv-bundle" onchange="_invCalc()" style="width:17px;height:17px"><span style="font-weight:600;color:#0B2545">Husband &amp; wife bundle — 15% off the will fee</span></label>'
    + '<div id="inv-total" style="background:#F8FAFC;border-radius:9px;padding:14px 18px;margin-top:12px;font-size:14px;color:#64748b">Select packages to see the total.</div>'
    + '<div id="inv-create-alert"></div>'
    + '<button onclick="_invCreate()" id="inv-create-btn" style="background:#0B2545;color:#fff;border:none;border-radius:9px;padding:12px 24px;font-weight:600;font-size:14px;cursor:pointer;margin-top:16px">Create invoice</button>'
    + '</div></div>';
}
function _invSelected(){
  return [].slice.call(document.querySelectorAll('.inv-pk:checked')).map(function(el){
    var person = (document.querySelector('.inv-person[data-pk="'+el.value+'"]')||{}).value||'';
    return {package:el.value, kind:el.getAttribute('data-kind'), person:person};
  });
}
function _invCalc(){
  // Platinum includes lifetime custodian — disable the separate custodian option.
  var plat=[].slice.call(document.querySelectorAll('.inv-pk')).find(function(x){return x.value==='platinum';});
  var custBox=[].slice.call(document.querySelectorAll('.inv-pk')).find(function(x){return x.value==='custodian';});
  if(plat&&custBox){ var lbl=custBox.closest('label'); if(plat.checked){ custBox.checked=false; custBox.disabled=true; if(lbl){lbl.style.opacity=.5; var t=lbl.querySelector('.cust-incl'); if(!t){ t=document.createElement('span'); t.className='cust-incl'; t.style.cssText='font-size:11px;color:#15803D;font-weight:600'; t.textContent=' ✓ included in Platinum'; custBox.parentNode.querySelector('div').appendChild(t);} } } else { custBox.disabled=false; if(lbl){lbl.style.opacity=1; var t2=lbl.querySelector('.cust-incl'); if(t2)t2.remove();} } }
  var pk=_invState.packages||{}; var sel=_invSelected();
  var willSub=0, custSub=0;
  sel.forEach(function(s){ var f=(pk[s.package]||{}).fee||0; if(s.kind==='custodian') custSub+=f; else willSub+=f; });
  var bundle=document.getElementById('inv-bundle') && document.getElementById('inv-bundle').checked;
  var willItems=sel.filter(function(s){return s.kind==='will';}).length;
  var disc = (bundle && willItems>=2) ? Math.round(willSub*0.15*100)/100 : 0;
  var net = willSub - disc + custSub;
  var deposit = Math.round(net*0.5*100)/100;
  var el=document.getElementById('inv-total'); if(!el) return;
  el.innerHTML = '<div style="display:flex;justify-content:space-between"><span>Subtotal</span><span>'+_rm(willSub+custSub)+'</span></div>'
    + (disc>0?'<div style="display:flex;justify-content:space-between;color:#15803D"><span>Spouse bundle (15%)</span><span>− '+_rm(disc)+'</span></div>':'')
    + '<div style="display:flex;justify-content:space-between;font-weight:700;color:#0B2545;border-top:1px solid #E2E8F0;margin-top:6px;padding-top:8px"><span>Total</span><span>'+_rm(net)+'</span></div>'
    + '<div style="display:flex;justify-content:space-between;color:#B45309;font-weight:700;margin-top:4px"><span>50% deposit now</span><span>'+_rm(deposit)+'</span></div>';
}
// Highlights the chosen card so the answer is visible without hunting for a
// filled radio — this is the one question on the screen that must not be
// answered by accident.
function _invMode(el, isTest){
  var box=document.getElementById('inv-mode'); if(!box) return;
  Array.prototype.forEach.call(box.querySelectorAll('label'), function(l){
    l.style.borderColor='#E2E8F0'; l.style.background='';
  });
  el.style.borderColor = isTest ? '#D97706' : '#0B2545';
  el.style.background  = isTest ? '#FFFBEB' : '#F8FAFC';
  var r=el.querySelector('input'); if(r) r.checked=true;
}
function _invModeValue(){
  var r=document.querySelector('#inv-mode input[name="inv-real"]:checked');
  return r ? r.value==='1' : null;   // null = not answered
}
async function _invCreate(){
  var client=document.getElementById('inv-client').value;
  var sel=_invSelected();
  var al=document.getElementById('inv-create-alert');
  var isTest=_invModeValue();
  if(isTest===null){ al.innerHTML='<div style="color:#DC2626;font-size:13px;margin-top:10px">Say whether this is for a real client or a test.</div>'; return; }
  if(!client){ al.innerHTML='<div style="color:#DC2626;font-size:13px;margin-top:10px">Please select a client.</div>'; return; }
  if(!sel.length){ al.innerHTML='<div style="color:#DC2626;font-size:13px;margin-top:10px">Please select at least one package.</div>'; return; }
  var btn=document.getElementById('inv-create-btn'); btn.disabled=true; btn.textContent='Creating…';
  try{
    var body={kyc_case_id:client, items:sel.map(function(s){return {package:s.package, person:s.person};}), spouse_bundle: document.getElementById('inv-bundle').checked, is_test:isTest};
    var r=await apiPost("/api/invoices", body);
    if(r.error){ throw new Error(r.error); }
    _invState.invoices.unshift(r); _invState.tab="invoices"; _invRender();
    _invView(r.id);
  }catch(e){ al.innerHTML='<div style="color:#DC2626;font-size:13px;margin-top:10px">'+escapeHtml(e.message)+'</div>'; btn.disabled=false; btn.textContent='Create invoice'; }
}

// ── invoice actions ──
async function _invOpenDoc(path){
  try{ var r=await fetch(API+path,{headers:_apiHeaders()}); var html=await r.text(); var b=new Blob([html],{type:'text/html'}); window.open(URL.createObjectURL(b),'_blank'); }catch(e){ alert('Could not open document.'); }
}
function _invView(id){ _invOpenDoc('/api/invoices/'+id+'/doc'); }
async function _invSend(id){
  if(!confirm('Email this invoice to the client (CC you)?')) return;
  var r=await apiPost('/api/invoices/'+id+'/send',{});
  alert(r.ok ? ('Sent to '+r.to+(r.cc?' (CC '+r.cc+')':'')) : ('Could not send: '+(r.error||'unknown')));
}
// Owner's rule: "dont type amount, just select invoice outstanding and confirmed
// paid with date and payor." The outstanding is already known from the invoice —
// the only facts that genuinely come from the bank are the DATE and the PAYER,
// so those are the only things typed. A part payment stays available (real case:
// LIFA-INV-2026-0008 sat at RM2,550 of RM5,100) but is the quiet second option.
async function _invPay(id, balance){
  var inv=null; try{ inv=_invState.invoices.find(function(x){return x.id===id;}); }catch(e){}
  var total=Number((inv&&inv.total)||balance||0);
  var paid=Number((inv&&inv.amount_paid)||0);
  var out=Math.round((Number(balance||(total-paid))||0)*100)/100;
  if(!(out>0)){ showToast('error','Nothing outstanding on this invoice.'); return; }
  var money=function(n){ return 'RM '+Number(n||0).toLocaleString('en-MY',{minimumFractionDigits:2,maximumFractionDigits:2}); };
  var today=new Date().toISOString().slice(0,10);
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(11,37,69,.45);z-index:9000;display:flex;align-items:center;justify-content:center;padding:20px;';
  ov.innerHTML='<div style="background:#fff;border-radius:14px;max-width:440px;width:100%;padding:22px;box-shadow:0 18px 50px rgba(11,37,69,.28)">'
    +'<div style="font-weight:700;font-size:17px;color:#0B2545">Record payment received</div>'
    +'<div style="color:#6B7280;font-size:13px;margin-top:2px">'+((inv&&inv.number)||'')+((inv&&inv.client_name)?' · '+inv.client_name:'')+'</div>'
    +'<div style="background:#F6F8FB;border-radius:10px;padding:14px;margin:14px 0">'
      +'<div style="display:flex;justify-content:space-between;font-size:13px;color:#6B7280"><span>Invoice total</span><span>'+money(total)+'</span></div>'
      +(paid>0?'<div style="display:flex;justify-content:space-between;font-size:13px;color:#6B7280;margin-top:4px"><span>Already received</span><span>'+money(paid)+'</span></div>':'')
      +'<div style="display:flex;justify-content:space-between;font-weight:700;color:#0B2545;margin-top:8px;padding-top:8px;border-top:1px solid #E3E8EF"><span>Outstanding</span><span>'+money(out)+'</span></div>'
    +'</div>'
    // The date is ASKED, never assumed. It is what the bank statement is matched
    // against when the client transfers offline, so pre-filling today meant it got
    // answered by pressing Confirm and nothing else ("I did not record the date and
    // payor just now, I just click confirm"). Empty by design — the handler below
    // will not let Confirm through until it is filled in. The payer field is
    // deliberately UNCHANGED: it stays pre-filled with the client as a starting
    // point, because someone else may have paid and that name is what the bank
    // narration shows.
    +'<label style="display:block;font-size:12px;font-weight:600;color:#374151;margin-bottom:4px">Date received</label>'
    +'<input id="_ipDate" type="date" value="" style="width:100%;padding:9px;border:1px solid #D1D5DB;border-radius:8px;font-size:14px">'
    +'<label style="display:block;font-size:12px;font-weight:600;color:#374151;margin:12px 0 4px">Received from</label>'
    +'<input id="_ipPayer" type="text" value="'+String((inv&&inv.client_name)||'').replace(/"/g,'&quot;')+'" placeholder="Who paid" style="width:100%;padding:9px;border:1px solid #D1D5DB;border-radius:8px;font-size:14px">'
    +'<label style="display:block;font-size:12px;font-weight:600;color:#374151;margin:12px 0 4px">How it was paid</label>'
    +'<select id="_ipMethod" style="width:100%;padding:9px;border:1px solid #D1D5DB;border-radius:8px;font-size:14px">'
      +'<option>Bank transfer</option><option>Online (Billplz)</option><option>Cheque</option><option>Cash</option></select>'
    +'<div id="_ipPartWrap" style="display:none;margin-top:12px">'
      +'<label style="display:block;font-size:12px;font-weight:600;color:#374151;margin-bottom:4px">Amount received (RM)</label>'
      +'<input id="_ipAmt" type="number" step="0.01" max="'+out+'" value="'+out+'" style="width:100%;padding:9px;border:1px solid #D1D5DB;border-radius:8px;font-size:14px">'
      +'<div style="font-size:12px;color:#6B7280;margin-top:4px">Cannot be more than the '+money(out)+' outstanding. The official receipt is issued once the invoice is fully settled.</div>'
    +'</div>'
    +'<button id="_ipGo" class="mini-btn" style="background:#0B2545;color:#fff;width:100%;margin-top:16px;padding:11px;font-size:15px;font-weight:600">Confirm '+money(out)+' received</button>'
    +'<div style="display:flex;justify-content:space-between;margin-top:10px">'
      +'<button id="_ipPart" style="background:none;border:none;color:#6B7280;font-size:13px;text-decoration:underline;cursor:pointer;padding:0">Only part of it was received</button>'
      +'<button id="_ipX" style="background:none;border:none;color:#6B7280;font-size:13px;cursor:pointer;padding:0">Cancel</button>'
    +'</div></div>';
  document.body.appendChild(ov);
  var close=function(){ try{ ov.remove(); }catch(e){} };
  ov.querySelector('#_ipX').onclick=close;
  ov.onclick=function(e){ if(e.target===ov) close(); };
  var partial=false;
  ov.querySelector('#_ipPart').onclick=function(){
    partial=true;
    ov.querySelector('#_ipPartWrap').style.display='block';
    this.style.display='none';
    ov.querySelector('#_ipGo').textContent='Confirm payment received';
  };
  ov.querySelector('#_ipGo').onclick=async function(){
    var n=out;
    // The date must actually be answered — same refusal shape as the amount check
    // below, and it points at the field rather than just complaining.
    var dateBox=ov.querySelector('#_ipDate');
    var when=String((dateBox&&dateBox.value)||'').trim();
    if(!when){
      showToast('error','Enter the date the money arrived.');
      if(dateBox) try{ dateBox.focus(); }catch(e){}
      return;
    }
    if(partial){
      n=parseFloat(String(ov.querySelector('#_ipAmt').value||'').replace(/[^\d.]/g,''));
      if(!(n>0)){ showToast('error','Enter the amount received.'); return; }
      if(n>out+0.005){ showToast('error','That is more than the '+money(out)+' outstanding.'); return; }
    }
    this.disabled=true; this.textContent='Recording…';
    var r=await apiPost('/api/invoices/'+id+'/pay',{amount:n, method:ov.querySelector('#_ipMethod').value,
      payer:ov.querySelector('#_ipPayer').value, paid_on:when});
    if(r.error){ showToast('error',r.error); this.disabled=false; this.textContent='Confirm payment received'; return; }
    close();
    try{ if(inv){ inv.status=r.invoice_status; inv.balance=r.balance; inv.amount_paid=Math.round(((inv.amount_paid||0)+n)*100)/100; } }catch(e){}
    _invRender();
    if(r.official && r.receipt){
      showToast('success','Fully settled. Official receipt '+(r.receipt.number||'')+' issued for '+money(total)+'.');
      if(confirm('Open the official receipt?')) _invOpenDoc('/api/receipts/'+r.receipt.id+'/doc');
    }else{
      showToast('success',money(n)+' recorded. '+money(r.balance)+' still outstanding — the official receipt is issued when the invoice is fully settled.');
    }
  };
}
async function _invExport(){ _invOpenDoc('/api/invoice/export'); }

// ── Access tab (admin) ──
async function _invLoadAccess(){
  try{ var r=await apiGet('/api/invoice/access'); _invState.access=Array.isArray(r)?r:[]; _invRender(); }catch(e){}
}
function _invAccessHTML(){
  if(!_invState.access.length) return '<div style="color:#6B7280">Loading advisers…</div>';
  var rows=_invState.access.map(function(a){
    var tier=(a.will_comm_tier||'').toLowerCase();
    return '<tr style="border-top:1px solid #EEF2F6">'
      + '<td style="padding:11px 12px;font-weight:600;color:#0B2545">'+escapeHtml(a.name||a.id)+'</td>'
      + '<td style="padding:11px 12px;color:#64748b">'+escapeHtml(a.rank||'')+'</td>'
      + '<td style="padding:11px 12px;text-align:center"><input type="checkbox" '+(a.can_invoice?'checked':'')+' onchange="_invGrant(\''+a.id+'\',this.checked)" style="width:18px;height:18px;cursor:pointer"></td>'
      + '<td style="padding:11px 12px"><select onchange="_invTier(\''+a.id+'\',this.value)" style="padding:7px 10px;border:1px solid #E2E8F0;border-radius:7px;font-size:13px"><option value="advisor"'+(tier!=='exco'?' selected':'')+'>Advisor (50% / 40%)</option><option value="exco"'+(tier==='exco'?' selected':'')+'>EXCO (70% / 52%)</option></select></td>'
      + '</tr>';
  }).join("");
  return '<div style="color:#64748b;font-size:13px;margin-bottom:12px">Only advisers you switch on here can issue invoices. Tier sets the commission split (Will 70% pool / Custodian 52% pool).</div>'
    + '<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden"><table style="width:100%;border-collapse:collapse;font-size:13.5px"><thead><tr style="background:#F8FAFC"><th style="padding:10px 12px;text-align:left;font-size:11px;color:#64748b;text-transform:uppercase">Adviser</th><th style="padding:10px 12px;text-align:left;font-size:11px;color:#64748b;text-transform:uppercase">Rank</th><th style="padding:10px 12px;text-align:center;font-size:11px;color:#64748b;text-transform:uppercase">Can invoice</th><th style="padding:10px 12px;text-align:left;font-size:11px;color:#64748b;text-transform:uppercase">Will commission tier</th></tr></thead><tbody>'+rows+'</tbody></table></div>';
}
async function _invGrant(id, can){ await apiPost('/api/invoice/access',{adviser_id:id, can:can}); var a=_invState.access.find(function(x){return x.id===id;}); if(a) a.can_invoice=can?1:0; }
async function _invTier(id, tier){ await apiPost('/api/invoice/access',{adviser_id:id, will_comm_tier:tier}); var a=_invState.access.find(function(x){return x.id===id;}); if(a) a.will_comm_tier=tier; }

// ── Settings tab (admin) ──
function _invSettingsHTML(){
  var c=_invState.cfg||{};
  var sstOpts=[["off","Not registered — no SST (plain Invoice)"],["8","Registered — 8% (Tax Invoice)"],["6","Registered — 6% (Tax Invoice)"]].map(function(o){return '<option value="'+o[0]+'"'+((c.sst_mode||'off')===o[0]?' selected':'')+'>'+o[1]+'</option>';}).join("");
  var billplzReady = c.billplz_collection_id ? '' : '<span style="color:#B45309;font-size:12px"> · Pay Now not connected yet</span>';
  return '<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;padding:22px 24px;max-width:560px">'
    + '<div style="font-size:12px;font-weight:700;color:#0B2545;text-transform:uppercase;letter-spacing:.5px;margin-bottom:8px">Payment (bank transfer)</div>'
    + '<label style="font-size:13px;color:#64748b">Bank name</label><input id="cfg-bank" value="'+escapeHtml(c.bank_name||'')+'" style="width:100%;padding:10px;border:1px solid #E2E8F0;border-radius:8px;margin:4px 0 12px">'
    + '<label style="font-size:13px;color:#64748b">Account number (payable to LIFA Planners Sdn Bhd)</label><input id="cfg-acct" value="'+escapeHtml(c.bank_account||'')+'" style="width:100%;padding:10px;border:1px solid #E2E8F0;border-radius:8px;margin:4px 0 18px">'
    + '<div style="font-size:12px;font-weight:700;color:#0B2545;text-transform:uppercase;letter-spacing:.5px;margin-bottom:8px">SST</div>'
    + '<select id="cfg-sst" style="width:100%;padding:10px;border:1px solid #E2E8F0;border-radius:8px;margin-bottom:8px">'+sstOpts+'</select>'
    + '<label style="font-size:13px;color:#64748b">SST registration number (only if registered)</label><input id="cfg-sstno" value="'+escapeHtml(c.sst_number||'')+'" style="width:100%;padding:10px;border:1px solid #E2E8F0;border-radius:8px;margin:4px 0 18px">'
    + '<div style="font-size:12px;font-weight:700;color:#0B2545;text-transform:uppercase;letter-spacing:.5px;margin-bottom:8px">Pay Now (FPX / Billplz)'+billplzReady+'</div>'
    + '<label style="font-size:13px;color:#64748b">Billplz Collection ID</label><input id="cfg-coll" value="'+escapeHtml(c.billplz_collection_id||'')+'" placeholder="from your Billplz dashboard" style="width:100%;padding:10px;border:1px solid #E2E8F0;border-radius:8px;margin:4px 0 6px">'
    + '<div style="font-size:11.5px;color:#94A3B8;margin-bottom:16px">API keys are set on the server as secrets — send them to your developer once Billplz approves the account.</div>'
    + '<div id="cfg-alert"></div>'
    + '<button onclick="_invSaveCfg()" style="background:#0B2545;color:#fff;border:none;border-radius:9px;padding:11px 22px;font-weight:600;cursor:pointer">Save settings</button>'
    + '</div>';
}
async function _invSaveCfg(){
  var body={bank_name:document.getElementById('cfg-bank').value, bank_account:document.getElementById('cfg-acct').value, sst_mode:document.getElementById('cfg-sst').value, sst_number:document.getElementById('cfg-sstno').value, billplz_collection_id:document.getElementById('cfg-coll').value};
  var r=await apiPut('/api/invoice/config', body);
  _invState.cfg=r; var a=document.getElementById('cfg-alert');
  a.innerHTML='<div style="color:#15803D;font-size:13px;margin-bottom:8px">✓ Saved.</div>';
}


// ── Email Templates ──────────────────────────────────────────────────────────
var _etData = null, _etSelected = null;
var _etTab = 'email';
// Form deck previews (paginated clean pages) — lazy-fetched from form-previews.json, cached here.
var _etDecks = null;        // { _form_intake:{css,pages:[{title,html}]}, _form_kyc:{...}, _form_licensing:{...} }
var _etDeckPage = {};       // per-form current page index, e.g. { _form_intake: 0 }
const _ET_EMAIL_GROUPS = [
  { label: 'KYC — to clients', keys: [
    {key:'first_time',       label:'KYC link — first time'},
    {key:'renewal',          label:'KYC link — renewal'},
    {key:'joint',            label:'KYC link — joint signer'},
    {key:'otp',              label:'OTP verification code'},
    {key:'client_ack',       label:'Form submitted (client)'},
  ]},
  { label: 'KYC — to advisers', keys: [
    {key:'submitted',            label:'Case submitted'},
    {key:'adviser_directive',    label:'Compliance directive'},
    {key:'esc_reminder_3d',      label:'Escalation — 3 days'},
    {key:'esc_warning_7d',       label:'Escalation — 7 days'},
    {key:'esc_breach_14d',       label:'Escalation — 14 days (breach)'},
    {key:'annual_review_reminder',label:'Annual review reminder'},
  ]},
  { label: 'CPE compliance', keys: [
    {key:'cpe_reminder_t90',    label:'CPE reminder — 3 months'},
    {key:'cpe_reminder_t30',    label:'CPE reminder — 1 month'},
    {key:'cpe_reminder_t3',     label:'CPE reminder — 3 days (urgent)'},
    {key:'cpe_reminder_overdue',label:'CPE reminder — overdue'},
    {key:'cpe_rejection',       label:'CPE cert rejected'},
  ]},
  { label: 'Adviser onboarding', keys: [
    {key:'adviser_welcome',      label:'Welcome + temp password'},
    {key:'password_reset',       label:'Password reset'},
    {key:'request_particulars',  label:'Request particulars'},
    {key:'cmsrl_paid',           label:'CMSRL renewal confirmed'},
  ]},
  { label: 'Commission & finance', keys: [
    {key:'commission_paid',  label:'Commission paid'},
    {key:'finance_summary',  label:'Finance summary'},
  ]},
  { label: 'Licensing — candidate emails', keys: [
    {key:'intake_resume_link',         label:'Application link (resume)'},
    {key:'intake_agreement_email',     label:'Sign appointment agreement'},
    {key:'intake_submitted_admin',     label:'New application (to admin)'},
    {key:'intake_docs_complete_admin', label:'All documents received (to admin)'},
  ]},
];
const _ET_FORM_GROUPS = [
  { label: 'Documents (rendered)', keys: [
    {key:'agreement_doc',       label:'Appointment Agreement'},
    {key:'code_of_ethics_doc',  label:'Code of Ethics'},
    {key:'pdpa_consent_intake', label:'PDPA consent (licensing)'},
  ]},
  { label: 'Recruitment — AI interview', keys: [
    {key:'_form_apply_direct',  label:'Candidate apply link'},
    {key:'_form_intake',        label:'AE — application form (admin preview)'},
    {key:'_form_intake_wa',     label:'WA — application form (admin preview)'},
    {key:'_form_demo',          label:'🧪 Demo mode — live interactive test'},
  ]},
  { label: 'Licensing — CMSRL submission', keys: [
    {key:'_form_licensing', label:'Licensing application form (CMSRL)'},
  ]},
  { label: 'KYC — live forms', keys: [
    {key:'_form_kyc',      label:'Client KYC fact-find form'},
    {key:'_form_feedback', label:'Client feedback form'},
  ]},
];
// Form keys rendered as clean paginated decks (snapshots in form-previews.json).
const _ET_DECK_KEYS = {
  _form_licensing:'Licensing application form (CMSRL) — the contracting/licensing intake a hired candidate completes: SC CMSRL → FIMM → iFAST',
  _form_kyc:'Client KYC fact-find form'
};
// Form keys that fall back to a simple link card (live URL or no captured deck).
const _ET_FORM_URLS = {
  _form_apply_direct: { label:'Candidate apply page', desc:'The live candidate-facing application portal. Send this link to applicants.', url:'https://apply.lifa.com.my' },
  _form_intake:    { label:'AE — Admin Executive application (admin preview)', desc:'Step-by-step admin walk-through of the Admin Executive application flow. 15 pages — Landing → Consent → Particulars → Written (all 10 Qs) → Assessment (all 5 tasks) → Video reassurance → Video (5 Qs) → Walk-in scheduler → Submitted. Use the dropdown to jump to any page.', url:'https://apply.lifa.com.my/?preview=1' },
  _form_intake_wa: { label:'WA — Wealth Advisor application (admin preview)', desc:'Step-by-step admin walk-through of the Wealth Advisor application flow.', url:'https://apply.lifa.com.my/?preview=wa' },
  _form_feedback:  { label:'Client feedback form', desc:'Public form where clients send feedback or complaints straight to LIFA Planners.', url:'https://kyc.lifa.com.my/feedback' },
};
function _etSubject(key){
  const subj = {
    first_time:'[LIFA Planners] Your KYC form is ready — please complete within 14 days',
    renewal:'[LIFA Planners] Annual KYC update required — please review and reconfirm',
    joint:'[LIFA Planners] Joint account KYC — please sign',
    otp:'Your LIFA KYC verification code',
    client_ack:'Thank you — your KYC form has been received',
    submitted:'KYC submitted — Sample Client',
    adviser_directive:'Compliance Directive: LIFA KYC required for every new account + yearly update',
    esc_reminder_3d:'Action required: KYC for Sample Client outstanding — 3 days',
    esc_warning_7d:'Action required: KYC for Sample Client outstanding — 7 days',
    esc_breach_14d:'BREACH: KYC for Sample Client — 14 days outstanding',
    annual_review_reminder:'KYC annual reviews due — please update your clients',
    cpe_reminder_t90:'[Reminder — 3 months] SC CPE compliance — deadline 13 Jun 2026',
    cpe_reminder_t30:'[Important — 1 month] SC CPE compliance — deadline 13 Jun 2026',
    cpe_reminder_t3:'[URGENT — 3 days] SC CPE compliance — deadline 13 Jun 2026',
    cpe_reminder_overdue:'[OVERDUE by 5 days] SC CPE compliance — deadline 13 Jun 2026',
    cpe_rejection:'❌ CPE certificate not accepted — please resubmit',
    adviser_welcome:'Your LIFA Planners adviser portal is ready',
    password_reset:'Your LIFA Planners portal password has been reset',
    request_particulars:'Please complete your details — LIFA Planners',
    cmsrl_paid:'CMSRL renewal payment received — LIFA Planners',
    commission_paid:'Commission statement — May 2026',
    finance_summary:'Finance payout summary — May 2026',
    intake_resume_link:'Your LIFA Planners application link',
    intake_agreement_email:'Sign your LIFA Planners Adviser Appointment Agreement',
    intake_submitted_admin:'New licensing application — Sample Candidate',
    intake_docs_complete_admin:'All documents received — Sample Candidate',
    agreement_doc:'Representative Appointment Agreement',
    code_of_ethics_doc:'Code of Ethics & Professional Conduct',
    pdpa_consent_intake:'PDPA consent — licensing application',
  };
  return subj[key] || key;
}
// Render one page of a form deck (clean paginated snapshot) into the preview pane.
function _etRenderDeck(key){
  var pane = document.getElementById('et-preview-pane');
  if(!pane) return;
  var deck = _etDecks && _etDecks[key];
  if(!deck || !deck.pages || !deck.pages.length){
    pane.innerHTML = '<div style="color:#94A3B8;padding:32px;text-align:center">No preview available</div>'; return;
  }
  var n = deck.pages.length;
  var i = _etDeckPage[key] || 0;
  if(i < 0) i = 0; if(i > n-1) i = n-1; _etDeckPage[key] = i;
  var pg = deck.pages[i];
  var btn = function(label, dir, disabled){
    return '<button '+(disabled?'disabled ':'')+'onclick="_etDeckStep(\''+key+'\','+dir+')" '
      + 'style="padding:7px 16px;border-radius:8px;border:1.5px solid '+(disabled?'#E2E8F0':'#0B2545')+';'
      + 'background:'+(disabled?'#F8FAFC':'#fff')+';color:'+(disabled?'#CBD5E1':'#0B2545')+';'
      + 'font:inherit;font-size:13px;font-weight:600;cursor:'+(disabled?'not-allowed':'pointer')+'">'+label+'</button>';
  };
  var label = _ET_DECK_KEYS[key] || key;
  var src = '<style>'+deck.css+'</style>'+pg.html;
  pane.innerHTML = '<div style="font-size:11px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:.05em;margin-bottom:4px">Form preview</div>'
    + '<div style="font-size:13px;font-weight:600;color:#0B2545;margin-bottom:12px;padding-bottom:10px;border-bottom:1px solid #E2E8F0">'+label+'</div>'
    + '<div style="display:flex;align-items:center;justify-content:center;gap:14px;margin-bottom:12px">'
    + btn('‹ Previous', -1, i===0)
    + '<div style="font-size:13px;font-weight:600;color:#0B2545;min-width:0;text-align:center">Page '+(i+1)+' of '+n+' · '+pg.title+'</div>'
    + btn('Next ›', 1, i===n-1)
    + '</div>'
    + '<iframe srcdoc="'+src.replace(/"/g,'&quot;')+'" style="width:100%;height:calc(100vh - 300px);border:1px solid #E2E8F0;border-radius:8px;background:#fff"></iframe>';
}
// Prev/Next — update page index and re-render the pane only (not the whole view).
function _etDeckStep(key, dir){
  var deck = _etDecks && _etDecks[key]; if(!deck) return;
  var n = deck.pages.length;
  var i = (_etDeckPage[key] || 0) + dir;
  if(i < 0) i = 0; if(i > n-1) i = n-1;
  _etDeckPage[key] = i;
  _etRenderDeck(key);
}
function _etShowKey(key){
  _etSelected = key;
  document.querySelectorAll('.et-item').forEach(function(el){ el.classList.toggle('et-active', el.dataset.key === key); });
  var pane = document.getElementById('et-preview-pane');
  if(!pane) return;
  // Form deck — clean paginated pages captured from the live forms (no app shell, no "open in new tab").
  if(_ET_DECK_KEYS[key]){
    if(_etDecks){ _etRenderDeck(key); return; }
    pane.innerHTML = '<div style="color:#94A3B8;padding:32px;text-align:center">Loading preview…</div>';
    fetch('form-previews.json').then(function(r){ return r.ok ? r.json() : null; }).then(function(j){
      _etDecks = j || {};
      if(_etSelected === key) _etRenderDeck(key);
    }).catch(function(){ _etDecks = {}; if(_etSelected === key) _etRenderDeck(key); });
    return;
  }
  // Demo mode — interactive live test with step-jump buttons
  if(key === '_form_demo'){
    var demoSteps = [
      {step:'consent',    emoji:'📋', label:'Consent',    desc:'Welcome screen + PDPA consent'},
      {step:'particulars',emoji:'👤', label:'Particulars', desc:'Personal details form'},
      {step:'written',    emoji:'💭', label:'Personality', desc:'10 scenario MCQ questions'},
      {step:'assessment', emoji:'📝', label:'Assessment',  desc:'5 practical tasks'},
      {step:'video',      emoji:'🎥', label:'Video',       desc:'Video vs walk-in choice'},
    ];
    pane.innerHTML = '<div style="font-size:11px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:.05em;margin-bottom:6px">Live Demo — Admin Executive</div>'
      + '<p style="font-size:13px;color:#374151;margin:0 0 16px">Click any step to open a <b>live interactive session</b> at that exact page. The form is fully functional — you can answer questions, fill fields, and test behaviour. A new tab opens each time.</p>'
      + '<div id="_demo-btns" style="display:grid;grid-template-columns:repeat(auto-fill,minmax(180px,1fr));gap:10px;margin-bottom:16px">'
      + demoSteps.map(function(s){
          return '<button onclick="_demoOpen(\''+s.step+'\')" style="display:flex;flex-direction:column;align-items:flex-start;padding:14px 16px;border:1px solid #E2E8F0;border-radius:10px;background:#fff;cursor:pointer;text-align:left;font:inherit;transition:box-shadow .15s" onmouseover="this.style.boxShadow=\'0 2px 8px #0001\'" onmouseout="this.style.boxShadow=\'\'">'
            + '<span style="font-size:22px;margin-bottom:4px">'+s.emoji+'</span>'
            + '<span style="font-size:13px;font-weight:600;color:#0B2545">'+s.label+'</span>'
            + '<span style="font-size:11px;color:#94A3B8;margin-top:2px">'+s.desc+'</span>'
            + '</button>';
        }).join('')
      + '</div>'
      + '<div id="_demo-status" style="font-size:12px;color:#64748B;min-height:20px"></div>';
    return;
  }
  // Form with no captured deck (e.g. feedback) — fall back to the simple link card.
  if(_ET_FORM_URLS[key]){
    var f = _ET_FORM_URLS[key];
    pane.innerHTML = '<div style="font-size:11px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:.05em;margin-bottom:4px">Live form</div>'
      + '<div style="display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:12px;padding-bottom:10px;border-bottom:1px solid #E2E8F0">'
      + '<div style="min-width:0"><div style="font-size:13px;font-weight:600;color:#0B2545">'+f.label+'</div>'
      + '<div style="font-size:12px;color:#94A3B8;margin-top:2px;line-height:1.5">'+f.desc+'</div></div>'
      + '<a href="'+f.url+'" target="_blank" rel="noopener" style="flex-shrink:0;margin-left:14px;font-size:12px;color:#0B2545;text-decoration:none;border:1px solid #CBD5E1;padding:6px 12px;border-radius:7px;white-space:nowrap">Open in new tab ↗</a>'
      + '</div>'
      + '<iframe src="'+f.url+'" title="'+f.label+'" style="width:100%;height:calc(100vh - 250px);border:1px solid #E2E8F0;border-radius:8px;background:#fff"></iframe>';
    return;
  }
  // Rendered template / document
  var html = _etData && _etData[key];
  if(!html){ pane.innerHTML = '<div style="color:#94A3B8;padding:32px;text-align:center">No preview available</div>'; return; }
  var subj = _etSubject(key);
  pane.innerHTML = '<div style="font-size:11px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:.05em;margin-bottom:4px">'+(_etTab==='forms'?'Document':'Subject')+'</div>'
    + '<div style="font-size:13px;font-weight:600;color:#0B2545;margin-bottom:14px;padding-bottom:10px;border-bottom:1px solid #E2E8F0">'+subj+'</div>'
    + '<iframe srcdoc="'+html.replace(/"/g,'&quot;')+'" style="width:100%;height:calc(100vh - 240px);border:none;border-radius:6px;background:#fff"></iframe>';
}
async function _demoOpen(step){
  var statusEl = document.getElementById('_demo-status');
  if(statusEl) statusEl.textContent = 'Opening ' + step + '…';
  try {
    var res = await apiPost('/api/apply/admin/demo-reset', {step:step});
    if(!res || !res.token){ if(statusEl) statusEl.textContent = 'Error — could not get session token'; return; }
    var url = 'https://apply.lifa.com.my?_demo=' + encodeURIComponent(res.token);
    window.open(url, '_blank', 'noopener');
    if(statusEl) statusEl.textContent = 'Opened — live session at "' + step + '" step. Close the tab when done.';
  } catch(e){
    if(statusEl) statusEl.textContent = 'Error: ' + (e && e.message || String(e));
  }
}
function _etSwitchTab(t){ _etTab = t; _etSelected = null; renderEmailTemplates(); }
async function renderEmailTemplates(){
  var el = document.getElementById('main-content');
  var tabBtn = function(id, label){ return '<button onclick="_etSwitchTab(\''+id+'\')" style="padding:8px 16px;border:none;border-radius:8px;cursor:pointer;font:inherit;font-size:13px;font-weight:500;background:'+(_etTab===id?'#0B2545':'#F1F5F9')+';color:'+(_etTab===id?'#fff':'#374151')+'">'+label+'</button>'; };
  el.innerHTML = '<div style="padding:28px 32px">'
    + '<h2 style="margin:0 0 4px;color:#0B2545">Templates</h2>'
    + '<p style="margin:0 0 14px;font-size:13px;color:#64748B">'+(_etTab==='forms' ? 'Forms &amp; documents — review the live forms and rendered document templates.' : 'All automated emails sent by the system — rendered with sample data.')+'</p>'
    + '<div style="display:flex;gap:8px;margin-bottom:18px">'+tabBtn('email','📧 Email templates')+tabBtn('forms','📋 Forms templates')+'</div>'
    + '<div style="display:flex;gap:20px;align-items:flex-start">'
    + '<div id="et-sidebar" style="width:240px;flex-shrink:0;background:#F8FAFC;border:1px solid #E2E8F0;border-radius:10px;padding:10px 0;max-height:calc(100vh - 230px);overflow-y:auto"></div>'
    + '<div id="et-preview-pane" style="flex:1;min-width:0"><div style="color:#94A3B8;padding:60px 0;text-align:center;font-size:13px">Select an item</div></div>'
    + '</div></div>';
  var groups = (_etTab === 'forms') ? _ET_FORM_GROUPS : _ET_EMAIL_GROUPS;
  var sidebar = document.getElementById('et-sidebar');
  sidebar.innerHTML = groups.map(function(g){
    return '<div style="padding:6px 14px 2px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:#94A3B8">'+g.label+'</div>'
      + g.keys.map(function(t){ return '<div class="et-item" data-key="'+t.key+'" onclick="_etShowKey(\''+t.key+'\')" style="padding:7px 16px;font-size:13px;cursor:pointer;color:#374151;border-radius:6px;margin:1px 6px">'+t.label+'</div>'; }).join('');
  }).join('');
  // Rendered templates/documents come from the API; live forms don't need it.
  if(!_etData){
    var res = await apiGet('/api/kyc/templates');
    if(res && !res.error) _etData = res;
  }
  var firstKey = groups[0].keys[0].key;
  _etShowKey(_etSelected || firstKey);
}

// ── Candidate Intakes ────────────────────────────────────────────────────────
async function renderIntakes(){
  const el = document.getElementById('main-content');
  el.innerHTML = '<div style="padding:24px 20px">'
    + '<a href="#" onclick="showView(\'licensing\');return false" style="font-size:12px;color:#6B7280;text-decoration:none;display:inline-block;margin-bottom:14px">← Pipeline</a>'
    + '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:4px">'
    + '<div style="font-size:17px;font-weight:700;color:#0B2545">Candidate Intakes</div>'
    + '<button onclick="openDirectInviteModal()" style="background:#0B2545;color:#fff;border:0;padding:8px 14px;border-radius:8px;font-size:12px;font-weight:600;cursor:pointer">+ Send invite link</button>'
    + '</div>'
    + '<div style="font-size:12px;color:#6B7280;margin-bottom:18px">Applications submitted by candidates via the online form</div>'
    + '<div id="intakes-body"><div style="color:#6B7280;font-size:13px">Loading…</div></div></div>';
  try {
    const d = await apiGet('/api/intakes');
    _renderIntakesTable(d);
  } catch(e) {
    document.getElementById('intakes-body').innerHTML = '<div style="color:#DC2626;font-size:13px">Failed to load: '+escapeHtml(String(e))+'</div>';
  }
}

function _renderIntakesTable(d){
  const rows = d.rows || [];
  if(!rows.length){
    document.getElementById('intakes-body').innerHTML = '<div style="color:#6B7280;font-size:13px;padding:20px 0">No submitted applications yet. Share a recruiter invite link for candidates to apply.</div>';
    return;
  }
  const trs = rows.map(function(r){
    const submittedDate = r.submitted_at ? new Date(r.submitted_at*1000).toLocaleDateString('en-MY',{day:'2-digit',month:'short',year:'numeric'}) : '—';
    const statusColor = {submitted:'#B45309', approved:'#15803D', rejected:'#DC2626'}[r.status]||'#94A3B8';
    const statusLabel = {submitted:'Submitted',approved:'Approved',rejected:'Rejected'}[r.status]||r.status;
    const contractBadge = r.contract_signed
      ? '<span style="color:#15803D;font-size:11px;font-weight:600">✓ Signed</span>'
      : '<span style="color:#9CA3AF;font-size:11px">—</span>';
    return '<tr style="border-bottom:1px solid #F1F5F9;cursor:pointer" onclick="openIntakeModal(\''+escapeHtml(r.id)+'\')" onmouseover="this.style.background=\'#F8FAFC\'" onmouseout="this.style.background=\'\'">'
      + '<td style="padding:12px 10px;font-weight:600;color:#0B2545">'+escapeHtml(r.full_name||'—')+'</td>'
      + '<td style="padding:12px 10px;font-size:12px;color:#6B7280">'+escapeHtml(r.ic_number||'—')+'</td>'
      + '<td style="padding:12px 10px;font-size:12px;color:#374151">'+escapeHtml(r.recruiter_name||r.recruiter_id||'—')+'</td>'
      + '<td style="padding:12px 10px;font-size:12px;color:#374151">'+escapeHtml(r.education_level||'—')+'</td>'
      + '<td style="padding:12px 10px;font-size:12px;color:'+(r.is_aia_prs?'#B45309':'#6B7280')+'">'+(r.is_aia_prs?'⚠ AIA':'—')+'</td>'
      + '<td style="padding:12px 10px;font-size:12px;color:#374151">'+escapeHtml(r.payment_amount?'RM'+r.payment_amount:'—')+'</td>'
      + '<td style="padding:12px 10px;font-size:12px;color:#6B7280">'+submittedDate+'</td>'
      + '<td style="padding:12px 10px">'+contractBadge+'</td>'
      + '<td style="padding:12px 10px"><span style="display:inline-block;padding:2px 8px;border-radius:10px;font-size:11px;font-weight:600;background:'+statusColor+'22;color:'+statusColor+'">'+escapeHtml(statusLabel)+'</span></td>'
      + '</tr>';
  }).join('');
  document.getElementById('intakes-body').innerHTML =
    '<table style="width:100%;border-collapse:collapse;font-size:13px">'
    + '<thead><tr style="background:#F8FAFC;border-bottom:2px solid #E2E8F0">'
    + '<th style="padding:10px;text-align:left;color:#374151;font-weight:600">Candidate</th>'
    + '<th style="padding:10px;text-align:left;color:#374151;font-weight:600">IC</th>'
    + '<th style="padding:10px;text-align:left;color:#374151;font-weight:600">Recruiter</th>'
    + '<th style="padding:10px;text-align:left;color:#374151;font-weight:600">Qualification</th>'
    + '<th style="padding:10px;text-align:left;color:#374151;font-weight:600">AIA</th>'
    + '<th style="padding:10px;text-align:left;color:#374151;font-weight:600">Payment</th>'
    + '<th style="padding:10px;text-align:left;color:#374151;font-weight:600">Submitted</th>'
    + '<th style="padding:10px;text-align:left;color:#374151;font-weight:600">Contract</th>'
    + '<th style="padding:10px;text-align:left;color:#374151;font-weight:600">Status</th>'
    + '</tr></thead><tbody>'+trs+'</tbody></table>';
}

function openIntakeModal(id){
  apiGet('/api/intake/'+id).then(function(r){
    var m=document.createElement('div'); m.id='intake-modal';
    m.style.cssText='position:fixed;inset:0;z-index:99999;background:rgba(11,37,69,.45);display:flex;align-items:center;justify-content:center;padding:16px';
    m.onclick=function(e){if(e.target===m)m.remove();};
    const esc=escapeHtml;
    const row=function(label,val){return val?'<div style="margin-bottom:8px"><span style="font-size:11px;font-weight:600;color:#374151">'+esc(label)+'</span><div style="font-size:13px;color:#0B2545;margin-top:2px">'+esc(String(val))+'</div></div>':'';};
    var emp='';
    try{var eh=JSON.parse(r.employment_history||'[]');emp=eh.map(function(e){return esc(e.employer||'')+(e.start_month?' ('+e.start_month+' '+e.start_year+' – '+(e.is_current?'Present':(e.end_month+' '+e.end_year))+')':'');}).join('<br>');}catch(x){}
    m.innerHTML='<div style="background:#fff;border-radius:16px;max-width:540px;width:100%;padding:24px;box-sizing:border-box;max-height:90vh;overflow-y:auto">'
      + '<div style="font-size:16px;font-weight:700;color:#0B2545;margin-bottom:16px">'+esc(r.full_name||id)+'</div>'
      + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:0 16px">'
      + row('IC Number', r.ic_number) + row('Date of Birth', r.dob)
      + row('Email', r.email) + row('Phone', r.phone)
      + '</div>'
      + row('Address', r.address)
      + '<div style="border-top:1px solid #F1F5F9;margin:12px 0"></div>'
      + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:0 16px">'
      + row('Education', r.education_level) + row('Institution', r.institution)
      + row('Grad Year', r.grad_year) + row('AIA PRS', r.is_aia_prs?'Yes':'No')
      + '</div>'
      + '<div style="border-top:1px solid #F1F5F9;margin:12px 0"></div>'
      + (emp?'<div style="margin-bottom:8px"><span style="font-size:11px;font-weight:600;color:#374151">Employment History</span><div style="font-size:12px;color:#374151;margin-top:2px">'+emp+'</div></div>':'')
      + '<div style="border-top:1px solid #F1F5F9;margin:12px 0"></div>'
      + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:0 16px">'
      + row('Payment Bank', r.payment_bank) + row('Payment Date', r.payment_date)
      + row('Payment Ref', r.payment_ref) + row('Amount', r.payment_amount?'RM'+r.payment_amount:'')
      + '</div>'
      + '<div style="margin-bottom:8px"><span style="font-size:11px;font-weight:600;color:#374151">Documents uploaded</span>'
      + '<div style="font-size:12px;color:#374151;margin-top:4px;display:flex;flex-wrap:wrap;gap:6px">'
      + (function(){
          var badge = function(label,ok){ return '<span style="background:'+(ok?'#DCFCE7':'#FEF2F2')+';color:'+(ok?'#15803D':'#DC2626')+';padding:2px 8px;border-radius:8px;font-size:11px">'+(ok?'✓ ':'')+label+'</span>'; };
          var allDocs = r.has_ic && r.has_degree && r.has_professional_cert && r.has_membership && r.has_photo && r.has_payment && (!r.is_aia_prs || r.has_aia_cert);
          return badge('IC',r.has_ic) + badge('Degree',r.has_degree)
            + badge('CFP/RFP Cert',r.has_professional_cert) + badge('Membership',r.has_membership)
            + badge('Passport Photo',r.has_photo)
            + (r.is_aia_prs ? badge('AIA Cert',r.has_aia_cert) : '')
            + badge('Receipt',r.has_payment)
            + (allDocs ? '<div style="margin-top:8px;background:#F0FDF4;border:1px solid #BBF7D0;border-radius:8px;padding:8px 12px;font-size:12px;color:#15803D;font-weight:600">All documents received — ready to submit SC Form 3 via EASy</div>' : '');
        })()
      + '</div></div>'
      + '<div style="border-top:1px solid #F1F5F9;margin:12px 0"></div>'
      + (function(){
          var contractUrl = 'https://lifajoin.pages.dev/contract.html?id='+esc(id);
          var contractId = 'ci-contract-url-'+esc(id).slice(0,8);
          if(r.contract_signed){
            var sd = r.contract_signed_at ? new Date(r.contract_signed_at*1000).toLocaleDateString('en-MY',{day:'2-digit',month:'short',year:'numeric'}) : '';
            return '<div style="background:#F0FDF4;border:1px solid #BBF7D0;border-radius:10px;padding:12px 14px">'
              + '<div style="font-size:11px;font-weight:600;color:#15803D;margin-bottom:3px">Agreement Signed</div>'
              + '<div style="font-size:12px;color:#166534">Signed by <b>'+esc(r.contract_signed_name||'')+'</b>'+(sd?' on '+sd:'')+'</div></div>';
          }
          return '<div style="background:#EFF6FF;border:1px solid #BFDBFE;border-radius:10px;padding:12px 14px">'
            + '<div style="font-size:11px;font-weight:600;color:#1D4ED8;margin-bottom:4px">Appointment Agreement — not yet signed</div>'
            + '<div style="font-size:12px;color:#1E40AF;word-break:break-all;margin-bottom:8px" id="'+contractId+'">'+contractUrl+'</div>'
            + '<div style="display:flex;gap:8px;flex-wrap:wrap">'
            + '<button onclick="(function(){var u=document.getElementById(\''+contractId+'\').textContent;navigator.clipboard.writeText(u).then(function(){showToast(\'success\',\'Link copied\');}).catch(function(){showToast(\'warn\',u);});})()" style="background:#1D4ED8;color:#fff;border:0;padding:7px 14px;border-radius:7px;font-size:12px;font-weight:600;cursor:pointer">Copy link</button>'
            + '<a href="'+contractUrl+'" target="_blank" style="background:#EFF6FF;color:#1D4ED8;border:1px solid #BFDBFE;padding:7px 14px;border-radius:7px;font-size:12px;font-weight:600;text-decoration:none">Open</a>'
            + '<button onclick="emailContractLink(\''+esc(id)+'\')" style="background:#fff;color:#1D4ED8;border:1px solid #BFDBFE;padding:7px 14px;border-radius:7px;font-size:12px;font-weight:600;cursor:pointer">Email to candidate</button>'
            + '</div></div>';
        })()
      + '<div style="margin-top:16px;padding-top:14px;border-top:1px solid #F1F5F9"><span style="font-size:11px;font-weight:600;color:#374151">Action</span>'
      + '<div style="display:flex;gap:10px;margin-top:8px;flex-wrap:wrap">'
      + '<button onclick="approveIntake(\''+esc(id)+'\')" style="background:#15803D;color:#fff;border:0;padding:9px 18px;border-radius:8px;font-size:13px;font-weight:600;cursor:pointer">Move to Pipeline</button>'
      + '<button onclick="openIntakePreview(\''+esc(id)+'\')" style="background:#F1F5F9;color:#374151;border:0;padding:9px 18px;border-radius:8px;font-size:13px;cursor:pointer">View full form</button>'
      + '<button onclick="document.getElementById(\'intake-modal\').remove()" style="background:#fff;border:1px solid #D1D5DB;color:#374151;padding:9px 18px;border-radius:8px;font-size:13px;cursor:pointer">Close</button>'
      + '</div></div>'
      + '</div>';
    document.body.appendChild(m);
  }).catch(function(e){ showToast('error','Failed to load: '+String(e)); });
}

async function approveIntake(id){
  // Promote intake to licensing pipeline: create a pipeline entry tagged to the candidate
  try{
    const r = await apiGet('/api/intake/'+id);
    const candidateId = 'REC-'+id.slice(0,8).toUpperCase();
    await api('/api/licensing/'+encodeURIComponent(candidateId), {method:'PUT', body:JSON.stringify({
      candidate_name: r.full_name||'Unknown',
      sc_status:'pending', fimm_status:'pending',
      notes:'Intake submitted '+(r.submitted_at?new Date(r.submitted_at*1000).toLocaleDateString('en-MY'):'')
        +(r.education_level?' — '+r.education_level:'')+(r.is_aia_prs?' — AIA PRS':'')
    })});
    document.getElementById('intake-modal')?.remove();
    showToast('success', (r.full_name||'Candidate')+' added to pipeline as '+candidateId);
    renderIntakes();
  }catch(e){ showToast('error','Failed: '+String(e)); }
}

// ── Licensing pipeline ───────────────────────────────────────────────────────
var _licData = null;

const SC_STATUS  = {pending:'Pending',submitted:'Submitted',returned:'Returned',approved:'Approved'};
const FIMM_STATUS = {pending:'Pending',submitted:'Submitted',documents_required:'Docs Required',approved:'Approved'};
const SC_COLOR   = {pending:'#94A3B8',submitted:'#B45309',returned:'#DC2626',approved:'#15803D'};
const FIMM_COLOR = {pending:'#94A3B8',submitted:'#B45309',documents_required:'#DC2626',approved:'#15803D'};

function _licBadge(label, color){
  return '<span style="display:inline-block;padding:2px 8px;border-radius:10px;font-size:11px;font-weight:600;background:'+color+'22;color:'+color+'">'+escapeHtml(label)+'</span>';
}

async function renderLicensing(){
  const el = document.getElementById('main-content');
  el.innerHTML = '<div style="padding:24px 20px">'
    + '<a href="#" onclick="showView(\'dashboard\');return false" style="font-size:12px;color:#6B7280;text-decoration:none;display:inline-block;margin-bottom:14px">← Dashboard</a>'
    + '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:18px">'
    + '<div><div style="font-size:17px;font-weight:700;color:#0B2545">SC &amp; FIMM Licensing Pipeline</div>'
    + '<div style="font-size:12px;color:#6B7280;margin-top:2px">Track new agent contracting: SC CMSRL → FIMM → iFAST</div></div>'
    + '<button onclick="openAddCandidateModal()" style="background:#0B2545;color:#fff;border:0;padding:9px 16px;border-radius:8px;font-size:13px;font-weight:600;cursor:pointer">+ Add Candidate</button>'
    + '</div>'
    + (!isAdmin && currentUser ? '<div style="background:#EFF6FF;border:1px solid #BFDBFE;border-radius:10px;padding:12px 16px;margin-bottom:16px;display:flex;align-items:center;justify-content:space-between;gap:12px">'
        + '<div><div style="font-size:12px;font-weight:600;color:#1D4ED8;margin-bottom:2px">Your recruiter invite link</div>'
        + '<div style="font-size:12px;color:#1E40AF;word-break:break-all" id="lic-invite-url">https://lifajoin.pages.dev?ref='+escapeHtml(currentUser)+'</div></div>'
        + '<button onclick="(function(){var u=document.getElementById(\'lic-invite-url\').textContent;navigator.clipboard.writeText(u).then(function(){showToast(\'success\',\'Link copied\');}).catch(function(){showToast(\'warn\',u);});})()" style="flex-shrink:0;background:#1D4ED8;color:#fff;border:0;padding:8px 14px;border-radius:8px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap">Copy</button>'
        + '</div>' : '')
    + '<div id="lic-body"><div style="color:#6B7280;font-size:13px">Loading…</div></div></div>';
  try {
    const d = await apiGet('/api/licensing');
    _licData = d;
    _renderLicTable(d);
  } catch(e) {
    document.getElementById('lic-body').innerHTML = '<div style="color:#DC2626;font-size:13px">Failed to load: '+escapeHtml(String(e))+'</div>';
  }
}

function _renderLicTable(d){
  const rows = d.rows || [];
  if(!rows.length){
    document.getElementById('lic-body').innerHTML='<div style="color:#6B7280;font-size:13px;padding:20px 0">No candidates in pipeline. Click <b>+ Add Candidate</b> to track a new recruit.</div>';
    return;
  }
  const trs = rows.map(function(r){
    const name = r.adviser_name || r.candidate_name || r.adviser_id;
    const sc   = r.sc_status   || 'pending';
    const fimm = r.fimm_status || 'pending';
    const contracted = !!(r.adviser_cmsrl && r.adviser_ifast);
    const done = contracted || (sc==='approved' && fimm==='approved' && r.ifast_code);
    const displayIfast = r.ifast_code || r.adviser_ifast || null;
    return '<tr onclick="openLicModal(\''+escapeHtml(r.adviser_id)+'\')" style="cursor:pointer;border-bottom:1px solid #F1F5F9" onmouseover="this.style.background=\'#F8FAFC\'" onmouseout="this.style.background=\'\'">'
      + '<td style="padding:12px 10px;font-weight:600;color:#0B2545;white-space:nowrap">'+escapeHtml(name)+'</td>'
      + '<td style="padding:12px 10px;font-size:12px;color:#6B7280">'+escapeHtml(r.adviser_id)+'</td>'
      + '<td style="padding:12px 10px">'
        + (contracted&&r.adviser_cmsrl
            ? _licBadge('Approved','#15803D')+'<div style="font-size:11px;color:#6B7280;margin-top:3px">'+escapeHtml(r.adviser_cmsrl)+'</div>'
            : _licBadge(SC_STATUS[sc]||sc, SC_COLOR[sc]||'#94A3B8')
              +(r.sc_ref?'<div style="font-size:11px;color:#6B7280;margin-top:3px">'+escapeHtml(r.sc_ref)+(r.sc_approved_date?' · '+escapeHtml(r.sc_approved_date):'')+'</div>':''))
      + '</td>'
      + '<td style="padding:12px 10px">'
        + (contracted&&r.adviser_ifast
            ? _licBadge('Approved','#15803D')
            : _licBadge(FIMM_STATUS[fimm]||fimm, FIMM_COLOR[fimm]||'#94A3B8')
              +(r.fimm_ticket?'<div style="font-size:11px;color:#6B7280;margin-top:3px">'+escapeHtml(r.fimm_ticket)+'</div>':'')
              +(r.fimm_issue&&fimm==='documents_required'?'<div style="font-size:11px;color:#DC2626;margin-top:2px">'+escapeHtml(r.fimm_issue.slice(0,70))+'…</div>':''))
      + '</td>'
      + '<td style="padding:12px 10px;font-size:12px;color:'+(displayIfast?'#15803D':'#94A3B8')+'">'+(displayIfast?escapeHtml(displayIfast):'—')+'</td>'
      + '<td style="padding:12px 10px;font-size:12px;color:'+(r.contract_signed?'#15803D':'#94A3B8')+'">'+(r.contract_signed?'✓ Signed':'—')+'</td>'
      + '<td style="padding:12px 10px">'+(done?'<span style="color:#15803D;font-weight:600;font-size:12px">✓ Contracted</span>':'<span style="color:#B45309;font-size:12px">In progress</span>')+'</td>'
      + '</tr>';
  }).join('');
  document.getElementById('lic-body').innerHTML =
    '<table style="width:100%;border-collapse:collapse;font-size:13px">'
    + '<thead><tr style="background:#F8FAFC;border-bottom:2px solid #E2E8F0">'
    + '<th style="padding:10px;text-align:left;color:#374151;font-weight:600">Candidate</th>'
    + '<th style="padding:10px;text-align:left;color:#374151;font-weight:600">ID</th>'
    + '<th style="padding:10px;text-align:left;color:#374151;font-weight:600">SC CMSRL</th>'
    + '<th style="padding:10px;text-align:left;color:#374151;font-weight:600">FIMM</th>'
    + '<th style="padding:10px;text-align:left;color:#374151;font-weight:600">iFAST</th>'
    + '<th style="padding:10px;text-align:left;color:#374151;font-weight:600">Contract</th>'
    + '<th style="padding:10px;text-align:left;color:#374151;font-weight:600">Status</th>'
    + '</tr></thead><tbody>'+trs+'</tbody></table>';
}

function openAddCandidateModal(){
  var m=document.createElement('div'); m.id='lic-add-modal';
  m.style.cssText='position:fixed;inset:0;z-index:99999;background:rgba(11,37,69,.45);display:flex;align-items:center;justify-content:center;padding:16px';
  m.onclick=function(e){if(e.target===m)m.remove();};
  m.innerHTML='<div style="background:#fff;border-radius:16px;max-width:400px;width:100%;padding:24px;box-sizing:border-box">'
    + '<div style="font-size:16px;font-weight:700;color:#0B2545;margin-bottom:16px">Add New Candidate</div>'
    + '<div style="margin-bottom:12px"><label style="font-size:11px;font-weight:600;color:#374151;display:block;margin-bottom:4px">Full Name</label>'
    + '<input type="text" id="add-cand-name" placeholder="e.g. CHAN MEI LING" style="width:100%;box-sizing:border-box;padding:9px;border:1px solid #D1D5DB;border-radius:8px;font-size:13px;font-family:inherit"></div>'
    + '<div style="margin-bottom:20px"><label style="font-size:11px;font-weight:600;color:#374151;display:block;margin-bottom:4px">Candidate ID</label>'
    + '<input type="text" id="add-cand-id" placeholder="e.g. LIFA011 or REC-001" style="width:100%;box-sizing:border-box;padding:9px;border:1px solid #D1D5DB;border-radius:8px;font-size:13px;font-family:inherit"></div>'
    + '<div style="display:flex;gap:10px;justify-content:flex-end">'
    + '<button onclick="document.getElementById(\'lic-add-modal\').remove()" style="background:#fff;border:1px solid #D1D5DB;color:#374151;padding:9px 18px;border-radius:8px;font-size:13px;cursor:pointer">Cancel</button>'
    + '<button onclick="saveNewCandidate()" style="background:#0B2545;color:#fff;border:0;padding:9px 18px;border-radius:8px;font-size:13px;font-weight:600;cursor:pointer">Add</button>'
    + '</div></div>';
  document.body.appendChild(m);
  document.getElementById('add-cand-name').focus();
}

async function saveNewCandidate(){
  const name = (document.getElementById('add-cand-name').value||'').trim().toUpperCase();
  const id   = (document.getElementById('add-cand-id').value||'').trim().toUpperCase().replace(/\s+/g,'-');
  if(!name||!id){ alert('Name and ID are required.'); return; }
  try {
    await api('/api/licensing/'+encodeURIComponent(id), {method:'PUT', body:JSON.stringify({candidate_name:name, sc_status:'pending', fimm_status:'pending'})});
    document.getElementById('lic-add-modal').remove();
    const d = await apiGet('/api/licensing');
    _licData = d;
    _renderLicTable(d);
  } catch(e){ alert('Failed: '+String(e)); }
}

function openLicModal(id){
  const rows = (_licData&&_licData.rows)||[];
  const r = rows.find(function(x){return x.adviser_id===id;}) || {adviser_id:id};
  const name = r.adviser_name || r.candidate_name || id;
  var m=document.createElement('div'); m.id='lic-modal';
  m.style.cssText='position:fixed;inset:0;z-index:99999;background:rgba(11,37,69,.45);display:flex;align-items:center;justify-content:center;padding:16px';
  m.onclick=function(e){if(e.target===m)m.remove();};
  m.innerHTML='<div style="background:#fff;border-radius:16px;max-width:520px;width:100%;padding:24px;box-sizing:border-box;max-height:90vh;overflow-y:auto">'
    + '<div style="font-size:16px;font-weight:700;color:#0B2545;margin-bottom:16px">'+escapeHtml(name)+' — Licensing</div>'

    + '<div style="font-size:12px;font-weight:600;color:#374151;margin-bottom:8px">SC CMSRL</div>'
    + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:12px">'
    + _licField('sc_status','Status','select',r.sc_status||'pending',Object.keys(SC_STATUS))
    + _licField('sc_app_date','EASy Submission Date','date',r.sc_app_date||'','')
    + _licField('sc_ref','SC Case / Approval Ref','text',r.sc_ref||'','e.g. L/2025/04057')
    + _licField('sc_approved_date','Approval Date','date',r.sc_approved_date||'','')
    + '</div>'
    + '<div style="margin-bottom:12px"><label style="font-size:11px;font-weight:600;color:#374151;display:block;margin-bottom:4px">SC Notes / Returns</label>'
    + '<textarea id="lf-sc_notes" rows="2" style="width:100%;box-sizing:border-box;padding:8px;border:1px solid #D1D5DB;border-radius:8px;font-size:12px;font-family:inherit;resize:vertical">'+escapeHtml(r.sc_notes||'')+'</textarea></div>'

    + '<div style="font-size:12px;font-weight:600;color:#374151;margin-bottom:8px">FIMM Consultant Registration</div>'
    + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:12px">'
    + _licField('fimm_status','Status','select',r.fimm_status||'pending',Object.keys(FIMM_STATUS))
    + _licField('fimm_ticket','Ticket No.','text',r.fimm_ticket||'','e.g. INC-13335')
    + _licField('fimm_approved_date','Approval Date','date',r.fimm_approved_date||'','')
    + '</div>'
    + '<div style="margin-bottom:12px"><label style="font-size:11px;font-weight:600;color:#374151;display:block;margin-bottom:4px">FIMM Issue / Blocker</label>'
    + '<textarea id="lf-fimm_issue" rows="2" style="width:100%;box-sizing:border-box;padding:8px;border:1px solid #D1D5DB;border-radius:8px;font-size:12px;font-family:inherit;resize:vertical">'+escapeHtml(r.fimm_issue||'')+'</textarea></div>'

    + '<div style="font-size:12px;font-weight:600;color:#374151;margin-bottom:8px">iFAST & Contract</div>'
    + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:12px">'
    + _licField('ifast_code','iFAST Code','text',r.ifast_code||'','e.g. LFA00009')
    + _licField('ifast_date','Account Created','date',r.ifast_date||'','')
    + '</div>'
    + '<label style="display:flex;align-items:center;gap:8px;margin-bottom:16px;cursor:pointer;font-size:13px">'
    + '<input type="checkbox" id="lf-contract_signed" '+(r.contract_signed?'checked':'')+' style="width:16px;height:16px"> Appointment agreement signed</label>'

    + '<div style="margin-bottom:16px"><label style="font-size:11px;font-weight:600;color:#374151;display:block;margin-bottom:4px">Notes</label>'
    + '<textarea id="lf-notes" rows="2" style="width:100%;box-sizing:border-box;padding:8px;border:1px solid #D1D5DB;border-radius:8px;font-size:12px;font-family:inherit;resize:vertical">'+escapeHtml(r.notes||'')+'</textarea></div>'

    + '<div style="display:flex;gap:10px;justify-content:flex-end">'
    + '<button onclick="document.getElementById(\'lic-modal\').remove()" style="background:#fff;border:1px solid #D1D5DB;color:#374151;padding:9px 18px;border-radius:8px;font-size:13px;cursor:pointer">Cancel</button>'
    + '<button onclick="saveLicensing(\''+escapeHtml(id)+'\')" style="background:#0B2545;color:#fff;border:0;padding:9px 18px;border-radius:8px;font-size:13px;font-weight:600;cursor:pointer">Save</button>'
    + '</div></div>';
  document.body.appendChild(m);
}

function _licField(id, label, type, value, placeholder){
  if(type==='select'){
    const opts = (typeof placeholder==='string'?[]:placeholder).map(function(k){
      const labels={pending:'Pending',submitted:'Submitted',returned:'Returned',approved:'Approved',documents_required:'Docs Required'};
      return '<option value="'+k+'"'+(value===k?' selected':'')+'>'+escapeHtml(labels[k]||k)+'</option>';
    }).join('');
    return '<div><label style="font-size:11px;font-weight:600;color:#374151;display:block;margin-bottom:4px">'+escapeHtml(label)+'</label>'
      + '<select id="lf-'+id+'" style="width:100%;padding:8px;border:1px solid #D1D5DB;border-radius:8px;font-size:12px;font-family:inherit">'+opts+'</select></div>';
  }
  return '<div><label style="font-size:11px;font-weight:600;color:#374151;display:block;margin-bottom:4px">'+escapeHtml(label)+'</label>'
    + '<input type="'+type+'" id="lf-'+id+'" value="'+escapeHtml(value)+'" placeholder="'+escapeHtml(placeholder||'')+'" style="width:100%;box-sizing:border-box;padding:8px;border:1px solid #D1D5DB;border-radius:8px;font-size:12px;font-family:inherit"></div>';
}

async function saveLicensing(id){
  function v(fid){ var el=document.getElementById('lf-'+fid); return el?(el.type==='checkbox'?el.checked:el.value.trim()):null; }
  const body = {
    sc_status:v('sc_status'), sc_ref:v('sc_ref'), sc_app_date:v('sc_app_date'),
    sc_approved_date:v('sc_approved_date'), sc_notes:v('sc_notes'),
    fimm_status:v('fimm_status'), fimm_ticket:v('fimm_ticket'), fimm_issue:v('fimm_issue'),
    fimm_approved_date:v('fimm_approved_date'),
    ifast_code:v('ifast_code'), ifast_date:v('ifast_date'),
    contract_signed:v('contract_signed'), notes:v('notes')
  };
  try {
    await api('/api/licensing/'+encodeURIComponent(id), {method:'PUT', body:JSON.stringify(body)});
    document.getElementById('lic-modal').remove();
    renderLicensing();
  } catch(e) { alert('Save failed: '+String(e)); }
}

async function emailContractLink(id){
  try{
    const r = await api('/api/intake/'+id+'/email-contract', {method:'POST'});
    if(r.already) showToast('warn','Agreement already signed — no email sent.');
    else showToast('success','Contract link emailed to candidate.');
  }catch(e){ showToast('error','Failed to send: '+String(e)); }
}

function openDirectInviteModal(){
  var m=document.createElement('div'); m.id='direct-invite-modal';
  m.style.cssText='position:fixed;inset:0;z-index:99999;background:rgba(11,37,69,.45);display:flex;align-items:center;justify-content:center;padding:16px';
  m.onclick=function(e){if(e.target===m)m.remove();};
  m.innerHTML='<div style="background:#fff;border-radius:16px;max-width:400px;width:100%;padding:24px;box-sizing:border-box">'
    +'<div style="font-size:16px;font-weight:700;color:#0B2545;margin-bottom:4px">Send intake link</div>'
    +'<div style="font-size:12px;color:#6B7280;margin-bottom:20px">For direct LIFA recruits — no recruiter upline</div>'
    +'<div style="margin-bottom:14px"><label style="font-size:12px;font-weight:600;color:#374151;display:block;margin-bottom:5px">Candidate Full Name</label>'
    +'<input id="di-name" type="text" placeholder="CHAN MEI LING" style="width:100%;box-sizing:border-box;padding:10px 12px;border:1.5px solid #D1D5DB;border-radius:10px;font-size:14px;font-family:inherit;text-transform:uppercase"></div>'
    +'<div style="margin-bottom:20px"><label style="font-size:12px;font-weight:600;color:#374151;display:block;margin-bottom:5px">Email Address</label>'
    +'<input id="di-email" type="email" placeholder="candidate@email.com" style="width:100%;box-sizing:border-box;padding:10px 12px;border:1.5px solid #D1D5DB;border-radius:10px;font-size:14px;font-family:inherit"></div>'
    +'<div style="display:flex;gap:10px;justify-content:flex-end">'
    +'<button onclick="document.getElementById(\'direct-invite-modal\').remove()" style="background:#fff;border:1px solid #D1D5DB;color:#374151;padding:9px 18px;border-radius:8px;font-size:13px;cursor:pointer">Cancel</button>'
    +'<button onclick="sendDirectInvite()" style="background:#0B2545;color:#fff;border:0;padding:9px 18px;border-radius:8px;font-size:13px;font-weight:600;cursor:pointer">Send invite</button>'
    +'</div></div>';
  document.body.appendChild(m);
  setTimeout(function(){ document.getElementById('di-name')&&document.getElementById('di-name').focus(); },100);
}

async function sendDirectInvite(){
  const name=(document.getElementById('di-name').value||'').trim().toUpperCase();
  const email=(document.getElementById('di-email').value||'').trim().toLowerCase();
  if(!name||!email){ showToast('error','Name and email are required.'); return; }
  try{
    await api('/api/intake/create-direct',{method:'POST',body:JSON.stringify({name,email})});
    document.getElementById('direct-invite-modal')?.remove();
    showToast('success','Invite sent to '+email);
  }catch(e){ showToast('error','Failed: '+String(e)); }
}

function openIntakePreview(id){
  apiGet('/api/intake/'+id).then(function(r){
    var m=document.createElement('div'); m.id='intake-preview-modal';
    m.style.cssText='position:fixed;inset:0;z-index:99999;background:rgba(11,37,69,.45);display:flex;align-items:center;justify-content:center;padding:16px';
    m.onclick=function(e){if(e.target===m)m.remove();};
    const esc=escapeHtml;
    const sec=function(title,body){ return '<div style="margin-bottom:20px"><div style="font-size:11px;font-weight:700;color:#0B2545;text-transform:uppercase;letter-spacing:.5px;margin-bottom:10px;padding-bottom:6px;border-bottom:1px solid #E2E8F0">'+title+'</div>'+body+'</div>'; };
    const row=function(label,val){ return val?'<div style="display:flex;justify-content:space-between;align-items:flex-start;padding:5px 0;border-bottom:1px solid #F8FAFC"><span style="font-size:11px;color:#6B7280;min-width:130px;flex-shrink:0">'+esc(label)+'</span><span style="font-size:13px;color:#0B2545;text-align:right">'+esc(String(val))+'</span></div>':''; };
    var emps=''; try{ var eh=JSON.parse(r.employment_history||'[]'); emps=eh.map(function(e){ return row(e.employer||'—',(e.start_month||'')+' '+(e.start_year||'')+' – '+(e.is_current?'Present':(e.end_month||'')+' '+(e.end_year||''))); }).join(''); }catch(x){}
    const docBadge=function(label,ok){ return '<span style="display:inline-block;margin:2px 4px 2px 0;padding:3px 10px;border-radius:8px;font-size:11px;font-weight:600;background:'+(ok?'#DCFCE7':'#FEF2F2')+';color:'+(ok?'#15803D':'#DC2626')+'">'+(ok?'✓ ':'')+label+'</span>'; };
    m.innerHTML='<div style="background:#fff;border-radius:16px;max-width:600px;width:100%;padding:28px;box-sizing:border-box;max-height:92vh;overflow-y:auto">'
      +'<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:20px">'
      +'<div style="font-size:17px;font-weight:700;color:#0B2545">'+esc(r.full_name||id)+'</div>'
      +'<button onclick="document.getElementById(\'intake-preview-modal\').remove()" style="background:#F1F5F9;border:0;color:#374151;width:30px;height:30px;border-radius:8px;cursor:pointer;font-size:16px;line-height:1">✕</button>'
      +'</div>'
      +sec('Personal',
        row('IC Number',r.ic_number)+row('Date of Birth',r.dob)+row('Email',r.email)+row('Phone',r.phone)+row('Address',r.address))
      +sec('Education',
        row('Qualification',r.education_level)+row('Institution',r.institution)+row('Grad Year',r.grad_year)+row('AIA PRS',r.is_aia_prs?'Yes':'No'))
      +(emps?sec('Employment History',emps):'')
      +sec('Documents',
        docBadge('IC',r.has_ic)+docBadge('Degree',r.has_degree)+docBadge('CFP/RFP Cert',r.has_professional_cert)
        +docBadge('Membership',r.has_membership)+docBadge('Passport Photo',r.has_photo)
        +(r.is_aia_prs?docBadge('AIA Cert',r.has_aia_cert):'')+docBadge('Receipt',r.has_payment))
      +sec('Payment',
        row('Bank',r.payment_bank)+row('Date',r.payment_date)+row('Ref No.',r.payment_ref)+row('Amount',r.payment_amount?'RM '+r.payment_amount:''))
      +sec('Signature & Contract',
        row('Review signature',r.signature_name)
        +(r.contract_signed?row('Agreement signed by',r.contract_signed_name)+''+row('Signed on',r.contract_signed_at?new Date(r.contract_signed_at*1000).toLocaleString('en-MY'):''):row('Agreement','Not yet signed')))
      +'</div>';
    document.getElementById('intake-modal')?.remove();
    document.body.appendChild(m);
  }).catch(function(e){ showToast('error','Failed to load: '+String(e)); });
}


// ── CIRCULARS — firm circulars every member can view (admin uploads) ─────────
async function renderCircularsView() {
  const el = document.getElementById("main-content");
  el.innerHTML = '<div class="card"><h2 style="margin-top:0">📜 Circulars</h2><p class="hint">Official firm circulars. Tap a circular to view the PDF.</p><div id="circ-admin"></div><div id="circ-list">Loading…</div></div>';
  if (typeof isAdmin !== "undefined" && isAdmin) {
    document.getElementById("circ-admin").innerHTML =
      '<div style="border:1px dashed #CBD5E1;border-radius:10px;padding:12px;margin:10px 0 16px">' +
      '<b style="font-size:13px">Upload a circular (admin)</b>' +
      '<div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:8px;align-items:center">' +
      '<input id="circ-title" placeholder="Circular title" style="flex:2;min-width:220px;padding:8px;border:1px solid #CBD5E1;border-radius:8px">' +
      '<input id="circ-date" type="date" style="padding:8px;border:1px solid #CBD5E1;border-radius:8px">' +
      '<input id="circ-file" type="file" accept="application/pdf" style="font-size:12px">' +
      '<button class="btn" onclick="uploadCircular()">Upload</button></div>' +
      '<div id="circ-up-msg" class="hint"></div></div>';
    const d = document.getElementById("circ-date"); if (d) d.value = new Date().toISOString().slice(0,10);
  }
  try {
    const admin = (typeof isAdmin !== "undefined" && isAdmin);
    const rows = await apiGet("/api/circulars");
    if (!Array.isArray(rows) || !rows.length) { document.getElementById("circ-list").innerHTML = '<p class="hint">No circulars yet.</p>'; return; }
    document.getElementById("circ-list").innerHTML =
      '<table style="width:100%;border-collapse:collapse;font-size:13px">' +
      '<tr><th style="text-align:left;padding:8px;border-bottom:1px solid #E2E8F0">Date</th><th style="text-align:left;padding:8px;border-bottom:1px solid #E2E8F0">Circular</th><th style="padding:8px;border-bottom:1px solid #E2E8F0"></th></tr>' +
      rows.map(r => '<tr><td style="padding:8px;border-bottom:1px solid #F1F5F9;white-space:nowrap">' + (r.version || (r.created_at||"").slice(0,10)) + '</td>' +
        '<td style="padding:8px;border-bottom:1px solid #F1F5F9"><b>' + escapeHtmlUi(r.title||"") + '</b></td>' +
        '<td style="padding:8px;border-bottom:1px solid #F1F5F9;text-align:right;white-space:nowrap"><button class="btn btn-sm" onclick="viewCircular(' + r.id + ')">View PDF</button>' +
        (admin ? ' <button class="btn btn-sm" style="background:#FEE2E2;color:#B91C1C;border-color:#FCA5A5" onclick="deleteCircular(' + r.id + ',\'' + escapeHtmlUi(String(r.title||"")).replace(/'/g,"\\'") + '\')">Delete</button>' : '') +
        '</td></tr>').join("") +
      '</table>';
  } catch (e) { document.getElementById("circ-list").innerHTML = '<p class="hint">Could not load circulars — please try again.</p>'; }
}
async function deleteCircular(id, title) {
  if (!confirm('Delete this circular?\n\n"' + (title || '') + '"\n\nThis removes it for everyone and cannot be undone.')) return;
  try {
    const r = await fetch(API + "/api/circulars/" + id, { method: "DELETE", headers: _apiHeaders() });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) { alert(d.error || "Could not delete — please try again."); return; }
    renderCircularsView();
  } catch (e) { alert("Could not delete — please try again."); }
}
function escapeHtmlUi(s){ return String(s).replace(/[&<>"']/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c])); }
async function viewCircular(id) {
  try {
    const r = await fetch(API + "/api/circulars/" + id + "/file", { headers: _apiHeaders() });
    if (!r.ok) { alert("Could not open the circular — please try again."); return; }
    const blob = await r.blob();
    window.open(URL.createObjectURL(blob), "_blank");
  } catch (e) { alert("Could not open the circular — please try again."); }
}
async function uploadCircular() {
  const msg = document.getElementById("circ-up-msg");
  const f = document.getElementById("circ-file").files[0];
  // A PDF is the only hard requirement. If no title is typed, use the file name
  // (cleaned) so choosing a file + clicking Upload just works — the old code
  // silently blocked on an empty title, which read as "Upload not responding".
  if (!f) { msg.style.color = "#B91C1C"; msg.textContent = "Choose a PDF file first."; return; }
  let title = (document.getElementById("circ-title").value || "").trim();
  if (!title) title = (f.name || "Circular").replace(/\.[^.]+$/, "").replace(/[_-]+/g, " ").trim();
  const date = document.getElementById("circ-date").value || "";
  msg.style.color = "#64748B"; msg.textContent = "Uploading…";
  try {
    const b64 = await new Promise((res, rej) => { const rd = new FileReader(); rd.onload = () => res(String(rd.result).split(",")[1]); rd.onerror = rej; rd.readAsDataURL(f); });
    const out = await apiPost("/api/circulars/upload", { title, date, filename: f.name, pdf_base64: b64 });
    if (out && out.ok) { msg.style.color = "#15803D"; msg.textContent = "✓ Uploaded “" + title + "”."; renderCircularsView(); }
    else { msg.style.color = "#B91C1C"; msg.textContent = (out && out.error) || "Upload failed — please try again."; }
  } catch (e) { msg.style.color = "#B91C1C"; msg.textContent = "Could not read the file — please try again."; }
}

// ── COMMISSION SIMULATOR ─────────────────────────────────────────────────────
// "What do I earn?" — on one sale, or across the year. Rates are NOT invented
// here: the ladders are LIFA PLANNERS Handbook V.2026 §5/6/7 (also circular #12),
// and the will-writing shares are circular LP/WILL/2026-02. Both are the same
// tables the live payout engine uses (WP_TIERS / MGR_TIERS / VP_TIERS above).
var SIM_WP  = [ {min:100000,rate:0.70,rank:"Associate Partner"},
                {min:50000, rate:0.60,rank:"Elite Wealth Planner"},
                {min:0,     rate:0.50,rank:"Wealth Planner"} ];
var SIM_MGR = [ {min:300000,rate:0.12,rank:"Partner"},
                {min:200000,rate:0.10,rank:"Senior Manager"},
                {min:0,     rate:0.06,rank:"Manager"} ];
var SIM_VP  = [ {min:600000,rate:0.06,rank:"Senior Partner"},
                {min:400000,rate:0.04,rank:"Senior Vice President"},
                {min:0,     rate:0.02,rank:"Vice President"} ];
// What reaches LIFA of each product's charge.
var SIM_IFAST = { ut:{type:"share",v:0.85}, bond:{type:"flat",v:0.002}, wrap:{type:"flat",v:0.0025} };
var SIM_MAXCHG = { ut:5, bond:2, wrap:1 };
// Trailer: the fund's annual management charge is split ~half to the platform,
// and iFAST shares 35% of its half with LIFA → 1.5% x 0.5 x 0.35 = 0.2625% p.a.
var SIM_TRAIL_PLATFORM = 0.5, SIM_TRAIL_SHARE = 0.35;
// Will writing — circular LP/WILL/2026-02. FLAT shares, no revenue ladder.
// A VP/EXCO-tier adviser WRITING it themselves takes the whole pool instead.
var SIM_PKG = { simple:{label:"Silver",fee:800}, comprehensive:{label:"Gold",fee:1500}, platinum:{label:"Platinum",fee:3000} };
var SIM_CUSTODY_FEE = 1000, SIM_SPOUSE_OFF = 0.15;
var SIM_WCOMM = {
  will:      { full:{writer:0.70}, advisor:{writer:0.50, direct:0.12, indirect:0.08} },
  custodian: { full:{writer:0.52}, advisor:{writer:0.40, direct:0.08, indirect:0.04} }
};

var SIM = { name:"", position:"", ownRev:0, directRev:0, groupRev:0, willTier:"advisor" };
var _simPOV = "own", _simKIND = "txn";

function _simRM(n){ return 'RM '+Number(n||0).toLocaleString('en-MY',{minimumFractionDigits:2,maximumFractionDigits:2}); }
function _simTier(t, rev){ for(var i=0;i<t.length;i++){ if(Number(rev||0)>=t[i].min) return t[i]; } return t[t.length-1]; }
function _simBandP(){ return _simTier(SIM_WP,  SIM.ownRev); }
function _simBandM(){ return _simTier(SIM_MGR, SIM.directRev); }
function _simBandV(){ return _simTier(SIM_VP,  SIM.groupRev); }
function _simIsExco(){ return /EXCOMM/i.test(SIM.position||""); }
// Levels with a team beneath them / above a Manager.
function _simMgrLvl(){ return /MANAGER|VP|VICE PRESIDENT|EXCOMM|PARTNER/i.test(SIM.position||""); }
function _simVPLvl(){  return /VP|VICE PRESIDENT|EXCOMM/i.test(SIM.position||""); }
// Will tier is set SEPARATELY on the adviser record. Usually it matches the
// investment rank, but some advisers are Wealth Planner on investment and
// full-pool (exco/VP) on will — deriving it from the rank underpays them.
function _simWillTier(row){
  var t = String((row && row.will_comm_tier) || "").toLowerCase().trim();
  if (t==="full"||t==="exco"||t==="vp"||t==="excomm") return "full";
  if (t==="advisor") return "advisor";
  return /VP|VICE PRESIDENT|EXCOMM/i.test(String((row&&row.rank)||"")+" "+String((row&&row.category)||"")) ? "full" : "advisor";
}

// What the viewer earns on the selected sale, as named components.
function _simParts(){
  var out=[];
  if(_simPOV==="own"){
    out.push({label:"Personal ("+_simBandP().rank+") "+Math.round(_simBandP().rate*100)+"%", rate:_simBandP().rate, kind:"p"});
    var kids=[];
    if(_simMgrLvl()) kids.push({label:Math.round(_simBandM().rate*100)+"% Manager ("+_simBandM().rank+")", rate:_simBandM().rate});
    if(_simVPLvl())  kids.push({label:Math.round(_simBandV().rate*100)+"% Vice President ("+_simBandV().rank+")", rate:_simBandV().rate});
    if(kids.length) out.push({label:"Direct team over-riding", kind:"g", kids:kids});
  } else if(_simPOV==="direct"){
    var k2=[];
    if(_simMgrLvl()) k2.push({label:Math.round(_simBandM().rate*100)+"% Manager ("+_simBandM().rank+")", rate:_simBandM().rate});
    if(_simVPLvl())  k2.push({label:Math.round(_simBandV().rate*100)+"% Vice President ("+_simBandV().rank+")", rate:_simBandV().rate});
    if(k2.length) out.push({label:"Direct team over-riding", kind:"g", kids:k2});
  } else if(_simVPLvl()){
    out.push({label:"Indirect over-riding ("+_simBandV().rank+") "+Math.round(_simBandV().rate*100)+"%", rate:_simBandV().rate, kind:"o"});
  }
  return out;
}
function _simPartRate(p){ return p.kind==="g" ? p.kids.reduce(function(n,k){return n+k.rate;},0) : p.rate; }
function _simTotalRate(){ return _simParts().reduce(function(n,p){ return n+_simPartRate(p); }, 0); }

function _simRow(l,v,c){
  return '<div style="display:flex;justify-content:space-between;gap:12px;padding:7px 0;font-size:13px;border-bottom:1px solid #EEF2F8"><span>'+l+
    '</span><span style="font-weight:700;white-space:nowrap;color:'+(c||'#0B2545')+'">'+_simRM(v)+'</span></div>';
}
function _simRenderPart(p, lifa){
  if(p.kind!=="g") return _simRow("Your share — "+p.label, lifa*p.rate, p.kind==="o"?"#1D4ED8":"#0B2545");
  var h = '<div style="display:flex;justify-content:space-between;padding:7px 0 2px;font-size:13px"><span><b>Your share — '+p.label+'</b></span><span></span></div>';
  p.kids.forEach(function(k){
    h += '<div style="display:flex;justify-content:space-between;padding:3px 0 3px 16px;font-size:13px"><span style="color:#6B7280">'+k.label+
      '</span><span style="font-weight:700;color:#1D4ED8">'+_simRM(lifa*k.rate)+'</span></div>';
  });
  var t=_simPartRate(p);
  h += '<div style="display:flex;justify-content:space-between;padding:3px 0 7px 16px;font-size:13px;border-bottom:1px solid #EEF2F8"><span><b>Total '+
    Math.round(t*100)+'%</b></span><span style="font-weight:700;color:#1D4ED8">'+_simRM(lifa*t)+'</span></div>';
  return h;
}

async function renderSimulatorView(){
  var el=document.getElementById("main-content");
  el.innerHTML='<div class="card"><p class="hint">Loading your rates…</p></div>';
  // Rank + will tier come from the adviser's own record — never chosen here.
  var me=null; try{ me=await apiGet('/api/me'); }catch(e){}
  SIM.name = (me && (me.display_name||me.name)) || "";
  SIM.position = (me && me.rank) || "Wealth Planner";
  SIM.willTier = _simWillTier(me||{});
  // Own revenue = investment commission + will fees (owner ruling: will fees
  // count toward adviser revenue and the tier band).
  SIM.ownRev = 0;
  try{
    var sts=await apiGet('/api/statements'); var yr=String(new Date().getFullYear());
    if(Array.isArray(sts)) sts.forEach(function(s){
      if(String(s.period||"").indexOf(yr)>=0) SIM.ownRev += (Number(s.ifast_comm)||0)+(Number(s.fp_base)||0);
    });
    SIM.ownRev = Math.round(SIM.ownRev);
  }catch(e){}

  var btn=function(id,fn,label,on){ return '<button id="'+id+'" onclick="'+fn+'" style="flex:1;padding:9px;border-radius:9px;border:1.5px solid '+
    (on?'#0B2545':'#E2E8F0')+';background:'+(on?'#0B2545':'#fff')+';color:'+(on?'#fff':'#374151')+';font-weight:700;font-size:13px;cursor:pointer">'+label+'</button>'; };

  el.innerHTML='<div class="card"><h2 style="margin-top:0">💰 Commission Simulator</h2>'
    +'<p class="hint">What you earn — on one sale, or across the year. Nothing is saved.</p>'
    +'<div id="sim-who" style="background:#FBF3DF;border:1px solid #E8DCC0;border-radius:10px;padding:10px 12px;margin:14px 0 16px;font-size:12.5px;color:#374151"></div>'
    +'<div style="display:flex;gap:8px;margin-bottom:16px">'+btn("sim-t-sale","simMode('sale')","This sale",true)+btn("sim-t-year","simMode('year')",String(new Date().getFullYear())+" (current tier)",false)+'</div>'
    +'<div id="sim-sale">'
    +  '<div id="sim-pov-wrap" style="display:none">'
    +    '<div style="font-size:11px;color:#6B7280;text-transform:uppercase;letter-spacing:.45px;font-weight:650;margin-bottom:7px">Whose sale is this?</div>'
    +    '<div style="display:flex;gap:8px;margin-bottom:14px">'
    +      btn("sim-v-own","simPov('own')","Personal sale",true)
    +      btn("sim-v-direct","simPov('direct')","Direct team over-riding",false)
    +      '<button id="sim-v-indirect" onclick="simPov(\'indirect\')" style="flex:1;padding:9px;border-radius:9px;border:1.5px solid #E2E8F0;background:#fff;color:#374151;font-weight:700;font-size:13px;cursor:pointer;display:none">Indirect over-riding</button>'
    +    '</div></div>'
    +  '<div style="font-size:11px;color:#6B7280;text-transform:uppercase;letter-spacing:.45px;font-weight:650;margin-bottom:7px">Type of income</div>'
    +  '<div style="display:flex;gap:8px;margin-bottom:14px">'
    +    btn("sim-k-txn","simKind('txn')","Transaction",true)+btn("sim-k-rec","simKind('rec')","Recurring",false)+btn("sim-k-will","simKind('will')","Will writing",false)+'</div>'
    +  '<div id="sim-k-txn-p"><div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:12px;margin-bottom:14px">'
    +    '<div><label style="font-size:12px;font-weight:650;color:#374151;display:block;margin-bottom:5px">Product</label>'
    +      '<select id="sim-prod" onchange="simProd()" style="width:100%;padding:9px;border:1.5px solid #E2E8F0;border-radius:9px;font-size:14px"><option value="ut">Unit Trust</option><option value="bond">Wholesale Bond</option></select></div>'
    +    '<div><label style="font-size:12px;font-weight:650;color:#374151;display:block;margin-bottom:5px">Investment amount (RM)</label>'
    +      '<input type="number" id="sim-amt" value="100000" min="0" step="10000" oninput="simCalc()" style="width:100%;padding:9px;border:1.5px solid #E2E8F0;border-radius:9px;font-size:14px"></div>'
    +    '<div><label id="sim-chg-l" style="font-size:12px;font-weight:650;color:#374151;display:block;margin-bottom:5px">Sales charge (%)</label>'
    +      '<input type="number" id="sim-chg" value="5" min="0" max="5" step="0.25" oninput="simCalc()" style="width:100%;padding:9px;border:1.5px solid #E2E8F0;border-radius:9px;font-size:14px"></div>'
    +  '</div></div>'
    +  '<div id="sim-k-rec-p" style="display:none">'
    +    '<label style="display:flex;gap:8px;align-items:center;font-size:12.5px;margin-bottom:10px;cursor:pointer"><input type="checkbox" id="sim-r-wrap" checked onchange="simCalc()"> Wrap fee</label>'
    +    '<label style="display:flex;gap:8px;align-items:center;font-size:12.5px;margin-bottom:14px;cursor:pointer"><input type="checkbox" id="sim-r-trail" checked onchange="simCalc()"> Trailer fee</label>'
    +    '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:12px;margin-bottom:14px">'
    +      '<div><label style="font-size:12px;font-weight:650;color:#374151;display:block;margin-bottom:5px">Portfolio / AUM (RM)</label>'
    +        '<input type="number" id="sim-raum" value="1000000" min="0" step="100000" oninput="simCalc()" style="width:100%;padding:9px;border:1.5px solid #E2E8F0;border-radius:9px;font-size:14px"></div>'
    +      '<div><label style="font-size:12px;font-weight:650;color:#374151;display:block;margin-bottom:5px">Wrap fee (% per year)</label>'
    +        '<input type="number" id="sim-wfee" value="1" min="0" max="1" step="0.05" oninput="simCalc()" style="width:100%;padding:9px;border:1.5px solid #E2E8F0;border-radius:9px;font-size:14px"></div>'
    +      '<div><label style="font-size:12px;font-weight:650;color:#374151;display:block;margin-bottom:5px">Fund management charge (% p.a.)</label>'
    +        '<input type="number" id="sim-mgmt" value="1.5" min="0" max="3" step="0.05" oninput="simCalc()" style="width:100%;padding:9px;border:1.5px solid #E2E8F0;border-radius:9px;font-size:14px"></div>'
    +  '</div></div>'
    +  '<div id="sim-k-will-p" style="display:none">'
    +    '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:12px;margin-bottom:12px">'
    +      '<div><label style="font-size:12px;font-weight:650;color:#374151;display:block;margin-bottom:5px">Will package</label>'
    +        '<select id="sim-wpkg" onchange="simCalc()" style="width:100%;padding:9px;border:1.5px solid #E2E8F0;border-radius:9px;font-size:14px">'
    +        '<option value="none">— none —</option><option value="simple">Silver — RM 800</option><option value="comprehensive" selected>Gold — RM 1,500</option><option value="platinum">Platinum — RM 3,000</option></select></div>'
    +      '<div><label style="font-size:12px;font-weight:650;color:#374151;display:block;margin-bottom:5px">How many cases</label>'
    +        '<input type="number" id="sim-wqty" value="1" min="0" max="50" step="1" oninput="simCalc()" style="width:100%;padding:9px;border:1.5px solid #E2E8F0;border-radius:9px;font-size:14px"></div>'
    +    '</div>'
    +    '<label style="display:flex;gap:8px;align-items:center;font-size:12.5px;margin-bottom:8px;cursor:pointer"><input type="checkbox" id="sim-w-spouse" onchange="simCalc()"> Spouse bundle — husband &amp; wife together (15% off the combined will fee)</label>'
    +    '<label style="display:flex;gap:8px;align-items:center;font-size:12.5px;margin-bottom:14px;cursor:pointer"><input type="checkbox" id="sim-w-cust" onchange="simCalc()"> Add Will Custodian — RM 1,000 each</label>'
    +  '</div>'
    +  '<div id="sim-out"></div>'
    +'</div>'
    +'<div id="sim-year" style="display:none">'
    +  '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:12px;margin-bottom:10px">'
    +    '<div><label style="font-size:12px;font-weight:650;color:#374151;display:block;margin-bottom:5px">My revenue this year (RM)</label>'
    +      '<input type="number" id="sim-y-own" value="'+(SIM.ownRev||60000)+'" min="0" step="5000" oninput="simYearCalc()" style="width:100%;padding:9px;border:1.5px solid #E2E8F0;border-radius:9px;font-size:14px">'
    +      '<div style="font-size:11px;color:'+(SIM.ownRev>0?'#15803D':'#6B7280')+';margin-top:3px">'+(SIM.ownRev>0?'Your revenue so far this year — adjust to your target.':'Investment commission + will fees.')+'</div></div>'
    +    '<div><label style="font-size:12px;font-weight:650;color:#374151;display:block;margin-bottom:5px">My Unit Trust AUM (RM)</label>'
    +      '<input type="number" id="sim-y-aum" value="0" min="0" step="100000" oninput="simYearCalc()" style="width:100%;padding:9px;border:1.5px solid #E2E8F0;border-radius:9px;font-size:14px">'
    +      '<div style="font-size:11px;color:#6B7280;margin-top:3px">Earns a trailer each year (management charge assumed 1.5%).</div></div>'
    +    '<div id="sim-y-team-wrap" style="display:none"><label style="font-size:12px;font-weight:650;color:#374151;display:block;margin-bottom:5px">My direct team revenue (RM)</label>'
    +      '<input type="number" id="sim-y-team" value="0" min="0" step="10000" oninput="simYearCalc()" style="width:100%;padding:9px;border:1.5px solid #E2E8F0;border-radius:9px;font-size:14px"></div>'
    +  '</div>'
    +  '<div id="sim-y-out"></div>'
    +'</div>'
    +'<div style="margin-top:14px;text-align:right"><button onclick="simExplain(1)" style="background:none;border:0;color:#6B7280;font-size:12px;cursor:pointer">ⓘ How this is calculated</button></div>'
    +'</div>';

  simPaintWho();
  if(_simMgrLvl()){
    document.getElementById("sim-pov-wrap").style.display="";
    document.getElementById("sim-v-indirect").style.display=_simVPLvl()?"":"none";
    document.getElementById("sim-y-team-wrap").style.display="";
  }
  simProd(); simCalc(); simYearCalc();
}

function simPaintWho(){
  var line=function(l,r,rate,c){ return '<div style="display:flex;justify-content:space-between;gap:12px"><span>'+l+
    ' <b style="color:#0B2545">('+r+')</b></span><b style="color:'+c+'">'+Math.round(rate*100)+'%</b></div>'; };
  var L=['<div style="font-size:12px;color:#6B7280">Rank</div>',
         '<div style="font-weight:800;color:#0B2545;font-size:15px;margin-bottom:8px">'+escapeHtmlUi(SIM.position)+'</div>',
         line("Personal", _simBandP().rank, _simBandP().rate, "#0B2545")];
  if(_simMgrLvl()){
    L.push('<div style="margin-top:5px;font-weight:700;color:#0B2545">Over-riding</div>');
    L.push(line("&nbsp;&nbsp;Direct over-riding", _simBandM().rank, _simBandM().rate, "#1D4ED8"));
    if(_simVPLvl()) L.push(line("&nbsp;&nbsp;Indirect over-riding", _simBandV().rank, _simBandV().rate, "#1D4ED8"));
  }
  var wFull=(SIM.willTier==="full");
  L.push('<div style="margin-top:7px;padding-top:6px;border-top:1px solid #E8DCC0;font-weight:700;color:#0B2545">Will writing</div>');
  L.push(line("&nbsp;&nbsp;Writer share", wFull?"VP / EXCO level":"Adviser", wFull?0.70:0.50, "#0B2545"));
  if(wFull && !_simVPLvl()) L.push('<div style="font-size:11px;color:#6B7280;margin-top:2px">Set separately from your investment rank.</div>');
  document.getElementById("sim-who").innerHTML = L.join("");
}

function _simSetBtn(id,on){ var b=document.getElementById(id); if(!b) return;
  b.style.background=on?'#0B2545':'#fff'; b.style.color=on?'#fff':'#374151'; b.style.borderColor=on?'#0B2545':'#E2E8F0'; }
function simMode(m){ var s=(m==="sale");
  document.getElementById("sim-sale").style.display=s?"":"none";
  document.getElementById("sim-year").style.display=s?"none":"";
  _simSetBtn("sim-t-sale",s); _simSetBtn("sim-t-year",!s); if(!s) simYearCalc(); }
function simPov(v){ _simPOV=v; ["own","direct","indirect"].forEach(function(k){ _simSetBtn("sim-v-"+k, k===v); }); simCalc(); }
function simKind(k){ _simKIND=k; ["txn","rec","will"].forEach(function(x){
    var p=document.getElementById("sim-k-"+x+"-p"); if(p) p.style.display=(x===k)?"":"none"; _simSetBtn("sim-k-"+x, x===k); }); simCalc(); }
function simProd(){ var p=document.getElementById("sim-prod").value;
  document.getElementById("sim-chg-l").textContent=(p==="bond")?"Sales charge / spread (%)":"Sales charge (%)";
  var c=document.getElementById("sim-chg"); c.max=SIM_MAXCHG[p]; if(Number(c.value)>SIM_MAXCHG[p]) c.value=SIM_MAXCHG[p]; simCalc(); }

function simCalc(){
  var rate=_simTotalRate(), h='';
  if(_simPOV!=="own") h+='<div style="font-size:11.5px;color:#6B7280;margin-bottom:8px">Showing what <b>you</b> earn when someone in your team writes this — your personal commission is on the other tab.</div>';
  h+='<div style="background:#F8FAFC;border:1px solid #E2E8F0;border-radius:11px;padding:14px 16px;margin-top:4px">';

  if(_simKIND==="txn"){
    var p=document.getElementById("sim-prod").value;
    var amt=Number(document.getElementById("sim-amt").value)||0, chg=Number(document.getElementById("sim-chg").value)||0;
    var client=amt*chg/100, f=SIM_IFAST[p];
    var lifa=(f.type==="share")? client*f.v : amt*Math.max(0,chg/100-f.v);
    var mine=lifa*rate;
    h+='<div style="font-size:11px;color:#6B7280;text-transform:uppercase;letter-spacing:.45px;font-weight:650;margin-bottom:7px">'+(p==="ut"?"Unit Trust":"Wholesale Bond")+' — one-time sales charge</div>'
      + _simRow("Client pays ("+chg+"%)", client)
      + _simRow("iFAST keeps", -(client-lifa), "#6B7280")
      + _simRow("<b>LIFA revenue</b>", lifa)
      + (_simParts().length ? _simParts().map(function(x){ return _simRenderPart(x,lifa); }).join("") : '')
      + (_simParts().length>1 ? _simRow("<b>Your share — total ("+Math.round(rate*100)+"%)</b>", mine, "#15803D") : '')
      + '<div style="margin-top:12px;padding:13px 15px;background:#E6F4EA;border-radius:11px"><div style="font-size:12px;color:#15803D;font-weight:650">Your share — one time</div>'
      + '<div style="font-size:26px;font-weight:800;color:#15803D">'+_simRM(mine)+'</div></div>';

  } else if(_simKIND==="rec"){
    var aum=Number(document.getElementById("sim-raum").value)||0;
    var wfee=Number(document.getElementById("sim-wfee").value)||0, mgmt=Number(document.getElementById("sim-mgmt").value)||0;
    var useW=document.getElementById("sim-r-wrap").checked, useT=document.getElementById("sim-r-trail").checked;
    var wrapL=useW? aum*Math.max(0,wfee/100-SIM_IFAST.wrap.v):0;
    var trailL=useT? aum*(mgmt/100)*SIM_TRAIL_PLATFORM*SIM_TRAIL_SHARE:0;
    var recL=wrapL+trailL, recMine=recL*rate;
    if(!useW && !useT){ h+='<div style="font-size:12px;color:#6B7280">Tick wrap fee or trailer fee to see your recurring income.</div></div>'; document.getElementById("sim-out").innerHTML=h; return; }
    h+='<div style="font-size:11px;color:#6B7280;text-transform:uppercase;letter-spacing:.45px;font-weight:650;margin-bottom:7px">Recurring — every year on '+_simRM(aum).replace('.00','')+'</div>'
      + (useW? _simRow("Wrap fee ("+wfee+"% − iFAST 0.25%)", wrapL):'')
      + (useT? _simRow("Trailer ("+mgmt+"% × 50% × 35%)", trailL):'')
      + ((useW&&useT)? _simRow("<b>Combined LIFA revenue</b>", recL) : _simRow("<b>LIFA revenue</b>", recL))
      + _simRow("<b>Your share ("+Math.round(rate*100)+"%)</b>", recMine, "#15803D")
      + '<div style="margin-top:12px;padding:13px 15px;background:#E6F4EA;border-radius:11px"><div style="font-size:12px;color:#15803D;font-weight:650">Recurring income</div>'
      + '<div style="font-size:26px;font-weight:800;color:#15803D">'+_simRM(recMine)+' <span style="font-size:14px;font-weight:600">a year</span></div></div>';

  } else {
    var pk=document.getElementById("sim-wpkg").value;
    var qty=Math.max(0,Number(document.getElementById("sim-wqty").value)||0);
    var spouse=document.getElementById("sim-w-spouse").checked, wantC=document.getElementById("sim-w-cust").checked;
    var tier=SIM.willTier, wc=SIM_WCOMM.will[tier], cc=SIM_WCOMM.custodian[tier];
    var adv=SIM_WCOMM.will.advisor, cadv=SIM_WCOMM.custodian.advisor;
    var per=spouse?2:1;
    var gross=(pk==="none")?0:SIM_PKG[pk].fee*per*qty;
    var net=spouse? gross*(1-SIM_SPOUSE_OFF) : gross;
    // Circular LP/WILL/2026-02: the over-riding shares are FLAT and always come
    // from the adviser split — the full-pool rate applies only to the WRITER.
    var wRate, wLbl;
    if(_simPOV==="own"){ wRate=wc.writer; wLbl=Math.round(wRate*100)+"% of the fee"; }
    else if(_simPOV==="direct"){ wRate=adv.direct; wLbl="Direct over-riding "+Math.round(wRate*100)+"%"; }
    else { wRate=adv.indirect; wLbl="Indirect over-riding "+Math.round(wRate*100)+"%"; }
    var wMine=net*wRate;
    var cFee=wantC? SIM_CUSTODY_FEE*per*qty : 0;
    var cRate=(_simPOV==="own")? cc.writer : (_simPOV==="direct"? cadv.direct : cadv.indirect);
    var cMine=cFee*cRate, totFee=net+cFee, allMine=wMine+cMine;
    h+='<div style="font-size:11px;color:#6B7280;text-transform:uppercase;letter-spacing:.45px;font-weight:650;margin-bottom:7px">Will writing — '+(tier==="full"?"VP / EXCO tier":"adviser tier")+'</div>';
    if(gross>0){
      h+=_simRow(SIM_PKG[pk].label+" × "+(per*qty)+(spouse?" (spouse bundle)":""), gross)
       + (spouse? _simRow("Spouse bundle discount (15%)", -(gross-net), "#6B7280"):'')
       + _simRow("<b>Will fee collected</b>", net)
       + _simRow("<b>Your share</b> ("+wLbl+")", wMine, "#15803D");
      if(tier!=="full" && _simPOV==="own"){
        h+=_simRow('<span style="color:#6B7280">Goes to your manager ('+Math.round(adv.direct*100)+'%)</span>', net*adv.direct, "#6B7280")
         + _simRow('<span style="color:#6B7280">Goes to your VP ('+Math.round(adv.indirect*100)+'%)</span>', net*adv.indirect, "#6B7280");
      }
    }
    if(cFee>0) h+=_simRow("Will custodian × "+(per*qty), cFee) + _simRow("<b>Your share</b> ("+Math.round(cRate*100)+"%)", cMine, "#15803D");
    h+= totFee>0
      ? '<div style="margin-top:12px;padding:13px 15px;background:#E6F4EA;border-radius:11px"><div style="font-size:12px;color:#15803D;font-weight:650">Your will-writing commission</div>'
        +'<div style="font-size:26px;font-weight:800;color:#15803D">'+_simRM(allMine)+'</div>'
        +'<div style="font-size:12px;color:#15803D">on '+_simRM(totFee)+' of fees collected</div></div>'
      : '<div style="font-size:12px;color:#6B7280">Pick a package or tick the custodian to see your commission.</div>';
  }
  h+='</div>';
  document.getElementById("sim-out").innerHTML=h;
}

function simYearCalc(){
  var own=Number((document.getElementById("sim-y-own")||{}).value)||0;
  var aum=Number((document.getElementById("sim-y-aum")||{}).value)||0;
  var team=Number((document.getElementById("sim-y-team")||{}).value)||0;
  var band=_simTier(SIM_WP,own), rate=band.rate;
  var personal=own*rate;
  var trailL=aum*0.015*SIM_TRAIL_PLATFORM*SIM_TRAIL_SHARE, trailMine=trailL*rate;
  var orInc=0, orBand=null;
  if(_simMgrLvl()){ orBand=_simTier(_simVPLvl()?SIM_VP:SIM_MGR, team); orInc=team*orBand.rate; }
  var total=personal+trailMine+orInc;
  var h='<div style="background:#F8FAFC;border:1px solid #E2E8F0;border-radius:11px;padding:14px 16px">'
    + _simRow("Personal commission ("+band.rank+" · "+Math.round(rate*100)+"%)", personal)
    + (trailMine>0? _simRow("Trailer on "+_simRM(aum).replace('.00','')+" UT AUM", trailMine, "#B8891A"):'')
    + (orBand? _simRow("Over-riding ("+orBand.rank+" · "+Math.round(orBand.rate*100)+"%)", orInc, "#1D4ED8"):'')
    + '<div style="margin-top:12px;padding:13px 15px;background:#E6F4EA;border-radius:11px">'
    + '<div style="font-size:12px;color:#15803D;font-weight:650">Estimated income this year</div>'
    + '<div style="font-size:26px;font-weight:800;color:#15803D">'+_simRM(total)+'</div>'
    + '<div style="font-size:12px;color:#15803D">≈ '+_simRM(total/12)+' a month</div></div>'
    + '<div style="font-size:11px;color:#6B7280;text-transform:uppercase;letter-spacing:.45px;font-weight:650;margin:16px 0 7px">Your commission tier</div>'
    + '<div style="display:flex;justify-content:space-between;padding:8px 11px;border-radius:9px;background:#E6F4EA;border:1px solid #86EFAC;font-size:12.5px;font-weight:750"><span>'
    + band.rank+' — '+Math.round(rate*100)+'% <span style="color:#6B7280;font-weight:500">(current)</span></span></div>';
  var next=SIM_WP.slice().sort(function(a,b){return a.min-b.min;}).filter(function(b){return b.min>own;})[0];
  if(next) h+='<div style="margin-top:8px;padding:11px 14px;border-radius:10px;background:#FDF0DC;border:1px solid #E8DCC0;color:#B45309;font-size:12.5px"><b>'
    +_simRM(next.min-own).replace('.00','')+'</b> more revenue to reach <b>'+next.rank+'</b> ('+Math.round(next.rate*100)+'%)</div>';
  if(orBand){
    var onx=(_simVPLvl()?SIM_VP:SIM_MGR).slice().sort(function(a,b){return a.min-b.min;}).filter(function(b){return b.min>team;})[0];
    h+='<div style="font-size:11px;color:#6B7280;text-transform:uppercase;letter-spacing:.45px;font-weight:650;margin:16px 0 7px">Your over-riding tier</div>'
      +'<div style="display:flex;justify-content:space-between;padding:8px 11px;border-radius:9px;background:#DBEAFE;border:1px solid #93C5FD;font-size:12.5px;font-weight:750"><span>'
      +orBand.rank+' — '+Math.round(orBand.rate*100)+'% <span style="color:#6B7280;font-weight:500">(current)</span></span></div>';
    if(onx) h+='<div style="margin-top:8px;padding:11px 14px;border-radius:10px;background:#DBEAFE;border:1px solid #93C5FD;color:#1E40AF;font-size:12.5px"><b>'
      +_simRM(onx.min-team).replace('.00','')+'</b> more team revenue to reach <b>'+onx.rank+'</b> ('+Math.round(onx.rate*100)+'%)</div>';
  }
  h+='<div style="font-size:11px;color:#94A3B8;margin-top:10px">Ranks are reviewed quarterly — January, April, July, October.</div></div>';
  var el=document.getElementById("sim-y-out"); if(el) el.innerHTML=h;
}

function simExplain(on){
  var id="sim-explain-ov", ex=document.getElementById(id);
  if(!on){ if(ex) ex.style.display="none"; return; }
  if(!ex){
    ex=document.createElement("div"); ex.id=id;
    ex.style.cssText="position:fixed;inset:0;background:rgba(11,37,69,.55);z-index:9999;display:flex;align-items:center;justify-content:center;padding:18px";
    ex.onclick=function(e){ if(e.target===ex) simExplain(0); };
    ex.innerHTML='<div style="background:#fff;border-radius:14px;max-width:520px;width:100%;max-height:86vh;overflow:auto;padding:20px 22px">'
      +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px"><b style="font-size:15px">How this is calculated</b>'
      +'<button onclick="simExplain(0)" style="background:none;border:0;font-size:20px;color:#6B7280;cursor:pointer">&times;</button></div>'
      +'<div style="font-size:12.5px;color:#374151;line-height:1.75">'
      +'<b>What reaches LIFA</b><br>Unit Trust — amount × charge% × 85% (iFAST keeps 15%)<br>'
      +'Wholesale Bond — amount × (charge% − 0.2%)<br>Wrap — AUM × (fee% − 0.25%) each year<br>'
      +'Trailer — AUM × management charge × 50% × 35% each year<br><br>'
      +'<b>Will writing</b> (circular LP/WILL/2026-02) — writer 50% · manager 12% · VP 8% · firm 30%. '
      +'A VP/EXCO-tier writer takes the whole 70% pool. Custody: 40% / 8% / 4%, or 52% full pool.<br><br>'
      +'<b>Payment timing (Handbook §C)</b><br>Sales-charge &amp; trailer commission — paid the <b>10th of every month</b><br>'
      +'Wrap advisory fee — paid <b>quarterly</b><br>Ranks level up <b>every quarter</b> (Jan / Apr / Jul / Oct); the difference on '
      +'earlier business is back-paid on <b>10 February</b> the following year.</div></div>';
    document.body.appendChild(ex);
  }
  ex.style.display="flex";
}

// ── ACADEMY — functional-role training: YouTube video + a quiz after it ───────
// Admin staff learn one operational role per topic (New Business Submission,
// Policy Owner Services, Claims, Due Listing Checking, …). Videos live on
// YouTube — admin pastes the link, nothing is hosted here. Quiz answers are
// graded in the worker and never sent to the browser.
var ACAD_ROLES = ["New Business Submission","Policy Owner Services","Claims","Due Listing Checking","Underwriting","Compliance","Finance","Other"];
var _acadTopics = [], _acadSearch = "", _acadRole = "";

async function renderAcademyView(){
  var el = document.getElementById("main-content");
  el.innerHTML = '<div style="padding:24px">'
    + '<h2 style="margin:0 0 4px 0;color:#0B2545">🎓 Academy</h2>'
    + '<div style="color:#64748B;font-size:13px;margin-bottom:14px;max-width:760px">Learn each functional role — watch the short video, then answer a few questions to check your understanding.</div>'
    + '<div id="acad-admin"></div>'
    + '<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin-bottom:12px">'
    +   '<input id="acad-q" placeholder="Search a topic…" oninput="_acadSearch=this.value;_acadRenderList()" style="flex:1;min-width:220px;padding:9px 12px;border:1px solid #CBD5E1;border-radius:9px;font-size:13px">'
    + '</div>'
    + '<div id="acad-roles" style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:14px"></div>'
    + '<div id="acad-list">Loading…</div></div>';
  if (typeof isAdmin !== "undefined" && isAdmin) {
    document.getElementById("acad-admin").innerHTML =
      '<div style="margin-bottom:14px"><button onclick="acadOpenForm()" style="background:#7C3AED;color:#fff;border:0;padding:9px 16px;border-radius:9px;font-size:13px;font-weight:700;cursor:pointer">+ Add a training topic</button>'
      + ' <button onclick="acadViewProgress()" style="background:#fff;border:1.5px solid #CBD5E1;color:#0B2545;padding:9px 16px;border-radius:9px;font-size:13px;font-weight:700;cursor:pointer">📊 Who has completed what</button></div>'
      + '<div id="acad-form"></div>';
  }
  try {
    var rows = await apiGet("/api/academy/topics");
    if (rows && rows.error) throw new Error(rows.error);
    _acadTopics = Array.isArray(rows) ? rows : [];
    _acadRenderRoles(); _acadRenderList();
  } catch(e){ document.getElementById("acad-list").innerHTML = '<div style="color:#B91C1C">'+escapeHtml(e.message||"Could not load the Academy.")+'</div>'; }
}

function _acadRenderRoles(){
  var roles = []; _acadTopics.forEach(function(t){ if(t.role && roles.indexOf(t.role)<0) roles.push(t.role); });
  roles.sort();
  var chip = function(label, val){
    var on = _acadRole === val;
    return '<button onclick="_acadRole='+JSON.stringify(val).replace(/"/g,'&quot;')+';_acadRenderRoles();_acadRenderList()" style="padding:5px 12px;border-radius:999px;border:1.5px solid '+(on?'#7C3AED':'#E2E8F0')+';background:'+(on?'#7C3AED':'#fff')+';color:'+(on?'#fff':'#475569')+';font-size:12px;font-weight:600;cursor:pointer">'+escapeHtml(label)+'</button>';
  };
  document.getElementById("acad-roles").innerHTML = chip("All roles","") + roles.map(function(r){ return chip(r,r); }).join("");
}

function _acadRenderList(){
  var q = (_acadSearch||"").trim().toLowerCase();
  var rows = _acadTopics.filter(function(t){
    if (_acadRole && t.role !== _acadRole) return false;
    if (!q) return true;
    return ((t.title||"")+" "+(t.role||"")+" "+(t.summary||"")).toLowerCase().indexOf(q) >= 0;
  });
  var el = document.getElementById("acad-list");
  if (!rows.length){ el.innerHTML = '<div style="color:#64748B;background:#fff;border:1px solid #E2E8F0;border-radius:10px;padding:18px">'+(_acadTopics.length?'No topic matches that search.':'No training topics yet.'+((typeof isAdmin!=="undefined"&&isAdmin)?' Add the first one above.':''))+'</div>'; return; }
  el.innerHTML = '<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(280px,1fr));gap:12px">' + rows.map(function(t){
    var p = t.progress;
    var badge = p && p.passed ? '<span style="background:#DCFCE7;color:#15803D;padding:2px 9px;border-radius:999px;font-size:10.5px;font-weight:700">✓ Passed '+p.score+'/'+p.total+'</span>'
      : p ? '<span style="background:#FEF3C7;color:#92400E;padding:2px 9px;border-radius:999px;font-size:10.5px;font-weight:700">Tried '+p.score+'/'+p.total+' — retake</span>'
      : '<span style="background:#F1F5F9;color:#64748B;padding:2px 9px;border-radius:999px;font-size:10.5px;font-weight:700">Not started</span>';
    return '<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;overflow:hidden;display:flex;flex-direction:column">'
      + (t.video_id ? '<img src="https://i.ytimg.com/vi/'+encodeURIComponent(t.video_id)+'/mqdefault.jpg" alt="" style="width:100%;height:132px;object-fit:cover;background:#0B2545">' : '')
      + '<div style="padding:12px 14px;flex:1;display:flex;flex-direction:column;gap:6px">'
      +   '<div style="font-size:10.5px;color:#7C3AED;font-weight:700;text-transform:uppercase;letter-spacing:.03em">'+escapeHtml(t.role||"")+'</div>'
      +   '<div style="font-weight:700;color:#0B2545;font-size:14px;line-height:1.35">'+escapeHtml(t.title||"")+'</div>'
      +   (t.summary?'<div style="font-size:12px;color:#64748B;line-height:1.5">'+escapeHtml(t.summary.slice(0,110))+(t.summary.length>110?'…':'')+'</div>':'')
      +   '<div style="margin-top:auto;display:flex;align-items:center;justify-content:space-between;gap:8px;padding-top:8px">'+badge
      +     '<button onclick="acadOpen('+t.id+')" style="background:#0B2545;color:#fff;border:0;padding:6px 14px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer">'+(p&&p.passed?'Review':'Start')+' →</button>'
      +   '</div>'
      + '</div></div>';
  }).join("") + '</div>';
}

// ── One topic: watch, then answer ────────────────────────────────────────────
var _acadCur = null;
async function acadOpen(id){
  var el = document.getElementById("main-content");
  el.innerHTML = '<div style="padding:24px">Loading…</div>';
  var t;
  try { t = await apiGet("/api/academy/topics/"+id); if(t&&t.error) throw new Error(t.error); }
  catch(e){ el.innerHTML = '<div style="padding:24px;color:#B91C1C">'+escapeHtml(e.message)+'</div>'; return; }
  _acadCur = t;
  var adminBtns = (typeof isAdmin!=="undefined" && isAdmin)
    ? '<button onclick="acadOpenForm('+t.id+')" style="background:#fff;border:1.5px solid #CBD5E1;color:#0B2545;padding:5px 12px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer">✎ Edit</button> '
      + '<button onclick="acadDelete('+t.id+')" style="background:#fff;border:1.5px solid #FECACA;color:#B91C1C;padding:5px 12px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer">Delete</button>'
    : '';
  el.innerHTML = '<div style="padding:24px;max-width:860px">'
    + '<button onclick="showView(\'academy\')" style="background:none;border:0;color:#64748B;font-size:13px;cursor:pointer;padding:0;margin-bottom:10px">← Back to Academy</button>'
    + '<div style="display:flex;align-items:flex-start;justify-content:space-between;gap:12px;margin-bottom:4px">'
    +   '<div><div style="font-size:11px;color:#7C3AED;font-weight:700;text-transform:uppercase">'+escapeHtml(t.role||"")+'</div>'
    +   '<h2 style="margin:2px 0 0;color:#0B2545">'+escapeHtml(t.title||"")+'</h2></div><div style="white-space:nowrap">'+adminBtns+'</div></div>'
    + (t.summary?'<p style="color:#475569;font-size:13.5px;line-height:1.6;margin:8px 0 14px">'+escapeHtml(t.summary)+'</p>':'')
    + (t.video_id ? '<div style="position:relative;padding-bottom:56.25%;height:0;border-radius:12px;overflow:hidden;background:#000;margin-bottom:18px">'
        + '<iframe src="https://www.youtube-nocookie.com/embed/'+encodeURIComponent(t.video_id)+'?rel=0" title="'+escapeHtml(t.title||"")+'" allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;border:0"></iframe></div>' : '')
    + '<div id="acad-quiz"></div></div>';
  _acadRenderQuiz();
}

function _acadRenderQuiz(){
  var t = _acadCur, box = document.getElementById("acad-quiz");
  if (!t.questions || !t.questions.length){ box.innerHTML = '<div style="color:#64748B;font-size:13px">No questions on this topic yet.</div>'; return; }
  var p = t.progress;
  var done = p && p.passed
    ? '<div style="background:#DCFCE7;border:1px solid #BBF7D0;border-radius:10px;padding:10px 14px;margin-bottom:12px;font-size:12.5px;color:#166534;font-weight:600">✓ You passed this topic — '+p.score+'/'+p.total+'. You can retake it any time.</div>' : '';
  box.innerHTML = done
    + '<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;padding:18px 20px">'
    + '<div style="font-weight:700;color:#0B2545;margin-bottom:2px">Check your understanding</div>'
    + '<div style="font-size:12px;color:#64748B;margin-bottom:14px">Answer all '+t.questions.length+' question'+(t.questions.length===1?'':'s')+'. You need '+t.pass_pct+'% to pass.</div>'
    + t.questions.map(function(q,i){
        return '<div style="margin-bottom:16px" id="acad-q-'+i+'">'
          + '<div style="font-size:13.5px;font-weight:600;color:#0B2545;margin-bottom:7px">'+(i+1)+'. '+escapeHtml(q.q)+'</div>'
          + q.options.map(function(o,j){
              return '<label style="display:flex;gap:8px;align-items:flex-start;padding:7px 10px;border:1px solid #E2E8F0;border-radius:8px;margin-bottom:5px;cursor:pointer;font-size:13px;color:#334155">'
                + '<input type="radio" name="acad-a-'+i+'" value="'+j+'" style="margin-top:2px"> <span>'+escapeHtml(o)+'</span></label>';
            }).join("")
          + '<div class="acad-fb" style="display:none;font-size:12px;margin-top:4px"></div></div>';
      }).join("")
    + '<button id="acad-submit" onclick="acadSubmit()" style="background:#7C3AED;color:#fff;border:0;padding:10px 20px;border-radius:9px;font-size:13px;font-weight:700;cursor:pointer">Submit answers</button>'
    + '<div id="acad-result" style="margin-top:12px"></div></div>';
}

async function acadSubmit(){
  var t = _acadCur, answers = [], missing = 0;
  t.questions.forEach(function(q,i){
    var sel = document.querySelector('input[name="acad-a-'+i+'"]:checked');
    if (!sel) missing++;
    answers.push(sel ? parseInt(sel.value,10) : -1);
  });
  var res = document.getElementById("acad-result");
  if (missing){ res.innerHTML = '<span style="color:#B45309;font-size:12.5px;font-weight:600">Please answer all questions — '+missing+' still blank.</span>'; return; }
  var btn = document.getElementById("acad-submit"); btn.disabled = true; btn.textContent = "Checking…";
  try {
    var out = await apiPost("/api/academy/topics/"+t.id+"/submit", {answers: answers});
    if (out && out.error) throw new Error(out.error);
    (out.feedback||[]).forEach(function(f){
      var el = document.querySelector('#acad-q-'+f.i+' .acad-fb');
      if (!el) return;
      el.style.display = "block";
      el.innerHTML = f.correct
        ? '<span style="color:#15803D;font-weight:700">✓ Correct.</span>'+(f.explain?' <span style="color:#475569">'+escapeHtml(f.explain)+'</span>':'')
        : '<span style="color:#B91C1C;font-weight:700">✗ Not quite — the answer is: '+escapeHtml(t.questions[f.i].options[f.correct_answer])+'.</span>'+(f.explain?' <span style="color:#475569">'+escapeHtml(f.explain)+'</span>':'');
    });
    res.innerHTML = out.passed
      ? '<div style="background:#DCFCE7;border:1px solid #BBF7D0;border-radius:9px;padding:11px 14px;color:#166534;font-weight:700;font-size:13px">🎉 Passed — '+out.score+'/'+out.total+' ('+out.pct+'%). Well done.</div>'
      : '<div style="background:#FEF3C7;border:1px solid #FDE68A;border-radius:9px;padding:11px 14px;color:#92400E;font-weight:700;font-size:13px">'+out.score+'/'+out.total+' ('+out.pct+'%) — you need '+out.pass_pct+'% to pass. Review the answers above and try again.</div>';
    btn.textContent = "Try again"; btn.disabled = false;
  } catch(e){ res.innerHTML = '<span style="color:#B91C1C;font-size:12.5px">'+escapeHtml(e.message||"Could not submit — please try again.")+'</span>'; btn.disabled=false; btn.textContent="Submit answers"; }
}

// ── Admin: add / edit a topic ────────────────────────────────────────────────
var _acadQ = [];
async function acadOpenForm(id){
  var t = null;
  if (id){ try { t = await apiGet("/api/academy/topics/"+id+"/answers"); if(t&&t.error) throw new Error(t.error); } catch(e){ alert(e.message); return; } }
  if (id) { showView('academy'); await new Promise(function(r){ setTimeout(r,400); }); }
  _acadQ = (t && t.questions && t.questions.length) ? JSON.parse(JSON.stringify(t.questions)) : [{q:"",options:["",""],answer:0,explain:""}];
  var box = document.getElementById("acad-form"); if(!box) return;
  box.innerHTML = '<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;padding:18px 20px;margin-bottom:16px">'
    + '<div style="font-weight:700;color:#0B2545;margin-bottom:12px">'+(id?'Edit topic':'New training topic')+'</div>'
    + '<input type="hidden" id="acad-f-id" value="'+(id||"")+'">'
    + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:10px">'
    +   '<div><label style="font-size:11px;color:#64748B;font-weight:700">Topic title</label><input id="acad-f-title" value="'+escapeHtml((t&&t.title)||"")+'" placeholder="How to submit a new business case" style="width:100%;padding:9px 11px;border:1px solid #CBD5E1;border-radius:8px;font-size:13px"></div>'
    +   '<div><label style="font-size:11px;color:#64748B;font-weight:700">Functional role</label><input id="acad-f-role" list="acad-roles-dl" value="'+escapeHtml((t&&t.role)||"")+'" placeholder="New Business Submission" style="width:100%;padding:9px 11px;border:1px solid #CBD5E1;border-radius:8px;font-size:13px">'
    +     '<datalist id="acad-roles-dl">'+ACAD_ROLES.map(function(r){return '<option value="'+escapeHtml(r)+'">';}).join("")+'</datalist></div>'
    + '</div>'
    + '<div style="margin-bottom:10px"><label style="font-size:11px;color:#64748B;font-weight:700">YouTube link</label><input id="acad-f-yt" value="'+escapeHtml((t&&t.youtube_url)||"")+'" placeholder="https://www.youtube.com/watch?v=…" style="width:100%;padding:9px 11px;border:1px solid #CBD5E1;border-radius:8px;font-size:13px"></div>'
    + '<div style="margin-bottom:12px"><label style="font-size:11px;color:#64748B;font-weight:700">What they will learn (optional)</label><textarea id="acad-f-sum" rows="2" placeholder="Short description" style="width:100%;padding:9px 11px;border:1px solid #CBD5E1;border-radius:8px;font-size:13px">'+escapeHtml((t&&t.summary)||"")+'</textarea></div>'
    + '<div style="font-weight:700;color:#0B2545;font-size:13px;margin-bottom:2px">Questions</div>'
    + '<div style="font-size:11.5px;color:#64748B;margin-bottom:8px">Tick the correct answer for each. Learners need 80% to pass.</div>'
    + '<div id="acad-f-qs"></div>'
    + '<button onclick="acadAddQ()" style="background:#fff;border:1.5px solid #CBD5E1;color:#0B2545;padding:6px 12px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer;margin-bottom:12px">+ Add question</button>'
    + '<div style="display:flex;gap:8px;align-items:center"><button onclick="acadSave()" style="background:#7C3AED;color:#fff;border:0;padding:10px 20px;border-radius:9px;font-size:13px;font-weight:700;cursor:pointer">'+(id?'Save changes':'Add topic')+'</button>'
    + '<button onclick="document.getElementById(\'acad-form\').innerHTML=\'\'" style="background:none;border:0;color:#64748B;font-size:12.5px;cursor:pointer">Cancel</button>'
    + '<span id="acad-f-msg" style="font-size:12.5px"></span></div></div>';
  _acadRenderQs();
  box.scrollIntoView({block:"start", behavior:"smooth"});
}

function _acadRenderQs(){
  document.getElementById("acad-f-qs").innerHTML = _acadQ.map(function(q,i){
    return '<div style="border:1px solid #E2E8F0;border-radius:9px;padding:11px 12px;margin-bottom:8px;background:#F8FAFC">'
      + '<div style="display:flex;gap:8px;align-items:center;margin-bottom:6px">'
      +   '<span style="font-size:11px;font-weight:700;color:#64748B">Q'+(i+1)+'</span>'
      +   '<input value="'+escapeHtml(q.q||"")+'" oninput="_acadQ['+i+'].q=this.value" placeholder="Question" style="flex:1;padding:7px 10px;border:1px solid #CBD5E1;border-radius:7px;font-size:12.5px">'
      +   (_acadQ.length>1?'<button onclick="_acadQ.splice('+i+',1);_acadRenderQs()" style="background:none;border:0;color:#B91C1C;font-size:14px;cursor:pointer" title="Remove">✕</button>':'')
      + '</div>'
      + q.options.map(function(o,j){
          return '<div style="display:flex;gap:7px;align-items:center;margin-bottom:4px;padding-left:22px">'
            + '<input type="radio" name="acad-correct-'+i+'" '+(q.answer===j?'checked':'')+' onchange="_acadQ['+i+'].answer='+j+'" title="Correct answer">'
            + '<input value="'+escapeHtml(o||"")+'" oninput="_acadQ['+i+'].options['+j+']=this.value" placeholder="Option '+(j+1)+'" style="flex:1;padding:6px 9px;border:1px solid #E2E8F0;border-radius:6px;font-size:12.5px">'
            + (q.options.length>2?'<button onclick="_acadQ['+i+'].options.splice('+j+',1);if(_acadQ['+i+'].answer>='+j+'&&_acadQ['+i+'].answer>0)_acadQ['+i+'].answer--;_acadRenderQs()" style="background:none;border:0;color:#94A3B8;cursor:pointer">✕</button>':'')
            + '</div>';
        }).join("")
      + '<div style="padding-left:22px;display:flex;gap:8px;align-items:center;margin-top:4px">'
      +   (q.options.length<6?'<button onclick="_acadQ['+i+'].options.push(\'\');_acadRenderQs()" style="background:none;border:0;color:#7C3AED;font-size:11.5px;font-weight:700;cursor:pointer">+ option</button>':'')
      +   '<input value="'+escapeHtml(q.explain||"")+'" oninput="_acadQ['+i+'].explain=this.value" placeholder="Why (shown after answering, optional)" style="flex:1;padding:6px 9px;border:1px dashed #CBD5E1;border-radius:6px;font-size:11.5px">'
      + '</div></div>';
  }).join("");
}
function acadAddQ(){ _acadQ.push({q:"",options:["",""],answer:0,explain:""}); _acadRenderQs(); }

async function acadSave(){
  var msg = document.getElementById("acad-f-msg");
  var body = {
    id: document.getElementById("acad-f-id").value || 0,
    title: document.getElementById("acad-f-title").value,
    role: document.getElementById("acad-f-role").value,
    youtube_url: document.getElementById("acad-f-yt").value,
    summary: document.getElementById("acad-f-sum").value,
    questions: _acadQ
  };
  msg.style.color = "#64748B"; msg.textContent = "Saving…";
  try {
    var out = await apiPost("/api/academy/topics", body);
    if (out && out.error) throw new Error(out.error);
    msg.style.color = "#15803D"; msg.textContent = "✓ Saved.";
    renderAcademyView();
  } catch(e){ msg.style.color = "#B91C1C"; msg.textContent = e.message || "Could not save."; }
}

async function acadDelete(id){
  if (!confirm("Delete this training topic?\n\nThe video stays on YouTube. Learners' progress for this topic is removed. This cannot be undone.")) return;
  try { var out = await apiDelete("/api/academy/topics/"+id); if(out&&out.error) throw new Error(out.error); showView('academy'); }
  catch(e){ alert(e.message); }
}

async function acadViewProgress(){
  var box = document.getElementById("acad-form"); if(!box) return;
  box.innerHTML = '<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;padding:16px 18px;margin-bottom:16px">Loading…</div>';
  try {
    var rows = await apiGet("/api/academy/progress");
    if (rows && rows.error) throw new Error(rows.error);
    box.innerHTML = '<div style="background:#fff;border:1px solid #E2E8F0;border-radius:12px;padding:16px 18px;margin-bottom:16px">'
      + '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px"><div style="font-weight:700;color:#0B2545">Who has completed what</div>'
      + '<button onclick="document.getElementById(\'acad-form\').innerHTML=\'\'" style="background:none;border:0;color:#64748B;font-size:12.5px;cursor:pointer">Close</button></div>'
      + (!rows.length ? '<div style="color:#64748B;font-size:13px">Nobody has taken a quiz yet.</div>'
        : '<table style="width:100%;border-collapse:collapse;font-size:12.5px"><thead style="background:#F8FAFC"><tr>'
          + '<th style="text-align:left;padding:7px 9px;color:#475569">Person</th><th style="text-align:left;padding:7px 9px;color:#475569">Topic</th>'
          + '<th style="text-align:left;padding:7px 9px;color:#475569">Score</th><th style="text-align:left;padding:7px 9px;color:#475569">Result</th>'
          + '<th style="text-align:left;padding:7px 9px;color:#475569">When</th></tr></thead><tbody>'
          + rows.map(function(r){
              return '<tr style="border-top:1px solid #F1F5F9"><td style="padding:7px 9px;color:#0B2545;font-weight:600">'+escapeHtml(r.name||r.user_id||"")+'</td>'
                + '<td style="padding:7px 9px">'+escapeHtml(r.title||"")+'<div style="font-size:10px;color:#94A3B8">'+escapeHtml(r.role||"")+'</div></td>'
                + '<td style="padding:7px 9px">'+r.score+'/'+r.total+'</td>'
                + '<td style="padding:7px 9px">'+(r.passed?'<span style="color:#15803D;font-weight:700">✓ Passed</span>':'<span style="color:#B45309;font-weight:700">Not yet</span>')+'</td>'
                + '<td style="padding:7px 9px;color:#64748B">'+escapeHtml((r.completed_at||"").slice(0,16))+'</td></tr>';
            }).join("") + '</tbody></table>')
      + '</div>';
  } catch(e){ box.innerHTML = '<div style="color:#B91C1C;padding:12px">'+escapeHtml(e.message)+'</div>'; }
}


// ── §AUDIT — does this month's money match the files it came from? ───────────
// FOUR questions, each of which was answered wrongly and silently by the system
// at some point this year:
//   1. Do the staged files add up to what the statements say? (the DPMS/UT
//      file-total defect put RM2,551 that iFAST never paid onto five months)
//   2. Does every adviser code in those files resolve to a real adviser? (an
//      unresolved code is dropped in silence — RM0.07 of THAM WENG SIUM's)
//   3. Per adviser, does the file figure equal the statement figure?
//   4. Does the month balance: revenue = paid out + kept by the firm?
// It reads only what is already loaded; it changes nothing.
// §ADJUST — the screen for "these months were re-checked; settle the difference
// next cycle". It shows the figures FIRST and writes nothing until the owner says
// so, because the numbers decide what real people are paid.
async function mcReconcile(period, btn){
  var panel = btn.parentElement.querySelector('.lcx-recon');
  if(panel){ panel.remove(); return; }
  var el=document.createElement('div'); el.className='lcx-recon';
  el.style.cssText='flex-basis:100%;margin-top:12px;border:1px solid #E2E8F0;border-radius:12px;padding:14px 16px;background:#fff;font-size:13.5px';
  el.innerHTML='Working out the difference…';
  btn.parentElement.appendChild(el);

  // Which earlier months may be settled here. A month whose payment is still
  // moving is OFF LIMITS: finance has a figure in hand, and reconciling it would
  // change the amount underneath them. Those months are shown, greyed, with the
  // reason — hiding them would just make the list look arbitrary.
  var IN_FLIGHT = {awaiting_finance:'still with finance', payment_created:'payment in flight'};
  var earlier = (window._mcRows||[]).filter(function(r){
    var a=_clYm(r.period), b=_clYm(period); return a && b && a < b;
  }).sort(function(a,b){ return _clYm(a.period) < _clYm(b.period) ? -1 : 1; });
  var months = earlier.filter(function(r){ return !IN_FLIGHT[r.finance_status]; }).map(function(r){return r.period;});
  var blocked = earlier.filter(function(r){ return IN_FLIGHT[r.finance_status]; });
  var pick = months.slice();
  if(!pick.length){
    el.innerHTML='<div style="color:#92400E">There is no earlier month that can be settled here'
      + (blocked.length ? ' — '+blocked.map(function(r){return escapeHtml(r.period)+' is '+IN_FLIGHT[r.finance_status];}).join(', ')+'.' : '.')
      + '</div>'; return;
  }

  async function draw(sel){
    el.innerHTML='Working out the difference…';
    var res;
    try{ res = await apiPost('/api/commission/reconcile', {periods: sel, effective_from: period}); }
    catch(e){ el.innerHTML='<div style="color:#B91C1C">'+escapeHtml(e && e.message || 'Could not reach the server')+'</div>'; return; }
    if(!res || res.error){ el.innerHTML='<div style="color:#B91C1C">'+escapeHtml((res&&res.error)||'Refused')+'</div>'; return; }
    var chips = months.map(function(m){
      var on = sel.indexOf(m)>=0;
      return '<label style="display:inline-flex;align-items:center;gap:5px;margin:0 8px 6px 0;padding:3px 9px;border-radius:20px;border:1px solid '+(on?'#0B2545':'#E2E8F0')+';background:'+(on?'#0B2545':'#fff')+';color:'+(on?'#fff':'#334155')+';font-size:12px;cursor:pointer">'
        +'<input type="checkbox" data-m="'+escapeHtml(m)+'" '+(on?'checked':'')+' style="margin:0"> '+escapeHtml(m)+'</label>';
    }).join('') + blocked.map(function(r){
      return '<span title="A month still being paid cannot be settled here" style="display:inline-flex;align-items:center;margin:0 8px 6px 0;padding:3px 9px;border-radius:20px;border:1px dashed #CBD5E1;background:#F8FAFC;color:#94A3B8;font-size:12px">'
        + escapeHtml(r.period) + ' — ' + IN_FLIGHT[r.finance_status] + '</span>';
    }).join('');
    var body = (res.rows||[]).map(function(r){
      var col = r.firm_only ? '#64748B' : (r.adjustment>0 ? '#166534' : (r.adjustment<0 ? '#B45309' : '#64748B'));
      var what = r.firm_only ? 'firm — never paid out'
               : (r.adjustment>0 ? 'was underpaid — add to next payout'
               : (r.adjustment<0 ? 'was overpaid — deduct from next payout' : 'square'));
      return '<tr><td style="padding:4px 8px">'+escapeHtml(r.name)+'</td>'
        +'<td style="padding:4px 8px;text-align:right;font-variant-numeric:tabular-nums">'+_clRM(r.earned)+'</td>'
        +'<td style="padding:4px 8px;text-align:right;font-variant-numeric:tabular-nums">'+_clRM(r.paid)+'</td>'
        +'<td style="padding:4px 8px;text-align:right;font-variant-numeric:tabular-nums;font-weight:700;color:'+col+'">'+_clRM(r.adjustment)+'</td>'
        +'<td style="padding:4px 8px;color:'+col+';font-size:12px">'+what+'</td></tr>';
    }).join('');
    el.innerHTML = '<div style="font-weight:700;margin-bottom:8px">Settle earlier months into '+escapeHtml(period)+'</div>'
      + '<div style="margin-bottom:8px">'+chips+'</div>'
      + '<table style="width:100%;border-collapse:collapse;font-size:12.5px"><thead><tr style="background:#F8FAFC;text-align:left">'
      + '<th style="padding:4px 8px">Adviser</th><th style="padding:4px 8px;text-align:right">Earned</th>'
      + '<th style="padding:4px 8px;text-align:right">Paid</th><th style="padding:4px 8px;text-align:right">Difference</th>'
      + '<th style="padding:4px 8px">What happens</th></tr></thead><tbody>'+body+'</tbody></table>'
      + '<div style="margin-top:10px;color:#475569">Net across '+_clPlural((res.count||0),'adviser')+': <b>'+_clRM(res.total||0)+'</b>'
      + ' — added to or taken off their '+escapeHtml(period)+' payout, under the usual RM50 rule.</div>'
      + '<div style="margin-top:10px;display:flex;gap:8px;align-items:center">'
      + '<button class="lcx-btn" data-go="1">Settle these into '+escapeHtml(period)+'</button>'
      + '<span style="font-size:12px;color:#64748B">Nothing is written until you press this.</span></div>';

    el.querySelectorAll('input[type=checkbox]').forEach(function(cb){
      cb.onchange=function(){
        var next = months.filter(function(m){
          var c = el.querySelector('input[data-m="'+m.replace(/"/g,'&quot;')+'"]');
          return c && c.checked;
        });
        if(next.length) draw(next);
      };
    });
    var go = el.querySelector('[data-go]');
    if(go) go.onclick=async function(){
      if(!confirm('Settle '+sel.join(', ')+' into '+period+'?\n\nNet '+_clRM(res.total||0)+' across '+(res.count||0)+' adviser(s).\nThose months will stop asking for payment of their own; the difference rides the '+period+' payout instead.')) return;
      go.disabled=true; go.textContent='Settling…';
      var out;
      try{ out = await apiPost('/api/commission/reconcile', {periods: sel, effective_from: period, confirm: true}); }
      catch(e){ out = {error: (e && e.message) || 'Could not reach the server'}; }
      if(!out || out.error){ el.insertAdjacentHTML('beforeend','<div style="margin-top:8px;color:#B91C1C">'+escapeHtml((out&&out.error)||'Refused')+'</div>'); go.disabled=false; go.textContent='Settle these into '+period; return; }
      el.innerHTML='<div style="font-weight:700;color:#166534">Done — '+_clPlural(out.created||0,'correction')+' will settle with '+escapeHtml(period)+'.</div>'
        +'<div style="margin-top:6px;color:#475569;font-size:12.5px">Each adviser sees it as a named line on their statement. Run &#9989; Audit this month before paying.</div>';
      if(typeof mcLoad==='function') try{ mcLoad(); }catch(e){}
    };
  }
  draw(pick);
}

async function mcAudit(period, btn){
  var panel = btn.parentElement.querySelector('.lcx-audit');
  if(panel){ panel.remove(); return; }
  var el=document.createElement('div'); el.className='lcx-audit';
  el.style.cssText='flex-basis:100%;margin-top:12px;border:1px solid #E2E8F0;border-radius:12px;padding:14px 16px;background:#fff;font-size:13.5px';
  el.innerHTML='Reading the files…';
  btn.parentElement.appendChild(el);

  // The month's own files must be staged to compare against.
  if(UP_FILTER.month!==period){ UP_FILTER.month=period; }
  var st=upGetMonthStatus(period);
  if(!st.iFiles.length && !st.pFiles.length){
    try{ await upImportFromEmail(); }catch(e){}
    st=upGetMonthStatus(period);
  }
  var rows=[], problems=0;
  function line(ok, label, right){
    if(!ok) problems++;
    rows.push('<div style="display:flex;justify-content:space-between;gap:16px;padding:5px 0;border-bottom:1px solid #F1F5F9">'
      +'<span>'+(ok?'<span style="color:#16A34A">✓</span>':'<span style="color:#DC2626">✕</span>')+' '+label+'</span>'
      +'<span style="font-variant-numeric:tabular-nums;white-space:nowrap">'+(right||'')+'</span></div>');
  }

  // 1 + 2 — the files
  var per={}, grand=0, refused=[];
  ['iFAST','Phillip'].forEach(function(p2){
    (UPLOADS[p2][period]||[]).forEach(function(f){
      if(f.parseError) refused.push(f.name+' — '+f.parseError);
      Object.keys(f.agentTotals||{}).forEach(function(k){
        var v=Number(f.agentTotals[k].ifast_comm)||0;
        var id=upResolveAgent(k, p2, f.agentTotals[k].name);
        var key=id||('??'+k);
        per[key]=(per[key]||0)+v; grand+=v;
      });
      if(p2==='Phillip' && Number(f.firmTotal)) grand+=Number(f.firmTotal);
    });
  });
  refused.forEach(function(r){ line(false,'A file would not reconcile against its own Grand Total', r.slice(0,60)); });
  var unmatched=Object.keys(per).filter(function(k){return k.indexOf('??')===0;});
  line(!unmatched.length, unmatched.length? 'Codes in the files that match no adviser: '+unmatched.map(function(k){return k.slice(2);}).join(', ')
       : 'Every adviser code in the files is recognised',
       unmatched.length? _clRM(unmatched.reduce(function(a,k){return a+per[k];},0))+' would be dropped' : '');

  // 3 — per adviser, files vs statements
  var stmtById={};
  Object.keys(STATEMENTS).forEach(function(id){
    var s2=(STATEMENTS[id]||[]).find(function(x){return x.period===period;});
    if(s2) stmtById[id]=Math.round(((Number(s2.ifast_comm)||0))*100)/100;
  });
  var diffs=[];
  Object.keys(per).forEach(function(id){
    if(id.indexOf('??')===0) return;
    var fileV=Math.round(per[id]*100)/100, stV=stmtById[id]||0;
    if(Math.abs(fileV-stV)>0.011) diffs.push((ADVISERS[id]?ADVISERS[id].name:id)+': files '+_clRM(fileV)+' vs statement '+_clRM(stV));
  });
  Object.keys(stmtById).forEach(function(id){
    if(per[id]===undefined && stmtById[id]>0.011) diffs.push((ADVISERS[id]?ADVISERS[id].name:id)+': statement '+_clRM(stmtById[id])+' with nothing in the files');
  });
  line(!diffs.length, diffs.length? 'Advisers whose statement differs from the files' : 'Every adviser matches the files exactly',
       diffs.length? diffs.length+' to check' : '');
  if(diffs.length) rows.push('<div style="color:#92400E;font-size:12.5px;padding:6px 0 0 18px">'+diffs.map(escapeHtml).join('<br>')+'</div>');

  // 4 — the month balances
  var r0=(window._mcRows||[]).find(function(x){return x.period===period;});
  if(r0){
    var gap=Math.round(((Number(r0.gross)||0)-((Number(r0.payout)||0)+(Number(r0.retention)||0)))*100)/100;
    line(Math.abs(gap)<0.011, 'Revenue equals what is paid out plus what the firm keeps',
         Math.abs(gap)<0.011? _clRM(r0.gross) : 'off by '+_clRM(gap));
  }
  // 5 — §ADJUST — a correction that never lands is the failure mode this catches.
  // An adjustment waiting for a month that has already gone is money nobody is
  // tracking, so it is reported here whether or not it belongs to THIS month.
  try{
    var adjs = await apiGet('/api/commission/adjustments?pending=1');
    if(Array.isArray(adjs) && adjs.length){
      var here = adjs.filter(function(a){ return _clYm(period) && a.effective_from && a.effective_from <= _clYm(period); });
      line(true, 'Corrections from earlier months waiting to settle', adjs.length+' waiting');
      rows.push('<div style="color:#334155;font-size:12.5px;padding:6px 0 0 18px">'
        + adjs.map(function(a){
            var nm = escapeHtml(a.name || a.adviser_id);
            return nm+': '+_clRM(a.amount)+' — '+escapeHtml(a.source_periods||'')+', from '+escapeHtml(a.effective_from||'');
          }).join('<br>')+'</div>');
      if(here.length) line(true, 'Of those, due to settle in this month or earlier', here.length+' — '+_clRM(here.reduce(function(t,a){return t+(Number(a.amount)||0);},0)));
    }
  }catch(e){}

  var head = problems? '<div style="font-weight:700;color:#B45309;margin-bottom:8px">'+problems+' thing'+(problems===1?'':'s')+' to look at before paying</div>'
                     : '<div style="font-weight:700;color:#166534;margin-bottom:8px">This month reconciles against its own files</div>';
  el.innerHTML = head + rows.join('') +
    '<div style="color:#64748B;font-size:12px;margin-top:10px">Compared against the files staged for '+escapeHtml(period)+'. '
    + 'It does not read iFAST&rsquo;s invoice PDF &mdash; check the Grand Total on that against the figure above for full assurance.</div>';
}
